webpackJsonp([1],{

/***/ "+4uU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterEditModal_vue__ = __webpack_require__("b+E9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3868149e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterEditModal_vue__ = __webpack_require__("i9WJ");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("fKHn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3868149e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/ChapterEditModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3868149e", Component.options)
  } else {
    hotAPI.reload("data-v-3868149e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+5yJ":
/***/ (function(module, exports) {

module.exports = {"Play":"Afspelen","Pause":"Pauze","Current Time":"Huidige tijd","Duration Time":"Looptijd","Remaining Time":"Resterende tijd","Stream Type":"Streamtype","LIVE":"LIVE","Loaded":"Geladen","Progress":"Status","Fullscreen":"Volledig scherm","Non-Fullscreen":"Geen volledig scherm","Mute":"Geluid uit","Unmute":"Geluid aan","Playback Rate":"Weergavesnelheid","Subtitles":"Ondertiteling","subtitles off":"ondertiteling uit","Captions":"Bijschriften","captions off":"bijschriften uit","Chapters":"Hoofdstukken","Descriptions":"Beschrijvingen","descriptions off":"beschrijvingen off","You aborted the media playback":"U hebt de mediaweergave afgebroken.","A network error caused the media download to fail part-way.":"De mediadownload is mislukt door een netwerkfout.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"De media kon niet worden geladen, vanwege een server- of netwerkfout of doordat het formaat niet wordt ondersteund.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"De mediaweergave is afgebroken vanwege beschadigde data of het mediabestand gebruikt functies die niet door uw browser worden ondersteund.","No compatible source was found for this media.":"Voor deze media is geen ondersteunde bron gevonden.","Play Video":"Video Afspelen","Close":"Sluiten","Modal Window":"Modal Venster","This is a modal window":"Dit is een modaal venster","This modal can be closed by pressing the Escape key or activating the close button.":"Dit modaal venster kan gesloten worden door op Escape te drukken of de 'sluiten' knop te activeren.",", opens captions settings dialog":", opent bijschriften instellingen venster",", opens subtitles settings dialog":", opent ondertiteling instellingen venster",", opens descriptions settings dialog":", opent beschrijvingen instellingen venster",", selected":", selected"}

/***/ }),

/***/ "+6rK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal hide-cancel-btn",
      attrs: {
        id: "evaluation-service-gone-modal",
        title: "공지사항",
        "ok-title": _vm.$t("common.confirm")
      },
      on: {
        ok: function($event) {
          return _vm.$emit("ok")
        }
      }
    },
    [
      _c("div", { staticClass: "evaluation-service-gone-container" }, [
        _vm._v(
          "\n안녕하세요 클래스팅 러닝을 사랑해 주시는 선생님들께 진심으로 감사의 말씀을 드립니다."
        ),
        _c("br"),
        _vm._v(
          "\n아쉽게도 8월 1일  자로 클래스팅 러닝 기능 중 '종합의견' 서비스가 종료됩니다."
        ),
        _c("br"),
        _vm._v(
          "\n선생님들께서는 종료  일정을 참고하시어 이용에 불편이 없으시길 바랍니다."
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n다시 한번 '종합의견'을 아껴주셨던 모든 선생님들께 진심으로 감사의 말씀을 드리며,"
        ),
        _c("br"),
        _vm._v(
          "\n향후 더 좋은 서비스로 선생님들을 찾아뵐 수 있도록 노력하겠습니다."
        ),
        _c("br"),
        _c("br"),
        _vm._v("\n\n감사합니다."),
        _c("br"),
        _vm._v("\n클래스팅드림\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d061eb42", esExports)
  }
}

/***/ }),

/***/ "+871":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyDetailCard_vue__ = __webpack_require__("qr4/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b92396e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyDetailCard_vue__ = __webpack_require__("GAqc");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("moW2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyDetailCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b92396e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyDetailCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DummyDetailCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b92396e", Component.options)
  } else {
    hotAPI.reload("data-v-7b92396e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+8Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'student-report',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      cls: null,
      currentStudent: {},
      selectedSubjectId: 0,
      students: null,
      assignments: [],
      assignmentsBySubjects: {},
      sortType: 'recent'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['managingClasses', 'getRouteQuery', 'coreConcepts', 'subjectMap']), {
    subjectIds: function subjectIds() {
      if (this.cls.grade >= 3 && this.cls.grade <= 6) {
        return [0, 2, 3, 5, 41, 42, 50, 51, 47, 48];
      } else if (this.cls.grade >= 7 && this.cls.grade <= 9) {
        return [0, 2, 5, 43, 44, 41, 42, 50, 51, 47, 48];
      }

      return [0, 41, 42, 50, 51, 47, 48, 49];
    },
    formattedClassName: function formattedClassName() {
      if (this.cls) {
        var year = this.cls.year;
        var schoolName = this.cls.school_name;
        var grade = this.cls.grade;
        var className = this.cls.name;

        return year + ' ' + this.getShortenedString(schoolName, 10) + ' ' + grade + ' - ' + this.getShortenedString(className, 25);
      }

      return '';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setIsStudentAssignmentPreview', 'setSelectedPreviewPageIndex', 'fetchTeacherAssignmentStats', 'fetchAssignedCardPages', 'setSelectedPreviewCard', 'fetchClassAssignments', 'fetchClassStudents', 'syncClassStudents']), {
    formattedDate: function formattedDate(dateStr) {
      return dateStr.substr(2, 2) + '.' + dateStr.substr(5, 2) + '.' + dateStr.substr(8, 2);
    },
    getNumStrTwoDigit: function getNumStrTwoDigit(number) {
      if (number <= 9) {
        return '0' + number;
      }
      return number;
    },
    getLearningElements: function getLearningElements(coreConcept) {
      if (!coreConcept) {
        return null;
      }

      return coreConcept.description;
    },
    getScoreRatio: function getScoreRatio(submission) {
      if (submission.quiz_count === 0) {
        return null;
      }

      return parseInt(submission.correct_quiz_count / submission.quiz_count * 100, 10);
    },
    getClassScoreRank: function getClassScoreRank(correctQuizCount, classScores) {
      var classScoreRank = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["orderBy"])(classScores, null, 'desc').indexOf(correctQuizCount);

      if (classScoreRank === -1) {
        return null;
      }

      return classScoreRank + 1;
    },
    getClassScoreRankRatio: function getClassScoreRankRatio(correctQuizCount, classScores, submissions) {
      var classScoreRank = this.getClassScoreRank(correctQuizCount, classScores);

      return parseInt(classScoreRank / submissions.length * 100, 10);
    },
    getSubmittedSubmissions: function getSubmittedSubmissions(submissions) {
      if (!submissions) {
        return [];
      }

      return submissions.filter(function (submission) {
        return !!submission.is_submitted;
      });
    },
    getAverageScore: function getAverageScore(submissions) {
      if (!submissions) {
        return null;
      }

      var filtered = submissions.filter(function (submission) {
        return submission.quiz_count > 0;
      });

      if (filtered.length === 0) {
        return null;
      }

      var scores = this.getSubmittedSubmissions(filtered).map(function (submission) {
        return submission.correct_quiz_count / submission.quiz_count * 100;
      });

      if (scores.length === 0) {
        return null;
      }

      return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["mean"])(scores), 10);
    },
    getAverageDuration: function getAverageDuration(submissions) {
      if (!submissions) {
        return null;
      }

      var filtered = this.getSubmittedSubmissions(submissions).filter(function (submission) {
        return submission.duration !== null;
      });

      if (filtered.length === 0) {
        return null;
      }

      var durations = filtered.map(function (submission) {
        return submission.duration;
      });

      return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["mean"])(durations), 10);
    },
    getCompleteRate: function getCompleteRate(submissions) {
      if (!submissions || submissions.length === 0) {
        return 0;
      }

      var submittedCount = this.getSubmittedSubmissions(submissions).length;
      var rate = submittedCount / submissions.length * 100;

      return parseInt(rate, 10);
    },
    openStudentAssignmentPreview: function openStudentAssignmentPreview(assignment) {
      var _this = this;

      var cardClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(assignment.assigned_card);

      cardClone.title += ' (' + this.currentStudent.name + ')';

      this.fetchAssignedCardPages(assignment.id).then(function (pages) {
        var quizPages = pages.filter(function (page) {
          return !!page.is_quiz;
        });
        cardClone.pages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(quizPages);

        cardClone.pages.forEach(function (page) {
          page.submitted_answers = page.submitted_answers.filter(function (answer) {
            return answer.student_id === _this.currentStudent.student_id;
          });
        });
      }).then(function () {
        return _this.setSelectedPreviewCard(cardClone);
      }).then(function () {
        return _this.setSelectedPreviewPageIndex(0);
      }).then(function () {
        return _this.setIsStudentAssignmentPreview(true);
      }).then(function () {
        _this.$root.$emit('show::modal', 'card-preview-modal');
      }).catch(function (err) {
        _this.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    sortAssignments: function sortAssignments() {
      var _this2 = this;

      if (this.sortType === 'recent') {
        this.assignmentsBySubjects[this.selectedSubjectId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["orderBy"])(this.assignmentsBySubjects[this.selectedSubjectId], function (assignment) {
          return assignment.due_date;
        }, 'desc');
        this.assignmentsBySubjects = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.assignmentsBySubjects);
      } else {
        this.assignmentsBySubjects[this.selectedSubjectId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["orderBy"])(this.assignmentsBySubjects[this.selectedSubjectId], function (assignment) {
          return _this2.getScoreRatio(assignment.currentStudentSubmission) || 0;
        }, 'desc');
        this.assignmentsBySubjects = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.assignmentsBySubjects);
      }
    },
    getShortenedString: function getShortenedString(string, maxLength) {
      if (string.length <= maxLength) {
        return string;
      }
      return string.substring(0, maxLength) + '...';
    }
  }),

  created: function created() {
    var _this3 = this;

    this.loading = true;
    var classId = this.$route.params.class_id;
    var studentId = this.$route.params.student_id;

    this.cls = this.managingClasses[classId];

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.cls)) {
      this.fetchClassStudents(this.cls.id).then(function (studentList) {
        if (!studentList || studentList.length === 0) {
          return _this3.syncClassStudents(_this3.cls.id);
        }

        return studentList;
      }).then(function (studentList) {
        _this3.students = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(studentList, 'student_id');
        _this3.currentStudent = _this3.students[studentId] || {};

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.currentStudent)) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('student not found in this class');
        }

        return _this3.currentStudent;
      }).then(function () {
        return _this3.fetchTeacherAssignmentStats({ class_id: classId }).then(function (assignmentStats) {
          _this3.assignmentStats = assignmentStats;

          return assignmentStats;
        });
      }).then(function (assignmentStats) {
        return _this3.fetchClassAssignments({ class_id: classId, per_page: assignmentStats.total_count });
      }).then(function (assignments) {
        return assignments.filter(function (asmt) {
          return asmt.submissions.map(function (submission) {
            return submission.student_id;
          }).indexOf(_this3.currentStudent.student_id) !== -1;
        });
      }).then(function (assignments) {
        _this3.assignments = assignments;
      }).then(function () {
        _this3.assignmentsBySubjects[0] = [];

        _this3.assignments.forEach(function (assignment) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.assignmentsBySubjects[assignment.assigned_card.subject_id])) {
            _this3.assignmentsBySubjects[assignment.assigned_card.subject_id] = [];
          }

          _this3.assignmentsBySubjects[0].push(assignment);
          _this3.assignmentsBySubjects[assignment.assigned_card.subject_id].push(assignment);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(assignment.classScores)) {
            assignment.classScores = [];
          }

          assignment.submissions.forEach(function (submission) {
            if (submission.student_id === _this3.currentStudent.student_id) {
              assignment.currentStudentSubmission = submission;
            }

            if (submission.is_submitted) {
              assignment.classScores.push(submission.correct_quiz_count);
            }

            if (_this3.students[submission.student_id]) {
              if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.students[submission.student_id].submissions)) {
                _this3.students[submission.student_id].submissions = [];
              }

              _this3.students[submission.student_id].submissions.push(submission);
            }
          });
        });
      }).then(function () {
        if (_this3.getRouteQuery.subject_id) {
          _this3.selectedSubjectId = _this3.getRouteQuery.subject_id;
        }
        _this3.sortAssignments();
        _this3.loading = false;
      }).catch(function (err) {
        _this3.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    } else {
      this.loading = false;
      this.$root.$emit('show::modal', 'basic-error-alert');
    }
  }
});

/***/ }),

/***/ "+9qS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("F0R5");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]);

/***/ }),

/***/ "+IHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LibraryCard__ = __webpack_require__("Sbkf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AdCard__ = __webpack_require__("4/r4");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'library',

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    LibraryCard: __WEBPACK_IMPORTED_MODULE_7__components_LibraryCard__["a" /* default */],
    AdCard: __WEBPACK_IMPORTED_MODULE_8__components_AdCard__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      isSchoolInfoModal: false,
      isNoticeModal: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['trimmedLibraryFilters', 'checkedTutorials', 'coreConceptList', 'customCardList', 'libraryFilters', 'getRouteQuery', 'coreConcepts', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds', 'unitList', 'units', 'currentUser', 'subjectList', 'gradeList', 'gradeSubjects']), {
    showTooltip: function showTooltip() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.checkedTutorials) && this.checkedTutorials.welcome && !this.checkedTutorials.tryCustomCard) {
        return true;
      }

      return false;
    },
    isFeaturedCardTab: function isFeaturedCardTab() {
      return this.$route.params.card_type === 'featured-cards';
    },
    isSchoolCardTab: function isSchoolCardTab() {
      return this.$route.params.card_type === 'school-cards';
    },
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.libraryFilters.subject_id + '&' + this.libraryFilters.grade_id;
    },
    currentUnitList: function currentUnitList() {
      var _this = this;

      return this.unitList.filter(function (unit) {
        return unit.subject_id === parseInt(_this.libraryFilters.subject_id, 10) && unit.name !== 'NO NAME YET';
      });
    },
    currentCoreConceptList: function currentCoreConceptList() {
      var _this2 = this;

      return this.coreConceptList.filter(function (coreConcept) {
        return coreConcept.subject_id === parseInt(_this2.libraryFilters.subject_id, 10) && coreConcept.grade_id === parseInt(_this2.libraryFilters.grade_id, 10);
      });
    },
    currentCardList: function currentCardList() {
      return this.customCardList;
    },
    customCardsTabBindings: function customCardsTabBindings() {
      return {
        active: !this.isFeaturedCardTab && !this.isSchoolCardTab
      };
    },
    featuredCardsTabBindings: function featuredCardsTabBindings() {
      return {
        active: this.isFeaturedCardTab
      };
    },
    schoolCardsTabBindings: function schoolCardsTabBindings() {
      return {
        active: this.isSchoolCardTab
      };
    },
    isEmptySchoolInfo: function isEmptySchoolInfo() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.currentUser)) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.currentUser.school_id);
    }
  }),

  watch: {
    $route: function $route(state) {
      var _this3 = this;

      this.loading = true;

      if (state.params.card_type === 'featured-cards') {
        return this.setLibrartFilter({ property: 'offset', value: 0 }).then(function () {
          return _this3.setLibrartFilter({ property: 'publisher_id', value: __WEBPACK_IMPORTED_MODULE_6__config__["i" /* FEATURED_PUBLISHER_ID */] });
        }).then(function () {
          return _this3.setLibrartFilter({ property: 'school_id', value: '' });
        }).then(function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this3.fetchCustomCards(_this3.trimmedLibraryFilters), _this3.fetchAdvertisement()]);
        }).then(function () {
          _this3.loading = false;
        }).catch(function (err) {
          console.error('err while fetching custom cards in library view:', err);
          _this3.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }

      if (state.params.card_type === 'custom-cards') {
        return this.setLibrartFilter({ property: 'offset', value: 0 }).then(function () {
          return _this3.setLibrartFilter({ property: 'publisher_id', value: '0' });
        }).then(function () {
          return _this3.setLibrartFilter({ property: 'school_id', value: '' });
        }).then(function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this3.fetchCustomCards(_this3.trimmedLibraryFilters), _this3.fetchAdvertisement()]);
        }).then(function () {
          return _this3.setTutorialAsChecked('tryCustomCard');
        }).then(function () {
          _this3.loading = false;
        }).catch(function (err) {
          console.error('err while fetching custom cards in library view:', err);
          _this3.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }

      if (state.params.card_type === 'school-cards') {
        if (this.isEmptySchoolInfo) {
          this.isSchoolInfoModal = true;
          return true;
        }

        return this.setLibrartFilter({ property: 'offset', value: 0 }).then(function () {
          return _this3.setLibrartFilter({ property: 'publisher_id', value: '0' });
        }).then(function () {
          return _this3.setLibrartFilter({ property: 'school_id', value: _this3.currentUser.school_id });
        }).then(function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this3.fetchCustomCards(_this3.trimmedLibraryFilters), _this3.fetchAdvertisement()]);
        }).then(function () {
          _this3.loading = false;
        }).catch(function (err) {
          console.error('err while fetching custom cards in library view:', err);
          _this3.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }

      return true;
    },
    gradeSubjects: function gradeSubjects(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('subject-dropdown').firstElementChild.disabled = false;
      }
    },
    currentCoreConceptList: function currentCoreConceptList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
      }
    },
    currentUnitList: function currentUnitList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('unit-dropdown').firstElementChild.disabled = false;
      }
    },
    selectedSubjectGrade: function selectedSubjectGrade(state) {
      if (state.match(/^[0-9]+&0$/) || state.match(/^0&[0-9]+$/)) {
        return null;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(state.match(/[0-9]+&[0-9]+/))) {

        return this.fetchUnits({
          subject_id: this.libraryFilters.subject_id,
          grade_id: this.libraryFilters.grade_id
        });
      }

      return null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setTutorialAsChecked', 'fetchCoreConcepts', 'setLibrartFilter', 'fetchCustomCards', 'fetchUnits', 'fetchGradeSubjects', 'resetGradeSubjects', 'fetchAdvertisement']), {
    onTooltipClosed: function onTooltipClosed() {
      this.setTutorialAsChecked('tryCustomCard');
    },
    onInfinite: function onInfinite() {
      var _this4 = this;

      this.setLibrartFilter({ property: 'offset', value: this.libraryFilters.offset + 20 }).then(function () {
        if (_this4.isFeaturedCardTab) {
          return _this4.setLibrartFilter({ property: 'publisher_id', value: __WEBPACK_IMPORTED_MODULE_6__config__["i" /* FEATURED_PUBLISHER_ID */] }).then(function () {
            return _this4.fetchCustomCards(_this4.trimmedLibraryFilters);
          });
        }

        return _this4.fetchCustomCards(_this4.trimmedLibraryFilters);
      }).then(function (cardList) {
        if (_this4.$refs.infiniteLoading) {
          _this4.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (cardList.length === 0) {
            _this4.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      }).catch(function (err) {
        _this4.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    selectSubject: function selectSubject(subjectId) {
      var _this5 = this;

      if (this.libraryFilters.subject_id !== subjectId) {
        this.setLibrartFilter({ property: 'subject_id', value: subjectId }).then(function () {
          return _this5.setLibrartFilter({ property: 'core_concept_id', value: '0' });
        }).then(function () {
          return _this5.setLibrartFilter({ property: 'unit_id', value: '0' });
        }).then(function () {
          return _this5.setLibrartFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this5.loading = true;

          return _this5.fetchCustomCards(_this5.trimmedLibraryFilters);
        }).then(function () {
          _this5.loading = false;
        }).catch(function (err) {
          _this5.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectGrade: function selectGrade(gradeId, schoolYear) {
      var _this6 = this;

      if (this.libraryFilters.grade_id !== gradeId) {
        this.fetchGradeSubjects({ grade: schoolYear }).then(function () {
          return _this6.setLibrartFilter({ property: 'school_year', value: schoolYear });
        }).then(function () {
          return _this6.setLibrartFilter({ property: 'grade_id', value: gradeId });
        }).then(function () {
          return _this6.setLibrartFilter({ property: 'subject_id', value: '0' });
        }).then(function () {
          return _this6.setLibrartFilter({ property: 'core_concept_id', value: '0' });
        }).then(function () {
          return _this6.setLibrartFilter({ property: 'unit_id', value: '0' });
        }).then(function () {
          return _this6.setLibrartFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this6.loading = true;
          return _this6.fetchCustomCards(_this6.trimmedLibraryFilters);
        }).then(function () {
          _this6.loading = false;
        }).catch(function (err) {
          _this6.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectCoreConcept: function selectCoreConcept(coreConceptId) {
      var _this7 = this;

      if (this.libraryFilters.core_concept_id !== coreConceptId) {
        this.setLibrartFilter({ property: 'core_concept_id', value: coreConceptId }).then(function () {
          return _this7.setLibrartFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this7.loading = true;
          return _this7.fetchCustomCards(_this7.trimmedLibraryFilters);
        }).then(function () {
          _this7.loading = false;
        }).catch(function (err) {
          _this7.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectUnit: function selectUnit(unitId) {
      var _this8 = this;

      if (this.libraryFilters.unit_id !== unitId) {
        this.setLibrartFilter({ property: 'unit_id', value: unitId }).then(function () {
          return _this8.setLibrartFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this8.loading = true;
          return _this8.fetchCustomCards(_this8.trimmedLibraryFilters);
        }).then(function () {
          _this8.loading = false;
        }).catch(function (err) {
          _this8.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectMediaType: function selectMediaType(mediaType) {
      var _this9 = this;

      this.setLibrartFilter({ property: 'media_type', value: mediaType }).then(function () {
        return _this9.setLibrartFilter({ property: 'offset', value: 0 });
      }).then(function () {
        _this9.loading = true;
        return _this9.fetchCustomCards(_this9.trimmedLibraryFilters);
      }).then(function () {
        _this9.loading = false;
      }).catch(function (err) {
        _this9.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    selectOrderBy: function selectOrderBy(orderByParam) {
      var _this10 = this;

      if (this.libraryFilters.order_by !== orderByParam) {
        this.setLibrartFilter({ property: 'order_by', value: orderByParam }).then(function () {
          return _this10.setLibrartFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this10.loading = true;
          return _this10.fetchCustomCards(_this10.trimmedLibraryFilters);
        }).then(function () {
          _this10.loading = false;
        }).catch(function (err) {
          _this10.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },

    fetchWithSearchKeywords: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
      var _this11 = this;

      this.loading = true;
      this.fetchCustomCards(this.trimmedLibraryFilters).then(function () {
        _this11.loading = false;
      }).catch(function (err) {
        _this11.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    }, 500),

    applySearchKeywords: function applySearchKeywords(inputText) {
      var _this12 = this;

      if (this.libraryFilters.search_keywords !== inputText) {
        this.setLibrartFilter({ property: 'search_keywords', value: inputText }).then(function () {
          return _this12.setLibrartFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this12.fetchWithSearchKeywords();
        }).catch(function (err) {
          _this12.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    fetchInitialData: function fetchInitialData() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this13.isFeaturedCardTab) {
          return _this13.setLibrartFilter({ property: 'publisher_id', value: __WEBPACK_IMPORTED_MODULE_6__config__["i" /* FEATURED_PUBLISHER_ID */] }).then(function () {
            return _this13.fetchCustomCards(_this13.trimmedLibraryFilters);
          });
        }

        return _this13.fetchCustomCards(_this13.trimmedLibraryFilters);
      }).then(function () {
        _this13.loading = false;
      }).then(function () {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this13.checkedTutorials) && !_this13.checkedTutorials.welcome) {
          _this13.$root.$emit('show::modal', 'welcome-message-modal');
        }
      }).catch(function (err) {
        console.error('err while fetching store cards in library view:', err);
        _this13.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    handelSchoolInfoConfirmClick: function handelSchoolInfoConfirmClick() {
      window.open(__WEBPACK_IMPORTED_MODULE_6__config__["b" /* CLASSTING_URL */] + '/settings/personal_info');
      this.isSchoolInfoModal = false;
      return this.$router.push('/library/custom-cards');
    },
    handleNoticeModalConfirmClick: function handleNoticeModalConfirmClick() {
      this.isNoticeModal = false;
    }
  }),

  mounted: function mounted() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.gradeSubjects)) {
      document.getElementById('subject-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('subject-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.coreConcepts)) {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.units)) {
      document.getElementById('unit-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('unit-dropdown').firstElementChild.disabled = false;
    }
  },
  created: function created() {
    var _this14 = this;

    if (this.customCardList.length === 0) {
      this.loading = true;

      if (this.getRouteQuery.subject_id && this.getRouteQuery.grade_id && this.getRouteQuery.unit_id) {
        this.setLibrartFilter({ property: 'offset', value: 0 }).then(function () {
          return _this14.setLibrartFilter({ property: 'subject_id', value: _this14.getRouteQuery.subject_id });
        }).then(function () {
          return _this14.setLibrartFilter({ property: 'grade_id', value: _this14.getRouteQuery.grade_id });
        }).then(function () {
          return _this14.setLibrartFilter({ property: 'unit_id', value: _this14.getRouteQuery.unit_id });
        }).then(function () {
          return _this14.fetchInitialData();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          return _this14.setLibrartFilter({ property: 'grade_id', value: _this14.currentUser.grade_id });
        }).then(function () {
          return _this14.fetchGradeSubjects({ grade: _this14.currentUser.grade_id });
        }).then(function () {
          return _this14.fetchInitialData();
        });
      }
    } else if (this.getRouteQuery.subject_id && this.getRouteQuery.grade_id && this.getRouteQuery.unit_id) {
      this.loading = true;

      this.setLibrartFilter({ property: 'offset', value: 0 }).then(function () {
        return _this14.setLibrartFilter({ property: 'subject_id', value: _this14.getRouteQuery.subject_id });
      }).then(function () {
        return _this14.setLibrartFilter({ property: 'grade_id', value: _this14.getRouteQuery.grade_id });
      }).then(function () {
        return _this14.setLibrartFilter({ property: 'unit_id', value: _this14.getRouteQuery.unit_id });
      }).then(function () {
        return _this14.fetchInitialData();
      });
    }
  }
});

/***/ }),

/***/ "+L1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chapter-list-item',

  props: {
    chapter: {
      type: Object,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    selectChapter: function selectChapter() {
      if (this.isActive) {
        return;
      }

      this.$emit('select-chapter', this.chapter.id);
    }
  }
});

/***/ }),

/***/ "+TP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["page"] = page;

function page(state) {
  return state.page;
}

/***/ }),

/***/ "+ZeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutosizeTextarea_vue__ = __webpack_require__("86hr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31356cba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutosizeTextarea_vue__ = __webpack_require__("ALs0");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutosizeTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31356cba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutosizeTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/AutosizeTextarea.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31356cba", Component.options)
  } else {
    hotAPI.reload("data-v-31356cba", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+cOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function datetime(dateStr) {
  if (dateStr) {
    var date = new Date(dateStr);

    var month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
    var day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    var hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
    var minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();

    var formattedDate = date.getFullYear() + '.' + month + '.' + day;
    var formattedTime = hour + ':' + minute;

    return formattedDate + ' ' + formattedTime;
  }

  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (datetime);

/***/ }),

/***/ "+hPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageLibraryModal_vue__ = __webpack_require__("Pw+G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f9aa91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageLibraryModal_vue__ = __webpack_require__("Hwr+");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageLibraryModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f9aa91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageLibraryModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/PageLibraryModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37f9aa91", Component.options)
  } else {
    hotAPI.reload("data-v-37f9aa91", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+iR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getRatio: function getRatio(num, total) {
      if (total === 0) {
        return 0;
      }

      return num / total * 100;
    },
    getSum: function getSum(numList) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["sum"])(numList);
    },
    getToCommas: function getToCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
});

/***/ }),

/***/ "+sNc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingBounce_vue__ = __webpack_require__("T1WI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21ae4e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBounce_vue__ = __webpack_require__("WZc2");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingBounce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21ae4e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBounce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LoadingBounce.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21ae4e38", Component.options)
  } else {
    hotAPI.reload("data-v-21ae4e38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/2uw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToSeriesModal_vue__ = __webpack_require__("bmII");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b65782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToSeriesModal_vue__ = __webpack_require__("zkyY");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("KBWG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToSeriesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b65782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToSeriesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/AddToSeriesModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47b65782", Component.options)
  } else {
    hotAPI.reload("data-v-47b65782", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/8gj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadVideoLecture_vue__ = __webpack_require__("s4iX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b173b9d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadVideoLecture_vue__ = __webpack_require__("dkNV");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("TP0h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b173b9d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadVideoLecture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b173b9d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadVideoLecture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-lectures/views/UploadVideoLecture.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b173b9d4", Component.options)
  } else {
    hotAPI.reload("data-v-b173b9d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Fal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_parses__ = __webpack_require__("N4id");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card-preview',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_parses__["a" /* default */]],

  data: function data() {
    return {
      answerList: [],

      currentPageIndex: 0,

      showSolution: false,

      onShown: true
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isStudentAssignmentPreview: 'isStudentAssignmentPreview',
    isClassAssignmentPreview: 'isClassAssignmentPreview',
    selectedPageIndex: 'selectedPreviewPageIndex',
    isPagePreview: 'isPagePreview',
    card: 'selectedPreviewCard'
  }), {
    showToggle: function showToggle() {
      return !this.isStudentAssignmentPreview && !this.isClassAssignmentPreview;
    },
    cardTitle: function cardTitle() {
      return this.card ? this.card.title : '';
    },
    currentPage: function currentPage() {
      if (this.card && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.card.pages) && this.card.pages[this.currentPageIndex]) {
        return this.card.pages[this.currentPageIndex];
      }

      return {};
    },
    hasNoPages: function hasNoPages() {
      if (this.card && this.card.pages && this.card.pages.length > 0) {
        return false;
      }

      return true;
    },
    currentPageAnswer: function currentPageAnswer() {
      return this.answerList[this.currentPageIndex];
    },
    isStorePage: function isStorePage() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.currentPage.store_page_id);
    },
    isQuizPage: function isQuizPage() {
      if (this.card) {
        return this.currentPage.is_quiz;
      }

      return false;
    },
    isEssayType: function isEssayType() {
      if (this.isQuizPage) {
        return this.getPageType() === 'essay_type';
      }

      return false;
    },
    hasExtraContent: function hasExtraContent() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.currentPage.extra_content);
    },
    submittedEssayAnswer: function submittedEssayAnswer() {
      if (this.isEssayType && this.submittedAnswer && this.submittedAnswer.value) {
        if (!this.currentPage.grading_keywords) {
          return this.submittedAnswer.value.replace(/\n/g, '<br>');
        }

        var answer = this.submittedAnswer.value.replace(/\n/g, '<br>');
        var gradingKeywords = this.currentPage.grading_keywords.replace(/\?/g, '\\?').replace(/\^/g, '\\^').replace(/\./g, '\\.').replace(/\$/g, '\\$').replace(/\|/g, '\\|').replace(/\*/g, '\\*').replace(/\+/g, '\\+').replace(/\(/g, '\\(').replace(/\)/g, '\\)').replace(/\[/g, '\\[').replace(/\]/g, '\\]').replace(/\{/g, '\\{').replace(/\}/g, '\\}');


        gradingKeywords.split(',').forEach(function (keyword) {
          answer = answer.replace(new RegExp(keyword, 'g'), '<span class="typography--color-accent typography--font-weight-600">' + keyword + '</span>');
        });

        return answer;
      }

      return null;
    },
    quizPageList: function quizPageList() {
      if (this.card) {
        return this.card.pages.filter(function (page) {
          return !!page.is_quiz;
        });
      }

      return [];
    },
    quizAnswers: function quizAnswers() {
      if (this.isQuizPage) {
        return this.currentPage.options || this.currentPage.answers;
      }

      return [];
    },
    submittedAnswer: function submittedAnswer() {
      if (this.currentPage.submitted_answers && this.currentPage.submitted_answers.length > 0) {
        return this.currentPage.submitted_answers[0];
      }

      return null;
    },
    summarizedSubmittedAnswers: function summarizedSubmittedAnswers() {
      if (this.currentPage.submitted_answers && this.currentPage.submitted_answers.length > 0) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["groupBy"])(this.currentPage.submitted_answers, 'value');
      }

      return null;
    },
    correctAnswerIndex: function correctAnswerIndex() {
      var _this = this;

      var correctIndex = -1;

      this.quizAnswers.forEach(function (answer, i) {
        if (_this.getIsCorrect(answer)) {
          correctIndex = i;
        }
      });

      return correctIndex + 1;
    },
    correctAnswerContents: function correctAnswerContents() {
      var _this2 = this;

      return this.quizAnswers.filter(function (answer) {
        return !!_this2.getIsCorrect(answer);
      }).map(function (answer) {
        return _this2.getAnswerContent(answer);
      }).join(', ');
    },
    submittedAnswerIndex: function submittedAnswerIndex() {
      var _this3 = this;

      if (!this.submittedAnswer) {
        return 0;
      }

      var submittedIndex = -1;

      this.quizAnswers.forEach(function (answer, i) {
        if (_this3.submittedAnswer.answer_id === answer.id) {
          submittedIndex = i;
        }
      });

      return submittedIndex + 1;
    },
    submittedAnswerContent: function submittedAnswerContent() {
      if (!this.submittedAnswer) {
        return '';
      }

      return this.submittedAnswer.value;
    },
    isLastPage: function isLastPage() {
      if (this.card) {
        return this.currentPageIndex === this.card.pages.length - 1;
      }

      return 0;
    },
    cardPagesLength: function cardPagesLength() {
      return this.card ? this.card.pages.length : 0;
    },
    extraContentImgaeBinding: function extraContentImgaeBinding() {
      if (this.currentPage.extra_content.image_url) {
        return {
          'background-image': 'url(\'' + this.currentPage.extra_content.image_url + '\')'
        };
      }
      return {};
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setIsStudentAssignmentPreview', 'setIsClassAssignmentPreview', 'setSelectedPreviewPageIndex', 'setIsPagePreview']), {
    showReportContentModal: function showReportContentModal() {
      var _this4 = this;

      this.setSelectedPreviewPageIndex(this.currentPageIndex).then(function () {
        return _this4.$emit('show-report-content-modal');
      });
    },
    setup: function setup() {
      this.onShown = true;
      this.answerList = this.card.pages.map(function (page) {
        if (page.is_quiz) {
          return { pageId: page.id, answer: null };
        }

        return {};
      });

      this.currentPageIndex = this.selectedPageIndex;
      this.showSolution = false;

      if (this.isClassAssignmentPreview || this.isStudentAssignmentPreview) {
        this.showSolution = true;
      }
    },
    clean: function clean() {
      this.onShown = false;
      this.answerList = [];
      var pageElem = document.querySelector('#card-preview-modal .modal-body>div');

      if (pageElem) {
        pageElem.scrollIntoView(true);
      }

      this.setIsStudentAssignmentPreview(false);
      this.setIsClassAssignmentPreview(false);
      this.setIsPagePreview(false);
    },
    prev: function prev() {
      if (this.currentPageIndex > 0) {
        this.currentPageIndex -= 1;
        document.querySelector('#card-preview-modal .modal-body>div').scrollIntoView(true);
      }
    },
    next: function next() {
      if (!this.isLastPage) {
        this.currentPageIndex += 1;
        document.querySelector('#card-preview-modal .modal-body>div').scrollIntoView(true);
      }
    },
    hasAudio: function hasAudio(page) {
      return page.audio_count > 0 && page.audios.length > 0;
    },
    hasVideo: function hasVideo(page) {
      return page.video_count > 0 && page.videos && page.videos.length > 0;
    },
    getFormattedAudio: function getFormattedAudio(page) {
      if (!this.hasAudio(page)) {
        return null;
      }

      var audio = page.audios[0];

      if (audio.audio_url) {
        return audio;
      }

      return {
        duration_millis: audio.duration_millis,
        audio_url: audio.url,
        created_at: audio.created_at,
        deleted_at: null,
        duration: audio.duration,
        file_size: audio.file_size,
        id: audio.id,
        original_filename: audio.original_filename,
        page_id: page.id,
        reference: audio.reference,
        updated_at: audio.updated_at
      };
    },
    getFormattedVideo: function getFormattedVideo(page) {
      if (!this.hasVideo(page)) {
        return null;
      }

      var video = page.videos[0];

      if (video.video_url) {
        return video;
      }

      return {
        duration_millis: video.duration_millis,
        video_url: video.url,
        created_at: video.created_at,
        deleted_at: null,
        duration: video.duration,
        file_size: video.file_size,
        id: video.id,
        width: video.width,
        height: video.height,
        page_id: page.id,
        poster_url: video.poster_url,
        reference: video.reference,
        updated_at: video.updated_at
      };
    },
    toggleShowSolution: function toggleShowSolution(value) {
      this.showSolution = value;
    },
    getIsCorrect: function getIsCorrect(answer) {
      if (answer.is_correct !== undefined) {
        return answer.is_correct;
      }

      return answer.is_answer;
    },
    getIsIncorrect: function getIsIncorrect(answer) {
      if (this.getSumittedAnswerCount(answer) === 0) {
        return false;
      }

      return !this.getIsCorrect(answer);
    },
    getAnswerContent: function getAnswerContent(answer) {
      if (answer.content !== undefined) {
        return answer.content;
      }

      return answer.value;
    },
    getPageType: function getPageType() {
      if (this.currentPage.quiz_type) {
        return this.currentPage.quiz_type;
      }

      if (this.currentPage.page_type) {
        return this.currentPage.page_type.name;
      }

      if (this.currentPage.page_type_id === 2) {
        return 'multiple_choice';
      }

      if (this.currentPage.page_type_id === 3) {
        return 'text_entry';
      }

      if (this.currentPage.page_type_id === 4) {
        return 'essay_type';
      }

      return '';
    },
    isVisibleQuizOptions: function isVisibleQuizOptions() {
      return this.currentPage.answer_view_type !== 'control' || !this.isEmptyOptions() && !this.isInvalidNumberOptions();
    },
    isInvalidNumberOptions: function isInvalidNumberOptions() {
      var _this5 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["every"])(this.quizAnswers, function (item) {
        var option = Number(_this5.getOption(item));
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNaN"])(option) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNumber"])(option) && _this5.getOption(item).length === 1;
      });
    },
    isEmptyOptions: function isEmptyOptions() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["every"])(this.quizAnswers, function (answer) {
        return !answer.content;
      });
    },
    getOption: function getOption(option) {
      return option.content || option.value;
    },
    getAverageQuizScoreRatio: function getAverageQuizScoreRatio(submittedAnswers) {
      if (!submittedAnswers || submittedAnswers.length === 0) {
        return 0;
      }

      var correctCount = submittedAnswers.filter(function (answer) {
        return !!answer.is_correct;
      }).length;

      return parseInt(correctCount / submittedAnswers.length * 100, 10);
    },
    getSumittedAnswerCount: function getSumittedAnswerCount(answer) {
      if (this.currentPage.submitted_answers && this.currentPage.submitted_answers.length > 0) {
        return this.currentPage.submitted_answers.filter(function (submittedAnswer) {
          return submittedAnswer.answer_id === answer.id;
        }).length;
      }

      return 0;
    },
    getSumittedAnswerRatio: function getSumittedAnswerRatio(count) {
      if (this.currentPage.submitted_answers && this.currentPage.submitted_answers.length > 0) {
        return parseInt(count / this.currentPage.submitted_answers.length * 100, 10);
      }

      return 0;
    }
  })
});

/***/ }),

/***/ "/OdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  selectedCustomCardId: '',

  customCardList: []
});

/***/ }),

/***/ "/UHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_quiz__ = __webpack_require__("cUxh");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quiz-preview',

  props: {
    quiz: {
      type: Object,
      default: {}
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_quiz__["a" /* default */]]

});

/***/ }),

/***/ "/ZIg":
/***/ (function(module, exports) {

module.exports = {"Play":"再生","Pause":"一時停止","Current Time":"現在の時間","Duration Time":"長さ","Remaining Time":"残りの時間","Stream Type":"ストリームの種類","LIVE":"ライブ","Loaded":"ロード済み","Progress":"進行状況","Fullscreen":"フルスクリーン","Non-Fullscreen":"フルスクリーン以外","Mute":"ミュート","Unmute":"ミュート解除","Playback Rate":"再生レート","Subtitles":"サブタイトル","subtitles off":"サブタイトル オフ","Captions":"キャプション","captions off":"キャプション オフ","Chapters":"チャプター","You aborted the media playback":"動画再生を中止しました","A network error caused the media download to fail part-way.":"ネットワーク エラーにより動画のダウンロードが途中で失敗しました","The media could not be loaded, either because the server or network failed or because the format is not supported.":"サーバーまたはネットワークのエラー、またはフォーマットがサポートされていないため、動画をロードできませんでした","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"破損の問題、またはお使いのブラウザがサポートしていない機能が動画に使用されていたため、動画の再生が中止されました","No compatible source was found for this media.":"この動画に対して互換性のあるソースが見つかりませんでした"}

/***/ }),

/***/ "/dQ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var UPDATE_CL_EVENT = 'clEvents/UPDATE_CL_EVENT';
var SET_CL_EVENTS = 'clEvents/SET_CL_EVENTS';

/* harmony default export */ __webpack_exports__["a"] = ({
  UPDATE_CL_EVENT: UPDATE_CL_EVENT,
  SET_CL_EVENTS: SET_CL_EVENTS
});

/***/ }),

/***/ "/f6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer-content'
});

/***/ }),

/***/ "/pyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  checkedTutorials: null
});

/***/ }),

/***/ "/rOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchAdvertisement"] = fetchAdvertisement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Kj51");




function fetchAdvertisement(_ref) {
  var commit = _ref.commit;

  var params = { view_template: 'learning' };
  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_0__config__["f" /* MINERVA_API_URL */] + '/advertisement', { params: params }).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_ADVERTISEMENT, res.data);
  }).catch(function () {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_ADVERTISEMENT, {});
  });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/hv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-summary',

  props: ['page', 'index'],

  computed: {
    pageContent: function pageContent() {
      return this.page ? this.page.content : '<p></p>';
    },
    contentImages: function contentImages() {
      var _this = this;

      return this.page.images.filter(function (image) {
        return _this.page.content.indexOf('data-image-id="' + image.id + '"') !== -1;
      });
    },
    hasImage: function hasImage() {
      return this.page.image_count > 0 && this.contentImages.length > 0;
    },
    hasAudio: function hasAudio() {
      return this.page.audio_count > 0 && this.page.audios.length > 0;
    },
    hasVideo: function hasVideo() {
      return this.page.video_count > 0 && this.page.videos && this.page.videos.length > 0;
    },
    hasEmbededVideo: function hasEmbededVideo() {
      return this.page.content.match(/<iframe/g) || (this.page.description || '').match(/<iframe/g);
    },
    classBindings: function classBindings() {
      return {
        'has-image': this.hasImage,
        'has-audio': this.hasAudio,
        'has-video': this.hasVideo || this.hasEmbededVideo
      };
    },
    firstImageSrc: function firstImageSrc() {
      if (this.hasImage) {
        var imageUrl = this.contentImages[0].image_url || this.contentImages[0].small_url || this.contentImages[0].medium_url || this.contentImages[0].original_url;

        return 'url(\'' + imageUrl + '\')';
      }

      return '';
    },
    firstAudioDuration: function firstAudioDuration() {
      if (this.hasAudio) {
        return this.page.audios[0].duration;
      }

      return 0;
    },
    firstVideoDuration: function firstVideoDuration() {
      if (this.hasVideo) {
        return this.page.videos[0].duration;
      }

      return 0;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'setIsPagePreview']), {
    openCardPreview: function openCardPreview() {
      var _this2 = this;

      this.setSelectedPreviewPageIndex(this.index).then(function () {
        return _this2.setIsPagePreview(true);
      }).then(function () {
        _this2.$root.$emit('show::modal', 'card-preview-modal');
      });
    }
  })
});

/***/ }),

/***/ "0Eyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-video-lecture" }, [
    _c("div", { staticClass: "edit-video-lecture__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "edit-video-lecture__header-title typography--color-primary text-center"
            },
            [
              _vm.lecture
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.edit_video_lecture.title")
                        ) +
                        "\n          "
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.new_video_lecture.title")
                        ) +
                        "\n          "
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _vm.videoEmbed
            ? _c(
                "div",
                { staticClass: "edit-video-lecture__video-preview w-100" },
                [
                  _c("div", {
                    staticClass: "w-100",
                    domProps: { innerHTML: _vm._s(_vm.videoEmbed) }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 text-center" },
                  [
                    _c("LoadingBounce"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-2 typography--color-disabled pb-5"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.loading")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "edit-video-lecture__form" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "subject-select" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("publishers.modal.new_series.subject")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.subjectId,
                          expression: "subjectId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "subject-select",
                        disabled: _vm.subjectSelectDisabled
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.subjectId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.onSubjectSelect
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "publishers.modal.new_series.subject_placeholder"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.subjectIds.filter(function(id) {
                          return id !== "0" && id !== "9999"
                        }),
                        function(sjId) {
                          return _c(
                            "option",
                            { key: sjId, domProps: { value: sjId } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getTranslatedName(_vm.subjectMap[sjId])
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "grade-select" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("publishers.modal.new_series.grade")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gradeId,
                          expression: "gradeId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "grade-select",
                        disabled: _vm.gradeSelectDisabled
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.gradeId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "publishers.modal.new_series.grade_placeholder"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.gradeIds.filter(function(id) {
                          return id !== "0" && id !== "9999"
                        }),
                        function(gId) {
                          return _c(
                            "option",
                            { key: gId, domProps: { value: gId } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getTranslatedName(_vm.gradeMap[gId])
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDomainSelect,
                        expression: "showDomainSelect"
                      }
                    ],
                    staticClass: "form-group"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary typography--font-weight-600",
                        attrs: { for: "domain-select" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("publishers.modal.chapter_edit.domain")
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.domainId,
                            expression: "domainId"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "domain-select",
                          disabled: _vm.domainSelectDisabled
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.domainId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.onDomainSelect
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "publishers.modal.chapter_edit.domain_placeholder"
                                )
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.domainList, function(domain) {
                          return _c(
                            "option",
                            { key: domain.id, domProps: { value: domain.id } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(domain.name) +
                                  "\n              "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDomainConceptSelect,
                        expression: "showDomainConceptSelect"
                      }
                    ],
                    staticClass: "form-group"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary typography--font-weight-600",
                        attrs: { for: "domain-concept-select" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "publishers.modal.chapter_edit.domain_concept"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.domainConceptId,
                            expression: "domainConceptId"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "domain-concept-select" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.domainConceptId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "publishers.modal.chapter_edit.domain_concept_placeholder"
                                )
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.domainConceptList, function(concept) {
                          return _c(
                            "option",
                            {
                              key: concept.id,
                              domProps: { value: concept.id }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(concept.name) +
                                  "\n              "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "video-lecture-title-input" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.lectureTitle,
                        expression: "lectureTitle",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "video-lecture-title-input",
                      maxlength: "50",
                      placeholder: _vm.$t(
                        "publishers.modal.new_series.name_placeholder"
                      )
                    },
                    domProps: { value: _vm.lectureTitle },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.lectureTitle = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "video-lecture-description-input" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("publishers.modal.new_series.description")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lectureDescription,
                        expression: "lectureDescription"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "video-lecture-description-input",
                      rows: "5",
                      maxlength: "500",
                      placeholder: _vm.$t(
                        "publishers.modal.new_series.description_placeholder"
                      )
                    },
                    domProps: { value: _vm.lectureDescription },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.lectureDescription = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group pb-4" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.modal.edit_video_lecture.share_level"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-6" },
                    [
                      _c(
                        "ToggleSwitch",
                        {
                          attrs: {
                            id: "share-level-switch",
                            "model-value": _vm.shareLevel,
                            "check-value": 1
                          },
                          on: { change: _vm.toggleShareLevel }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getShareLevelLabel(_vm.shareLevel || 2)
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.lecture
                  ? _c("div", { staticClass: "text-center mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-full edit-video-lecture__create-btn",
                          attrs: { disabled: _vm.newLectureDisabled },
                          on: {
                            click: function($event) {
                              return _vm.update()
                            }
                          }
                        },
                        [
                          !_vm.busy
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("common.save")))
                              ])
                            : _c("LoadingBounce")
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "text-center mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-full edit-video-lecture__create-btn",
                          attrs: { disabled: _vm.newLectureDisabled },
                          on: {
                            click: function($event) {
                              return _vm.create()
                            }
                          }
                        },
                        [
                          !_vm.busy
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "video_lectures.new_video_course.create"
                                    )
                                  )
                                )
                              ])
                            : _c("LoadingBounce")
                        ],
                        1
                      )
                    ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center mt-2" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn btn-secondary btn-full edit-video-lecture__cancel-btn typography--color-secondary",
                        attrs: { to: _vm.prevLink }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("btn.redirect_to_root")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd4df9f", esExports)
  }
}

/***/ }),

/***/ "0K6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "library-card dummy-card" }, [
    _c("div", { staticClass: "card-cover-img-thumb" }),
    _vm._v(" "),
    _c("div", { staticClass: "card-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 card-info-section" }, [
          _c("h4", { staticClass: "card-title typography--title" }),
          _vm._v(" "),
          _c("small", { staticClass: "typography--caption" }),
          _vm._v(" "),
          _c("div", { staticClass: "card-bottom-desc" }, [
            _c("div", [
              _c("small", {
                staticClass: "typography--caption typography--color-secondary"
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("small", {
                staticClass: "typography--caption typography--color-secondary"
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("small", {
                staticClass: "typography--caption typography--color-secondary"
              })
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-action" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03f4abd8", esExports)
  }
}

/***/ }),

/***/ "0MsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CreateDocxQuizzes__ = __webpack_require__("c8AG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_PublisherSeries__ = __webpack_require__("Df6v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_NonSeriesCards__ = __webpack_require__("x7vy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_SeriesCards__ = __webpack_require__("b7xH");





var router = [{
  path: '/publishers',
  redirect: function redirect() {
    return '/publishers/series';
  }
}, {
  name: 'publishers.nonSeriesCards',
  path: '/publishers/non-series-cards',
  component: __WEBPACK_IMPORTED_MODULE_2__views_NonSeriesCards__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'publishers.createDocxQuizzes',
  path: '/publishers/create-docx-quizzes',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CreateDocxQuizzes__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'publishers.series',
  path: '/publishers/series',
  component: __WEBPACK_IMPORTED_MODULE_1__views_PublisherSeries__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'publishers.series.cards',
  path: '/publishers/series/:series_id',
  component: __WEBPACK_IMPORTED_MODULE_3__views_SeriesCards__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'publishers.series.chapters.createDocxQuizzes',
  path: '/publishers/series/:series_id/chapters/:chapter_id/create-docx-quizzes',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CreateDocxQuizzes__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "0OPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-course-item clickable" }, [
    _c(
      "div",
      {
        staticClass: "card-title video-course-item__title typography--body-1",
        attrs: { title: _vm.course.title }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.course.title + " (" + _vm.course.id + ")") +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "typography--body-2" }, [
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.getGradeLabel(_vm.course)) +
              "\n      " +
              _vm._s(_vm.getSubjectLabel(_vm.course)) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _vm.course.domain
        ? _c(
            "small",
            {
              staticClass:
                "text-muted typography--caption typography--color-secondary"
            },
            [
              _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("|")]),
              _vm._v(
                "\n      " +
                  _vm._s("영역: " + _vm.course.domain.name) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "typography--body-2" }, [
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [_vm._v("\n      " + _vm._s(_vm.getUnitName(_vm.course)) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "typography--body-2" }, [
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("video_lectures.video_course.lecture_count", {
                  count: _vm.course.lecture_count
                })
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "small",
        {
          staticClass:
            "text-muted typography--caption typography--color-secondary"
        },
        [
          _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("|")]),
          _vm._v(" "),
          _vm.course.share_level === "1"
            ? _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("common.card.share_level.public")) +
                    "\n      "
                )
              ])
            : _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("common.card.share_level.private")) +
                    "\n      "
                )
              ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3afacfe0", esExports)
  }
}

/***/ }),

/***/ "0OjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal extra-content-edit-modal",
      attrs: { id: "extra-content-edit-modal", isCustomFooter: true }
    },
    [
      _c(
        "div",
        {
          staticClass: "extra-content-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v("\n    긴지문 설정\n    "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger ml-20",
              attrs: { type: "button", disabled: !_vm.hasExtraContent },
              on: {
                click: function($event) {
                  return _vm.remove()
                }
              }
            },
            [_vm._v("\n      삭제\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "extra-content-edit-modal__form" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "extra-content-title-input" }
            },
            [_vm._v("\n        제목\n      ")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.extraContentTitle,
                expression: "extraContentTitle"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", id: "extra-content-title-input" },
            domProps: { value: _vm.extraContentTitle },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.extraContentTitle = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600 clickable"
            },
            [
              _vm._v("\n        긴지문 이미지\n        "),
              _c("img", {
                attrs: { src: "/static/images/ic-camera.svg", alt: "" }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "no-display",
                attrs: {
                  type: "file",
                  accept: "image/png,image/jpeg,image/jpg"
                },
                on: { change: _vm.onExtraContentImageChange }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "extra-content-image",
            style: _vm.extraContentImgaeBinding
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mr-10",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [_vm._v("\n      취소\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.save()
              }
            }
          },
          [_vm._v("\n      저장\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d50e02", esExports)
  }
}

/***/ }),

/***/ "0ZBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_player_vue__ = __webpack_require__("xMHy");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7e6ee47f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_player_vue__ = __webpack_require__("rgzp");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("IQA+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7e6ee47f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-video-player/player.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e6ee47f", Component.options)
  } else {
    hotAPI.reload("data-v-7e6ee47f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0fi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchMyQuizzes"] = fetchMyQuizzes;
/* harmony export (immutable) */ __webpack_exports__["createQuiz"] = createQuiz;
/* harmony export (immutable) */ __webpack_exports__["updateQuiz"] = updateQuiz;
/* harmony export (immutable) */ __webpack_exports__["deleteQuiz"] = deleteQuiz;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("K9lf");




function fetchMyQuizzes(_ref, _ref2) {
  var commit = _ref.commit;
  var type = _ref2.type,
      params = _ref2.params;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].FETCH_MY_QUIZZES_REQUEST);
  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_0__config__["m" /* CT_API_URL */] + '/users/me/quizzes', { params: params }).then(function (res) {
    return commit(type, { myQuizzes: res.data, total: res.headers.total });
  }).catch(function (err) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].FETCH_MY_QUIZZES_FAILURE, err);
  });
}

function createQuiz(_ref3, data) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_QUIZ_REQUEST);
  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_0__config__["m" /* CT_API_URL */] + '/quizzes', data).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_QUIZ_SUCCESS, res.data);
  }).catch(function (err) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_QUIZ_FAILURE, err);
  });
}

function updateQuiz(_ref4, data) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].PUT_QUIZ_REQUEST);
  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].put(__WEBPACK_IMPORTED_MODULE_0__config__["m" /* CT_API_URL */] + '/quizzes/' + data.id, data).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].PUT_QUIZ_SUCCESS, res.data);
  }).catch(function (err) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].PUT_QUIZ_FAILURE, err);
  });
}

function deleteQuiz(_ref5, id) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].DELETE_QUIZ_REQUEST);
  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_0__config__["m" /* CT_API_URL */] + '/quizzes/' + id).then(function () {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].DELETE_QUIZ_SUCCESS, id);
  }).catch(function (err) {
    return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].DELETE_QUIZ_FAILURE, err);
  });
}

/***/ }),

/***/ "0qmm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__my_quizzes__ = __webpack_require__("a+L7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__video_lectures__ = __webpack_require__("lZGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__video_courses__ = __webpack_require__("1p+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assignments__ = __webpack_require__("7ktI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__publishers__ = __webpack_require__("F04J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__my_cards__ = __webpack_require__("TvRo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__edit_page__ = __webpack_require__("ao0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth__ = __webpack_require__("b3O1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__library__ = __webpack_require__("+9qS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__errors__ = __webpack_require__("a7z3");












/* harmony default export */ __webpack_exports__["a"] = ([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__my_quizzes__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__video_lectures__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__video_courses__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__assignments__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__publishers__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__my_cards__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__library__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__auth__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__errors__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__edit_page__["a" /* router */])));

/***/ }),

/***/ "0skX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0xvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal policy-modal hide-cancel-btn",
      attrs: {
        id: _vm.id,
        title: _vm.title,
        "ok-title": _vm.$t("common.close")
      },
      on: { shown: _vm.onOpen }
    },
    [
      _c(
        "div",
        { staticClass: "policy-container scroll-box" },
        [
          _vm.markdown
            ? _c("VueMarkdown", { attrs: { source: _vm.markdown } })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-070b65ca", esExports)
  }
}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1+da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("sQ9I");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1Lkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyQuizzes_vue__ = __webpack_require__("4mxe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a5412a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyQuizzes_vue__ = __webpack_require__("PyPT");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("n4MN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a5412a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyQuizzes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a5412a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyQuizzes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-quizzes/views/MyQuizzes.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a5412a0", Component.options)
  } else {
    hotAPI.reload("data-v-1a5412a0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1W3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageEditorModal_vue__ = __webpack_require__("m3BN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b6f80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageEditorModal_vue__ = __webpack_require__("xYl9");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Oudl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageEditorModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b6f80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageEditorModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/PageEditorModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72b6f80e", Component.options)
  } else {
    hotAPI.reload("data-v-72b6f80e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1ekj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "badge badge-default in-progress-badge" }, [
    _vm._v("\n  " + _vm._s(_vm.$t("common.in_progress")) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b3f5dd1", esExports)
  }
}

/***/ }),

/***/ "1nS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clickout__ = __webpack_require__("om2z");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'topic-dropup',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clickout__["a" /* default */]],

  data: function data() {
    return {
      visible: false
    };
  },


  watch: {
    visible: function visible(state, old) {
      if (state === old) {
        return;
      }

      if (state) {
        this.$root.$emit('shown::dropdown', this);
      } else {
        this.$root.$emit('hidden::dropdown', this);
      }
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.visible = !this.visible;
    },
    clickOutListener: function clickOutListener() {
      this.visible = false;
    },
    click: function click() {
      this.toggleMenu();
    }
  },

  created: function created() {
    var _this = this;

    this.$root.$on('shown::dropdown', function (el) {
      if (el !== _this) {
        _this.visible = false;
      }
    });
  }
});

/***/ }),

/***/ "1p+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("kwSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("lBJM");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2IbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lecture
    ? _c("Card", { staticClass: "video-lecture-item clickable" }, [
        _c("div", {
          staticClass: "video-lecture-item__thumbnail",
          style: _vm.lectureThumbStyle
        }),
        _vm._v(" "),
        _c("div", { staticClass: "card-block video-lecture-item__meta" }, [
          _c(
            "div",
            {
              staticClass:
                "card-title video-lecture-item__title typography--body-1",
              attrs: { title: _vm.lecture.title }
            },
            [_vm._v("\n      " + _vm._s(_vm.lecture.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-text" }, [
            _c("div", [
              _c(
                "small",
                {
                  staticClass:
                    "text-muted typography--caption typography--color-secondary"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getGradeLabel(_vm.lecture)) +
                      "\n          " +
                      _vm._s(_vm.getSubjectLabel(_vm.lecture)) +
                      "\n          "
                  ),
                  _vm.lecture.domain
                    ? _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.lecture.domain.name) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getShareLevelLabel(_vm.lecture.share_level || 2)
                        ) +
                        "\n          "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "small",
                {
                  staticClass:
                    "text-muted typography--caption typography--color-secondary"
                },
                [
                  _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.terms.view_count")) +
                        " " +
                        _vm._s(_vm.lecture.view_count) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.terms.like")) +
                        " " +
                        _vm._s(_vm.lecture.like_count) +
                        "\n          "
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-518c2c2e", esExports)
  }
}

/***/ }),

/***/ "2Q4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-time-picker-container",
      on: { click: _vm.showPicker }
    },
    [
      _c("input", {
        staticClass: "date-time-picker-input",
        attrs: { type: "text", id: _vm.pickerId },
        domProps: { value: _vm.initialDueDate }
      }),
      _vm._v(" "),
      _vm._t("label")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f503b48e", esExports)
  }
}

/***/ }),

/***/ "2UVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__("u4Bf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CourseLectureItem__ = __webpack_require__("ChIo");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-course-details',

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_publisherOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_labels__["a" /* default */]],

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    CourseLectureItem: __WEBPACK_IMPORTED_MODULE_8__components_CourseLectureItem__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a
  },

  data: function data() {
    return {
      domainConceptList: [],
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['lecturesByCourseId', 'videoLectures', 'videoCourses', 'subjectMap', 'gradeMap']), {
    course: function course() {
      return this.videoCourses[this.$route.params.course_id];
    },
    subjectName: function subjectName() {
      return this.getSubjectLabel(this.course);
    },
    gradeName: function gradeName() {
      return this.getGradeLabel(this.course);
    },
    courseTitle: function courseTitle() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course)) {
        return '';
      }

      return this.gradeName + ' ' + this.subjectName + ': ' + this.course.title;
    },
    courseDescription: function courseDescription() {
      if (this.course && this.course.description) {
        return this.course.description.replace(/\n/g, '<br>');
      }

      return null;
    },
    courseDomainName: function courseDomainName() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.course.domain)) {
        return '';
      }

      return this.course.domain.name;
    },
    domainConcepts: function domainConcepts() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(this.domainConceptList, function (dc) {
        return dc.id;
      });
    },
    lectureCount: function lectureCount() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course)) {
        return 0;
      }

      return this.course.lecture_count || 0;
    },


    lectures: {
      get: function get() {
        var lectures = this.lecturesByCourseId[this.$route.params.course_id] || [];

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(lectures, 'position');
      },
      set: function set(list) {
        var _this = this;

        var newList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(list, function (item, i) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
            position: i + 1
          });
        });

        var modifiedItems = newList.filter(function (item) {
          return item.position !== _this.videoLectures[item.id].position;
        });

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(modifiedItems, function (item) {
          return _this.updateVideoLecture({
            id: item.id,
            position: item.position
          });
        }));
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchDomainConceptList', 'fetchMyVideoLectureList', 'updateVideoLecture', 'removeVideoCourse', 'fetchVideoCourse']), {
    removeCourse: function removeCourse() {
      var _this2 = this;

      this.removeVideoCourse(this.course.id).then(function () {
        return _this2.$router.replace('/video-courses');
      });
    },
    onInfinite: function onInfinite() {
      var _this3 = this;

      var perPage = 10;
      var page = parseInt(this.lectures.length / perPage, 10) + 1;
      var params = {
        video_course_id: this.$route.params.course_id,
        per_page: perPage,
        page: page
      };

      return this.fetchMyVideoLectureList(params).then(function (courseLectureList) {
        if (_this3.$refs.infiniteLoading) {
          _this3.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (courseLectureList.length < perPage) {
            _this3.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this4 = this;

    this.loading = true;

    var courseId = this.$route.params.course_id;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this4.videoCourses[courseId])) {
        return _this4.fetchVideoCourse(courseId);
      }

      return _this4.videoCourses[courseId];
    }).then(function () {
      if (_this4.course.domain_id) {
        var params = {
          domain_id: _this4.course.domain_id,
          per_page: 50
        };

        return _this4.fetchDomainConceptList(params);
      }

      return [];
    }).then(function (domainConceptList) {
      _this4.domainConceptList = domainConceptList;
      _this4.loading = false;
    });
  }
});

/***/ }),

/***/ "2ZuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-carousel',

  props: {
    imageList: {
      type: Array,
      default: null
    }
  }
});

/***/ }),

/***/ "2fdQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchSubjectList"] = fetchSubjectList;
/* harmony export (immutable) */ __webpack_exports__["fetchGradeList"] = fetchGradeList;
/* harmony export (immutable) */ __webpack_exports__["fetchUnits"] = fetchUnits;
/* harmony export (immutable) */ __webpack_exports__["fetchCoreConcepts"] = fetchCoreConcepts;
/* harmony export (immutable) */ __webpack_exports__["fetchDomainList"] = fetchDomainList;
/* harmony export (immutable) */ __webpack_exports__["fetchDomain"] = fetchDomain;
/* harmony export (immutable) */ __webpack_exports__["fetchDomainConceptList"] = fetchDomainConceptList;
/* harmony export (immutable) */ __webpack_exports__["fetchDomainConcept"] = fetchDomainConcept;
/* harmony export (immutable) */ __webpack_exports__["fetchLearningElementList"] = fetchLearningElementList;
/* harmony export (immutable) */ __webpack_exports__["fetchGradeSubjects"] = fetchGradeSubjects;
/* harmony export (immutable) */ __webpack_exports__["resetGradeSubjects"] = resetGradeSubjects;
/* harmony export (immutable) */ __webpack_exports__["setMyCardsFilter"] = setMyCardsFilter;
/* harmony export (immutable) */ __webpack_exports__["setLibrartFilter"] = setLibrartFilter;
/* harmony export (immutable) */ __webpack_exports__["setPageLibraryFilter"] = setPageLibraryFilter;
/* harmony export (immutable) */ __webpack_exports__["setAssignmentsFilter"] = setAssignmentsFilter;
/* harmony export (immutable) */ __webpack_exports__["setCoreConcepts"] = setCoreConcepts;
/* harmony export (immutable) */ __webpack_exports__["setDomains"] = setDomains;
/* harmony export (immutable) */ __webpack_exports__["setUnits"] = setUnits;
/* harmony export (immutable) */ __webpack_exports__["setSubjects"] = setSubjects;
/* harmony export (immutable) */ __webpack_exports__["setGrades"] = setGrades;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("yE1h");








function fetchSubjectList(_ref, params) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/subjects', { params: params }).then(function (res) {
    return res.data;
  }).then(function (subjectList) {
    return dispatch('setSubjects', subjectList);
  }).catch(function (err) {
    console.error('err while fetching subjects:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchGradeList(_ref2, params) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/grades', { params: params }).then(function (res) {
    return res.data;
  }).then(function (gradeList) {
    return dispatch('setGrades', gradeList);
  }).catch(function (err) {
    console.error('err while fetching grades:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchUnits(_ref3, params) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/units', { params: params }).then(function (res) {
    return res.data;
  }).then(function (units) {
    return dispatch('setUnits', units);
  }).catch(function (err) {
    console.error('err while fetching units:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchCoreConcepts(_ref4, params) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/core-concepts', { params: params }).then(function (res) {
    return res.data;
  }).then(function (coreConcepts) {
    return dispatch('setCoreConcepts', coreConcepts);
  }).catch(function (err) {
    console.error('err while fetching core concepts:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchDomainList(_ref5, params) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/domains', { params: params }).then(function (res) {
    return res.data;
  }).then(function (domains) {
    return dispatch('setDomains', domains);
  }).catch(function (err) {
    console.error('err while fetching domains:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchDomain(_, domainId) {
  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/domains/' + domainId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching domain:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchDomainConceptList(_, params) {
  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/domain-concepts', { params: params }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching domain concepts:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchDomainConcept(_, conceptId) {
  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/domain-concepts/' + conceptId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching domain concept:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchLearningElementList(_, params) {
  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/learning-elements', { params: params }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching learning elements:', err);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchGradeSubjects(_ref6, params) {
  var commit = _ref6.commit;

  if (params.grade === '0' || params.grade === 'null') {
    params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(params, 'grade'));
  }

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/subjects', { params: params }).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].FETCH_GRADE_SUBJECTS, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function resetGradeSubjects(_ref7) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].RESET_GRADE_SUBJECTS);
}

function setMyCardsFilter(_ref8, filterInfo) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_MY_CARDS_FILTER, filterInfo);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setLibrartFilter(_ref9, filterInfo) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_LIBRARY_FILTER, filterInfo);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setPageLibraryFilter(_ref10, filterInfo) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_PAGE_LIBRARY_FILTER, filterInfo);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setAssignmentsFilter(_ref11, filterInfo) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_ASSIGNMENTS_FILTER, filterInfo);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setCoreConcepts(_ref12, coreConcepts) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_CORE_CONCEPTS, coreConcepts);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(coreConcepts);
}

function setDomains(_ref13, domains) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_DOMAINS, domains);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(domains);
}

function setUnits(_ref14, units) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_UNITS, units);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(units);
}

function setSubjects(_ref15, subjectList) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_SUBJECTS, subjectList);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(subjectList);
}

function setGrades(_ref16, gradeList) {
  var commit = _ref16.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_GRADES, gradeList);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(gradeList);
}

/***/ }),

/***/ "2gnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'class-item',

  props: ['cls'],

  data: function data() {
    return {
      studentList: [],
      assignmentStats: null
    };
  },


  computed: {
    styleBindings: function styleBindings() {
      if (this.cls) {
        return {
          'background-image': 'url(\'' + this.cls.profile_image + '\')'
        };
      }

      return {};
    },
    assignmentCount: function assignmentCount() {
      if (!this.assignmentStats) {
        return 0;
      }

      return this.assignmentStats.total_count;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchTeacherAssignmentStats', 'fetchClassStudents', 'syncClassStudents']), {
    goToClassReport: function goToClassReport() {
      this.$router.push('/reports/classes/' + this.cls.id);
    },
    getShortenedString: function getShortenedString(string, maxLength) {
      if (string.length <= maxLength) {
        return string;
      }
      return string.substring(0, maxLength) + '..';
    }
  }),

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.fetchTeacherAssignmentStats({ class_id: this.cls.id }), this.fetchClassStudents(this.cls.id)]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          assignmentStats = _ref2[0],
          studentList = _ref2[1];

      _this.assignmentStats = assignmentStats;

      if (!studentList || studentList.length === 0) {
        return _this.syncClassStudents(_this.cls.id).then(function (syncedStudentList) {
          _this.studentList = syncedStudentList;
        });
      }

      _this.studentList = studentList;

      return studentList;
    });
  }
});

/***/ }),

/***/ "2n7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clickout__ = __webpack_require__("om2z");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'floating-dropup',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clickout__["a" /* default */]],

  data: function data() {
    return {
      visible: false
    };
  },


  watch: {
    visible: function visible(state, old) {
      if (state === old) {
        return;
      }

      if (state) {
        this.$root.$emit('shown::dropdown', this);
      } else {
        this.$root.$emit('hidden::dropdown', this);
      }
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.visible = !this.visible;
    },
    clickOutListener: function clickOutListener() {
      this.visible = false;
    },
    click: function click() {
      this.toggleMenu();
    }
  },

  created: function created() {
    var _this = this;

    this.$root.$on('shown::dropdown', function (el) {
      if (el !== _this) {
        _this.visible = false;
      }
    });
  }
});

/***/ }),

/***/ "2q93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_publisherOnly__ = __webpack_require__("vWCn");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-lecture-details',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_publisherOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      domainConcept: null,
      domain: null,
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['videoLectures', 'videoCourses', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds']), {
    lecture: function lecture() {
      return this.videoLectures[this.$route.params.lecture_id];
    },
    course: function course() {
      return this.videoCourses[this.$route.params.course_id];
    },
    lectureTitle: function lectureTitle() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.lecture)) {
        return '';
      }

      return this.lecture.title;
    },
    videoEmbed: function videoEmbed() {
      if (this.lecture && this.lecture.video && this.lecture.video.embed) {
        return this.lecture.video.embed;
      }

      return null;
    },
    lectureDescription: function lectureDescription() {
      if (this.lecture && this.lecture.description) {
        return this.lecture.description.replace(/\n/g, '<br>');
      }

      return null;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['updateVideoLecture', 'removeVideoLecture', 'fetchDomainConcept', 'fetchVideoLecture', 'fetchVideoCourse', 'fetchDomain']), {
    removeLecture: function removeLecture() {
      var _this = this;

      this.removeVideoLecture(this.lecture.id).then(function () {
        if (_this.course) {
          return _this.$router.replace('/video-courses/' + _this.course.id);
        }

        return _this.$router.replace('/video-lectures');
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    this.loading = true;

    var lectureId = this.$route.params.lecture_id;
    var courseId = this.$route.params.course_id;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(courseId) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this2.videoCourses[courseId])) {
        return _this2.fetchVideoCourse(courseId);
      }

      return null;
    }).then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this2.videoLectures[lectureId])) {
        return _this2.fetchVideoLecture(lectureId);
      }

      return _this2.videoLectures[lectureId];
    }).then(function () {
      if (_this2.lecture && _this2.lecture.domain_id) {
        return _this2.fetchDomain(_this2.lecture.domain_id).then(function (domain) {
          _this2.domain = domain;
        });
      }

      return null;
    }).then(function () {
      if (_this2.lecture && _this2.lecture.domain_concept_id) {
        return _this2.fetchDomainConcept(_this2.lecture.domain_concept_id).then(function (domainConcept) {
          _this2.domainConcept = domainConcept;
        });
      }

      return null;
    }).then(function () {
      _this2.loading = false;
    });
  }
});

/***/ }),

/***/ "2qX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-lecture-details" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7" }, [
            _vm.course
              ? _c(
                  "h5",
                  {
                    staticClass:
                      "action-header video-course-details__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                    attrs: {
                      title:
                        _vm.$t("video_lectures.sub_header.video_courses") +
                        " > " +
                        _vm.course.title +
                        " > " +
                        _vm.lectureTitle
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.video_courses")
                        ) +
                        " > " +
                        _vm._s(_vm.course.title) +
                        " > " +
                        _vm._s(_vm.lectureTitle) +
                        "\n        "
                    )
                  ]
                )
              : _c(
                  "h5",
                  {
                    staticClass:
                      "action-header video-lecture-details__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                    attrs: {
                      title:
                        _vm.$t("video_lectures.sub_header.video_lectures") +
                        " > " +
                        _vm.lectureTitle
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.video_lectures")
                        ) +
                        " > " +
                        _vm._s(_vm.lectureTitle) +
                        "\n        "
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-5 hidden-sm-down" }, [
            _c(
              "div",
              { staticClass: "action-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary float-right ml-1 mr-1",
                    attrs: { to: _vm.$route.path + "/edit" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("video_lectures.video_lecture.edit")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right mr-1",
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "show::modal",
                          "remove-video-lecture-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("publishers.headers.actions.remove")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _vm.videoEmbed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "video-lecture-details__video-preview text-center w-100"
                  },
                  [
                    _c("div", {
                      staticClass: "w-100",
                      domProps: { innerHTML: _vm._s(_vm.videoEmbed) }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm.lecture
              ? _c("div", { staticClass: "video-lecture-details__meta" }, [
                  _c("div", { staticClass: "typography--title mt-3" }, [
                    _vm._v("\n        " + _vm._s(_vm.lectureTitle) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary mt-2"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.domain && _vm.domain.name) +
                          " " +
                          _vm._s(_vm.domainConcept && _vm.domainConcept.name) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary mb-3"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getGradeLabel(_vm.lecture)) +
                          " " +
                          _vm._s(_vm.getSubjectLabel(_vm.lecture)) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary mb-3"
                    },
                    [
                      _c("span", { staticClass: "mr-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.terms.view_count")) +
                            " " +
                            _vm._s(_vm.lecture.view_count) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "mr-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.terms.like")) +
                            " " +
                            _vm._s(_vm.lecture.like_count) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getShareLevelLabel(
                                _vm.lecture.share_level || 2
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.lectureDescription
                    ? _c("div", {
                        staticClass: "typography--body-1 break-word-all mt-3",
                        domProps: { innerHTML: _vm._s(_vm.lectureDescription) }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "typography--body-1 typography--color-disabled mt-3"
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("common.terms.no_description")) +
                              "\n      "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-disabled mb-5"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.terms.posted_date")) +
                          ":\n        " +
                          _vm._s(_vm._f("datetime")(_vm.lecture.created_at)) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-video-lecture-modal",
              title: _vm.$t("video_lectures.modals.remove_lecture.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeLecture()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("video_lectures.modals.remove_lecture.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78d42586", esExports)
  }
}

/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BEST_URL; });
/* unused harmony export CLASSTING_ACCOUNTS_URL */
/* unused harmony export CLASSTING_OIDC_CLIENT_ID */
/* unused harmony export CLASSTING_REDIRECT_URI */
/* unused harmony export CLASSTING_CLIENT_ID */
/* unused harmony export CLASSTING_AUTH_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLASSTING_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MINERVA_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AI_WEB_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CT_PERF_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CT_VIEWER_URL; });
/* unused harmony export CL_EVENTS_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CL_EVENTS_API_URL; });
/* unused harmony export NEW_CLASS_BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NEW_CLASS_BACKEND_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AWS_CF_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOG_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOG_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return VIDEO_LAMBDA_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FEATURED_PUBLISHER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GOOGLE_FORMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SLACK_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONTENT_REPORTS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GA_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLASSTING_FULL_AUTH_URL; });
/* unused harmony export VERSION */
/* unused harmony export AUTH_TOKEN_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return USER_TUTORIAL_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return USER_CL_EVENTS_KEY; });
/* unused harmony export CURRENT_USER_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return POLICY_VERSIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomstring__ = __webpack_require__("WV7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_randomstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyVersions__ = __webpack_require__("4dGX");



var BEST_URL = "https://cbt-backend.pendev.co.kr";
var CLASSTING_ACCOUNTS_URL = "https://accounts.classting.net";
var CLASSTING_OIDC_CLIENT_ID = "PspyA0FREY3dbC6suhwY7";
var CLASSTING_REDIRECT_URI = window.location.origin + '/oauth_callback/classting';
var CLASSTING_CLIENT_ID = __webpack_require__.i({"NODE_ENV":"staging","BEST_URL":"https://cbt-backend.pendev.co.kr","CLASSTING_ACCOUNTS_URL":"https://accounts.classting.net","CLASSTING_OIDC_CLIENT_ID":"PspyA0FREY3dbC6suhwY7","CLASSTING_REDIRECT_URI":"https://learning.classting.net/oauth_callback/classting","CLASSTING_URL":"https://www.classting.net","CT_API_URL":"https://ctapi.classting.net/v1","MINERVA_API_URL":"https://clapi.classting.net/v1","AI_WEB_URL":"https://ai.classting.net","CT_PERF_URL":"https://perf-web.classting.net","CT_VIEWER_URL":"https://cl-viewer.classting.net","CL_EVENTS_URL":"https://cl-events.classting.net","CL_EVENTS_API_URL":"https://cl-events-api.classting.net/v1","NEW_CLASS_BASE_URL":"https://newclass.classting.net","NEW_CLASS_BACKEND_BASE_URL":"https://apis.classting.net/classroom-service","AWS_CF_URL":"https://d2feivphx9jgk.cloudfront.net","LOG_URL":"https://wlog.classting.net/learning.stg.api","LOG_BASE_URL":"https://wlog.classting.net/learning.stg","VIDEO_LAMBDA_URL":"https://edge.classting.com/encoding-stg/videos/presigned-url","FEATURED_PUBLISHER_ID":84,"GOOGLE_FORMS":{"url":"https://docs.google.com/forms/d/e/1FAIpQLSfa3LBEHVEozQ7SXMAOZGDONOGVlhP0kQfjovY4S2AIwoVrNQ/formResponse","fields":{"schoolName":"entry.907775628","name":"entry.573870947","position":"entry.722312610","email":"entry.294785178","mobile":"entry.538953548","content":"entry.1390390138"}},"SLACK_CONFIG":{"url":"https://hooks.slack.com/services/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","username":"[STG] 클래스팅 러닝 문의 알림","iconUrl":"http://emojis.slackmojis.com/emojis/images/1464135056/462/fb-laugh.gif","header":"[STG] 문의가 접수되었습니다."},"CONTENT_REPORTS_CONFIG":{"url":"https://hooks.slack.com/services/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","username":"[STG] 클래스팅 러닝 콘텐츠 신고","header":"[STG] 신고가 접수되었습니다."},"GA_ID":"UA-30499296-22","VERSION":"0.0.1"}).CLASSTING_CLIENT_ID;
var CLASSTING_AUTH_URL = __webpack_require__.i({"NODE_ENV":"staging","BEST_URL":"https://cbt-backend.pendev.co.kr","CLASSTING_ACCOUNTS_URL":"https://accounts.classting.net","CLASSTING_OIDC_CLIENT_ID":"PspyA0FREY3dbC6suhwY7","CLASSTING_REDIRECT_URI":"https://learning.classting.net/oauth_callback/classting","CLASSTING_URL":"https://www.classting.net","CT_API_URL":"https://ctapi.classting.net/v1","MINERVA_API_URL":"https://clapi.classting.net/v1","AI_WEB_URL":"https://ai.classting.net","CT_PERF_URL":"https://perf-web.classting.net","CT_VIEWER_URL":"https://cl-viewer.classting.net","CL_EVENTS_URL":"https://cl-events.classting.net","CL_EVENTS_API_URL":"https://cl-events-api.classting.net/v1","NEW_CLASS_BASE_URL":"https://newclass.classting.net","NEW_CLASS_BACKEND_BASE_URL":"https://apis.classting.net/classroom-service","AWS_CF_URL":"https://d2feivphx9jgk.cloudfront.net","LOG_URL":"https://wlog.classting.net/learning.stg.api","LOG_BASE_URL":"https://wlog.classting.net/learning.stg","VIDEO_LAMBDA_URL":"https://edge.classting.com/encoding-stg/videos/presigned-url","FEATURED_PUBLISHER_ID":84,"GOOGLE_FORMS":{"url":"https://docs.google.com/forms/d/e/1FAIpQLSfa3LBEHVEozQ7SXMAOZGDONOGVlhP0kQfjovY4S2AIwoVrNQ/formResponse","fields":{"schoolName":"entry.907775628","name":"entry.573870947","position":"entry.722312610","email":"entry.294785178","mobile":"entry.538953548","content":"entry.1390390138"}},"SLACK_CONFIG":{"url":"https://hooks.slack.com/services/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","username":"[STG] 클래스팅 러닝 문의 알림","iconUrl":"http://emojis.slackmojis.com/emojis/images/1464135056/462/fb-laugh.gif","header":"[STG] 문의가 접수되었습니다."},"CONTENT_REPORTS_CONFIG":{"url":"https://hooks.slack.com/services/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","username":"[STG] 클래스팅 러닝 콘텐츠 신고","header":"[STG] 신고가 접수되었습니다."},"GA_ID":"UA-30499296-22","VERSION":"0.0.1"}).CLASSTING_AUTH_URL;
var CLASSTING_URL = "https://www.classting.net";
var MINERVA_API_URL = "https://clapi.classting.net/v1";
var CT_API_URL = "https://ctapi.classting.net/v1";
var AI_WEB_URL = "https://ai.classting.net";
var CT_PERF_URL = "https://perf-web.classting.net";
var CT_VIEWER_URL = "https://cl-viewer.classting.net";
var CL_EVENTS_URL = "https://cl-events.classting.net";
var CL_EVENTS_API_URL = "https://cl-events-api.classting.net/v1";
var NEW_CLASS_BASE_URL = "https://newclass.classting.net";
var NEW_CLASS_BACKEND_BASE_URL = "https://apis.classting.net/classroom-service";
var AWS_CF_URL = "https://d2feivphx9jgk.cloudfront.net";
var LOG_URL = "https://wlog.classting.net/learning.stg.api";
var LOG_BASE_URL = "https://wlog.classting.net/learning.stg";
var VIDEO_LAMBDA_URL = "https://edge.classting.com/encoding-stg/videos/presigned-url";
var FEATURED_PUBLISHER_ID = 84;
var GOOGLE_FORMS = {"url":"https://docs.google.com/forms/d/e/1FAIpQLSfa3LBEHVEozQ7SXMAOZGDONOGVlhP0kQfjovY4S2AIwoVrNQ/formResponse","fields":{"schoolName":"entry.907775628","name":"entry.573870947","position":"entry.722312610","email":"entry.294785178","mobile":"entry.538953548","content":"entry.1390390138"}};
var SLACK_CONFIG = {"url":"https://hooks.slack.com/services/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","username":"[STG] 클래스팅 러닝 문의 알림","iconUrl":"http://emojis.slackmojis.com/emojis/images/1464135056/462/fb-laugh.gif","header":"[STG] 문의가 접수되었습니다."};
var CONTENT_REPORTS_CONFIG = {"url":"https://hooks.slack.com/services/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","username":"[STG] 클래스팅 러닝 콘텐츠 신고","header":"[STG] 신고가 접수되었습니다."};
var GA_ID = "UA-30499296-22";
var CLASSTING_FULL_AUTH_URL = [CLASSTING_ACCOUNTS_URL + '/oidc/auth', '?client_id=' + CLASSTING_OIDC_CLIENT_ID, '&response_type=id_token+token', '&scope=openid+email+profile', '&nonce=' + __WEBPACK_IMPORTED_MODULE_0_randomstring___default.a.generate(10), '&redirect_uri=' + CLASSTING_REDIRECT_URI].join('');
var VERSION = "0.0.1";
var AUTH_TOKEN_KEY = 'auth_token';
var USER_TUTORIAL_KEY = 'user_tutorial';
var USER_CL_EVENTS_KEY = 'cl_events';
var CURRENT_USER_KEY = 'current_user';
var POLICY_VERSIONS = __WEBPACK_IMPORTED_MODULE_1__policyVersions__["a" /* default */];

/***/ }),

/***/ "2vgd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-answer-btn-box clickable" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b8f26a4", esExports)
  }
}

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "30WV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("tQIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("s3LW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("hV5E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("6jjT");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "39Ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  page: {}
});

/***/ }),

/***/ "3QMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_RECENT_UPLOAD_INFO = 'videoLectures/SET_RECENT_UPLOAD_INFO';
var REMOVE_VIDEO_LECTURE = 'videoLectures/REMOVE_VIDEO_LECTURE';
var CLEAR_VIDEO_LECTURES = 'videoLectures/CLEAR_VIDEO_LECTURES';
var SET_VIDEO_LECTURE = 'videoLectures/SET_VIDEO_LECTURE';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_RECENT_UPLOAD_INFO: SET_RECENT_UPLOAD_INFO,
  REMOVE_VIDEO_LECTURE: REMOVE_VIDEO_LECTURE,
  CLEAR_VIDEO_LECTURES: CLEAR_VIDEO_LECTURES,
  SET_VIDEO_LECTURE: SET_VIDEO_LECTURE
});

/***/ }),

/***/ "3QeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'library-card'
});

/***/ }),

/***/ "3mKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("YUk/");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "3t+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_async_es_eachSeries__ = __webpack_require__("fwed");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mammoth_mammoth_browser_min__ = __webpack_require__("VxvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mammoth_mammoth_browser_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mammoth_mammoth_browser_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_labels__ = __webpack_require__("kl7r");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-docx-quizzes',

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_publisherOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      subjectId: '',
      gradeId: '',
      unitId: '',
      coreConceptId: '',
      seriesId: null,
      chapterId: null,
      chapterPosition: null,
      chapterName: null,
      cardTitle: '',
      cardGoal: '',
      unitList: [],
      coreConceptList: [],
      validFileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      docxFileBuffer: null,
      docxFileName: null,
      imageList: [],
      pageList: [],
      busy: false,
      loading: false,
      docxParsingCompleted: false,
      errMsg: '',
      videoCourseId: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['currentPublisherInfo', 'currentUser', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds']), {
    prevLink: function prevLink() {
      if (this.isSeriesCard && this.seriesId) {
        return {
          name: 'publishers.series.cards',
          params: {
            series_id: this.seriesId
          }
        };
      }

      return '/publishers/non-series-cards';
    },
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.subjectId + '&' + this.gradeId;
    },
    showUnitSelect: function showUnitSelect() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.unitList);
    },
    showCoreConceptSelect: function showCoreConceptSelect() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.coreConceptList);
    },
    unitsById: function unitsById() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["keyBy"])(this.unitList, 'id');
    },
    fileInfo: function fileInfo() {
      return {
        quizCount: this.pageList.length,
        multipleChoiceCount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(this.pageList, function (page) {
          return page.page_type_id === 2;
        }).length,
        textEntryCount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(this.pageList, function (page) {
          return page.page_type_id === 3;
        }).length,
        imageCount: this.imageList.length
      };
    },
    createDisabled: function createDisabled() {
      if (this.subjectId === '') {
        return true;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.unitList) && this.unitId === '') {
        return true;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.coreConceptList) && this.coreConceptId === '') {
        return true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.cardTitle)) {
        return true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(this.docxFileBuffer)) {
        return true;
      }

      if (!this.docxParsingCompleted) {
        return true;
      }

      return false;
    },
    isSeriesCard: function isSeriesCard() {
      return this.$route.name === 'publishers.series.chapters.createDocxQuizzes';
    }
  }),

  watch: {
    selectedSubjectGrade: function selectedSubjectGrade(value) {
      var _this = this;

      if (value.match(/^[0-9]+&9999$/) || value.match(/^9999&[0-9]+$/)) {
        return null;
      }

      var params = {
        subject_id: this.subjectId,
        grade_id: this.gradeId,
        unit_id: this.$route.query.unit_id
      };

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(value.match(/[0-9]+&[0-9]+/))) {

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.fetchCoreConcepts(params), this.fetchUnits(params)]).then(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              coreConceptList = _ref2[0],
              unitList = _ref2[1];

          _this.coreConceptList = coreConceptList || [];
          _this.unitList = unitList || [];

          var coreConceptsById = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["keyBy"])(_this.coreConceptList, 'id');
          var unitsById = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["keyBy"])(_this.unitList, 'id');

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(coreConceptsById, _this.coreConceptId))) {
            _this.coreConceptId = '';
          }

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(unitsById, _this.unitId))) {
            _this.unitId = '';
          }
        });
      }

      return null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['uploadNewCardPageImage', 'createNewMyCardPage', 'fetchCoreConcepts', 'createNewMyCard', 'addCardToSeries', 'updateMyPage', 'fetchUnits', 'createVideoCourseCards']), {
    onUnitSelect: function onUnitSelect() {
      var coreConceptId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(this.unitsById, this.unitId + '.core_concept_id');

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(coreConceptId)) {
        this.coreConceptId = coreConceptId;
      }
    },
    clearFileInput: function clearFileInput() {
      var docxFileInput = this.$refs.docxFileInput;
      docxFileInput.value = '';
    },
    onFileInputChange: function onFileInputChange(event) {
      var _this2 = this;

      if (this.loading) {
        return null;
      }

      var files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        return null;
      }

      var file = files[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(file, 'type', '').indexOf(this.validFileType) === -1) {
        return this.$root.$emit('show::modal', 'docx-type-alert');
      }

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function (loadEvent) {
        _this2.loading = true;
        _this2.docxFileName = file.name;
        _this2.docxFileBuffer = loadEvent.target.result;

        _this2.convertDocxToHtml().then(function (result) {
          var doc = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(result.value);
          _this2.pageList = _this2.parsePages(doc);
          _this2.docxParsingCompleted = true;
        }).catch(function (err) {
          _this2.errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["toString"])(err);
          _this2.$root.$emit('show::modal', 'basic-error-alert');
          console.error('errMsg:', _this2.errMsg);

          _this2.docxFileName = null;
          _this2.docxFileBuffer = null;
          _this2.pageList = [];
          _this2.loading = false;
          _this2.clearFileInput();
        });
      };

      return reader.readAsArrayBuffer(file);
    },
    convertDocxToHtml: function convertDocxToHtml() {
      var _this3 = this;

      var options = {
        convertImage: __WEBPACK_IMPORTED_MODULE_7_mammoth_mammoth_browser_min___default.a.images.imgElement(function (image) {
          return image.read().then(function (imageBuffer) {
            var dataImgId = 'tmp_' + Math.floor(Math.random() * 1000000);
            var imageBlob = new Blob([imageBuffer], { type: image.contentType });
            var imageInfo = {
              image_file: imageBlob,
              key: dataImgId
            };

            _this3.imageList.push(imageInfo);

            return { src: '' + dataImgId };
          });
        }),
        styleMap: ['u => u']
      };

      return __WEBPACK_IMPORTED_MODULE_7_mammoth_mammoth_browser_min___default.a.convertToHtml({ arrayBuffer: this.docxFileBuffer }, options);
    },
    initNewPage: function initNewPage() {
      return {
        author_id: this.currentUser.id,
        author_name: this.currentUser.name,
        publisher_id: this.currentPublisherInfo.id,
        publisher_name: this.currentPublisherInfo.name,
        page_type_id: null,
        language: '',
        content: '',
        description: '',
        answers: [],
        answer_view_type: '',
        position: null,
        is_copied_page: false,
        is_quiz: true,
        audio_count: 0,
        video_count: 0,
        image_count: 0,
        is_autograde: true,
        is_store_page: true,
        score: 1,
        images: []
      };
    },
    handlePageType: function handlePageType(page, text) {
      switch (text) {
        case '단답형':
          page.page_type_id = 3;
          break;
        case '객관식':
          page.page_type_id = 2;
          break;
        default:
          throw new Error('INCORRECT PAGE TYPE: ' + text);
      }
    },
    handleLanguage: function handleLanguage(page, text) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(text)) {
        page.language = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["toLower"])(text);
      }
    },
    handleContent: function handleContent(page, label, text, elem) {
      var imgs = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('img', elem);

      if (imgs.length > 1) {
        throw new Error('ONLY ONE IMAGE IS ALLOWED PER A LINE.');
      }

      if (imgs.length > 0 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(text)) {
        throw new Error('IMAGE AND TEXT ARE NOT ALLOWED TO BE ON THE SAME LINE.');
      }

      if (imgs.length > 0) {
        var imgDataId = imgs.attr('src');
        var imgElem = '<figure><img src="" data-image-id="' + imgDataId + '"></figure>';
        var imageInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(this.imageList, function (_ref3) {
          var key = _ref3.key;
          return key === imgDataId;
        });

        page[label] += imgElem;
        page.image_count += 1;
        page.images.push(imageInfo);
      } else {
        page[label] += elem.outerHTML;
      }
    },
    handleAnswers: function handleAnswers(page, text, isCorrect) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(text)) {
        var answer = {
          content: text,
          is_correct: isCorrect
        };

        page.answers.push(answer);
      }
    },
    handleAnswerViewType: function handleAnswerViewType(page, text) {
      switch (text) {
        case '글자버튼':
          page.answer_view_type = 'list';
          break;
        case '숫자버튼':
          page.answer_view_type = 'control';
          break;
        default:
          throw new Error('INCORRECT ANSWER VIEW TYPE: ' + text);
      }
    },
    isValidPage: function isValidPage(page) {
      var pageTypeId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(page, 'page_type_id');
      var answerCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(page.answers, 'length');
      var correctAnswerCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(page.answers, 'is_correct'), 'length');

      if (pageTypeId === 2) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.language) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.content) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.answers) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.answer_view_type) && correctAnswerCount === 1 && answerCount > 1 && answerCount < 6;
      }

      if (pageTypeId === 3) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.language) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.content) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(page.answers);
      }

      return false;
    },
    isEmptyPage: function isEmptyPage(page) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEqual"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["omit"])(page, 'position'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["omit"])(this.initNewPage(), 'position'));
    },
    parsePages: function parsePages(doc) {
      var _this4 = this;

      var templateLabels = {
        '[유형]': 'page_type_id',
        '[언어]': 'language',
        '[문제]': 'content',
        '[오답]': 'answers',
        '[정답]': 'correct_answers',
        '[보기선택방법]': 'answer_view_type',
        '[해설]': 'description'
      };
      var labelKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["keys"])(templateLabels);
      var pageList = [];
      var page = this.initNewPage();
      var label = '';

      doc.each(function (i, elem) {
        var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["trim"])(__WEBPACK_IMPORTED_MODULE_8_jquery___default()(elem).text());

        if (text === '[유형]') {
          if (_this4.isValidPage(page)) {
            page.answers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["sortBy"])(page.answers, 'content');
            pageList.push(page);
          } else if (!_this4.isEmptyPage(page)) {
            throw new Error('IS INCORRECT PAGE: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(page));
          }

          page = _this4.initNewPage();
          page.position = pageList.length + 1;
        }

        if (labelKeys.indexOf(text) !== -1) {
          label = templateLabels[text];

          return null;
        }

        switch (label) {
          case 'page_type_id':
            return _this4.handlePageType(page, text);
          case 'language':
            return _this4.handleLanguage(page, text);
          case 'content':
          case 'description':
            return _this4.handleContent(page, label, text, elem);
          case 'answers':
            return _this4.handleAnswers(page, text, false);
          case 'correct_answers':
            return _this4.handleAnswers(page, text, true);
          case 'answer_view_type':
            return _this4.handleAnswerViewType(page, text);
          default:
            return null;
        }
      });

      if (this.isValidPage(page)) {
        page.answers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["sortBy"])(page.answers, 'content');
        pageList.push(page);
      } else if (!this.isEmptyPage(page)) {
        throw new Error('IS INCORRECT PAGE: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(page));
      }

      return pageList;
    },
    createNewCard: function createNewCard() {
      var unitsById = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["keyBy"])(this.unitList, 'id');
      var params = {
        title: this.cardTitle || '제목없음',
        goal: this.cardGoal,
        subject_id: this.subjectId,
        grade_id: this.gradeId || null,
        unit_id: this.unitId || undefined,
        chapter_position: this.chapterPosition || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(unitsById, this.unitId + '.position'),
        chapter_name: this.chapterName || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(unitsById, this.unitId + '.name'),
        core_concept_id: this.coreConceptId,
        author_id: this.currentUser.id,
        author_name: this.currentUser.name,
        publisher_id: this.currentPublisherInfo.id,
        publisher_name: this.currentPublisherInfo.name,
        share_level: 2,
        page_count: this.pageList.length,
        quiz_count: this.pageList.length,
        image_count: this.imageList.length,
        audio_count: 0,
        video_count: 0,
        is_autograde: true,
        language: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["first"])(this.pageList), 'language')
      };

      return this.createNewMyCard(params);
    },
    createNewPage: function createNewPage(page, cardId) {
      var _this5 = this;

      var omittedPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["omitBy"])(page, function (value, key) {
        return key === 'images' || value === '';
      });

      return this.createNewMyCardPage({ page: omittedPage, cardId: cardId }).then(function (newPage) {
        var updateInfo = {
          content: newPage.content,
          description: newPage.description || ''
        };

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_async_es_eachSeries__["a" /* default */])(page.images, function (image, callback) {
            return _this5.uploadNewCardPageImage({ pageId: newPage.id, imageFile: image.image_file }).then(function (newImage) {
              var oldAttr = 'data-image-id="' + image.key + '"';
              var newAttr = 'data-image-id="' + newImage.id + '"';

              if (updateInfo.content.indexOf(oldAttr) !== -1) {
                updateInfo.content = updateInfo.content.replace(oldAttr, newAttr);
              }

              if (updateInfo.description.indexOf(oldAttr) !== -1) {
                updateInfo.description = updateInfo.description.replace(oldAttr, newAttr);
              }

              return callback();
            }).catch(callback);
          }, function (err) {
            if (err) {
              return reject(err);
            }

            return resolve({ pageId: newPage.id, updateInfo: updateInfo });
          });
        });
      }).then(function (_ref4) {
        var pageId = _ref4.pageId,
            updateInfo = _ref4.updateInfo;
        return _this5.updateMyPage({ pageId: pageId, updateInfo: updateInfo });
      });
    },
    create: function create() {
      var _this6 = this;

      if (this.busy) {
        return null;
      }

      this.busy = true;

      return this.createNewCard().then(function (newCard) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(_this6.pageList, function (page) {
          return _this6.createNewPage(page, newCard.id);
        })).then(function () {
          return newCard;
        });
      }).then(function (newCard) {
        if (!_this6.isSeriesCard) {
          return newCard;
        }

        var params = {
          subject_id: _this6.subjectId,
          grade_id: _this6.gradeId,
          series_id: _this6.seriesId,
          chapter_id: _this6.chapterId,
          chapter_name: _this6.chapterName,
          chapter_position: _this6.chapterPosition,
          core_concept_id: _this6.coreConceptId || null,
          unit_id: _this6.unitId || null,
          card_id: newCard.id
        };

        return _this6.addCardToSeries(params).then(function () {
          return newCard;
        });
      }).then(function (newCard) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(_this6.videoCourseId)) {
          return _this6.createVideoCourseCards({
            video_course_id: _this6.videoCourseId,
            card_id: newCard.id
          }).then(function () {
            return newCard;
          });
        }

        return newCard;
      }).then(function (newCard) {
        return _this6.$router.push('/my-cards/' + newCard.id);
      });
    }
  }),

  mounted: function mounted() {
    if (this.isSeriesCard) {
      this.chapterId = this.$route.params.chapter_id;
      this.seriesId = this.$route.params.series_id;
      this.unitId = this.$route.query.unit_id;
      this.coreConceptId = this.$route.query.core_concept_id;
      this.chapterPosition = this.$route.query.chapter_position;
      this.chapterName = this.$route.query.chapter_name;
      this.subjectId = this.$route.query.subject_id;
      this.gradeId = this.$route.query.grade_id;
    }
  }
});

/***/ }),

/***/ "3veI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "dummy-page-item" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 push-md-4" }, [
        _c("div", { staticClass: "page-summary-container" }, [
          _c("div", { staticClass: "page-summary" }, [
            _c("div", { staticClass: "block-1" }),
            _vm._v(" "),
            _c("div", { staticClass: "block-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "block-3" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 pull-md-8" }, [
        _c("div", { staticClass: "card-top-info" }, [
          _c("div", { staticClass: "block-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "block-2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-bottom-info" }, [
          _c("div", { staticClass: "block-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "block-2" }),
          _vm._v(" "),
          _c("div", { staticClass: "block-3" })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48da220a", esExports)
  }
}

/***/ }),

/***/ "3xdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("QQ+2");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4/r4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdCard_vue__ = __webpack_require__("b8PB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59150641_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdCard_vue__ = __webpack_require__("78ju");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ORGd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59150641_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/library/components/AdCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59150641", Component.options)
  } else {
    hotAPI.reload("data-v-59150641", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "42JS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "page-item clickable", class: _vm.selectedPageBindings },
    [
      _c("div", { staticClass: "row", on: { click: _vm.selectPage } }, [
        _c("div", { staticClass: "col-md-8 push-md-4" }, [
          _c("div", { staticClass: "page-summary-container" }, [
            _c("div", { staticClass: "page-summary" }, [
              _c(
                "p",
                {
                  staticClass: "typography--body-3 typography--color-secondary"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.pageType) + " " + _vm._s(_vm.index + 1))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "page-content-container",
                  class: _vm.classBindings
                },
                [
                  _vm.hasImage
                    ? _c("div", {
                        staticClass: "page-image-summary float-left",
                        style: { "background-image": _vm.firstImageSrc }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasAudio
                    ? _c("div", { staticClass: "page-audio-summary" }, [
                        _c("img", {
                          staticClass: "align-middle",
                          attrs: { src: "/static/images/icon-audio.svg" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "align-middle typography--body-3" },
                          [
                            _vm._v(
                              _vm._s(_vm._f("duration")(_vm.firstAudioDuration))
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasVideo || _vm.hasEmbededVideo
                    ? _c("div", { staticClass: "page-video-summary" }, [
                        _c("img", {
                          staticClass: "align-middle",
                          attrs: { src: "/static/images/icon-video.svg" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "align-middle typography--body-3" },
                          [
                            _vm._v(
                              _vm._s(_vm._f("duration")(_vm.firstVideoDuration))
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "typography--body-2 typography--pre-line page-content",
                    domProps: { innerHTML: _vm._s(_vm.page.content) }
                  })
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 pull-md-8" }, [
          _c("div", { staticClass: "card-top-info" }, [
            _c("h4", { staticClass: "typography--title page-card-title" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.page.card_title) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "typography--caption" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getGradeLabel(_vm.page)) +
                  "\n          " +
                  _vm._s(_vm.getSubjectLabel(_vm.page)) +
                  "\n          "
              ),
              _vm.page.chapter_name
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.page.chapter_name) +
                        "\n          "
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getCoreConceptLabel(
                            _vm.coreConcepts[_vm.page.core_concept_id]
                          )
                        ) +
                        "\n          "
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-bottom-info" }, [
            _c(
              "small",
              {
                staticClass:
                  "typography--caption typography--color-secondary mb-1"
              },
              [
                _vm.page.card_assigned_count
                  ? _c("span", [
                      _vm._v(
                        "| " +
                          _vm._s(
                            _vm.$t("common.card.share_count", {
                              cnt: _vm.page.card_assigned_count
                            })
                          )
                      )
                    ])
                  : _vm._e()
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-action" }, [
        _c("div", { staticClass: "card-action-btn text-right" }, [
          _c(
            "a",
            {
              staticClass: "typography--body-3",
              on: { click: _vm.openCardPreview }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("common.preview")) + "\n      "
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02c6a172", esExports)
  }
}

/***/ }),

/***/ "49iO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Evaluations__ = __webpack_require__("XtQO");


var router = [{
  name: 'evaluations',
  path: '/evaluations',
  component: __WEBPACK_IMPORTED_MODULE_0__views_Evaluations__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* unused harmony default export */ var _unused_webpack_default_export = (router);

/***/ }),

/***/ "4LOq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4SVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    {
                      staticClass: "nav-item",
                      class: _vm.customCardsTabBindings
                    },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: { position: "bottom", show: _vm.showTooltip },
                          on: { "tooltip-closed": _vm.onTooltipClosed }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link typography--body-3",
                              attrs: { to: "/library/custom-cards" }
                            },
                            [
                              _vm._v(
                                "\n                  커뮤니티 자료\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              attrs: { slot: "tooltip-body" },
                              slot: "tooltip-body"
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "typography--body-3 typography--color-secondary",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("common.tooltip.try_custom_card")
                                  )
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "nav-item",
                      class: _vm.schoolCardsTabBindings
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/library/school-cards" }
                        },
                        [
                          _vm._v(
                            "\n                소속 기관 자료\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row browse-filter-row" }, [
          _c("div", { staticClass: "col-12 col-lg-7 ml-0 mr-0" }, [
            _c("div", { staticClass: "row box" }, [
              _c(
                "div",
                { staticClass: "col-sm-3 divider" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown grade-select",
                      attrs: {
                        text: _vm.getTranslatedName(
                          _vm.gradeMap[_vm.libraryFilters.grade_id]
                        )
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectGrade("0", "0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.all_grades")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.gradeList, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            on: {
                              click: function($event) {
                                return _vm.selectGrade(
                                  value.id,
                                  value.school_year
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getTranslatedName(_vm.gradeMap[value.id])
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectGrade("null", "null")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.others")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 divider" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown subject-select",
                      attrs: {
                        id: "subject-dropdown",
                        text: _vm.getTranslatedName(
                          _vm.subjectMap[_vm.libraryFilters.subject_id]
                        )
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectSubject("0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.all_subjects")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.gradeSubjects, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            on: {
                              click: function($event) {
                                return _vm.selectSubject(value.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getTranslatedName(
                                    _vm.subjectMap[value.id]
                                  )
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown chapter-select",
                      attrs: {
                        text:
                          _vm.getUnitLabel(
                            _vm.units[_vm.libraryFilters.unit_id]
                          ) || _vm.$t("common.browse_filters.all_chapters"),
                        id: "unit-dropdown"
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectUnit("0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("common.browse_filters.all_chapters")
                              ) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.currentUnitList, function(unit) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: unit.id,
                            on: {
                              click: function($event) {
                                return _vm.selectUnit(unit.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getUnitLabel(unit)) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-lg-5 pl-12" },
            [
              _c("SearchInput", {
                attrs: { "model-value": _vm.libraryFilters.search_keywords },
                on: { input: _vm.applySearchKeywords }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row browse-filter-row" }, [
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.libraryFilters.media_type,
                    "check-value": "all",
                    id: "media-type-all"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.all"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.libraryFilters.media_type,
                    "check-value": "image",
                    id: "media-type-image"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.image"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.libraryFilters.media_type,
                    "check-value": "video",
                    id: "media-type-video"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.video"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.libraryFilters.media_type,
                    "check-value": "audio",
                    id: "media-type-audio"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.audio"))
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4" }, [
            _c("ul", { staticClass: "nav justify-content-end order-by-btns" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link typography--color-secondary",
                    class: {
                      active: _vm.libraryFilters.order_by === "updated_at"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectOrderBy("updated_at")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.order_by.recency"))
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link typography--color-secondary",
                    class: {
                      active: _vm.libraryFilters.order_by === "popularity"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectOrderBy("popularity")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("common.browse_filters.order_by.popularity")
                      )
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "row" },
              _vm._l(4, function(n) {
                return _c(
                  "div",
                  { key: n, staticClass: "col-sm-6 col-md-4 col-lg-3" },
                  [_c("div", { staticClass: "card-row" }, [_c("DummyCard")], 1)]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "col-sm-6 col-md-4 col-lg-3" }, [
                  _c("div", { staticClass: "card-row" }, [_c("AdCard")], 1)
                ]),
                _vm._v(" "),
                _vm._l(_vm.currentCardList, function(card) {
                  return _c(
                    "div",
                    { key: card.id, staticClass: "col-sm-6 col-md-4 col-lg-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-row" },
                        [_c("LibraryCard", { attrs: { card: card } })],
                        1
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 text-center mb-5 pb-5",
                        attrs: { slot: "no-more" },
                        slot: "no-more"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "empty-list-text typography--body-2 typography--color-disabled pt-4"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  this.libraryFilters.search_keywords
                                    ? _vm.$t("library.no_search_cards", {
                                        keyword: this.libraryFilters
                                          .search_keywords
                                      })
                                    : _vm.$t("library.no_cards")
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "no-class-to-assign-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.no_class_to_assign_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isSchoolInfoModal && _vm.isEmptySchoolInfo && _vm.isSchoolCardTab
          ? _c(
              "CustomModal",
              {
                staticClass: "basic-modal no-header-modal hide-cancel-btn",
                attrs: {
                  id: "school-info-modal",
                  "hide-header": true,
                  "ok-title": _vm.$t("common.confirm")
                },
                on: { ok: _vm.handelSchoolInfoConfirmClick }
              },
              [
                _c("div", { staticClass: "typography--color-primary" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("errors.empty_school_info")) +
                      "\n      "
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isNoticeModal
          ? _c(
              "CustomModal",
              {
                staticClass: "basic-modal hide-cancel-btn",
                attrs: {
                  id: "evaluation-service-gone-modal",
                  title:
                    "이제 새로운 클래스에서 러닝(학습자료실)을 사용해보세요!",
                  "ok-title": _vm.$t("common.confirm")
                },
                on: { ok: _vm.handleNoticeModalConfirmClick }
              },
              [
                _c("div", [
                  _vm._v(
                    "\n        새로운 클래스에서 '자료실 과제' 만들기를 누르면 러닝(학습자료실)의 모든 자료를 한 번에 조회하고 첨부할 수 있어요."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        러닝(학습자료실)에서 기존 클래스로 '내보내기'하는 기능 종료 기한을 연장하였습니다."
                  ),
                  _c("br"),
                  _vm._v("\n        자세한 내용은 "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          " https://support.classting.com/hc/ko/articles/4422617956377-%EB%9F%AC%EB%8B%9D-%ED%95%99%EC%8A%B5%EC%9E%90%EB%A3%8C%EC%8B%A4-%EC%9D%BC%EB%B6%80-%EA%B8%B0%EB%8A%A5-%EC%A2%85%EB%A3%8C-%EB%B0%8F-%EC%97%85%EB%8D%B0%EC%9D%B4%ED%8A%B8-%EC%95%88%EB%82%B4-2022-02-24-",
                        target: "_blank"
                      }
                    },
                    [_vm._v("공지사항")]
                  ),
                  _vm._v("을 확인해주세요.\n      ")
                ])
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-377c84af", esExports)
  }
}

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4b9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-card-share-setup-modal',

  props: {
    cardShareLevel: {
      type: Number,
      default: 0
    },
    onModalOkClick: {
      type: Function
    },
    onModalCancelClick: {
      type: Function
    },
    isLoading: {
      type: Boolean
    },
    isPublisher: {
      type: Boolean
    }
  },

  data: function data() {
    return {
      selectedMyCardShareLevel: 0
    };
  },


  methods: {
    handleShareLevelChange: function handleShareLevelChange(shareLevel) {
      this.selectedMyCardShareLevel = shareLevel;
    }
  },

  beforeMount: function beforeMount() {
    this.selectedMyCardShareLevel = this.cardShareLevel;
  }
});

/***/ }),

/***/ "4dGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var policyVersions = {
  terms: {
    en: [{
      version: '20160624',
      url: 'static/policy-mds/terms/20160624.en-US.md'
    }, {
      version: '20150824',
      url: 'static/policy-mds/terms/20150824.en-US.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/terms/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/terms/20130401.en-US.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/terms/20121002.en-US.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/terms/20120720.en-US.md'
    }],
    ko: [{
      version: '20131010',
      url: 'static/policy-mds/terms/20131010.ko-KR.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/terms/20130401.ko-KR.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/terms/20121002.ko-KR.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/terms/20120720.ko-KR.md'
    }],
    ja: [{
      version: '20150730',
      url: 'static/policy-mds/terms/20150730.ja-JP.md'
    }, {
      version: '20150605',
      url: 'static/policy-mds/terms/20150605.ja-JP.md'
    }],
    'zh-TW': [{
      version: '20150910',
      url: 'static/policy-mds/terms/20150910.zh-TW.md'
    }],
    'en-HK': [{
      version: '20150901',
      url: 'static/policy-mds/terms/20150901.en-HK.md'
    }],
    'zh-CN': [{
      version: '20150901',
      url: 'static/policy-mds/terms/20150901.zh-CN.md'
    }],
    es: [{
      version: '20150824',
      url: 'static/policy-mds/terms/20150824.en-US.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/terms/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/terms/20130401.en-US.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/terms/20121002.en-US.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/terms/20120720.en-US.md'
    }],
    tr: [{
      version: '20150824',
      url: 'static/policy-mds/terms/20150824.en-US.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/terms/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/terms/20130401.en-US.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/terms/20121002.en-US.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/terms/20120720.en-US.md'
    }]
  },
  operation: {
    en: [{
      version: '20131010',
      url: 'static/policy-mds/operation/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/operation/20130401.en-US.md'
    }],
    ko: [{
      version: '20131010',
      url: 'static/policy-mds/operation/20131010.ko-KR.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/operation/20130401.ko-KR.md'
    }],
    ja: [{
      version: '20150605',
      url: 'static/policy-mds/operation/20150605.ja-JP.md'
    }],
    'zh-TW': [{
      version: '20150910',
      url: 'static/policy-mds/operation/20150910.zh-TW.md'
    }],
    es: [{
      version: '20131010',
      url: 'static/policy-mds/operation/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/operation/20130401.en-US.md'
    }],
    tr: [{
      version: '20131010',
      url: 'static/policy-mds/operation/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/operation/20130401.en-US.md'
    }]
  },
  privacy: {
    en: [{
      version: '20160624',
      url: 'static/policy-mds/privacy/20160624.en-US.md'
    }, {
      version: '20150910',
      url: 'static/policy-mds/privacy/20150910.en-US.md'
    }, {
      version: '20150824',
      url: 'static/policy-mds/privacy/20150824.en-US.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/privacy/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/privacy/20130401.en-US.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/privacy/20121002.en-US.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/privacy/20120720.en-US.md'
    }],
    ko: [{
      version: '20160919',
      url: 'static/policy-mds/privacy/20160919.ko-KR.md'
    }, {
      version: '20160624',
      url: 'static/policy-mds/privacy/20160624.ko-KR.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/privacy/20131010.ko-KR.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/privacy/20130401.ko-KR.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/privacy/20121002.ko-KR.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/privacy/20120720.ko-KR.md'
    }],
    ja: [{
      version: '20160624',
      url: 'static/policy-mds/privacy/20160624.ja-JP.md'
    }, {
      version: '20160530',
      url: 'static/policy-mds/privacy/20160530.ja-JP.md'
    }, {
      version: '20150605',
      url: 'static/policy-mds/privacy/20150605.ja-JP.md'
    }],
    'zh-TW': [{
      version: '20160624',
      url: 'static/policy-mds/privacy/20160624.zh-TW.md'
    }, {
      version: '20150910',
      url: 'static/policy-mds/privacy/20150910.zh-TW.md'
    }],
    'zh-CN': [{
      version: '20150901',
      url: 'static/policy-mds/privacy/20150901.zh-CN.md'
    }],
    'en-HK': [{
      version: '20150901',
      url: 'static/policy-mds/privacy/20150901.en-HK.md'
    }],
    es: [{
      version: '20150910',
      url: 'static/policy-mds/privacy/20150910.en-US.md'
    }, {
      version: '20150824',
      url: 'static/policy-mds/privacy/20150824.en-US.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/privacy/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/privacy/20130401.en-US.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/privacy/20121002.en-US.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/privacy/20120720.en-US.md'
    }],
    tr: [{
      version: '20160624',
      url: 'static/policy-mds/privacy/20160624.en-US.md'
    }, {
      version: '20150910',
      url: 'static/policy-mds/privacy/20150910.en-US.md'
    }, {
      version: '20150824',
      url: 'static/policy-mds/privacy/20150824.en-US.md'
    }, {
      version: '20131010',
      url: 'static/policy-mds/privacy/20131010.en-US.md'
    }, {
      version: '20130401',
      url: 'static/policy-mds/privacy/20130401.en-US.md'
    }, {
      version: '20121002',
      url: 'static/policy-mds/privacy/20121002.en-US.md'
    }, {
      version: '20120720',
      url: 'static/policy-mds/privacy/20120720.en-US.md'
    }]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (policyVersions);

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "4iNN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4kYG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4mxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__("K9lf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_QuizFormModal__ = __webpack_require__("W7R5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MyQuizCard__ = __webpack_require__("QiU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MyQuizModal__ = __webpack_require__("N6yp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("qI5z");















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-quizzes',

  data: function data() {
    return {
      isQuizFormModal: false,
      isQuizModal: false,
      quiz: {}
    };
  },


  components: {
    QuizFormModal: __WEBPACK_IMPORTED_MODULE_7__components_QuizFormModal__["a" /* default */],
    MyQuizCard: __WEBPACK_IMPORTED_MODULE_8__components_MyQuizCard__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a,
    MyQuizModal: __WEBPACK_IMPORTED_MODULE_9__components_MyQuizModal__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    myQuizzes: 'getMyQuizzes',
    isLoadingMyQuizzes: 'isLoadingMyQuizzes',
    totalMyQuizzes: 'getTotalMyQuizzes'
  }), {
    isEmptyQuizzes: function isEmptyQuizzes() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.myQuizzes);
    },
    isInfiniteLoading: function isInfiniteLoading() {
      return this.myQuizzes.length < this.totalMyQuizzes;
    },
    getBodyStyle: function getBodyStyle() {
      return {
        background: 'linear-gradient(to bottom, #4823ae, #9751c7 64%)',
        'min-height': '100vh'
      };
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchMyQuizzes']), {
    handleNewQuizClick: function handleNewQuizClick() {
      this.quiz = {};
      this.isQuizFormModal = true;
    },
    handleModalCloseClick: function handleModalCloseClick() {
      this.isQuizFormModal = false;
    },
    handleQuizClick: function handleQuizClick(quiz) {
      this.quiz = quiz;
      this.isQuizModal = true;
    },
    handleQuizModalCancelClick: function handleQuizModalCancelClick() {
      this.isQuizModal = false;
    },
    handleQuizModalOkClick: function handleQuizModalOkClick() {
      this.isQuizModal = false;
      this.isQuizFormModal = true;
    },
    onInfiniteMyQuizzes: function onInfiniteMyQuizzes() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var page, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["floor"])(_this.myQuizzes.length / __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* PER_PAGE */]) + 1 || 1;
                params = {
                  page: page,
                  per_page: __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* PER_PAGE */],
                  sort: '-created_at'
                };
                _context.next = 4;
                return _this.fetchMyQuizzes({ type: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["a" /* default */].FETCH_INFINITE_MY_QUIZZES_SUCCESS, params: params });

              case 4:

                if (_this.$refs.infiniteLoading) {
                  _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
                  if (_this.myQuizzes.length === _this.totalMyQuizzes) {
                    _this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                  }
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),

  beforeMount: function beforeMount() {
    var params = {
      page: 1,
      per_page: __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* PER_PAGE */],
      sort: '-created_at'
    };

    this.fetchMyQuizzes({ type: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["a" /* default */].FETCH_MY_QUIZZES_SUCCESS, params: params });
  }
});

/***/ }),

/***/ "4oLA":
/***/ (function(module, exports) {

module.exports = {"Play":"Pusti","Pause":"Pauza","Current Time":"Trenutno vrijeme","Duration Time":"Vrijeme trajanja","Remaining Time":"Preostalo vrijeme","Stream Type":"Način strimovanja","LIVE":"UŽIVO","Loaded":"Učitan","Progress":"Progres","Fullscreen":"Puni ekran","Non-Fullscreen":"Mali ekran","Mute":"Prigušen","Unmute":"Ne-prigušen","Playback Rate":"Stopa reprodukcije","Subtitles":"Podnaslov","subtitles off":"Podnaslov deaktiviran","Captions":"Titlovi","captions off":"Titlovi deaktivirani","Chapters":"Poglavlja","You aborted the media playback":"Isključili ste reprodukciju videa.","A network error caused the media download to fail part-way.":"Video se prestao preuzimati zbog greške na mreži.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.","No compatible source was found for this media.":"Nije nađen nijedan kompatibilan izvor ovog videa."}

/***/ }),

/***/ "4rAc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__("kl7r");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-series-modal',

  props: {
    publisherId: {
      type: Number,
      default: null
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      selected: {
        subjectId: '',
        gradeId: '',
        chapterCount: ''
      },
      seriesTitle: '',
      showChapterSelect: false,
      busy: false
    };
  },


  watch: {
    selectedSubjectGrade: function selectedSubjectGrade(value) {
      var _this = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(value.match(/[0-9]+&[0-9]+/))) {
        return this.fetchUnits({
          subject_id: this.selected.subjectId,
          grade_id: this.selected.gradeId
        }).then(function (units) {
          _this.selected.chapterCount = units.length || '';
          _this.showChapterSelect = units.length === 0;
        });
      }

      if (value.match(/[0-9]+&null/)) {
        this.showChapterSelect = true;
      }

      return null;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['subjectMap', 'subjectIds', 'gradeMap', 'gradeIds']), {
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.selected.subjectId + '&' + this.selected.gradeId;
    },
    newSeriesDisabled: function newSeriesDisabled() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.selected.subjectId) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.selected.gradeId)) {
        return true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.seriesTitle)) {
        return true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"])(this.selected.chapterCount)) {
        return true;
      }

      return false;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['createNewSeries', 'fetchUnits']), {
    create: function create() {
      var _this2 = this;

      if (!this.busy) {
        this.busy = true;

        var params = {
          name: this.seriesTitle,
          publisher_id: this.publisherId,
          subject_id: this.selected.subjectId,
          grade_id: this.selected.gradeId === 'null' ? null : this.selected.gradeId,
          chapters_count: this.selected.chapterCount
        };

        this.createNewSeries(params).then(function () {
          return _this2.$emit('ok');
        });
      }
    }
  })
});

/***/ }),

/***/ "4vWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clickout__ = __webpack_require__("om2z");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'more-btn-dropdown',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clickout__["a" /* default */]],

  props: {
    dropup: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },


  computed: {
    classBindings: function classBindings() {
      return {
        show: this.visible,
        dropup: this.dropup
      };
    }
  },

  watch: {
    visible: function visible(state, old) {
      if (state === old) {
        return;
      }

      if (state) {
        this.$root.$emit('shown::dropdown', this);
      } else {
        this.$root.$emit('hidden::dropdown', this);
      }
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.visible = !this.visible;
    },
    clickOutListener: function clickOutListener() {
      this.visible = false;
    },
    click: function click() {
      this.toggleMenu();
    }
  },

  created: function created() {
    var _this = this;

    this.$root.$on('shown::dropdown', function (el) {
      if (el !== _this) {
        _this.visible = false;
      }
    });
  }
});

/***/ }),

/***/ "4xbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("2uFj");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-lecture-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  props: {
    lecture: {
      type: Object,
      default: null
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap']), {
    lectureThumbLink: function lectureThumbLink() {
      var defaultLink = __WEBPACK_IMPORTED_MODULE_4__config__["k" /* AWS_CF_URL */] + '/uploads/cover_images/ESC.png';

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.lecture, 'video.pictures[1].link', defaultLink);
    },
    lectureThumbStyle: function lectureThumbStyle() {
      return {
        'background-image': 'url(\'' + this.lectureThumbLink + '\')'
      };
    }
  })
});

/***/ }),

/***/ "4y8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var router = [];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5+pX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchStoreCards"] = fetchStoreCards;
/* harmony export (immutable) */ __webpack_exports__["fetchStoreCardDetails"] = fetchStoreCardDetails;
/* harmony export (immutable) */ __webpack_exports__["fetchStoreCardPages"] = fetchStoreCardPages;
/* harmony export (immutable) */ __webpack_exports__["fetchPublisherCardPages"] = fetchPublisherCardPages;
/* harmony export (immutable) */ __webpack_exports__["setStoreCardsInStore"] = setStoreCardsInStore;
/* harmony export (immutable) */ __webpack_exports__["addStoreCardsInStore"] = addStoreCardsInStore;
/* harmony export (immutable) */ __webpack_exports__["setSelectedStoreCardId"] = setSelectedStoreCardId;
/* harmony export (immutable) */ __webpack_exports__["setStoreCardPages"] = setStoreCardPages;
/* harmony export (immutable) */ __webpack_exports__["setPublisherCardPages"] = setPublisherCardPages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("rM12");







function fetchStoreCards(_ref, filters) {
  var dispatch = _ref.dispatch;

  var queryParams = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(filters);

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/store-cards?' + queryParams).then(function (res) {
    if (!filters.offset) {
      return dispatch('setStoreCardsInStore', res.data);
    }

    return dispatch('addStoreCardsInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching store cards:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchStoreCardDetails(_ref2, cardId) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/store-cards/' + cardId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching store card details:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchStoreCardPages(_ref3, cardId) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/store-cards/' + cardId + '/pages').then(function (res) {
    return dispatch('setStoreCardPages', { cardId: cardId, pageList: res.data });
  }).catch(function (err) {
    console.error('err while fetching store card pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchPublisherCardPages(_ref4, cardId) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/pages').then(function (res) {
    return dispatch('setCustomCardPages', { cardId: cardId, pageList: res.data });
  }).then(function (pageList) {
    return dispatch('setPublisherCardPages', { cardId: cardId, pageList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(pageList) });
  }).catch(function (err) {
    console.error('err while fetching publisher card pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setStoreCardsInStore(_ref5, cardList) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_CARDS, cardList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardList);
}

function addStoreCardsInStore(_ref6, cardList) {
  var commit = _ref6.commit,
      getters = _ref6.getters;

  var filteredCardList = cardList.filter(function (card) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(card.store_card_id) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["has"])(getters.storeCards, card.id) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(card.store_card_id) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["has"])(getters.publisherCards, card.id);
  });

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].ADD_CARDS, filteredCardList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(filteredCardList);
}

function setSelectedStoreCardId(_ref7, cardId) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_SELECTED, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setStoreCardPages(_ref8, setInfo) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_CARD_PAGES, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setInfo.pageList);
}

function setPublisherCardPages(_ref9, setInfo) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_PUB_CARD_PAGES, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setInfo.pageList);
}

/***/ }),

/***/ "56Sp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  selectedStoreCardId: '',

  storeCardList: []
});

/***/ }),

/***/ "58zr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesListItem_vue__ = __webpack_require__("Ufk7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046a21e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesListItem_vue__ = __webpack_require__("etAw");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("EIgA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046a21e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/SeriesListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-046a21e0", Component.options)
  } else {
    hotAPI.reload("data-v-046a21e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5BI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function getShortLocale(language) {
  if (!language) {
    return 'ko';
  }
  if (/^ko(-([\w]{1,4}))?$/.test(language)) {
    return 'ko';
  }
  if (/^en(-([\w]{1,4}))?$/.test(language)) {
    return 'en';
  }
  if (/^ja(-([\w]{1,4}))?$/.test(language)) {
    return 'ja';
  }
  if (/^es(-([\w]{1,4}))?$/.test(language)) {
    return 'es';
  }
  if (/^tr(-([\w]{1,4}))?$/.test(language)) {
    return 'tr';
  }
  if (/^vi(-([\w]{1,4}))?$/.test(language)) {
    return 'vi-VN';
  }
  if (/^ms(-([\w]{1,4}))?$/.test(language)) {
    return 'ms-MY';
  }
  if (/^id(-([\w]{1,4}))?$/.test(language)) {
    return 'id-ID';
  }
  if (/^th(-([\w]{1,4}))?$/.test(language)) {
    return 'th-TH';
  }
  if (/^ru(-([\w]{1,4}))?$/.test(language)) {
    return 'ru-RU';
  }
  if (language === 'zh-tw') {
    return 'zh-TW';
  }

  return language;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getLocale: function getLocale(userInfo) {
      var language = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this, '$route.query.lang');

      if (!language) {
        language = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(userInfo, 'language');
      }

      return getShortLocale(language);
    }
  }
});

/***/ }),

/***/ "5HxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ReportContentModal", {
    attrs: { card: _vm.selectedPreviewCard, page: _vm.reportingPage },
    on: {
      ok: function($event) {
        return _vm.$emit("ok")
      },
      cancel: function($event) {
        return _vm.$emit("cancel")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ed1f689", esExports)
  }
}

/***/ }),

/***/ "5QD0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landing-main-v3',

  props: {
    isIntro: {
      type: Boolean,
      default: false
    },
    attachHome: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      aiUrl: __WEBPACK_IMPORTED_MODULE_2__config__["t" /* AI_WEB_URL */],
      authUrl: __WEBPACK_IMPORTED_MODULE_2__config__["e" /* CLASSTING_FULL_AUTH_URL */],
      selectedAnalysisView: 'teacher',
      analysisSlides: {
        teacher: [{
          id: 'teacher_01',
          image: '/static/images/teacher_analysis_02_1.png',
          title: 'landing_v2.block7.teacher.slide1.title',
          subtitle: 'landing_v2.block7.teacher.slide1.subtitle'
        }, {
          id: 'teacher_02',
          image: '/static/images/teacher_analysis_02_2.png',
          title: 'landing_v2.block7.teacher.slide2.title',
          subtitle: 'landing_v2.block7.teacher.slide2.subtitle'
        }],
        student: [{
          id: 'student_01',
          image: '/static/images/student_analysis_02_1.png',
          title: 'landing_v2.block7.student.slide1.title',
          subtitle: 'landing_v2.block7.student.slide1.subtitle'
        }, {
          id: 'student_02',
          image: '/static/images/student_analysis_02_2.png',
          title: 'landing_v2.block7.student.slide2.title',
          subtitle: 'landing_v2.block7.student.slide2.subtitle'
        }],
        parent: [{
          id: 'parent_01',
          image: '/static/images/parent_analysis_02_1.png',
          title: 'landing_v2.block7.parent.slide1.title',
          subtitle: 'landing_v2.block7.parent.slide1.subtitle'
        }, {
          id: 'parent_02',
          image: '/static/images/parent_analysis_02_2.png',
          title: 'landing_v2.block7.parent.slide2.title',
          subtitle: 'landing_v2.block7.parent.slide2.subtitle'
        }]
      },
      showVideo: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isSignedIn']), {
    selectedAnalysisSlides: function selectedAnalysisSlides() {
      return this.analysisSlides[this.selectedAnalysisView];
    }
  }),

  methods: {
    startCl: function startCl() {
      if (this.isIntro) {
        return this.$router.push('/library');
      }

      if (this.isSignedIn) {
        return this.$router.push('/library');
      }

      sessionStorage.setItem('continue_url', '/library');
      window.location.href = this.authUrl;
      return true;
    }
  }
});

/***/ }),

/***/ "5TPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function date(dateObj) {
  if (dateObj) {
    var month = dateObj.getMonth() + 1 > 9 ? dateObj.getMonth() + 1 : '0' + (dateObj.getMonth() + 1);
    var day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();

    return dateObj.getFullYear() + '/' + month + '/' + day;
  }

  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),

/***/ "5hnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchEvaluationList"] = fetchEvaluationList;
/* harmony export (immutable) */ __webpack_exports__["fetchEvaluation"] = fetchEvaluation;
/* harmony export (immutable) */ __webpack_exports__["saveEvaluationList"] = saveEvaluationList;
/* harmony export (immutable) */ __webpack_exports__["fetchEvaluationCriteria"] = fetchEvaluationCriteria;
/* harmony export (immutable) */ __webpack_exports__["saveEvaluationCriteria"] = saveEvaluationCriteria;
/* harmony export (immutable) */ __webpack_exports__["fetchEvaluationDomains"] = fetchEvaluationDomains;
/* harmony export (immutable) */ __webpack_exports__["saveEvaluationDomains"] = saveEvaluationDomains;
/* harmony export (immutable) */ __webpack_exports__["setEvaluationListInStore"] = setEvaluationListInStore;
/* harmony export (immutable) */ __webpack_exports__["setEvaluationInStore"] = setEvaluationInStore;
/* harmony export (immutable) */ __webpack_exports__["setEvaluationCriteriaInStore"] = setEvaluationCriteriaInStore;
/* harmony export (immutable) */ __webpack_exports__["setEvaluationFilter"] = setEvaluationFilter;
/* harmony export (immutable) */ __webpack_exports__["setEvaluationOrderBy"] = setEvaluationOrderBy;
/* harmony export (immutable) */ __webpack_exports__["setEvaluationDomains"] = setEvaluationDomains;
/* harmony export (immutable) */ __webpack_exports__["setSelectedEvaluationDomainIds"] = setSelectedEvaluationDomainIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("k0lw");







function fetchEvaluationList(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var classId = _ref2.classId,
      filters = _ref2.filters;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/evaluation', { params: filters }).then(function (res) {
    return dispatch('setEvaluationListInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching evaluation list:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchEvaluation(_ref3, _ref4) {
  var dispatch = _ref3.dispatch;
  var studentId = _ref4.studentId,
      filters = _ref4.filters,
      index = _ref4.index;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/users/' + studentId + '/evaluation', { params: filters }).then(function (res) {
    return dispatch('setEvaluationInStore', { index: index, evaluation: res.data });
  }).catch(function (err) {
    console.error('err while fetching evaluation:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function saveEvaluationList(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var classId = _ref6.classId,
      evaluationList = _ref6.evaluationList;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/evaluation', evaluationList).catch(function (err) {
    console.error('err while saving evaluation list:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchEvaluationCriteria(_ref7, _ref8) {
  var dispatch = _ref7.dispatch;
  var classId = _ref8.classId,
      filters = _ref8.filters;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/criteria', { params: filters }).then(function (res) {
    return dispatch('setEvaluationCriteriaInStore', res.data.criteria[0]);
  }).catch(function (err) {
    console.error('err while fetching evaluation criteria:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function saveEvaluationCriteria(_ref9, _ref10) {
  var dispatch = _ref9.dispatch;
  var classId = _ref10.classId,
      criteriaBody = _ref10.criteriaBody;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/criteria', criteriaBody).then(function () {
    return dispatch('setEvaluationCriteriaInStore', criteriaBody.criteria[0]);
  }).catch(function (err) {
    console.error('err while saving evaluation criteria:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchEvaluationDomains(_ref11, _ref12) {
  var dispatch = _ref11.dispatch;
  var classId = _ref12.classId,
      filters = _ref12.filters;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/domains', { params: filters }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch('setEvaluationDomains', { domains: res.data.domains || [], classId: classId }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(res.data.selected_domains)) {
        var domainIds = res.data.domains.map(function (domain) {
          return domain.id;
        });

        return dispatch('setSelectedEvaluationDomainIds', { selectedDomainIds: domainIds, classId: classId });
      }

      return dispatch('setSelectedEvaluationDomainIds', { selectedDomainIds: res.data.selected_domains || [], classId: classId });
    })]);
  }).catch(function (err) {
    console.error('err while fetching evaluation domains:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function saveEvaluationDomains(_ref13, _ref14) {
  var dispatch = _ref13.dispatch;
  var classId = _ref14.classId,
      domainBody = _ref14.domainBody;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/domains', domainBody).catch(function (err) {
    console.error('err while saving evaluation domains:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setEvaluationListInStore(_ref15, evaluationList) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_EVALUATION_LIST, evaluationList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(evaluationList);
}

function setEvaluationInStore(_ref16, _ref17) {
  var commit = _ref16.commit;
  var index = _ref17.index,
      evaluation = _ref17.evaluation;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_EVALUATION, { index: index, evaluation: evaluation });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(evaluation);
}

function setEvaluationCriteriaInStore(_ref18, criteria) {
  var commit = _ref18.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_EVALUATION_CRITERIA, criteria);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(criteria);
}

function setEvaluationFilter(_ref19, filterInfo) {
  var commit = _ref19.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_EVALUATION_FILTER, filterInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setEvaluationOrderBy(_ref20, orderBy) {
  var commit = _ref20.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_EVALUATION_ORDER_BY, orderBy);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setEvaluationDomains(_ref21, params) {
  var commit = _ref21.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CLASS_EVALUATION_DOMAINS, params);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(params);
}

function setSelectedEvaluationDomainIds(_ref22, params) {
  var commit = _ref22.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED_CLASS_EVALUATION_DOMAINS, params);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(params);
}

/***/ }),

/***/ "5isV":
/***/ (function(module, exports) {

module.exports = {"Play":"Възпроизвеждане","Pause":"Пауза","Current Time":"Текущо време","Duration Time":"Продължителност","Remaining Time":"Оставащо време","Stream Type":"Тип на потока","LIVE":"НА ЖИВО","Loaded":"Заредено","Progress":"Прогрес","Fullscreen":"Цял екран","Non-Fullscreen":"Спиране на цял екран","Mute":"Без звук","Unmute":"Със звук","Playback Rate":"Скорост на възпроизвеждане","Subtitles":"Субтитри","subtitles off":"Спряни субтитри","Captions":"Аудио надписи","captions off":"Спряни аудио надписи","Chapters":"Глави","You aborted the media playback":"Спряхте възпроизвеждането на видеото","A network error caused the media download to fail part-way.":"Грешка в мрежата провали изтеглянето на видеото.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Видеото не може да бъде заредено заради проблем със сървъра или мрежата или защото този формат не е поддържан.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Възпроизвеждането на видеото беше прекъснато заради проблем с файла или защото видеото използва опции които браузърът Ви не поддържа.","No compatible source was found for this media.":"Не беше намерен съвместим източник за това видео."}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "61Ek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "evaluations" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 hidden-xs-down" }, [
            _c("div", { staticClass: "sub-header-btn-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary mr-1",
                  attrs: { disabled: _vm.noClass },
                  on: {
                    click: function($event) {
                      _vm.evaluationCriteriaModalIsShown = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("evaluations.sub_header.config_criteria")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary ml-1 mr-1",
                  attrs: { disabled: _vm.noClass },
                  on: { click: _vm.save }
                },
                [
                  !_vm.busy
                    ? [_vm._v(_vm._s(_vm.$t("common.save")))]
                    : _c("LoadingBounce")
                ],
                2
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.noClass
      ? _c(
          "div",
          {
            staticClass: "container mw-960 mb-5 pb-20 text-center",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", {
              staticClass:
                "typography--body-2 typography--color-disabled pt-5 mt-5",
              domProps: { innerHTML: _vm._s(_vm.$t("evaluations.no_classes")) }
            })
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-960 pb-20",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row browse-filter-row" }, [
              _c("div", { staticClass: "col-12 col-lg-7" }, [
                _c("div", { staticClass: "row box" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-5 divider" },
                    [
                      _c(
                        "b-dropdown",
                        {
                          staticClass: "mnv-dropdown",
                          attrs: { text: _vm.selectedClassName }
                        },
                        _vm._l(_vm.managingClassList, function(cls) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: cls.id,
                              attrs: { disabled: _vm.loading },
                              on: {
                                click: function($event) {
                                  return _vm.selectClass(cls.id)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cls.year) +
                                  " " +
                                  _vm._s(cls.grade) +
                                  " - " +
                                  _vm._s(cls.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-3" },
                    [
                      _c(
                        "b-dropdown",
                        {
                          staticClass: "mnv-dropdown subject-select",
                          attrs: { text: _vm.subjectMap[_vm.selectedSubjectId] }
                        },
                        _vm._l(_vm.subjectMap, function(subjectName, sjId) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: sjId,
                              attrs: {
                                disabled:
                                  _vm.loading ||
                                  (sjId !== "2" && sjId !== "3" && sjId !== "5")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectSubject(sjId)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.subjectMap[sjId]) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-5" }, [
                _c(
                  "ul",
                  { staticClass: "nav justify-content-end order-by-btns" },
                  [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link typography--color-secondary",
                          class: { active: _vm.evaluationOrderBy === "number" },
                          on: {
                            click: function($event) {
                              return _vm.selectOrderBy("number")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("evaluations.filters.order_by.number")
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link typography--color-secondary",
                          class: { active: _vm.evaluationOrderBy === "name" },
                          on: {
                            click: function($event) {
                              return _vm.selectOrderBy("name")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("evaluations.filters.order_by.name"))
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("DomainSelect", {
              attrs: {
                domains: _vm.domains,
                "selected-domain-ids": _vm.selectedDomainIds,
                loading: _vm.loading
              },
              on: { "domain-option-clicked": _vm.onDomainOptionClicked }
            }),
            _vm._v(" "),
            _vm.loading
              ? _c("div", [_c("LoadingBounce")], 1)
              : _c("EvaluationTable", {
                  attrs: {
                    "evaluation-list": _vm.sortedEvaluationList,
                    "selected-domain-ids": _vm.selectedDomainIds
                  }
                })
          ],
          1
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _vm.evaluationCriteriaModalIsShown
          ? _c("EvaluationCriteriaModal", {
              on: {
                "criteria-updated": _vm.onCriteriaUpdated,
                cancel: function($event) {
                  _vm.evaluationCriteriaModalIsShown = false
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("Snackbar")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fff8b27", esExports)
  }
}

/***/ }),

/***/ "66Wm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["notificationParams"] = notificationParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");



function notificationParams(state, getters) {
  var parentIds = getters.getRouteQuery.parent_ids;

  if (!parentIds) {
    return null;
  }

  var studentName = getters.currentUser.name;
  var queryParams = {
    student_name: studentName,
    grade: getters.currentUser.grade,
    student_id: getters.currentUser.id,
    source: 'classting'
  };

  var targetUrl = __WEBPACK_IMPORTED_MODULE_1__config__["r" /* CT_PERF_URL */] + '/parent-view?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(queryParams);

  return {
    target_user_ids: parentIds,
    target_role: 'parent',
    target_url: encodeURIComponent(targetUrl),
    contents: {
      en: studentName + ' just finished learning. Check ' + studentName + '\'s learning performance now.',
      ko: studentName + ' \uD559\uC0DD\uC774 \uD559\uC2B5\uC744 \uC644\uB8CC\uD588\uC2B5\uB2C8\uB2E4. \uC9C0\uAE08 \uD559\uC2B5 \uD37C\uD3EC\uBA3C\uC2A4\uB97C \uD655\uC778\uD574\uBCF4\uC138\uC694.'
    }
  };
}

/***/ }),

/***/ "6MFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Forbidden__ = __webpack_require__("trVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_NotFound__ = __webpack_require__("qbKL");



var router = [{
  name: 'errors.forbidden',
  path: '/403',
  component: __WEBPACK_IMPORTED_MODULE_0__views_Forbidden__["a" /* default */],
  meta: {
    requiresAuth: false,
    requiresTeacherRole: false
  }
}, {
  name: 'errors.notFound',
  path: '/404',
  component: __WEBPACK_IMPORTED_MODULE_1__views_NotFound__["a" /* default */],
  meta: {
    requiresAuth: false,
    requiresTeacherRole: false
  }
}, {
  path: '*',
  redirect: '404'
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "6Pfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["selectedAssignmentId"] = selectedAssignmentId;
/* harmony export (immutable) */ __webpack_exports__["assignments"] = assignments;
/* harmony export (immutable) */ __webpack_exports__["assignmentList"] = assignmentList;
/* harmony export (immutable) */ __webpack_exports__["assignmentIds"] = assignmentIds;
/* harmony export (immutable) */ __webpack_exports__["classAssignments"] = classAssignments;
/* harmony export (immutable) */ __webpack_exports__["teacherAssignmentStats"] = teacherAssignmentStats;
/* harmony export (immutable) */ __webpack_exports__["selectedCardForNewAssignment"] = selectedCardForNewAssignment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function selectedAssignmentId(state) {
  return state.selectedAssignmentId;
}

function assignments(state) {
  return state.assignments;
}

function assignmentList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.assignments), ['updated_at'], ['desc']);
}

function assignmentIds(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"])(state.assignments);
}

function classAssignments(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"])(getters.assignmentList, 'class_id');
}

function teacherAssignmentStats(state) {
  return state.teacherAssignmentStats;
}

function selectedCardForNewAssignment(state) {
  return state.selectedCardForNewAssignment;
}

/***/ }),

/***/ "6Pig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("YR2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("w4MO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("i7qK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("85v8");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "6WE2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6WOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectAssignmentModal_vue__ = __webpack_require__("yAk1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96f47d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectAssignmentModal_vue__ = __webpack_require__("AVVC");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Fi7t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96f47d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectAssignmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96f47d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectAssignmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/components/SelectAssignmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-96f47d8a", Component.options)
  } else {
    hotAPI.reload("data-v-96f47d8a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6ZH2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "6a9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationBadge_vue__ = __webpack_require__("wBJx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a14734d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationBadge_vue__ = __webpack_require__("PLQ9");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("CIAg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationBadge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a14734d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationBadge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/EvaluationBadge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a14734d", Component.options)
  } else {
    hotAPI.reload("data-v-2a14734d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6gAy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6jjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["videoLectures"] = videoLectures;
/* harmony export (immutable) */ __webpack_exports__["videoLectureList"] = videoLectureList;
/* harmony export (immutable) */ __webpack_exports__["lecturesByCourseId"] = lecturesByCourseId;
/* harmony export (immutable) */ __webpack_exports__["recentVideoUploadInfo"] = recentVideoUploadInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function videoLectures(state) {
  return state.videoLectures;
}

function videoLectureList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.videoLectures), ['created_at'], ['desc']);
}

function lecturesByCourseId(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"])(state.videoLectures, 'video_course_id');
}

function recentVideoUploadInfo(state) {
  return state.recentVideoUploadInfo;
}

/***/ }),

/***/ "6mhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'domain-select-option',

  props: {
    domain: {
      type: Object,
      default: null
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "6qw9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report-content-from-preview',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['selectedPreviewPageIndex', 'selectedPreviewCard']), {
    reportingPage: function reportingPage() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.selectedPreviewCard) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.selectedPreviewCard.pages) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.selectedPreviewCard.pages) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.selectedPreviewPageIndex) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.selectedPreviewCard.pages[this.selectedPreviewPageIndex])) {
        return this.selectedPreviewCard.pages[this.selectedPreviewPageIndex];
      }

      return null;
    }
  })
});

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7+09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardDetails_vue__ = __webpack_require__("e1ZV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c30b86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardDetails_vue__ = __webpack_require__("slOa");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c30b86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/library/views/CardDetails.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74c30b86", Component.options)
  } else {
    hotAPI.reload("data-v-74c30b86", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "78ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "library-card",
      on: { mouseover: _vm.handleCardOver, mouseleave: _vm.handleCardLeave }
    },
    [
      _c(
        "div",
        _vm._g(
          {
            staticClass: "card-ad-container",
            class: { clickable: _vm.advertisement.link }
          },
          _vm.advertisement.link ? { click: _vm.goToAdLink } : {}
        ),
        [
          _c("div", {
            staticClass: "card-ad-img",
            style: {
              "background-image": "url('" + _vm.advertisement.image_url + "')"
            }
          }),
          _vm._v(" "),
          _vm.mouseOver && _vm.advertisement.link
            ? _c("div", { staticClass: "card-ad-background" })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-cover-img-thumb clickable" }),
      _vm._v(" "),
      _c("div", { staticClass: "card-block clickable" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 card-info-section" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h4", { staticClass: "card-title" }),
              _vm._v(" "),
              _c("div", { staticClass: "card-subtitle typography--caption" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-bottom-desc" }, [
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _c("span", { staticStyle: { color: "transparent" } }, [
                      _vm._v(" ")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [_vm._v(" ")]
                )
              ]),
              _vm._v(" "),
              _vm.showOwner
                ? _c("div", [
                    _c(
                      "small",
                      {
                        staticClass:
                          "typography--caption typography--color-secondary"
                      },
                      [_vm._v(" ")]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59150641", esExports)
  }
}

/***/ }),

/***/ "7K8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http; });
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = setCountryCode;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeCountryCode;
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors__ = __webpack_require__("wbE/");



var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();

http.defaults.headers.post['Content-Type'] = 'application/json';

function setToken(token) {
  if (token) {
    http.defaults.headers.common.Authorization = 'Bearer ' + token;
  }
}

function removeToken() {
  delete http.defaults.headers.common.Authorization;
}

function setCountryCode(countryCode) {
  if (countryCode) {
    http.defaults.headers.common['Country-Code'] = countryCode;
  }
}

function removeCountryCode() {
  delete http.defaults.headers.common['Country-Code'];
}

function install(Vue, _ref) {
  var store = _ref.store,
      router = _ref.router;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* default */])(http, store, router);

  Object.defineProperty(Vue.prototype, '$http', {
    get: function get() {
      return http;
    }
  });
}

/***/ }),

/***/ "7TVa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("K49E");


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_PROPERTY, function (state, _ref) {
  var property = _ref.property,
      value = _ref.value;

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.user, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_TOKEN, function (state, token) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'token', token);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_USER, function (state, user) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'user', user);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SIGN_OUT, function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].delete(state, 'token');
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].delete(state, 'user');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_DEVICE, function (state, device) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'device', device);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "7VK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["selectedClassId"] = selectedClassId;
/* harmony export (immutable) */ __webpack_exports__["selectedClassName"] = selectedClassName;
/* harmony export (immutable) */ __webpack_exports__["managingClasses"] = managingClasses;
/* harmony export (immutable) */ __webpack_exports__["managingClassList"] = managingClassList;
/* harmony export (immutable) */ __webpack_exports__["managingClassIds"] = managingClassIds;
/* harmony export (immutable) */ __webpack_exports__["managingClassListBySchools"] = managingClassListBySchools;
/* harmony export (immutable) */ __webpack_exports__["isClassStudent"] = isClassStudent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function selectedClassId(state) {
  return state.selectedClassId;
}

function selectedClassName(state, getter) {
  if (state.managingClasses[getter.selectedClassId]) {
    return state.managingClasses[getter.selectedClassId].name;
  }

  return '모든 클래스';
}

function managingClasses(state) {
  return state.managingClasses;
}

function managingClassList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.managingClasses), ['school_year', 'year', 'name'], ['desc', 'desc', 'asc']);
}

function managingClassIds(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"])(state.managingClasses);
}

function managingClassListBySchools(state, getter) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"])(getter.managingClassList, function (cls) {
    return cls.school_id + ';' + cls.school_name;
  });
}

function isClassStudent(state) {
  return state.isClassStudent;
}

/***/ }),

/***/ "7Xb3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Z2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AiScoreGuideModal_vue__ = __webpack_require__("waa7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21764a7b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AiScoreGuideModal_vue__ = __webpack_require__("8zvC");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("0skX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21764a7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AiScoreGuideModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21764a7b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AiScoreGuideModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/AiScoreGuideModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21764a7b", Component.options)
  } else {
    hotAPI.reload("data-v-21764a7b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7ktI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("4y8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("L6A9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "7phZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("UwXV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("uCIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("2fdQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("udcR");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "7sNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationCriteriaModal_vue__ = __webpack_require__("Qenl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de0eb290_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationCriteriaModal_vue__ = __webpack_require__("c6D2");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Ua77")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationCriteriaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de0eb290_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationCriteriaModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/EvaluationCriteriaModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-de0eb290", Component.options)
  } else {
    hotAPI.reload("data-v-de0eb290", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "8/AZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "83AY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clickout__ = __webpack_require__("om2z");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon-dropdown',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clickout__["a" /* default */]],

  props: {
    dropup: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },


  computed: {
    classBindings: function classBindings() {
      return {
        show: this.visible,
        dropup: this.dropup
      };
    }
  },

  watch: {
    visible: function visible(state, old) {
      if (state === old) {
        return;
      }

      if (state) {
        this.$root.$emit('shown::dropdown', this);
      } else {
        this.$root.$emit('hidden::dropdown', this);
      }
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.visible = !this.visible;
    },
    clickOutListener: function clickOutListener() {
      this.visible = false;
    },
    click: function click() {
      this.toggleMenu();
    }
  },

  created: function created() {
    var _this = this;

    this.$root.$on('shown::dropdown', function (el) {
      if (el !== _this) {
        _this.visible = false;
      }
    });
  }
});

/***/ }),

/***/ "85X4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WelcomeMessageModal_vue__ = __webpack_require__("r5lM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40444568_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WelcomeMessageModal_vue__ = __webpack_require__("Ok4L");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WelcomeMessageModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40444568_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WelcomeMessageModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/WelcomeMessageModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40444568", Component.options)
  } else {
    hotAPI.reload("data-v-40444568", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "85pS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewSeriesModal_vue__ = __webpack_require__("4rAc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a979744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewSeriesModal_vue__ = __webpack_require__("l8k1");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("YV9O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewSeriesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a979744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewSeriesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/NewSeriesModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a979744", Component.options)
  } else {
    hotAPI.reload("data-v-1a979744", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "85v8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["series"] = series;
/* harmony export (immutable) */ __webpack_exports__["seriesList"] = seriesList;
/* harmony export (immutable) */ __webpack_exports__["nonSeriesCards"] = nonSeriesCards;
/* harmony export (immutable) */ __webpack_exports__["nonSeriesCardList"] = nonSeriesCardList;
/* harmony export (immutable) */ __webpack_exports__["chapters"] = chapters;
/* harmony export (immutable) */ __webpack_exports__["chapterList"] = chapterList;
/* harmony export (immutable) */ __webpack_exports__["chaptersBySeriesId"] = chaptersBySeriesId;
/* harmony export (immutable) */ __webpack_exports__["chapterCards"] = chapterCards;
/* harmony export (immutable) */ __webpack_exports__["chapterCardList"] = chapterCardList;
/* harmony export (immutable) */ __webpack_exports__["cardsByChapterId"] = cardsByChapterId;
/* harmony export (immutable) */ __webpack_exports__["videoCourseCard"] = videoCourseCard;
/* harmony export (immutable) */ __webpack_exports__["isLoadingVideoCourseCard"] = isLoadingVideoCourseCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function series(state) {
  return state.series;
}

function seriesList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.series), ['created_at'], ['desc']);
}

function nonSeriesCards(state) {
  return state.nonSeriesCards;
}

function nonSeriesCardList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.nonSeriesCards), ['created_at'], ['desc']);
}

function chapters(state) {
  return state.chapters;
}

function chapterList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.chapters), ['series_id', 'position'], ['asc']);
}

function chaptersBySeriesId(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"])(getters.chapterList, 'series_id');
}

function chapterCards(state) {
  return state.chapterCards;
}

function chapterCardList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.chapterCards), ['chapter_id', 'position'], ['asc']);
}

function cardsByChapterId(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"])(getters.chapterCardList, 'chapter_id');
}

function videoCourseCard(state) {
  return state.videoCourseCard || {};
}

function isLoadingVideoCourseCard(state) {
  return state.isLoadingVideoCourseCard;
}

/***/ }),

/***/ "86hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__("JnrT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'autosize-textarea',

  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    limit: {
      type: Number,
      default: undefined
    },
    rows: {
      type: Number,
      default: 1
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onInput: function onInput(value) {
      this.$emit('input', value);
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_autosize___default()(this.$el);
  }
});

/***/ }),

/***/ "8JgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("A47E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("ylPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("y8Tl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("Ezk2");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "8PQF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8RXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicModal_vue__ = __webpack_require__("jt7f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ffd462_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicModal_vue__ = __webpack_require__("eYCq");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ffd462_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/BasicModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f8ffd462", Component.options)
  } else {
    hotAPI.reload("data-v-f8ffd462", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8UcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__ = __webpack_require__("UlOv");





var reactiveProp = __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__["b" /* Line */],
  name: 'proficiency-line-chart',
  mixins: [reactiveProp],
  props: ['chartData', 'dataset', 'labels'],
  data: function data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          pointLabels: {
            display: true,
            fontColor: '#ffffff',
            fontSize: 12
          },
          yAxes: [{
            gridLines: {
              zeroLineWidth: 1,
              scaleShowGridLines: true,
              display: false,
              drawBorder: true,
              color: 'rgba(255, 255, 255, 0)'
            },
            scaleLabel: {
              display: false
            },
            scaleShowLabels: false,
            ticks: {
              display: true,
              beginAtZero: true,
              stepSize: 250,
              fontColor: '#ffffff',
              fontSize: 12
            }
          }],
          xAxes: [{
            position: 'bottom',
            gridLines: {
              display: false,
              scaleShowGridLines: true,
              drawBorder: true,
              color: 'rgba(255, 255, 255, 0.1)'
            },
            ticks: {
              display: true,
              beginAtZero: false,
              fontColor: '#ffffff',
              fontSize: 12
            }
          }]
        },
        legend: {
          display: false
        }
      }
    };
  },
  mounted: function mounted() {
    var maxX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["min"])([window.innerWidth, 700]);
    var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(10, 0, maxX, 0);
    gradient.addColorStop(0, 'rgba(255, 255, 255, 0.05)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0.4)');

    var chartData = {
      labels: this.labels,
      datasets: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dataset, {
        backgroundColor: gradient
      })]
    };

    this.renderChart(chartData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.options));
  }
});

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8cID":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8coR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quiz-preview-wrapper" }, [
    _c("div", { staticClass: "preview-header" }),
    _vm._v(" "),
    _c("div", { staticClass: "preview-body" }, [
      _c("div", { staticClass: "preview-quiz-wrapper" }, [
        _vm.getQuizTags(_vm.quiz)
          ? _c(
              "div",
              { staticClass: "tag-wrapper" },
              _vm._l(_vm.getQuizTags(_vm.quiz), function(value, index) {
                return _c("div", { key: index, staticClass: "tag" }, [
                  _vm._v("\n        " + _vm._s(value) + "\n      ")
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v("\n      " + _vm._s(_vm.quiz.content) + "\n    ")
        ]),
        _vm._v(" "),
        _vm.isNoOptionsQuiz(_vm.quiz.options)
          ? _c("div", { staticClass: "no-options-wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _c(
              "div",
              { staticClass: "options-wrapper" },
              _vm._l(_vm.quiz.options, function(option, index) {
                return _c("div", { key: index, staticClass: "option" }, [
                  _vm._v("\n        " + _vm._s(option.value) + "\n      ")
                ])
              }),
              0
            )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-footer" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option" }, [
      _c("img", { attrs: { src: "/static/images/ic-correct.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option" }, [
      _c("img", { attrs: { src: "/static/images/ic-incorrect.svg" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e372280", esExports)
  }
}

/***/ }),

/***/ "8iHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCourseDetails_vue__ = __webpack_require__("2UVN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8a13bc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCourseDetails_vue__ = __webpack_require__("WmYt");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("JOTJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8a13bc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCourseDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8a13bc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCourseDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-courses/views/VideoCourseDetails.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8a13bc6", Component.options)
  } else {
    hotAPI.reload("data-v-d8a13bc6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8kb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-footer'
});

/***/ }),

/***/ "8zvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "ai-score-guide-modal",
      attrs: {
        id: "ai-score-guide-modal",
        centered: "",
        "hide-header": "",
        "hide-footer": ""
      }
    },
    [
      _c("div", { staticClass: "ai-score-guide-modal__main" }, [
        _c("div", { staticClass: "ai-score-guide-modal__header text-right" }, [
          _c("img", {
            staticClass: "clickable",
            attrs: {
              src: "/static/images/score-guide-close.svg",
              alt: "close modal"
            },
            on: {
              click: function($event) {
                return _vm.$refs.modal.hide()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ai-score-guide-modal__body" }, [
          _c("div", {
            staticClass: "ai-score-guide-modal__title text-center",
            domProps: {
              innerHTML: _vm._s(_vm.$t("ai_report.score_guide.title"))
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "ai-score-guide-modal__description text-center mx-auto",
            domProps: {
              innerHTML: _vm._s(_vm.$t("ai_report.score_guide.description"))
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ai-score-guide-modal__score-list text-center" },
            _vm._l(_vm.aiGradeCount, function(i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "ai-score-guide-modal__score-list-item"
                },
                [
                  _c(
                    "div",
                    { staticClass: "ai-score-guide-modal__score-label" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("ai_report.score_guide.score_label_" + i)
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ai-score-guide-modal__score-value" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("ai_report.score_guide.score_value_" + i)
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21764a7b", esExports)
  }
}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "9+yp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishedBadge_vue__ = __webpack_require__("cFWn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2344545e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedBadge_vue__ = __webpack_require__("RWNW");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishedBadge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2344545e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedBadge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/FinishedBadge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2344545e", Component.options)
  } else {
    hotAPI.reload("data-v-2344545e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "90A7":
/***/ (function(module, exports) {

module.exports = {"Play":"Pusti","Pause":"Pauza","Current Time":"Trenutno vrijeme","Duration Time":"Vrijeme trajanja","Remaining Time":"Preostalo vrijeme","Stream Type":"Način strimovanja","LIVE":"UŽIVO","Loaded":"Učitan","Progress":"Progres","Fullscreen":"Puni ekran","Non-Fullscreen":"Mali ekran","Mute":"Prigušen","Unmute":"Ne-prigušen","Playback Rate":"Stopa reprodukcije","Subtitles":"Podnaslov","subtitles off":"Podnaslov deaktiviran","Captions":"Titlovi","captions off":"Titlovi deaktivirani","Chapters":"Poglavlja","You aborted the media playback":"Isključili ste reprodukciju videa.","A network error caused the media download to fail part-way.":"Video se prestao preuzimati zbog greške na mreži.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.","No compatible source was found for this media.":"Nije nađen nijedan kompatibilan izvor ovog videa."}

/***/ }),

/***/ "95k5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  videoCourses: {},
  coreConceptVideoCourses: [],
  unitsWithCoreConcepts: []
});

/***/ }),

/***/ "99rT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9In3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass:
                  "class-manage-btn btn btn-outline-primary close-btn mr-2",
                attrs: { type: "button" },
                on: { click: _vm.openStudentManageModal }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("reports.manage_class_students")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "h5",
              {
                staticClass:
                  "action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile pb-12"
              },
              [_vm._v(_vm._s(_vm.formattedClassName))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mr-12 clickable",
                class: {
                  "class-report-menu-selected": _vm.selectedReport === 1,
                  "class-report-menu-nonselected": _vm.selectedReport !== 1
                },
                on: {
                  click: function($event) {
                    _vm.selectedReport = 1
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("reports.subject_study_status")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clickable",
                class: {
                  "class-report-menu-selected": _vm.selectedReport === 2,
                  "class-report-menu-nonselected": _vm.selectedReport !== 2
                },
                on: {
                  click: function($event) {
                    _vm.selectedReport = 2
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("reports.all_study_status")))]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-15",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row pt-3" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [_vm._v(_vm._s(_vm.$t("common.loading")))]
                  )
                ],
                1
              )
            ])
          : _c("div", [
              _vm.selectedReport === 1
                ? _c("div", [
                    _c(
                      "div",
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "select-subject-dropdown mnv-dropdown",
                            attrs: {
                              text: _vm.getTranslatedName(
                                _vm.subjectMap[_vm.selectedSubjectId]
                              )
                            }
                          },
                          _vm._l(_vm.subjectIds, function(subjectId) {
                            return _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.selectedSubjectId = parseInt(
                                      subjectId,
                                      10
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTranslatedName(
                                      _vm.subjectMap[subjectId]
                                    )
                                  )
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-outline-rectangle select-assignment-btn",
                            on: {
                              click: function($event) {
                                _vm.selectAssignmentModalIsShown = true
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("reports.select_assignments")) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-center mr-6 clickable",
                            class: {
                              "student-report-select":
                                _vm.selectedStudentReport === 1,
                              "student-report-nonselect":
                                _vm.selectedStudentReport !== 1
                            },
                            on: {
                              click: function($event) {
                                _vm.selectedStudentReport = 1
                                _vm.sortType = "number"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("reports.need_help_students")) +
                                "  "
                            ),
                            _c(
                              "span",
                              { staticClass: "typography--font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumStrTwoDigit(
                                      _vm.needHelpStudentList.length
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: " text-center clickable",
                            class: {
                              "student-report-select":
                                _vm.selectedStudentReport === 2,
                              "student-report-nonselect":
                                _vm.selectedStudentReport !== 2
                            },
                            on: {
                              click: function($event) {
                                _vm.selectedStudentReport = 2
                                _vm.sortType = "number"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("reports.all_students_report")) +
                                "  "
                            ),
                            _c(
                              "span",
                              { staticClass: "typography--font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumStrTwoDigit(
                                      _vm.studentList.length
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "report-students-info mt-27" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "report-students-info-sort typography--color-secondary"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "display-inlineblock clickable right-border",
                                    class: {
                                      "sort-active": _vm.sortType === "number"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.sortType = "number"
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("reports.sort_number")) +
                                        "  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "display-inlineblock clickable",
                                    class: {
                                      "sort-active": _vm.sortType === "score"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.sortType = "score"
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                 " +
                                        _vm._s(_vm.$t("reports.sort_rank")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 1
                              ? _c(
                                  "div",
                                  { staticClass: "report-students-info-title" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("reports.need_help_students")
                                        ) +
                                        "  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typography--font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNumStrTwoDigit(
                                              _vm.needHelpStudentList.length
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 2
                              ? _c(
                                  "div",
                                  { staticClass: "report-students-info-title" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("reports.all_students_report")
                                        ) +
                                        "  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typography--font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNumStrTwoDigit(
                                              _vm.studentList.length
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 1
                              ? _c(
                                  "div",
                                  { staticClass: "card-block row" },
                                  [
                                    _vm._l(_vm.needHelpStudentList, function(
                                      student,
                                      index
                                    ) {
                                      return _vm.viewMoreNeedHelp ||
                                        index < _vm.viewMoreLength
                                        ? _c(
                                            "Card",
                                            {
                                              staticClass:
                                                "report-students-card"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "report-students-card-header clickable",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$router.push(
                                                        "/reports/classes/" +
                                                          _vm.cls.id +
                                                          "/students/" +
                                                          student.student_id +
                                                          "?subject_id=" +
                                                          _vm.selectedSubjectId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "report-students-card-header-time":
                                                          _vm.getTotalDuration(
                                                            student.submissions
                                                          ) !== 0,
                                                        "report-students-card-header-time-disabled":
                                                          _vm.getTotalDuration(
                                                            student.submissions
                                                          ) === 0
                                                      }
                                                    },
                                                    [
                                                      _vm.getTotalDuration(
                                                        student.submissions
                                                      ) !== 0
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/images/time-icon.svg"
                                                            }
                                                          })
                                                        : _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/images/time-gray-icon.svg"
                                                            }
                                                          }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.formattedTime(
                                                              _vm.getTotalDuration(
                                                                student.submissions
                                                              )
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "student-number"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getNumStrTwoDigit(
                                                            student.number
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " \n                  "
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "student-name"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(student.name)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "report-students-card-body clickable"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            "/reports/classes/" +
                                                              _vm.cls.id +
                                                              "/students/" +
                                                              student.student_id +
                                                              "?subject_id=" +
                                                              _vm.selectedSubjectId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "report-students-card-body-titles"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "reports.table.score"
                                                                )
                                                              )
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.rank"
                                                                )
                                                              )
                                                          ),
                                                          _c("br"),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "reports.table.complete_rate"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "report-students-card-body-contents"
                                                        },
                                                        [
                                                          _vm.getSubmissionSubjectScore(
                                                            student.submissions,
                                                            _vm.selectedSubjectId
                                                          ) === null
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "typography--font-weight-bold rank-left"
                                                                },
                                                                [_vm._v("-")]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "typography--font-weight-bold rank-left"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getSubmissionSubjectScore(
                                                                        student.submissions,
                                                                        _vm.selectedSubjectId
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [
                                                              _vm.classSubjectScoreRanks.indexOf(
                                                                _vm.getSubmissionSubjectScore(
                                                                  student.submissions,
                                                                  _vm.selectedSubjectId
                                                                )
                                                              ) >= 0
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.classSubjectScoreRanks.indexOf(
                                                                            _vm.getSubmissionSubjectScore(
                                                                              student.submissions,
                                                                              _vm.selectedSubjectId
                                                                            )
                                                                          ) + 1
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "reports.rank_suffix"
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v("-")
                                                                  ])
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " |   " +
                                                              _vm._s(
                                                                _vm.studentList
                                                                  .length
                                                              )
                                                          ),
                                                          _c("br"),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getCompleteRateSubject(
                                                                    student.submissions,
                                                                    _vm.selectedSubjectId
                                                                  ) || 0
                                                                ) + "%"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-students-card-footer clickable",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.studentToRecommend = student
                                                          _vm.openRecommendContentModal()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.go_to_recommend_contents"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                    _vm._v(" "),
                                    _vm.needHelpStudentList.length === 0
                                      ? _c(
                                          "Card",
                                          {
                                            staticClass:
                                              "report-students-no-card"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row no-need-help-container"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/static/images/friends-img.png"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "no-need-help-text"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "no-need-help-text1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.no_need_help_students"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "no-need-help-text2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.students_well_following"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 1 &&
                            _vm.needHelpStudentList.length > _vm.viewMoreLength
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "view-more-container text-center",
                                    on: {
                                      click: function($event) {
                                        _vm.viewMoreNeedHelp = !_vm.viewMoreNeedHelp
                                      }
                                    }
                                  },
                                  [
                                    !_vm.viewMoreNeedHelp
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_more"))
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_less"))
                                          )
                                        ]),
                                    _vm._v(
                                      "\n                \n              "
                                    ),
                                    !_vm.viewMoreNeedHelp
                                      ? _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-down.svg"
                                          }
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-up.svg"
                                          }
                                        })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 2
                              ? _c(
                                  "div",
                                  { staticClass: "card-block row" },
                                  _vm._l(_vm.sortedStudentList, function(
                                    student,
                                    index
                                  ) {
                                    return _vm.viewMoreTotalStudents ||
                                      index < _vm.viewMoreLength
                                      ? _c(
                                          "Card",
                                          {
                                            staticClass: "report-students-card"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "report-students-card-header clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$router.push(
                                                      "/reports/classes/" +
                                                        _vm.cls.id +
                                                        "/students/" +
                                                        student.student_id +
                                                        "?subject_id=" +
                                                        _vm.selectedSubjectId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    class: {
                                                      "report-students-card-header-time":
                                                        _vm.getTotalDuration(
                                                          student.submissions
                                                        ) !== 0,
                                                      "report-students-card-header-time-disabled":
                                                        _vm.getTotalDuration(
                                                          student.submissions
                                                        ) === 0
                                                    }
                                                  },
                                                  [
                                                    _vm.getTotalDuration(
                                                      student.submissions
                                                    ) !== 0
                                                      ? _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/images/time-icon.svg"
                                                          }
                                                        })
                                                      : _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/images/time-gray-icon.svg"
                                                          }
                                                        }),
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedTime(
                                                            _vm.getTotalDuration(
                                                              student.submissions
                                                            )
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "student-number"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumStrTwoDigit(
                                                          student.number
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" \n                  "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "student-name"
                                                  },
                                                  [_vm._v(_vm._s(student.name))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "report-students-card-body clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$router.push(
                                                      "/reports/classes/" +
                                                        _vm.cls.id +
                                                        "/students/" +
                                                        student.student_id +
                                                        "?subject_id=" +
                                                        _vm.selectedSubjectId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-students-card-body-titles"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.table.score"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.rank"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.table.complete_rate"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-students-card-body-contents"
                                                    },
                                                    [
                                                      _vm.getSubmissionSubjectScore(
                                                        student.submissions,
                                                        _vm.selectedSubjectId
                                                      ) === null
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [_vm._v("-")]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getSubmissionSubjectScore(
                                                                    student.submissions,
                                                                    _vm.selectedSubjectId
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typography--font-weight-bold rank-left"
                                                        },
                                                        [
                                                          _vm.classSubjectScoreRanks.indexOf(
                                                            _vm.getSubmissionSubjectScore(
                                                              student.submissions,
                                                              _vm.selectedSubjectId
                                                            )
                                                          ) >= 0
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.classSubjectScoreRanks.indexOf(
                                                                        _vm.getSubmissionSubjectScore(
                                                                          student.submissions,
                                                                          _vm.selectedSubjectId
                                                                        )
                                                                      ) + 1
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "reports.rank_suffix"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v("-")
                                                              ])
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " |   " +
                                                          _vm._s(
                                                            _vm.studentList
                                                              .length
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typography--font-weight-bold rank-left"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getCompleteRateSubject(
                                                                student.submissions,
                                                                _vm.selectedSubjectId
                                                              ) || 0
                                                            ) + "%"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 2 &&
                            _vm.studentList.length > _vm.viewMoreLength
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "view-more-container text-center",
                                    on: {
                                      click: function($event) {
                                        _vm.viewMoreTotalStudents = !_vm.viewMoreTotalStudents
                                      }
                                    }
                                  },
                                  [
                                    !_vm.viewMoreTotalStudents
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_more"))
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_less"))
                                          )
                                        ]),
                                    _vm._v(
                                      "\n                \n              "
                                    ),
                                    !_vm.viewMoreTotalStudents
                                      ? _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-down.svg"
                                          }
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-up.svg"
                                          }
                                        })
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "card-row mb-12" }, [
                            _c(
                              "div",
                              { staticClass: "row ml-0 mr-0" },
                              [
                                _c(
                                  "Card",
                                  {
                                    staticClass: "graph-summary-stat-container"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row pl-10 graph-header" },
                                      [
                                        _vm.selectedGraph === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "graph-summary-stat"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "reports.all_students_count"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "total-students-number"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.studentList.length
                                                      ) +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.modal.preview.count"
                                                          )
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.selectedGraph === 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "graph-summary-stat"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "avg-score" },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.average_score"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-narrow"
                                                      },
                                                      [
                                                        _vm.diffAvgScore > 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore === 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore < 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "avg-score-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentAvgScore
                                                          ) + "점"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-wide"
                                                      },
                                                      [
                                                        _vm.diffAvgScore > 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore === 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore < 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "diff-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getNumStrTwoDigit(
                                                              Math.abs(
                                                                _vm.diffAvgScore
                                                              )
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("br")
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "avg-submit-rate"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.submit_assignment"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-narrow"
                                                      },
                                                      [
                                                        _vm.diffSubmissionRate >
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate ===
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate <
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "avg-submit-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentSubmissionRate ||
                                                              0
                                                          ) + "%"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-wide"
                                                      },
                                                      [
                                                        _vm.diffSubmissionRate >
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate ===
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate <
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "diff-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getNumStrTwoDigit(
                                                              Math.abs(
                                                                _vm.diffSubmissionRate ||
                                                                  0
                                                              )
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-selectgraph clickable",
                                            class: {
                                              "btn-rectangle-primary":
                                                _vm.selectedGraph === 1,
                                              "typography--color-secondary":
                                                _vm.selectedGraph !== 1,
                                              "btn-outline-rectangle-disabled":
                                                _vm.selectedGraph !== 1
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.selectedGraph = 1
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("reports.achievement")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-selectgraph clickable",
                                            class: {
                                              "btn-rectangle-primary":
                                                _vm.selectedGraph === 2,
                                              "typography--color-secondary":
                                                _vm.selectedGraph !== 2,
                                              "btn-outline-rectangle-disabled":
                                                _vm.selectedGraph !== 2
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.selectedGraph = 2
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "reports.achievement_trend"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedGraph === 1
                                      ? _c("BarChart", {
                                          attrs: {
                                            height: 150,
                                            chartData:
                                              _vm.achievementDistribution,
                                            totalStudents:
                                              _vm.studentList.length
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedGraph === 2
                                      ? _c("LineChart", {
                                          attrs: {
                                            height: 150,
                                            chartData: _vm.trendData
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("Card", { staticClass: "study-state" }, [
                                  _c(
                                    "div",
                                    { staticClass: "study-state-title" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("reports.study_status"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "study-state-time" },
                                    [
                                      _c("DoughnutChart", {
                                        attrs: {
                                          chartData: _vm.activeStudentData
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "study-state-time-text1 text-center"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "bold-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.floor(
                                                      _vm.getAverageDuration(
                                                        _vm.getSubmissionsThisWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) / 3600
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("h\n                      "),
                                          _c(
                                            "span",
                                            { staticClass: "bold-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.ceil(
                                                      (_vm.getAverageDuration(
                                                        _vm.getSubmissionsThisWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) /
                                                        60) %
                                                        60
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("m\n                    ")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "study-state-time-text2 text-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "reports.last_week_avg_time"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typography--font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.floor(
                                                      _vm.getAverageDuration(
                                                        _vm.getSubmissionsUntilLastWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) / 3600
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("h\n                      "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typography--font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.ceil(
                                                      (_vm.getAverageDuration(
                                                        _vm.getSubmissionsUntilLastWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) /
                                                        60) %
                                                        60
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("m\n                    ")
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "ws-nowrap pb-6 font-14" },
                                    [
                                      _c("div", {
                                        staticClass: "active-legend"
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("reports.active_students")
                                        ) + "   "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "bold-number" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                _vm.getActiveStudents()
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c("br")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "ws-nowrap font-14" },
                                    [
                                      _c("div", {
                                        staticClass: "inactive-legend"
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("reports.inactive_students")
                                        ) + "   "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "bold-number" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                _vm.studentList.length -
                                                  _vm.getActiveStudents()
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                : _c("div", [
                    _c("div", { staticClass: "class-report-allsubs" }, [
                      _c("table", { staticClass: "mw-960" }, [
                        _c("tbody", [
                          _c(
                            "tr",
                            [
                              _c("td"),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c(
                                  "th",
                                  {
                                    staticClass: "clickable",
                                    on: {
                                      click: function($event) {
                                        _vm.selectedSubjectId = subjectId
                                        _vm.selectedReport = 1
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTranslatedName(
                                          _vm.subjectMap[subjectId]
                                        )
                                      )
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(_vm._s(_vm.$t("reports.avg_score")))
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typography--font-weight-bold",
                                      class: {
                                        "color-00c896":
                                          _vm.diffScoreBySubjects[subjectId] >
                                          0,
                                        "color-f97e76":
                                          _vm.diffScoreBySubjects[subjectId] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.averageScoreBySubjects[
                                              subjectId
                                            ]
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-12",
                                      class: {
                                        "diff-up":
                                          _vm.diffScoreBySubjects[subjectId] >
                                          0,
                                        "diff-neutral":
                                          _vm.diffScoreBySubjects[subjectId] ===
                                          0,
                                        "diff-down":
                                          _vm.diffScoreBySubjects[subjectId] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formattedDiff(
                                              _vm.diffScoreBySubjects[subjectId]
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.$t("reports.average_duration"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c("td", [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "time-up":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] > 0,
                                        "time-down":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "typography--font-weight-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                Math.floor(
                                                  _vm.averageDurationBySubjects[
                                                    subjectId
                                                  ] / 3600
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v("h\n                  "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "typography--font-weight-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                Math.ceil(
                                                  (_vm
                                                    .averageDurationBySubjects[
                                                    subjectId
                                                  ] /
                                                    60) %
                                                    60
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v("m\n                ")
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.diffDurationBySubjects[subjectId] < 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            "/static/images/red-time-icon.svg"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.diffDurationBySubjects[subjectId] === 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            "/static/images/non-time-icon.svg"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.diffDurationBySubjects[subjectId] > 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            "/static/images/grn-time-icon.svg"
                                        }
                                      })
                                    : _vm._e(),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-12",
                                      class: {
                                        "color-00c896":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] > 0,
                                        "color-f97e76":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formattedTime(
                                              _vm.diffDurationBySubjects[
                                                subjectId
                                              ]
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(_vm._s(_vm.$t("reports.complete_rate")))
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typography--font-weight-bold",
                                      class: {
                                        "color-00c896":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] > 0,
                                        "color-f97e76":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.averageSubmitrateBySubjects[
                                              subjectId
                                            ]
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-12",
                                      class: {
                                        "diff-up":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] > 0,
                                        "diff-neutral":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] === 0,
                                        "diff-down":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formattedDiff(
                                              _vm.diffSubmitrateBySubjects[
                                                subjectId
                                              ]
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _c("br"),
                    _c("br"),
                    _c("br"),
                    _c("br")
                  ])
            ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal student-manage-modal",
            attrs: {
              id: "student-manage-modal",
              title: _vm.$t("reports.manage_students")
            }
          },
          [
            _c(
              "div",
              { staticClass: "student-manage-table-container scroll-box" },
              [
                _c("table", { staticClass: "table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th"),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "typography--body-3 typography--color-secondary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("reports.table.number")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "typography--body-3 typography--color-secondary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("reports.table.name")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "typography--body-3 typography--color-secondary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("reports.table.gender")) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.managingStudentList, function(student, index) {
                      return _c("tr", { key: student.student_id }, [
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-secondary"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mdc-form-field" },
                              [
                                _c("Checkbox", {
                                  attrs: {
                                    "model-value": _vm.checkedStudents,
                                    "check-value": student,
                                    id: "student-checkbox-" + student.student_id
                                  },
                                  on: { change: _vm.selectStudent }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-primary"
                          },
                          [_vm._v(_vm._s(index + 1))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-primary"
                          },
                          [_vm._v(_vm._s(student.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-secondary"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mdc-form-field" },
                              [
                                _c(
                                  "Radio",
                                  {
                                    attrs: {
                                      "model-value": student.gender,
                                      "check-value": 1,
                                      id: "male-student"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectStudentGender(
                                          student,
                                          1
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("reports.gender.1"))
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "Radio",
                                  {
                                    attrs: {
                                      "model-value": student.gender,
                                      "check-value": 2,
                                      id: "female-student"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectStudentGender(
                                          student,
                                          2
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("reports.gender.2"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-100",
                attrs: { slot: "modal-footer" },
                slot: "modal-footer"
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "float-left btn btn-outline-primary btn-fab btn-mini-fab mr-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.moveStudentNumber("up")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("keyboard_arrow_up")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "float-left btn btn-outline-primary btn-fab btn-mini-fab",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.moveStudentNumber("down")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("keyboard_arrow_down")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary float-right close-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.updateStudents }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.save")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary float-right close-btn mr-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "hide::modal",
                          "student-manage-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.cancel")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal",
            attrs: {
              id: "recommend-content-modal",
              title:
                this.$t("reports.go_to_recommend_contents") +
                " | " +
                _vm.getTranslatedName(_vm.subjectMap[_vm.selectedSubjectId])
            }
          },
          [
            _c("div", { staticClass: "recommend-content-container" }, [
              _c("div", { staticClass: "recommend-content-studentname" }, [
                _c("div", { staticClass: "recommend-content-header-time" }, [
                  _vm.getTotalDuration(_vm.studentToRecommend.submissions) !== 0
                    ? _c("img", {
                        attrs: { src: "/static/images/time-icon.svg" }
                      })
                    : _c("img", {
                        attrs: { src: "/static/images/time-gray-icon.svg" }
                      }),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.formattedTime(
                          _vm.getTotalDuration(
                            _vm.studentToRecommend.submissions
                          )
                        )
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "typography--font-weight-bold typography--color-secondary"
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getNumStrTwoDigit(_vm.studentToRecommend.number)
                        ) +
                        "   " +
                        _vm._s(_vm.studentToRecommend.name)
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "recommend-content-studentinfo" }, [
                _c("div", { staticClass: "recommend-content-item-left" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("reports.table.score")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommend-content-item-right color-000000" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getSubmissionSubjectScore(
                            _vm.studentToRecommend.submissions,
                            _vm.selectedSubjectId
                          )
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "recommend-content-item-left" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.rank")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommend-content-item-right color-000000" },
                  [
                    _vm.classSubjectScoreRanks.indexOf(
                      _vm.getSubmissionSubjectScore(
                        _vm.studentToRecommend.submissions,
                        _vm.selectedSubjectId
                      )
                    ) >= 0
                      ? _c(
                          "span",
                          { staticClass: "typography--font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.classSubjectScoreRanks.indexOf(
                                    _vm.getSubmissionSubjectScore(
                                      _vm.studentToRecommend.submissions,
                                      _vm.selectedSubjectId
                                    )
                                  ) + 1
                                ) +
                                _vm._s(_vm.$t("reports.rank_suffix")) +
                                "\n            "
                            )
                          ]
                        )
                      : _c(
                          "span",
                          { staticClass: "typography--font-weight-bold" },
                          [
                            _vm._v(
                              _vm._s(_vm.classSubjectScoreRanks.length + 1) +
                                _vm._s(_vm.$t("reports.rank_suffix"))
                            )
                          ]
                        ),
                    _vm._v(
                      " / " + _vm._s(_vm.studentList.length) + "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommend-content-item-left text-right" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("reports.table.complete_rate")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "recommend-content-item-right typography--font-weight-bold color-000000 text-right"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getCompleteRateSubject(
                            _vm.studentToRecommend.submissions,
                            _vm.selectedSubjectId
                          )
                        ) +
                        "%\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.getRecommendUnits(_vm.studentToRecommend).length === 0
                ? _c("div", { staticClass: "text-center pt-30 pb-20" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("reports.no_recommend_chapters")) +
                        "\n        "
                    )
                  ])
                : _c(
                    "div",
                    _vm._l(
                      _vm.getRecommendUnits(_vm.studentToRecommend),
                      function(unitId) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.units[unitId],
                                expression: "units[unitId]"
                              }
                            ],
                            key: unitId,
                            staticClass: "recommend-content-chapter clickable",
                            on: {
                              click: function($event) {
                                return _vm.goToLibrary(
                                  _vm.selectedSubjectId,
                                  _vm.cls,
                                  unitId
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "recommend-content-chapter-score"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("reports.table.score")) +
                                    "  \n              "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typography--font-weight-bold recommend-content-chapter-score-number"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getAverageScore(
                                            _vm.getSubmissionsOfUnit(
                                              _vm.studentToRecommend
                                                .submissions,
                                              unitId
                                            )
                                          ) || 0
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getUnitLabel(_vm.units[unitId])) +
                                "\n          "
                            )
                          ]
                        )
                      }
                    ),
                    0
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-100",
                attrs: { slot: "modal-footer" },
                slot: "modal-footer"
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary float-right close-btn mr-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "hide::modal",
                          "recommend-content-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.close")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm.selectAssignmentModalIsShown
          ? _c("SelectAssignmentModal", {
              attrs: {
                "assignment-list":
                  _vm.assignmentsBySubjects[_vm.selectedSubjectId],
                "pre-selected-list": _vm.selectedAssignmentList,
                "has-selected-all-assignments": _vm.hasSelectedAllAssignments
              },
              on: {
                cancel: function($event) {
                  _vm.selectAssignmentModalIsShown = false
                },
                "assignments-selected": _vm.onAssignmentsSelected
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc86192a", esExports)
  }
}

/***/ }),

/***/ "9ItA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "up-down-arrow", class: _vm.upDownClass }, [
    _c("img", { attrs: { src: _vm.arrowSrc } }),
    _vm._v("\n  " + _vm._s(_vm.absValue) + _vm._s(_vm.unit) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e6e7a8", esExports)
  }
}

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9XSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("main", { attrs: { id: "app" } }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c1e3f0c", esExports)
  }
}

/***/ }),

/***/ "9c1F":
/***/ (function(module, exports) {

module.exports = {"Play":"재생","Pause":"일시중지","Current Time":"현재 시간","Duration Time":"지정 기간","Remaining Time":"남은 시간","Stream Type":"스트리밍 유형","LIVE":"라이브","Loaded":"로드됨","Progress":"진행","Fullscreen":"전체 화면","Non-Fullscreen":"전체 화면 해제","Mute":"음소거","Unmute":"음소거 해제","Playback Rate":"재생 비율","Subtitles":"서브타이틀","subtitles off":"서브타이틀 끄기","Captions":"자막","captions off":"자막 끄기","Chapters":"챕터","You aborted the media playback":"비디오 재생을 취소했습니다.","A network error caused the media download to fail part-way.":"네트워크 오류로 인하여 비디오 일부를 다운로드하지 못 했습니다.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"비디오를 로드할 수 없습니다. 서버 혹은 네트워크 오류 때문이거나 지원되지 않는 형식 때문일 수 있습니다.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"비디오 재생이 취소됐습니다. 비디오가 손상되었거나 비디오가 사용하는 기능을 브라우저에서 지원하지 않는 것 같습니다.","No compatible source was found for this media.":"비디오에 호환되지 않는 소스가 있습니다."}

/***/ }),

/***/ "9h+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function numberToTime() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.0;

  var minutes = parseInt(number / 60, 10);
  var seconds = parseInt(number % 60, 10);
  function pad2(val) {
    return (val < 10 ? '0' : '') + val;
  }

  return pad2(minutes) + ':' + pad2(seconds);
}

/* harmony default export */ __webpack_exports__["a"] = (numberToTime);

/***/ }),

/***/ "9ok5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__("u4Bf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MyPageSummary__ = __webpack_require__("GDs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageAddBlock__ = __webpack_require__("d67z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PageEditorModal__ = __webpack_require__("1W3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AddVideoModal__ = __webpack_require__("SVVP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MathEditorModal__ = __webpack_require__("GW0y");















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-my-card',

  components: {
    PageEditorModal: __WEBPACK_IMPORTED_MODULE_9__components_PageEditorModal__["a" /* default */],
    MathEditorModal: __WEBPACK_IMPORTED_MODULE_11__components_MathEditorModal__["a" /* default */],
    MyPageSummary: __WEBPACK_IMPORTED_MODULE_7__components_MyPageSummary__["a" /* default */],
    AddVideoModal: __WEBPACK_IMPORTED_MODULE_10__components_AddVideoModal__["a" /* default */],
    PageAddBlock: __WEBPACK_IMPORTED_MODULE_8__components_PageAddBlock__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      showNonQuizEditorModal: false,

      showMultipleChoiceEditorModal: false,

      showTextEntryEditorModal: false,

      showEssayTypeEditorModal: false,

      showEditPageModal: false,

      busy: false,

      hasError: false,

      pageIndexToDelete: null,

      currentEditingPage: null,

      acceptableFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],

      fileSizeLimit: 10 * 1024 * 1024,

      initialCardState: {
        title: '',
        goal: null,
        pages: [],
        subject_id: undefined,
        grade_id: undefined,
        unit_id: undefined,
        chapter_position: undefined,
        chapter_name: undefined,
        core_concept_id: undefined,
        cover_image: null,
        cover_image_file: null
      },

      card: {
        title: '',
        goal: null,
        pages: [],
        subject_id: undefined,
        grade_id: undefined,
        unit_id: undefined,
        chapter_position: undefined,
        chapter_name: undefined,
        core_concept_id: undefined,
        cover_image: null,
        cover_image_file: null
      },

      selected: {
        title: '',
        goal: '',
        subject_id: '9999',
        grade_id: '9999',
        unit_id: '9999',
        chapter_position: '9999',
        core_concept_id: '9999'
      },

      destination: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['activeEditorLocation', 'currentPublisherInfo', 'isPublisherUser', 'coreConceptList', 'activeEditorId', 'coreConcepts', 'currentUser', 'subjectMap', 'subjectIds', 'gradeMap', 'unitList', 'units', 'gradeSubjects', 'gradeList']), {
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.selected.subject_id + '&' + this.selected.grade_id;
    },
    currentUnitList: function currentUnitList() {
      var _this = this;

      return this.unitList.filter(function (unit) {
        return unit.subject_id === parseInt(_this.selected.subject_id, 10) && unit.name !== 'NO NAME YET';
      });
    },
    currentCoreConceptList: function currentCoreConceptList() {
      var _this2 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(this.coreConceptList.filter(function (coreConcept) {
        return coreConcept.subject_id === parseInt(_this2.selected.subject_id, 10) && coreConcept.grade_id === parseInt(_this2.selected.grade_id, 10);
      }), 'chapter_position', 'asc');
    },
    cardAuthorName: function cardAuthorName() {
      if (this.card) {
        return this.card.author_name;
      }

      return '';
    },
    styleBindings: function styleBindings() {
      if (this.card && this.card.cover_image) {
        return {
          'background-image': 'url(\'' + this.card.cover_image + '\')'
        };
      }

      return {};
    },
    saveDisabled: function saveDisabled() {
      return this.card.pages.length === 0 || this.hasError;
    }
  }),

  watch: {
    gradeSubjects: function gradeSubjects(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(state)) {
        document.getElementById('subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('subject-dropdown').firstElementChild.disabled = false;
      }
    },
    currentCoreConceptList: function currentCoreConceptList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(state)) {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(state);
    },
    currentUnitList: function currentUnitList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(state)) {
        document.getElementById('unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('unit-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(state);
    },
    selectedSubjectGrade: function selectedSubjectGrade(state) {
      if (state.match(/^[0-9]+&9999$/) || state.match(/^9999&[0-9]+$/)) {
        return null;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(state.match(/[0-9]+&[0-9]+/))) {

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.fetchUnits({
          subject_id: this.selected.subject_id,
          grade_id: this.selected.grade_id
        }), this.fetchCoreConcepts({
          subject_id: this.selected.subject_id,
          grade_id: this.selected.grade_id
        })]);
      }

      return null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'uploadNewCardCoverImage', 'uploadNewCardPageImage', 'uploadNewCardPageAudio', 'setSelectedPreviewCard', 'setPageLibraryFilter', 'createNewMyCardPage', 'fetchCoreConcepts', 'updateMyCardPages', 'createNewMyCard', 'updateMyPage', 'fetchUnits', 'fetchGradeSubjects', 'resetGradeSubjects']), {
    onPageAdded: function onPageAdded(newQuizPage) {
      var newPageClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(newQuizPage);

      if (this.pageIndexToDelete !== null) {
        this.card.pages.splice(this.pageIndexToDelete, 1, newPageClone);
        this.currentEditingPage = null;
        this.pageIndexToDelete = null;
      } else {
        newPageClone.position = this.card.pages.length + 1;
        this.card.pages.push(newPageClone);
      }

      this.showMultipleChoiceEditorModal = false;
      this.showTextEntryEditorModal = false;
      this.showEssayTypeEditorModal = false;
      this.showNonQuizEditorModal = false;
      this.showEditPageModal = false;
    },
    addVideo: function addVideo(embed) {
      var content = '';
      if (embed.is_iframe) {
        content = '<p><iframe src="' + embed.src + '" width="640" height="360" frameborder="0" scrolling="no" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></p><p></p>';
      } else {
        content = '<p>\uB3D9\uC601\uC0C1 \uB9C1\uD06C</p><br>' + embed.src + '<p></p>';
      }

      if (this.activeEditorId) {
        var editor = tinymce.get(this.activeEditorId);

        if (this.activeEditorLocation) {
          editor.selection.setRng(this.activeEditorLocation);
        }

        return editor.insertContent(content);
      }

      return tinymce.activeEditor.insertContent(content);
    },
    addMath: function addMath(latex) {
      if (latex.length > 0) {
        var replacedLatex = latex.replace(/overarc/g, 'overparen');
        var mathInlineId = Math.floor(Math.random() * 1000);
        var content = '&nbsp;<span id="math-inline-' + mathInlineId + '" contenteditable="false">\\(' + replacedLatex + '\\)</span>&nbsp;';
        var activeEditor = void 0;

        if (this.activeEditorId) {
          activeEditor = tinymce.get(this.activeEditorId);

          if (this.activeEditorLocation) {
            activeEditor.selection.setRng(this.activeEditorLocation);
          }
        } else {
          activeEditor = tinymce.activeEditor;
        }

        activeEditor.insertContent(content);

        setTimeout(function () {
          MathJax.Hub.Queue(['Typeset', MathJax.Hub, 'math-inline-' + mathInlineId]);

          activeEditor.insertContent('');
        }, 200);
      }
    },
    pageLeaveOk: function pageLeaveOk() {
      this.$router.push(this.destination.path);
    },
    pageLeaveCancel: function pageLeaveCancel() {
      this.destination = null;
    },
    onCoverImageChange: function onCoverImageChange(event) {
      var images = event.target.files || event.dataTransfer.files;

      if (!images.length) {
        return null;
      }

      var file = images[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (file.size > this.fileSizeLimit) {
        return this.$root.$emit('show::modal', 'file-size-alert');
      }

      if (this.acceptableFileTypes.indexOf(file.type) === -1) {
        return this.$root.$emit('show::modal', 'file-type-alert');
      }

      return this.createMedia(file, 'image');
    },
    createMedia: function createMedia(file) {
      var _this3 = this;

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function (event) {
        _this3.card.cover_image = event.target.result;
        _this3.card.cover_image_file = file;
      };

      return reader.readAsDataURL(file);
    },
    selectSubject: function selectSubject(subjectId) {
      if (this.selected.subject_id !== subjectId) {
        this.selected.subject_id = subjectId;
        this.selected.core_concept_id = '9999';
        this.selected.unit_id = '9999';
      }
    },
    selectGrade: function selectGrade(gradeId, schoolYear) {
      if (this.selected.grade_id !== gradeId) {
        this.selected.grade_id = gradeId;
        this.selected.core_concept_id = '9999';
        this.selected.unit_id = '9999';
        this.selected.subject_id = '9999';
        this.fetchGradeSubjects({ grade: schoolYear });
      }
    },
    selectUnit: function selectUnit(unitId) {
      if (this.selected.unit_id !== unitId) {
        this.selected.unit_id = unitId;

        var unit = this.units[unitId];

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(unit) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(unit.core_concept_id)) {
          this.selected.core_concept_id = unit.core_concept_id;
        }
      }
    },
    selectCoreConcept: function selectCoreConcept(coreConceptId) {
      if (this.selected.core_concept_id !== coreConceptId) {
        this.selected.core_concept_id = coreConceptId;
      }
    },
    applySelectedCardInfo: function applySelectedCardInfo() {
      this.card.title = this.selected.title;
      this.card.goal = this.selected.goal || null;

      if (this.selected.subject_id !== '9999') {
        this.card.subject_id = this.selected.subject_id;
      } else {
        this.card.subject_id = undefined;
      }

      this.setPageLibraryFilter({ property: 'subject_id', value: this.card.subject_id || '0' });

      if (this.selected.grade_id !== '9999') {
        this.card.grade_id = this.selected.grade_id;
      } else {
        this.card.grade_id = undefined;
      }

      this.setPageLibraryFilter({ property: 'grade_id', value: this.card.grade_id || '0' });

      if (this.selected.unit_id !== '9999') {
        this.card.unit_id = this.selected.unit_id;

        var unit = this.units[this.card.unit_id];

        this.card.chapter_position = unit ? unit.position : undefined;
        this.card.chapter_name = unit ? unit.name : undefined;
      } else {
        this.card.chapter_position = undefined;
        this.card.chapter_name = undefined;
        this.card.unit_id = undefined;
      }

      if (this.selected.core_concept_id !== '9999') {
        this.card.core_concept_id = this.selected.core_concept_id;
      } else {
        this.card.core_concept_id = undefined;
      }

      if (this.card.unit_id) {
        this.setPageLibraryFilter({ property: 'unit_id', value: this.card.unit_id || '0' });
      } else {
        this.setPageLibraryFilter({ property: 'core_concept_id', value: this.card.core_concept_id || '0' });
      }
    },
    setupEditCardModal: function setupEditCardModal() {
      if (this.card.title) {
        this.selected.title = this.card.title;
      } else {
        this.selected.title = '';
      }

      if (this.card.goal) {
        this.selected.goal = this.card.goal;
      } else {
        this.selected.goal = '';
      }

      if (this.card.subject_id) {
        this.selected.subject_id = this.card.subject_id;
      } else {
        this.selected.subject_id = '9999';
      }

      if (this.card.grade_id !== undefined) {
        this.selected.grade_id = this.card.grade_id;
      } else {
        this.selected.grade_id = '9999';
      }

      if (this.card.unit_id) {
        this.selected.unit_id = this.card.unit_id;
      } else {
        this.selected.unit_id = '9999';
      }

      if (this.card.core_concept_id) {
        this.selected.core_concept_id = this.card.core_concept_id;
      } else {
        this.selected.core_concept_id = '9999';
      }
    },
    importPages: function importPages(pageList) {
      var _card$pages;

      (_card$pages = this.card.pages).push.apply(_card$pages, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(pageList));
    },
    removePage: function removePage() {
      if (this.pageIndexToDelete !== null) {
        this.card.pages.splice(this.pageIndexToDelete, 1);
        this.pageIndexToDelete = null;
      }
    },
    cancelRemovePage: function cancelRemovePage() {
      this.pageIndexToDelete = null;
    },
    openRemovePageModal: function openRemovePageModal(pageIndex) {
      this.pageIndexToDelete = pageIndex;

      this.$root.$emit('show::modal', 'delete-my-card-page-modal');
    },
    openPageEditorModal: function openPageEditorModal(pageIndex) {
      this.currentEditingPage = this.card.pages[pageIndex];
      this.pageIndexToDelete = pageIndex;

      this.showEditPageModal = true;
    },
    cancelPageEdit: function cancelPageEdit() {
      this.showEditPageModal = false;
      this.currentEditingPage = null;
      this.pageIndexToDelete = null;
    },
    applyCardTitle: function applyCardTitle(inputText) {
      this.card.title = inputText;
    },
    onHasError: function onHasError(hasError) {
      this.hasError = hasError;
    },
    deleteCard: function deleteCard() {
      this.$router.push('/my-cards');
    },
    openCardPreview: function openCardPreview() {
      var _this4 = this;

      var cardClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(this.card);

      this.setSelectedPreviewCard(cardClone).then(function () {
        return _this4.setSelectedPreviewPageIndex(0);
      }).then(function () {
        _this4.$root.$emit('show::modal', 'card-preview-modal');
      });
    },
    getLearningElements: function getLearningElements(coreConcept) {
      if (!coreConcept) {
        return null;
      }

      return coreConcept.description;
    },
    saveMyCard: function saveMyCard() {
      var _this5 = this;

      if (!this.busy) {
        this.busy = true;

        var imageCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sum"])(this.card.pages.map(function (page) {
          return page.image_count || 0;
        }));
        var audioCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sum"])(this.card.pages.map(function (page) {
          return page.audio_count || 0;
        }));
        var videoCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sum"])(this.card.pages.map(function (page) {
          return page.video_count || 0;
        }));

        var newCardInfo = {
          title: this.card.title || '제목없음',
          goal: this.card.goal,
          subject_id: this.card.subject_id,
          grade_id: this.card.grade_id,
          unit_id: this.card.unit_id,
          chapter_position: this.card.chapter_position,
          chapter_name: this.card.chapter_name,
          core_concept_id: this.card.core_concept_id,
          author_id: this.currentUser.id,
          author_name: this.currentUser.name,
          publisher_id: this.currentPublisherInfo.id,
          publisher_name: this.currentPublisherInfo.name,
          share_level: 2,
          page_count: this.card.pages.length,
          quiz_count: this.card.pages.filter(function (page) {
            return !!page.is_quiz;
          }).length,
          image_count: imageCount,
          audio_count: audioCount,
          video_count: videoCount,
          is_autograde: true,
          language: 'KR',
          school_id: this.currentUser.school_id
        };

        this.createNewMyCard(newCardInfo).then(function (newCard) {
          if (!_this5.card.cover_image_file) {
            return newCard;
          }

          var coverImageInfo = {
            cardId: newCard.id,
            imageFile: _this5.card.cover_image_file
          };

          return _this5.uploadNewCardCoverImage(coverImageInfo).then(function () {
            return newCard;
          });
        }).then(function (newCard) {
          if (_this5.card.pages.length === 0) {
            return newCard;
          }

          var pageUpdateList = _this5.card.pages.map(function (page, i) {
            if (page.id) {
              return {
                type: 'new',
                store_page_id: page.id,
                position: i + 1
              };
            }

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, page, {

              type: 'created',
              position: i + 1
            });
          });
          var createdPageList = pageUpdateList.filter(function (page) {
            return page.type === 'created';
          });

          var pageUpdateInfo = {
            cardId: newCard.id,
            pageUpdateList: pageUpdateList.filter(function (page) {
              return page.type === 'new';
            })
          };

          if (pageUpdateInfo.pageUpdateList.length > 0) {
            return _this5.updateMyCardPages(pageUpdateInfo).then(function () {
              return { newCard: newCard, createdPageList: createdPageList };
            });
          }

          return { newCard: newCard, createdPageList: createdPageList };
        }).then(function (_ref) {
          var newCard = _ref.newCard,
              createdPageList = _ref.createdPageList;

          var createPagePromises = createdPageList.map(function (page) {
            return _this5.createNewMyCardPage({ cardId: newCard.id, page: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, page, { images: [] }) }).then(function (newPage) {
              var updateInfo = {
                content: newPage.content,
                description: newPage.description || ''
              };

              var uploadImgPromises = page.images.map(function (image) {
                return _this5.uploadNewCardPageImage({ pageId: newPage.id, imageFile: image.image_file }).then(function (newImage) {
                  if (updateInfo.content.indexOf('data-image-id="' + image.key + '"') !== -1) {
                    updateInfo.content = updateInfo.content.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
                  }

                  if (updateInfo.description.indexOf('data-image-id="' + image.key + '"') !== -1) {
                    updateInfo.description = updateInfo.description.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
                  }
                });
              });

              var uploadAudioPromises = page.audios.map(function (audio) {
                return _this5.uploadNewCardPageAudio({ pageId: newPage.id, audioFile: audio.audio_file });
              });

              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(uploadImgPromises).then(function () {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(uploadAudioPromises);
              }).then(function () {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(updateInfo)) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
                }

                return _this5.updateMyPage({ pageId: newPage.id, updateInfo: updateInfo });
              });
            });
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(createPagePromises).then(function () {
            return newCard;
          });
        }).then(function (newCard) {
          _this5.initialCardState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(_this5.card);
          _this5.busy = false;

          return _this5.$router.push('/my-cards/' + newCard.id);
        }).catch(function (err) {
          _this5.busy = false;
          _this5.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    }
  }),

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!this.destination && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(this.initialCardState, this.card)) {
      this.destination = to;
      this.$root.$emit('show::modal', 'page-leave-alert');

      return next(false);
    }

    return next();
  },
  mounted: function mounted() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.gradeSubjects)) {
      document.getElementById('subject-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('subject-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.currentCoreConceptList)) {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.currentUnitList)) {
      document.getElementById('unit-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('unit-dropdown').firstElementChild.disabled = false;
    }

    this.$root.$emit('show::modal', 'edit-card-modal');
  },
  created: function created() {
    this.resetGradeSubjects();
  }
});

/***/ }),

/***/ "A3f9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A47E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("EP12");



var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].MAKE_CARD_PRIVATE, function (state, cardId) {
  state.myCardList.forEach(function (card, i) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.myCardList[i], 'share_level', 2);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].MAKE_CARD_PUBLIC, function (state, cardId) {
  state.myCardList.forEach(function (card, i) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.myCardList[i], 'share_level', 1);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CARD_SHARE_LEVEL, function (state, _ref) {
  var cardId = _ref.cardId,
      shareLevel = _ref.shareLevel;

  state.myCardList.forEach(function (card, i) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.myCardList[i], 'share_level', shareLevel);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].UPDATE_CARD, function (state, updatedCard) {
  state.myCardList.forEach(function (card, i) {
    if (card.id === updatedCard.id) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.myCardList, i, updatedCard);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REMOVE_CARD, function (state, cardId) {
  state.myCardList.forEach(function (card, i) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.myCardList, i);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CARDS, function (state, cardList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'myCardList', cardList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].ADD_CARDS, function (state, cardList) {
  var _state$myCardList;

  (_state$myCardList = state.myCardList).push.apply(_state$myCardList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cardList));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CARD_PAGES, function (state, _ref2) {
  var cardId = _ref2.cardId,
      pageList = _ref2.pageList;

  state.myCardList.forEach(function (card) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(card, 'pages', pageList);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CARD_COVER_IMAGE, function (state, _ref3) {
  var cardId = _ref3.cardId,
      coverImage = _ref3.coverImage;

  state.myCardList.forEach(function (card) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(card, 'cover_image', coverImage);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].ADD_SELECTED_PAGE, function (state, page) {
  state.selectedPageList.push(page);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REMOVE_SELECTED_PAGE, function (state, index) {
  state.selectedPageList.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].RESET_SELECTED_PAGE, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'selectedPageList', []);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "A6/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AE9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'extra-content-edit-modal',

  props: {
    page: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    card: {
      type: Object
    }
  },

  data: function data() {
    return {
      acceptableFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      extraContentTitle: null,
      extraContentImageData: null,
      extraContentImageUrl: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])([]), {
    hasExtraContent: function hasExtraContent() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.page.extra_content);
    },
    extraContentImgaeBinding: function extraContentImgaeBinding() {
      if (this.extraContentImageUrl) {
        return {
          'background-image': 'url(\'' + this.extraContentImageUrl + '\')'
        };
      }

      return {};
    }
  }),

  beforeMount: function beforeMount() {
    this.extraContentTitle = this.page.extra_content.title;
    this.extraContentImageUrl = this.page.extra_content.image_url;
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['updateExtraContent', 'removeExtraContent', 'fetchMyCardPages']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, errorMessage, pages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                params = {
                  title: _this.extraContentTitle
                };

                if (_this.extraContentImageData) {
                  params.imageFile = _this.extraContentImageData;
                }
                _context.next = 5;
                return _this.updateExtraContent({
                  pageId: _this.page.id,
                  params: params
                });

              case 5:
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(_context.t0, 'response.data.error_description', '알 수 없는 오류 입니다.');

                alert(errorMessage);

              case 11:
                _context.next = 13;
                return _this.fetchMyCardPages({
                  cardId: _this.page.card_id,
                  isPublisherUser: true
                });

              case 13:
                pages = _context.sent;

                _this.card.pages = pages;

                _this.$emit('ok');

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    remove: function remove() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var pages;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.removeExtraContent(_this2.page.extra_content.id);

              case 2:
                _context2.next = 4;
                return _this2.fetchMyCardPages({
                  cardId: _this2.page.card_id,
                  isPublisherUser: true
                });

              case 4:
                pages = _context2.sent;

                _this2.card.pages = pages;
                _this2.$emit('ok');

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onExtraContentImageChange: function onExtraContentImageChange(event) {
      var images = event.target.files || event.dataTransfer.files;

      if (!images.length) {
        return null;
      }

      var file = images[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (file.size > this.fileSizeLimit) {
        return this.$root.$emit('show::modal', 'file-size-alert');
      }

      if (this.acceptableFileTypes.indexOf(file.type) === -1) {
        return this.$root.$emit('show::modal', 'file-type-alert');
      }

      return this.createMedia(file, 'image');
    },
    createMedia: function createMedia(file) {
      var _this3 = this;

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function (event) {
        _this3.extraContentImageData = file;
        _this3.extraContentImageUrl = event.target.result;
      };
      return reader.readAsDataURL(file);
    }
  })
});

/***/ }),

/***/ "ALjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("pjQi");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED_CARD_FOR_NEW_ASMT, function (state, card) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'selectedCardForNewAssignment', card);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED, function (state, assignmentId) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'selectedAssignmentId', assignmentId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PROPERTY, function (state, _ref) {
  var id = _ref.id,
      property = _ref.property,
      value = _ref.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.assignments[id], property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ASSIGNMENT_STATS, function (state, teacherAssignmentStats) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'teacherAssignmentStats', teacherAssignmentStats);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ASSIGNMENTS, function (state, assignmentList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'assignments', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(assignmentList, 'id'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_ASSIGNMENTS, function (state, assignmentList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'assignments', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.assignments, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(assignmentList, 'id')));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_ASSIGNMENT, function (state, assignmentId) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.assignments, assignmentId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_ASSIGNMENT, function (state, asmt) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.assignments, asmt.id, asmt);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].UPDATE_ASSIGNMENT, function (state, asmt) {
  if (state.assignments[asmt.id]) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.assignments, asmt.id, asmt);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_PAGES, function (state, _ref2) {
  var assignmentId = _ref2.assignmentId,
      pageList = _ref2.pageList;

  if (state.assignments[assignmentId]) {
    var assignedCard = state.assignments[assignmentId].assigned_card;

    if (assignedCard) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(assignedCard, 'pages', pageList);
    }
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "ALs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    attrs: {
      id: _vm.id,
      placeholder: _vm.placeholder,
      rows: _vm.rows,
      maxlength: _vm.limit,
      disabled: _vm.isDisabled
    },
    domProps: { value: _vm.value },
    on: {
      input: function($event) {
        return _vm.onInput($event.target.value)
      },
      focus: function($event) {
        return _vm.$emit("focus")
      },
      blur: function($event) {
        return _vm.$emit("blur")
      },
      keyup: function($event) {
        return _vm.$emit("keyup")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31356cba", esExports)
  }
}

/***/ }),

/***/ "ANXl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyPageSummary_vue__ = __webpack_require__("Zkqa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a32be02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyPageSummary_vue__ = __webpack_require__("oIH6");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("FJSv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyPageSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a32be02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyPageSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DummyPageSummary.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a32be02", Component.options)
  } else {
    hotAPI.reload("data-v-6a32be02", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ARZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconDropdown_vue__ = __webpack_require__("83AY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb50ada_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconDropdown_vue__ = __webpack_require__("VFCK");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb50ada_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/IconDropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7fb50ada", Component.options)
  } else {
    hotAPI.reload("data-v-7fb50ada", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AS8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-video-lecture',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_publisherOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      subjectId: '',
      gradeId: '',
      domainId: '',
      domainConceptId: '',
      unitId: '',
      lectureTitle: '',
      lectureDescription: '',
      shareLevel: 2,
      domainList: [],
      domainConceptList: [],
      loading: false,
      busy: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['recentVideoUploadInfo', 'videoLectures', 'videoCourses', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds']), {
    lecture: function lecture() {
      return this.videoLectures[this.$route.params.lecture_id];
    },
    course: function course() {
      return this.videoCourses[this.$route.params.course_id];
    },
    videoEmbed: function videoEmbed() {
      if (this.lecture && this.lecture.video && this.lecture.video.embed) {
        return this.lecture.video.embed;
      }

      if (this.recentVideoUploadInfo && this.recentVideoUploadInfo.embed) {
        return this.recentVideoUploadInfo.embed;
      }

      return null;
    },
    prevLink: function prevLink() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.lecture)) {
        return '/video-lectures';
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course)) {
        return '/video-lectures/' + this.lecture.id;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.lecture)) {
        return '/video-courses/' + this.course.id;
      }

      return '/video-courses/' + this.course.id + '/lectures/' + this.lecture.id;
    },
    showDomainSelect: function showDomainSelect() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.domainList);
    },
    showDomainConceptSelect: function showDomainConceptSelect() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.domainConceptList);
    },
    newLectureDisabled: function newLectureDisabled() {
      if (this.subjectId === '') {
        return true;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.domainList) && this.domainId === '') {
        return true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.lectureTitle)) {
        return true;
      }

      return false;
    },
    subjectSelectDisabled: function subjectSelectDisabled() {
      return this.course && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course.subject_id);
    },
    gradeSelectDisabled: function gradeSelectDisabled() {
      return this.course && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course.grade_id);
    },
    domainSelectDisabled: function domainSelectDisabled() {
      return this.course && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.course.domain_id);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setRecentVideoUploadInfoInStore', 'fetchLearningElementList', 'fetchDomainConceptList', 'createNewVideoLecture', 'updateVideoLecture', 'fetchVideoLecture', 'fetchVideoCourse', 'fetchDomainList']), {
    fetchLearningElementNames: function fetchLearningElementNames(params) {
      var regex = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|#|@|~|!|\$|\u20A9|%|\^|&|\*|\(|\)|\x2D|\+|=|\[|\]|\{|\}|:|;|'|"|\?|\.|,|\/|<|>|`|\\|\|/g;

      return this.fetchLearningElementList(params).then(function (learningElementList) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["uniq"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["flatten"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(learningElementList, function (elem) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(elem.name.split('/'), function (name) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["trim"])(name).replace(regex, '_');
          });
        })));
      });
    },
    onSubjectSelect: function onSubjectSelect() {
      var _this = this;

      this.fetchDomainList({ subject_id: this.subjectId }).then(function (domainList) {
        _this.domainId = '';
        _this.domainConceptId = '';
        _this.domainList = domainList;
        _this.domainConceptList = [];
      });
    },
    onDomainSelect: function onDomainSelect() {
      var _this2 = this;

      this.fetchDomainConceptList({ domain_id: this.domainId }).then(function (domainConceptList) {
        _this2.domainConceptId = '';
        _this2.domainConceptList = domainConceptList;
      });
    },
    toggleShareLevel: function toggleShareLevel(value) {
      this.shareLevel = value ? 1 : 2;
    },
    create: function create() {
      var _this3 = this;

      if (!this.busy) {
        this.busy = true;

        var params = {
          title: this.lectureTitle,
          description: this.lectureDescription || undefined,
          subject_id: this.subjectId || undefined,
          grade_id: this.gradeId === 'null' ? null : this.gradeId || undefined,
          domain_id: this.domainId || undefined,
          domain_concept_id: this.domainConceptId || undefined,
          video_course_id: this.$route.params.course_id || undefined,
          position: this.course ? this.course.lecture_count + 1 : undefined,
          share_level: this.shareLevel,
          external_video_id: this.recentVideoUploadInfo.video_id,
          external_video_embed: this.recentVideoUploadInfo.embed
        };

        this.createNewVideoLecture(params).then(function () {
          return _this3.$router.replace(_this3.prevLink);
        });
      }
    },
    update: function update() {
      var _this4 = this;

      if (!this.busy) {
        this.busy = true;

        var params = {
          id: this.$route.params.lecture_id,
          title: this.lectureTitle,
          description: this.lectureDescription || undefined,
          subject_id: this.subjectId || undefined,
          grade_id: this.gradeId === 'null' ? null : this.gradeId || undefined,
          domain_id: this.domainId || undefined,
          domain_concept_id: this.domainConceptId || undefined,
          share_level: this.shareLevel
        };

        this.updateVideoLecture(params).then(function () {
          _this4.busy = false;
        });
      }
    }
  }),

  beforeMount: function beforeMount() {
    var _this5 = this;

    this.loading = true;

    var lectureId = this.$route.params.lecture_id;
    var courseId = this.$route.params.course_id;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(courseId)) {
        return _this5.fetchVideoCourse(courseId);
      }

      return null;
    }).then(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(_this5.course)) {
        _this5.subjectId = _this5.course.subject_id;
        _this5.gradeId = _this5.course.grade_id;
        _this5.domainId = _this5.course.domain_id;
      }
    }).then(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(lectureId) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this5.videoLectures[lectureId])) {
        return _this5.fetchVideoLecture(lectureId);
      }

      return null;
    }).then(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(_this5.lecture)) {
        _this5.subjectId = _this5.lecture.subject_id || '';
        _this5.gradeId = _this5.lecture.grade_id;
        _this5.domainId = _this5.lecture.domain_id || '';
        _this5.domainConceptId = _this5.lecture.domain_concept_id || '';
        _this5.unitId = _this5.lecture.unit_id;
        _this5.lectureTitle = _this5.lecture.title;
        _this5.lectureDescription = _this5.lecture.description;
        _this5.shareLevel = _this5.lecture.share_level;
      }
    }).then(function () {
      if (_this5.subjectId) {
        return _this5.fetchDomainList({ subject_id: _this5.subjectId }).then(function (domainList) {
          _this5.domainList = domainList;
        });
      }

      return null;
    }).then(function () {
      if (_this5.domainId) {
        return _this5.fetchDomainConceptList({ domain_id: _this5.domainId }).then(function (domainConceptList) {
          _this5.domainConceptList = domainConceptList;
        });
      }

      return null;
    }).then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(_this5.videoEmbed)) {
        return _this5.$router.replace(_this5.prevLink);
      }

      _this5.loading = false;
      return null;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.setRecentVideoUploadInfoInStore(null);
  }
});

/***/ }),

/***/ "ASz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["evaluationList"] = evaluationList;
/* harmony export (immutable) */ __webpack_exports__["evaluations"] = evaluations;
/* harmony export (immutable) */ __webpack_exports__["evaluationFilters"] = evaluationFilters;
/* harmony export (immutable) */ __webpack_exports__["evaluationSubjectMap"] = evaluationSubjectMap;
/* harmony export (immutable) */ __webpack_exports__["evaluationCriteria"] = evaluationCriteria;
/* harmony export (immutable) */ __webpack_exports__["evaluationOrderBy"] = evaluationOrderBy;
/* harmony export (immutable) */ __webpack_exports__["classEvaluationDomains"] = classEvaluationDomains;
/* harmony export (immutable) */ __webpack_exports__["selectedClassEvaluationDomainIds"] = selectedClassEvaluationDomainIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function evaluationList(state) {
  return state.evaluationList;
}

function evaluations(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keyBy"])(state.evaluationList, function (evaluation) {
    return evaluation.id;
  });
}

function evaluationFilters(state) {
  return state.evaluationFilters;
}

function evaluationSubjectMap(state) {
  return state.evaluationSubjectMap;
}

function evaluationCriteria(state) {
  return state.evaluationCriteria;
}

function evaluationOrderBy(state) {
  return state.evaluationOrderBy;
}

function classEvaluationDomains(state) {
  return state.classEvaluationDomains;
}

function selectedClassEvaluationDomainIds(state) {
  return state.selectedClassEvaluationDomainIds;
}

/***/ }),

/***/ "AVVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal select-assignment-modal",
      attrs: {
        id: "select-assignment-modal",
        title: _vm.$t("reports.select_assignments"),
        "ok-title": _vm.$t("common.confirm"),
        "close-title": _vm.$t("common.cancel"),
        "ok-disabled": _vm.okDisabled
      },
      on: {
        ok: function($event) {
          return _vm.applySelectedList()
        },
        cancel: function($event) {
          return _vm.$emit("cancel")
        }
      }
    },
    [
      _c("div", { staticClass: "select-assignment-modal__body" }, [
        _c(
          "div",
          {
            staticClass:
              "select-assignment-modal__checkbox-row select-assignment-modal__select-all-row"
          },
          [
            _c(
              "Checkbox",
              {
                attrs: { "model-value": _vm.isAll, "check-value": true },
                on: { change: _vm.selectAllAssignments }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "ml-3 typography--body-3",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("reports.select_all_assignments")) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "float-right typography--caption typography--color-secondary mt-1"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("reports.select_all_assignments_help")) +
                    "\n      "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.assignmentList, function(assignment) {
            return _c(
              "div",
              {
                key: assignment.id,
                staticClass: "select-assignment-modal__checkbox-row"
              },
              [
                _c(
                  "Checkbox",
                  {
                    attrs: {
                      "model-value": _vm.selectedList,
                      "check-value": assignment.id,
                      disabled: _vm.isAll
                    },
                    on: { change: _vm.selectAssignment }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "ml-3 typography--body-3",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(assignment.assigned_card.title) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96f47d8a", esExports)
  }
}

/***/ }),

/***/ "AaSe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterContent_vue__ = __webpack_require__("/f6k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98417144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterContent_vue__ = __webpack_require__("jT7j");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("8PQF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98417144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/FooterContent.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-98417144", Component.options)
  } else {
    hotAPI.reload("data-v-98417144", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AgwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["coreConceptVideoCourses"] = coreConceptVideoCourses;
/* harmony export (immutable) */ __webpack_exports__["unitsWithCoreConcepts"] = unitsWithCoreConcepts;
/* harmony export (immutable) */ __webpack_exports__["videoCourses"] = videoCourses;
/* harmony export (immutable) */ __webpack_exports__["videoCourseList"] = videoCourseList;
/* harmony export (immutable) */ __webpack_exports__["coreConceptVideoCourse"] = coreConceptVideoCourse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function coreConceptVideoCourses(state) {
  return state.coreConceptVideoCourses;
}

function unitsWithCoreConcepts(state) {
  return state.unitsWithCoreConcepts;
}

function videoCourses(state) {
  return state.videoCourses;
}

function videoCourseList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.videoCourses), ['created_at'], ['desc']);
}

function coreConceptVideoCourse(state) {
  return state.coreConceptVideoCourse;
}

/***/ }),

/***/ "AmN6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox',

  props: ['id', 'model-value', 'check-value', 'disabled'],

  data: function data() {
    return {
      isChecked: false
    };
  },


  computed: {
    state: function state() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(this.modelValue)) {
        return this.modelValue.indexOf(this.checkValue) !== -1;
      }

      return this.modelValue === this.checkValue;
    }
  },

  methods: {
    check: function check() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(this.modelValue)) {
        var value = this.modelValue.slice(0);
        value.push(this.checkValue);

        return this.$emit('change', value);
      }

      return this.$emit('change', this.checkValue);
    },
    uncheck: function uncheck() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(this.modelValue)) {
        var value = this.modelValue.slice(0);
        value.splice(value.indexOf(this.checkValue), 1);

        return this.$emit('change', value);
      }

      if (this.checkValue === true) {
        return this.$emit('change', false);
      }

      return this.$emit('change', null);
    },
    onChange: function onChange() {
      if (this.state) {
        this.uncheck();
      } else {
        this.check();
      }
    }
  }
});

/***/ }),

/***/ "B1XC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BQ3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("qYau");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "BYjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function newClassGradeText(gradeData) {
  switch (gradeData) {
    case 'first':
    case 'seventh':
    case 'tenth':
      return '1학년';
    case 'second':
    case 'eighth':
    case 'eleventh':
      return '2학년';
    case 'third':
    case 'ninth':
    case 'twelfth':
      return '3학년';
    case 'fourth':
      return '4학년';
    case 'fifth':
      return '5학년';
    case 'sixth':
      return '6학년;';
    default:
      return '';
  }
}

/* harmony default export */ __webpack_exports__["a"] = (newClassGradeText);

/***/ }),

/***/ "Bliq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "publisher-series" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/publishers/series" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("publishers.sub_header.series")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/publishers/non-series-cards" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("publishers.sub_header.non_series_cards")
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c("div", { staticClass: "sub-header-btn-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary new-series-btn float-right",
                  on: {
                    click: function($event) {
                      _vm.newSeriesModalIsShown = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("publishers.sub_header.new_series")) +
                      "\n          "
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.seriesList.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("publishers.no_series"))
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.seriesList, function(series) {
                      return _c(
                        "div",
                        {
                          key: series.id,
                          staticClass: "col-sm-6 col-md-4 col-lg-3"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "card-row",
                              attrs: {
                                to: "/publishers/series/" + series.id,
                                tag: "div"
                              }
                            },
                            [_c("SeriesItem", { attrs: { series: series } })],
                            1
                          )
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _vm.newSeriesModalIsShown
          ? _c("NewSeriesModal", {
              attrs: { "publisher-id": _vm.publisherId },
              on: {
                cancel: function($event) {
                  _vm.newSeriesModalIsShown = false
                },
                ok: function($event) {
                  _vm.newSeriesModalIsShown = false
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed75a97e", esExports)
  }
}

/***/ }),

/***/ "BsW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "slide" } },
    [
      _c(
        "b-navbar",
        {
          class: _vm.headerClassBindings,
          attrs: { toggleable: "", fixed: "top", variant: "faded" }
        },
        [
          _c(
            "div",
            { staticClass: "container app-header-container" },
            [
              _c("b-nav-toggle", {
                staticClass: "clickable",
                attrs: { target: "scroll-app-header-nav-collapse" }
              }),
              _vm._v(" "),
              _vm.attachHome
                ? _c(
                    "b-link",
                    {
                      staticClass: "navbar-brand app-brand",
                      attrs: { to: "/intro" }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-classting-logo.svg" }
                      })
                    ]
                  )
                : _c(
                    "b-link",
                    {
                      staticClass: "navbar-brand app-brand",
                      attrs: { to: "/library" }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-classting-logo.svg" }
                      })
                    ]
                  ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  attrs: { "is-nav": "", id: "scroll-app-header-nav-collapse" }
                },
                [
                  _c(
                    "b-nav",
                    { staticClass: "mx-auto", attrs: { "is-nav-bar": "" } },
                    [
                      _c("b-nav-item", { attrs: { to: "/library" } }, [
                        _vm._v(_vm._s(_vm.$t("header.nav_menu.library")))
                      ]),
                      _vm._v(" "),
                      _c("b-nav-item", { attrs: { to: "/my-cards" } }, [
                        _vm._v(_vm._s(_vm.$t("header.nav_menu.my_cards")))
                      ]),
                      _vm._v(" "),
                      _vm.isPublisherUser
                        ? _c("b-nav-item", { attrs: { to: "/publishers" } }, [
                            _vm._v(_vm._s(_vm.$t("header.nav_menu.publishers")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isPublisherUser
                        ? _c(
                            "b-nav-item",
                            { attrs: { to: "/video-courses" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("header.nav_menu.video_lectures"))
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav",
                    {
                      staticClass: "hidden-sm-down",
                      attrs: { "is-nav-bar": "" }
                    },
                    [
                      _c("a", {
                        staticClass: "btn rounded-circle profile-btn",
                        style: _vm.styleBindings,
                        attrs: { href: _vm.userProfileUrl, target: "_blank" }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48717d41", esExports)
  }
}

/***/ }),

/***/ "BsrQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forbidden',

  data: function data() {
    return {
      classtingUrl: __WEBPACK_IMPORTED_MODULE_0__config__["b" /* CLASSTING_URL */]
    };
  }
});

/***/ }),

/***/ "BxyQ":
/***/ (function(module, exports) {

module.exports = {"Play":"Tocar","Pause":"Pausar","Current Time":"Tempo","Duration Time":"Duração","Remaining Time":"Tempo Restante","Stream Type":"Tipo de Stream","LIVE":"AO VIVO","Loaded":"Carregado","Progress":"Progresso","Fullscreen":"Tela Cheia","Non-Fullscreen":"Tela Normal","Mute":"Mudo","Unmute":"Habilitar Som","Playback Rate":"Velocidade","Subtitles":"Legendas","subtitles off":"Sem Legendas","Captions":"Anotações","captions off":"Sem Anotações","Chapters":"Capítulos","You aborted the media playback":"Você parou a execução do vídeo.","A network error caused the media download to fail part-way.":"Um erro na rede fez o vídeo parar parcialmente.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"O vídeo não pode ser carregado, ou porque houve um problema com sua rede ou pelo formato do vídeo não ser suportado.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"A execução foi interrompida por um problema com o vídeo ou por seu navegador não dar suporte ao seu formato.","No compatible source was found for this media.":"Não foi encontrada fonte de vídeo compatível."}

/***/ }),

/***/ "Bz0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "mdc-snackbar",
        attrs: {
          "aria-live": "assertive",
          "aria-atomic": "true",
          "aria-hidden": "true"
        }
      },
      [
        _c("div", { staticClass: "mdc-snackbar__text" }),
        _vm._v(" "),
        _c("div", { staticClass: "mdc-snackbar__action-wrapper" }, [
          _c("button", {
            staticClass: "mdc-snackbar__action-button",
            attrs: { type: "button" }
          })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-573c0296", esExports)
  }
}

/***/ }),

/***/ "C0dL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyCard_vue__ = __webpack_require__("3QeH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f4abd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyCard_vue__ = __webpack_require__("0K6s");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("8cID")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f4abd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DummyCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03f4abd8", Component.options)
  } else {
    hotAPI.reload("data-v-03f4abd8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C8Zk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var UPDATE_PAGE = 'edit-page/UPDATE_PAGE';

/* harmony default export */ __webpack_exports__["a"] = ({
  UPDATE_PAGE: UPDATE_PAGE
});

/***/ }),

/***/ "CIAg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CRfm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CVAp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesItem_vue__ = __webpack_require__("XQQR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6383d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesItem_vue__ = __webpack_require__("eBP1");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("kg9P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6383d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/SeriesItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a6383d2", Component.options)
  } else {
    hotAPI.reload("data-v-1a6383d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ChIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseLectureItem_vue__ = __webpack_require__("Gx4I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5d20e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseLectureItem_vue__ = __webpack_require__("Sl0p");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("B1XC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc5d20e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseLectureItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5d20e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseLectureItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-courses/components/CourseLectureItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cc5d20e6", Component.options)
  } else {
    hotAPI.reload("data-v-cc5d20e6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cp7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomModal_vue__ = __webpack_require__("KunQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1906fdbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomModal_vue__ = __webpack_require__("V6Px");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1906fdbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/CustomModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1906fdbc", Component.options)
  } else {
    hotAPI.reload("data-v-1906fdbc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Csdr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("7phZ");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "Cx08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("UKYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin__ = __webpack_require__("box3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__("/pyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("sOIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("VONw");







var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module, plugin: __WEBPACK_IMPORTED_MODULE_2__plugin__["a" /* default */] });

/***/ }),

/***/ "DDRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchPolicy"] = fetchPolicy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__("7K8a");



function fetchPolicy(_ref, policyPath) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].get('/' + policyPath).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching policy:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

/***/ }),

/***/ "DIUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("K9lf");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_MY_QUIZZES_REQUEST, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingMyQuizzes', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_MY_QUIZZES_SUCCESS, function (state, _ref) {
  var myQuizzes = _ref.myQuizzes,
      total = _ref.total;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingMyQuizzes', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'total', total);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'myQuizzes', myQuizzes);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_INFINITE_MY_QUIZZES_SUCCESS, function (state, _ref2) {
  var myQuizzes = _ref2.myQuizzes,
      total = _ref2.total;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingMyQuizzes', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'total', total);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'myQuizzes', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["concat"])(state.myQuizzes, myQuizzes));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_MY_QUIZZES_FAILURE, function (state, err) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingMyQuizzes', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'error', err);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_QUIZ_REQUEST, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_QUIZ_SUCCESS, function (state, quiz) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'myQuizzes', [quiz].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.myQuizzes)));
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'quiz', quiz);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_QUIZ_FAILURE, function (state, err) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'error', err);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].PUT_QUIZ_REQUEST, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].PUT_QUIZ_SUCCESS, function (state, quiz) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', false);
  var myQuizzes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(state.myQuizzes, function (item) {
    if (item.id === quiz.id) {
      return quiz;
    }

    return item;
  });

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'myQuizzes', myQuizzes);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].PUT_QUIZ_FAILURE, function (state, err) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'error', err);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].DELETE_QUIZ_REQUEST, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].DELETE_QUIZ_SUCCESS, function (state, id) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', false);
  var myQuizzes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(state.myQuizzes, function (item) {
    return item.id !== id;
  });
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'myQuizzes', myQuizzes);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'total', state.total - 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].DELETE_QUIZ_FAILURE, function (state, err) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingQuiz', false);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'error', err);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "DNTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EvaluationTableRow__ = __webpack_require__("P2Id");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-table',

  components: {
    EvaluationTableRow: __WEBPACK_IMPORTED_MODULE_0__EvaluationTableRow__["a" /* default */]
  },

  props: {
    evaluationList: {
      type: Array,
      default: null
    },
    selectedDomainIds: {
      type: Array,
      default: null
    }
  }
});

/***/ }),

/***/ "DSth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__("kl7r");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'publisher-card-view',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  props: {
    card: {
      type: Object,
      default: null
    },
    isSeriesCard: {
      type: Boolean,
      default: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap']), {
    coverImageStyle: function coverImageStyle() {
      if (this.card && this.card.cover_image_small) {
        return {
          'background-image': 'url(\'' + this.card.cover_image_small + '\')'
        };
      }

      return {};
    },
    isCardAuthor: function isCardAuthor() {
      if (this.card && this.card.author_id) {
        return true;
      }

      return false;
    },
    cardPrice: function cardPrice() {
      if (this.card && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.card.price)) {
        return this.card.price;
      }

      return '-';
    }
  }),

  methods: {
    goToMyCardDetails: function goToMyCardDetails() {
      this.$router.push('/my-cards/' + this.card.id);
    },


    isEmpty: __WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"]
  }
});

/***/ }),

/***/ "Df6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublisherSeries_vue__ = __webpack_require__("Tl9Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed75a97e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublisherSeries_vue__ = __webpack_require__("Bliq");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublisherSeries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed75a97e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublisherSeries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/views/PublisherSeries.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ed75a97e", Component.options)
  } else {
    hotAPI.reload("data-v-ed75a97e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DhPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("/dQ8");






function subscribe(store) {
  store.subscribe(function (mutation, _ref) {
    var ClEvents = _ref.ClEvents,
        Auth = _ref.Auth;

    switch (mutation.type) {
      case __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CL_EVENTS:
        {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(Auth.user)) {
            var cookieKey = __WEBPACK_IMPORTED_MODULE_2__config__["n" /* USER_CL_EVENTS_KEY */] + '/' + Auth.user.id;
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(cookieKey, ClEvents.clEvents, { expires: 999 });
          }

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].UPDATE_CL_EVENT:
        {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(Auth.user)) {
            var _cookieKey = __WEBPACK_IMPORTED_MODULE_2__config__["n" /* USER_CL_EVENTS_KEY */] + '/' + Auth.user.id;
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(_cookieKey, ClEvents.clEvents, { expires: 999 });
          }

          break;
        }

      default:
        {
          break;
        }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  subscribe(store);
});

/***/ }),

/***/ "DlYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropup topic-dropup", class: { show: _vm.visible } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary dropdown-toggle",
          on: { click: _vm.toggleMenu }
        },
        [_vm._t("dropup-btn")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-menu",
          on: {
            click: function($event) {
              _vm.visible = false
            }
          }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4707d4e", esExports)
  }
}

/***/ }),

/***/ "DrZz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_ACTIVE_EDITOR_LOCATION = 'root/SET_ACTIVE_EDITOR_LOCATION';
var SET_IS_STUDENT_PREVIEW = 'root/SET_IS_STUDENT_PREVIEW';
var SET_IS_CLASS_PREVIEW = 'root/SET_IS_CLASS_PREVIEW';
var SET_ACTIVE_EDITOR_ID = 'root/SET_ACTIVE_EDITOR_ID';
var SET_IS_PAGE_PREVIEW = 'root/SET_IS_PAGE_PREVIEW';
var SET_PAGE_INDEX = 'root/SET_PAGE_INDEX';
var SET_SELECTED = 'root/SET_SELECTED';
var SET_BUSY = 'SET_BUSY';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_ACTIVE_EDITOR_LOCATION: SET_ACTIVE_EDITOR_LOCATION,
  SET_IS_STUDENT_PREVIEW: SET_IS_STUDENT_PREVIEW,
  SET_IS_CLASS_PREVIEW: SET_IS_CLASS_PREVIEW,
  SET_ACTIVE_EDITOR_ID: SET_ACTIVE_EDITOR_ID,
  SET_IS_PAGE_PREVIEW: SET_IS_PAGE_PREVIEW,
  SET_PAGE_INDEX: SET_PAGE_INDEX,
  SET_SELECTED: SET_SELECTED,
  SET_BUSY: SET_BUSY
});

/***/ }),

/***/ "DwvS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("/dQ8");


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].UPDATE_CL_EVENT, function (state, _ref) {
  var eventName = _ref.eventName,
      value = _ref.value;

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.clEvents, eventName, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_CL_EVENTS, function (state, clEvents) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'clEvents', clEvents);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "E42Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchClasses"] = fetchClasses;
/* harmony export (immutable) */ __webpack_exports__["syncClasses"] = syncClasses;
/* harmony export (immutable) */ __webpack_exports__["fetchClassStudents"] = fetchClassStudents;
/* harmony export (immutable) */ __webpack_exports__["fetchClassStudent"] = fetchClassStudent;
/* harmony export (immutable) */ __webpack_exports__["syncClassStudents"] = syncClassStudents;
/* harmony export (immutable) */ __webpack_exports__["manageClassStudents"] = manageClassStudents;
/* harmony export (immutable) */ __webpack_exports__["fetchClassAssignments"] = fetchClassAssignments;
/* harmony export (immutable) */ __webpack_exports__["fetchClassTopics"] = fetchClassTopics;
/* harmony export (immutable) */ __webpack_exports__["setClassesInStore"] = setClassesInStore;
/* harmony export (immutable) */ __webpack_exports__["setSelectedClassId"] = setSelectedClassId;
/* harmony export (immutable) */ __webpack_exports__["setIsClassStudent"] = setIsClassStudent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutation_types__ = __webpack_require__("Mnw2");











function fetchClasses(_ref) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes').then(function (res) {
    return dispatch('setClassesInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching classes:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function syncClasses(_ref2) {
  var _this = this;

  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes', {}).then(function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
      var classList, newClassListRes, newClassList, convertedNewClassList;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              classList = res.data;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_6__config__["q" /* NEW_CLASS_BACKEND_BASE_URL */] + '/classrooms?role=admin');

            case 3:
              newClassListRes = _context.sent;
              newClassList = newClassListRes.data.classrooms ? newClassListRes.data.classrooms : [];
              convertedNewClassList = [];


              newClassList.forEach(function (newClass) {
                var snakeCaseNewClass = { is_new_class: true };

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(newClass).forEach(function (entry) {
                  var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["snakeCase"])(entry[0]);
                  var value = entry[1];
                  snakeCaseNewClass[key] = value;
                });

                convertedNewClassList.push(snakeCaseNewClass);
              });

              return _context.abrupt('return', [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(classList), convertedNewClassList));

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()).then(function (classList) {
    return dispatch('setClassesInStore', classList);
  }).catch(function (err) {
    console.error('err while syncing classes:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchClassStudents(_ref4, classId) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/students').then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching class students:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchClassStudent(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var classId = _ref6.classId,
      studentId = _ref6.studentId;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/students/' + studentId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    if (err.response && err.response.status === 404) {
      return null;
    }

    console.error('err while fetching class student:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function syncClassStudents(_ref7, classId) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/students', {}).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while syncing class students:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function manageClassStudents(_ref8, _ref9) {
  var dispatch = _ref8.dispatch;
  var classId = _ref9.classId,
      students = _ref9.students;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/student-info', { students: students }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while managing class students:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchClassAssignments(_ref10, params) {
  var dispatch = _ref10.dispatch;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes/' + params.class_id + '/assignments', { params: params }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching class assignments:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchClassTopics(_ref11, classId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_7__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* MINERVA_API_URL */] + '/classes/' + classId + '/topics').then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching class topics:', err);
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setClassesInStore(_ref12, classList) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* default */].SET_CLASSES, classList);

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(classList);
}

function setSelectedClassId(_ref13, classId) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* default */].SET_SELECTED, classId);

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve();
}

function setIsClassStudent(_ref14, isClassStudent) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* default */].SET_IS_CLASS_STUDENT, isClassStudent);

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(isClassStudent);
}

/***/ }),

/***/ "E4H8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PublisherCardView__ = __webpack_require__("NbUQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddToSeriesModal__ = __webpack_require__("/2uw");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'non-series-cards',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_publisherOnly__["a" /* default */]],

  components: {
    PublisherCardView: __WEBPACK_IMPORTED_MODULE_4__components_PublisherCardView__["a" /* default */],
    AddToSeriesModal: __WEBPACK_IMPORTED_MODULE_5__components_AddToSeriesModal__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },

  data: function data() {
    return {
      loading: false,
      addToSeriesModalIsShown: false,
      cardIdForAddToSeries: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentPublisherInfo', 'nonSeriesCardList', 'seriesList']), {
    publisherId: function publisherId() {
      return this.currentPublisherInfo.id;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchNonSeriesCards']), {
    openAddToSeriesModal: function openAddToSeriesModal(cardId) {
      this.cardIdForAddToSeries = cardId;
      this.addToSeriesModalIsShown = true;
    },
    closeAddToSeriesModal: function closeAddToSeriesModal() {
      this.addToSeriesModalIsShown = false;
      this.cardIdForAddToSeries = null;
    },
    onInfinite: function onInfinite() {
      var _this = this;

      var offset = parseInt(this.nonSeriesCardList.length / 20, 10) * 20;
      var limit = 20;
      var params = {
        publisher_id: this.publisherId,
        offset: offset,
        limit: limit
      };

      return this.fetchNonSeriesCards(params).then(function (cardList) {
        if (_this.$refs.infiniteLoading) {
          _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (cardList.length < limit) {
            _this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      });
    }
  })
});

/***/ }),

/***/ "ECU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EIgA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EOHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VideoLectureItem__ = __webpack_require__("t56z");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-lecture-list',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_publisherOnly__["a" /* default */]],

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a,
    VideoLectureItem: __WEBPACK_IMPORTED_MODULE_5__components_VideoLectureItem__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['lecturesByCourseId', 'currentUserId']), {
    lectures: function lectures() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(this.lecturesByCourseId.null, ['created_at'], ['desc']);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchMyVideoLectureList']), {
    onInfinite: function onInfinite() {
      var _this = this;

      var perPage = 10;
      var page = parseInt(this.lectures.length / perPage, 10) + 1;
      var params = {
        owner_id: this.currentUserId,
        order_by: '-created_at',
        video_course_id: 'null',
        per_page: perPage,
        page: page
      };

      return this.fetchMyVideoLectureList(params).then(function (videoLectureList) {
        if (_this.$refs.infiniteLoading) {
          _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (videoLectureList.length < perPage) {
            _this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      });
    }
  })
});

/***/ }),

/***/ "EOeG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EP12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var REMOVE_SELECTED_PAGE = 'myCards/REMOVE_SELECTED_PAGE';
var SET_CARD_COVER_IMAGE = 'myCards/SET_CARD_COVER_IMAGE';
var RESET_SELECTED_PAGE = 'myCards/RESET_SELECTED_PAGE';
var ADD_SELECTED_PAGE = 'myCards/ADD_SELECTED_PAGE';
var MAKE_CARD_PRIVATE = 'myCards/MAKE_CARD_PRIVATE';
var MAKE_CARD_PUBLIC = 'myCards/MAKE_CARD_PUBLIC';
var SET_CARD_SHARE_LEVEL = 'myCards/SET_CARD_SHARE_LEVEL';
var SET_CARD_PAGES = 'myCards/SET_CARD_PAGES';
var REMOVE_CARD = 'myCards/REMOVE_CARD';
var UPDATE_CARD = 'myCards/UPDATE_CARD';
var SET_CARDS = 'myCards/SET_CARDS';
var ADD_CARDS = 'myCards/ADD_CARDS';

/* harmony default export */ __webpack_exports__["a"] = ({
  REMOVE_SELECTED_PAGE: REMOVE_SELECTED_PAGE,
  SET_CARD_COVER_IMAGE: SET_CARD_COVER_IMAGE,
  RESET_SELECTED_PAGE: RESET_SELECTED_PAGE,
  ADD_SELECTED_PAGE: ADD_SELECTED_PAGE,
  MAKE_CARD_PRIVATE: MAKE_CARD_PRIVATE,
  MAKE_CARD_PUBLIC: MAKE_CARD_PUBLIC,
  SET_CARD_SHARE_LEVEL: SET_CARD_SHARE_LEVEL,
  SET_CARD_PAGES: SET_CARD_PAGES,
  REMOVE_CARD: REMOVE_CARD,
  UPDATE_CARD: UPDATE_CARD,
  SET_CARDS: SET_CARDS,
  ADD_CARDS: ADD_CARDS
});

/***/ }),

/***/ "EXL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_CORE_CONCEPT_VIDEO_COURSES = 'videoCourses/SET_CORE_CONCEPT_VIDEO_COURSES';
var SET_UNITS_WITH_CORE_CONCEPTS = 'videoCourses/SET_UNITS_WITH_CORE_CONCEPTS';
var REMOVE_VIDEO_COURSE = 'videoCourses/REMOVE_VIDEO_COURSE';
var SET_VIDEO_COURSES = 'videoCourses/SET_VIDEO_COURSES';
var SET_CORE_CONCEPT_VIDEO_COURSE = 'videoCourses/SET_CORE_CONCEPT_VIDEO_COURSE';
var FETCH_CORE_CONCEPT_VIDEO_COURSES = 'videoCourses/FETCH_CORE_CONCEPT_VIDEO_COURSES';
var UPDATE_CORE_CONCEPT_VIDEO_COURSE = 'videoCourses/UPDATE_CORE_CONCEPT_VIDEO_COURSE';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CORE_CONCEPT_VIDEO_COURSES: SET_CORE_CONCEPT_VIDEO_COURSES,
  SET_UNITS_WITH_CORE_CONCEPTS: SET_UNITS_WITH_CORE_CONCEPTS,
  REMOVE_VIDEO_COURSE: REMOVE_VIDEO_COURSE,
  SET_VIDEO_COURSES: SET_VIDEO_COURSES,
  SET_CORE_CONCEPT_VIDEO_COURSE: SET_CORE_CONCEPT_VIDEO_COURSE,
  FETCH_CORE_CONCEPT_VIDEO_COURSES: FETCH_CORE_CONCEPT_VIDEO_COURSES,
  UPDATE_CORE_CONCEPT_VIDEO_COURSE: UPDATE_CORE_CONCEPT_VIDEO_COURSE
});

/***/ }),

/***/ "EY1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mdc-form-field mdc-radio-container" }, [
    _vm.leftLabel
      ? _c(
          "label",
          {
            staticClass:
              "typography--body-3 typography--color-secondary clickable",
            attrs: { id: _vm.id + "-left-label", for: _vm.id }
          },
          [_vm._t("left-label")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mdc-radio" }, [
      _c("input", {
        staticClass: "mdc-radio__native-control",
        attrs: { id: _vm.id, type: "radio" },
        domProps: { checked: _vm.state },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    !_vm.leftLabel
      ? _c(
          "label",
          {
            staticClass:
              "typography--body-3 typography--color-secondary clickable",
            attrs: { id: _vm.id + "-label", for: _vm.id }
          },
          [_vm._t("label")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mdc-radio__background" }, [
      _c("div", { staticClass: "mdc-radio__outer-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-radio__inner-circle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-961ceb0a", esExports)
  }
}

/***/ }),

/***/ "EZHp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eahh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchCustomCards"] = fetchCustomCards;
/* harmony export (immutable) */ __webpack_exports__["fetchCustomCardDetails"] = fetchCustomCardDetails;
/* harmony export (immutable) */ __webpack_exports__["fetchCustomCardPages"] = fetchCustomCardPages;
/* harmony export (immutable) */ __webpack_exports__["setCustomCardsInStore"] = setCustomCardsInStore;
/* harmony export (immutable) */ __webpack_exports__["addCustomCardsInStore"] = addCustomCardsInStore;
/* harmony export (immutable) */ __webpack_exports__["setSelectedCustomCardId"] = setSelectedCustomCardId;
/* harmony export (immutable) */ __webpack_exports__["setCustomCardPages"] = setCustomCardPages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("eEBw");






function fetchCustomCards(_ref, filters) {
  var dispatch = _ref.dispatch;

  var queryParams = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(filters);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards?' + queryParams).then(function (res) {
    if (filters.offset === 0) {
      return dispatch('setCustomCardsInStore', res.data);
    }

    return dispatch('addCustomCardsInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching custom cards:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchCustomCardDetails(_ref2, cardId) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching custom card details:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchCustomCardPages(_ref3, cardId) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/pages').then(function (res) {
    return dispatch('setCustomCardPages', { cardId: cardId, pageList: res.data });
  }).catch(function (err) {
    console.error('err while fetching custom card pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setCustomCardsInStore(_ref4, cardList) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARDS, cardList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardList);
}

function addCustomCardsInStore(_ref5, cardList) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_CARDS, cardList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardList);
}

function setSelectedCustomCardId(_ref6, cardId) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setCustomCardPages(_ref7, setInfo) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_PAGES, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setInfo.pageList);
}

/***/ }),

/***/ "ElHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classes_vue__ = __webpack_require__("gp/W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c91945_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classes_vue__ = __webpack_require__("RrWb");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c91945_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/views/Classes.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25c91945", Component.options)
  } else {
    hotAPI.reload("data-v-25c91945", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EsBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal math-editor-modal",
      attrs: {
        id: _vm.id,
        title: _vm.$t("common.modal.math_editor.title"),
        "ok-title": _vm.$t("common.confirm"),
        "close-title": _vm.$t("common.cancel")
      },
      on: { ok: _vm.addMath, cancel: _vm.clear }
    },
    [
      _c("nav", { staticClass: "navbar navbar-toggleable navbar-light" }, [
        _c("ul", { staticClass: "nav navbar-nav" }, [
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.currentTab === "basic" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link typography--body-3",
                  on: {
                    click: function($event) {
                      _vm.currentTab = "basic"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.modal.math_editor.tabs.basic")) +
                      "\n        "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.currentTab === "geometry" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link typography--body-3",
                  on: {
                    click: function($event) {
                      _vm.currentTab = "geometry"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.modal.math_editor.tabs.geometry")) +
                      "\n        "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.currentTab === "etc" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link typography--body-3",
                  on: {
                    click: function($event) {
                      _vm.currentTab = "etc"
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.modal.math_editor.tabs.etc")) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "width-100" }, [
          _c(
            "table",
            { staticClass: "table table-responsive math-cmd-table width-100" },
            [
              _c(
                "tbody",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "basic",
                      expression: "currentTab === 'basic'"
                    }
                  ]
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Exponent",
                            "aria-label": "Exponent"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("^", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("x^{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Square root",
                            "aria-label": "Square root"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sqrt", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sqrt{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Square brackets",
                            "aria-label": "Square brackets"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("[", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left[\\right]")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Divide", "aria-label": "Divide" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\div", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\div")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Minus", "aria-label": "Minus" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("-", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("-")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Equal to",
                            "aria-label": "Equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("=", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("=")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Less than",
                            "aria-label": "Less than"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\lt")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\lt")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Greater than",
                            "aria-label": "Greater than"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\gt")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\gt")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Subscript",
                            "aria-label": "Subscript"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("_", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("x_{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Root", "aria-label": "Root" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sqrt[]{}")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sqrt[]{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Parentheses",
                            "aria-label": "Parentheses"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("(", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left(\\right)")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Times", "aria-label": "Times" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\times", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\times")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Plus", "aria-label": "Plus" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("+", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("+")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Not equal to",
                            "aria-label": "Not equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\neq")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\neq")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Less than or equal to",
                            "aria-label": "Less than or equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\leq")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\leq")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Greater than or equal to",
                            "aria-label": "Greater than or equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\geq")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\geq")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Fraction",
                            "aria-label": "Fraction"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\frac", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\frac{}{}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Curly brackets",
                            "aria-label": "Curly brackets"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("{", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left\\{\\right\\}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box empty-box" }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Plus minus",
                            "aria-label": "Plus minus"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\pm", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\pm")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Approximately equal to",
                            "aria-label": "Approximately equal to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\approx")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\approx")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Right arrow",
                            "aria-label": "Right arrow"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\to")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\to")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Triple bar",
                            "aria-label": "Triple bar"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\equiv")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\equiv")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "tbody",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "geometry",
                      expression: "currentTab === 'geometry'"
                    }
                  ]
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Angle", "aria-label": "Angle" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\angle", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\angle")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Is perpendicular to",
                            "aria-label": "Is perpendicular to"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\perp", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\perp")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Segment", "aria-label": "Segment" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\overline", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overline{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Over right arrow",
                            "aria-label": "Over right arrow"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\overrightarrow", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overrightarrow{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Slash", "aria-label": "Slash" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\slash", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\slash")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Triangle",
                            "aria-label": "Triangle"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\triangle", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\triangle")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Measured angle",
                            "aria-label": "Measured angle"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\measuredangle", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\measuredangle")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Degree", "aria-label": "Degree" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("^{\\circ}")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("^{\\circ}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Over arc",
                            "aria-label": "Over arc"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\overarc", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overarc{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Text", "aria-label": "Text" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\textrm", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\textrm{AB}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Square", "aria-label": "Square" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\square", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\square")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Distance",
                            "aria-label": "Distance"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("|", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\left| \\right|")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Similarity",
                            "aria-label": "Similarity"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sim", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sim")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Over left right arrow",
                            "aria-label": "Over left right arrow"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd(
                                "\\overleftrightarrow",
                                true
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\overleftrightarrow{xyz}")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Pi", "aria-label": "Pi" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\pi", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\pi")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Big circle",
                            "aria-label": "Big circle"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\bigcirc", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\bigcirc")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "tbody",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "etc",
                      expression: "currentTab === 'etc'"
                    }
                  ]
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Infinity",
                            "aria-label": "Infinity"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\infty", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\infty")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Therefore",
                            "aria-label": "Therefore"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\therefore", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\therefore")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Sine", "aria-label": "Sine" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\sin", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\sin")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: {
                            title: "Natural log",
                            "aria-label": "Natural log"
                          },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\ln", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\ln")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box border-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Because", "aria-label": "Because" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\because")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\because")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Cosine", "aria-label": "Cosine" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\cos", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\cos")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "math-cmd-btn-box border-right empty-box"
                    }),
                    _vm._v(" "),
                    _c("td", { staticClass: "math-cmd-btn-box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "math-cmd-btn",
                          attrs: { title: "Tangent", "aria-label": "Tangent" },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.writeMathCmd("\\tan", true)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "mathquill-embedded-latex" },
                            [_vm._v("\\tan")]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "math-editor-field-container" }, [
          _c("span", { staticClass: "math-editor-field" })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71e49b16", esExports)
  }
}

/***/ }),

/***/ "Ezk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["myCardList"] = myCardList;
/* harmony export (immutable) */ __webpack_exports__["myCards"] = myCards;
/* harmony export (immutable) */ __webpack_exports__["myCardIds"] = myCardIds;
/* harmony export (immutable) */ __webpack_exports__["selectedPageList"] = selectedPageList;
/* harmony export (immutable) */ __webpack_exports__["selectedPageIds"] = selectedPageIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function myCardList(state) {
  return state.myCardList;
}

function myCards(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keyBy"])(state.myCardList, function (card) {
    return card.id;
  });
}

function myCardIds(state) {
  return state.myCardList.map(function (card) {
    return card.id;
  });
}

function selectedPageList(state) {
  return state.selectedPageList;
}

function selectedPageIds(state) {
  return state.selectedPageList.map(function (page) {
    return page.id;
  });
}

/***/ }),

/***/ "F04J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("0MsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("6Pig");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "F0R5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CardDetails__ = __webpack_require__("7+09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Library__ = __webpack_require__("wJ1H");



var router = [{
  path: '/library',
  redirect: function redirect() {
    return '/library/custom-cards';
  }
}, {
  path: '/library/store-cards',
  redirect: function redirect() {
    return '/library/custom-cards';
  }
}, {
  name: 'library.library',
  path: '/library/:card_type',
  component: __WEBPACK_IMPORTED_MODULE_1__views_Library__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'library.cardDetails',
  path: '/library/:card_type/:card_id',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CardDetails__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "F6Qi":
/***/ (function(module, exports) {

module.exports = {"Play":"Afspil","Pause":"Pause","Current Time":"Aktuel tid","Duration Time":"Varighed","Remaining Time":"Resterende tid","Stream Type":"Stream-type","LIVE":"LIVE","Loaded":"Indlæst","Progress":"Status","Fullscreen":"Fuldskærm","Non-Fullscreen":"Luk fuldskærm","Mute":"Uden lyd","Unmute":"Med lyd","Playback Rate":"Afspilningsrate","Subtitles":"Undertekster","subtitles off":"Uden undertekster","Captions":"Undertekster for hørehæmmede","captions off":"Uden undertekster for hørehæmmede","Chapters":"Kapitler","You aborted the media playback":"Du afbrød videoafspilningen.","A network error caused the media download to fail part-way.":"En netværksfejl fik download af videoen til at fejle.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videoen kunne ikke indlæses, enten fordi serveren eller netværket fejlede, eller fordi formatet ikke er understøttet.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videoafspilningen blev afbrudt på grund af ødelagte data eller fordi videoen benyttede faciliteter som din browser ikke understøtter.","No compatible source was found for this media.":"Fandt ikke en kompatibel kilde for denne media."}

/***/ }),

/***/ "F7iD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_VideoLectureDetails__ = __webpack_require__("OBYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_UploadVideoLecture__ = __webpack_require__("/8gj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_EditVideoLecture__ = __webpack_require__("nDej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_VideoLectureList__ = __webpack_require__("azys");





var router = [{
  name: 'videoLectures.videoLectureList',
  path: '/video-lectures',
  component: __WEBPACK_IMPORTED_MODULE_3__views_VideoLectureList__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoLectures.uploadVideoLecture',
  path: '/upload-video-lecture',
  component: __WEBPACK_IMPORTED_MODULE_1__views_UploadVideoLecture__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoLectures.newVideoLecture',
  path: '/new-video-lecture',
  component: __WEBPACK_IMPORTED_MODULE_2__views_EditVideoLecture__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoLectures.videoLectureDetails',
  path: '/video-lectures/:lecture_id',
  component: __WEBPACK_IMPORTED_MODULE_0__views_VideoLectureDetails__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoLectures.editVideoLecture',
  path: '/video-lectures/:lecture_id/edit',
  component: __WEBPACK_IMPORTED_MODULE_2__views_EditVideoLecture__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "FJSv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FOyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchEventCode"] = fetchEventCode;
/* harmony export (immutable) */ __webpack_exports__["createEventCode"] = createEventCode;
/* harmony export (immutable) */ __webpack_exports__["checkUserClEvents"] = checkUserClEvents;
/* harmony export (immutable) */ __webpack_exports__["setClEvents"] = setClEvents;
/* harmony export (immutable) */ __webpack_exports__["updateClEvent"] = updateClEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("/dQ8");








function fetchEventCode(_ref, eventId) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["o" /* CL_EVENTS_API_URL */] + '/events/' + eventId + '/event-codes').then(function (res) {
    return dispatch('updateClEvent', { eventName: eventId, value: res.data });
  }).catch(function (err) {
    var res = err.response;

    if (res && res.status === 404) {
      return dispatch('updateClEvent', { eventName: eventId, value: false });
    }

    console.error('err while fetching event code:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createEventCode(_ref2, _ref3) {
  var dispatch = _ref2.dispatch;
  var eventId = _ref3.eventId,
      coinAmount = _ref3.coinAmount;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_3__config__["o" /* CL_EVENTS_API_URL */] + '/events/' + eventId + '/event-codes', { coin_amount: coinAmount }).then(function (res) {
    return dispatch('updateClEvent', { eventName: eventId, value: res.data });
  }).catch(function (err) {
    var res = err.response;

    if (res && res.status === 409) {
      console.error(res.data.error_description);
      return true;
    }

    console.error('err while creating event code:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function checkUserClEvents(_ref4, eventId) {
  var dispatch = _ref4.dispatch,
      state = _ref4.state,
      getters = _ref4.getters;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(state.clEvents)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.clEvents);
  }

  var userClEventsStr = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* USER_CL_EVENTS_KEY */] + '/' + getters.currentUserId);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(userClEventsStr)) {
    return dispatch('fetchEventCode', eventId);
  }

  var userClEvents = JSON.parse(userClEventsStr);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(userClEvents[eventId])) {
    return dispatch('fetchEventCode', eventId);
  }

  if (!userClEvents[eventId].is_expired) {
    return dispatch('fetchEventCode', eventId);
  }

  return dispatch('setClEvents', userClEvents);
}

function setClEvents(_ref5, clEvents) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_CL_EVENTS, clEvents);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function updateClEvent(_ref6, _ref7) {
  var commit = _ref6.commit;
  var eventName = _ref7.eventName,
      value = _ref7.value;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].UPDATE_CL_EVENT, { eventName: eventName, value: value });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

/***/ }),

/***/ "FaUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LcAudio_vue__ = __webpack_require__("RX0B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61693b1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LcAudio_vue__ = __webpack_require__("TKkL");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("8/AZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LcAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61693b1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LcAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LcAudio.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61693b1f", Component.options)
  } else {
    hotAPI.reload("data-v-61693b1f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fd6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSummary_vue__ = __webpack_require__("0/hv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018cdf99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSummary_vue__ = __webpack_require__("TXvb");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018cdf99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/library/components/PageSummary.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-018cdf99", Component.options)
  } else {
    hotAPI.reload("data-v-018cdf99", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fi7t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G5b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tooltip-container" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.showTooltip
        ? _c(
            "div",
            {
              staticClass: "tooltip-box hidden-xs-down",
              class: _vm.classBindings
            },
            [
              _c("div", { staticClass: "tooltip-pointer" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tooltip-body text-center" },
                [
                  _vm._t("tooltip-body", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary"
                      },
                      [_vm._v("hello")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary"
                      },
                      [_vm._v("world")]
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-action" }, [
                _c("img", {
                  staticClass: "close-tooltip clickable",
                  attrs: { src: "/static/images/icon-close-tooltip.svg" },
                  on: { click: _vm.close }
                })
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70596efa", esExports)
  }
}

/***/ }),

/***/ "G5f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  user: {},
  device: {}
});

/***/ }),

/***/ "GAqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "library-detail-card dummy-detail-card" }, [
    _c("div", { staticClass: "card-cover-img-thumb" }),
    _vm._v(" "),
    _c("div", { staticClass: "card-block" }, [
      _c("div", { staticClass: "card-info-section" }, [
        _c("div", { staticClass: "row" }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }),
        _vm._v(" "),
        _c("div", { staticClass: "row" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-keywords-section" }, [
        _c("div", { staticClass: "row" })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b92396e", esExports)
  }
}

/***/ }),

/***/ "GDs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPageSummary_vue__ = __webpack_require__("rcBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5538a1e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPageSummary_vue__ = __webpack_require__("xJdW");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPageSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5538a1e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPageSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/MyPageSummary.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5538a1e8", Component.options)
  } else {
    hotAPI.reload("data-v-5538a1e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GEkf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',

  props: {
    attachHome: {
      type: Boolean,
      default: false
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isPublisherUser', 'currentUser', 'isKrUser']), {
    userProfileUrl: function userProfileUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["b" /* CLASSTING_URL */] + '/users/' + this.currentUser.id;
    },
    styleBindings: function styleBindings() {
      if (this.currentUser) {
        return {
          'background-image': 'url(\'' + this.currentUser.profile_image + '\')'
        };
      }

      return {};
    }
  })
});

/***/ }),

/***/ "GFai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoverImageEditModal_vue__ = __webpack_require__("KvMQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b843772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoverImageEditModal_vue__ = __webpack_require__("TcOf");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("W1nl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoverImageEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b843772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoverImageEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/CoverImageEditModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9b843772", Component.options)
  } else {
    hotAPI.reload("data-v-9b843772", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GW0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathEditorModal_vue__ = __webpack_require__("u+tO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e49b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MathEditorModal_vue__ = __webpack_require__("EsBt");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ewOj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathEditorModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e49b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MathEditorModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/MathEditorModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71e49b16", Component.options)
  } else {
    hotAPI.reload("data-v-71e49b16", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gf8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Doughnut */],
  mixins: [reactiveProp],
  data: function data() {
    return {
      chartOptions: {
        cutoutPercentage: 80,
        legend: {
          display: false
        },
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        tooltips: {
          enabled: false
        }
      }
    };
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
});

/***/ }),

/***/ "Gx4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("2uFj");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'course-lecture-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  props: {
    lecture: {
      type: Object,
      default: null
    },
    position: {
      type: Number,
      default: 0
    },
    domainConcepts: {
      type: Object,
      default: null
    },
    domainName: {
      type: String,
      default: ''
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap']), {
    lectureThumbLink: function lectureThumbLink() {
      var defaultLink = __WEBPACK_IMPORTED_MODULE_4__config__["k" /* AWS_CF_URL */] + '/uploads/cover_images/ESC.png';

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.lecture, 'video.pictures[1].link', defaultLink);
    },
    lectureThumbStyle: function lectureThumbStyle() {
      return {
        'background-image': 'url(\'' + this.lectureThumbLink + '\')'
      };
    },
    lectureDescription: function lectureDescription() {
      if (this.lecture && this.lecture.description) {
        return this.lecture.description.replace(/\n/g, '<br>');
      }

      return null;
    },
    domainConceptName: function domainConceptName() {
      if (this.domainConcepts && this.lecture) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.domainConcepts[this.lecture.domain_concept_id], 'name', '');
      }

      return '';
    }
  })
});

/***/ }),

/***/ "H/op":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H2zE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContentModal_vue__ = __webpack_require__("hg9+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd431990_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContentModal_vue__ = __webpack_require__("Ospv");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd431990_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ReportContentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dd431990", Component.options)
  } else {
    hotAPI.reload("data-v-dd431990", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H3S0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("K49E");







function subscribe(store) {
  store.subscribe(function (mutation, _ref) {
    var Auth = _ref.Auth;

    switch (mutation.type) {

      case __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_TOKEN:
        {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__plugins_http__["c" /* setToken */])(Auth.token);
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_USER:
        {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$ga.set('userId', Auth.user.id);
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$ga.set('dimension1', Auth.user.role);
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$ga.set('dimension2', Auth.user.grade);
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$ga.set('dimension3', Auth.user.school_id);
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$ga.set('dimension4', Auth.user.zipcode);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__plugins_http__["d" /* setCountryCode */])(Auth.user.country_code);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PROPERTY:
        {
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SIGN_OUT:
        {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__plugins_http__["e" /* removeToken */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__plugins_http__["f" /* removeCountryCode */])();

          if (__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].currentRoute.meta.requiresAuth) {
            window.location.href = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* CLASSTING_FULL_AUTH_URL */];
          }

          break;
        }

      default:
        {
          break;
        }

    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  subscribe(store);
});

/***/ }),

/***/ "HNYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainSelect_vue__ = __webpack_require__("Iwjx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8febac6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainSelect_vue__ = __webpack_require__("wNoM");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("o4Zc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8febac6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/DomainSelect.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8febac6c", Component.options)
  } else {
    hotAPI.reload("data-v-8febac6c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCourseItem_vue__ = __webpack_require__("XS48");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3afacfe0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCourseItem_vue__ = __webpack_require__("0OPP");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("DrZz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3afacfe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCourseItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3afacfe0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCourseItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-courses/components/VideoCourseItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3afacfe0", Component.options)
  } else {
    hotAPI.reload("data-v-3afacfe0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hwr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "page-library-modal",
      attrs: { id: "page-library-modal" },
      on: { shown: _vm.setup, hidden: _vm.clean }
    },
    [
      _c(
        "div",
        {
          staticClass: "container page-library-header",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _c("div", { staticClass: "row btn-row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "hide::modal",
                          "page-library-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.close")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Tooltip",
                  {
                    staticClass: "float-right",
                    attrs: { position: "bottom", show: _vm.showTooltip },
                    on: { "tooltip-closed": _vm.onTooltipClosed }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          disabled: _vm.selectedPageList.length === 0
                        },
                        on: { click: _vm.importPages }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.add")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "tooltip-body" }, slot: "tooltip-body" },
                      [
                        _c("div", {
                          staticClass:
                            "typography--body-3 typography--color-secondary",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("common.tooltip.try_select_and_add_pages")
                            )
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.selectedPageList.length > 0,
                        expression: "selectedPageList.length > 0"
                      }
                    ],
                    staticClass: "float-right text-right selected-page-count"
                  },
                  [
                    _c("small", { staticClass: "typography--caption" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("page_library.selected_count", {
                            cnt: _vm.selectedPageList.length
                          })
                        )
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "nav",
                {
                  staticClass:
                    "navbar navbar-toggleable navbar-light justify-content-center"
                },
                [
                  _c(
                    "ul",
                    { staticClass: "nav navbar-nav justify-content-center" },
                    [
                      _c(
                        "li",
                        {
                          staticClass: "nav-item",
                          class: _vm.isNotQuizTabBindings
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link typography--body-3",
                              on: {
                                click: function($event) {
                                  return _vm.selectIsQuiz("0")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.card.non_quiz")))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "nav-item",
                          class: _vm.isQuizTabBindings
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link typography--body-3",
                              on: {
                                click: function($event) {
                                  return _vm.selectIsQuiz("1")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.card.quiz")))]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container page-library-body mw-960" }, [
        _c("div", { staticClass: "row browse-filter-row" }, [
          _c("div", { staticClass: "col-12 col-lg-7" }, [
            _c("div", { staticClass: "row box" }, [
              _c(
                "div",
                { staticClass: "col-sm-3 divider" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown",
                      attrs: {
                        text: _vm.getTranslatedName(
                          _vm.gradeMap[_vm.pageLibraryFilters.grade_id]
                        )
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectGrade("0", "0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.all_grades")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.gradeList, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            on: {
                              click: function($event) {
                                return _vm.selectGrade(
                                  value.id,
                                  value.school_year
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getTranslatedName(_vm.gradeMap[value.id])
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectGrade("null", "null")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.others")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 divider" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown",
                      attrs: {
                        id: "page-subject-dropdown",
                        text: _vm.getTranslatedName(
                          _vm.subjectMap[_vm.pageLibraryFilters.subject_id]
                        )
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectSubject("0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.all_subjects")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.gradeSubjects, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            on: {
                              click: function($event) {
                                return _vm.selectSubject(value.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getTranslatedName(
                                    _vm.subjectMap[value.id]
                                  )
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown",
                      attrs: {
                        text:
                          _vm.getUnitLabel(
                            _vm.units[_vm.pageLibraryFilters.unit_id]
                          ) || _vm.$t("common.browse_filters.all_chapters"),
                        id: "page-unit-dropdown"
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectUnit("0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("common.browse_filters.all_chapters")
                              ) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.currentUnitList, function(unit) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: unit.id,
                            on: {
                              click: function($event) {
                                return _vm.selectUnit(unit.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getUnitLabel(unit)) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-lg-5" },
            [
              _c("SearchInput", {
                attrs: {
                  "model-value": _vm.pageLibraryFilters.search_keywords
                },
                on: { input: _vm.applySearchKeywords }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row browse-filter-row" }, [
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.pageLibraryFilters.media_type,
                    "check-value": "all",
                    id: "media-type-all"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.all"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.pageLibraryFilters.media_type,
                    "check-value": "image",
                    id: "media-type-image"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.image"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.pageLibraryFilters.media_type,
                    "check-value": "video",
                    id: "media-type-video"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.video"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.pageLibraryFilters.media_type,
                    "check-value": "audio",
                    id: "media-type-audio"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.audio"))
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4" }, [
            _c("ul", { staticClass: "nav justify-content-end order-by-btns" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link typography--color-secondary",
                    class: {
                      active: _vm.pageLibraryFilters.order_by === "updated_at"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectOrderBy("updated_at")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.order_by.recency"))
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link typography--color-secondary",
                    class: {
                      active: _vm.pageLibraryFilters.order_by === "popularity"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectOrderBy("popularity")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("common.browse_filters.order_by.popularity")
                      )
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "card-row" }, [_c("DummyPageItem")], 1)
              ])
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm._l(_vm.storePageList, function(page, index) {
                  return _c("div", { key: page.id, staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "card-row" },
                      [_c("PageItem", { attrs: { page: page, index: index } })],
                      1
                    )
                  ])
                }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 text-center mb-5 pb-5",
                        attrs: { slot: "no-more" },
                        slot: "no-more"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "empty-list-text typography--body-2 typography--color-disabled pt-4"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("page_library.no_pages")) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              2
            )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37f9aa91", esExports)
  }
}

/***/ }),

/***/ "IBWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'in-progress-badge'
});

/***/ }),

/***/ "IFeR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IQA+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ISPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mdc-checkbox-container",
      class: { "mdc-checkbox-container--disabled": _vm.disabled }
    },
    [
      _c(
        "div",
        {
          staticClass: "mdc-checkbox",
          class: { "mdc-checkbox--disabled": _vm.disabled }
        },
        [
          _c("input", {
            staticClass: "mdc-checkbox__native-control",
            attrs: { type: "checkbox", id: _vm.id, disabled: _vm.disabled },
            domProps: { checked: _vm.state },
            on: { change: _vm.onChange }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mdc-checkbox__background" }, [
            !_vm.disabled
              ? _c(
                  "svg",
                  {
                    staticClass: "mdc-checkbox__checkmark",
                    attrs: { viewBox: "0 0 24 24" }
                  },
                  [
                    _c("path", {
                      staticClass: "mdc-checkbox__checkmark__path",
                      attrs: {
                        fill: "none",
                        stroke: "white",
                        d: "M1.73,12.91 8.1,19.28 22.79,4.59"
                      }
                    })
                  ]
                )
              : _c("img", {
                  attrs: { src: "/static/images/checkbox-disabled-btn.svg" }
                }),
            _vm._v(" "),
            _c("div", { staticClass: "mdc-checkbox__mixedmark" })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass:
            "typography--caption typography--color-secondary clickable",
          attrs: { for: _vm.id }
        },
        [_vm._t("label")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-756cbb1a", esExports)
  }
}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules__ = __webpack_require__("rh7Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins__ = __webpack_require__("bGDG");











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  strict: "staging" !== 'production',

  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,

  modules: __WEBPACK_IMPORTED_MODULE_6__modules__["a" /* default */],
  plugins: __WEBPACK_IMPORTED_MODULE_7__plugins__["a" /* default */],

  getters: __WEBPACK_IMPORTED_MODULE_5__getters__
}));

/***/ }),

/***/ "IhEY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iqoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "card",
      on: {
        mouseover: function($event) {
          return _vm.$emit("mouseover")
        },
        mouseleave: function($event) {
          return _vm.$emit("mouseleave")
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54cdc180", esExports)
  }
}

/***/ }),

/***/ "Iwjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DomainSelectOption__ = __webpack_require__("aTk2");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'domain-select',

  components: {
    DomainSelectOption: __WEBPACK_IMPORTED_MODULE_0__DomainSelectOption__["a" /* default */]
  },

  props: {
    domains: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedDomainIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    isSelectedDomain: function isSelectedDomain(domainId) {
      return this.selectedDomainIds.indexOf(domainId) !== -1;
    }
  }
});

/***/ }),

/***/ "JDL/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mdc-form-field mdc-switch-container" }, [
    _c(
      "label",
      {
        staticClass:
          "mdc-switch-label typography--body-3 typography--color-secondary clickable",
        attrs: { for: _vm.id }
      },
      [_vm._t("label")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mdc-switch" }, [
      _c("input", {
        staticClass: "mdc-switch__native-control",
        attrs: { type: "checkbox", id: _vm.id },
        domProps: { checked: _vm.state },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mdc-switch__background" }, [
      _c("div", { staticClass: "mdc-switch__knob" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8babe050", esExports)
  }
}

/***/ }),

/***/ "JOTJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JX/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "class-card clickable" }, [
    _c("div", {
      staticClass: "card-cover-img-thumb",
      style: _vm.styleBindings,
      on: { click: _vm.goToClassReport }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "card-cover-text" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.cls.year) +
          " " +
          _vm._s(_vm.getShortenedString(_vm.cls.school_name, 10))
      ),
      _c("br"),
      _vm._v(
        "\n    " +
          _vm._s(_vm.cls.grade) +
          _vm._s(_vm.$t("card_details.card_meta.grade")) +
          " " +
          _vm._s(_vm.getShortenedString(_vm.cls.name, 15)) +
          _vm._s(_vm.$t("common.class")) +
          " | " +
          _vm._s(_vm.$t("common.student")) +
          " " +
          _vm._s(_vm.studentList.length) +
          _vm._s(_vm.$t("common.modal.preview.count\n")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "clickable card-cover-bottom",
        on: { click: _vm.goToClassReport }
      },
      [
        _c("div", { staticClass: "class-card-asmt-cnt" }, [
          _vm._v(_vm._s(_vm.assignmentCount))
        ]),
        _vm._v("\n     " + _vm._s(_vm.$t("reports.assignment_count")) + "\n  ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d78fcbc", esExports)
  }
}

/***/ }),

/***/ "Ji8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "hide-header-menu inquiry-form" }, [
    _c(
      "div",
      {
        staticClass: "container",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row inquiry-form-header" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "inquiry-form-header__title text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.header.title")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inquiry-form-header__subtitle text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.header.subtitle")) +
                    "\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row inquiry-form-form" }, [
          _c("div", { staticClass: "col-12 mx-auto" }, [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("schoolName") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "school-name-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.school_name")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.schoolName,
                      expression: "schoolName"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: {
                    "form-control-danger": _vm.errors.has("schoolName")
                  },
                  attrs: {
                    type: "text",
                    id: "school-name-input",
                    placeholder: _vm.$t(
                      "inquiry_form.form.school_name_placeholder"
                    ),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.schoolName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.schoolName = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("name") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "name-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.name")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("name") },
                  attrs: {
                    type: "text",
                    id: "name-input",
                    placeholder: _vm.$t("inquiry_form.form.name_placeholder"),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("position") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "position-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.position")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.position,
                      expression: "position"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("position") },
                  attrs: {
                    type: "text",
                    id: "position-input",
                    placeholder: _vm.$t(
                      "inquiry_form.form.position_placeholder"
                    ),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.position },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.position = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("email") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "email-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.email")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("email") },
                  attrs: {
                    type: "email",
                    id: "email-input",
                    placeholder: _vm.$t("inquiry_form.form.email_placeholder"),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("mobile") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "mobile-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.mobile")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mobile,
                      expression: "mobile"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("mobile") },
                  attrs: {
                    type: "tel",
                    id: "mobile-input",
                    placeholder: _vm.$t("inquiry_form.form.mobile_placeholder"),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.mobile },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mobile = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass: "inquiry-form-form__label",
                  attrs: { for: "content-input" }
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("inquiry_form.form.content")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content"
                  }
                ],
                staticClass: "form-control basic-text-input",
                attrs: {
                  id: "content-input",
                  placeholder: _vm.$t("inquiry_form.form.content_placeholder"),
                  rows: "6"
                },
                domProps: { value: _vm.content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.content = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-full inquiry-form-form__submit-btn",
                  attrs: { disabled: _vm.isFormInvalid },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [
                  !_vm.busy
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("inquiry_form.form.submit_btn")))
                      ])
                    : _c("LoadingBounce")
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row inquiry-form-contact" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "inquiry-form-contact__title text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.contact.title")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inquiry-form-contact__subtitle text-center" },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-outline-primary inquiry-form-contact__subtitle-btn",
                    attrs: {
                      href: "tel:" + _vm.$t("inquiry_form.contact.subtitle")
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("inquiry_form.contact.subtitle")) +
                        "\n          "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inquiry-form-contact__desc text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.contact.desc")) +
                    "\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row inquiry-form-footer" }, [
          _c(
            "div",
            { staticClass: "col-12 text-center" },
            [_c("FooterContent")],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "inquiry-submitted-alert",
              "hide-header": true,
              "no-close-on-backdrop": true,
              "ok-title": _vm.$t("common.confirm")
            },
            on: { ok: _vm.goBack }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("inquiry_form.modal.inquiry_submitted_alert")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "basic-error-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.basic_error_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94fd00aa", esExports)
  }
}

/***/ }),

/***/ "JmJ5":
/***/ (function(module, exports) {

module.exports = {"Play":"Spill","Pause":"Pause","Current Time":"Aktuell tid","Duration Time":"Varighet","Remaining Time":"Gjenstående tid","Stream Type":"Type strøm","LIVE":"DIREKTE","Loaded":"Lastet inn","Progress":"Status","Fullscreen":"Fullskjerm","Non-Fullscreen":"Lukk fullskjerm","Mute":"Lyd av","Unmute":"Lyd på","Playback Rate":"Avspillingsrate","Subtitles":"Undertekst på","subtitles off":"Undertekst av","Captions":"Undertekst for hørselshemmede på","captions off":"Undertekst for hørselshemmede av","Chapters":"Kapitler","You aborted the media playback":"Du avbrøt avspillingen.","A network error caused the media download to fail part-way.":"En nettverksfeil avbrøt nedlasting av videoen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videoen kunne ikke lastes ned, på grunn av nettverksfeil eller serverfeil, eller fordi formatet ikke er støttet.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videoavspillingen ble avbrudt på grunn av ødelagte data eller fordi videoen ville gjøre noe som nettleseren din ikke har støtte for.","No compatible source was found for this media.":"Fant ikke en kompatibel kilde for dette mediainnholdet."}

/***/ }),

/***/ "Jmjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_QuizPreview__ = __webpack_require__("oFyy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_quiz__ = __webpack_require__("cUxh");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-quiz-modal',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_quiz__["a" /* default */]],

  props: {
    quiz: {
      type: Object,
      default: {}
    }
  },

  components: {
    QuizPreview: __WEBPACK_IMPORTED_MODULE_4__components_QuizPreview__["a" /* default */]
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['deleteQuiz']), {
    handleDeleteClick: function handleDeleteClick() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.quiz.id) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this.deleteQuiz(_this.quiz.id);

              case 4:
                _context.next = 6;
                return _this.$emit('cancel');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    isLoading: 'isLoadingQuiz'
  }), {
    getQuizSet: function getQuizSet() {
      return this.quiz.quiz_set || {};
    },
    isActiveQuiz: function isActiveQuiz() {
      return this.getQuizState(this.getQuizSet).value === 'active';
    },
    isEndQuiz: function isEndQuiz() {
      return this.getQuizState(this.getQuizSet).value === 'end';
    },
    isReviewCompletedQuiz: function isReviewCompletedQuiz() {
      return this.getQuizState(this.getQuizSet).value === 'review_completed';
    }
  })

});

/***/ }),

/***/ "JsV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    [
      _c(
        "div",
        {
          staticClass: "container mw-960",
          attrs: { slot: "layout-body" },
          slot: "layout-body"
        },
        [
          _c("div", { staticClass: "error-container text-center" }, [
            _c("img", {
              attrs: { src: "/static/images/signin-lcic-inactive.svg" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "typography--content-body",
              domProps: { innerHTML: _vm._s(_vm.$t("errors.not_found_msg")) }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("AppFooter", { attrs: { slot: "footer" }, slot: "footer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce5b7f86", esExports)
  }
}

/***/ }),

/***/ "K49E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_PROPERTY = 'auth/SET_PROPERTY';
var SET_TOKEN = 'auth/SET_TOKEN';
var SET_USER = 'auth/SET_USER';
var SIGN_OUT = 'auth/SIGN_OUT';
var SET_DEVICE = 'auth/SET_DEVICE';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_PROPERTY: SET_PROPERTY,
  SET_TOKEN: SET_TOKEN,
  SET_USER: SET_USER,
  SIGN_OUT: SIGN_OUT,
  SET_DEVICE: SET_DEVICE
});

/***/ }),

/***/ "K8Cj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown more-btn-dropdown", class: _vm.classBindings },
    [
      _c("button", {
        staticClass: "btn rounded-circle menu-toggle",
        on: { click: _vm.toggleMenu }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dropdown-menu dropdown-menu-right" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24f70df8", esExports)
  }
}

/***/ }),

/***/ "K9lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FETCH_MY_QUIZZES_REQUEST = 'my-quizzes/FETCH_MY_QUIZZES_REQUEST';
var FETCH_MY_QUIZZES_SUCCESS = 'my-quizzes/FETCH_MY_QUIZZES_SUCCESS';
var FETCH_INFINITE_MY_QUIZZES_SUCCESS = 'my-quizzes/FETCH_INFINITE_MY_QUIZZES_SUCCESS';
var FETCH_MY_QUIZZES_FAILURE = 'my-quizzes/FETCH_MY_QUIZZES_FAILURE';
var SET_QUIZ_REQUEST = 'my-quizzes/SET_QUIZ_REQUEST';
var SET_QUIZ_SUCCESS = 'my-quizzes/SET_QUIZ_SUCCESS';
var SET_QUIZ_FAILURE = 'my-quizzes/SET_SET_QUIZ_FAILURE';
var PUT_QUIZ_REQUEST = 'my-quizzes/PUTQUIZ_REQUEST';
var PUT_QUIZ_SUCCESS = 'my-quizzes/PUT_QUIZ_SUCCESS';
var PUT_QUIZ_FAILURE = 'my-quizzes/PUT_QUIZ_FAILURE';
var DELETE_QUIZ_REQUEST = 'my-quizzes/DELETE_QUIZ_REQUEST';
var DELETE_QUIZ_SUCCESS = 'my-quizzes/DELETE_QUIZ_SUCCESS';
var DELETE_QUIZ_FAILURE = 'my-quizzes/DELETE_QUIZ_FAILURE';

/* harmony default export */ __webpack_exports__["a"] = ({
  FETCH_MY_QUIZZES_REQUEST: FETCH_MY_QUIZZES_REQUEST,
  FETCH_MY_QUIZZES_SUCCESS: FETCH_MY_QUIZZES_SUCCESS,
  FETCH_INFINITE_MY_QUIZZES_SUCCESS: FETCH_INFINITE_MY_QUIZZES_SUCCESS,
  FETCH_MY_QUIZZES_FAILURE: FETCH_MY_QUIZZES_FAILURE,
  SET_QUIZ_REQUEST: SET_QUIZ_REQUEST,
  SET_QUIZ_SUCCESS: SET_QUIZ_SUCCESS,
  SET_QUIZ_FAILURE: SET_QUIZ_FAILURE,
  PUT_QUIZ_REQUEST: PUT_QUIZ_REQUEST,
  PUT_QUIZ_SUCCESS: PUT_QUIZ_SUCCESS,
  PUT_QUIZ_FAILURE: PUT_QUIZ_FAILURE,
  DELETE_QUIZ_REQUEST: DELETE_QUIZ_REQUEST,
  DELETE_QUIZ_SUCCESS: DELETE_QUIZ_SUCCESS,
  DELETE_QUIZ_FAILURE: DELETE_QUIZ_FAILURE
});

/***/ }),

/***/ "KBWG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KPqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpDownArrow_vue__ = __webpack_require__("mfnR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e6e7a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpDownArrow_vue__ = __webpack_require__("9ItA");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("TqFq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24e6e7a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpDownArrow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e6e7a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpDownArrow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/UpDownArrow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24e6e7a8", Component.options)
  } else {
    hotAPI.reload("data-v-24e6e7a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KQEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("u655");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "KW6q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LcImage_vue__ = __webpack_require__("amYd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d9fe24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LcImage_vue__ = __webpack_require__("uUra");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LcImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d9fe24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LcImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LcImage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21d9fe24", Component.options)
  } else {
    hotAPI.reload("data-v-21d9fe24", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.2","/home/runner/work/learning-web/learning-web"]],"_development":true,"_from":"elliptic@6.5.2","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.2","saveSpec":null,"fetchSpec":"6.5.2"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_spec":"6.5.2","_where":"/home/runner/work/learning-web/learning-web","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}

/***/ }),

/***/ "KcW0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__("wbe0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c55e1cb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__("umTm");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("A3f9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c55e1cb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ProgressBar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c55e1cb4", Component.options)
  } else {
    hotAPI.reload("data-v-c55e1cb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KdCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicDropup_vue__ = __webpack_require__("1nS0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4707d4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicDropup_vue__ = __webpack_require__("DlYF");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopicDropup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4707d4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopicDropup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/TopicDropup.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d4707d4e", Component.options)
  } else {
    hotAPI.reload("data-v-d4707d4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kj51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_ADVERTISEMENT = 'advertisements/SET_ADVERTISEMENT';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_ADVERTISEMENT: SET_ADVERTISEMENT
});

/***/ }),

/***/ "Kpuh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("xYUW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("QnFA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("5hnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("ASz9");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "KunQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'custom-modal',

  props: {
    id: String,
    title: String,
    okTitle: {
      type: String,
      default: null
    },
    closeTitle: {
      type: String,
      default: null
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    okBusy: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    isHideFooter: {
      type: Boolean,
      default: false
    },
    isCustomFooter: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "KvMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cover-image-edit-modal',

  props: {
    seriesItem: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      loading: false,
      coverImage: null,
      coverImageFile: null,
      acceptableFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      fileSizeLimit: 10 * 1024 * 1024,
      busy: false
    };
  },


  computed: {
    coverImageStyle: function coverImageStyle() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.coverImage)) {
        return {
          'background-image': 'url(\'' + this.coverImage + '\')'
        };
      }

      return {};
    },
    saveDisabled: function saveDisabled() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.seriesItem)) {
        return this.coverImage === this.seriesItem.cover_image;
      }

      return true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['uploadNewSeriesCoverImage']), {
    onCoverImageChange: function onCoverImageChange() {
      var images = event.target.files || event.dataTransfer.files;

      if (!images.length) {
        return null;
      }

      var file = images[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (file.size > this.fileSizeLimit) {
        return this.$root.$emit('show::modal', 'file-size-alert');
      }

      if (this.acceptableFileTypes.indexOf(file.type) === -1) {
        return this.$root.$emit('show::modal', 'file-type-alert');
      }

      return this.createMedia(file, 'image');
    },
    createMedia: function createMedia(file) {
      var _this = this;

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function (event) {
        _this.coverImage = event.target.result;
        _this.coverImageFile = file;
      };

      return reader.readAsDataURL(file);
    },
    save: function save() {
      var _this2 = this;

      if (!this.busy) {
        this.busy = true;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.coverImageFile)) {
          return;
        }

        var params = {
          seriesId: this.seriesItem.id,
          imageFile: this.coverImageFile
        };

        this.uploadNewSeriesCoverImage(params).then(function () {
          return _this2.$emit('ok');
        });
      }
    }
  }),

  beforeMount: function beforeMount() {
    this.loading = true;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.seriesItem)) {
      this.coverImage = this.seriesItem.cover_image;
    }

    this.loading = false;
  }
});

/***/ }),

/***/ "L2mm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_StudentReport__ = __webpack_require__("p1XE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_ClassReport__ = __webpack_require__("U+y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Classes__ = __webpack_require__("ElHX");




var router = [{
  name: 'classes.classes',
  path: '/reports/classes',
  component: __WEBPACK_IMPORTED_MODULE_2__views_Classes__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  path: '/reports/classes/:class_id',
  component: __WEBPACK_IMPORTED_MODULE_1__views_ClassReport__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  path: '/reports/classes/:class_id/students/:student_id',
  component: __WEBPACK_IMPORTED_MODULE_0__views_StudentReport__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* unused harmony default export */ var _unused_webpack_default_export = (router);

/***/ }),

/***/ "L6A9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("ALjK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("x94F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("x2Y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("6Pfz");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "LCT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-main'
});

/***/ }),

/***/ "LDaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCardDetails_vue__ = __webpack_require__("UHCP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e0e43f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCardDetails_vue__ = __webpack_require__("LSKi");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCardDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e0e43f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCardDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/views/MyCardDetails.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33e0e43f", Component.options)
  } else {
    hotAPI.reload("data-v-33e0e43f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LF/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesEditModal_vue__ = __webpack_require__("p9Zn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422b0494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesEditModal_vue__ = __webpack_require__("Lqim");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("WU4l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422b0494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/SeriesEditModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-422b0494", Component.options)
  } else {
    hotAPI.reload("data-v-422b0494", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LGuJ":
/***/ (function(module, exports) {

module.exports = {"Play":"Відтворити","Pause":"Призупинити","Current Time":"Поточний час","Duration Time":"Тривалість","Remaining Time":"Час, що залишився","Stream Type":"Тип потоку","LIVE":"НАЖИВО","Loaded":"Завантаження","Progress":"Прогрес","Fullscreen":"Повноекранний режим","Non-Fullscreen":"Неповноекранний режим","Mute":"Без звуку","Unmute":"Зі звуком","Playback Rate":"Швидкість відтворення","Subtitles":"Субтитри","subtitles off":"Без субтитрів","Captions":"Підписи","captions off":"Без підписів","Chapters":"Розділи","You aborted the media playback":"Ви припинили відтворення відео","A network error caused the media download to fail part-way.":"Помилка мережі викликала збій під час завантаження відео.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Неможливо завантажити відео через мережевий чи серверний збій або формат не підтримується.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Відтворення відео було припинено через пошкодження або у зв'язку з тим, що відео використовує функції, які не підтримуються вашим браузером.","No compatible source was found for this media.":"Сумісні джерела для цього відео відсутні."}

/***/ }),

/***/ "LSKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-lg-4 col-xl-4" },
            [
              _c("CardTitleInput", {
                staticClass:
                  "action-header typography--headline typography--title",
                attrs: { "model-value": _vm.card.title },
                on: { input: _vm.applyCardTitle, "has-error": _vm.onHasError }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-8 col-lg-8 col-xl-8 hidden-sm-down" },
            [
              _c(
                "div",
                { staticClass: "action-btn-row" },
                [
                  _c(
                    "MoreBtnDropdown",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass:
                            "dropdown-item typography--color-secondary",
                          on: {
                            click: function($event) {
                              return _vm.$root.$emit(
                                "show::modal",
                                "delete-my-card-modal"
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.card.menu.remove")))]
                      ),
                      _vm._v(" "),
                      this.isBusanPublisher
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-label",
                                  style: { "padding-left": "20px" }
                                },
                                [_c("strong", [_vm._v("부산교육청 메뉴")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.$root.$emit(
                                        "show::modal",
                                        "export-content"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                BEST로 내보내기\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right ml-1 mr-1",
                      attrs: { disabled: _vm.saveDisabled || !this.isModified },
                      on: { click: _vm.saveMyCard }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("common.save")))])
                        : _c("LoadingBounce")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary float-right mr-1",
                      on: { click: _vm.openCardPreview }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.preview")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-outline-primary float-right ml-1 mr-1",
                      staticStyle: { padding: "5px 16px" },
                      attrs: { disabled: _vm.saveDisabled },
                      on: {
                        click: function($event) {
                          return _vm.handleMyCardShareSetupClick(
                            _vm.card.id,
                            _vm.card.share_level
                          )
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-hotspot.svg" }
                      }),
                      _vm._v(" "),
                      _vm.card.share_level === 2
                        ? _c("span", [_vm._v("비공개중")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.share_level === 1
                        ? _c("span", [_vm._v("전체 공개중")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.share_level === 3
                        ? _c("span", [_vm._v("기관 공개중")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.share_level === 99
                        ? _c("span", [_vm._v("숨김처리중")])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-4 pt-1",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              { staticClass: "card-row" },
              [
                _c("Card", { staticClass: "library-detail-card" }, [
                  _c("div", {
                    staticClass: "card-cover-img-thumb",
                    style: _vm.styleBindings
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "card-cover-img-input text-center clickable"
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-camera.svg", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "no-display",
                        attrs: {
                          type: "file",
                          accept: "image/png,image/jpeg,image/jpg"
                        },
                        on: { change: _vm.onCoverImageChange }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-block" }, [
                    _c("div", { staticClass: "card-info-section" }, [
                      !_vm.card.subject_id
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.subject_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getSubjectLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      _vm.card.grade_id === undefined
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.grade_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getGradeLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      !_vm.card.unit_id
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.chapter_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.unit_id
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.card.chapter_name) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.core_concept_id === undefined ||
                      _vm.card.core_concept_id === null
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.core_concepts_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _vm.isPublisherUser
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getCoreConceptLabel(
                                              _vm.coreConcepts[
                                                _vm.card.core_concept_id
                                              ]
                                            ) +
                                              " (" +
                                              _vm.card.core_concept_id +
                                              ")"
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getCoreConceptLabel(
                                              _vm.coreConcepts[
                                                _vm.card.core_concept_id
                                              ]
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-keywords-section" }, [
                      _vm.card.core_concept_id
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.learning_elements"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-8" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.getLearningElements(
                                          _vm.coreConcepts[
                                            _vm.card.core_concept_id
                                          ]
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-action" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary btn-block",
                          attrs: { disabled: _vm.isLoadingVideoCourseCard },
                          on: {
                            click: function($event) {
                              return _vm.$root.$emit(
                                "show::modal",
                                "edit-card-modal"
                              )
                            }
                          }
                        },
                        [
                          _vm.isLoadingVideoCourseCard
                            ? [_c("LoadingBounce")]
                            : [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("card_details.card_meta.edit")
                                    ) +
                                    "\n                "
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          staticClass: "edit-card-modal",
                          attrs: {
                            id: "edit-card-modal",
                            title: _vm.$t("card_details.card_meta.edit"),
                            "ok-title": _vm.$t("common.save"),
                            "close-title": _vm.$t("common.cancel")
                          },
                          on: {
                            ok: _vm.applySelectedCardInfo,
                            shown: _vm.setupEditCardModal
                          }
                        },
                        [
                          _c("div", { staticClass: "dropdown-group" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-secondary",
                                  attrs: { for: "card-title-input" }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.title")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected.title,
                                    expression: "selected.title"
                                  }
                                ],
                                staticClass: "form-control basic-text-input",
                                attrs: {
                                  type: "text",
                                  id: "card-title-input",
                                  placeholder: _vm.$t(
                                    "card_details.card_meta.title_placeholder"
                                  ),
                                  maxlength: "50"
                                },
                                domProps: { value: _vm.selected.title },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.selected,
                                      "title",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isPublisherUser
                            ? _c("div", { staticClass: "dropdown-group" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "typography--body-3 typography--color-secondary",
                                        attrs: { for: "card-goal-input" }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "card_details.card_meta.goal"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("AutosizeTextarea", {
                                      staticClass:
                                        "form-control basic-text-input",
                                      attrs: {
                                        id: "card-goal-input",
                                        rows: 3,
                                        limit: 5000,
                                        placeholder: _vm.$t(
                                          "card_details.card_meta.goal_placeholder"
                                        )
                                      },
                                      model: {
                                        value: _vm.selected.goal,
                                        callback: function($$v) {
                                          _vm.$set(_vm.selected, "goal", $$v)
                                        },
                                        expression: "selected.goal"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text: _vm.getTranslatedName(
                                      _vm.gradeMap[_vm.selected.grade_id]
                                    )
                                  }
                                },
                                [
                                  _vm._l(_vm.gradeList, function(value, key) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: key,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGrade(
                                              value.id,
                                              value.school_year
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getTranslatedName(
                                                _vm.gradeMap[value.id]
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectGrade(null, "null")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("common.selects.others")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    id: "subject-dropdown",
                                    text: _vm.getTranslatedName(
                                      _vm.subjectMap[_vm.selected.subject_id]
                                    )
                                  }
                                },
                                _vm._l(_vm.gradeSubjects, function(value, key) {
                                  return _c(
                                    "b-dropdown-item",
                                    {
                                      key: key,
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSubject(value.id)
                                        }
                                      }
                                    },
                                    [
                                      value.id
                                        ? [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.getTranslatedName(
                                                    _vm.subjectMap[value.id]
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text:
                                      _vm.getUnitLabel(
                                        _vm.units[_vm.selected.unit_id]
                                      ) ||
                                      _vm.$t("card_details.card_meta.select"),
                                    id: "unit-dropdown"
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectUnit("9999")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "card_details.card_meta.select"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.currentUnitList, function(unit) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: unit.id,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectUnit(unit.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.getUnitLabel(unit)) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text:
                                      _vm.getDetailedCoreConceptLabel(
                                        _vm.coreConcepts[
                                          _vm.selected.core_concept_id
                                        ]
                                      ) ||
                                      _vm.$t("card_details.card_meta.select"),
                                    id: "core-concept-dropdown"
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectCoreConcept("9999")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "card_details.card_meta.select"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.currentCoreConceptList, function(
                                    coreConcept
                                  ) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: coreConcept.id,
                                        attrs: {
                                          title:
                                            _vm.$t(
                                              "card_details.card_meta.learning_elements"
                                            ) +
                                            ": " +
                                            coreConcept.description
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectCoreConcept(
                                              coreConcept.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getDetailedCoreConceptLabel(
                                                coreConcept
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "keyword-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "keyword-label typography--body-3 typography--color-secondary"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.learning_elements"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "keyword-container" }, [
                              _vm.coreConcepts[_vm.selected.core_concept_id]
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-secondary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getLearningElements(
                                              _vm.coreConcepts[
                                                _vm.selected.core_concept_id
                                              ]
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isPublisherUser
                            ? _c("div", { staticClass: "dropdown-group" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-secondary",
                                      attrs: { for: "video-course-id" }
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "card_details.card_meta.video_course"
                                              )
                                            ) +
                                            "\n                      "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selected.video_course_id,
                                        expression: "selected.video_course_id"
                                      }
                                    ],
                                    staticClass:
                                      "form-control basic-text-input",
                                    attrs: {
                                      type: "text",
                                      id: "video-course-id"
                                    },
                                    domProps: {
                                      value: _vm.selected.video_course_id
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.selected,
                                          "video_course_id",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.pagesReady,
                  expression: "!pagesReady"
                }
              ],
              staticClass: "col-md-8"
            },
            [
              _c(
                "div",
                { staticClass: "card-row" },
                [_c("DummyPageSummary")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pagesReady,
                  expression: "pagesReady"
                }
              ],
              staticClass: "col-md-8"
            },
            [
              _c(
                "draggable",
                {
                  on: {
                    start: function($event) {
                      _vm.drag = true
                    },
                    end: function($event) {
                      _vm.drag = false
                    }
                  },
                  model: {
                    value: _vm.card.pages,
                    callback: function($$v) {
                      _vm.$set(_vm.card, "pages", $$v)
                    },
                    expression: "card.pages"
                  }
                },
                _vm._l(_vm.card.pages, function(page, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "card-row" },
                    [
                      _c("MyPageSummary", {
                        attrs: {
                          page: page,
                          card: _vm.card,
                          index: index,
                          "card-title": _vm.card.title
                        },
                        on: {
                          "edit-page": _vm.openPageEditorModal,
                          "remove-page": _vm.openRemovePageModal,
                          "hidden-page": _vm.openHiddenPageModal,
                          "recover-hidden-page": _vm.openRecoverHiddenPageModal,
                          "edit-extra-content": _vm.openEditExtraContentModal
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-row" },
                [_c("PageAddBlock", { staticClass: "hide-tooltip" })],
                1
              )
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.deleteCard }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-page-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.removePage, cancel: _vm.cancelRemovePage }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: { id: "hidden-my-card-page-modal", title: "숨김" },
            on: { ok: _vm.hiddenPage, cancel: _vm.cancelHiddenPage }
          },
          [
            _c("div", {
              domProps: { innerHTML: _vm._s("페이지를 숨김처리 하시겠습니까?") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "recover-hidden-my-card-page-modal",
              title: "숨김 처리 복구"
            },
            on: {
              ok: _vm.recoverHiddenPage,
              cancel: _vm.cancelRecoverHiddenPage
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s("페이지를 숨김 상태를 복구하시겠습니까?")
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: { id: "export-content", title: "내보내기" },
            on: { ok: _vm.exportContent }
          },
          [
            _c("div", {
              domProps: { innerHTML: _vm._s("BEST 시스템으로 내보내겠습니까?") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "make-card-public-modal",
              title: _vm.$t("common.modal.make_public.title")
            },
            on: {
              ok: function($event) {
                return _vm.updateShareLevel(1)
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.make_public.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "make-card-private-modal",
              title: _vm.$t("common.modal.make_private.title")
            },
            on: {
              ok: function($event) {
                return _vm.updateShareLevel(2)
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.make_private.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "no-class-to-assign-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.no_class_to_assign_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "empty-card-info-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.empty_card_info.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal hide-ok-btn square-area-btn-modal",
            attrs: {
              id: "quiz-type-select-modal",
              title: _vm.$t("card_details.create_page"),
              "close-title": _vm.$t("common.close")
            }
          },
          [
            _c("div", { staticClass: "row square-area-btn-row" }, [
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showNonQuizEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-non-quiz"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.non_quiz")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showMultipleChoiceEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-multiple-choice"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.multiple_choice")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showTextEntryEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-text-entry"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.text_entry")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showEssayTypeEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-essay-type"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.essay_type")) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        !!_vm.pageToEditExtraContent
          ? _c("ExtraContentEditModal", {
              attrs: {
                id: "extra-content-edit-modal",
                page: _vm.pageToEditExtraContent,
                card: _vm.card
              },
              on: { cancel: _vm.cancelPageEdit, ok: _vm.cancelPageEdit }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("PageLibraryModal", { on: { "import-pages": _vm.importPages } }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNonQuizEditorModal,
              expression: "showNonQuizEditorModal"
            }
          ],
          attrs: {
            id: "non_quiz-editor-modal",
            "new-page-type": "non_quiz",
            "is-shown": _vm.showNonQuizEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showNonQuizEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMultipleChoiceEditorModal,
              expression: "showMultipleChoiceEditorModal"
            }
          ],
          attrs: {
            id: "multiple_choice-editor-modal",
            "new-page-type": "multiple_choice",
            "is-shown": _vm.showMultipleChoiceEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showMultipleChoiceEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTextEntryEditorModal,
              expression: "showTextEntryEditorModal"
            }
          ],
          attrs: {
            id: "text_entry-editor-modal",
            "new-page-type": "text_entry",
            "is-shown": _vm.showTextEntryEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showTextEntryEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEssayTypeEditorModal,
              expression: "showEssayTypeEditorModal"
            }
          ],
          attrs: {
            id: "essay_type-editor-modal",
            "new-page-type": "essay_type",
            "is-shown": _vm.showEssayTypeEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showEssayTypeEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEditPageModal,
              expression: "showEditPageModal"
            }
          ],
          attrs: {
            id: "edit-page-editor-modal",
            page: _vm.currentEditingPage,
            "is-shown": _vm.showEditPageModal
          },
          on: { "page-added": _vm.onPageAdded, cancel: _vm.cancelPageEdit }
        }),
        _vm._v(" "),
        _c("AddVideoModal", { on: { add: _vm.addVideo } }),
        _vm._v(" "),
        _c("MathEditorModal", {
          attrs: { id: "math-editor-modal" },
          on: { add: _vm.addMath }
        }),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "page-leave-alert",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: { ok: _vm.pageLeaveOk, cancel: _vm.pageLeaveCancel }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.page_leave_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isMyCardShareSetupModal
          ? _c("MyCardShareSetupModal", {
              attrs: {
                cardId: _vm.selectedCardId,
                cardShareLevel: _vm.savedCardShareLevel,
                onModalCancelClick: function() {
                  return (this$1.isMyCardShareSetupModal = false)
                },
                onModalOkClick: _vm.handleCardShareLevelUpdate,
                isLoading: _vm.isLoadingCardShareLevel,
                isPublisher: _vm.isPublisherUser
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hidden-md-up",
        attrs: { slot: "floating-action-menu" },
        slot: "floating-action-menu"
      },
      [
        _c(
          "FloatingDropup",
          [
            _c("b-dropdown-item", { on: { click: _vm.openCardPreview } }, [
              _vm._v(_vm._s(_vm.$t("common.preview")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                attrs: { disabled: _vm.saveDisabled },
                on: { click: _vm.saveMyCard }
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                on: {
                  click: function($event) {
                    return _vm.$root.$emit(
                      "show::modal",
                      "delete-my-card-modal"
                    )
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.card.menu.remove")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                attrs: { disabled: _vm.saveDisabled },
                on: { click: _vm.openMakePublicModal }
              },
              [
                _vm.card.share_level === 2
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("common.card.menu.make_public")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.card.share_level === 1
                  ? _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v(_vm._s(_vm.$t("common.card.menu.make_private")))
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e0e43f", esExports)
  }
}

/***/ }),

/***/ "LSV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LWwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["selectedCustomCardId"] = selectedCustomCardId;
/* harmony export (immutable) */ __webpack_exports__["customCardList"] = customCardList;
/* harmony export (immutable) */ __webpack_exports__["customCards"] = customCards;
/* harmony export (immutable) */ __webpack_exports__["customCardIds"] = customCardIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function selectedCustomCardId(state) {
  return state.selectedCustomCardId;
}

function customCardList(state) {
  return state.customCardList;
}

function customCards(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keyBy"])(state.customCardList, function (card) {
    return card.id;
  });
}

function customCardIds(state) {
  return state.customCardList.map(function (card) {
    return card.id;
  });
}

/***/ }),

/***/ "LYeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("ZXWV");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "LdoQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_EditPage__ = __webpack_require__("t8qe");


var router = [{
  name: 'editPage',
  path: '/pages/:page_id/edit',
  component: __WEBPACK_IMPORTED_MODULE_0__views_EditPage__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Lqim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal series-edit-modal",
      attrs: {
        id: "series-edit-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "series-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.series_edit.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c("div", { staticClass: "series-edit-modal__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "series-title-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seriesTitle,
                    expression: "seriesTitle"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "series-title-input",
                  placeholder: _vm.$t(
                    "publishers.modal.new_series.name_placeholder"
                  )
                },
                domProps: { value: _vm.seriesTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.seriesTitle = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "series-price-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.series_edit.price")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seriesPrice,
                    expression: "seriesPrice"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  id: "series-price-input",
                  step: "1000",
                  min: "0",
                  placeholder: _vm.$t(
                    "publishers.modal.series_edit.price_placeholder"
                  )
                },
                domProps: { value: _vm.seriesPrice },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.seriesPrice = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "series-card-price-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("publishers.modal.series_edit.card_price")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seriesCardPrice,
                    expression: "seriesCardPrice"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  id: "series-card-price-input",
                  step: "100",
                  min: "0",
                  placeholder: _vm.$t(
                    "publishers.modal.series_edit.card_price_placeholder"
                  )
                },
                domProps: { value: _vm.seriesCardPrice },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.seriesCardPrice = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("publishers.modal.series_edit.share_level")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-6" },
                [
                  _c(
                    "ToggleSwitch",
                    {
                      attrs: {
                        "model-value": _vm.seriesShareLevel,
                        "check-value": 1,
                        id: "share-level-switch"
                      },
                      on: { change: _vm.toggleShareLevel }
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getShareLevelLabel(_vm.seriesShareLevel || 2)
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-422b0494", esExports)
  }
}

/***/ }),

/***/ "MICQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("Cx08");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "MRjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("rM12");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED, function (state, cardId) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'selectedStoreCardId', cardId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARDS, function (state, cardList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'storeCardList', cardList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_CARDS, function (state, cardList) {
  var _state$storeCardList;

  (_state$storeCardList = state.storeCardList).push.apply(_state$storeCardList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cardList));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_PAGES, function (state, _ref) {
  var cardId = _ref.cardId,
      pageList = _ref.pageList;

  state.storeCardList.forEach(function (card) {
    if (card.id === cardId && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(card.store_card_id)) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(card, 'pages', pageList);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PUB_CARD_PAGES, function (state, _ref2) {
  var cardId = _ref2.cardId,
      pageList = _ref2.pageList;

  state.storeCardList.forEach(function (card) {
    if (card.id === cardId && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(card.store_card_id)) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(card, 'pages', pageList);
    }
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "MUYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quiz-form" },
    [
      !_vm.isPreviewQuiz
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal quiz-form-modal",
              attrs: { id: "quiz-form-modal", isCustomFooter: true }
            },
            [
              _c(
                "div",
                {
                  staticClass: "new-quiz-title",
                  attrs: { slot: "modal-header" },
                  slot: "modal-header"
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isNewQuiz
                          ? "데일리 퀴즈 만들기"
                          : "데일리 퀴즈 수정하기"
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "new-quiz-body" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v("\n            퀴즈타입 선택\n          ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.quizTypes, function(quiz, index) {
                      return _c(
                        "Radio",
                        {
                          key: index,
                          attrs: {
                            "model-value": _vm.selectedQuizType,
                            "check-value": index,
                            id: "quiz-type-" + index
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleQuizTypeChange(index)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(quiz.name))]
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v("\n            태그 선택\n          ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-3 typography--color-disabled mb-8"
                      },
                      [
                        _vm._v(
                          "\n          최대 2개까지 선택 가능합니다.\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.tags, function(value, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "tag",
                          class: { selected: _vm.isSelectedTag(value) },
                          on: {
                            click: function($event) {
                              return _vm.handleTagClick(value)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s("#" + value.name) +
                              "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "typography--body-1 typography--color-secondary"
                    },
                    [
                      _c("strong", [
                        _vm._v("\n            문제 입력\n          ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "textarea-wrapper w-100" },
                      [
                        _c("AutosizeTextarea", {
                          attrs: {
                            placeholder: "문제를 입력해주세요.",
                            limit: 40
                          },
                          model: {
                            value: _vm.content,
                            callback: function($$v) {
                              _vm.content = $$v
                            },
                            expression: "content"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v("\n            보기 입력\n          ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "textarea-wrapper" },
                            [
                              _c("AutosizeTextarea", {
                                attrs: {
                                  isDisabled: _vm.isNoOptionsQuiz(_vm.options),
                                  placeholder: _vm.$t(
                                    "page_editor.choices.placeholder"
                                  ),
                                  limit: 10
                                },
                                model: {
                                  value: option.value,
                                  callback: function($$v) {
                                    _vm.$set(option, "value", $$v)
                                  },
                                  expression: "option.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "option-wrapper float-right" },
                            [
                              _c(
                                "Radio",
                                {
                                  attrs: {
                                    "model-value": _vm.selectedOption,
                                    "check-value": index,
                                    id: "option-" + index,
                                    "left-label": "true"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleOptionChange(option.key)
                                    }
                                  }
                                },
                                [
                                  false
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "typography--body-3 typography--color-secondary",
                                          attrs: { slot: "left-label" },
                                          slot: "left-label"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "page_editor.choices.is_correct"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "typography--body-1 typography--color-secondary"
                    },
                    [
                      _c("strong", [
                        _vm._v("\n            문제 해설\n          ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "textarea-wrapper w-100" },
                      [
                        _c("AutosizeTextarea", {
                          attrs: {
                            placeholder: "해설을 입력해주세요.",
                            limit: 40
                          },
                          model: {
                            value: _vm.answer,
                            callback: function($$v) {
                              _vm.answer = $$v
                            },
                            expression: "answer"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("cancel")
                        }
                      }
                    },
                    [_vm._v("\n        취소\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.isNewQuiz
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.handlePreviewQuizClick }
                        },
                        [_vm._v("\n        미리보기\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isNewQuiz
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "button",
                            disabled: _vm.isDisabledQuiz
                          },
                          on: { click: _vm.handleNewQuizClick }
                        },
                        [
                          !_vm.isLoading
                            ? [_vm._v("저장")]
                            : _c("LoadingBounce")
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isNewQuiz
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: _vm.isDisabledQuiz
                          },
                          on: { click: _vm.handleUpdateQuizClick }
                        },
                        [_vm._v("\n        수정\n      ")]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPreviewQuiz
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal quiz-preview-modal",
              attrs: { id: "quiz-preview-modal", isHideFooter: true }
            },
            [
              _c(
                "div",
                {
                  staticClass: "quiz-preview-title",
                  attrs: { slot: "modal-header" },
                  on: { click: _vm.handlePreviewCloseClick },
                  slot: "modal-header"
                },
                [
                  _c("img", {
                    staticClass: "back-icon",
                    attrs: { src: "/static/images/ic-arrow-back.svg" }
                  }),
                  _vm._v("\n      미리보기\n    ")
                ]
              ),
              _vm._v(" "),
              _c("QuizPreview", { attrs: { quiz: _vm.getPreviewQuizData } })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aec22c1", esExports)
  }
}

/***/ }),

/***/ "MYZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-gauge" }, [
    _vm.value > 0
      ? _c("div", { staticClass: "lg-position", style: _vm.styleBindings })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-549d46e5", esExports)
  }
}

/***/ }),

/***/ "MZXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  advertisement: {}
});

/***/ }),

/***/ "MjF7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["selectedStorePageId"] = selectedStorePageId;
/* harmony export (immutable) */ __webpack_exports__["storePageList"] = storePageList;
/* harmony export (immutable) */ __webpack_exports__["storePages"] = storePages;
/* harmony export (immutable) */ __webpack_exports__["storePageIds"] = storePageIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function selectedStorePageId(state) {
  return state.selectedStorePageId;
}

function storePageList(state) {
  return state.storePageList;
}

function storePages(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keyBy"])(state.storePageList, function (page) {
    return page.id;
  });
}

function storePageIds(state) {
  return state.storePageList.map(function (page) {
    return page.id;
  });
}

/***/ }),

/***/ "MnNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mnw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_IS_CLASS_STUDENT = 'classes/SET_IS_CLASS_STUDENT';
var SET_SELECTED = 'classes/SET_SELECTED';
var SET_CLASSES = 'classes/SET_CLASSES';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_IS_CLASS_STUDENT: SET_IS_CLASS_STUDENT,
  SET_SELECTED: SET_SELECTED,
  SET_CLASSES: SET_CLASSES
});

/***/ }),

/***/ "N4id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_linkifyjs_html__ = __webpack_require__("3R8l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_linkifyjs_html__);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    parseHyperlink: function parseHyperlink(content) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(content)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_linkifyjs_html___default()(content);
    }
  }
});

/***/ }),

/***/ "N5uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile"
              },
              [_vm._v(_vm._s(_vm.formattedClassName))]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-15",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row pt-3" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [_vm._v(_vm._s(_vm.$t("common.loading")))]
                  )
                ],
                1
              )
            ])
          : _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "row sort-subject-menu" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "select-subject-dropdown mnv-dropdown",
                      attrs: {
                        text: _vm.getTranslatedName(
                          _vm.subjectMap[_vm.selectedSubjectId]
                        )
                      }
                    },
                    _vm._l(_vm.subjectIds, function(value, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              _vm.selectedSubjectId = parseInt(value, 10)
                              _vm.sortAssignments()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getTranslatedName(_vm.subjectMap[value])
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sort-type clickable mr-12 typography--color-secondary",
                      on: {
                        click: function($event) {
                          _vm.sortType = "recent"
                          _vm.sortAssignments()
                        }
                      }
                    },
                    [
                      _vm.sortType === "recent"
                        ? _c("img", {
                            attrs: { src: "/static/images/radio-btn-01.svg" }
                          })
                        : _c("img", {
                            attrs: { src: "/static/images/radio-btn-02.svg" }
                          }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("reports.sort_new_assignment"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sort-type clickable typography--color-secondary",
                      on: {
                        click: function($event) {
                          _vm.sortType = "score"
                          _vm.sortAssignments()
                        }
                      }
                    },
                    [
                      _vm.sortType === "score"
                        ? _c("img", {
                            attrs: { src: "/static/images/radio-btn-01.svg" }
                          })
                        : _c("img", {
                            attrs: { src: "/static/images/radio-btn-02.svg" }
                          }),
                      _vm._v(" " + _vm._s(_vm.$t("reports.sort_achievement")))
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [
                    _c("TableCard", { staticClass: "report-result" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mb-8",
                          attrs: { slot: "table-action" },
                          slot: "table-action"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "typography--content-body pb-3" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getShortenedString(
                                      _vm.currentStudent.name,
                                      30
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "float-right typography--caption typography--color-secondary pb-2"
                            },
                            [
                              _vm.assignmentsBySubjects[_vm.selectedSubjectId]
                                ? _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "reports.assignment_count_cnt",
                                            {
                                              cnt:
                                                _vm.assignmentsBySubjects[
                                                  _vm.selectedSubjectId
                                                ].length
                                            }
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("reports.assignment_count_cnt", {
                                          cnt: 0
                                        })
                                      )
                                    )
                                  ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass: "table",
                          attrs: { slot: "table" },
                          slot: "table"
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary text-left pl-10"
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("reports.table.card_name"))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("reports.table.score"))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("reports.table.class_rank")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("reports.table.correct_count")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("reports.table.duration")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("reports.assignment_period")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("reports.see_result")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              (
                                _vm.assignmentsBySubjects[
                                  _vm.selectedSubjectId
                                ] || []
                              ).length > 0
                                ? _vm._l(
                                    _vm.assignmentsBySubjects[
                                      _vm.selectedSubjectId
                                    ] || [],
                                    function(asmt, index) {
                                      return _c("tr", { key: index }, [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-middle typography--body-3 card-info-cell pl-10"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-middle clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openStudentAssignmentPreview(
                                                      asmt
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.getShortenedString(
                                                        asmt.assigned_card
                                                          .title,
                                                        30
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center",
                                                class: {
                                                  "typography--color-alert":
                                                    _vm.getScoreRatio(
                                                      asmt.currentStudentSubmission
                                                    ) <= 20
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getScoreRatio(
                                                        asmt.currentStudentSubmission
                                                      ) || 0
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "typography--font-weight-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.getClassScoreRank(
                                                            asmt
                                                              .currentStudentSubmission
                                                              .correct_quiz_count,
                                                            asmt.classScores
                                                          )
                                                        ) +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.rank_suffix"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  " / " +
                                                    _vm._s(
                                                      _vm.getNumStrTwoDigit(
                                                        asmt.submissions.length
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "typography--font-weight-bold correct-quiz-count"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumStrTwoDigit(
                                                          asmt
                                                            .currentStudentSubmission
                                                            .correct_quiz_count
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                        / " +
                                                    _vm._s(
                                                      asmt
                                                        .currentStudentSubmission
                                                        .quiz_count
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("duration")(
                                                        asmt
                                                          .currentStudentSubmission
                                                          .duration
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-top typography--body-3 text-center"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formattedDate(
                                                  asmt.start_date
                                                )
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.formattedDate(
                                                    asmt.due_date
                                                  )
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-top typography--body-3 text-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-outline-rectangle clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openStudentAssignmentPreview(
                                                      asmt
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "reports.assignment_result"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  )
                                : [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      )
                                    ])
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6e2e2a4", esExports)
  }
}

/***/ }),

/***/ "N6yp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyQuizModal_vue__ = __webpack_require__("Jmjy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_456438ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyQuizModal_vue__ = __webpack_require__("pO6y");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("k8Lu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-456438ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyQuizModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_456438ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyQuizModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-quizzes/components/MyQuizModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-456438ce", Component.options)
  } else {
    hotAPI.reload("data-v-456438ce", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N959":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardTitleInput_vue__ = __webpack_require__("dIKD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0817bcb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardTitleInput_vue__ = __webpack_require__("QKZm");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardTitleInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0817bcb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardTitleInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/CardTitleInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0817bcb2", Component.options)
  } else {
    hotAPI.reload("data-v-0817bcb2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NH0s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationTable_vue__ = __webpack_require__("DNTg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a005f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationTable_vue__ = __webpack_require__("nztc");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("NkP5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a005f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/EvaluationTable.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35a005f8", Component.options)
  } else {
    hotAPI.reload("data-v-35a005f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_video_player__ = __webpack_require__("NBiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboards__ = __webpack_require__("1f+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_autocomplete__ = __webpack_require__("HpzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_min_css__ = __webpack_require__("ksQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_main_scss__ = __webpack_require__("H/op");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AppRoot__ = __webpack_require__("gTxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("IcnI");



























__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_clipboards__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate___default.a, { errorBagName: 'veeErrors' });
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16__plugins_http__["a" /* default */], { store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */], router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_video_player___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_v_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* GA_ID */],
  router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */],
  autoTracking: {
    pageviewOnLoad: false
  },
  ignoreRoutes: ['auth']
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17__components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18__filters__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_20__i18n__["a" /* default */],
  el: '#app',
  template: '<AppRoot/>',
  components: { AppRoot: __WEBPACK_IMPORTED_MODULE_15__AppRoot__["a" /* default */] }
});

/***/ }),

/***/ "NU23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),

/***/ "NbUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublisherCardView_vue__ = __webpack_require__("DSth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4920eff9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublisherCardView_vue__ = __webpack_require__("olR/");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("4iNN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublisherCardView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4920eff9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublisherCardView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/PublisherCardView.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4920eff9", Component.options)
  } else {
    hotAPI.reload("data-v-4920eff9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NkA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return answerCriteriaTypes; });

var answerCriteriaTypes = [{
  label: '단어포함 (정답: 손흥민 | 허용되는 답: 손흥민 선수)',
  value: 1
}, {
  label: '띄어쓰기 무시 (정답: 이순신장군 | 허용되는 답: 이순신 장군)',
  value: 2
}, {
  label: '대소문자 무시 (정답: Student | 허용되는 답: student)',
  value: 4
}, {
  label: '숫자만 인식 (정답: 10 | 허용되는 답: 10개)',
  value: 8
}, {
  label: '한글/영어/숫자만 인식(특수문자 제거) (정답: 가 자전거 | 허용되는 답: 가: 자전거) ',
  value: 16
}];

/***/ }),

/***/ "NkP5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NowG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__my_quizzes__ = __webpack_require__("a+L7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__video_lectures__ = __webpack_require__("lZGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_courses__ = __webpack_require__("1p+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__evaluations__ = __webpack_require__("QaKr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assignments__ = __webpack_require__("7ktI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__publishers__ = __webpack_require__("F04J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__my_cards__ = __webpack_require__("TvRo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__edit_page__ = __webpack_require__("ao0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__classes__ = __webpack_require__("eiba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__auth__ = __webpack_require__("b3O1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tutorials__ = __webpack_require__("MICQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cl_events__ = __webpack_require__("3mKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__advertisements__ = __webpack_require__("LYeg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__browse_filters__ = __webpack_require__("Csdr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__notifications__ = __webpack_require__("BQ3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__custom_cards__ = __webpack_require__("1+da");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_cards__ = __webpack_require__("w1p6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store_pages__ = __webpack_require__("KQEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__policies__ = __webpack_require__("3xdI");


























var store = {
  MyQuizzes: __WEBPACK_IMPORTED_MODULE_5__my_quizzes__["b" /* store */],
  Advertisements: __WEBPACK_IMPORTED_MODULE_17__advertisements__["a" /* default */],
  BrowseFilters: __WEBPACK_IMPORTED_MODULE_18__browse_filters__["a" /* default */],
  Notifications: __WEBPACK_IMPORTED_MODULE_19__notifications__["a" /* default */],
  VideoLectures: __WEBPACK_IMPORTED_MODULE_6__video_lectures__["b" /* store */],
  VideoCourses: __WEBPACK_IMPORTED_MODULE_7__video_courses__["b" /* store */],
  Evaluations: __WEBPACK_IMPORTED_MODULE_8__evaluations__["a" /* store */],
  Assignments: __WEBPACK_IMPORTED_MODULE_9__assignments__["b" /* store */],
  CustomCards: __WEBPACK_IMPORTED_MODULE_20__custom_cards__["a" /* default */],
  Publishers: __WEBPACK_IMPORTED_MODULE_10__publishers__["b" /* store */],
  StoreCards: __WEBPACK_IMPORTED_MODULE_21__store_cards__["a" /* default */],
  StorePages: __WEBPACK_IMPORTED_MODULE_22__store_pages__["a" /* default */],
  MyCards: __WEBPACK_IMPORTED_MODULE_11__my_cards__["b" /* store */],
  Classes: __WEBPACK_IMPORTED_MODULE_13__classes__["a" /* store */],
  Auth: __WEBPACK_IMPORTED_MODULE_14__auth__["b" /* store */],
  Tutorials: __WEBPACK_IMPORTED_MODULE_15__tutorials__["a" /* default */],
  ClEvents: __WEBPACK_IMPORTED_MODULE_16__cl_events__["a" /* default */],
  Policies: __WEBPACK_IMPORTED_MODULE_23__policies__["a" /* default */],
  EditPage: __WEBPACK_IMPORTED_MODULE_12__edit_page__["b" /* store */]
};
var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(store);

var modules = keys.reduce(function (acc, key) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, store[key].module));
}, {});
var plugins = keys.reduce(function (acc, key) {
  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [store[key].plugin]);
}, []).filter(__WEBPACK_IMPORTED_MODULE_4_lodash__["isFunction"]);

/* harmony default export */ __webpack_exports__["a"] = ({ modules: modules, plugins: plugins });

/***/ }),

/***/ "OBYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLectureDetails_vue__ = __webpack_require__("2q93");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d42586_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLectureDetails_vue__ = __webpack_require__("2qX0");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("PWKZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLectureDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d42586_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLectureDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-lectures/views/VideoLectureDetails.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78d42586", Component.options)
  } else {
    hotAPI.reload("data-v-78d42586", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OC/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("8kb5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb56dc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("RjGI");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb56dc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/AppFooter.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fdb56dc8", Component.options)
  } else {
    hotAPI.reload("data-v-fdb56dc8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OFBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyPageItem_vue__ = __webpack_require__("uMsc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48da220a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyPageItem_vue__ = __webpack_require__("3veI");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("nwTf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DummyPageItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48da220a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DummyPageItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DummyPageItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48da220a", Component.options)
  } else {
    hotAPI.reload("data-v-48da220a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OHwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'basic-line-gauge',

  props: {
    value: {
      type: Number,
      default: 50
    },
    ratio: {
      type: Number,
      default: 50
    },
    unit: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    bgColor: {
      type: String,
      default: '#00c896'
    }
  }
});

/***/ }),

/***/ "ORGd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OTO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "evaluation-table-row" }, [
    _c(
      "td",
      {
        staticClass:
          "typography--body-2 evaluation-table-td evaluation-table-student-number"
      },
      [_vm._v("\n    " + _vm._s(_vm.evaluation.number || "-") + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass:
          "typography--body-2 evaluation-table-td evaluation-table-student-name"
      },
      [_vm._v("\n    " + _vm._s(_vm.evaluation.name) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.evaluationComment && !_vm.loading
      ? _c(
          "td",
          {
            staticClass:
              "typography--body-2 evaluation-table-td evaluation-table-comment"
          },
          [
            _vm._v("\n    " + _vm._s(_vm.evaluationComment) + "\n\n    "),
            _c(
              "div",
              { staticClass: "evaluation-table-row-actions" },
              [
                _vm._l(_vm.domains, function(domain) {
                  return _c("EvaluationBadge", {
                    key: domain.id,
                    attrs: { domain: domain }
                  })
                }),
                _vm._v(" "),
                _c("button", {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard",
                      value: _vm.evaluationComment,
                      expression: "evaluationComment"
                    }
                  ],
                  staticClass:
                    "btn rounded-circle copy-evaluation-btn float-right",
                  attrs: {
                    title: _vm.$t("evaluations.table.btn.copied_to_clipboard")
                  },
                  on: {
                    success: function($event) {
                      return _vm.$root.$emit(
                        "show::snackbar",
                        _vm.snackbarOptions
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("button", {
                  staticClass:
                    "btn rounded-circle refresh-evaluation-btn float-right mr-6",
                  attrs: { title: _vm.$t("evaluations.table.btn.refresh") },
                  on: {
                    click: function($event) {
                      return _vm.refreshEvaluation()
                    }
                  }
                })
              ],
              2
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.evaluationComment && !_vm.loading
      ? _c(
          "td",
          {
            staticClass:
              "typography--body-2 typography--color-disabled evaluation-table-td evaluation-table-comment"
          },
          [
            _vm.evaluationNotSupported
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("evaluations.table.comment_not_supported"))
                  )
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("evaluations.table.comment_empty")))
                ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "td",
          { staticClass: "evaluation-table-td evaluation-table-comment" },
          [_c("LoadingBounce", { staticClass: "float-left" })],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ec101c", esExports)
  }
}

/***/ }),

/***/ "Ofg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    [
      _c(
        "div",
        {
          staticClass: "container mw-960",
          attrs: { slot: "layout-body" },
          slot: "layout-body"
        },
        [
          _c("div", { staticClass: "error-container text-center" }, [
            _c("img", {
              attrs: { src: "/static/images/signin-lcic-inactive.svg" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "typography--content-body",
              domProps: { innerHTML: _vm._s(_vm.$t("errors.unauthorized_msg")) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "link-back-to-ct" }, [
              _c("a", { attrs: { href: _vm.classtingUrl } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("errors.back_to_classting")) +
                    "\n        "
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("AppFooter", { attrs: { slot: "footer" }, slot: "footer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3029ac1b", esExports)
  }
}

/***/ }),

/***/ "Oif5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function time(dateObj) {
  if (dateObj) {
    var hour = dateObj.getHours() > 9 ? dateObj.getHours() : '0' + dateObj.getHours();
    var minute = dateObj.getMinutes() > 9 ? dateObj.getMinutes() : '0' + dateObj.getMinutes();

    return hour + ':' + minute;
  }

  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (time);

/***/ }),

/***/ "Ok4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal hide-cancel-btn",
      attrs: {
        id: "welcome-message-modal",
        "close-on-backdrop": false,
        "ok-title": _vm.$t("common.modal.welcome_msg.start")
      },
      on: {
        ok: function($event) {
          return _vm.setTutorialAsChecked("welcome")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
        _c("h5", {
          staticClass: "typography--title",
          domProps: {
            innerHTML: _vm._s(_vm.$t("common.modal.welcome_msg.title"))
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "typography--body-3 typography--color-secondary mb-4 mt-6"
        },
        [
          _c("img", {
            staticClass: "mr-12",
            attrs: { src: "/static/images/icon-check.svg" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("common.modal.welcome_msg.body_1")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary mb-4" },
        [
          _c("img", {
            staticClass: "mr-12",
            attrs: { src: "/static/images/icon-check.svg" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("common.modal.welcome_msg.body_2")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c("img", {
            staticClass: "mr-12",
            attrs: { src: "/static/images/icon-check.svg" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("common.modal.welcome_msg.body_3")) +
              "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40444568", esExports)
  }
}

/***/ }),

/***/ "Ospv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: "report-content-modal",
        title: _vm.$t("common.modal.report_content.title"),
        "close-title": _vm.$t("common.cancel"),
        "ok-title": _vm.$t("common.confirm"),
        "ok-busy": _vm.busy
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.reportContent()
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "option-content-has-error",
                "model-value": _vm.reportIssue,
                "check-value": 1
              },
              on: { change: _vm.onRadioSelect }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("common.modal.report_content.options.has_error")
                    ) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "Radio",
            {
              attrs: {
                id: "option-content-is-inappropriate",
                "model-value": _vm.reportIssue,
                "check-value": 2
              },
              on: { change: _vm.onRadioSelect }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "common.modal.report_content.options.inappropriate"
                      )
                    ) +
                    "\n      "
                )
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd431990", esExports)
  }
}

/***/ }),

/***/ "Oudl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P2Id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationTableRow_vue__ = __webpack_require__("t+79");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ec101c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationTableRow_vue__ = __webpack_require__("OTO7");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("6gAy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationTableRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ec101c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationTableRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/EvaluationTableRow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-64ec101c", Component.options)
  } else {
    hotAPI.reload("data-v-64ec101c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P4Wo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tooltip',

  props: ['position', 'show'],

  data: function data() {
    return {
      closed: false
    };
  },


  computed: {
    showTooltip: function showTooltip() {
      return this.show && !this.closed;
    },
    classBindings: function classBindings() {
      return {
        'tooltip-top': this.position === 'top',
        'tooltip-bottom': this.position === 'bottom',
        'tooltip-left': this.position === 'left',
        'tooltip-right': this.position === 'right'
      };
    }
  },

  methods: {
    close: function close() {
      this.closed = true;
      this.$emit('tooltip-closed');
    }
  }
});

/***/ }),

/***/ "P6Ue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__my_cards_components_PageEditorModal__ = __webpack_require__("1W3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__my_cards_components_MathEditorModal__ = __webpack_require__("GW0y");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-page',

  components: {
    PageEditorModal: __WEBPACK_IMPORTED_MODULE_5__my_cards_components_PageEditorModal__["a" /* default */],
    MathEditorModal: __WEBPACK_IMPORTED_MODULE_6__my_cards_components_MathEditorModal__["a" /* default */]
  },

  data: function data() {
    return {
      busy: false,

      hasError: false,

      acceptableFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],

      fileSizeLimit: 10 * 1024 * 1024,

      page: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['page', 'currentUserId'])),

  created: function created() {
    var _this = this;

    return this.fetchAdminInfo(this.currentUserId).then(function (adminData) {
      if (!adminData) return _this.$router.replace('/');

      return _this.fetchPage(_this.$route.params.page_id);
    }).then(function (page) {
      _this.page = page;
    }).catch(function () {
      _this.$router.replace('/');
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchPage', 'updatePage', 'uploadPageImage', 'uploadPageAudio', 'fetchAdminInfo']), {
    cancelPageEdit: function cancelPageEdit() {
      this.$router.go(-1);
    },
    onPageAdded: function onPageAdded(newQuizPage) {
      var _this2 = this;

      var pageId = this.$route.params.page_id;
      var newPageClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(newQuizPage);

      var uploadImgPromises = newPageClone.images.filter(function (image) {
        return typeof image.image_file !== 'string';
      }).map(function (image) {
        return _this2.uploadPageImage({ pageId: pageId, imageFile: image.image_file }).then(function (newImage) {
          if (newPageClone.content.indexOf('data-image-id="' + image.key + '"') !== -1) {
            newPageClone.content = newPageClone.content.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
          }

          if (newPageClone.description.indexOf('data-image-id="' + image.key + '"') !== -1) {
            newPageClone.description = newPageClone.description.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
          }
        });
      });

      var uploadAudioPromises = newPageClone.audios.map(function (audio) {
        return _this2.uploadPageAudio({ pageId: pageId, audioFile: audio.audio_file });
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uploadImgPromises), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uploadAudioPromises))).then(function () {
        return _this2.updatePage({ pageId: pageId, updateInfo: newPageClone });
      }).catch(function () {
        return alert('문항 업데이트에 실패하였습니다.');
      }).finally(function () {
        return window.location.reload();
      });
    },
    addMath: function addMath(latex) {
      if (latex.length > 0) {
        var replacedLatex = latex.replace(/overarc/g, 'overparen');
        var mathInlineId = Math.floor(Math.random() * 1000);
        var content = '&nbsp;<span id="math-inline-' + mathInlineId + '" contenteditable="false">\\(' + replacedLatex + '\\)</span>&nbsp;';
        var activeEditor = void 0;

        if (this.activeEditorId) {
          activeEditor = tinymce.get(this.activeEditorId);

          if (this.activeEditorLocation) {
            activeEditor.selection.setRng(this.activeEditorLocation);
          }
        } else {
          activeEditor = tinymce.activeEditor;
        }

        activeEditor.insertContent(content);

        setTimeout(function () {
          MathJax.Hub.Queue(['Typeset', MathJax.Hub, 'math-inline-' + mathInlineId]);

          activeEditor.insertContent('');
        }, 200);
      }
    }
  })
});

/***/ }),

/***/ "P9CW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PJGR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PLQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.domain
    ? _c("div", { staticClass: "evaluation-badge", class: _vm.classBindings }, [
        _vm._v("\n  " + _vm._s(_vm.domain.name) + " "),
        _c("strong", [_vm._v(_vm._s(_vm.domain.grade))])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a14734d", esExports)
  }
}

/***/ }),

/***/ "PWKZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pw+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-library-modal',

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      isShown: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['trimmedPageLibraryFilters', 'pageLibraryFilters', 'selectedPageList', 'checkedTutorials', 'coreConceptList', 'storePageList', 'coreConcepts', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds', 'unitList', 'units', 'gradeList', 'gradeSubjects', 'currentUser']), {
    showTooltip: function showTooltip() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.checkedTutorials) && this.checkedTutorials.tryAddNewPages && !this.checkedTutorials.trySelectAndAddPages) {
        return true;
      }

      return false;
    },
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.pageLibraryFilters.subject_id + '&' + this.pageLibraryFilters.grade_id;
    },
    currentUnitList: function currentUnitList() {
      var _this = this;

      return this.unitList.filter(function (unit) {
        return unit.subject_id === parseInt(_this.pageLibraryFilters.subject_id, 10) && unit.name !== 'NO NAME YET';
      });
    },
    currentCoreConceptList: function currentCoreConceptList() {
      var _this2 = this;

      return this.coreConceptList.filter(function (coreConcept) {
        return coreConcept.subject_id === parseInt(_this2.pageLibraryFilters.subject_id, 10) && coreConcept.grade_id === parseInt(_this2.pageLibraryFilters.grade_id, 10);
      });
    },
    isQuizTabBindings: function isQuizTabBindings() {
      return {
        active: this.pageLibraryFilters.is_quiz === '1'
      };
    },
    isNotQuizTabBindings: function isNotQuizTabBindings() {
      return {
        active: this.pageLibraryFilters.is_quiz === '0'
      };
    }
  }),

  watch: {
    gradeSubjects: function gradeSubjects(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('page-subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('page-subject-dropdown').firstElementChild.disabled = false;
      }
    },
    currentCoreConceptList: function currentCoreConceptList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state);
    },
    currentUnitList: function currentUnitList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('page-unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('page-unit-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state);
    },
    selectedSubjectGrade: function selectedSubjectGrade(state) {
      if (state.match(/^[0-9]+&0$/) || state.match(/^0&[0-9]+$/)) {
        return null;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(state.match(/[0-9]+&[0-9]+/))) {

        return this.fetchUnits({
          subject_id: this.pageLibraryFilters.subject_id,
          grade_id: this.pageLibraryFilters.grade_id
        });
      }

      return null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setPageLibraryFilter', 'setTutorialAsChecked', 'resetSelectedPage', 'fetchCoreConcepts', 'fetchStorePages', 'fetchUnits', 'fetchGradeSubjects']), {
    onInfinite: function onInfinite() {
      var _this3 = this;

      if (this.isShown) {
        this.setPageLibraryFilter({ property: 'offset', value: this.pageLibraryFilters.offset + 20 }).then(function () {
          return _this3.fetchStorePages(_this3.trimmedPageLibraryFilters);
        }).then(function (pageList) {
          if (_this3.$refs.infiniteLoading) {
            _this3.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

            if (pageList.length === 0) {
              _this3.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
            }
          }
        }).catch(function (err) {
          _this3.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectIsQuiz: function selectIsQuiz(isQuiz) {
      var _this4 = this;

      if (this.pageLibraryFilters.is_quiz !== isQuiz) {
        this.setPageLibraryFilter({ property: 'is_quiz', value: isQuiz }).then(function () {
          return _this4.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this4.loading = true;
          document.querySelector('#page-library-modal .modal-body>div').scrollIntoView(true);

          return _this4.fetchStorePages(_this4.trimmedPageLibraryFilters);
        }).then(function () {
          _this4.loading = false;
        }).catch(function (err) {
          _this4.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectSubject: function selectSubject(subjectId) {
      var _this5 = this;

      if (this.pageLibraryFilters.subject_id !== subjectId) {
        this.setPageLibraryFilter({ property: 'subject_id', value: subjectId }).then(function () {
          return _this5.setPageLibraryFilter({ property: 'core_concept_id', value: '0' });
        }).then(function () {
          return _this5.setPageLibraryFilter({ property: 'unit_id', value: '0' });
        }).then(function () {
          return _this5.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this5.loading = true;

          return _this5.fetchStorePages(_this5.trimmedPageLibraryFilters);
        }).then(function () {
          _this5.loading = false;
        }).catch(function (err) {
          _this5.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectGrade: function selectGrade(gradeId, schoolYear) {
      var _this6 = this;

      if (this.pageLibraryFilters.grade_id !== gradeId) {
        this.fetchGradeSubjects({ grade: schoolYear }).then(function () {
          return _this6.setPageLibraryFilter({ property: 'school_year', value: schoolYear });
        }).then(function () {
          return _this6.setPageLibraryFilter({ property: 'grade_id', value: gradeId });
        }).then(function () {
          return _this6.setPageLibraryFilter({ property: 'subject_id', value: '0' });
        }).then(function () {
          return _this6.setPageLibraryFilter({ property: 'core_concept_id', value: '0' });
        }).then(function () {
          return _this6.setPageLibraryFilter({ property: 'unit_id', value: '0' });
        }).then(function () {
          return _this6.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this6.loading = true;

          return _this6.fetchStorePages(_this6.trimmedPageLibraryFilters);
        }).then(function () {
          _this6.loading = false;
        }).catch(function (err) {
          _this6.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectUnit: function selectUnit(unitId) {
      var _this7 = this;

      if (this.pageLibraryFilters.unit_id !== unitId) {
        this.setPageLibraryFilter({ property: 'unit_id', value: unitId }).then(function () {
          return _this7.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this7.loading = true;

          return _this7.fetchStorePages(_this7.trimmedPageLibraryFilters);
        }).then(function () {
          _this7.loading = false;
        }).catch(function (err) {
          _this7.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectCoreConcept: function selectCoreConcept(coreConceptId) {
      var _this8 = this;

      if (this.pageLibraryFilters.core_concept_id !== coreConceptId) {
        this.setPageLibraryFilter({ property: 'core_concept_id', value: coreConceptId }).then(function () {
          return _this8.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this8.loading = true;

          return _this8.fetchStorePages(_this8.trimmedPageLibraryFilters);
        }).then(function () {
          _this8.loading = false;
        }).catch(function (err) {
          _this8.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectMediaType: function selectMediaType(mediaType) {
      var _this9 = this;

      this.setPageLibraryFilter({ property: 'media_type', value: mediaType }).then(function () {
        return _this9.setPageLibraryFilter({ property: 'offset', value: 0 });
      }).then(function () {
        _this9.loading = true;

        return _this9.fetchStorePages(_this9.trimmedPageLibraryFilters);
      }).then(function () {
        _this9.loading = false;
      }).catch(function (err) {
        _this9.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    selectOrderBy: function selectOrderBy(orderByParam) {
      var _this10 = this;

      if (this.pageLibraryFilters.order_by !== orderByParam) {
        this.setPageLibraryFilter({ property: 'order_by', value: orderByParam }).then(function () {
          return _this10.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this10.loading = true;

          return _this10.fetchStorePages(_this10.trimmedPageLibraryFilters);
        }).then(function () {
          _this10.loading = false;
        }).catch(function (err) {
          _this10.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },

    fetchWithSearchKeywords: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
      var _this11 = this;

      this.loading = true;

      this.fetchStorePages(this.trimmedPageLibraryFilters).then(function () {
        _this11.loading = false;
      });
    }, 500),

    applySearchKeywords: function applySearchKeywords(inputText) {
      var _this12 = this;

      if (this.pageLibraryFilters.search_keywords !== inputText) {
        this.setPageLibraryFilter({ property: 'search_keywords', value: inputText }).then(function () {
          return _this12.setPageLibraryFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this12.fetchWithSearchKeywords();
        }).catch(function (err) {
          _this12.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    setup: function setup() {
      var _this13 = this;

      if (this.storePageList.length === 0) {
        this.loading = true;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          return _this13.setPageLibraryFilter({ property: 'grade_id', value: _this13.currentUser.grade_id });
        }).then(function () {
          return _this13.fetchGradeSubjects({ grade: _this13.currentUser.grade_id });
        }).then(function () {
          return _this13.fetchStorePages(_this13.trimmedPageLibraryFilters);
        }).then(function () {
          _this13.loading = false;
          _this13.isShown = true;
        }).catch(function (err) {
          console.error('err while fetching store pages in page library view:', err);
          _this13.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      } else {
        this.isShown = true;
      }
    },
    onTooltipClosed: function onTooltipClosed() {
      this.setTutorialAsChecked('trySelectAndAddPages');
    },
    importPages: function importPages() {
      var _this14 = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.checkedTutorials) && !this.checkedTutorials.trySelectAndAddPages) {
        this.setTutorialAsChecked('trySelectAndAddPages').then(function () {
          _this14.$emit('import-pages', _this14.selectedPageList);
          _this14.$root.$emit('hide::modal', 'page-library-modal');
        });
      } else {
        this.$emit('import-pages', this.selectedPageList);
        this.$root.$emit('hide::modal', 'page-library-modal');
      }
    },
    clean: function clean() {
      this.resetSelectedPage();
      document.querySelector('#page-library-modal .modal-body>div').scrollIntoView(true);
      this.isShown = false;
    }
  }),

  mounted: function mounted() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.gradeSubjects)) {
      document.getElementById('page-subject-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('page-subject-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.currentCoreConceptList)) {
      document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('page-core-concept-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.currentUnitList)) {
      document.getElementById('page-unit-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('page-unit-dropdown').firstElementChild.disabled = false;
    }
  }
});

/***/ }),

/***/ "PyPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { attrs: { bodyStyle: _vm.getBodyStyle } }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _c(
              "h5",
              {
                staticClass:
                  "sub-header-header typography--headline typography--color-secondary pl-10-mobile pr-10-mobile"
              },
              [_vm._v("\n          AI 데일리 퀴즈\n        ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6 hidden-xs-down" }, [
            _c("div", { staticClass: "sub-header-btn-row float-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary new-quiz-button",
                  attrs: { disabled: _vm.isLoadingMyQuizzes },
                  on: { click: _vm.handleNewQuizClick }
                },
                [_vm._v("\n            AI 데일리 퀴즈 만들기\n          ")]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 my-quizzes-wrapper",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.isLoadingMyQuizzes && _vm.isEmptyQuizzes
          ? _c("LoadingBounce", { staticClass: "loading" })
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.isEmptyQuizzes
                  ? _c("div", { staticClass: "no-quiz-wrapper" }, [
                      _vm._v(
                        "\n        지금 바로 AI 데일리 퀴즈를 만들어 보세요.\n      "
                      )
                    ])
                  : _vm._l(_vm.myQuizzes, function(quiz, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "col-lg-6 col-xs-12 quiz-wrapper"
                        },
                        [
                          _c("MyQuizCard", {
                            attrs: { quiz: quiz },
                            on: {
                              click: function($event) {
                                return _vm.handleQuizClick(quiz)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _vm.isInfiniteLoading
                  ? _c(
                      "InfiniteLoading",
                      {
                        ref: "infiniteLoading",
                        staticClass: "w-100",
                        attrs: { "on-infinite": _vm.onInfiniteMyQuizzes }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "spinner" }, slot: "spinner" },
                          [_c("LoadingBounce", { staticClass: "loading" })],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", {
                          attrs: { slot: "no-results" },
                          slot: "no-results"
                        }),
                        _vm._v(" "),
                        _c("span", {
                          attrs: { slot: "no-more" },
                          slot: "no-more"
                        })
                      ]
                    )
                  : _vm._e()
              ],
              2
            ),
        _vm._v(" "),
        _vm.isQuizFormModal
          ? _c("QuizFormModal", {
              attrs: { quiz: _vm.quiz },
              on: { cancel: _vm.handleModalCloseClick }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isQuizModal
          ? _c("MyQuizModal", {
              attrs: { quiz: _vm.quiz },
              on: {
                ok: _vm.handleQuizModalOkClick,
                cancel: _vm.handleQuizModalCancelClick
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a5412a0", esExports)
  }
}

/***/ }),

/***/ "Pz6z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pzxd":
/***/ (function(module, exports) {

module.exports = {"Play":"تشغيل","Pause":"ايقاف","Current Time":"الوقت الحالي","Duration Time":"Dauer","Remaining Time":"الوقت المتبقي","Stream Type":"نوع التيار","LIVE":"مباشر","Loaded":"تم التحميل","Progress":"التقدم","Fullscreen":"ملء الشاشة","Non-Fullscreen":"غير ملء الشاشة","Mute":"صامت","Unmute":"غير الصامت","Playback Rate":"معدل التشغيل","Subtitles":"الترجمة","subtitles off":"ايقاف الترجمة","Captions":"التعليقات","captions off":"ايقاف التعليقات","Chapters":"فصول","You aborted the media playback":"لقد ألغيت تشغيل الفيديو","A network error caused the media download to fail part-way.":"تسبب خطأ في الشبكة بفشل تحميل الفيديو بالكامل.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"لا يمكن تحميل الفيديو بسبب فشل في الخادم أو الشبكة ، أو فشل بسبب عدم امكانية قراءة تنسيق الفيديو.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"تم ايقاف تشغيل الفيديو بسبب مشكلة فساد أو لأن الفيديو المستخدم يستخدم ميزات غير مدعومة من متصفحك.","No compatible source was found for this media.":"فشل العثور على أي مصدر متوافق مع هذا الفيديو.","Play Video":"تشغيل الفيديو","Close":"أغلق","Modal Window":"نافذة مشروطة","This is a modal window":"هذه نافذة مشروطة","This modal can be closed by pressing the Escape key or activating the close button.":"يمكن غلق هذه النافذة المشروطة عن طريق الضغط على زر الخروج أو تفعيل زر الإغلاق",", opens captions settings dialog":", تفتح نافذة  خيارات التعليقات",", opens subtitles settings dialog":", تفتح نافذة  خيارات الترجمة",", selected":", مختار"}

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filters */
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberToPercentage__ = __webpack_require__("mcwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__numberToTime__ = __webpack_require__("9h+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datetime__ = __webpack_require__("+cOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__("jCu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date__ = __webpack_require__("5TPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__time__ = __webpack_require__("Oif5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__newClassGradeText__ = __webpack_require__("BYjg");









var filters = {
  numberToPercentage: __WEBPACK_IMPORTED_MODULE_1__numberToPercentage__["a" /* default */],
  numberToTime: __WEBPACK_IMPORTED_MODULE_2__numberToTime__["a" /* default */],
  datetime: __WEBPACK_IMPORTED_MODULE_3__datetime__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_5__date__["a" /* default */],
  time: __WEBPACK_IMPORTED_MODULE_6__time__["a" /* default */],
  newClassGradeText: __WEBPACK_IMPORTED_MODULE_7__newClassGradeText__["a" /* default */]
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).forEach(function (name) {
    Vue.filter(name, filters[name]);
  });
}

/***/ }),

/***/ "Q3Ac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "library-card",
      on: {
        mouseover: function($event) {
          return _vm.handleCardOver(_vm.card.id)
        },
        mouseleave: _vm.handleCardLeave
      }
    },
    [
      _vm.selectedCardId === _vm.card.id
        ? _c("div", { staticClass: "card-background" }, [
            _c("div", { staticClass: "card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.openCardPreview }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-eye.svg", alt: "icon" }
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.preview")) +
                        "\n        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.goToCardDetails }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/images/ic-zoom-in.svg",
                        alt: "icon"
                      }
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.detail_view")) +
                        "\n        "
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-cover-img-thumb clickable",
          style: _vm.styleBindings
        },
        [
          false
            ? _c("div", { staticClass: "card-action" }, [
                _c(
                  "div",
                  { staticClass: "card-action-btn" },
                  [
                    _c(
                      "IconDropdown",
                      { attrs: { dropup: false } },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.openCardPreview }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.preview")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-block clickable" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 card-info-section" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "h4",
                {
                  staticClass: "card-title",
                  class: _vm.card.title.length > 20 && "long-title",
                  attrs: { title: _vm.card.title }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.card.title) + "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-subtitle typography--caption" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getGradeLabel(_vm.card)) +
                    " ∙\n            " +
                    _vm._s(_vm.getSubjectLabel(_vm.card)) +
                    "\n            "
                ),
                _vm.card.chapter_name
                  ? _c("span", [
                      _vm._v(
                        "\n              ∙ " +
                          _vm._s(_vm.card.chapter_name) +
                          "\n            "
                      )
                    ])
                  : _vm.card.core_concept_id
                  ? _c("span", [
                      _vm._v(
                        "\n              ∙ " +
                          _vm._s(
                            _vm.getCoreConceptLabel(_vm.card.core_concept)
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-bottom-desc" }, [
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _vm.card.page_count - _vm.card.quiz_count > 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.card.non_quiz")) +
                              " " +
                              _vm._s(
                                _vm.$t("common.card.count", {
                                  cnt: _vm.card.page_count - _vm.card.quiz_count
                                })
                              ) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.page_count - _vm.card.quiz_count > 0 &&
                    _vm.card.quiz_count > 0
                      ? _c("span", [_vm._v("∙")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.quiz_count > 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.card.quiz")) +
                              " " +
                              _vm._s(
                                _vm.$t("common.card.count", {
                                  cnt: _vm.card.quiz_count
                                })
                              ) +
                              "\n              "
                          )
                        ])
                      : _c("span", { staticStyle: { color: "transparent" } }, [
                          _vm._v("_")
                        ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.card.author_name))]),
                    _vm._v(" "),
                    _vm.card.assigned_count
                      ? _c("span", [
                          _vm._v(
                            "| " +
                              _vm._s(
                                _vm.$t("common.card.share_count", {
                                  cnt: _vm.card.assigned_count
                                })
                              )
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              !_vm.card.publisher_id
                ? _c("div", [
                    _c(
                      "small",
                      {
                        staticClass:
                          "typography--caption typography--color-secondary"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.card.updated_at")) +
                            ": " +
                            _vm._s(_vm._f("datetime")(_vm.card.updated_at)) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d975b426", esExports)
  }
}

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QKZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mdc-textfield-container card-title-input" },
    [
      _c(
        "div",
        { staticClass: "mdc-textfield", class: _vm.inputValidationBindings },
        [
          _c("input", {
            staticClass: "mdc-textfield__input",
            attrs: {
              type: "text",
              id: "card-title-input",
              required: "",
              placeholder: _vm.$t("card_details.card_meta.title_placeholder")
            },
            domProps: { value: _vm.text },
            on: { input: _vm.onInput }
          })
        ]
      ),
      _vm._v(" "),
      _vm.errors.has("text:required")
        ? _c(
            "p",
            {
              staticClass:
                "mdc-textfield-helptext mdc-textfield-helptext--persistent mdc-textfield-helptext--validation-msg",
              attrs: { role: "alert" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("card_details.error.title_required")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.has("text:max")
        ? _c(
            "p",
            {
              staticClass:
                "mdc-textfield-helptext mdc-textfield-helptext--persistent mdc-textfield-helptext--validation-msg",
              attrs: { role: "alert" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("card_details.error.title_max_len")) +
                  "\n  "
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0817bcb2", esExports)
  }
}

/***/ }),

/***/ "QOoE":
/***/ (function(module, exports) {

module.exports = {"Play":"Spela","Pause":"Pausa","Current Time":"Aktuell tid","Duration Time":"Total tid","Remaining Time":"Återstående tid","Stream Type":"Strömningstyp","LIVE":"LIVE","Loaded":"Laddad","Progress":"Förlopp","Fullscreen":"Fullskärm","Non-Fullscreen":"Ej fullskärm","Mute":"Ljud av","Unmute":"Ljud på","Playback Rate":"Uppspelningshastighet","Subtitles":"Text på","subtitles off":"Text av","Captions":"Text på","captions off":"Text av","Chapters":"Kapitel","You aborted the media playback":"Du har avbrutit videouppspelningen.","A network error caused the media download to fail part-way.":"Ett nätverksfel gjorde att nedladdningen av videon avbröts.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Det gick inte att ladda videon, antingen på grund av ett server- eller nätverksfel, eller för att formatet inte stöds.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Uppspelningen avbröts på grund av att videon är skadad, eller också för att videon använder funktioner som din webbläsare inte stöder.","No compatible source was found for this media.":"Det gick inte att hitta någon kompatibel källa för den här videon."}

/***/ }),

/***/ "QQ+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("DDRY");


var module = {
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "QQ97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleSwitch_vue__ = __webpack_require__("ro9L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8babe050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleSwitch_vue__ = __webpack_require__("JDL/");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8babe050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ToggleSwitch.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8babe050", Component.options)
  } else {
    hotAPI.reload("data-v-8babe050", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QaKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("49iO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("Kpuh");
/* unused harmony reexport router */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "QbNR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-video-modal',

  data: function data() {
    return {
      videoLink: '',

      youtube: /(^https?:\/\/youtu\.be\/[-_a-zA-Z0-9]+$|^https:\/\/www\.youtube\.com\/watch\?v=[-_a-zA-Z0-9]+$)/,

      vimeo: /^https?:\/\/vimeo\.com\/[-_a-zA-Z0-9]+$/,

      naverTv: /^https?:\/\/tv\.naver\.com\/v\/[-_a-zA-Z0-9]+$/,

      baseRegex: /(^https?:\/\/youtu\.be\/|^https?:\/\/www\.youtube\.com\/watch\?v=|^https?:\/\/vimeo\.com\/|^https?:\/\/tv\.naver\.com\/v\/)/,

      youtubeEmbedBase: 'https://www.youtube.com/embed/',

      vimeoEmbedBase: 'https://player.vimeo.com/video/'
    };
  },


  computed: {
    trimmedVideoLink: function trimmedVideoLink() {
      return this.videoLink.trim();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchVideoEmbedSrc']), {
    getVideoId: function getVideoId(link) {
      return link.replace(this.baseRegex, '');
    },
    getEmbed: function getEmbed(link) {
      var embed = {
        src: '',
        is_iframe: false
      };

      if (this.youtube.test(link)) {
        embed.src = '' + this.youtubeEmbedBase + this.getVideoId(link);
        embed.is_iframe = true;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(embed);
      }

      if (this.vimeo.test(link)) {
        embed.src = '' + this.vimeoEmbedBase + this.getVideoId(link);
        embed.is_iframe = true;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(embed);
      }

      if (this.naverTv.test(link)) {
        return this.fetchVideoEmbedSrc({ video_url: link }).then(function (result) {
          embed.src = result.embed_src;
          embed.is_iframe = true;
          return embed;
        }).catch(function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('video-load-failed-alert');
        });
      }

      embed.src = link;
      embed.is_iframe = false;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(embed);
    },
    addVideo: function addVideo() {
      var _this = this;

      this.getEmbed(this.trimmedVideoLink).then(function (embed) {
        _this.$emit('add', embed);
        _this.clear();
      }).catch(function (err) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isString"])(err)) {
          _this.$root.$emit('show::modal', err);
        }
      });
    },
    clear: function clear() {
      this.videoLink = '';
    }
  })
});

/***/ }),

/***/ "Qenl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-criteria-modal',

  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a
  },

  data: function data() {
    return {
      loading: true,

      criteriaValue: 60
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    evaluationCriteria: 'evaluationCriteria',
    evaluationFilters: 'evaluationFilters',
    managingClasses: 'managingClasses',
    subjectMap: 'evaluationSubjectMap'
  }), {
    selectedSubjectId: function selectedSubjectId() {
      return this.evaluationFilters.subject_id;
    },
    selectedClassId: function selectedClassId() {
      return this.evaluationFilters.class_id;
    },
    selectedClassName: function selectedClassName() {
      if (this.managingClasses[this.selectedClassId]) {
        var selectedClass = this.managingClasses[this.selectedClassId];

        return selectedClass.year + ' ' + selectedClass.grade + ' - ' + selectedClass.name;
      }

      return '';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchEvaluationCriteria', 'saveEvaluationCriteria']), {
    fetchCriteria: function fetchCriteria() {
      var _this = this;

      var params = {
        classId: this.selectedClassId,
        filters: {
          subject_id: this.selectedSubjectId
        }
      };

      this.fetchEvaluationCriteria(params).then(function () {
        _this.criteriaValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(_this.evaluationCriteria);
        _this.loading = false;
      });
    },
    saveCriteria: function saveCriteria() {
      var _this2 = this;

      this.loading = true;

      var params = {
        classId: this.selectedClassId,
        criteriaBody: {
          subject_id: this.selectedSubjectId,
          criteria: [this.criteriaValue, 0]
        }
      };

      this.saveEvaluationCriteria(params).then(function () {
        return _this2.$emit('criteria-updated');
      });
    }
  }),

  created: function created() {
    this.fetchCriteria();
  },
  beforeDestroy: function beforeDestroy() {
    this.loading = true;
  }
});

/***/ }),

/***/ "QiU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyQuizCard_vue__ = __webpack_require__("t/um");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc23358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyQuizCard_vue__ = __webpack_require__("pRPP");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("99rT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dc23358"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyQuizCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc23358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyQuizCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-quizzes/components/MyQuizCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4dc23358", Component.options)
  } else {
    hotAPI.reload("data-v-4dc23358", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QnFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  evaluationList: [],

  evaluationFilters: {
    class_id: null,
    subject_id: null,
    date_range: 365
  },

  evaluationOrderBy: 'number',

  evaluationCriteria: null,

  evaluationSubjectMap: {
    2: '수학',
    3: '사회',
    5: '과학'
  },

  classEvaluationDomains: {},

  selectedClassEvaluationDomainIds: {}
});

/***/ }),

/***/ "R+Pf":
/***/ (function(module, exports) {

module.exports = {"Play":"播放","Pause":"暂停","Current Time":"当前时间","Duration Time":"时长","Remaining Time":"剩余时间","Stream Type":"媒体流类型","LIVE":"直播","Loaded":"加载完毕","Progress":"进度","Fullscreen":"全屏","Non-Fullscreen":"退出全屏","Mute":"静音","Unmute":"取消静音","Playback Rate":"播放码率","Subtitles":"字幕","subtitles off":"字幕关闭","Captions":"内嵌字幕","captions off":"内嵌字幕关闭","Chapters":"节目段落","You aborted the media playback":"视频播放被终止","A network error caused the media download to fail part-way.":"网络错误导致视频下载中途失败。","The media could not be loaded, either because the server or network failed or because the format is not supported.":"视频因格式不支持或者服务器或网络的问题无法加载。","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。","No compatible source was found for this media.":"无法找到此视频兼容的源。","The media is encrypted and we do not have the keys to decrypt it.":"视频已加密，无法解密。"}

/***/ }),

/***/ "RA5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_labels__ = __webpack_require__("kl7r");











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-video-course',

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_publisherOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      subjectId: '',
      gradeId: '',
      domainId: '',
      courseTitle: '',
      courseDescription: '',
      domainList: [],
      busy: false,
      coreConceptId: '',
      coreConcepts: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['videoCourses', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds', 'coreConceptVideoCourse']), {
    course: function course() {
      return this.videoCourses[this.$route.params.course_id];
    },
    showDomainSelect: function showDomainSelect() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.domainList);
    },
    newCourseDisabled: function newCourseDisabled() {
      if (this.subjectId === '') {
        return true;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.domainList) && this.domainId === '') {
        return true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.courseTitle)) {
        return true;
      }

      return false;
    },
    isCoreConcepts: function isCoreConcepts() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.coreConcepts);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['createNewVideoCourse', 'updateVideoCourse', 'fetchVideoCourse', 'fetchCoreConcepts', 'createCoreConceptVideoCourse', 'fetchCoreConceptVideoCourses', 'updateCoreConceptVideoCourse']), {
    prevLink: function prevLink() {
      return this.$router.go(-1);
    },
    onSubjectSelect: function onSubjectSelect() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  grade_id: _this.gradeId === 'null' ? null : _this.gradeId,
                  subject_id: _this.subjectId
                };
                _context.next = 3;
                return _this.fetchCoreConcepts(params);

              case 3:
                _this.coreConcepts = _context.sent;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onGradeSelect: function onGradeSelect() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  grade_id: _this2.gradeId === 'null' ? null : _this2.gradeId,
                  subject_id: _this2.subjectId
                };
                _context2.next = 3;
                return _this2.fetchCoreConcepts(params);

              case 3:
                _this2.coreConcepts = _context2.sent;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    create: function create() {
      var _this3 = this;

      if (!this.busy) {
        this.busy = true;

        var params = {
          title: this.courseTitle,
          description: this.courseDescription || undefined,
          subject_id: this.subjectId || undefined,
          grade_id: this.gradeId === 'null' ? null : this.gradeId || undefined,
          domain_id: this.domainId || undefined
        };

        this.createNewVideoCourse(params).then(function (videoCourses) {
          if (_this3.isCoreConcepts && _this3.coreConceptId) {
            return _this3.createCoreConceptVideoCourse({
              video_course_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["head"])(videoCourses).id,
              core_concept_id: _this3.coreConceptId
            });
          }

          return true;
        }).then(function () {
          return _this3.$router.replace('/video-courses');
        });
      }
    },
    update: function update() {
      var _this4 = this;

      if (!this.busy) {
        this.busy = true;

        var params = {
          id: this.$route.params.course_id,
          title: this.courseTitle,
          description: this.courseDescription || undefined,
          subject_id: this.subjectId || undefined,
          grade_id: this.gradeId === 'null' ? null : this.gradeId || undefined,
          domain_id: this.domainId || undefined
        };

        this.updateVideoCourse(params).then(function () {
          var data = {
            video_course_id: Number(_this4.$route.params.course_id),
            core_concept_id: _this4.coreConceptId
          };

          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this4.coreConceptVideoCourse) && _this4.coreConceptId && _this4.coreConceptId !== _this4.coreConceptVideoCourse.core_concept_id) {
            data.id = _this4.coreConceptVideoCourse.id;
            return _this4.updateCoreConceptVideoCourse(data);
          }

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this4.coreConceptVideoCourse) && _this4.coreConceptId) {
            return _this4.createCoreConceptVideoCourse(data);
          }

          return true;
        }).then(function () {
          _this4.busy = false;
        });
      }
    }
  }),

  beforeMount: function beforeMount() {
    var _this5 = this;

    this.loading = true;

    var courseId = this.$route.params.course_id;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isNil"])(courseId)) {
      this.loading = false;
      return true;
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this5.videoCourses[courseId])) {
        return _this5.fetchVideoCourse(courseId);
      }

      return _this5.videoCourses[courseId];
    }).then(function () {
      _this5.subjectId = _this5.course.subject_id || '';
      _this5.gradeId = _this5.course.grade_id;
      _this5.courseTitle = _this5.course.title;
      _this5.courseDescription = _this5.course.description || '';
    }).then(function () {
      return _this5.fetchCoreConcepts({
        grade_id: _this5.gradeId === 'null' ? null : _this5.gradeId,
        subject_id: _this5.subjectId
      });
    }).then(function (coreConcepts) {
      _this5.coreConcepts = coreConcepts;
      return true;
    }).then(function () {
      return _this5.fetchCoreConceptVideoCourses({ video_course_id: courseId });
    }).then(function () {
      _this5.coreConceptId = _this5.coreConceptVideoCourse.core_concept_id;
      return true;
    }).then(function () {
      _this5.loading = false;
    });

    return true;
  }
});

/***/ }),

/***/ "RKoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVideoCourse_vue__ = __webpack_require__("RA5C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164adeab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVideoCourse_vue__ = __webpack_require__("SqUV");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("4kYG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164adeab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVideoCourse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164adeab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVideoCourse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-courses/views/EditVideoCourse.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-164adeab", Component.options)
  } else {
    hotAPI.reload("data-v-164adeab", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RQVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("nt+b");



var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_SELECTED, function (state, pageId) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'selectedStorePageId', pageId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_PAGES, function (state, pageList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'storePageList', pageList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].ADD_PAGES, function (state, pageList) {
  var _state$storePageList;

  (_state$storePageList = state.storePageList).push.apply(_state$storePageList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(pageList));
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "RWNW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "badge badge-default finished-badge" }, [
    _vm._v("\n  " + _vm._s(_vm.$t("assignments.assignment.completed")) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2344545e", esExports)
  }
}

/***/ }),

/***/ "RWjT":
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ "RX0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mobile__ = __webpack_require__("yx9P");




var convertTimeHHMMSS = function convertTimeHHMMSS(val) {
  var hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lc-audio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mobile__["a" /* default */]],

  props: ['audio', 'autoPlay'],

  data: function data() {
    return {
      audioEl: null,
      loaded: false,
      playing: false,
      paused: true,
      complete: false,
      progressStyle: '',
      currentTime: 0,
      totalDuration: 0
    };
  },


  computed: {
    file: function file() {
      return this.audio.audio_url || this.audio.url;
    },
    current: function current() {
      return this.audioEl ? convertTimeHHMMSS(this.currentTime) : '00:00';
    },
    duration: function duration() {
      return this.audioEl ? convertTimeHHMMSS(this.totalDuration) : '00:00';
    }
  },

  mounted: function mounted() {
    this.audioEl = this.$refs.audiofile;

    this.audioEl.addEventListener('loadeddata', this.handleLoaded);
    this.audioEl.addEventListener('timeupdate', this.handlePlayer);
    this.audioEl.addEventListener('pause', this.handlePlayPause);
    this.audioEl.addEventListener('play', this.handlePlayPause);
  },
  beforeDestroy: function beforeDestroy() {
    this.audioEl.removeEventListener('loadeddata', this.handleLoaded);
    this.audioEl.removeEventListener('timeupdate', this.handlePlayer);
    this.audioEl.removeEventListener('pause', this.handlePlayPause);
    this.audioEl.removeEventListener('play', this.handlePlayPause);
  },


  methods: {
    play: function play() {
      if (this.playing) {
        return;
      }

      this.audioEl.play();

      this.paused = false;
      this.playing = true;
    },
    replay: function replay() {
      this.audioEl.currentTime = 0;
      this.complete = false;
      this.play();
    },
    pause: function pause() {
      if (this.paused) {
        return;
      }

      this.audioEl.pause();

      this.paused = true;
      this.playing = false;
    },
    setPosition: function setPosition(e) {
      var tag = e.target;

      if (!this.playing) return;

      var pos = tag.getBoundingClientRect();
      var seekPos = (e.clientX - pos.left) / pos.width;

      this.audioEl.currentTime = parseInt(this.audioEl.duration * seekPos, 10);
    },
    handleLoaded: function handleLoaded() {
      if (this.audioEl.readyState >= 2) {
        if (this.autoPlay) {
          this.play();
        }

        this.loaded = true;
        this.totalDuration = parseInt(this.audioEl.duration, 10);
      } else {
        throw new Error('Failed to load sound file');
      }
    },
    handlePlayer: function handlePlayer() {
      var currentTime = parseInt(this.audioEl.currentTime, 10);
      var percentage = parseInt(currentTime / this.totalDuration * 100, 10);

      this.progressStyle = 'width: ' + percentage + '%;';
      this.currentTime = currentTime;

      if (this.currentTime === this.totalDuration) {
        this.complete = true;
        this.playing = false;
        this.paused = true;
      }
    },
    handlePlayPause: function handlePlayPause(e) {
      if (e.type === 'pause' && this.paused === false && this.playing === false) {
        this.progressStyle = 'width: 0%;';
        this.currentTime = '00:00';
      }
    }
  },

  created: function created() {
    var _this = this;

    window.pauseMedia = function () {
      _this.pause();
    };
  }
});

/***/ }),

/***/ "RhCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__("XziF");
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/components/LineChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-514d8dc1", Component.options)
  } else {
    hotAPI.reload("data-v-514d8dc1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RjGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "app-footer" }, [_c("FooterContent")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdb56dc8", esExports)
  }
}

/***/ }),

/***/ "RrWb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/reports/assignments" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("reports.sub_header.assignments_tab"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/reports/classes" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("reports.sub_header.classes_tab"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm.managingClassList.length === 0
              ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                  _c("div", { staticClass: "empty-list-text" }, [
                    _c("div", {
                      staticClass:
                        "typography--body-2 typography--color-disabled",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("classes.no_classes"))
                      }
                    })
                  ])
                ])
              : _vm._l(_vm.managingClassList, function(cls) {
                  return _c(
                    "div",
                    { key: cls.id, staticClass: "col-sm-6 col-md-4 col-lg-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-row" },
                        [_c("ClassItem", { attrs: { cls: cls } })],
                        1
                      )
                    ]
                  )
                })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25c91945", esExports)
  }
}

/***/ }),

/***/ "S0bl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraContentEditModal_vue__ = __webpack_require__("AE9a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d50e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraContentEditModal_vue__ = __webpack_require__("0OjA");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("MnNs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraContentEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d50e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraContentEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/ExtraContentEditModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40d50e02", Component.options)
  } else {
    hotAPI.reload("data-v-40d50e02", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S3S+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InquiryForm_vue__ = __webpack_require__("YmAD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94fd00aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InquiryForm_vue__ = __webpack_require__("Ji8T");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("IhEY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InquiryForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94fd00aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InquiryForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/InquiryForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-94fd00aa", Component.options)
  } else {
    hotAPI.reload("data-v-94fd00aa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S4VY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MyCard__ = __webpack_require__("v8Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MyCardShareSetupModal__ = __webpack_require__("dwjP");











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-cards',

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    MyCard: __WEBPACK_IMPORTED_MODULE_6__components_MyCard__["a" /* default */],
    MyCardShareSetupModal: __WEBPACK_IMPORTED_MODULE_7__components_MyCardShareSetupModal__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      cardIdToDelete: null,
      cardIdToMakePrivate: null,
      isMyCardShareSetupModal: false,
      selectedCardId: null,
      savedCardShareLevel: null,
      isLoadingCardShareLevel: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['trimmedMyCardsFilters', 'checkedTutorials', 'coreConceptList', 'myCardsFilters', 'coreConcepts', 'myCardList', 'subjectMap', 'subjectIds', 'gradeMap', 'gradeIds', 'unitList', 'units', 'subjectList', 'gradeList', 'gradeSubjects', 'currentUser']), {
    showTooltip: function showTooltip() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.checkedTutorials) && this.checkedTutorials.welcome && !this.checkedTutorials.tryNewMyCard) {
        return true;
      }

      return false;
    },
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.myCardsFilters.subject_id + '&' + this.myCardsFilters.grade_id;
    },
    currentUnitList: function currentUnitList() {
      var _this = this;

      return this.unitList.filter(function (unit) {
        return unit.subject_id === parseInt(_this.myCardsFilters.subject_id, 10) && unit.name !== 'NO NAME YET';
      });
    },
    currentCoreConceptList: function currentCoreConceptList() {
      var _this2 = this;

      return this.coreConceptList.filter(function (coreConcept) {
        return coreConcept.subject_id === parseInt(_this2.myCardsFilters.subject_id, 10) && coreConcept.grade_id === parseInt(_this2.myCardsFilters.grade_id, 10);
      });
    }
  }),

  watch: {
    gradeSubjects: function gradeSubjects(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('subject-dropdown').firstElementChild.disabled = false;
      }
    },
    currentCoreConceptList: function currentCoreConceptList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state);
    },
    currentUnitList: function currentUnitList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state)) {
        document.getElementById('unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('unit-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(state);
    },
    selectedSubjectGrade: function selectedSubjectGrade(state) {
      if (state.match(/^[0-9]+&0$/) || state.match(/^0&[0-9]+$/)) {
        return null;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(state.match(/[0-9]+&[0-9]+/))) {

        return this.fetchUnits({
          subject_id: this.myCardsFilters.subject_id,
          grade_id: this.myCardsFilters.grade_id
        });
      }

      return null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['makeMyCardPrivateInStore', 'setTutorialAsChecked', 'fetchCoreConcepts', 'setMyCardsFilter', 'updateMyCard', 'removeMyCard', 'fetchMyCards', 'fetchUnits', 'fetchGradeSubjects', 'resetGradeSubjects', 'setMyCardShareLevel']), {
    onTooltipClosed: function onTooltipClosed() {
      this.setTutorialAsChecked('tryNewMyCard');
    },
    goToNewMyCard: function goToNewMyCard() {
      var _this3 = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.checkedTutorials) && !this.checkedTutorials.tryNewMyCard) {
        return this.setTutorialAsChecked('tryNewMyCard').then(function () {
          _this3.$router.push('/new-my-card');
        });
      }

      return this.$router.push('/new-my-card');
    },
    deleteCard: function deleteCard() {
      var _this4 = this;

      this.removeMyCard(this.cardIdToDelete).then(function () {
        _this4.cardIdToDelete = null;
      }).catch(function (err) {
        _this4.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    cancelDeleteCard: function cancelDeleteCard() {
      this.cardIdToDelete = null;
    },
    openDeleteModal: function openDeleteModal(cardId) {
      this.cardIdToDelete = cardId;

      this.$root.$emit('show::modal', 'delete-my-card-modal');
    },
    makeCardPrivate: function makeCardPrivate() {
      var _this5 = this;

      var updateInfo = { share_level: 2 };

      return this.updateMyCard({ cardId: this.cardIdToMakePrivate, updateInfo: updateInfo }).then(function () {
        return _this5.makeMyCardPrivateInStore(_this5.cardIdToMakePrivate);
      }).catch(function (err) {
        _this5.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    cancelMakeCardPrivate: function cancelMakeCardPrivate() {
      this.cardIdToMakePrivate = null;
    },
    openMakeCardPrivateModal: function openMakeCardPrivateModal(cardId) {
      this.cardIdToMakePrivate = cardId;

      this.$root.$emit('show::modal', 'make-card-private-modal');
    },
    handleShareLevelSetupClick: function handleShareLevelSetupClick(cardId, cardShareLevel) {
      this.selectedCardId = cardId;
      this.savedCardShareLevel = cardShareLevel;
      this.isMyCardShareSetupModal = true;
    },
    handleCardShareLevelUpdate: function handleCardShareLevelUpdate(selectedMyCardShareLevel) {
      var _this6 = this;

      var updateInfo = { share_level: selectedMyCardShareLevel };

      this.isLoadingCardShareLevel = true;
      this.updateMyCard({ cardId: this.selectedCardId, updateInfo: updateInfo }).then(function () {
        return _this6.setMyCardShareLevel({
          cardId: _this6.selectedCardId,
          shareLevel: selectedMyCardShareLevel
        });
      }).catch(function (err) {
        _this6.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      }).finally(function () {
        _this6.isLoadingCardShareLevel = false;
        _this6.isMyCardShareSetupModal = false;
      });
    },
    onInfinite: function onInfinite() {
      var _this7 = this;

      this.setMyCardsFilter({ property: 'offset', value: this.myCardsFilters.offset + 20 }).then(function () {
        return _this7.fetchMyCards(_this7.trimmedMyCardsFilters);
      }).then(function (cardList) {
        if (_this7.$refs.infiniteLoading) {
          if (cardList.length === 0) {
            _this7.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          } else {
            _this7.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
          }
        }
      }).catch(function (err) {
        _this7.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    selectSubject: function selectSubject(subjectId) {
      var _this8 = this;

      if (this.myCardsFilters.subject_id !== subjectId) {
        this.setMyCardsFilter({ property: 'subject_id', value: subjectId }).then(function () {
          return _this8.setMyCardsFilter({ property: 'core_concept_id', value: '0' });
        }).then(function () {
          return _this8.setMyCardsFilter({ property: 'unit_id', value: '0' });
        }).then(function () {
          return _this8.setMyCardsFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this8.loading = true;

          return _this8.fetchMyCards(_this8.trimmedMyCardsFilters);
        }).then(function () {
          _this8.loading = false;
        }).catch(function (err) {
          _this8.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectGrade: function selectGrade(gradeId, schoolYear) {
      var _this9 = this;

      if (this.myCardsFilters.grade_id !== gradeId) {
        this.fetchGradeSubjects({ grade: schoolYear }).then(function () {
          return _this9.setMyCardsFilter({ property: 'school_year', value: schoolYear });
        }).then(function () {
          return _this9.setMyCardsFilter({ property: 'grade_id', value: gradeId });
        }).then(function () {
          return _this9.setMyCardsFilter({ property: 'subject_id', value: '0' });
        }).then(function () {
          return _this9.setMyCardsFilter({ property: 'core_concept_id', value: '0' });
        }).then(function () {
          return _this9.setMyCardsFilter({ property: 'unit_id', value: '0' });
        }).then(function () {
          return _this9.setMyCardsFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this9.loading = true;

          return _this9.fetchMyCards(_this9.trimmedMyCardsFilters);
        }).then(function () {
          _this9.loading = false;
        }).catch(function (err) {
          _this9.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectCoreConcept: function selectCoreConcept(coreConceptId) {
      var _this10 = this;

      if (this.myCardsFilters.core_concept_id !== coreConceptId) {
        this.setMyCardsFilter({ property: 'core_concept_id', value: coreConceptId }).then(function () {
          return _this10.setMyCardsFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this10.loading = true;

          return _this10.fetchMyCards(_this10.trimmedMyCardsFilters);
        }).then(function () {
          _this10.loading = false;
        }).catch(function (err) {
          _this10.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectUnit: function selectUnit(unitId) {
      var _this11 = this;

      if (this.myCardsFilters.unit_id !== unitId) {
        this.setMyCardsFilter({ property: 'unit_id', value: unitId }).then(function () {
          return _this11.setMyCardsFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this11.loading = true;

          return _this11.fetchMyCards(_this11.trimmedMyCardsFilters);
        }).then(function () {
          _this11.loading = false;
        }).catch(function (err) {
          _this11.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },
    selectMediaType: function selectMediaType(mediaType) {
      var _this12 = this;

      this.setMyCardsFilter({ property: 'media_type', value: mediaType }).then(function () {
        return _this12.setMyCardsFilter({ property: 'offset', value: 0 });
      }).then(function () {
        _this12.loading = true;

        return _this12.fetchMyCards(_this12.trimmedMyCardsFilters);
      }).then(function () {
        _this12.loading = false;
      }).catch(function (err) {
        _this12.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    selectOrderBy: function selectOrderBy(orderByParam) {
      var _this13 = this;

      if (this.myCardsFilters.order_by !== orderByParam) {
        this.setMyCardsFilter({ property: 'order_by', value: orderByParam }).then(function () {
          return _this13.setMyCardsFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this13.loading = true;

          return _this13.fetchMyCards(_this13.trimmedMyCardsFilters);
        }).then(function () {
          _this13.loading = false;
        }).catch(function (err) {
          _this13.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },

    fetchWithSearchKeywords: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
      var _this14 = this;

      this.loading = true;

      this.fetchMyCards(this.trimmedMyCardsFilters).then(function () {
        _this14.loading = false;
      }).catch(function (err) {
        _this14.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    }, 500),

    applySearchKeywords: function applySearchKeywords(inputText) {
      var _this15 = this;

      if (this.myCardsFilters.search_keywords !== inputText) {
        this.setMyCardsFilter({ property: 'search_keywords', value: inputText }).then(function () {
          return _this15.setMyCardsFilter({ property: 'offset', value: 0 });
        }).then(function () {
          _this15.fetchWithSearchKeywords();
        }).catch(function (err) {
          _this15.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    }
  }),

  mounted: function mounted() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.gradeSubjects)) {
      document.getElementById('subject-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('subject-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.currentCoreConceptList)) {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.currentUnitList)) {
      document.getElementById('unit-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('unit-dropdown').firstElementChild.disabled = false;
    }
  },
  created: function created() {
    var _this16 = this;

    this.resetGradeSubjects();
    this.loading = true;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      return _this16.setMyCardsFilter({ property: 'grade_id', value: _this16.currentUser.grade_id });
    }).then(function () {
      return _this16.fetchGradeSubjects({ grade: _this16.currentUser.grade_id });
    }).then(function () {
      return _this16.setMyCardsFilter({ property: 'offset', value: 0 });
    }).then(function () {
      return _this16.fetchMyCards(_this16.trimmedMyCardsFilters);
    }).then(function () {
      _this16.loading = false;
    }).then(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this16.checkedTutorials) && !_this16.checkedTutorials.welcome) {
        _this16.$root.$emit('show::modal', 'welcome-message-modal');
      }
    }).catch(function (err) {
      console.error('err while fetching my cards in my cards view:', err);
      _this16.$root.$emit('show::modal', 'basic-error-alert');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
  }
});

/***/ }),

/***/ "SAZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__ = __webpack_require__("m5iD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573c0296_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__ = __webpack_require__("Bz0m");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("dI30")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573c0296_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Snackbar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-573c0296", Component.options)
  } else {
    hotAPI.reload("data-v-573c0296", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SCW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoughnutChart_vue__ = __webpack_require__("Gf8J");
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoughnutChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/components/DoughnutChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a8d6741a", Component.options)
  } else {
    hotAPI.reload("data-v-a8d6741a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SH2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__ = __webpack_require__("hY/E");
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/components/BarChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56d40638", Component.options)
  } else {
    hotAPI.reload("data-v-56d40638", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SIQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  clEvents: {}
});

/***/ }),

/***/ "SVVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVideoModal_vue__ = __webpack_require__("QbNR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e74d8e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddVideoModal_vue__ = __webpack_require__("UhI+");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Pz6z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVideoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e74d8e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddVideoModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/AddVideoModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8e74d8e0", Component.options)
  } else {
    hotAPI.reload("data-v-8e74d8e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sbkf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryCard_vue__ = __webpack_require__("yyHP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d975b426_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryCard_vue__ = __webpack_require__("Q3Ac");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibraryCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d975b426_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibraryCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/library/components/LibraryCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d975b426", Component.options)
  } else {
    hotAPI.reload("data-v-d975b426", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ScmJ":
/***/ (function(module, exports) {

module.exports = {"Play":"Lecture","Pause":"Pause","Current Time":"Temps actuel","Duration Time":"Durée","Remaining Time":"Temps restant","Stream Type":"Type de flux","LIVE":"EN DIRECT","Loaded":"Chargé","Progress":"Progression","Fullscreen":"Plein écran","Non-Fullscreen":"Fenêtré","Mute":"Sourdine","Unmute":"Son activé","Playback Rate":"Vitesse de lecture","Subtitles":"Sous-titres","subtitles off":"Sous-titres désactivés","Captions":"Sous-titres transcrits","captions off":"Sous-titres transcrits désactivés","Chapters":"Chapitres","Close Modal Dialog":"Fermer la boîte de dialogue modale","Descriptions":"Descriptions","descriptions off":"descriptions désactivées","Audio Track":"Piste audio","You aborted the media playback":"Vous avez interrompu la lecture de la vidéo.","A network error caused the media download to fail part-way.":"Une erreur de réseau a interrompu le téléchargement de la vidéo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Cette vidéo n'a pas pu être chargée, soit parce que le serveur ou le réseau a échoué ou parce que le format n'est pas reconnu.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La lecture de la vidéo a été interrompue à cause d'un problème de corruption ou parce que la vidéo utilise des fonctionnalités non prises en charge par votre navigateur.","No compatible source was found for this media.":"Aucune source compatible n'a été trouvée pour cette vidéo.","The media is encrypted and we do not have the keys to decrypt it.":"Le média est chiffré et nous n'avons pas les clés pour le déchiffrer.","Play Video":"Lire la vidéo","Close":"Fermer","Modal Window":"Fenêtre modale","This is a modal window":"Ceci est une fenêtre modale","This modal can be closed by pressing the Escape key or activating the close button.":"Ce modal peut être fermé en appuyant sur la touche Échap ou activer le bouton de fermeture.",", opens captions settings dialog":", ouvrir les paramètres des sous-titres transcrits",", opens subtitles settings dialog":", ouvrir les paramètres des sous-titres",", opens descriptions settings dialog":", ouvrir les paramètres des descriptions",", selected":", sélectionné"}

/***/ }),

/***/ "Sl0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lecture
    ? _c(
        "div",
        { staticClass: "row course-lecture-item" },
        [
          _c(
            "div",
            {
              staticClass:
                "col align-self-center course-lecture-item__position-col typography--color-primary text-right"
            },
            [
              _c("span", { staticClass: "course-lecture-item__position" }, [
                _vm._v("\n      " + _vm._s(_vm.position) + "\n    ")
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "col-3 course-lecture-item__thumbnail-col text-center",
              attrs: {
                to: _vm.$route.path + "/lectures/" + _vm.lecture.id,
                tag: "div"
              }
            },
            [
              _c("div", {
                staticClass: "course-lecture-item__thumbnail",
                style: _vm.lectureThumbStyle
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "col course-lecture-item__info-col",
              attrs: {
                to: _vm.$route.path + "/lectures/" + _vm.lecture.id,
                tag: "div"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-1 typography--font-weight-600 mb-1 course-lecture-item__title"
                },
                [_vm._v("\n      " + _vm._s(_vm.lecture.title) + "\n    ")]
              ),
              _vm._v(" "),
              _vm.domainName || _vm.domainConceptName
                ? _c(
                    "div",
                    {
                      staticClass:
                        "typography--caption typography--color-secondary"
                    },
                    [
                      _c("small", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.domainName) +
                            " " +
                            _vm._s(_vm.domainConceptName) +
                            "\n      "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "typography--caption typography--color-secondary"
                },
                [
                  _c("small", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getGradeLabel(_vm.lecture)) +
                        "\n        " +
                        _vm._s(_vm.getSubjectLabel(_vm.lecture)) +
                        "\n        - " +
                        _vm._s(
                          _vm.getShareLevelLabel(_vm.lecture.share_level || 2)
                        ) +
                        "\n      "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.lectureDescription
                ? _c(
                    "div",
                    { staticClass: "typography--caption break-word-all" },
                    [
                      _c("small", {
                        domProps: { innerHTML: _vm._s(_vm.lectureDescription) }
                      })
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "typography--caption typography--color-disabled"
                    },
                    [
                      _c("small", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("common.terms.no_description")) +
                            "\n      "
                        )
                      ])
                    ]
                  )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col align-self-center course-lecture-item__menu-col"
            },
            [
              _c(
                "IconDropdown",
                [
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        to:
                          _vm.$route.path +
                          "/lectures/" +
                          _vm.lecture.id +
                          "/edit"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("video_lectures.video_lecture.edit")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "course-lecture-item__drag-handle" }, [
      _c("img", {
        attrs: {
          src: "/static/images/baseline-drag_handle-24px.svg",
          alt: "drag handle"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc5d20e6", esExports)
  }
}

/***/ }),

/***/ "SqUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-video-course" }, [
    _c("div", { staticClass: "edit-video-course__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "edit-video-course__header-title typography--color-primary text-center"
            },
            [
              _vm.course
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.edit_video_course.title")
                        ) +
                        "\n          "
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.new_video_course.title")
                        ) +
                        "\n          "
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "edit-video-course__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "subject-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("publishers.modal.new_series.subject")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subjectId,
                      expression: "subjectId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "subject-select" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.subjectId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onSubjectSelect
                    ]
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "publishers.modal.new_series.subject_placeholder"
                          )
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.subjectIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(sjId) {
                      return _c(
                        "option",
                        { key: sjId, domProps: { value: sjId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.getTranslatedName(_vm.subjectMap[sjId])
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "grade-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("publishers.modal.new_series.grade")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gradeId,
                      expression: "gradeId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "grade-select" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.gradeId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onGradeSelect
                    ]
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "publishers.modal.new_series.grade_placeholder"
                          )
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.gradeIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(gId) {
                      return _c(
                        "option",
                        { key: gId, domProps: { value: gId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getTranslatedName(_vm.gradeMap[gId])) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.isCoreConcepts
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "core-concept-select" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("card_details.card_meta.core_concept")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.coreConceptId,
                          expression: "coreConceptId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "core-concept-select" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.coreConceptId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "card_details.card_meta.core_concepts_placeholder"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.coreConcepts, function(coreConcept) {
                        return _c(
                          "option",
                          {
                            key: coreConcept.id,
                            domProps: { value: coreConcept.id }
                          },
                          [
                            _vm._v(
                              "\n                [" +
                                _vm._s(coreConcept.id) +
                                "] " +
                                _vm._s(coreConcept.name) +
                                " | " +
                                _vm._s(coreConcept.code) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "video-course-title-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.courseTitle,
                    expression: "courseTitle",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "video-course-title-input",
                  maxlength: "40",
                  placeholder: _vm.$t(
                    "publishers.modal.new_series.name_placeholder"
                  )
                },
                domProps: { value: _vm.courseTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.courseTitle = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "video-course-description-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t("publishers.modal.new_series.description")
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.courseDescription,
                    expression: "courseDescription"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: "video-course-description-input",
                  rows: "5",
                  maxlength: "500",
                  placeholder: _vm.$t(
                    "publishers.modal.new_series.description_placeholder"
                  )
                },
                domProps: { value: _vm.courseDescription },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.courseDescription = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.course
              ? _c("div", { staticClass: "text-center mt-2" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-full edit-video-course__create-btn",
                      attrs: { disabled: _vm.newCourseDisabled },
                      on: {
                        click: function($event) {
                          return _vm.update()
                        }
                      }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("common.save")))])
                        : _c("LoadingBounce")
                    ],
                    1
                  )
                ])
              : _c("div", { staticClass: "text-center mt-2" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-full edit-video-course__create-btn",
                      attrs: { disabled: _vm.newCourseDisabled },
                      on: {
                        click: function($event) {
                          return _vm.create()
                        }
                      }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("video_lectures.new_video_course.create")
                              )
                            )
                          ])
                        : _c("LoadingBounce")
                    ],
                    1
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center mt-2" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary btn-full edit-video-course__cancel-btn typography--color-secondary",
                  on: {
                    click: function($event) {
                      return _vm.prevLink()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("btn.redirect_to_root")) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-164adeab", esExports)
  }
}

/***/ }),

/***/ "Swd/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterListItem_vue__ = __webpack_require__("+L1v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f06b5c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterListItem_vue__ = __webpack_require__("t/qG");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("IFeR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f06b5c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/ChapterListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2f06b5c6", Component.options)
  } else {
    hotAPI.reload("data-v-2f06b5c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SxYe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scroll-app-header',

  props: {
    attachHome: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isPinned: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isPublisherUser', 'currentUser', 'isKrUser']), {
    userProfileUrl: function userProfileUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["b" /* CLASSTING_URL */] + '/users/' + this.currentUser.id;
    },
    headerClassBindings: function headerClassBindings() {
      return {
        'header--unpinned': !this.isPinned,
        'header--pinned': this.isPinned,
        'scroll-app-header': true,
        'app-header': true,
        'bs-b': true
      };
    },
    styleBindings: function styleBindings() {
      if (this.currentUser) {
        return {
          'background-image': 'url(\'' + this.currentUser.profile_image + '\')'
        };
      }

      return {};
    }
  }),

  mounted: function mounted() {
    var _this = this;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 250) {
        _this.isPinned = true;
      } else {
        _this.isPinned = false;
      }
    });
  }
});

/***/ }),

/***/ "T1WI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading-bounce'
});

/***/ }),

/***/ "TCsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchInput_vue__ = __webpack_require__("cKKq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eed8ffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchInput_vue__ = __webpack_require__("TXtg");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eed8ffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SearchInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2eed8ffc", Component.options)
  } else {
    hotAPI.reload("data-v-2eed8ffc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TKdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OAuthCallback_vue__ = __webpack_require__("zpPa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0104e8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OAuthCallback_vue__ = __webpack_require__("vbWt");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OAuthCallback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0104e8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OAuthCallback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/auth/views/OAuthCallback.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f0104e8a", Component.options)
  } else {
    hotAPI.reload("data-v-f0104e8a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TKkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isOldAndroid
    ? _c("div", { staticClass: "lc-audio" }, [
        _c("div", { staticClass: "lc-audio__player lc-container" }, [
          _c("div", { staticClass: "lc-audio__control" }, [
            _vm.paused && !_vm.complete
              ? _c(
                  "button",
                  {
                    staticClass: "mdc-button mdc-button--icon",
                    on: { click: _vm.play }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("play_arrow")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.complete
              ? _c(
                  "button",
                  {
                    staticClass: "mdc-button mdc-button--icon",
                    on: { click: _vm.replay }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("replay")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.playing && !_vm.complete
              ? _c(
                  "button",
                  {
                    staticClass: "mdc-button mdc-button--icon",
                    on: { click: _vm.pause }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("pause")
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "lc-audio__playback-time",
              on: { click: _vm.setPosition }
            },
            [
              _c("span", {
                staticClass: "lc-audio__playback-time-indicator",
                style: _vm.progressStyle
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "lc-audio__time" }, [
            _c("span", { staticClass: "lc-audio__time-current" }, [
              _vm._v("\n        " + _vm._s(_vm.current) + "\n      ")
            ]),
            _vm._v(" |\n      "),
            _c("span", { staticClass: "lc-audio__time-total" }, [
              _vm._v("\n        " + _vm._s(_vm.duration) + "\n      ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("audio", {
          ref: "audiofile",
          staticStyle: { display: "none" },
          attrs: { src: _vm.file, preload: "auto" }
        })
      ])
    : _c("div", { staticClass: "lc-container" }, [
        _c("audio", {
          ref: "audiofile",
          attrs: { controls: "", src: _vm.file, preload: "auto" }
        })
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61693b1f", esExports)
  }
}

/***/ }),

/***/ "TP0h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TX5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-courses" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-courses" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_courses"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-lectures" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_lectures"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-primary new-video-course-btn float-right",
                    attrs: { to: "/new-video-course" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.new_video_course")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row list-group" },
              [
                _vm.videoCourseList.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("video_lectures.no_course")
                            )
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.videoCourseList, function(videoCourse) {
                      return _c(
                        "div",
                        { key: videoCourse.id, staticClass: "list-group-item" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: "/video-courses/" + videoCourse.id }
                            },
                            [
                              _c("VideoCourseItem", {
                                attrs: { course: videoCourse }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-auto" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    to:
                                      "/video-courses/" +
                                      videoCourse.id +
                                      "/edit"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("common.edit")) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v("\n                    \n          "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateCourseLecturesShareLevelModal(
                                        videoCourse.id,
                                        _vm.publicShareLevel
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.video_lectures.share_level.public"
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateCourseLecturesShareLevelModal(
                                        videoCourse.id,
                                        _vm.privateShareLevel
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.video_lectures.share_level.private"
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "make-video-course-lectures-public-modal",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: {
              ok: function($event) {
                return _vm.updateCourseLecturesShareLevel(_vm.publicShareLevel)
              },
              cancel: function($event) {
                _vm.courseIdToUpdateShareLevel = null
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "video_lectures.modals.make_course_lectures_public.message"
                  )
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "make-video-course-lectures-private-modal",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: {
              ok: function($event) {
                return _vm.updateCourseLecturesShareLevel(_vm.privateShareLevel)
              },
              cancel: function($event) {
                _vm.courseIdToUpdateShareLevel = null
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "video_lectures.modals.make_course_lectures_private.message"
                  )
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-084694d3", esExports)
  }
}

/***/ }),

/***/ "TXfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProficiencyLineChart_vue__ = __webpack_require__("8UcO");
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProficiencyLineChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ProficiencyLineChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-067c65f6", Component.options)
  } else {
    hotAPI.reload("data-v-067c65f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TXtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mdc-textfield-container search-input",
      class: _vm.textfieldClassBinding
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-textfield" }, [
        _c("input", {
          staticClass: "mdc-textfield__input",
          attrs: {
            type: "search",
            id: "search-input",
            placeholder: _vm.$t("common.browse_filters.search_placeholder")
          },
          domProps: { value: _vm.text },
          on: { input: _vm.onInput, focus: _vm.focusInput, blur: _vm.blurInput }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cancel-input-btn", on: { click: _vm.clearInput } },
          [
            _c("img", {
              attrs: { src: "/static/images/icon-cancel.svg", alt: "" }
            })
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "search-input" } }, [
      _c("img", { attrs: { src: "/static/images/icon-search.svg", alt: "" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2eed8ffc", esExports)
  }
}

/***/ }),

/***/ "TXvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "page-summary-card clickable" }, [
    _c(
      "div",
      { staticClass: "card-block", on: { click: _vm.openCardPreview } },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "typography--body-3" }, [
              _c("strong", { staticClass: "typography--color-secondary" }, [
                _vm._v(_vm._s(_vm.index + 1))
              ]),
              _vm._v(" "),
              _vm.page.is_quiz
                ? _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.quiz")))]
                  )
                : _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.non_quiz")))]
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "page-content-container",
                class: _vm.classBindings
              },
              [
                _vm.hasImage
                  ? _c("div", {
                      staticClass: "page-image-summary float-left",
                      style: { "background-image": _vm.firstImageSrc }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAudio
                  ? _c("div", { staticClass: "page-audio-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-audio.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstAudioDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasVideo || _vm.hasEmbededVideo
                  ? _c("div", { staticClass: "page-video-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-video.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstVideoDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "typography--body-2 typography--pre-line page-content",
                  domProps: { innerHTML: _vm._s(_vm.pageContent) }
                })
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-018cdf99", esExports)
  }
}

/***/ }),

/***/ "Tarp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chapter-view pt-12 pb-20" }, [
    _c(
      "div",
      { staticClass: "col-12 typography--body-1 typography--font-weight-500" },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("series_cards.chapters.index", { i: _vm.chapter.position })
            ) +
            ": " +
            _vm._s(_vm.chapter.name) +
            "\n\n    "
        ),
        _c(
          "small",
          {
            staticClass: "link-btns clickable ml-1",
            on: {
              click: function($event) {
                return _vm.$emit("open-chapter-edit-modal", _vm.chapter)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("common.edit")))]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "link-btns typography--color-primary ml-2",
            attrs: { to: _vm.createDocxQuizzesLink }
          },
          [
            _c("small", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.create_docx_quizzes.title")) +
                  "\n      "
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "col-12 typography--body-2 typography--color-secondary mt-6"
      },
      [
        _c("span", { staticClass: "mr-6" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("series_cards.chapters.meta.card_count", {
                  cnt: _vm.cardCount
                })
              ) +
              "\n    "
          )
        ]),
        _vm._v("\n    |\n    "),
        _c("span", { staticClass: "ml-6 mr-6" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("series_cards.chapters.meta.domain")) +
              ":\n      " +
              _vm._s(_vm.getDomainLabel(_vm.chapter.domain) || "-") +
              "\n    "
          )
        ]),
        _vm._v("\n    |\n    "),
        _c("span", { staticClass: "ml-6" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("series_cards.chapters.meta.core_concept")) +
              ":\n      " +
              _vm._s(_vm.getCoreConceptLabel(_vm.chapter.core_concept) || "-") +
              "\n    "
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "draggable",
          {
            staticClass: "chapter-view__card-list row",
            on: {
              start: function($event) {
                _vm.drag = true
              },
              end: function($event) {
                _vm.drag = false
              }
            },
            model: {
              value: _vm.chapterCardList,
              callback: function($$v) {
                _vm.chapterCardList = $$v
              },
              expression: "chapterCardList"
            }
          },
          _vm._l(_vm.chapterCardList, function(card) {
            return _c(
              "div",
              { key: card.id, staticClass: "col-sm-6 col-md-4 col-lg-3" },
              [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [
                    _c("PublisherCardView", {
                      attrs: { card: card, "is-series-card": true },
                      on: {
                        "open-remove-from-series-modal": function($event) {
                          return _vm.$emit(
                            "open-remove-from-series-modal",
                            card.id
                          )
                        },
                        "open-remove-card-modal": function($event) {
                          return _vm.$emit("open-remove-card-modal", card.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52e2bc1a", esExports)
  }
}

/***/ }),

/***/ "TcOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal cover-image-edit-modal",
      attrs: {
        id: "cover-image-edit-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "cover-image-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.cover_image_edit.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c("div", { staticClass: "cover-image-edit-modal__form" }, [
            _c("div", {
              staticClass: "cover-image-edit-modal__cover-img-thumb",
              style: _vm.coverImageStyle
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "cover-image-edit-modal__cover-img-input text-center clickable"
              },
              [
                _c("img", {
                  attrs: { src: "/static/images/icon-camera.png", alt: "" }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "no-display",
                  attrs: {
                    type: "file",
                    accept: "image/png,image/jpeg,image/jpg"
                  },
                  on: { change: _vm.onCoverImageChange }
                })
              ]
            )
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary mt-16" },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.cover_image_edit.message")) +
              "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b843772", esExports)
  }
}

/***/ }),

/***/ "Tl9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewSeriesModal__ = __webpack_require__("85pS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SeriesItem__ = __webpack_require__("CVAp");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'publisher-series',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_publisherOnly__["a" /* default */]],

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a,
    NewSeriesModal: __WEBPACK_IMPORTED_MODULE_4__components_NewSeriesModal__["a" /* default */],
    SeriesItem: __WEBPACK_IMPORTED_MODULE_5__components_SeriesItem__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false,
      newSeriesModalIsShown: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentPublisherInfo', 'seriesList']), {
    publisherId: function publisherId() {
      return this.currentPublisherInfo.id;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchPublisherSeries']), {
    onInfinite: function onInfinite() {
      var _this = this;

      var offset = parseInt(this.seriesList.length / 20, 10) * 20;
      var limit = 20;
      var params = {
        publisher_id: this.publisherId,
        offset: offset,
        limit: limit
      };

      return this.fetchPublisherSeries(params).then(function (seriesList) {
        if (_this.$refs.infiniteLoading) {
          _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (seriesList.length < limit) {
            _this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      });
    }
  })
});

/***/ }),

/***/ "TqFq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TvRo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("iV6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("8JgS");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "TwK6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U+y0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassReport_vue__ = __webpack_require__("iW3f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc86192a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassReport_vue__ = __webpack_require__("9In3");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("hwN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc86192a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/views/ClassReport.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dc86192a", Component.options)
  } else {
    hotAPI.reload("data-v-dc86192a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UHCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__("u4Bf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MyPageSummary__ = __webpack_require__("GDs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PageAddBlock__ = __webpack_require__("d67z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PageEditorModal__ = __webpack_require__("1W3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AddVideoModal__ = __webpack_require__("SVVP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_MathEditorModal__ = __webpack_require__("GW0y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MyCardShareSetupModal__ = __webpack_require__("dwjP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__publishers_components_ExtraContentEditModal__ = __webpack_require__("S0bl");



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-card-details',

  components: {
    PageEditorModal: __WEBPACK_IMPORTED_MODULE_11__components_PageEditorModal__["a" /* default */],
    MathEditorModal: __WEBPACK_IMPORTED_MODULE_13__components_MathEditorModal__["a" /* default */],
    MyPageSummary: __WEBPACK_IMPORTED_MODULE_9__components_MyPageSummary__["a" /* default */],
    AddVideoModal: __WEBPACK_IMPORTED_MODULE_12__components_AddVideoModal__["a" /* default */],
    PageAddBlock: __WEBPACK_IMPORTED_MODULE_10__components_PageAddBlock__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a,
    MyCardShareSetupModal: __WEBPACK_IMPORTED_MODULE_14__components_MyCardShareSetupModal__["a" /* default */],
    ExtraContentEditModal: __WEBPACK_IMPORTED_MODULE_15__publishers_components_ExtraContentEditModal__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      pagesReady: false,

      showNonQuizEditorModal: false,

      showMultipleChoiceEditorModal: false,

      showTextEntryEditorModal: false,

      showEssayTypeEditorModal: false,

      showEditPageModal: false,

      busy: false,

      hasError: false,

      pageIndexToDelete: null,

      pageToEditExtraContent: null,

      currentEditingPage: null,

      acceptableFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],

      fileSizeLimit: 10 * 1024 * 1024,

      card: {
        id: null,
        title: '',
        goal: null,
        pages: [],
        subject_id: undefined,
        grade_id: undefined,
        unit_id: undefined,
        chapter_position: undefined,
        chapter_name: undefined,
        core_concept_id: undefined,
        page_count: null,
        quiz_count: null,
        share_level: null,
        cover_image: null,
        cover_image_file: null
      },

      originalCard: {},

      selected: {
        title: '',
        goal: '',
        subject_id: '9999',
        grade_id: '9999',
        unit_id: '9999',
        chapter_position: '9999',
        core_concept_id: '9999'
      },

      destination: null,
      isMyCardShareSetupModal: false,
      selectedCardId: null,
      savedCardShareLevel: null,
      isLoadingCardShareLevel: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['activeEditorLocation', 'isPublisherUser', 'coreConceptList', 'activeEditorId', 'currentUserId', 'coreConcepts', 'subjectMap', 'subjectIds', 'gradeMap', 'unitList', 'myCards', 'units', 'videoCourseCard', 'isLoadingVideoCourseCard', 'gradeSubjects', 'gradeList', 'isBusanPublisher']), {
    selectedSubjectGrade: function selectedSubjectGrade() {
      return this.selected.subject_id + '&' + this.selected.grade_id;
    },
    currentUnitList: function currentUnitList() {
      var _this = this;

      return this.unitList.filter(function (unit) {
        return unit.subject_id === parseInt(_this.selected.subject_id, 10) && unit.name !== 'NO NAME YET';
      });
    },
    currentCoreConceptList: function currentCoreConceptList() {
      var _this2 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["orderBy"])(this.coreConceptList.filter(function (coreConcept) {
        return coreConcept.subject_id === parseInt(_this2.selected.subject_id, 10) && coreConcept.grade_id === parseInt(_this2.selected.grade_id, 10);
      }), 'chapter_position', 'asc');
    },
    cardAuthorName: function cardAuthorName() {
      if (this.card) {
        return this.card.author_name;
      }

      return '';
    },
    isModified: function isModified() {
      var updatedProperties = this.getUpdatedProperties(this.card);
      delete updatedProperties.cover_image_file;

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(updatedProperties);
    },
    styleBindings: function styleBindings() {
      if (this.card && this.card.cover_image) {
        return {
          'background-image': 'url(\'' + this.card.cover_image + '\')'
        };
      }

      return {};
    },
    saveDisabled: function saveDisabled() {
      return this.card.pages.length === 0 || this.hasError;
    },
    isVideoCourseCard: function isVideoCourseCard() {
      return this.selected.video_course_id !== '' && this.isPublisherUser;
    }
  }),

  watch: {
    gradeSubjects: function gradeSubjects(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(state)) {
        document.getElementById('subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('subject-dropdown').firstElementChild.disabled = false;
      }
    },
    currentCoreConceptList: function currentCoreConceptList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(state)) {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(state);
    },
    currentUnitList: function currentUnitList(state) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(state)) {
        document.getElementById('unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('unit-dropdown').firstElementChild.disabled = false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(state);
    },
    selectedSubjectGrade: function selectedSubjectGrade(state) {
      if (state.match(/^[0-9]+&9999$/) || state.match(/^9999&[0-9]+$/)) {
        return null;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNil"])(state.match(/[0-9]+&[0-9]+/))) {

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.fetchUnits({
          subject_id: this.selected.subject_id,
          grade_id: this.selected.grade_id
        }), this.fetchCoreConcepts({
          subject_id: this.selected.subject_id,
          grade_id: this.selected.grade_id
        })]);
      }

      return null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'makeMyCardPrivateInStore', 'uploadNewCardCoverImage', 'removeMyCardCoverImage', 'setSelectedPreviewCard', 'uploadNewCardPageImage', 'uploadNewCardPageAudio', 'removeMyCardPageAudio', 'removeMyCardPageImage', 'setPageLibraryFilter', 'createNewMyCardPage', 'updateMyCardInStore', 'fetchMyCardDetails', 'updateMyCardPages', 'fetchCoreConcepts', 'fetchMyCardPages', 'updateMyPage', 'removeMyCard', 'updateMyCard', 'fetchUnits', 'fetchVideoCourseCards', 'updateVideoCourseCards', 'createVideoCourseCards', 'requestVideoCourseCard', 'fetchGradeSubjects', 'setMyCardShareLevel', 'exportToBest']), {
    onPageAdded: function onPageAdded(newQuizPage) {
      var newPageClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(newQuizPage);

      if (this.pageIndexToDelete !== null) {
        this.card.pages.splice(this.pageIndexToDelete, 1, newPageClone);
        this.currentEditingPage = null;
        this.pageIndexToDelete = null;
      } else {
        newPageClone.position = this.card.pages.length + 1;
        this.card.pages.push(newPageClone);
      }

      this.showMultipleChoiceEditorModal = false;
      this.showTextEntryEditorModal = false;
      this.showEssayTypeEditorModal = false;
      this.showNonQuizEditorModal = false;
      this.showEditPageModal = false;
      this.updateCardPageCount();
    },
    addVideo: function addVideo(embed) {
      var content = '';
      if (embed.is_iframe) {
        content = '<p><iframe src="' + embed.src + '" width="640" height="360" frameborder="0" scrolling="no" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></p><p></p>';
      } else {
        content = '<p>\uB3D9\uC601\uC0C1 \uB9C1\uD06C</p><br>' + embed.src + '<p></p>';
      }

      if (this.activeEditorId) {
        var editor = tinymce.get(this.activeEditorId);

        if (this.activeEditorLocation) {
          editor.selection.setRng(this.activeEditorLocation);
        }

        return editor.insertContent(content);
      }

      return tinymce.activeEditor.insertContent(content);
    },
    addMath: function addMath(latex) {
      if (latex.length > 0) {
        var replacedLatex = latex.replace(/overarc/g, 'overparen');
        var mathInlineId = Math.floor(Math.random() * 1000);
        var content = '&nbsp;<span id="math-inline-' + mathInlineId + '" contenteditable="false">\\(' + replacedLatex + '\\)</span>&nbsp;';
        var activeEditor = void 0;

        if (this.activeEditorId) {
          activeEditor = tinymce.get(this.activeEditorId);

          if (this.activeEditorLocation) {
            activeEditor.selection.setRng(this.activeEditorLocation);
          }
        } else {
          activeEditor = tinymce.activeEditor;
        }

        activeEditor.insertContent(content);

        setTimeout(function () {
          MathJax.Hub.Queue(['Typeset', MathJax.Hub, 'math-inline-' + mathInlineId]);

          activeEditor.insertContent('');
        }, 200);
      }
    },
    pageLeaveOk: function pageLeaveOk() {
      this.$router.push(this.destination.path);
    },
    pageLeaveCancel: function pageLeaveCancel() {
      this.destination = null;
    },
    onCoverImageChange: function onCoverImageChange(event) {
      var images = event.target.files || event.dataTransfer.files;

      if (!images.length) {
        return null;
      }

      var file = images[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (file.size > this.fileSizeLimit) {
        return this.$root.$emit('show::modal', 'file-size-alert');
      }

      if (this.acceptableFileTypes.indexOf(file.type) === -1) {
        return this.$root.$emit('show::modal', 'file-type-alert');
      }

      return this.createMedia(file, 'image');
    },
    createMedia: function createMedia(file) {
      var _this3 = this;

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function (event) {
        _this3.card.cover_image = event.target.result;
        _this3.card.cover_image_file = file;
      };

      return reader.readAsDataURL(file);
    },
    selectSubject: function selectSubject(subjectId) {
      if (this.selected.subject_id !== subjectId) {
        this.selected.subject_id = subjectId;
        this.selected.core_concept_id = '9999';
        this.selected.unit_id = '9999';
      }
    },
    selectGrade: function selectGrade(gradeId, schoolYear) {
      if (this.selected.grade_id !== gradeId) {
        this.selected.grade_id = gradeId;
        this.selected.core_concept_id = '9999';
        this.selected.unit_id = '9999';
        this.selected.subject_id = '9999';
        this.fetchGradeSubjects({ grade: schoolYear });
      }
    },
    selectUnit: function selectUnit(unitId) {
      if (this.selected.unit_id !== unitId) {
        this.selected.unit_id = unitId;

        var unit = this.units[unitId];

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNil"])(unit) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNil"])(unit.core_concept_id)) {
          this.selected.core_concept_id = unit.core_concept_id;
        }
      }
    },
    selectCoreConcept: function selectCoreConcept(coreConceptId) {
      if (this.selected.core_concept_id !== coreConceptId) {
        this.selected.core_concept_id = coreConceptId;
      }
    },
    applySelectedCardInfo: function applySelectedCardInfo() {
      this.card.title = this.selected.title;
      this.card.goal = this.selected.goal || null;

      if (this.selected.subject_id !== '9999') {
        this.card.subject_id = this.selected.subject_id;
      } else {
        this.card.subject_id = undefined;
      }

      this.setPageLibraryFilter({ property: 'subject_id', value: this.card.subject_id || '0' });

      if (this.selected.grade_id !== '9999') {
        this.card.grade_id = this.selected.grade_id;
      } else {
        this.card.grade_id = undefined;
      }

      this.setPageLibraryFilter({ property: 'grade_id', value: this.card.grade_id || '0' });

      if (this.selected.unit_id !== '9999') {
        this.card.unit_id = this.selected.unit_id;

        var unit = this.units[this.card.unit_id];

        this.card.chapter_position = unit ? unit.position : undefined;
        this.card.chapter_name = unit ? unit.name : undefined;
      } else {
        this.card.chapter_position = undefined;
        this.card.chapter_name = undefined;
        this.card.unit_id = undefined;
      }

      if (this.selected.core_concept_id !== '9999') {
        this.card.core_concept_id = this.selected.core_concept_id;
      } else {
        this.card.core_concept_id = undefined;
      }

      if (this.card.unit_id) {
        this.setPageLibraryFilter({ property: 'unit_id', value: this.card.unit_id });
      } else {
        this.setPageLibraryFilter({ property: 'core_concept_id', value: this.card.core_concept_id || '0' });
      }

      if (this.isVideoCourseCard && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.videoCourseCard)) {
        this.requestVideoCourseCard();
        this.updateVideoCourseCards({
          id: this.videoCourseCard.id,
          video_course_id: this.selected.video_course_id,
          card_id: this.videoCourseCard.card_id
        });
      }

      if (this.isVideoCourseCard && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.videoCourseCard) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.card) && Number(this.selected.video_course_id) > 0) {
        this.requestVideoCourseCard();
        this.createVideoCourseCards({
          video_course_id: Number(this.selected.video_course_id),
          card_id: Number(this.card.id)
        });
      }
    },
    setupEditCardModal: function setupEditCardModal() {
      if (this.card.title) {
        this.selected.title = this.card.title;
      } else {
        this.selected.title = '';
      }

      if (this.card.goal) {
        this.selected.goal = this.card.goal;
      } else {
        this.selected.goal = '';
      }

      if (this.card.subject_id) {
        this.selected.subject_id = this.card.subject_id;
      } else {
        this.selected.subject_id = '9999';
      }

      if (this.card.grade_id !== undefined) {
        this.selected.grade_id = this.card.grade_id;
      } else {
        this.selected.grade_id = '9999';
      }

      if (this.card.unit_id) {
        this.selected.unit_id = this.card.unit_id;
      } else {
        this.selected.unit_id = '9999';
      }

      if (this.card.core_concept_id) {
        this.selected.core_concept_id = this.card.core_concept_id;
      } else {
        this.selected.core_concept_id = '9999';
      }

      if (this.isPublisherUser && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.videoCourseCard)) {
        this.selected.video_course_id = this.videoCourseCard.video_course_id;
      }
    },
    getLearningElements: function getLearningElements(coreConcept) {
      if (!coreConcept) {
        return null;
      }

      return coreConcept.description;
    },
    importPages: function importPages(pageList) {
      var _card$pages;

      (_card$pages = this.card.pages).push.apply(_card$pages, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(pageList)));
      this.updateCardPageCount();
    },
    removePage: function removePage() {
      if (this.pageIndexToDelete !== null) {
        this.card.pages.splice(this.pageIndexToDelete, 1);
        this.updateCardPageCount();
        this.pageIndexToDelete = null;
      }
    },
    hiddenPage: function hiddenPage() {
      var page = this.card.pages[this.pageIndexToHidden];
      page.share_level = 99;
      this.updateCardPageCount();
    },
    recoverHiddenPage: function recoverHiddenPage() {
      var page = this.card.pages[this.pageIndexToRecoverHidden];
      page.share_level = this.card.share_level;
      this.updateCardPageCount();
    },
    exportContent: function exportContent() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.busy = true;
                _context.next = 3;
                return _this4.exportToBest(_this4.card);

              case 3:
                _this4.busy = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    updateCardPageCount: function updateCardPageCount() {
      var availablePages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["filter"])(this.card.pages, function (page) {
        return page.share_level !== 99;
      });
      var imageCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["sum"])(availablePages.map(function (page) {
        return page.image_count || 0;
      }));
      var audioCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["sum"])(availablePages.map(function (page) {
        return page.audio_count || 0;
      }));
      var videoCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["sum"])(availablePages.map(function (page) {
        return page.video_count || 0;
      }));

      this.card.page_count = availablePages.length;
      this.card.quiz_count = availablePages.filter(function (page) {
        return !!page.is_quiz;
      }).length;
      this.card.image_count = imageCount;
      this.card.audio_count = audioCount;
      this.card.video_count = videoCount;
    },
    cancelRemovePage: function cancelRemovePage() {
      this.pageIndexToDelete = null;
    },
    cancelHiddenPage: function cancelHiddenPage() {
      this.pageIndexToHidden = null;
    },
    cancelRecoverHiddenPage: function cancelRecoverHiddenPage() {
      this.pageIndexToRecoverHidden = null;
    },
    openRemovePageModal: function openRemovePageModal(pageIndex) {
      this.pageIndexToDelete = pageIndex;

      this.$root.$emit('show::modal', 'delete-my-card-page-modal');
    },
    openHiddenPageModal: function openHiddenPageModal(pageIndex) {
      this.pageIndexToHidden = pageIndex;

      this.$root.$emit('show::modal', 'hidden-my-card-page-modal');
    },
    openRecoverHiddenPageModal: function openRecoverHiddenPageModal(pageIndex) {
      this.pageIndexToRecoverHidden = pageIndex;

      this.$root.$emit('show::modal', 'recover-hidden-my-card-page-modal');
    },
    openEditExtraContentModal: function openEditExtraContentModal(pageIndex) {
      if (this.isModified) {
        alert('수정 중인 문항이 있어, 긴지문을 추가할 수 없는 상태입니다. (새로고침 후 추가 가능)');
      } else {
        this.pageToEditExtraContent = this.card.pages[pageIndex];
      }
    },
    openPageEditorModal: function openPageEditorModal(pageIndex) {
      this.currentEditingPage = this.card.pages[pageIndex];
      this.pageIndexToDelete = pageIndex;

      this.showEditPageModal = true;
    },
    cancelPageEdit: function cancelPageEdit() {
      this.showEditPageModal = false;
      this.currentEditingPage = null;
      this.pageIndexToDelete = null;
      this.pageToEditExtraContent = null;
    },
    openMakePublicModal: function openMakePublicModal() {
      if (this.card.share_level === 1) {
        return this.$root.$emit('show::modal', 'make-card-private-modal');
      }

      if (this.isModified) {
        this.$root.$emit('show::modal', 'make-card-public-modal');

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this.updateShareLevel(1);
    },
    updateShareLevel: function updateShareLevel(shareLevel) {
      var _this5 = this;

      if (shareLevel === 1) {
        this.card.share_level = 1;

        return this.saveMyCard();
      }

      var updateInfo = { share_level: 2 };

      return this.updateMyCard({ cardId: this.card.id, updateInfo: updateInfo }).then(function () {
        _this5.card.share_level = 2;

        return _this5.makeMyCardPrivateInStore(_this5.card.id);
      }).then(function () {
        if (_this5.originalCard.share_level === 1) {
          _this5.originalCard.share_level = 2;
        }
      }).catch(function (err) {
        _this5.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    applyCardTitle: function applyCardTitle(inputText) {
      this.card.title = inputText;
    },
    onHasError: function onHasError(hasError) {
      this.hasError = hasError;
    },
    deleteCard: function deleteCard() {
      var _this6 = this;

      this.removeMyCard(this.card.id).then(function () {
        _this6.$router.push('/my-cards');
      }).catch(function (err) {
        _this6.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    copyCardProperties: function copyCardProperties(card) {
      var cardClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(card);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["extend"])(this.card, cardClone);
    },
    openCardPreview: function openCardPreview() {
      var _this7 = this;

      var cardClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(this.card);

      this.setSelectedPreviewCard(cardClone).then(function () {
        return _this7.setSelectedPreviewPageIndex(0);
      }).then(function () {
        _this7.$root.$emit('show::modal', 'card-preview-modal');
      });
    },
    getUpdatedProperties: function getUpdatedProperties() {
      var _this8 = this;

      var updatedFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["reduce"])(this.card, function (result, value, key) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(value, _this8.originalCard[key]) ? result : result.concat(key);
      }, []);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["zipObject"])(updatedFields, updatedFields.map(function (key) {
        return _this8.card[key];
      }));
    },
    saveMyCard: function saveMyCard() {
      var _this9 = this;

      if (!this.busy) {
        this.busy = true;
        this.updateCardPageCount();
        var updateInfo = this.getUpdatedProperties();
        var updated = false;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          if (!updateInfo.cover_image || !updateInfo.cover_image_file) {
            delete updateInfo.cover_image_file;
            return true;
          }

          var coverImageInfo = {
            cardId: _this9.card.id,
            imageFile: updateInfo.cover_image_file
          };

          if (!_this9.originalCard.cover_image) {
            return _this9.uploadNewCardCoverImage(coverImageInfo).then(function () {
              delete updateInfo.cover_image;
              delete updateInfo.cover_image_file;
              _this9.card.cover_image_file = null;
              updated = true;
            });
          }

          return _this9.removeMyCardCoverImage(_this9.card.id).then(function () {
            return _this9.uploadNewCardCoverImage(coverImageInfo).then(function () {
              delete updateInfo.cover_image;
              delete updateInfo.cover_image_file;
              _this9.card.cover_image_file = null;
              updated = true;
            });
          });
        }).then(function () {
          if (!updateInfo.pages) {
            return true;
          }

          var pageUpdateList = [];
          var originalCardPages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["keyBy"])(_this9.originalCard.pages, 'id');

          _this9.card.pages.forEach(function (page, i) {
            if (!page.card_page_count && originalCardPages[page.id]) {
              if (originalCardPages[page.id].content !== page.content || originalCardPages[page.id].description !== page.description || originalCardPages[page.id].answer_view_type !== page.answer_view_type || originalCardPages[page.id].grading_keywords !== page.grading_keywords || originalCardPages[page.id].score !== page.score || originalCardPages[page.id].answer_criteria !== page.answer_criteria || originalCardPages[page.id].share_level !== page.share_level || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(originalCardPages[page.id].answers, page.answers) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(originalCardPages[page.id].audios, page.audios)) {
                pageUpdateList.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, page, {

                  position: i + 1,
                  type: 'edited'
                }));
              } else if (originalCardPages[page.id].position !== i + 1) {
                pageUpdateList.push({
                  page_id: page.id,
                  position: i + 1,
                  type: 'update'
                });
              }
              delete originalCardPages[page.id];
            } else {
              if (page.id) {
                pageUpdateList.push({
                  store_page_id: page.id,
                  position: i + 1,
                  type: 'new'
                });
              } else {
                pageUpdateList.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, page, {

                  position: i + 1,
                  type: 'created'
                }));
              }
            }
          });

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["keys"])(originalCardPages).forEach(function (pageId) {
            pageUpdateList.push({
              page_id: pageId,
              type: 'delete'
            });
          });

          var createdPageList = pageUpdateList.filter(function (page) {
            return page.type === 'created';
          });
          var editedPageList = pageUpdateList.filter(function (page) {
            return page.type === 'edited';
          });
          var pageUpdateInfo = {
            cardId: _this9.card.id,
            pageUpdateList: pageUpdateList.filter(function (page) {
              return page.type !== 'created' && page.type !== 'edited';
            })
          };

          return _this9.updateMyCardPages(pageUpdateInfo).then(function () {
            var createPagePromises = createdPageList.map(function (page) {
              return _this9.createNewMyCardPage({ cardId: _this9.card.id, page: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, page, { images: [] }) }).then(function (newPage) {
                var createdUpdateInfo = {
                  content: newPage.content,
                  description: newPage.description || ''
                };

                var uploadImgPromises = page.images.map(function (image) {
                  return _this9.uploadNewCardPageImage({ pageId: newPage.id, imageFile: image.image_file }).then(function (newImage) {
                    if (createdUpdateInfo.content.indexOf('data-image-id="' + image.key + '"') !== -1) {
                      createdUpdateInfo.content = createdUpdateInfo.content.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
                    }

                    if (createdUpdateInfo.description.indexOf('data-image-id="' + image.key + '"') !== -1) {
                      createdUpdateInfo.description = createdUpdateInfo.description.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
                    }
                  });
                });

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(uploadImgPromises).then(function () {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(page.audios.map(function (audio) {
                    return _this9.uploadNewCardPageAudio({ pageId: newPage.id, audioFile: audio.audio_file });
                  }));
                }).then(function () {
                  if (newPage.content === createdUpdateInfo.content && newPage.description === createdUpdateInfo.description) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
                  }

                  return _this9.updateMyPage({ pageId: newPage.id, updateInfo: createdUpdateInfo });
                });
              });
            });


            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(createPagePromises);
          }).then(function () {
            var oldCardPages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["keyBy"])(_this9.originalCard.pages, 'id');

            var editedPagePromises = editedPageList.map(function (page) {
              var newImages = page.images.filter(function (img) {
                return !img.id;
              });
              var newAudios = page.audios.filter(function (audio) {
                return !audio.id;
              });
              var removedImages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["differenceBy"])(oldCardPages[page.id].images, page.images, 'id');
              var removedAudios = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["differenceBy"])(oldCardPages[page.id].audios, page.audios, 'id');
              var editedUpdateInfo = {
                content: page.content,
                description: page.description || '',
                answers: page.answers,
                grading_keywords: page.grading_keywords,
                score: page.score,
                answer_criteria: page.answer_criteria,
                share_level: page.share_level
              };

              var uploadImgPromises = newImages.map(function (image) {
                return _this9.uploadNewCardPageImage({ pageId: page.id, imageFile: image.image_file }).then(function (newImage) {
                  if (editedUpdateInfo.content.indexOf('data-image-id="' + image.key + '"') !== -1) {
                    editedUpdateInfo.content = editedUpdateInfo.content.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
                  }

                  if (editedUpdateInfo.description.indexOf('data-image-id="' + image.key + '"') !== -1) {
                    editedUpdateInfo.description = editedUpdateInfo.description.replace('data-image-id="' + image.key + '"', 'data-image-id="' + newImage.id + '"').replace(image.image_url, newImage.image_url);
                  }
                });
              });

              var removeImgPromises = removedImages.map(function (image) {
                return _this9.removeMyCardPageImage(image.id);
              });

              var uploadAudioPromises = newAudios.map(function (audio) {
                return _this9.uploadNewCardPageAudio({ pageId: page.id, audioFile: audio.audio_file });
              });

              var removeAudioPromises = removedAudios.map(function (audio) {
                return _this9.removeMyCardPageAudio(audio.id);
              });

              if (oldCardPages[page.id].position !== page.position) {
                editedUpdateInfo.position = page.position;
              }

              if (oldCardPages[page.id].answer_view_type !== page.answer_view_type) {
                editedUpdateInfo.answer_view_type = page.answer_view_type;
              }

              if (oldCardPages[page.id].image_count !== page.image_count) {
                editedUpdateInfo.image_count = page.image_count;
              }

              if (oldCardPages[page.id].audio_count !== page.audio_count) {
                editedUpdateInfo.audio_count = page.audio_count;
              }

              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(uploadImgPromises).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(removeImgPromises);
              }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(uploadAudioPromises);
              }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(removeAudioPromises);
              }).then(function () {
                return _this9.updateMyPage({ pageId: page.id, updateInfo: editedUpdateInfo });
              });
            });

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(editedPagePromises);
          }).then(function () {
            delete updateInfo.pages;
            updated = true;
          });
        }).then(function () {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(updateInfo)) {
            return true;
          }

          return _this9.updateMyCard({ cardId: _this9.card.id, updateInfo: updateInfo }).then(function () {
            updated = true;
          });
        }).then(function () {
          if (!updated) {
            return true;
          }

          return _this9.fetchMyCardDetails(_this9.card.id).then(function (card) {
            _this9.originalCard = card;
            _this9.copyCardProperties(_this9.originalCard);

            return _this9.fetchMyCardPages({
              cardId: card.id,
              isPublisherUser: _this9.isPublisherUser
            });
          }).then(function (pages) {
            _this9.originalCard.pages = pages;
            _this9.card.pages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(_this9.originalCard.pages);

            return true;
          }).then(function () {
            return _this9.updateMyCardInStore(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(_this9.originalCard));
          });
        }).then(function () {
          _this9.busy = false;
        }).catch(function (err) {
          _this9.busy = false;
          _this9.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
    },
    handleMyCardShareSetupClick: function handleMyCardShareSetupClick(cardId, cardShareLevel) {
      if (this.isModified) {
        this.$root.$emit('show::modal', 'make-card-public-modal');
      }

      this.selectedCardId = cardId;
      this.savedCardShareLevel = cardShareLevel;
      this.isMyCardShareSetupModal = true;
    },
    handleCardShareLevelUpdate: function handleCardShareLevelUpdate(selectedMyCardShareLevel) {
      var _this10 = this;

      var updateInfo = { share_level: selectedMyCardShareLevel };

      this.originalCard.pages.forEach(function (page) {
        if (page.share_level !== 99) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["merge"])(page, { share_level: selectedMyCardShareLevel });
        }
      });
      this.card.pages.forEach(function (page) {
        if (page.share_level !== 99) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["merge"])(page, { share_level: selectedMyCardShareLevel });
        }
      });

      this.isLoadingCardShareLevel = true;
      this.updateMyCard({ cardId: this.selectedCardId, updateInfo: updateInfo }).then(function () {
        return _this10.setMyCardShareLevel({
          cardId: _this10.selectedCardId,
          shareLevel: selectedMyCardShareLevel
        });
      }).catch(function (err) {
        _this10.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
      }).finally(function () {
        _this10.originalCard.share_level = selectedMyCardShareLevel;
        _this10.card.share_level = selectedMyCardShareLevel;
        _this10.isLoadingCardShareLevel = false;
        _this10.isMyCardShareSetupModal = false;
      });
    }
  }),

  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!this.destination && this.isModified) {
      this.destination = to;
      this.$root.$emit('show::modal', 'page-leave-alert');

      return next(false);
    }

    return next();
  },
  mounted: function mounted() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.gradeSubjects)) {
      document.getElementById('subject-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('subject-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.currentCoreConceptList)) {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.currentUnitList)) {
      document.getElementById('unit-dropdown').firstElementChild.disabled = true;
    } else {
      document.getElementById('unit-dropdown').firstElementChild.disabled = false;
    }
  },
  created: function created() {
    var _this11 = this;

    var cardId = this.$route.params.card_id;

    if (this.myCards[cardId]) {
      this.originalCard = this.myCards[cardId];
      this.copyCardProperties(this.originalCard);

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNil"])(this.originalCard.core_concept)) {
        this.fetchCoreConcepts({
          subject_id: this.originalCard.core_concept.subject_id,
          grade_id: this.originalCard.core_concept.grade_id
        });
      }
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.card) || !this.card.id) {
      this.fetchMyCardDetails(cardId).then(function (card) {
        if (card.author_id !== _this11.currentUserId) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject('not_my_card');
        }

        _this11.originalCard = card;
        _this11.copyCardProperties(_this11.originalCard);

        _this11.fetchGradeSubjects({ grade: _this11.originalCard.grade_id });

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNil"])(card.core_concept)) {
          _this11.fetchCoreConcepts({
            subject_id: _this11.originalCard.core_concept.subject_id,
            grade_id: _this11.originalCard.core_concept.grade_id
          });
        }
        return _this11.fetchMyCardPages({
          cardId: card.id,
          isPublisherUser: _this11.isPublisherUser
        });
      }).then(function (pages) {
        _this11.originalCard.pages = pages;
        _this11.card.pages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(_this11.originalCard.pages);

        return null;
      }).then(function () {
        _this11.pagesReady = true;
      }).then(function () {
        return _this11.setPageLibraryFilter({ property: 'subject_id', value: _this11.card.subject_id || '0' });
      }).then(function () {
        return _this11.setPageLibraryFilter({ property: 'grade_id', value: _this11.card.grade_id || '0' });
      }).then(function () {
        return _this11.setPageLibraryFilter({ property: 'core_concept_id', value: _this11.card.core_concept_id || '0' });
      }).catch(function (err) {
        if (err === 'not_my_card') {
          _this11.destination = { path: '/my-cards' };
          return _this11.$router.replace('/my-cards');
        }

        _this11.$root.$emit('show::modal', 'basic-error-alert');

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
      });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.card.pages)) {
      this.fetchGradeSubjects({ grade: this.card.grade_id }).then(function () {
        return _this11.fetchMyCardPages({
          cardId: _this11.card.id,
          isPublisherUser: _this11.isPublisherUser
        });
      }).then(function () {
        _this11.card.pages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(_this11.originalCard.pages);

        return null;
      }).then(function () {
        _this11.pagesReady = true;
      }).catch(function (err) {
        _this11.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
      });
    } else {
      this.pagesReady = true;
    }

    if (cardId && this.isPublisherUser) {
      var params = {
        card_id: cardId
      };

      this.fetchVideoCourseCards(params);
    }
  }
});

/***/ }),

/***/ "UKYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("k/oC");


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].CHECK_TUTORIAL, function (state, tutorial) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.checkedTutorials, tutorial, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_CHECKED_TUTORIALS, function (state, checkedTutorials) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'checkedTutorials', checkedTutorials);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "UNMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-answer-button'
});

/***/ }),

/***/ "USCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "Tooltip",
                  {
                    attrs: { position: "bottom", show: _vm.showTooltip },
                    on: { "tooltip-closed": _vm.onTooltipClosed }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary new-my-card-link",
                        on: { click: _vm.goToNewMyCard }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("my_cards.sub_header.new_my_card")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "tooltip-body" }, slot: "tooltip-body" },
                      [
                        _c("div", {
                          staticClass:
                            "typography--body-3 typography--color-secondary",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("common.tooltip.try_new_my_card")
                            )
                          }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row browse-filter-row" }, [
          _c("div", { staticClass: "col-12 col-lg-7" }, [
            _c("div", { staticClass: "row box" }, [
              _c(
                "div",
                { staticClass: "col-sm-3 divider" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown grade-select",
                      attrs: {
                        text: _vm.getTranslatedName(
                          _vm.gradeMap[_vm.myCardsFilters.grade_id]
                        )
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectGrade("0", "0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.all_grades")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.gradeList, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            on: {
                              click: function($event) {
                                return _vm.selectGrade(
                                  value.id,
                                  value.school_year
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getTranslatedName(_vm.gradeMap[value.id])
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectGrade("null", "null")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.others")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 divider" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown subject-select",
                      attrs: {
                        id: "subject-dropdown",
                        text: _vm.getTranslatedName(
                          _vm.subjectMap[_vm.myCardsFilters.subject_id]
                        )
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectSubject("0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.selects.all_subjects")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.gradeSubjects, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            on: {
                              click: function($event) {
                                return _vm.selectSubject(value.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getTranslatedName(
                                    _vm.subjectMap[value.id]
                                  )
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mnv-dropdown chapter-select",
                      attrs: {
                        text:
                          _vm.getUnitLabel(
                            _vm.units[_vm.myCardsFilters.unit_id]
                          ) || _vm.$t("common.browse_filters.all_chapters"),
                        id: "unit-dropdown"
                      }
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.selectUnit("0")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("common.browse_filters.all_chapters")
                              ) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.currentUnitList, function(unit) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: unit.id,
                            on: {
                              click: function($event) {
                                return _vm.selectUnit(unit.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getUnitLabel(unit)) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-lg-5" },
            [
              _c("SearchInput", {
                attrs: { "model-value": _vm.myCardsFilters.search_keywords },
                on: { input: _vm.applySearchKeywords }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row browse-filter-row my-cards-filters" }, [
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.myCardsFilters.media_type,
                    "check-value": "all",
                    id: "media-type-all"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.all"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.myCardsFilters.media_type,
                    "check-value": "image",
                    id: "media-type-image"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.image"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.myCardsFilters.media_type,
                    "check-value": "video",
                    id: "media-type-video"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.video"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Radio",
                {
                  attrs: {
                    "model-value": _vm.myCardsFilters.media_type,
                    "check-value": "audio",
                    id: "media-type-audio"
                  },
                  on: { change: _vm.selectMediaType }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.media_type.audio"))
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4" }, [
            _c("ul", { staticClass: "nav justify-content-end order-by-btns" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link typography--color-secondary",
                    class: {
                      active: _vm.myCardsFilters.order_by === "updated_at"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectOrderBy("updated_at")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("common.browse_filters.order_by.recency"))
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link typography--color-secondary",
                    class: {
                      active: _vm.myCardsFilters.order_by === "popularity"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectOrderBy("popularity")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("common.browse_filters.order_by.popularity")
                      )
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "row" },
              _vm._l(4, function(n) {
                return _c(
                  "div",
                  { key: n, staticClass: "col-sm-6 col-md-4 col-lg-3" },
                  [_c("div", { staticClass: "card-row" }, [_c("DummyCard")], 1)]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm._l(_vm.myCardList, function(card) {
                  return _c(
                    "div",
                    { key: card.id, staticClass: "col-sm-6 col-md-4 col-lg-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-row" },
                        [
                          _c("MyCard", {
                            attrs: { card: card },
                            on: {
                              "open-delete-modal": _vm.openDeleteModal,
                              "open-make-card-private-modal":
                                _vm.openMakeCardPrivateModal,
                              onShareLevelSetupClick:
                                _vm.handleShareLevelSetupClick
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 text-center mb-5 pb-5",
                        attrs: { slot: "no-results" },
                        slot: "no-results"
                      },
                      [
                        _vm.myCardList.length === 0
                          ? _c("div", [
                              _c("div", {
                                staticClass:
                                  "empty-list-text typography--body-2 typography--color-disabled pt-4",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("my_cards.no_cards"))
                                }
                              })
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "no-more" }, slot: "no-more" })
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.deleteCard, cancel: _vm.cancelDeleteCard }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "make-card-private-modal",
              title: _vm.$t("common.modal.make_private.title")
            },
            on: { ok: _vm.makeCardPrivate, cancel: _vm.cancelMakeCardPrivate }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.make_private.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "no-class-to-assign-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.no_class_to_assign_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isMyCardShareSetupModal
          ? _c("MyCardShareSetupModal", {
              attrs: {
                cardId: _vm.selectedCardId,
                cardShareLevel: _vm.savedCardShareLevel,
                onModalCancelClick: function() {
                  return (this$1.isMyCardShareSetupModal = false)
                },
                onModalOkClick: _vm.handleCardShareLevelUpdate,
                isLoading: _vm.isLoadingCardShareLevel
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hidden-sm-up",
        attrs: { slot: "floating-action-menu" },
        slot: "floating-action-menu"
      },
      [
        _c(
          "FloatingDropup",
          [
            _c("b-dropdown-item", { attrs: { to: "/new-my-card" } }, [
              _vm._v(_vm._s(_vm.$t("my_cards.sub_header.new_my_card")))
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b7d1d0", esExports)
  }
}

/***/ }),

/***/ "Ua77":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ufk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChapterListItem__ = __webpack_require__("Swd/");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'series-list-item',

  components: {
    ChapterListItem: __WEBPACK_IMPORTED_MODULE_5__ChapterListItem__["a" /* default */]
  },

  props: {
    seriesItem: {
      type: Object,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    selectedChapterId: {
      type: Number,
      default: null
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['chaptersBySeriesId', 'subjectMap', 'gradeMap']), {
    chapters: function chapters() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return [];
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(this.chaptersBySeriesId[this.seriesItem.id], 'position');
    },
    coverImageStyle: function coverImageStyle() {
      if (this.seriesItem && this.seriesItem.cover_image_mini) {
        return {
          'background-image': 'url(\'' + this.seriesItem.cover_image_mini + '\')'
        };
      }

      return {};
    },
    subjectName: function subjectName() {
      return this.getSubjectLabel(this.seriesItem);
    },
    gradeName: function gradeName() {
      return this.getGradeLabel(this.seriesItem);
    },
    seriesTitle: function seriesTitle() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return '';
      }

      return this.gradeName + ' ' + this.subjectName + ': ' + this.seriesItem.name;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSeriesChapters']), {
    selectChapter: function selectChapter(chapterId) {
      this.$emit('select-chapter', chapterId);
    },
    selectSeries: function selectSeries() {
      var _this = this;

      if (this.isActive) {
        this.$emit('select-series', null);
        return;
      }

      this.loading = true;
      this.$emit('select-series', this.seriesItem.id);

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this.chapters)) {
          return _this.fetchSeriesChapters(_this.seriesItem.id);
        }

        return true;
      }).then(function () {
        _this.loading = false;
      });
    }
  })
});

/***/ }),

/***/ "UhI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BasicModal",
    {
      staticClass: "basic-modal add-video-modal",
      attrs: {
        id: "add-video-modal",
        title: _vm.$t("common.modal.add_video.title")
      },
      on: { ok: _vm.addVideo, cancel: _vm.clear }
    },
    [
      _c("div", { staticClass: "add-video-input-area" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.videoLink,
              expression: "videoLink"
            }
          ],
          attrs: {
            placeholder: _vm.$t("common.modal.add_video.input_placeholder"),
            type: "url"
          },
          domProps: { value: _vm.videoLink },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.videoLink = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--caption typography--color-secondary" },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("common.modal.add_video.message")) + "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e74d8e0", esExports)
  }
}

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["activeEditorLocation"] = activeEditorLocation;
/* harmony export (immutable) */ __webpack_exports__["activeEditorId"] = activeEditorId;
/* harmony export (immutable) */ __webpack_exports__["selectedPreviewCard"] = selectedPreviewCard;
/* harmony export (immutable) */ __webpack_exports__["selectedPreviewPageIndex"] = selectedPreviewPageIndex;
/* harmony export (immutable) */ __webpack_exports__["isStudentAssignmentPreview"] = isStudentAssignmentPreview;
/* harmony export (immutable) */ __webpack_exports__["isClassAssignmentPreview"] = isClassAssignmentPreview;
/* harmony export (immutable) */ __webpack_exports__["isPagePreview"] = isPagePreview;
/* harmony export (immutable) */ __webpack_exports__["getRouteName"] = getRouteName;
/* harmony export (immutable) */ __webpack_exports__["getRoute"] = getRoute;
/* harmony export (immutable) */ __webpack_exports__["getRouteParams"] = getRouteParams;
/* harmony export (immutable) */ __webpack_exports__["getRouteQuery"] = getRouteQuery;
/* harmony export (immutable) */ __webpack_exports__["getBusy"] = getBusy;
function activeEditorLocation(state) {
  return state.activeEditorLocation;
}

function activeEditorId(state) {
  return state.activeEditorId;
}

function selectedPreviewCard(state) {
  return state.selectedPreviewCard;
}

function selectedPreviewPageIndex(state) {
  return state.selectedPreviewPageIndex;
}

function isStudentAssignmentPreview(state) {
  return state.isStudentAssignmentPreview;
}

function isClassAssignmentPreview(state) {
  return state.isClassAssignmentPreview;
}

function isPagePreview(state) {
  return state.isPagePreview;
}

function getRouteName(state) {
  return state.route.name;
}

function getRoute(state) {
  return state.route.params;
}

function getRouteParams(state) {
  return state.route.params;
}

function getRouteQuery(state) {
  return state.route.query;
}

function getBusy(state) {
  return state.busy;
}

/***/ }),

/***/ "UwXV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("yE1h");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PAGE_LIBRARY_FILTER, function (state, _ref) {
  var property = _ref.property,
      value = _ref.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.pageLibraryFilters, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_MY_CARDS_FILTER, function (state, _ref2) {
  var property = _ref2.property,
      value = _ref2.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.myCardsFilters, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_LIBRARY_FILTER, function (state, _ref3) {
  var property = _ref3.property,
      value = _ref3.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.libraryFilters, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ASSIGNMENTS_FILTER, function (state, _ref4) {
  var property = _ref4.property,
      value = _ref4.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.assignmentsFilters, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CORE_CONCEPTS, function (state, coreConceptList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'coreConcepts', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(coreConceptList, function (coreConcept) {
    return coreConcept.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_DOMAINS, function (state, domainList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'domains', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.domains, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(domainList, function (domain) {
    return domain.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_UNITS, function (state, unitList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'units', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(unitList, function (unit) {
    return unit.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SUBJECTS, function (state, subjectList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'subjectList', subjectList);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'subjectMap', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.subjectMap, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(subjectList, 'id')));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_GRADES, function (state, gradeList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'gradeMap', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.gradeMap, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(gradeList, 'id')));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_GRADE_SUBJECTS, function (state, gradeSubjects) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'gradeSubjects', gradeSubjects);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].RESET_GRADE_SUBJECTS, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'gradeSubjects', []);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "V6Px":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask", attrs: { id: _vm.id } }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-dialog modal-container" }, [
          _c("div", { staticClass: "modal-content" }, [
            !_vm.hideHeader
              ? _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _vm._t("modal-header", [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.title) +
                            "\n              "
                        )
                      ])
                    ])
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "modal-subheader" }, slot: "modal-subheader" },
              [_vm._t("modal-subheader")],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            !_vm.isHideFooter
              ? _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    !_vm.isCustomFooter
                      ? _vm._t("modal-footer", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("cancel")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.closeTitle || _vm.$t("common.cancel")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                disabled: _vm.okDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("ok")
                                }
                              }
                            },
                            [
                              !_vm.okBusy
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.okTitle || _vm.$t("common.confirm")
                                      )
                                    )
                                  ])
                                : _c("LoadingBounce")
                            ],
                            1
                          )
                        ])
                      : _vm._t("modal-footer")
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1906fdbc", esExports)
  }
}

/***/ }),

/***/ "VFCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown icon-dropdown", class: _vm.classBindings },
    [
      _c(
        "button",
        {
          staticClass:
            "btn btn-outline-secondary btn-icon rounded-circle menu-toggle",
          on: { click: _vm.toggleMenu }
        },
        [
          _vm.horizontal
            ? _c("i", { staticClass: "material-icons" }, [
                _vm._v("\n      more_horiz\n    ")
              ])
            : _c("i", { staticClass: "material-icons" }, [
                _vm._v("\n      more_vert\n    ")
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dropdown-menu dropdown-menu-right" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb50ada", esExports)
  }
}

/***/ }),

/***/ "VJFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("GEkf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb50a5e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("okbZ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb50a5e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/AppHeader.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bb50a5e4", Component.options)
  } else {
    hotAPI.reload("data-v-bb50a5e4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VJrM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoCourseItem__ = __webpack_require__("HUuY");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-course-list',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_publisherOnly__["a" /* default */]],

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a,
    VideoCourseItem: __WEBPACK_IMPORTED_MODULE_4__components_VideoCourseItem__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false,
      courseIdToUpdateShareLevel: null,
      publicShareLevel: 1,
      privateShareLevel: 2
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['videoCourseList', 'currentUserId'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateVideoCourseLecturesShareLevel', 'fetchVideoCourseList']), {
    showUpdateCourseLecturesShareLevelModal: function showUpdateCourseLecturesShareLevelModal(courseId, shareLevel) {
      this.courseIdToUpdateShareLevel = courseId;

      if (shareLevel === this.publicShareLevel) {
        return this.$root.$emit('show::modal', 'make-video-course-lectures-public-modal');
      }

      return this.$root.$emit('show::modal', 'make-video-course-lectures-private-modal');
    },
    updateCourseLecturesShareLevel: function updateCourseLecturesShareLevel(shareLevel) {
      var params = {
        id: this.courseIdToUpdateShareLevel,
        share_level: shareLevel
      };

      return this.updateVideoCourseLecturesShareLevel(params);
    },
    onInfinite: function onInfinite() {
      var _this = this;

      var perPage = 10;
      var page = parseInt(this.videoCourseList.length / perPage, 10) + 1;
      var params = {
        owner_id: this.currentUserId,
        order_by: '-created_at',
        per_page: perPage,
        page: page
      };

      return this.fetchVideoCourseList(params).then(function (videoCourseList) {
        if (_this.$refs.infiniteLoading) {
          _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (videoCourseList.length < perPage) {
            _this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      });
    }
  })
});

/***/ }),

/***/ "VONw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["checkedTutorials"] = checkedTutorials;

function checkedTutorials(state) {
  return state.checkedTutorials;
}

/***/ }),

/***/ "W1nl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W7R5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizFormModal_vue__ = __webpack_require__("qrX2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aec22c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizFormModal_vue__ = __webpack_require__("MUYf");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ecS0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0aec22c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizFormModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aec22c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizFormModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-quizzes/components/QuizFormModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0aec22c1", Component.options)
  } else {
    hotAPI.reload("data-v-0aec22c1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W9X/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lc-video" },
    [
      !_vm.isOldAndroid
        ? _c("video-player", {
            ref: "videoPlayer",
            attrs: { options: _vm.videoOptions }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOldAndroid
        ? _c("video", {
            ref: "videofile",
            attrs: {
              controls: "",
              src: _vm.video.video_url || _vm.video.url,
              preload: "auto"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4b64d78", esExports)
  }
}

/***/ }),

/***/ "WQ/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WU4l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-bounce" }, [
      _c("div", { staticClass: "child-bounce loading-bounce-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "child-bounce loading-bounce-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "child-bounce loading-bounce-3" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21ae4e38", esExports)
  }
}

/***/ }),

/***/ "WmYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-course-details" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header video-course-details__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                attrs: {
                  title:
                    _vm.$t("video_lectures.sub_header.video_courses") +
                    " > " +
                    _vm.courseTitle
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("video_lectures.sub_header.video_courses")) +
                    " > " +
                    _vm._s(_vm.courseTitle) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "typography--body-2 typography--color-secondary" },
              [
                _vm.courseDomainName
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("series_cards.chapters.meta.domain")) +
                          ":\n            " +
                          _vm._s(_vm.courseDomainName) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.courseDomainName
                  ? _c("span", { staticClass: "ml-6 mr-6" }, [
                      _vm._v("\n            |\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("video_lectures.video_course.lecture_count", {
                          count: _vm.lectureCount
                        })
                      ) +
                      "\n          "
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-5 hidden-sm-down" }, [
            _c(
              "div",
              { staticClass: "action-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary float-right ml-1 mr-1",
                    attrs: { to: _vm.$route.path + "/upload-video-lecture" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "video_lectures.video_course.create_new_lecture"
                          )
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary float-right ml-1 mr-1",
                    attrs: { to: _vm.$route.path + "/edit" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("video_lectures.video_course.edit")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right mr-1",
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "show::modal",
                          "remove-video-course-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("publishers.headers.actions.remove")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", [
              _vm.courseDescription
                ? _c("div", {
                    staticClass: "typography--body-1 break-word-all",
                    domProps: { innerHTML: _vm._s(_vm.courseDescription) }
                  })
                : _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-disabled"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.terms.no_description")) +
                          "\n      "
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "draggable",
              {
                staticClass: "row",
                attrs: {
                  options: { handle: ".course-lecture-item__drag-handle" }
                },
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: function($event) {
                    _vm.drag = false
                  }
                },
                model: {
                  value: _vm.lectures,
                  callback: function($$v) {
                    _vm.lectures = $$v
                  },
                  expression: "lectures"
                }
              },
              [
                _vm.lectures.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("video_lectures.no_lectures")
                            )
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.lectures, function(lecture, index) {
                      return _c(
                        "div",
                        {
                          key: lecture.id,
                          staticClass:
                            "col-12 video-course-details__lecture-row"
                        },
                        [
                          _c("CourseLectureItem", {
                            attrs: {
                              position: index + 1,
                              lecture: lecture,
                              "domain-concepts": _vm.domainConcepts,
                              "domain-name": _vm.courseDomainName
                            }
                          })
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.loading")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
          ],
          1
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-video-course-modal",
              title: _vm.$t("video_lectures.modals.remove_course.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeCourse()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("video_lectures.modals.remove_course.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8a13bc6", esExports)
  }
}

/***/ }),

/***/ "WwmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileCallback_vue__ = __webpack_require__("ZO7k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b276f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileCallback_vue__ = __webpack_require__("YBaC");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileCallback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b276f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileCallback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/auth/views/MobileCallback.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78b276f8", Component.options)
  } else {
    hotAPI.reload("data-v-78b276f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XQQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_labels__ = __webpack_require__("kl7r");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'series-item',

  props: {
    series: {
      type: Object,
      default: null
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap']), {
    coverImageStyle: function coverImageStyle() {
      if (this.series && this.series.cover_image) {
        return {
          'background-image': 'url(\'' + this.series.cover_image + '\')'
        };
      }

      return {};
    }
  })
});

/***/ }),

/***/ "XS48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__("kl7r");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-course-item',

  props: {
    course: {
      type: Object,
      default: null
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap', 'unitsWithCoreConcepts', 'coreConceptVideoCourses'])),

  methods: {
    getUnitName: function getUnitName(course) {
      var filteredCoreConceptVideoCourses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["filter"])(this.coreConceptVideoCourses, function (c) {
        return c.video_course_id === course.id;
      });
      if (filteredCoreConceptVideoCourses.length > 0) {
        var coreConceptIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(filteredCoreConceptVideoCourses, 'core_concept_id');
        var filteredUnits = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["filter"])(this.unitsWithCoreConcepts, function (u) {
          var unitCoreConceptIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(u.core_concepts, 'id');
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["intersection"])(unitCoreConceptIds, coreConceptIds));
        });
        if (filteredUnits.length > 0) {
          var unitNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(filteredUnits, function (u) {
            return u.grade_id + '\uD559\uB144 ' + u.position + '\uB2E8\uC6D0 ' + u.name;
          });
          return '' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["join"])(unitNames, ',');
        }
      }
      return 'AI에 연결된 정보가 없습니다';
    }
  }
});

/***/ }),

/***/ "XUf3":
/***/ (function(module, exports) {

module.exports = {"Play":"Aναπαραγωγή","Pause":"Παύση","Current Time":"Τρέχων χρόνος","Duration Time":"Συνολικός χρόνος","Remaining Time":"Υπολοιπόμενος χρόνος","Stream Type":"Τύπος ροής","LIVE":"ΖΩΝΤΑΝΑ","Loaded":"Φόρτωση επιτυχής","Progress":"Πρόοδος","Fullscreen":"Πλήρης οθόνη","Non-Fullscreen":"Έξοδος από πλήρη οθόνη","Mute":"Σίγαση","Unmute":"Kατάργηση σίγασης","Playback Rate":"Ρυθμός αναπαραγωγής","Subtitles":"Υπότιτλοι","subtitles off":"απόκρυψη υπότιτλων","Captions":"Λεζάντες","captions off":"απόκρυψη λεζάντων","Chapters":"Κεφάλαια","Close Modal Dialog":"Κλείσιμο παραθύρου","Descriptions":"Περιγραφές","descriptions off":"απόκρυψη περιγραφών","Audio Track":"Ροή ήχου","You aborted the media playback":"Ακυρώσατε την αναπαραγωγή","A network error caused the media download to fail part-way.":"Ένα σφάλμα δικτύου προκάλεσε την αποτυχία μεταφόρτωσης του αρχείου προς αναπαραγωγή.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Το αρχείο προς αναπαραγωγή δεν ήταν δυνατό να φορτωθεί είτε γιατί υπήρξε σφάλμα στον διακομιστή ή το δίκτυο, είτε γιατί ο τύπος του αρχείου δεν υποστηρίζεται.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Η αναπαραγωγή ακυρώθηκε είτε λόγω κατεστραμμένου αρχείου, είτε γιατί το αρχείο απαιτεί λειτουργίες που δεν υποστηρίζονται από το πρόγραμμα περιήγησης που χρησιμοποιείτε.","No compatible source was found for this media.":"Δεν βρέθηκε συμβατή πηγή αναπαραγωγής για το συγκεκριμένο αρχείο.","The media is encrypted and we do not have the keys to decrypt it.":"Το αρχείο προς αναπαραγωγή είναι κρυπτογραφημένo και δεν υπάρχουν τα απαραίτητα κλειδιά αποκρυπτογράφησης.","Play Video":"Αναπαραγωγή βίντεο","Close":"Κλείσιμο","Modal Window":"Aναδυόμενο παράθυρο","This is a modal window":"Το παρών είναι ένα αναδυόμενο παράθυρο","This modal can be closed by pressing the Escape key or activating the close button.":"Αυτό το παράθυρο μπορεί να εξαφανιστεί πατώντας το πλήκτρο Escape ή πατώντας το κουμπί κλεισίματος.",", opens captions settings dialog":", εμφανίζει τις ρυθμίσεις για τις λεζάντες",", opens subtitles settings dialog":", εμφανίζει τις ρυθμίσεις για τους υπότιτλους",", opens descriptions settings dialog":", εμφανίζει τις ρυθμίσεις για τις περιγραφές",", selected":", επιλεγμένο"}

/***/ }),

/***/ "Xc7h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: "my-card-share-setup-modal",
        title: "공개 범위 설정",
        okTitle: "저장",
        okBusy: _vm.isLoading,
        okDisabled: _vm.isLoading
      },
      on: {
        ok: function($event) {
          return _vm.onModalOkClick(_vm.selectedMyCardShareLevel)
        },
        cancel: _vm.onModalCancelClick
      }
    },
    [
      _c(
        "div",
        { staticClass: "display-block" },
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "private",
                "model-value": _vm.selectedMyCardShareLevel,
                "check-value": 2
              },
              on: {
                change: function($event) {
                  return _vm.handleShareLevelChange(2)
                }
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("비공개")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "display-block" },
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "public",
                "model-value": _vm.selectedMyCardShareLevel,
                "check-value": 3
              },
              on: {
                change: function($event) {
                  return _vm.handleShareLevelChange(3)
                }
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("소속 기관에만 공개")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "display-block" },
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "academy",
                "model-value": _vm.selectedMyCardShareLevel,
                "check-value": 1
              },
              on: {
                change: function($event) {
                  return _vm.handleShareLevelChange(1)
                }
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("전체 공개")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isPublisher
        ? _c(
            "div",
            { staticClass: "display-block" },
            [
              _c(
                "Radio",
                {
                  attrs: {
                    id: "hidden",
                    "model-value": _vm.selectedMyCardShareLevel,
                    "check-value": 99
                  },
                  on: {
                    change: function($event) {
                      return _vm.handleShareLevelChange(99)
                    }
                  }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("숨기기")
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d3d8910", esExports)
  }
}

/***/ }),

/***/ "Xi+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", [
    _c(
      "div",
      { staticClass: "card-block" },
      [
        _c("div", { staticClass: "table-action" }, [_vm._t("table-action")], 2),
        _vm._v(" "),
        _vm._t("table-container", [
          _c(
            "div",
            { staticClass: "responsive-table-container" },
            [
              _vm._t("table", [
                _c(
                  "table",
                  { staticClass: "table" },
                  [_vm._t("thead"), _vm._v(" "), _vm._t("tbody")],
                  2
                )
              ])
            ],
            2
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62ce5cfe", esExports)
  }
}

/***/ }),

/***/ "Xkc4":
/***/ (function(module, exports) {

module.exports = {"Play":"Reproducción","Pause":"Pausa","Current Time":"Tiempo reproducido","Duration Time":"Duración total","Remaining Time":"Tiempo restante","Stream Type":"Tipo de secuencia","LIVE":"DIRECTO","Loaded":"Cargado","Progress":"Progreso","Fullscreen":"Pantalla completa","Non-Fullscreen":"Pantalla no completa","Mute":"Silenciar","Unmute":"No silenciado","Playback Rate":"Velocidad de reproducción","Subtitles":"Subtítulos","subtitles off":"Subtítulos desactivados","Captions":"Subtítulos especiales","captions off":"Subtítulos especiales desactivados","Chapters":"Capítulos","You aborted the media playback":"Ha interrumpido la reproducción del vídeo.","A network error caused the media download to fail part-way.":"Un error de red ha interrumpido la descarga del vídeo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.","No compatible source was found for this media.":"No se ha encontrado ninguna fuente compatible con este vídeo."}

/***/ }),

/***/ "XmDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-layout',

  props: {
    attachHome: {
      type: Boolean,
      default: false
    },
    hideAppHeader: {
      type: Boolean,
      default: false
    },
    reportContentModalIsShownProp: {
      type: Boolean,
      default: false
    },
    bodyStyle: {
      type: Object,
      default: Object
    }
  },

  data: function data() {
    return {
      contentReportSuccessModalIsShown: false,
      reportContentModalIsShown: false,
      countryCodeSettingModalIsShown: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUserContryCode']), {
    countryCodeSettingLink: function countryCodeSettingLink() {
      return __WEBPACK_IMPORTED_MODULE_3__config__["b" /* CLASSTING_URL */] + '/settings/personal_info';
    }
  }),

  beforeMount: function beforeMount() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.currentUserContryCode) && this.$route.meta.requiresAuth) {
      this.countryCodeSettingModalIsShown = true;
    }
  },


  watch: {
    reportContentModalIsShownProp: function reportContentModalIsShownProp(value) {
      if (value) {
        this.reportContentModalIsShown = true;
      }
    },
    reportContentModalIsShown: function reportContentModalIsShown(value) {
      if (!value) {
        this.$emit('close-report-content-modal');
      }
    }
  },

  methods: {
    onContentReportSent: function onContentReportSent() {
      this.reportContentModalIsShown = false;
      this.contentReportSuccessModalIsShown = true;
    }
  }
});

/***/ }),

/***/ "XtQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Evaluations_vue__ = __webpack_require__("YcXX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fff8b27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Evaluations_vue__ = __webpack_require__("61Ek");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("p3dc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Evaluations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fff8b27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Evaluations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/views/Evaluations.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5fff8b27", Component.options)
  } else {
    hotAPI.reload("data-v-5fff8b27", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XziF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mixins: [reactiveProp],
  data: function data() {
    var _this = this;

    return {
      chartOptions: {
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 4,
              min: 0,
              max: 100
            },
            gridLines: {
              display: true
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          custom: function custom(tooltipModel) {
            if (tooltipModel.dataPoints) {
              if (tooltipModel.dataPoints[0].datasetIndex === 0) {
                tooltipModel.borderColor = '#ffcd78';
              } else {
                tooltipModel.borderColor = '#00c896';
              }
            }
          },

          callbacks: {
            title: function title(tooltipItem) {
              if (tooltipItem[0].datasetIndex === 0) {
                return Number(tooltipItem[0]['yLabel']).toFixed(1) + '%';
              }
              return '' + tooltipItem[0]['yLabel'] + _this.$t('common.numeric_score_suffix');
            },
            label: function label() {
              return '';
            }
          },
          displayColors: false,
          backgroundColor: 'rgba(255,255,255,1)',
          borderColor: '#000000',
          borderWidth: 1,
          titleFontColor: '#000000',
          titleFontStyle: 'normal'
        }
      }
    };
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
});

/***/ }),

/***/ "Y12a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCard_vue__ = __webpack_require__("uS0I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ce5cfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCard_vue__ = __webpack_require__("Xi+Y");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ce5cfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/TableCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62ce5cfe", Component.options)
  } else {
    hotAPI.reload("data-v-62ce5cfe", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y47w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchStorePages"] = fetchStorePages;
/* harmony export (immutable) */ __webpack_exports__["setStorePagesInStore"] = setStorePagesInStore;
/* harmony export (immutable) */ __webpack_exports__["addStorePagesInStore"] = addStorePagesInStore;
/* harmony export (immutable) */ __webpack_exports__["setSelectedStorePageId"] = setSelectedStorePageId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("nt+b");






function fetchStorePages(_ref, filters) {
  var dispatch = _ref.dispatch;

  var queryParams = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(filters);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/store-pages?' + queryParams).then(function (res) {
    if (!filters.offset) {
      return dispatch('setStorePagesInStore', res.data);
    }

    return dispatch('addStorePagesInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching store pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setStorePagesInStore(_ref2, pageList) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PAGES, pageList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(pageList);
}

function addStorePagesInStore(_ref3, pageList) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_PAGES, pageList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(pageList);
}

function setSelectedStorePageId(_ref4, pageId) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED, pageId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

/***/ }),

/***/ "YBaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "oauth-callback" }, [_c("LoadingBounce")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78b276f8", esExports)
  }
}

/***/ }),

/***/ "YQXT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  selectedClassId: 'all',

  managingClasses: {},

  isClassStudent: null
});

/***/ }),

/***/ "YR2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("pNG8");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SERIES, function (state, seriesList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'series', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.series, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(seriesList, function (eachSeries) {
    return eachSeries.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_SERIES, function (state, seriesId) {
  var filteredList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(state.series, function (eachSeries) {
    return eachSeries.id !== seriesId;
  });

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'series', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(filteredList, function (eachSeries) {
    return eachSeries.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_NON_SERIES_CARDS, function (state, nonSeriesCardList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'nonSeriesCards', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.nonSeriesCards, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(nonSeriesCardList, function (card) {
    return card.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_NON_SERIES_CARD, function (state, cardId) {
  var filteredList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(state.nonSeriesCards, function (card) {
    return card.id !== cardId;
  });

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'nonSeriesCards', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(filteredList, function (card) {
    return card.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CHAPTERS, function (state, chapterList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'chapters', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.chapters, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(chapterList, function (chapter) {
    return chapter.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CHAPTER_CARDS, function (state, cards) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'chapterCards', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.chapterCards, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(cards, function (card) {
    return card.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_CHAPTER_CARD, function (state, cardId) {
  var filteredList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(state.chapterCards, function (card) {
    return card.id !== cardId;
  });

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'chapterCards', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(filteredList, function (card) {
    return card.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REQUEST_VIDEO_COURSE_CARD, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingVideoCourseCard', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_VIDEO_COURSE_CARD, function (state, videoCourseCard) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoCourseCard', videoCourseCard);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingVideoCourseCard', false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_VIDEO_COURSE_CARDS, function (state, videoCourseCards) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoCourseCard', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(videoCourseCards));
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingVideoCourseCard', false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].UPDATE_VIDEO_COURSE_CARD, function (state, videoCourseCard) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoCourseCard', videoCourseCard);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'isLoadingVideoCourseCard', false);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "YUk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("DwvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin__ = __webpack_require__("DhPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__("SIQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("FOyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("aMTb");







var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module, plugin: __WEBPACK_IMPORTED_MODULE_2__plugin__["a" /* default */] });

/***/ }),

/***/ "YV9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YWpU":
/***/ (function(module, exports) {

module.exports = {"Play":"Reproducció","Pause":"Pausa","Current Time":"Temps reproduït","Duration Time":"Durada total","Remaining Time":"Temps restant","Stream Type":"Tipus de seqüència","LIVE":"EN DIRECTE","Loaded":"Carregat","Progress":"Progrés","Fullscreen":"Pantalla completa","Non-Fullscreen":"Pantalla no completa","Mute":"Silencia","Unmute":"Amb so","Playback Rate":"Velocitat de reproducció","Subtitles":"Subtítols","subtitles off":"Subtítols desactivats","Captions":"Llegendes","captions off":"Llegendes desactivades","Chapters":"Capítols","You aborted the media playback":"Heu interromput la reproducció del vídeo.","A network error caused the media download to fail part-way.":"Un error de la xarxa ha interromput la baixada del vídeo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"No s'ha pogut carregar el vídeo perquè el servidor o la xarxa han fallat, o bé perquè el seu format no és compatible.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La reproducció de vídeo s'ha interrumput per un problema de corrupció de dades o bé perquè el vídeo demanava funcions que el vostre navegador no ofereix.","No compatible source was found for this media.":"No s'ha trobat cap font compatible amb el vídeo."}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__("evzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__beforeEachRoutes__ = __webpack_require__("kBv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LandingMainV3__ = __webpack_require__("lH8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_InquiryForm__ = __webpack_require__("S3S+");











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { y: 0 };
  },


  routes: [{
    path: '/',
    redirect: function redirect() {
      return '/library/custom-cards';
    },
    props: {
      attachHome: true
    },
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false
    }
  }, {
    path: '/intro',
    component: __WEBPACK_IMPORTED_MODULE_6__components_LandingMainV3__["a" /* default */],
    props: {
      isIntro: true
    },
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false
    }
  }, {
    path: '/inquiries',
    component: __WEBPACK_IMPORTED_MODULE_7__components_InquiryForm__["a" /* default */],
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false
    }
  }, {
    path: '/viewer/cards/:cardId(\\d+)',
    alias: '/viewer/assignments/:cardId(\\d+)',
    redirect: function redirect(to) {
      var params = to.params;

      window.location.href = __WEBPACK_IMPORTED_MODULE_4__config__["d" /* CT_VIEWER_URL */] + '/viewer/cards/' + params.cardId;
    },
    props: true
  }, {
    path: '/viewer/cats/:catId(\\d+)',
    redirect: function redirect(to) {
      var params = to.params;

      window.location.href = __WEBPACK_IMPORTED_MODULE_4__config__["d" /* CT_VIEWER_URL */] + '/viewer/cats/' + params.catId;
    },
    props: true
  }, {
    path: '/viewer/coin-cards/:cardId(\\d+)',
    redirect: function redirect(to) {
      var params = to.params;

      window.location.href = __WEBPACK_IMPORTED_MODULE_4__config__["d" /* CT_VIEWER_URL */] + '/viewer/coin-cards/' + params.cardId;
    },
    props: true
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* router */]))
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__beforeEachRoutes__["a" /* default */])(router);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YcXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EvaluationServiceGoneModal__ = __webpack_require__("yxUv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EvaluationCriteriaModal__ = __webpack_require__("7sNu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EvaluationTable__ = __webpack_require__("NH0s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DomainSelect__ = __webpack_require__("HNYj");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluations',

  components: {
    EvaluationServiceGoneModal: __WEBPACK_IMPORTED_MODULE_5__components_EvaluationServiceGoneModal__["a" /* default */],
    EvaluationCriteriaModal: __WEBPACK_IMPORTED_MODULE_6__components_EvaluationCriteriaModal__["a" /* default */],
    EvaluationTable: __WEBPACK_IMPORTED_MODULE_7__components_EvaluationTable__["a" /* default */],
    DomainSelect: __WEBPACK_IMPORTED_MODULE_8__components_DomainSelect__["a" /* default */]
  },

  data: function data() {
    return {
      evaluationCriteriaModalIsShown: false,

      evaluationServiceGoneModalIsShown: true,

      noClass: false,

      loading: false,

      busy: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    selectedClassDomainIds: 'selectedClassEvaluationDomainIds',
    classDomains: 'classEvaluationDomains',
    evaluationFilters: 'evaluationFilters',
    evaluationOrderBy: 'evaluationOrderBy',
    managingClassList: 'managingClassList',
    managingClasses: 'managingClasses',
    subjectMap: 'evaluationSubjectMap',
    evaluationList: 'evaluationList'
  }), {
    sortedEvaluationList: function sortedEvaluationList() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sortBy"])(this.evaluationList, this.evaluationOrderBy);
    },
    domains: function domains() {
      return this.classDomains[this.selectedClassId] || [];
    },
    selectedDomainIds: function selectedDomainIds() {
      return this.selectedClassDomainIds[this.selectedClassId] || [];
    },
    selectedSubjectId: function selectedSubjectId() {
      return this.evaluationFilters.subject_id;
    },
    selectedClassId: function selectedClassId() {
      return this.evaluationFilters.class_id;
    },
    selectedClassName: function selectedClassName() {
      if (this.managingClasses[this.selectedClassId]) {
        var selectedClass = this.managingClasses[this.selectedClassId];

        return selectedClass.year + ' ' + selectedClass.grade + ' - ' + selectedClass.name;
      }

      return '';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSelectedEvaluationDomainIds', 'fetchEvaluationDomains', 'saveEvaluationDomains', 'setEvaluationOrderBy', 'setEvaluationFilter', 'fetchEvaluationList', 'saveEvaluationList']), {
    selectSubject: function selectSubject(subjectId) {
      var _this = this;

      var parsedSubjectId = parseInt(subjectId, 10);

      if (parsedSubjectId !== this.selectedSubjectId) {
        this.loading = true;

        this.setEvaluationFilter({ property: 'subject_id', value: parsedSubjectId }).then(function () {
          return _this.fetchDomains();
        }).then(function () {
          return _this.fetchEvaluations();
        }).then(function () {
          _this.loading = false;
        });
      }
    },
    selectClass: function selectClass(classId) {
      var _this2 = this;

      if (classId !== this.selectedClassId) {
        this.loading = true;

        this.setEvaluationFilter({ property: 'class_id', value: classId }).then(function () {
          return _this2.fetchDomains();
        }).then(function () {
          return _this2.fetchEvaluations();
        }).then(function () {
          _this2.loading = false;
        });
      }
    },
    selectOrderBy: function selectOrderBy(orderBy) {
      this.setEvaluationOrderBy(orderBy);
    },
    fetchEvaluations: function fetchEvaluations() {
      return this.fetchEvaluationList({
        classId: this.selectedClassId,
        filters: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.evaluationFilters, {
          domains: this.selectedDomainIds.join(',')
        })
      });
    },
    fetchDomains: function fetchDomains() {
      return this.fetchEvaluationDomains({
        classId: this.selectedClassId,
        filters: this.evaluationFilters
      });
    },
    onDomainOptionClicked: function onDomainOptionClicked(domainId) {
      var _this3 = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this3.selectedDomainIds.indexOf(domainId) === -1) {
          return _this3.setSelectedEvaluationDomainIds({
            classId: _this3.selectedClassId,
            selectedDomainIds: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.selectedDomainIds), [domainId])
          });
        }

        return _this3.setSelectedEvaluationDomainIds({
          classId: _this3.selectedClassId,
          selectedDomainIds: _this3.selectedDomainIds.filter(function (id) {
            return id !== domainId;
          })
        });
      }).then(function () {
        return _this3.fetchEvaluations();
      }).then(function () {
        _this3.loading = false;
      });
    },
    onCriteriaUpdated: function onCriteriaUpdated() {
      var _this4 = this;

      this.loading = true;
      this.evaluationCriteriaModalIsShown = false;

      this.fetchEvaluations().then(function () {
        _this4.loading = false;
      });
    },
    save: function save() {
      var _this5 = this;

      this.busy = true;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.saveEvaluationDomains({
        classId: this.selectedClassId,
        domainBody: {
          subject_id: this.selectedSubjectId,
          domains: this.selectedDomainIds.join(',')
        }
      }), this.saveEvaluationList({
        classId: this.selectedClassId,
        evaluationList: this.evaluationList
      })]).then(function () {
        _this5.busy = false;
      });
    }
  }),

  created: function created() {
    var _this6 = this;

    if (this.managingClassList.length === 0) {
      this.noClass = true;

      return;
    }

    this.loading = true;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (!_this6.selectedClassId && _this6.managingClassList.length > 0) {
        return _this6.setEvaluationFilter({ property: 'class_id', value: _this6.managingClassList[0].id });
      }

      return true;
    }).then(function () {
      if (!_this6.selectedSubjectId) {
        return _this6.setEvaluationFilter({ property: 'subject_id', value: 2 });
      }

      return true;
    }).then(function () {
      return _this6.fetchDomains();
    }).then(function () {
      return _this6.fetchEvaluations();
    }).then(function () {
      _this6.loading = false;
    });
  }
});

/***/ }),

/***/ "YmAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inquiry-form',

  validator: null,

  data: function data() {
    return {
      errors: null,

      busy: false,

      schoolName: '',

      name: '',

      position: '',

      email: '',

      mobile: '',

      content: ''
    };
  },


  watch: {
    schoolName: function schoolName(value) {
      this.validator.validate('schoolName', value);
    },
    name: function name(value) {
      this.validator.validate('name', value);
    },
    position: function position(value) {
      this.validator.validate('position', value);
    },
    email: function email(value) {
      this.validator.validate('email', value);
    },
    mobile: function mobile(value) {
      this.validator.validate('mobile', value);
    }
  },

  computed: {
    isFormInvalid: function isFormInvalid() {
      return this.schoolName === '' || this.name === '' || this.position === '' || this.email === '' || this.mobile === '' || this.errors.any();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['sendSlackNotification', 'submitGoogleForms']), {
    submit: function submit() {
      var _this = this;

      this.busy = true;

      var params = {
        url: __WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].url,
        fields: {}
      };

      params.fields[__WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].fields.schoolName] = this.schoolName;
      params.fields[__WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].fields.name] = this.name;
      params.fields[__WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].fields.position] = this.position;
      params.fields[__WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].fields.email] = this.email;
      params.fields[__WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].fields.mobile] = this.mobile;
      params.fields[__WEBPACK_IMPORTED_MODULE_3__config__["s" /* GOOGLE_FORMS */].fields.content] = this.content;

      var slackParams = {
        school_name: this.schoolName,
        name: this.name,
        position: this.position,
        email: this.email,
        mobile: this.mobile,
        content: this.content
      };

      this.submitGoogleForms(params).then(function () {
        return _this.sendSlackNotification(slackParams);
      }).then(function () {
        _this.$root.$emit('show::modal', 'inquiry-submitted-alert');
        _this.busy = false;
      }).catch(function () {
        _this.$root.$emit('show::modal', 'basic-error-alert');
        _this.busy = false;
      });
    },
    goBack: function goBack() {
      this.$router.back();
    }
  }),

  created: function created() {
    this.validator = new __WEBPACK_IMPORTED_MODULE_1_vee_validate__["Validator"]({
      schoolName: {
        required: true
      },
      name: {
        required: true
      },
      position: {
        required: true
      },
      email: {
        required: true,
        email: true
      },
      mobile: {
        required: true,
        regex: /^\d{3}-?\d{3,4}-?\d{4}$/
      }
    });

    this.$set(this, 'errors', this.validator.errorBag);
  }
});

/***/ }),

/***/ "Yskx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    {
      staticClass: "hide-header-menu landing-main-v3",
      attrs: { "attach-home": _vm.attachHome, "hide-app-header": true }
    },
    [
      _c(
        "div",
        {
          staticClass: "landing-main-v3__container",
          attrs: { slot: "layout-body" },
          slot: "layout-body"
        },
        [
          _c("div", { staticClass: "landing-block-1" }, [
            _c("div", { staticClass: "landing-block-1__logo" }, [
              _c("img", {
                attrs: { src: "/static/images/ic-classting-logo.svg" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-1__title text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("landing_v3.block1.title")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "landing-block-1__subtitle text-center hidden-sm-down"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block1.subtitle")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "landing-block-1__subtitle text-center hidden-md-up",
              domProps: {
                innerHTML: _vm._s(_vm.$t("landing_v3.block1.subtitle_mobile"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-1__btn-row mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block btn-rectangle",
                      on: {
                        click: function($event) {
                          return _vm.startCl()
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block1.start_btn")
                          )
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-outline-primary btn-block btn-rectangle",
                      attrs: { href: _vm.aiUrl, target: "_blank" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("landing_v3.block1.go_to_premium")) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-1__partner-list mx-auto" },
              [
                _c("img", {
                  attrs: { src: "/static/images/img-cp-list-small@2x.png" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-2" }, [
            _c("div", {
              staticClass:
                "landing-block-2__title text-center typography--color-primary",
              domProps: { innerHTML: _vm._s(_vm.$t("landing_v3.block2.title")) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-2__main-intro mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col align-self-center text-center hidden-sm-down"
                  },
                  [
                    _c("img", {
                      staticClass:
                        "align-self-center landing-block-2__main-before",
                      attrs: { src: "/static/images/img-main-before.svg" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "align-self-center landing-block-2__bg-arrow",
                  attrs: { src: "/static/images/img-main-arrow-line.png" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-7 landing-block-2__main-video text-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "landing-block-2__main-video__student-icon"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/static/images/ic-student-m.svg" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("video", { attrs: { autoplay: "", loop: "" } }, [
                      _c("track", { attrs: { kind: "captions" } }),
                      _vm._v(" "),
                      _c("source", {
                        attrs: {
                          src: "/static/videos/main_intro_v3.mp4",
                          type: "video/mp4"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col align-self-center text-center hidden-sm-down"
                  },
                  [
                    _c("img", {
                      staticClass: "landing-block-2__main-after",
                      attrs: { src: "/static/images/img-main-after.svg" }
                    })
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-3" }, [
            _c(
              "div",
              { staticClass: "landing-block-3__guide-arrow text-center" },
              [
                _c("img", {
                  attrs: { src: "/static/images/ic-arrow-intro.svg" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "landing-block-3__title text-center typography--color-primary"
              },
              [
                _c("img", {
                  attrs: {
                    src: "/static/images/img-cl-logo-intro.svg",
                    alt: "Classting Learning"
                  }
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block3.title")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__guide-number text-center" },
              [_vm._v("\n        01\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__feature-intro mx-auto" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 push-md-7 landing-block-3__feature-intro__text"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "landing-block-3__feature-intro__title typography--color-primary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("landing_v3.block3.features.01.title")
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "landing-block-3__feature-intro__description typography--color-secondary",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block3.features.01.description")
                          )
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 pull-md-5 landing-block-3__feature-intro__video"
                    },
                    [
                      _c("video", { attrs: { autoplay: "", loop: "" } }, [
                        _c("track", { attrs: { kind: "captions" } }),
                        _vm._v(" "),
                        _c("source", {
                          attrs: {
                            src: "/static/videos/assign_easily_v3.mp4",
                            type: "video/mp4"
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__guide-number text-center" },
              [_vm._v("\n        02\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-3__feature-intro mx-auto" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 landing-block-3__feature-intro__text"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "landing-block-3__feature-intro__text-right"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "landing-block-3__feature-intro__title typography--color-primary"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "landing_v3.block3.features.02.title"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "landing-block-3__feature-intro__description typography--color-secondary",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "landing_v3.block3.features.02.description"
                                )
                              )
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 landing-block-3__feature-intro__video"
                    },
                    [
                      _c("video", { attrs: { autoplay: "", loop: "" } }, [
                        _c("track", { attrs: { kind: "captions" } }),
                        _vm._v(" "),
                        _c("source", {
                          attrs: {
                            src: "/static/videos/learning_reports_v3.mp4",
                            type: "video/mp4"
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "landing-block-5" },
            [
              _c(
                "carousel",
                {
                  attrs: {
                    "per-page": 1,
                    "pagination-active-color": "#00c896",
                    "pagination-color": "rgba(0, 0, 0, 0.1)",
                    "pagination-padding": 6,
                    "pagination-size": 10,
                    loop: true,
                    "autoplay-hover-pause": true,
                    "autoplay-timeout": 3000,
                    autoplay: false
                  }
                },
                _vm._l(_vm.selectedAnalysisSlides, function(item) {
                  return _c("slide", { key: item.id }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 landing-block-5__slide-image"
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: { src: item.image }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 align-self-center landing-block-5__slide-text"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "landing-block-5__title typography--color-primary typography--font-weight-500"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t(item.title)) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "landing-block-5__description typography--color-secondary",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t(item.subtitle))
                            }
                          })
                        ]
                      )
                    ])
                  ])
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "landing-block-6__title typography--color-primary text-center"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block6.title")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "landing-block-6__subtitle typography--color-secondary text-center mx-auto",
              domProps: {
                innerHTML: _vm._s(_vm.$t("landing_v3.block6.subtitle"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-6__stats mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                  _c("div", { staticClass: "landing-block-6__stats__icon" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-total-user.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "landing-block-6__stats__number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("landing_v3.block6.stats.users.count")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "landing-block-6__stats__label typography--color-secondary typography--font-weight-500"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("landing_v3.block6.stats.users.label")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                  _c("div", { staticClass: "landing-block-6__stats__icon" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-total-teacher.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "landing-block-6__stats__number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("landing_v3.block6.stats.teachers.count")
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "landing-block-6__stats__label typography--color-secondary typography--font-weight-500"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("landing_v3.block6.stats.teachers.label")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                  _c("div", { staticClass: "landing-block-6__stats__icon" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-total-school.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "landing-block-6__stats__number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("landing_v3.block6.stats.schools.count")
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "landing-block-6__stats__label typography--color-secondary typography--font-weight-500"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("landing_v3.block6.stats.schools.label")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-7" }, [
            _c("div", { staticClass: "landing-block-7__title text-center" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("landing_v3.block7.title")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "landing-block-7__subtitle text-center mx-auto" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("landing_v3.block7.subtitle")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "landing-block-7__btn-row mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block btn-rectangle",
                      on: {
                        click: function($event) {
                          return _vm.startCl()
                        }
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block7.start_btn")
                          )
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("router-link", {
                      staticClass:
                        "btn btn-outline-primary btn-block btn-rectangle",
                      attrs: { to: "/inquiries", tag: "button" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("landing_v3.block7.inquiry_btn")
                        )
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-8" }, [
            _c(
              "div",
              { staticClass: "landing-block-8__testimonials hidden-sm-down" },
              [
                _c("div", { staticClass: "row no-gutters teachers-top-row" }, [
                  _c("div", { staticClass: "col teachers-side-col" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-1-1.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-2-1.jpg" }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-1-2.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/left-2-2.jpg" }
                            })
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col teachers-middle-col" }, [
                    _c("div", { staticClass: "landing-block-8__video-cover" }, [
                      _c("div", {
                        staticClass:
                          "landing-block-8__video-cover__title text-center",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("landing_v3.block8.video_title")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "landing-block-8__video-cover__btn clickable",
                            on: {
                              click: function($event) {
                                _vm.showVideo = true
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/static/images/ic-play-btn.svg",
                                alt: "play teacher interview video"
                              }
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showVideo
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "landing-block-8__close-video-btn clickable",
                            on: {
                              click: function($event) {
                                _vm.showVideo = false
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: "/static/images/icon-cancel.svg" }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showVideo
                      ? _c(
                          "div",
                          { staticClass: "landing-block-8__video-container" },
                          [
                            _c("iframe", {
                              attrs: {
                                frameborder: "0",
                                width: "560",
                                height: "315",
                                id: "video",
                                src:
                                  "https://www.youtube.com/embed/FJNviT9gJss?autoplay=1;rel=0&showinfo=0",
                                allowfullscreen: ""
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col teachers-side-col" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-1-1.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-2-1.jpg" }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col col-md-6 teachers-img-col" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-1-2.jpg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "transparent-bg" }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "w-100 img-fluid",
                              attrs: { src: "/static/images/right-2-2.jpg" }
                            })
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row no-gutters teachers-bottom-row" },
                  [
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-1.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-2.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-3.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-4.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-5.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-6.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-7.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-8.jpg" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col teachers-img-col" }, [
                      _c("div", { staticClass: "transparent-bg" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "w-100 img-fluid",
                        attrs: { src: "/static/images/bottom-1-9.jpg" }
                      })
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "landing-block-8__testimonials-mobile hidden-md-up"
              },
              [
                _c("div", { staticClass: "landing-block-8__video-cover" }, [
                  _c("div", {
                    staticClass:
                      "landing-block-8__video-cover__title text-center",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("landing_v3.block8.video_title"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "landing-block-8__video-cover__btn clickable",
                        on: {
                          click: function($event) {
                            _vm.showVideo = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/static/images/ic-play-btn.svg",
                            alt: "play teacher interview video"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.showVideo
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "landing-block-8__close-video-btn clickable",
                        on: {
                          click: function($event) {
                            _vm.showVideo = false
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: "/static/images/icon-cancel.svg" }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showVideo
                  ? _c(
                      "div",
                      { staticClass: "landing-block-8__video-container" },
                      [
                        _c("iframe", {
                          attrs: {
                            frameborder: "0",
                            width: "560",
                            height: "315",
                            id: "video-mobile",
                            src:
                              "https://www.youtube.com/embed/FJNviT9gJss?autoplay=1;rel=0&showinfo=0",
                            allowfullscreen: ""
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "landing-block-8__edulab-photos-mobile hidden-md-up"
              },
              [
                _c("img", {
                  staticClass: "w-100",
                  attrs: { src: "/static/images/bg-edulab-768.jpg" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing-block-9" }, [
            _c("div", { staticClass: "text-center" }, [_c("FooterContent")], 1)
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d58196e6", esExports)
  }
}

/***/ }),

/***/ "Z53B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicLineGauge_vue__ = __webpack_require__("OHwt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737ef387_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicLineGauge_vue__ = __webpack_require__("vfyc");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("PJGR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicLineGauge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737ef387_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicLineGauge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/BasicLineGauge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-737ef387", Component.options)
  } else {
    hotAPI.reload("data-v-737ef387", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZL3V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZO7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_locales__ = __webpack_require__("5BI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Mobile__ = __webpack_require__("yx9P");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobile-callback',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_locales__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Mobile__["a" /* default */]],

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setToken', 'setDevice', 'signIn'])),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    routeQuery: 'getRouteQuery'
  })),

  created: function created() {
    var _this = this;

    var APP_NAME = 'classting';
    var continueUrl = this.routeQuery.continue_url;

    this.setDevice(APP_NAME);
    window.setToken = function (token) {
      _this.setToken(token).then(function () {
        return _this.signIn();
      }).then(function (userInfo) {
        _this.$i18n.locale = _this.getLocale(userInfo);
      }).then(function () {
        if (continueUrl) {
          _this.$router.replace(window.decodeURIComponent(continueUrl));
        } else {
          _this.$router.replace('/');
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      });
    };

    this.call('ctjscall://authorize?source=' + APP_NAME + '&callback=setToken');
  }
});

/***/ }),

/***/ "ZXWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("lRsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("MZXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("/rOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("tGcv");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "ZYmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_OAuthCallback__ = __webpack_require__("TKdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_MobileCallback__ = __webpack_require__("WwmP");



var router = [{
  name: 'auth.oauthCallback',
  path: '/oauth_callback/:provider',
  component: __WEBPACK_IMPORTED_MODULE_0__views_OAuthCallback__["a" /* default */],
  meta: {
    requiresAuth: false,
    requiresTeacherRole: false
  }
}, {
  name: 'auth.mobileCallback',
  path: '/mobile_callback/:provider',
  component: __WEBPACK_IMPORTED_MODULE_1__views_MobileCallback__["a" /* default */],
  meta: {
    requiresAuth: false,
    requiresTeacherRole: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Zkqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dummy-page-summary'
});

/***/ }),

/***/ "ZzLu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchPage"] = fetchPage;
/* harmony export (immutable) */ __webpack_exports__["updatePage"] = updatePage;
/* harmony export (immutable) */ __webpack_exports__["uploadPageImage"] = uploadPageImage;
/* harmony export (immutable) */ __webpack_exports__["uploadPageAudio"] = uploadPageAudio;
/* harmony export (immutable) */ __webpack_exports__["fetchAdminInfo"] = fetchAdminInfo;
/* harmony export (immutable) */ __webpack_exports__["setEditedPageInStore"] = setEditedPageInStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("C8Zk");





function fetchPage(_, pageId) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching page:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updatePage(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var pageId = _ref2.pageId,
      updateInfo = _ref2.updateInfo;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId, updateInfo).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while updating my page:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadPageImage(_ref3, _ref4) {
  var dispatch = _ref3.dispatch;
  var pageId = _ref4.pageId,
      imageFile = _ref4.imageFile;

  var formData = new FormData();
  formData.append('file', imageFile);

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId + '/images', formData).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while uploading new page image:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadPageAudio(_, _ref5) {
  var pageId = _ref5.pageId,
      audioFile = _ref5.audioFile;

  var formData = new FormData();
  formData.append('file', audioFile);

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId + '/audios', formData).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while uploading new page audio:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchAdminInfo(_, userId) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/admins/' + userId).then(function (res) {
    return res.data;
  });
}

function setEditedPageInStore(_ref6, page) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].UPDATE_PAGE, page);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(page);
}

/***/ }),

/***/ "a+L7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("xQUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("wwUL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "a7z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("6MFk");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]);

/***/ }),

/***/ "aBA+":
/***/ (function(module, exports) {

module.exports = {"Play":"播放","Pause":"暫停","Current Time":"目前時間","Duration Time":"總共時間","Remaining Time":"剩餘時間","Stream Type":"串流類型","LIVE":"直播","Loaded":"載入完畢","Progress":"進度","Fullscreen":"全螢幕","Non-Fullscreen":"退出全螢幕","Mute":"靜音","Unmute":"取消靜音","Playback Rate":" 播放速率","Subtitles":"字幕","subtitles off":"關閉字幕","Captions":"內嵌字幕","captions off":"關閉內嵌字幕","Chapters":"章節","You aborted the media playback":"影片播放已終止","A network error caused the media download to fail part-way.":"網路錯誤導致影片下載失敗。","The media could not be loaded, either because the server or network failed or because the format is not supported.":"影片因格式不支援或者伺服器或網路的問題無法載入。","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"由於影片檔案損毀或是該影片使用了您的瀏覽器不支援的功能，播放終止。","No compatible source was found for this media.":"無法找到相容此影片的來源。","The media is encrypted and we do not have the keys to decrypt it.":"影片已加密，無法解密。"}

/***/ }),

/***/ "aCrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseEditor_vue__ = __webpack_require__("uklx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e65e264_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseEditor_vue__ = __webpack_require__("lkEJ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e65e264_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/BaseEditor.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e65e264", Component.options)
  } else {
    hotAPI.reload("data-v-4e65e264", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aGfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("7TVa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin__ = __webpack_require__("H3S0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__("G5f9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("d9C3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("x0qI");







var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module, plugin: __WEBPACK_IMPORTED_MODULE_2__plugin__["a" /* default */] });

/***/ }),

/***/ "aMTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clEvents"] = clEvents;

function clEvents(state) {
  return state.clEvents;
}

/***/ }),

/***/ "aTk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainSelectOption_vue__ = __webpack_require__("6mhx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e54c342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainSelectOption_vue__ = __webpack_require__("ptPc");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainSelectOption_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e54c342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainSelectOption_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/DomainSelectOption.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e54c342", Component.options)
  } else {
    hotAPI.reload("data-v-4e54c342", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "amYd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lc-image',

  props: ['image'],

  computed: {
    defaultSrc: function defaultSrc() {
      return this.image.large_url;
    },
    srcSet: function srcSet() {
      return [this.image.medium_url + ' 1x', this.image.large_url + ' 2x'].join(',');
    }
  }
});

/***/ }),

/***/ "ao0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("LdoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("klwB");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "aoyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("eEBw");



var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_SELECTED, function (state, cardId) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'selectedCustomCardId', cardId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CARDS, function (state, cardList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'customCardList', cardList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].ADD_CARDS, function (state, cardList) {
  var _state$customCardList;

  (_state$customCardList = state.customCardList).push.apply(_state$customCardList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cardList));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CARD_PAGES, function (state, _ref) {
  var cardId = _ref.cardId,
      pageList = _ref.pageList;

  state.customCardList.forEach(function (card) {
    if (card.id === cardId) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(card, 'pages', pageList);
    }
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "azys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLectureList_vue__ = __webpack_require__("EOHR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417e449a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLectureList_vue__ = __webpack_require__("shMJ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLectureList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417e449a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLectureList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-lectures/views/VideoLectureList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-417e449a", Component.options)
  } else {
    hotAPI.reload("data-v-417e449a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+E9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chapter-edit-modal',

  props: {
    chapter: {
      type: Object,
      default: null
    },
    seriesItem: {
      type: Object,
      default: null
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      loading: false,
      selected: {
        domainId: null,
        coreConceptId: null
      },
      chapterTitle: '',
      filteredCoreConepts: [],
      filteredDomains: [],
      busy: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['coreConceptList', 'domainList', 'subjectMap', 'gradeMap']), {
    modalTitle: function modalTitle() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.chapter) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return [this.getGradeLabel(this.seriesItem), this.getSubjectLabel(this.seriesItem), this.$t('series_cards.chapters.index', { i: this.chapter.position })].join(' ');
      }

      return '';
    },
    saveDisabled: function saveDisabled() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.chapter)) {
        return this.chapterTitle === this.chapter.name && this.selected.domainId === this.chapter.domain_id && this.selected.coreConceptId === this.chapter.core_concept_id;
      }

      return true;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchCoreConcepts', 'fetchDomainList', 'updateChapter']), {
    save: function save() {
      var _this = this;

      if (!this.busy) {
        this.busy = true;

        var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.chapter, {
          name: this.chapterTitle,
          domain_id: this.selected.domainId,
          core_concept_id: this.selected.coreConceptId
        });

        this.updateChapter(params).then(function () {
          return _this.$emit('ok');
        });
      }
    }
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    this.loading = true;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.chapter) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
      this.chapterTitle = this.chapter.name;
      this.selected.domainId = this.chapter.domain_id;
      this.selected.coreConceptId = this.chapter.core_concept_id;

      if (this.seriesItem.grade_id === null) {
        this.loading = false;
        return true;
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        _this2.filteredDomains = _this2.domainList.filter(function (domain) {
          return domain.subject_id === _this2.seriesItem.subject_id;
        });

        if (_this2.filteredDomains.length === 0) {
          return _this2.fetchDomainList({ subject_id: _this2.seriesItem.subject_id }).then(function (domains) {
            _this2.filteredDomains = domains;
          });
        }

        return true;
      }).then(function () {
        _this2.filteredCoreConepts = _this2.coreConceptList.filter(function (cc) {
          return cc.subject_id === _this2.seriesItem.subject_id && cc.grade_id === _this2.seriesItem.grade_id;
        });

        if (_this2.filteredCoreConepts.length === 0) {
          return _this2.fetchCoreConcepts({
            subject_id: _this2.seriesItem.subject_id,
            grade_id: _this2.seriesItem.grade_id
          }).then(function (coreConepts) {
            _this2.filteredCoreConepts = coreConepts;
          });
        }

        return true;
      }).then(function () {
        _this2.loading = false;
      });
    }

    return true;
  }
});

/***/ }),

/***/ "b3O1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("ZYmj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("aGfm");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "b7xH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesCards_vue__ = __webpack_require__("kdnP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790dbd5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesCards_vue__ = __webpack_require__("y00c");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("WQ/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeriesCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790dbd5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeriesCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/views/SeriesCards.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-790dbd5a", Component.options)
  } else {
    hotAPI.reload("data-v-790dbd5a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b8PB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ad-card',

  data: function data() {
    return {
      mouseOver: false
    };
  },


  props: ['showOwner'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['advertisement'])),

  methods: {
    goToAdLink: function goToAdLink() {
      window.open(this.advertisement.link);
    },
    handleCardOver: function handleCardOver() {
      this.mouseOver = true;
    },
    handleCardLeave: function handleCardLeave() {
      this.mouseOver = false;
    }
  }
});

/***/ }),

/***/ "bGDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("evzl");





var plugins = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__app__["b" /* store */].plugins));

/* harmony default export */ __webpack_exports__["a"] = (plugins);

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export components */
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReportContentFromPreview__ = __webpack_require__("n4lW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProficiencyLineChart__ = __webpack_require__("TXfd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WelcomeMessageModal__ = __webpack_require__("85X4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportContentModal__ = __webpack_require__("H2zE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AiScoreGuideModal__ = __webpack_require__("7Z2/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DummyPageSummary__ = __webpack_require__("ANXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PageLibraryModal__ = __webpack_require__("+hPb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AutosizeTextarea__ = __webpack_require__("+ZeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DummyDetailCard__ = __webpack_require__("+871");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollAppHeader__ = __webpack_require__("qJ5E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MoreBtnDropdown__ = __webpack_require__("z0Cz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InProgressBadge__ = __webpack_require__("qNpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FloatingDropup__ = __webpack_require__("pTQH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardTitleInput__ = __webpack_require__("N959");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DateTimePicker__ = __webpack_require__("g7Jj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BasicLineGauge__ = __webpack_require__("Z53B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FinishedBadge__ = __webpack_require__("9+yp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LoadingBounce__ = __webpack_require__("+sNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DummyPageItem__ = __webpack_require__("OFBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__EditorToolbar__ = __webpack_require__("j3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ImageCarousel__ = __webpack_require__("n0Sg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FooterContent__ = __webpack_require__("AaSe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__IconDropdown__ = __webpack_require__("ARZg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ToggleSwitch__ = __webpack_require__("QQ97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CardPreview__ = __webpack_require__("c09o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SearchInput__ = __webpack_require__("TCsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TopicDropup__ = __webpack_require__("KdCt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PolicyModal__ = __webpack_require__("hcAK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__CustomModal__ = __webpack_require__("Cp7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__UpDownArrow__ = __webpack_require__("KPqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__MainLayout__ = __webpack_require__("o3Mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__BasicModal__ = __webpack_require__("8RXv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__BaseEditor__ = __webpack_require__("aCrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AppHeader__ = __webpack_require__("VJFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__AppFooter__ = __webpack_require__("OC/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__TableCard__ = __webpack_require__("Y12a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__DummyCard__ = __webpack_require__("C0dL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__PageItem__ = __webpack_require__("vC3p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Checkbox__ = __webpack_require__("xXit");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Snackbar__ = __webpack_require__("SAZF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__LcAudio__ = __webpack_require__("FaUx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__LcImage__ = __webpack_require__("KW6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__LcVideo__ = __webpack_require__("wuUz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Tooltip__ = __webpack_require__("wwUG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__AppMain__ = __webpack_require__("vZwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Radio__ = __webpack_require__("uPNt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Card__ = __webpack_require__("rhdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ProgressBar__ = __webpack_require__("KcW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__LineGauge__ = __webpack_require__("zq8D");



















































var components = {
  ReportContentFromPreview: __WEBPACK_IMPORTED_MODULE_1__ReportContentFromPreview__["a" /* default */],
  ProficiencyLineChart: __WEBPACK_IMPORTED_MODULE_2__ProficiencyLineChart__["a" /* default */],
  WelcomeMessageModal: __WEBPACK_IMPORTED_MODULE_3__WelcomeMessageModal__["a" /* default */],
  ReportContentModal: __WEBPACK_IMPORTED_MODULE_4__ReportContentModal__["a" /* default */],
  AiScoreGuideModal: __WEBPACK_IMPORTED_MODULE_5__AiScoreGuideModal__["a" /* default */],
  DummyPageSummary: __WEBPACK_IMPORTED_MODULE_6__DummyPageSummary__["a" /* default */],
  PageLibraryModal: __WEBPACK_IMPORTED_MODULE_7__PageLibraryModal__["a" /* default */],
  AutosizeTextarea: __WEBPACK_IMPORTED_MODULE_8__AutosizeTextarea__["a" /* default */],
  DummyDetailCard: __WEBPACK_IMPORTED_MODULE_9__DummyDetailCard__["a" /* default */],
  ScrollAppHeader: __WEBPACK_IMPORTED_MODULE_10__ScrollAppHeader__["a" /* default */],
  MoreBtnDropdown: __WEBPACK_IMPORTED_MODULE_11__MoreBtnDropdown__["a" /* default */],
  InProgressBadge: __WEBPACK_IMPORTED_MODULE_12__InProgressBadge__["a" /* default */],
  FloatingDropup: __WEBPACK_IMPORTED_MODULE_13__FloatingDropup__["a" /* default */],
  CardTitleInput: __WEBPACK_IMPORTED_MODULE_14__CardTitleInput__["a" /* default */],
  DateTimePicker: __WEBPACK_IMPORTED_MODULE_15__DateTimePicker__["a" /* default */],
  BasicLineGauge: __WEBPACK_IMPORTED_MODULE_16__BasicLineGauge__["a" /* default */],
  FinishedBadge: __WEBPACK_IMPORTED_MODULE_17__FinishedBadge__["a" /* default */],
  EditorToolbar: __WEBPACK_IMPORTED_MODULE_20__EditorToolbar__["a" /* default */],
  ImageCarousel: __WEBPACK_IMPORTED_MODULE_21__ImageCarousel__["a" /* default */],
  FooterContent: __WEBPACK_IMPORTED_MODULE_22__FooterContent__["a" /* default */],
  LoadingBounce: __WEBPACK_IMPORTED_MODULE_18__LoadingBounce__["a" /* default */],
  DummyPageItem: __WEBPACK_IMPORTED_MODULE_19__DummyPageItem__["a" /* default */],
  ToggleSwitch: __WEBPACK_IMPORTED_MODULE_24__ToggleSwitch__["a" /* default */],
  IconDropdown: __WEBPACK_IMPORTED_MODULE_23__IconDropdown__["a" /* default */],
  CardPreview: __WEBPACK_IMPORTED_MODULE_25__CardPreview__["a" /* default */],
  SearchInput: __WEBPACK_IMPORTED_MODULE_26__SearchInput__["a" /* default */],
  TopicDropup: __WEBPACK_IMPORTED_MODULE_27__TopicDropup__["a" /* default */],
  PolicyModal: __WEBPACK_IMPORTED_MODULE_28__PolicyModal__["a" /* default */],
  CustomModal: __WEBPACK_IMPORTED_MODULE_29__CustomModal__["a" /* default */],
  UpDownArrow: __WEBPACK_IMPORTED_MODULE_30__UpDownArrow__["a" /* default */],
  MainLayout: __WEBPACK_IMPORTED_MODULE_31__MainLayout__["a" /* default */],
  BasicModal: __WEBPACK_IMPORTED_MODULE_32__BasicModal__["a" /* default */],
  BaseEditor: __WEBPACK_IMPORTED_MODULE_33__BaseEditor__["a" /* default */],
  AppHeader: __WEBPACK_IMPORTED_MODULE_34__AppHeader__["a" /* default */],
  AppFooter: __WEBPACK_IMPORTED_MODULE_35__AppFooter__["a" /* default */],
  TableCard: __WEBPACK_IMPORTED_MODULE_36__TableCard__["a" /* default */],
  DummyCard: __WEBPACK_IMPORTED_MODULE_37__DummyCard__["a" /* default */],
  PageItem: __WEBPACK_IMPORTED_MODULE_38__PageItem__["a" /* default */],
  Checkbox: __WEBPACK_IMPORTED_MODULE_39__Checkbox__["a" /* default */],
  Snackbar: __WEBPACK_IMPORTED_MODULE_40__Snackbar__["a" /* default */],
  LcAudio: __WEBPACK_IMPORTED_MODULE_41__LcAudio__["a" /* default */],
  LcImage: __WEBPACK_IMPORTED_MODULE_42__LcImage__["a" /* default */],
  LcVideo: __WEBPACK_IMPORTED_MODULE_43__LcVideo__["a" /* default */],
  Tooltip: __WEBPACK_IMPORTED_MODULE_44__Tooltip__["a" /* default */],
  AppMain: __WEBPACK_IMPORTED_MODULE_45__AppMain__["a" /* default */],
  Radio: __WEBPACK_IMPORTED_MODULE_46__Radio__["a" /* default */],
  Card: __WEBPACK_IMPORTED_MODULE_47__Card__["a" /* default */],
  ProgressBar: __WEBPACK_IMPORTED_MODULE_48__ProgressBar__["a" /* default */],
  LineGauge: __WEBPACK_IMPORTED_MODULE_49__LineGauge__["a" /* default */]
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (name) {
    Vue.component(name, components[name]);
  });
}

/***/ }),

/***/ "bmII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SeriesListItem__ = __webpack_require__("58zr");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-to-series-modal',

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a,
    SeriesListItem: __WEBPACK_IMPORTED_MODULE_4__SeriesListItem__["a" /* default */]
  },

  props: {
    seriesList: {
      type: Array,
      default: []
    },
    publisherId: {
      type: Number,
      default: null
    },
    cardIdForAddToSeries: {
      type: Number,
      default: null
    }
  },

  data: function data() {
    return {
      loading: false,
      busy: false,
      selectedSeriesId: null,
      selectedChapterId: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['chapters', 'series']), {
    saveDisabled: function saveDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.selectedSeriesId) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.selectedChapterId);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchPublisherSeries', 'addCardToSeries']), {
    selectSeries: function selectSeries(seriesId) {
      this.selectedSeriesId = seriesId;
      this.selectedChapterId = null;
    },
    selectChapter: function selectChapter(chapterId) {
      this.selectedChapterId = chapterId;
    },
    onInfinite: function onInfinite() {
      var _this = this;

      var offset = parseInt(this.seriesList.length / 20, 10) * 20;
      var limit = 20;
      var params = {
        publisher_id: this.publisherId,
        offset: offset,
        limit: limit
      };

      return this.fetchPublisherSeries(params).then(function (seriesList) {
        if (_this.$refs.infiniteLoading) {
          _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

          if (seriesList.length < limit) {
            _this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      });
    },
    save: function save() {
      var _this2 = this;

      if (!this.busy && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.cardIdForAddToSeries)) {
        this.busy = true;

        var selectedChapter = this.chapters[this.selectedChapterId];
        var selectedSeries = this.series[this.selectedSeriesId];
        var params = {
          card_id: this.cardIdForAddToSeries,
          series_id: this.selectedSeriesId,
          chapter_id: this.selectedChapterId
        };

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(selectedSeries)) {
          params.subject_id = selectedSeries.subject_id;
          params.grade_id = selectedSeries.grade_id;
        }

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(selectedChapter)) {
          params.chapter_name = selectedChapter.name;
          params.chapter_position = selectedChapter.position;
          params.core_concept_id = selectedChapter.core_concept_id;
          params.unit_id = selectedChapter.unit_id;
        }

        this.addCardToSeries(params).then(function () {
          return _this2.$emit('ok');
        });
      }
    }
  })

});

/***/ }),

/***/ "box3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("k/oC");






function subscribe(store) {
  store.subscribe(function (mutation, _ref) {
    var Tutorials = _ref.Tutorials,
        Auth = _ref.Auth;

    switch (mutation.type) {
      case __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CHECKED_TUTORIALS:
        {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(Auth.user)) {
            var cookieKey = __WEBPACK_IMPORTED_MODULE_2__config__["p" /* USER_TUTORIAL_KEY */] + '/' + Auth.user.id;
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(cookieKey, Tutorials.checkedTutorials, { expires: 999 });
          }

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].CHECK_TUTORIAL:
        {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(Auth.user)) {
            var _cookieKey = __WEBPACK_IMPORTED_MODULE_2__config__["p" /* USER_TUTORIAL_KEY */] + '/' + Auth.user.id;
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(_cookieKey, Tutorials.checkedTutorials, { expires: 999 });
          }

          break;
        }

      default:
        {
          break;
        }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  subscribe(store);
});

/***/ }),

/***/ "c09o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPreview_vue__ = __webpack_require__("/Fal");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d558bed0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPreview_vue__ = __webpack_require__("pgxr");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("LSV2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d558bed0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/CardPreview.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d558bed0", Component.options)
  } else {
    hotAPI.reload("data-v-d558bed0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c6D2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: "config-criteria-modal",
        title: _vm.$t("evaluations.modal.config_criteria.title"),
        "ok-title": _vm.$t("evaluations.modal.config_criteria.ok_title"),
        "close-title": _vm.$t("common.cancel")
      },
      on: {
        ok: function($event) {
          return _vm.saveCriteria()
        },
        cancel: function($event) {
          return _vm.$emit("cancel")
        }
      }
    },
    [
      _c("div", { staticClass: "class-subject-container" }, [
        _c(
          "div",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-bold pr-8"
          },
          [_vm._v("\n      " + _vm._s(_vm.selectedClassName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-bold pl-8"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.subjectMap[_vm.selectedSubjectId]) +
                "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "evluation-criteria-container mt-27 pt-20 pb-20" },
            [_c("LoadingBounce")],
            1
          )
        : _c("div", { staticClass: "evluation-criteria-container" }, [
            _c("div", { staticClass: "score-description-box" }, [
              _c("div", { staticClass: "score-description" }, [
                _c("div", { staticClass: "score-mark high-score-mark" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "evaluations.modal.config_criteria.body.high_score_mark"
                        )
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "score-description-text",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "evaluations.modal.config_criteria.body.high_score",
                        { score: _vm.criteriaValue }
                      )
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "score-description" }, [
                _c("div", { staticClass: "score-mark middle-score-mark" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "evaluations.modal.config_criteria.body.middle_score_mark"
                        )
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "score-description-text",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "evaluations.modal.config_criteria.body.middle_score",
                        { score: _vm.criteriaValue }
                      )
                    )
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "score-control-box" },
              [
                _c("vue-slider", {
                  attrs: {
                    interval: 5,
                    tooltip: false,
                    piecewise: true,
                    height: 12,
                    "bg-style": { "background-color": "#fa8471" },
                    "process-style": { "background-color": "#00c896" },
                    "piecewise-style": {
                      "background-color": "#fff",
                      width: "1px",
                      "border-radius": "initial"
                    }
                  },
                  model: {
                    value: _vm.criteriaValue,
                    callback: function($$v) {
                      _vm.criteriaValue = $$v
                    },
                    expression: "criteriaValue"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "typography--body-3 typography--color-disabled typography--font-weight-500 float-left"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "evaluations.modal.config_criteria.body.min_value"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "typography--body-3 typography--color-disabled typography--font-weight-500 float-right"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "evaluations.modal.config_criteria.body.max_value"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary text-center score-control-help"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "evaluations.modal.config_criteria.body.control_help"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de0eb290", esExports)
  }
}

/***/ }),

/***/ "c6YG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PageEditorModal", {
        directives: [
          { name: "show", rawName: "v-show", value: true, expression: "true" }
        ],
        attrs: {
          id: "edit-page-editor-modal",
          page: _vm.page,
          "is-shown": true
        },
        on: { "page-added": _vm.onPageAdded, cancel: _vm.cancelPageEdit }
      }),
      _vm._v(" "),
      _c("MathEditorModal", {
        attrs: { id: "math-editor-modal" },
        on: { add: _vm.addMath }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e37d9e", esExports)
  }
}

/***/ }),

/***/ "c8AG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateDocxQuizzes_vue__ = __webpack_require__("3t+e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a8b936_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateDocxQuizzes_vue__ = __webpack_require__("vOfy");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("CRfm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25a8b936"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateDocxQuizzes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a8b936_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateDocxQuizzes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/views/CreateDocxQuizzes.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25a8b936", Component.options)
  } else {
    hotAPI.reload("data-v-25a8b936", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'finished-badge'
});

/***/ }),

/***/ "cKKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clickout__ = __webpack_require__("om2z");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'search-input',

  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clickout__["a" /* default */]],

  data: function data() {
    return {
      isFocused: false
    };
  },


  computed: {
    text: function text() {
      return this.modelValue || '';
    },
    textfieldClassBinding: function textfieldClassBinding() {
      return {
        'textfield-focused': this.isFocused
      };
    }
  },

  methods: {
    focusInput: function focusInput() {
      this.isFocused = true;
    },
    blurInput: function blurInput() {
      var _this = this;

      setTimeout(function () {
        _this.isFocused = false;
      }, 200);
    },
    onInput: function onInput(event) {
      this.$emit('input', event.target.value);
    },
    clearInput: function clearInput() {
      this.$emit('input', '');
      this.isFocused = false;
    },
    clickOutListener: function clickOutListener() {
      this.isFocused = false;
    }
  }
});

/***/ }),

/***/ "cQSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__("u4Bf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PublisherCardView__ = __webpack_require__("NbUQ");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chapter-view',

  components: {
    PublisherCardView: __WEBPACK_IMPORTED_MODULE_6__PublisherCardView__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a
  },

  props: {
    chapter: {
      type: Object,
      default: null
    },
    seriesItem: {
      type: Object,
      default: null
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['cardsByChapterId', 'chapterCards']), {
    createDocxQuizzesLink: function createDocxQuizzesLink() {
      return {
        name: 'publishers.series.chapters.createDocxQuizzes',
        params: {
          series_id: this.seriesItem.id,
          chapter_id: this.chapter.id
        },
        query: {
          subject_id: this.seriesItem.subject_id,
          grade_id: this.seriesItem.grade_id,
          chapter_name: this.chapter.name,
          chapter_position: this.chapter.position,
          unit_id: this.chapter.unit_id
        }
      };
    },


    chapterCardList: {
      get: function get() {
        return this.cardsByChapterId[this.chapter.id];
      },
      set: function set(value) {
        var _this = this;

        var newList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(value);

        newList.forEach(function (item, i) {
          item.position = i + 1;
        });


        this.storeComponentListClone = newList;

        var modifiedItems = newList.filter(function (item) {
          return item.position !== _this.chapterCards[item.id].position;
        });

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(modifiedItems.map(function (item) {
          return _this.updateSeriesCard({
            series_id: _this.seriesItem.id,
            card_id: item.id,
            position: item.position
          });
        }));
      }
    },

    cardCount: function cardCount() {
      if (this.cardsByChapterId[this.chapter.id]) {
        return this.cardsByChapterId[this.chapter.id].length;
      }

      return 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['updateSeriesCard']))
});

/***/ }),

/***/ "cUxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getQuizTags: function getQuizTags(quiz) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(quiz.tags)) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["split"])(quiz.tags, ','), function (item) {
        return '#' + item;
      });
    },
    isNoOptionsQuiz: function isNoOptionsQuiz(options) {
      var OX_QUIZ_OPTIONS_LENGTH = 2;
      return options.length === OX_QUIZ_OPTIONS_LENGTH;
    },
    getQuizState: function getQuizState(value) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(value)) {
        return {
          label: '검토중',
          value: 'under_review'
        };
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(value.start_at) && !value.is_active) {
        return {
          label: '검토 완료',
          value: 'review_completed'
        };
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(value.start_at) && value.is_active) {
        return {
          label: '출제중',
          value: 'active'
        };
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(value.start_at) && !value.is_active) {
        return {
          label: '종료',
          value: 'end'
        };
      }

      return {
        label: '-',
        value: ''
      };
    }
  }
});

/***/ }),

/***/ "cmNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCards_vue__ = __webpack_require__("S4VY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b7d1d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCards_vue__ = __webpack_require__("USCQ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b7d1d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/views/MyCards.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35b7d1d0", Component.options)
  } else {
    hotAPI.reload("data-v-35b7d1d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d67z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAddBlock_vue__ = __webpack_require__("hOXB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a24f08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageAddBlock_vue__ = __webpack_require__("pZbv");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ZL3V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAddBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a24f08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageAddBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/PageAddBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a24f08e", Component.options)
  } else {
    hotAPI.reload("data-v-2a24f08e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d9C3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setToken"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["setDevice"] = setDevice;
/* harmony export (immutable) */ __webpack_exports__["setSkipLanding"] = setSkipLanding;
/* harmony export (immutable) */ __webpack_exports__["fetchUser"] = fetchUser;
/* harmony export (immutable) */ __webpack_exports__["signIn"] = signIn;
/* harmony export (immutable) */ __webpack_exports__["updateUser"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["setUserInStore"] = setUserInStore;
/* harmony export (immutable) */ __webpack_exports__["setUserPropertyInStore"] = setUserPropertyInStore;
/* harmony export (immutable) */ __webpack_exports__["signOut"] = signOut;
/* harmony export (immutable) */ __webpack_exports__["checkUserToken"] = checkUserToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("K49E");








function setToken(_ref, token) {
  var commit = _ref.commit,
      state = _ref.state;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_TOKEN, token);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(token);
}

function setDevice(_ref2, device) {
  var commit = _ref2.commit,
      state = _ref2.state;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_DEVICE, device);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(device);
}

function setSkipLanding(_, skipLanding) {
  __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('skip_landing_page_v2', skipLanding, { expires: 999 });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(skipLanding);
}

function fetchUser(_ref3) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/users/me').then(function (res) {
    return dispatch('setUserInStore', res.data);
  }).catch(function (err) {
    if (err.response && err.response.status === 404) {
      console.error('user not found in DB!');
      return dispatch('signIn');
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  }).then(function () {
    return dispatch('syncClasses');
  }).catch(function (err) {
    dispatch('setToken', '');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function signIn(_ref4) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/users/sign-in', {}).then(function (res) {
    return dispatch('setUserInStore', res.data);
  }).then(function () {
    return dispatch('checkUserTutorial');
  }).then(function () {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch('fetchSubjectList'), dispatch('fetchGradeList'), dispatch('syncClasses'), dispatch('fetchAdvertisement')]);
  }).catch(function (err) {
    dispatch('setToken', '');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateUser(_ref5, updateInfo) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_4__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* MINERVA_API_URL */] + '/users/me', updateInfo).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setUserInStore(_ref6, userInfo) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_USER, userInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(userInfo);
}

function setUserPropertyInStore(_ref7, setInfo) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SET_PROPERTY, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function signOut(_ref8) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* default */].SIGN_OUT);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function checkUserToken(_ref9) {
  var state = _ref9.state;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(state.token)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.token);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('NO_TOKEN');
}

/***/ }),

/***/ "dI30":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dIKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vee_validate__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card-title-input',

  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },

  validator: null,

  data: function data() {
    return {
      errors: null
    };
  },


  computed: {
    text: function text() {
      return this.modelValue || '';
    },
    inputValidationBindings: function inputValidationBindings() {
      return {
        'mdc-textfield--invalid': this.errors.any()
      };
    }
  },

  watch: {
    text: function text(value) {
      this.validator.validate('text', value);
      this.$emit('has-error', this.errors.any());
    }
  },

  methods: {
    onInput: function onInput(event) {
      this.$emit('input', event.target.value);
    }
  },

  created: function created() {
    this.validator = new __WEBPACK_IMPORTED_MODULE_0_vee_validate__["Validator"]({
      text: {
        required: true,
        max: 50
      }
    });

    this.$set(this, 'errors', this.validator.errorBag);
  }
});

/***/ }),

/***/ "dgSd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMyCard_vue__ = __webpack_require__("9ok5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee0f9ad6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewMyCard_vue__ = __webpack_require__("m0Mz");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMyCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee0f9ad6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewMyCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/views/NewMyCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ee0f9ad6", Component.options)
  } else {
    hotAPI.reload("data-v-ee0f9ad6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dkNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-video-lecture" }, [
    _c("div", { staticClass: "upload-video-lecture__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "upload-video-lecture__header-title typography--color-primary text-center"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("video_lectures.upload_video.header_title")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "upload-video-lecture__form" }, [
            _c(
              "div",
              {
                staticClass:
                  "upload-video-lecture__upload-area mx-auto text-center"
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "upload-video-lecture__upload-input text-center clickable w-100"
                  },
                  [
                    _c("input", {
                      staticClass: "no-display",
                      attrs: {
                        type: "file",
                        accept: "video/mp4,video/x-m4v,video/*",
                        disabled: _vm.busy
                      },
                      on: { change: _vm.onVideoInputChange }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "upload-video-lecture__upload-text typography--headline typography--color-secondary"
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("video_lectures.upload_video.upload_text")
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.busy
                  ? _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.uploading")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "upload-video-lecture__modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "video-type-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.video_type_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b173b9d4", esExports)
  }
}

/***/ }),

/***/ "dmSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["sendNotification"] = sendNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__("7K8a");



function sendNotification(_ref, params) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_0__config__["f" /* MINERVA_API_URL */] + '/notifications', params).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while sending notification:', err);
    return err;
  });
}

/***/ }),

/***/ "dpag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Mnw2");


var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_IS_CLASS_STUDENT, function (state, isClassStudent) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'isClassStudent', isClassStudent);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_SELECTED, function (state, classId) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'selectedClassId', classId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CLASSES, function (state, classList) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'managingClasses', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keyBy"])(classList, 'id'));
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "dwjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCardShareSetupModal_vue__ = __webpack_require__("4b9y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d3d8910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCardShareSetupModal_vue__ = __webpack_require__("Xc7h");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCardShareSetupModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d3d8910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCardShareSetupModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/MyCardShareSetupModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d3d8910", Component.options)
  } else {
    hotAPI.reload("data-v-2d3d8910", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e1ZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageSummary__ = __webpack_require__("Fd6A");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card-details',

  components: {
    PageSummary: __WEBPACK_IMPORTED_MODULE_5__components_PageSummary__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  data: function data() {
    return {
      pagesReady: false,
      card: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['publisherCards', 'customCards', 'subjectMap', 'gradeMap']), {
    isPublisherCard: function isPublisherCard() {
      return this.$route.params.card_type === 'publisher-cards';
    },
    cardTitle: function cardTitle() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.card)) {
        return this.card.title;
      }

      return '제목';
    },
    cardAuthorName: function cardAuthorName() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.card)) {
        return this.card.author_name;
      }

      return '';
    },
    styleBindings: function styleBindings() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.card)) {
        return {
          'background-image': 'url(\'' + this.card.cover_image + '\')'
        };
      }

      return {};
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'fetchPublisherCardPages', 'setSelectedPreviewCard', 'fetchCustomCardDetails', 'fetchCustomCardPages']), {
    getLearningElements: function getLearningElements(coreConcept) {
      if (!coreConcept) {
        return null;
      }

      return coreConcept.description;
    },
    openCardPreview: function openCardPreview() {
      var _this = this;

      this.setSelectedPreviewPageIndex(0).then(function () {
        _this.$root.$emit('show::modal', 'card-preview-modal');
      });
    }
  }),

  created: function created() {
    var _this2 = this;

    var cardId = this.$route.params.card_id;
    if (this.isPublisherCard) {
      this.card = this.publisherCards[cardId] || {};

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.card)) {
        this.fetchCustomCardDetails(cardId).then(function (card) {
          if (card.share_level !== 1) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('is_private_card');
          }

          _this2.card = card;
          return _this2.fetchPublisherCardPages(card.id);
        }).then(function (pages) {
          _this2.card.pages = pages;

          return _this2.setSelectedPreviewCard(_this2.card);
        }).then(function () {
          _this2.pagesReady = true;
        }).catch(function (err) {
          if (err === 'is_private_card') {
            return _this2.$router.replace('/library');
          }

          _this2.$root.$emit('show::modal', 'basic-error-alert');

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      } else if (!this.card.pages) {
        this.fetchPublisherCardPages(this.card.id).then(function () {
          return _this2.setSelectedPreviewCard(_this2.card);
        }).then(function () {
          _this2.pagesReady = true;
        }).catch(function (err) {
          _this2.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      } else {
        this.setSelectedPreviewCard(this.card).then(function () {
          _this2.pagesReady = true;
        });
      }
    } else {
      this.card = this.customCards[cardId] || {};

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.card)) {
        this.fetchCustomCardDetails(cardId).then(function (card) {
          if (card.share_level !== 1) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('is_private_card');
          }

          _this2.card = card;

          return _this2.fetchCustomCardPages(card.id);
        }).then(function (pages) {
          _this2.card.pages = pages;

          return _this2.setSelectedPreviewCard(_this2.card);
        }).then(function () {
          _this2.pagesReady = true;
        }).catch(function (err) {
          if (err === 'is_private_card') {
            return _this2.$router.replace('/library');
          }

          _this2.$root.$emit('show::modal', 'basic-error-alert');

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      } else if (!this.card.pages) {
        this.fetchCustomCardPages(this.card.id).then(function () {
          return _this2.setSelectedPreviewCard(_this2.card);
        }).then(function () {
          _this2.pagesReady = true;
        }).catch(function (err) {
          _this2.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      } else {
        this.setSelectedPreviewCard(this.card).then(function () {
          _this2.pagesReady = true;
        });
      }
    }
  }
});

/***/ }),

/***/ "eBP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.series
    ? _c("Card", { staticClass: "series-item clickable" }, [
        _c(
          "div",
          { staticClass: "card-header series-item__header typography--body-2" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.getGradeLabel(_vm.series)) +
                " " +
                _vm._s(_vm.getSubjectLabel(_vm.series)) +
                "\n  "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-block" }, [
          _c(
            "div",
            {
              staticClass: "card-title series-item__title typography--body-1",
              attrs: { title: _vm.series.name }
            },
            [_vm._v("\n      " + _vm._s(_vm.series.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [
            _c(
              "small",
              {
                staticClass:
                  "text-muted typography--caption typography--color-secondary"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("publishers.series.chapter_count", {
                        cnt: _vm.series.chapters_count
                      })
                    ) +
                    "\n      "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "series-item__cover-img-thumb",
          style: _vm.coverImageStyle
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a6383d2", esExports)
  }
}

/***/ }),

/***/ "eEBw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_CARD_PAGES = 'customCards/SET_CARD_PAGES';
var SET_SELECTED = 'customCards/SET_SELECTED';
var SET_CARDS = 'customCards/SET_CARDS';
var ADD_CARDS = 'customCards/ADD_CARDS';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CARD_PAGES: SET_CARD_PAGES,
  SET_SELECTED: SET_SELECTED,
  SET_CARDS: SET_CARDS,
  ADD_CARDS: ADD_CARDS
});

/***/ }),

/***/ "eYCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: _vm.id,
        title: _vm.title,
        "close-title": _vm.closeTitle || _vm.$t("common.cancel"),
        "ok-title": _vm.okTitle || _vm.$t("common.confirm")
      },
      on: { ok: _vm.ok, cancel: _vm.cancel }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8ffd462", esExports)
  }
}

/***/ }),

/***/ "ecS0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eiba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("L2mm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("mi6L");
/* unused harmony reexport router */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "etAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "series-list-item" },
    [
      _c(
        "div",
        {
          staticClass: "series-list-item__series-info clickable",
          class: { "series-list-item__series-info--active": _vm.isActive },
          on: {
            click: function($event) {
              return _vm.selectSeries()
            }
          }
        },
        [
          _c("div", {
            staticClass: "series-list-item__series-cover-img-thumb float-left",
            style: _vm.coverImageStyle
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "series-list-item__series-description float-left" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "series-list-item__series-title typography--body-2 typography--font-weight-500"
                },
                [_vm._v("\n        " + _vm._s(_vm.seriesTitle) + "\n      ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isActive
          ? _c("div", { staticClass: "series-list-item__chapter-list" }, [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "text-center mt-16 mb-8" },
                    [
                      _c("LoadingBounce"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "typography--body-2 typography--color-disabled"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("common.loading")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "pl-8 pr-8" },
                    _vm._l(_vm.chapters, function(chapter) {
                      return _c("ChapterListItem", {
                        key: chapter.id,
                        attrs: {
                          chapter: chapter,
                          "is-active": _vm.selectedChapterId === chapter.id
                        },
                        on: { "select-chapter": _vm.selectChapter }
                      })
                    }),
                    1
                  )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-046a21e0", esExports)
  }
}

/***/ }),

/***/ "evzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("0qmm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("NowG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "ewOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f9ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-card',

  data: function data() {
    return {
      selectedCardId: null
    };
  },


  props: ['card', 'onShareLevelSetupClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap']), {
    styleBindings: function styleBindings() {
      if (this.card && this.card.cover_image) {
        return {
          'background-image': 'url(\'' + this.card.cover_image + '\')'
        };
      }

      return {};
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'makeMyCardPrivateInStore', 'makeMyCardPublicInStore', 'setSelectedPreviewCard', 'fetchMyCardPages', 'updateMyCard']), {
    setPreviewCard: function setPreviewCard() {
      var _this = this;

      return this.setSelectedPreviewCard(this.card).then(function () {
        return _this.setSelectedPreviewPageIndex(0);
      }).then(function () {
        _this.$root.$emit('show::modal', 'card-preview-modal');
      });
    },
    openCardPreview: function openCardPreview() {
      var _this2 = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.card.pages)) {
        return this.setPreviewCard();
      }

      return this.fetchMyCardPages({ cardId: this.card.id }).then(function () {
        return _this2.setPreviewCard();
      }).catch(function (err) {
        _this2.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    goToMyCardDetails: function goToMyCardDetails() {
      this.$router.push('/my-cards/' + this.card.id);
    },
    updateShareLevel: function updateShareLevel() {
      var _this3 = this;

      var newShareLevel = this.card.share_level === 1 ? 2 : 1;
      var updateInfo = { share_level: newShareLevel };

      if (newShareLevel === 2) {
        return this.$emit('open-make-card-private-modal', this.card.id);
      }

      return this.updateMyCard({ cardId: this.card.id, updateInfo: updateInfo }).then(function () {
        return _this3.makeMyCardPublicInStore(_this3.card.id);
      }).catch(function (err) {
        _this3.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    handleCardOver: function handleCardOver(cardId) {
      this.selectedCardId = cardId;
    },
    handleCardLeave: function handleCardLeave() {
      this.selectedCardId = null;
    }
  })
});

/***/ }),

/***/ "fKHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g7Jj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTimePicker_vue__ = __webpack_require__("z+b6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f503b48e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__ = __webpack_require__("2Q4z");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("6ZH2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTimePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f503b48e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTimePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DateTimePicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f503b48e", Component.options)
  } else {
    hotAPI.reload("data-v-f503b48e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gLov":
/***/ (function(module, exports) {

module.exports = {"Play":"پخش","Pause":"وقفه","Current Time":"زمان کنونی","Duration Time":"مدت زمان","Remaining Time":"زمان باقیمانده","Stream Type":"نوع استریم","LIVE":"زنده","Loaded":"فراخوانی شده","Progress":"پیشرفت","Fullscreen":"تمام صفحه","Non-Fullscreen":"نمایش عادی","Mute":"بی صدا","Unmute":"بهمراه صدا","Playback Rate":"سرعت پخش","Subtitles":"زیرنویس","subtitles off":"بدون زیرنویس","Captions":"عنوان","captions off":"بدون عنوان","Chapters":"فصل","You aborted the media playback":"شما پخش را متوقف کردید.","A network error caused the media download to fail part-way.":"مشکل در دریافت ویدئو ...","The media could not be loaded, either because the server or network failed or because the format is not supported.":"فرمت پشتیبانی نمیشود یا خطایی روی داده است.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"مشکل در دریافت ویدئو ...","No compatible source was found for this media.":"هیچ ورودی ای برای این رسانه شناسایی نشد."}

/***/ }),

/***/ "gS7P":
/***/ (function(module, exports) {

module.exports = {"brand":{"name":"Learning+"},"header":{"nav_menu":{"reports":"學習成果","my_cards":"我的學習卡","library":"我的學習庫","evaluations":"綜合建議","publishers":"出版社","video_lectures":"影音教學"}},"common":{"preview":"預覽","loading":"載入中","assign":"作業導出","cancel":"取消","save":"儲存","close":"關閉","add":"添加","previous":"上一個","next":"下一個","confirm":"確定","show_description":"查看評論","browse_filters":{"in_progress":"進行作業","past_assignments":"完成作業","search_placeholder":"輸入關鍵字","all_subjects":"全部科目","all_grades":"全部年級","all_chapters":"全部單元","media_type":{"all":"全部","image":"圖片","audio":"聲音檔","video":"影片"},"order_by":{"popularity":"依人氣","title":"依題目","recency":"依最新"},"all_core_concepts":"全部核心概念"},"modal":{"remove":{"title":"刪除","message":"確定刪除嗎?"},"assign":{"title":"發布作業","message":"發布作業前必須先儲存。<br>您是否要儲存當前內容？"},"status":{"title":"檢視作業狀態","assign_more":"添加作業","assigned_classes":"班級作業","assigned_period":"學習期間","is_active":"進行中","is_inactive":"截止"},"make_public":{"title":"公開學習庫","message":"儲存學習教材後可發布作業。<br>您是否要保存變更？"},"close_assignment":{"title":"完成作業","message":"此作業的截止日期{date}。<br>您確定要立即退出所選的作業嗎？"},"file_size_alert":{"message":"圖像文件上傳失敗。圖像上傳上限10MB。"},"file_type_alert":{"message":"圖像文件上傳失敗。圖像文件只能上傳JPG,JPEG,PNG等。"},"preview":{"show_solution":"查看評論","class_average_score":"班級平均正確答題率","count":"名","is_incorrect":"答案錯誤","is_correct":"正確答案","no_pages":"無可顯示頁面","correct_answer":"正確答案","answer_number":"{n}分","chosen_answer":"選擇題答案","entered_answer":"輸入答案","score_input":"輸入分數","grading_keywords":"核心關鍵字","no_grading_keywords":"未設定核心關鍵字","no_submitted_answer":"無可繳交的答題","feedback_input":"填入評論","feedback_placeholder":"請填入評論","use_default_description":"填入簡單評論","submitted_answer":"填答","score":"分數","report_content":"錯誤申告","edit_assignment":"作業編輯"},"no_class_to_assign_alert":{"message":"您非班級管理者，請建立班級並為班級管理者後再試一次"},"welcome_msg":{"title":"有效率地準備課程與學習活動,<br>現在您可於Classting Learning進行!","body_1":"您可找尋課程教材或建立新課程","body_2":"可將作業發布於班級並收集學習成果","body_3":"學生可比較和分析學習成就","start":"開始"},"empty_card_info":{"message":"所有訊息輸入後可發布作業"},"assignments_init":{"title":"學習結果初始化","desc":"目前正確答案率、學習時間和其他學習結果將被初始化。你確定再學習一次嗎？"},"assignments_end":{"title":"作業結束","desc":"{date} 作業截止"},"make_private":{"title":"取消發布","message":"您確定取消發布作業嗎?"},"page_leave_alert":{"message":"即將離開本頁面，您確定不儲存嗎?"},"change_due_date":{"title":"編輯日期"},"assignments_only_students":{"title":"問題解決方法","desc":"答案將不顯示於結果中"},"math_editor":{"title":"輸入公式","tabs":{"basic":"基本方程式","geometry":"圖形方程","etc":"其他"}},"basic_error_alert":{"message":"操作失敗，出現未知錯誤。如問題仍存在，請聯繫Classting客服中心support@classting.com"},"card_not_purchased_alert":{"message":"尚未購買, 請先購買"},"asmt_events":{"title":"建立作業並獲得優惠劵<br>完成參與活動任務","message":"可透過活動優惠券來兌換學習庫的內容給班級學生學習<br>\n是否前往兌換頁面？","ok_title":"前往分享優惠卷"},"ask_skip_landing":{"message":"前往<strong>Classting Learning</strong>","checkbox_label":"不再顯示此頁面"},"add_video":{"title":"請輸入影片連結","input_placeholder":"請輸入影片連結","message":"侵犯版權或誹謗的影片可能受到Classting條款和相關法律的制裁。"},"confirm_assign":{"message":"作業正在進行時無法編輯<br>確定要導出作業嗎?"},"remove_assignment":{"title":"刪除作業","message":"已刪除的作業將不會恢復。<br>確定要刪除此作業嗎？"},"content_report_success":{"message":"錯誤申告已收到"},"report_content":{"title":"錯誤申告","options":{"has_error":"任務作業中有錯誤的內容","inappropriate":"任務作業中有不適當的內容"}},"video_type_alert":{"message":"影片上傳失敗。僅能上傳MP4, MOV, WMV, AVI，FLV, WebM等文件"},"docx_type_alert":{"message":"文件上傳失敗。僅能上傳DOCX文件"},"file_reader_unsupported":{"message":"不支援上傳<br/>請嘗試其他瀏覽器"},"audio_size_alert":{"message":"聲音檔無法上傳。聲音檔容量上限20MB。"},"audio_type_alert":{"message":"聲音檔無法上傳。聲音檔僅能上傳MP3, WAV, OGG, FLAC檔案。"},"confirm_report_content":{"title":"","desc":""}},"card":{"menu":{"duplicate":"複製","remove":"刪除","status":"檢視作業狀態","make_public":"學習教材公開","make_private":"學習教材公開中"},"page":{"edit":"編輯內容","remove":"刪除","description":"描述"},"non_quiz":"本文","quiz":"測驗","count":"{cnt}個","share_count":"分享 {cnt}回","updated_at":"最新更新日","share_level":{"public":"公開","private":"非公開"}},"assignment":{"due_date":{"date":"截止日期","time":"截止時間","active":"截止","inactive":"完成"}},"empty":"無","in_progress":"進行中","tooltip":{"try_new_my_card":"建立新作業","try_add_new_pages":"添加所需的文字/題目","try_select_and_add_pages":"選擇文字/題目，並添加為新作業","try_assign":"作業準備已完成","try_set_due_date":"請輸入作業說明並設定截止日期","try_check_class":"課堂直接確認","try_custom_card":"嘗試使用自製教材"},"change":"變更","complete":"完成","page_types":{"multiple_choice":"複選題","text_entry":"簡答題","non_quiz":"內容","essay_type":"問答題"},"learning_elements":"學習元素","numeric_score":"{n}分","optional":"\n(選擇性)","complete_grading":"完成評分","rank":"排名","view_more":"查看更多","view_less":"查看減少","month":"月","day":"日","time":"時間","wrong_answer":"答題錯誤","not_graded":"未評分","minute":"分","numeric_score_suffix":"分數","class":"班級","student":"學生","count_suffix":"個","edit":"編輯","terms":{"like":"點燈","view_count":"查看","no_description":"無說明","posted_date":"發布時間"},"uploading":"上傳中","video_lectures":{"share_level":{"private":"非公開","public":"公開"}},"save_edit":"完成編輯","reading_file":"閱讀檔案中","selects":{"all_subjects":"所有科目","all_grades":"所有年級","placeholder":"選擇","others":"其他"},"empty_country_code":{"text":"您可以在瀏覽器的Classting 網頁上登錄，設立你的居住國家。<br />\n在更新之後您可以使用一些新的功能。","link":"國家設定"},"view_count":"","grade_label":"{grade}年級","detail_view":""},"assignments":{"sub_header":{"all_class":"全部班級"},"assignment":{"submitted":"完成繳交","not_submitted":"未繳交","menu":{"edit":"編輯作業內容","close":"作業終止","remove":"刪除作業","preview":"作業預覽"},"completed":"完成進度"},"no_assignments":"無作業發布。<br>您可以搜尋或建立學習教材。"},"new_assignment":{"sub_header":{"title":"班級作業","write":"輸入"},"privacy":"公開設定","role":{"teacher":"老師","student":"學生","parent":"家長"},"select_topic":"選擇主題","class_picker":"","write":""},"my_cards":{"sub_header":{"new_my_card":"建立新教材"},"no_cards":"目前尚無作業；建立新作業並發佈在班級中。"},"card_details":{"card_meta":{"title_placeholder":"請輸入題目","subject_placeholder":"請選擇科目","grade_placeholder":"請選擇年級","chapter_placeholder":"請選擇單元","elements_placeholder":"請選擇核心概念","elements_select_placeholder":"準備中","subject":"科目","grade":"年級","chapter":"單元","elements":"核心概念","edit":"編輯","select":"選擇","title":"題目","core_concept":"核心概念","core_concepts_placeholder":"請選擇學習核心概念","learning_elements":"學習元素","goal":"學習目標","goal_placeholder":"請輸入學習目標","video_course":""},"import_page":"可以添加文字或題目","create_page":"建立頁面","search_page":"加載","error":{"title_required":"請輸入標題","title_max_len":"標題限制50字元"}},"library":{"sub_header":{"store_cards_tab":"推薦學習教材","custom_cards_tab":"教師自製教材","featured_cards_tab":"可汗學院 Khan Academy ","school_cards_tab":""},"no_cards":"無作業","no_search_cards":"無作業"},"page_library":{"selected_count":"{cnt}個選擇","no_pages":"無作業"},"edit_assignment":{"sub_header":{"title":"編輯作業內容","update":"完成"}},"reports":{"sub_header":{"assignments_tab":"作業列表","classes_tab":"班級列表","class_ai_reports_tab":""},"students_report":"學生報告","assignment_info":"學習資料","quiz_correct_ratio":"各題正確答題率","learning_result_summary":"學習成果總結","learning_result_summary_desc":"班級平均(總平均)","manage_students":"學生資料管理","class_name":"班級","assigner":"發布者","assigned_date":"發布時間","go_to_class":"前往班級","go_to_card":"前往學習教材","show_quizzes":"查看題目","answer_ratio":"正確答題率","complete_rate":"作業完成率","average_duration":"平均學習時間","assignment_result_report":"班級成果報告","go_to_class_report":"班級詳細報告","filters":{"all":"全部","submitted":"繳交完成","not_submitted":"未繳交"},"student_count":"學生 {cnt}名","table":{"number":"座號","student":"學生","name":"姓名","gender":"性別","submitted_date":"繳交日期","correct_count":"正確答題/題目","score":"成績","average_score":"平均成績","average_duration":"平均學習時間","perfect":"(滿分:100)","ratio":"百分比","class_over_all":"(班平均/總數)","class_rank":"班級排名","all_rank":"排名/總數 (百分比)","duration":"學習時間","complete_rate":"完成率","not_submitted":"未繳交","chapter_name":"單元名稱","core_concept":"核心概念","card_name":"題名","subjects":{"title":"科目","korean":"國語","math":"數學","science":"自然","social":"社會","english":"英語"},"class_avg":"班平均","all_avg":"全體平均","no_score":"無分數","learning_elements":"學習元素","need_grading":"請評分","thead":{"number":"","student_id":"","student_name":"","is_submitted":"","is_graded":"","duration":"","score":"","rank":"","non_essay_score":"","essay_score":"","submitted_at":"","not_submitted":"未繳交"}},"gender":{"1":"男","2":"女"},"assignment_count":"總作業","chapter_results":"單元診斷成果","key_concept_results":"核心概念診斷成果","personal_score":"個人成果","avg_class_score":"班平均程成果","avg_all_score":"全體平均成果","chapter_count":"共{cnt}單元","key_concept_count":"共{cnt}個","all_students":"全部學生","submission_completed":"完成繳交","not_submitted":"未繳交","class_average":"班級平均","correct_ratio":"作業正確答題率","study_time":"作業學習時間","class_students_report":"班級學生報告","student_report":"學生成果學習報告","correct_question":"正確答案問題","correct_answer":"正確答案","see_result":"查看成果","assignment_due_date":"作業繳交截止日","all_assignments":"全部作業","assignment_rank":"作業排名","rank_suffix":"排名","manage_class_students":"班級學生管理","subject_study_status":"科別學習狀況","all_study_status":"全部學習狀況","need_help_students":"需幫助的學生","all_students_report":"全部學生報告","go_to_recommend_contents":"前往推薦學習教材","no_need_help_students":"沒有學生需要幫助","students_well_following":"學生學習得很好喔!","all_students_count":"所有學生","average_score":"平均成績","submit_assignment":"繳交作業","achievement":"學習成就","achievement_trend":"學習成長率","study_status":"學習狀態","last_week_avg_time":"上周平均學習時間","active_students":"活躍使用學生","inactive_students":"非活躍使用學生","avg_score":"平均分數","no_chapter_name":"無章節名稱","sort_new_assignment":"最新作業排名","sort_achievement":"成就排名","assignment_period":"作業期間","assignment_result":"作業結果","go_to_library":"進入學習庫","no_assignment":"此班級尚無作業","no_assignment_desc":"建立作業，並在班級課堂發布作業!","sort_number":"按座號","sort_rank":"排名","assignment_count_cnt":"總計 {cnt} 作業","class_report":"班級報告","partial_answer":"部分解答","no_recommend_chapters":"無推薦章節","question_type":{"multiple_choice":"多選題","essay":"問答題"},"btns":{"ai_report":"<strong>Classting AI</strong> 報告","export":""},"select_assignments":"選擇題目","select_all_assignments":"所有題目","select_all_assignments_help":"*全選題目無法再個別挑選題目","sync_students":""},"classes":{"no_classes":"您無管理中的班級。<br>如果您想指派作業，請成為班級管理者"},"view":{"not_found":{"title":"找不到頁面","content":"網址輸入不正確或已更改<br>找不到頁面"},"payment_required":{"content":"每日一次免費學習卡已結束<br>要繼續學習，請在安裝應用程序後訂閱","title":"開始訂閱"},"oauth_callback":{"classting":{"title":"登入Classting","help":"正在登入Classting帳號..."},"naver":{"title":"登入Naver","help":"正在登入Naver帳號..."},"google":{"title":"登入Google","help":"正在登入Google帳號..."}},"terms_confirmation":{"title":"同意條款","help":"確認以下內容：<br> 同意後，開始Learning Card"}},"btn":{"redirect_to_root":"返回","launch_app":"繼續學習","sign_in":{"classting":"登入Classting","naver":"登入Naver","google":"登入Google"},"detail":"查看","sign_out":"登出","view_as_app":"查看應用程式","start_free_learning":"開始學習","study_again":"再次學習","study":"學習","see_results":"查看成果","check_quiz_results":"確認答案","back_to_classting":"回到Classting","more":"更多"},"form":{"terms_confirmation":{"label":{"all_checked":"全部同意","terms_of_use":"使用條款","privacy_policy":"隱私政策"},"btn":{"submit":"開始Learning+"}},"label":{"required":"(必填)"}},"footer":{"nav":{"about":"介紹","terms_of_use":"使用條款","privacy_policy":"隱私政策","copyright":"© Classting {year}"},"brand":"ⓒ Classting 2017","terms":"使用條款","privacy":"隱私政策","operation":"營運政策","support":"Classting Learning 使用指南"},"comp":{"card":{"goal":{"title":"學習內容:"},"info":{"summary":"{chapterPosition}. {chapterName} 學習卡","publisher_name":"教師: {name}"},"additional_info":{"label":{"quizzes_count":"測驗數","videos_count":"影片數","duration":"所需時間"}},"results":{"title":"完成學習","label":{"correct_ratio":"正確答題率","rank_ratio":"排名","duration":"所需時間","all_rank_ratio":"全體排名","class_rank_ratio":"班級排名","not_graded":"未解決的問題"},"quiz_result_chart":"正確解答狀態"},"due_date":"截止日期{date}","submission_date":"{date}繳交完成"},"learningcard_app":{"subtitle":"國內最讚的學習庫, 影片、教材高達六百多項","title":"Learning+還有更多的學習卡喔!","btn":{"launch_app":"前往應用程式學習"},"description":"已完成。於截止日期前,可再次嘗試。"},"correct_answers_graph":{"title":"配對題目","label":{"total_quizzes_count":"總共{totalQuizzesCount}個題目"}}},"seo":{"global":{"title":"開始行動學習","title_template":"%s - Classting Learning+","description":"透Classting進行行動學習","keywords":"行動學習, 學習卡, Learning Card, Classting, 課室廳, 人工智慧, 學習秘書, EBS, Disney, YBM, MBC, 英語, 華語, 中文, 翰林"}},"viewer":{"modal":{"init":{"title":"再試一次?","message":"目前的正確答案、學習時間等被初始化。確定再學習一次？"}},"quiz_item":{"text_entry_control":{"alerts":{"max_length":"請輸入30字以內"}}},"quiz":{"result":{"score_labels":{"great":"寫得好!","good":"可以寫得更好!","need_effort":"再接再厲!","not_graded":"尚未評分!"},"submission":{"label":"回答:"}},"header":{"label":""}},"confirm_submit":{"message":"已完成作業囉!<br>\n繳交後將不能再修正,請問是否要繳交作業呢?","submit_btn":"繳交","review_btn":"編輯","message_mobile":"已完成作業囉!<br>\n繳交後將不能再修正,<br>\n請問是否要繳交作業呢?","title":"破解任務完成"},"card":{"sam":{"explain":"初始診斷測驗共<strong>{quizCount}題</ strong><br>\n<strong> SAM </ strong>會根據學生的診斷結果選擇級別並調整為<strong> 10題 </ strong>。","progress":{"label":"診斷率"},"domain":{"label":"領域"},"study":{"button":"開始"}},"explain":{"growth":"與同年級相比，高{growthScore}分!","ungrowth":"與同年級相比，低{growthScore}分!"},"result":{"learning":"已完成傳送任務<br />前往確認Sam的任務診斷結果?","assignment":"已完成繳交任務作業<br />前往確認繳交的任務結果?","ai_learning":""},"my":{"score":"我的Classting分數"},"score":"{currentScore}分","domain":{"label":"領域"},"chapter":{"label":"單元"},"goal":{"label":"學習內容"},"assignment":{"result":{"label":"任務結果","action":"讀取全部"},"score":{"result":"我的分數","rate":"百分比"},"class":{"score":"班及平均分數"},"max":{"score":"100分"},"correct":{"answer":"正確答案"},"essay":{"label":"描述性","description":"讀取老師評論","score":"分/5分","comment":"老師評論","result":"讀取結果"},"learning":{"button":"前往班級任務"},"store":{"button":"學習此領域"}},"chart":{"label":"今日學習診斷報告將於隔天反饋"},"parent":{"child":{"report":"查看Sam學習診斷結果","uncompleted":"孩子正在進行學習診斷<br>完成後可確認結果","unsupport":"<strong>家長</strong>無法作答，僅能讀取學習診斷報告"}},"user":{"unsupport":"答題學習者非學生,將不納入結果評斷"}},"page":{"header":{"label":"題數 {quizCount}"},"quiz":{"result":{"correct":"正確答題","wrong":"答題錯誤"},"text":{"save":"儲存"},"desc":{"label":"評論"},"completed":"尚有其他學習課程\n繼續前一項學習\n","position":"學習日期 {date}"},"modal":{"quiz":{"text":{"save":"內容已儲存"}}},"next":{"button":"後一個"},"prev":{"button":"前一個"},"completed":{"graded":"評分完成"},"submit":{"button":"完成對答案"},"result":{"button":"對答案"},"submit-assignments":{"button":"任務完成"},"assignments":{"button":"開始任務"},"loading":{"text":"題目尋找中"}},"learning":"學習","result":{"score":"我的分數","answers":{"count":"正確答案","percent":"正確答題率"},"wrong":{"answers":{"explain":"再確認一次錯誤答題?","action":"查看錯誤答題"}},"action":{"learning":"提高實力"},"growth":{"learning":"更多題目"},"back":{"learning":"前往Sam的任務"},"my":{"score":"我的分數"},"learning":"診斷結果","more":{"learning":"不足的學習要素"},"parent":{"child":{"report":"是否讀取孩子的Sam學習診斷報告？"}},"close":{"learning":""}},"content":{"header":{"label":"文字 {count}"}},"sam":{"quiz":{"prev":{"button":"前一題"},"next":{"button":"下一題"}}},"cat":{"page":{"error":""}}},"errors":{"not_found_msg":"無內容","unauthorized_msg":"Classting Learning目前僅提供老師使用","back_to_classting":"返回Classting","unassigned_msg":"無可閱讀頁面<br>請再次確認課堂作業。","empty_school_info":""},"page_editor":{"question":{"title":"題目","placeholder":"請輸入題目"},"choices":{"title":"查看","hint":"請輸入後選擇正確答案","is_correct":"正確答案","add_new":{"placeholder":"+ 添加"},"alerts":{"max_length":"上限500字","view_type_hint":"請輸入30字元以上"},"view_types":{"title":"選擇方式","text_button_type":"請選擇字母選項按鈕","number_button_type":"請選擇選項按鈕"},"placeholder":"請輸入"},"text_entry":{"title":"答案","hint":"*您最多可以輸入5個正確的答案。","placeholder":"請輸入正確答案","add_new":{"placeholder":"+ 添加複選答案"}},"description":{"title":"描述","placeholder":"請輸入題目描述","essay_type_hint":"* 附加說明不支援附件媒體、方程式、改變字型大小"},"header":{"multiple_choice":"複選題","text_entry":"簡答題","non_quiz":"內容","essay_type":"問答題"},"alerts":{"max_image_limit":"附加圖片一張為限","max_video_limit":"影片檔案上限一個","unsupported_video_service":"不支援影片","video_load_failed":"無法加載影片","max_audio_limit":"僅可附加一聲音檔","only_audio_or_video":"僅可附加一影片檔或聲音檔"},"non_quiz":{"title":"標題","placeholder":"請輸入內容"},"score_allotment":{"title":"設置問題點","hint":"*最多可以設置10分。","disabled_hint":"*繳交作業後無法修改。"},"grading_keywords":{"title":"輸入核心關鍵字","hint":"*如學生填答包含核心關鍵字將標示出來","long_placeholder":"完成輸入關鍵字請按Enter","short_placeholder":"輸入關鍵字"},"essay_type":{"placeholder":"請填入答案"}},"editor":{"alerts":{"max_length":"不能輸入超過{n}個字元"}},"evaluations":{"table":{"number":"座號","student_name":"姓名","comment":"綜合建議","comment_empty":"無綜合建議","comment_not_supported":"未支援班級或科目","btn":{"copied_to_clipboard":"複製到剪貼簿","refresh":"更新"}},"filters":{"order_by":{"number":"依座號","name":"依姓名"}},"sub_header":{"config_criteria":"設定分數"},"modal":{"config_criteria":{"title":"設定分數","body":{"high_score":"從<strong> {score}分</ strong>到<strong> 100分</ strong>。","middle_score":"從<strong> 0 </ strong>到<strong> {score}分</ strong>。","middle_score_mark":"中","high_score_mark":"上","min_value":"0分","max_value":"100分","control_help":"向左或向右移動以設定分數！"},"ok_title":"應用"}},"snackbar":{"copied_to_clipboard":"複製到剪貼簿","dismiss":"隱藏"},"domain_select":{"header":{"title":"選擇領域","description":"*僅顯示本領域,以選擇的領域爲標準,自動生成綜合意見"}},"no_classes":"無管理中班級。<br>如果您想使用綜合評價，需為班級導師。"},"landing_v2":{"block1":{"title":"共同成長的教育","subtitle":"Classting Learning根據數據分析技術提供給教師、學生與家長最棒的學習體驗","start_btn":"開始<strong>Classting Learning</strong>","checkbox_label":"不再顯示Classting Learning介紹畫面","manual_btn":"下載使用說明書"},"block2":{"title":"輕鬆上手活用","subtitle":"提供多面向分析、建議和綜合評價"},"block3":{"icon_desc_1":"多面向學習分析和推薦","icon_desc_2":"學習管理系統和綜合評價","icon_desc_3":"Classting共享與協作"},"block4":{"scenario1":{"title":"老師可以輕鬆建立學習作業<br>，並透過Classting發布作業給學生。","desc":"具各類題型學習庫，<br> 可結合各種教材或建立作業<br>或與其他老師共同合作<br>您可將教材作業與Classting班級連結，輕鬆發布教材與作業至您的班級。"},"scenario2":{"title":"以各種方式分析學習狀況，推薦為學習者優質內容","desc":"識別學生的優勢和劣勢，<br> 並且提供適合的優質內容<br> <br> 家長可以追蹤孩子的學習進步。"},"scenario3":{"title":"基於學習者多方面分析的綜合建議服務<br>老師可提供更好的教學。","desc":"教師可一目了然掌握班級狀況，即時反饋給需要幫助的學生 <br> 多面向學習分析提供學生個人建議。"}},"block5":{"title":"為教師、學生和家長提供直接多方面的學習環境","subtitle":"從簡單的選擇測驗到開放性問答題任務，Classting Learning提供最直接多方面的學習，並提供教師、學生和家長成果分析。"},"block6":{"icon_desc_1":"教師教學系統","icon_desc_2":"學生學習成就","icon_desc_3":"給父母的子女學習報告"},"block8":{"title":"集中最好的學習出版內容","subtitle":"Disney, YBM, EBS...超過二十多間出版商提供的多樣化教材學習內容"},"block10":{"title":"Classting夢想建立最好的學習空間","subtitle":"許多學校正在使用Classting<br>\nClassting是最受歡迎的教育暨學習交流平台, 提供下一代更好的學習環境"},"block11":{"icon_title_1":"4,000,000+","icon_desc_1":"全部使用者數","icon_title_2":"150,000+","icon_desc_2":"使用教師數","icon_title_3":"14,500+","icon_desc_3":"使用學校數"},"block12":{"title":"您想在課堂中使用Classting Learning嗎?","subtitle":"如果您有任何問題，請隨時與我們聯繫","ask_btn":"<strong>Classting Learning</strong> 意見與建議","manual_btn":"閱讀Classting Learning說明書"},"block7":{"teacher":{"slide1":{"title":"可以了解班級當前狀態","subtitle":"通過Classting Learning，老師可獲得學習狀況的報告，<br> 您可檢視學生目前學習狀況，並可以針對每位學生提出合適的學習內容。"},"slide2":{"title":"提供學生綜合分析建議","subtitle":"根據學生學習成果分析<br>\n自動綜合配對顯示適合的內容\n<br>\n亦可可根據成績自行設定點<br>\n搭配配對適合的內容"}},"student":{"slide1":{"title":"我可確認我的學習能力","subtitle":"透過Classting Learning來學習可獲得個人學習分析報告。 透過學習報告了解學習狀況<br>學習報告幫助確定學習需加強的部分，有效利用學習時間。"},"slide2":{"title":"個人適性化學習內容推薦","subtitle":"自動分析學生的學習數據結果<br> 我們根據個別狀況分析推薦不同的學習內容<br>透過分析提供高品質學習內容，幫助學生輕鬆銜接學習<br> <br> 學生也可提高自己的學習能力。"}},"parent":{"slide1":{"title":"您現在可查看孩子的學習狀況","subtitle":"您可以通過Classting的應用程式輕鬆查看您孩子的學習報告。<br><br> 包含每個科目的學習成就、學習動機、理解和成長等的詳細報告。 有助於促進您與孩子間有關學習的溝通交流。\n"},"slide2":{"title":"子女的學習活動可進行囉!","subtitle":"您可以使用Classting Learning來推薦適合您孩子學習狀況的學習卡，並使用Classting Coin支付學習卡。 <br> <br>如果您的孩子透過您支付購買的學習卡，將會呈現給您孩子的學習成果報告。"}}}},"inquiry_form":{"header":{"title":"詢問 Classting Learning","subtitle":"將學校/教育機構等活動帶入Classting Learning輔助，開始輕鬆課堂及教材內容管理。"},"form":{"school_name":"學校 / 機構名稱","school_name_placeholder":"學校 / 機構名稱","name":"姓名","name_placeholder":"姓名","position":"職稱","position_placeholder":"辦公室","email":"e-mail(單位e-mail)","email_placeholder":"abcd@classting.com","mobile":"手機","mobile_placeholder":"0912-345-678","content":"建議內容","content_placeholder":"請輸入建議","submit_btn":"建議"},"contact":{"title":"立即發送Email?","subtitle":"support@classting.com","desc":"平日 上午9:00~下午6:00"},"modal":{"inquiry_submitted_alert":"已傳送您的詢問與意見"}},"card_results":{"modal":{"card_ratings":{"title":"有沒有幫助到學習? <br> 評分一下你的作業!","rates":{"10":"1分，這樣啊...","15":"1.5分，你可以的!","20":"2分，沒關係!","25":"2.5分，再接再勵!","30":"3分，不錯~再接再勵!","35":"3.5分，不錯喔!","40":"4分，很棒喔!","45":"4.5分，你很棒喔!","50":"恭喜! 5分~最高分!","05":"0.5分，需要幫助嗎?"}}}},"mission":{"mission_complete":"任務完成","view_mission_progress":"查看任務進度"},"publishers":{"sub_header":{"series":"系列","non_series_cards":"其他卡","new_series":"建立系列"},"no_series":"目前尚無系列","modal":{"new_series":{"title":"建立系列","subject":"科目","subject_placeholder":"請選擇科目","grade":"年級","grade_placeholder":"請選擇年級","name":"題目","name_placeholder":"請輸入題目","unit":"單元","unit_placeholder":"請選擇單元數","description_placeholder":"請輸入說明","description":"說明","hashtags":"標籤"},"chapter_edit":{"name":"主題","name_placeholder":"請輸入主題","domain":"領域","domain_placeholder":"請選擇領域","core_concept":"核心概念","core_concept_placeholder":"請選擇核心概念","domain_concept":"核心概念","domain_concept_placeholder":"請選擇核心概念"},"series_edit":{"title":"編輯系列","price":"系列價格(元)","price_placeholder":"請輸入系列價格","card_price":"學習卡價格(元)","card_price_placeholder":"請輸入學習卡價格","share_level":"設定所有學習卡公開"},"remove_series":{"title":"刪除系列","message":"刪除系列並不刪除所包含之所有學習卡<br>\n您確定要刪除嗎?"},"cover_image_edit":{"message":"系列代表圖片設定後將變更並設定為系列預設圖片","title":"系列代表圖片設定"},"add_to_series":{"title":"增加系列"},"remove_from_series":{"title":"從系列中刪除此學習卡","message":"從本系列刪除此學習卡嗎?<br>\n自本系列刪除的學習卡仍可於應用程式中讀取"},"remove_publisher_card":{"title":"刪除學習卡","message":"刪除後的學習卡無法復原<br>\n您確定要刪除嗎?"},"new_video_course":{"title":"建立影音課程"},"edit_video_course":{"title":"編輯影片課程資訊"},"edit_video_lecture":{"title":"編輯影片課程資訊","share_level":"公開"},"new_video_lecture":{"title":"建立新影片課程"}},"series":{"chapter_count":"{cnt}單元"},"card":{"add_to_series":"增加至系列","remove_from_series":"從系列移除"},"headers":{"actions":{"upload_cover_image":"設定代表圖片","remove":"刪除"}},"no_cards":"無學習卡","create_docx_quizzes":{"title":"自動輸入項目","upload_text":"請選擇要上傳的*.docx文件","create":"建立","file_info":{"name":"檔案: {name}","quiz_count":"共{count}題目","multiple_choice_count":"多重選擇{count}個","text_entry_count":"簡答類型{count}個","image_count":"含圖片{count}個"}}},"series_cards":{"chapters":{"index":"{i} 單元","meta":{"card_count":"學習卡{cnt}個","domain":"領域","core_concept":"核心概念"}},"meta":{"series_price":"系列價格: {price}元","card_price":"學習卡價格: {price}元"}},"landing_v3":{"block1":{"title":"與未來教育一起成長","subtitle":"讓Classting Learning老師, 學生, 家長與未來教育一起成長","start_btn":"開始<strong>Classting Learning</strong> ","go_to_premium":"看看Learning AI","subtitle_mobile":"讓Classting Learning老師, 學生, 家長<br>\n與未來教育一起成長"},"block2":{"title":"<strong>持續調整</strong>的個人適性化學習系統"},"block3":{"title":"這樣做","features":{"01":{"title":"簡單建立作業任務","description":"多樣化題目創建編輯器輕鬆創建題庫，<br>\n超過20個出版商免費提供的學習資源<br>\n可直接發送作業給學生們"},"02":{"title":"綜合評論與班級報告","description":"教師可以一目了然了解學生的學習情況<br>\n確定需要幫助的學生並可立即提供反饋<br>\n<br>\n綜合評論可不斷反映在學生的學習成果中<br>\n提供準確、可靠並完整的反饋"},"03":{"title":"透過數據分析客製學習","description":"學生透過學習成果的數據分析了解優勢和劣勢\n再建議適合級別的學習內容<br>\n<br>\nClassting Learning透過數據分析提供個人化創新學習體驗。"}},"go_to_premium":"探索Learning AI"},"block6":{"title":"Classting是我的夢想校園","subtitle":"許多學校正在使用Classting\nClassting為提供最好教育而開發的服務，為下一代創造更好的學習環境。","stats":{"users":{"count":"4,000,000+","label":"會員人數"},"teachers":{"count":"180,000+","label":"使用班級數"},"schools":{"count":"14,500+","label":"使用學校數"}}},"block7":{"title":"想用Classting Learning來帶動教學嗎?","subtitle":"如果您有任何疑問，請聯繫客戶服務中心。","start_btn":"開始<strong>Classting Learning</strong> ","inquiry_btn":"問與答"},"block8":{"video_title":"<strong class =“typography - color-accent”>Classting Learning</ strong> <br>\n改善教育環境並提升教學熱情<br>\n集結<strong>全國Edu Lab教師 </ strong>"}},"video_lectures":{"sub_header":{"video_courses":"影音教學課程","video_lectures":"個別影音課程","new_video_course":"建立課程","new_video_lecture":"建立影片課程"},"no_course":"尚無影音課程","video_course":{"lecture_count":"{Count} 堂講座","edit":"編輯課程資訊","create_new_lecture":"添加影片課程"},"new_video_course":{"create":"建立"},"modals":{"remove_course":{"title":"刪除影片課程","message":"課程中包含的影片也將刪除<br/>\n確定要刪除嗎？"},"remove_lecture":{"title":"刪除影片課程","message":"確定刪除嗎？"},"make_course_lectures_public":{"message":"所有影片課程將更改為公開<br>\n確定變更嗎？"},"make_course_lectures_private":{"message":"所有影片課程將更改為非公開<br>\n確定變更嗎？"}},"no_lectures":"尚無影片課程","upload_video":{"header_title":"上傳新影片課程","upload_text":"選取上傳檔案"},"video_lecture":{"edit":"編輯課程資訊"}},"hashtag_form":{"hashtag_candidate":{"media_count":"{count} 則貼文"},"hashtag_input":{"placeholder":"請輸入您的標籤"}},"ai_report":{"header":{"title":"Classting AI 報告"},"summary":{"title":"Classting分數","me":"我的","average":"平均","need_cat":"需診斷"},"proficiency_rank":{"top":"排名","label_suffix":"基準","in_progress":"聚集中","grade_rank_label":"全部","updated_at":"<strong>{month}月{day}日</strong> 更新，同年級百分比(%)"},"proficiency_history":{"title":"{name} 的學習程度變化"},"domain_list":{"title":"領域({cnt})","score":"比分","rank":"排名"},"score_guide":{"title":"Classting分數？","description":"透過提供符合程度的題目<br>\n判斷我的學習程度<br>\n<br>\n可直接評斷我在同年級的分數與程度","score_label_1":"小學一年級標準","score_label_2":"小學二年級標準","score_label_3":"小學三年級標準","score_label_4":"小學四年級標準","score_label_5":"小學五年級標準","score_label_6":"小學六年級標準","score_label_7":"七年級標準","score_label_8":"八年級標準","score_label_9":"九年級標準","score_label_10":"高中一年級標準","score_label_11":"高中二年級標準","score_label_12":"高中三年級標準","score_value_1":"100 ~ 199分","score_value_2":"200 ~ 299分","score_value_3":"300 ~ 399分","score_value_4":"400 ~ 499分","score_value_5":"500 ~ 599分","score_value_6":"600 ~ 699分","score_value_7":"700 ~ 799分","score_value_8":"800 ~ 899分","score_value_9":"900 ~ 999分","score_value_10":"1000 ~ 1099分","score_value_11":"1100 ~ 1199分","score_value_12":"1200 ~ 1299分"},"learning_element_list":{"title":"內容單元"}},"not_support_prime":{"title":"非AI許可會員嗎？","description":"學校/教師登錄AI許可後即可使用"},"prime":{"first_quiz_complete":"您已完成免費學習診斷<br>如欲繼續使用AI學習診斷分析<br/>請加入<strong>進階會員</strong>","not_support_user":"您目前非進階會員，將移動到詳細介紹頁面。","benefit":{"title":"想查看進階學習報告嗎？<br><strong>現在就加入Classting進階會員!</strong>","item_1":"無限次AI初步診斷","item_2":"無限量AI推薦影片教學與參考書","item_3":"即時學習分析報告","item_4":"去廣告和離線使用","not_support":"一般會員可免費體驗一回","title_2":"請無限制的使用AI老師Sam的<br><strong>自動學習分析<strong> 服務<br>!"},"notice":{"confirm":"詳細查看進階會員內容","cancel":"稍後再看"}},"class_ai_report":{"proficiency_history":{"title":""},"no_classes":"","btns":{"go_to_new_class":"","print":"","export":"","go_to_class_details":""},"table":{"all_subjects":"","title":"","subtitle":"","thead":{"number":"","id":"","name":""}},"no_students":""}}

/***/ }),

/***/ "gTxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppRoot_vue__ = __webpack_require__("zFhp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5055158c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppRoot_vue__ = __webpack_require__("uosL");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppRoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5055158c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppRoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/AppRoot.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5055158c", Component.options)
  } else {
    hotAPI.reload("data-v-5055158c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gUDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ScrollAppHeader", { attrs: { "attach-home": _vm.attachHome } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bs-b" },
        [
          !_vm.hideAppHeader
            ? _c("AppHeader", { attrs: { "attach-home": _vm.attachHome } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "sub-header" }, [_vm._t("sub-header")], 2)
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-bar" }, [_vm._t("action-bar")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-body", style: _vm.bodyStyle },
        [
          false ? _c("LoadingBounce") : _vm._e(),
          _vm._v(" "),
          _vm._t("layout-body")
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-area" }, [_vm._t("modal-area")], 2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "floating-action-menu" },
        [_vm._t("floating-action-menu")],
        2
      ),
      _vm._v(" "),
      _c("WelcomeMessageModal"),
      _vm._v(" "),
      _c("CardPreview", {
        on: {
          "show-report-content-modal": function($event) {
            _vm.reportContentModalIsShown = true
          }
        }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "file-size-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.file_size_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "audio-size-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.audio_size_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "file-type-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.file_type_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "audio-type-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.audio_type_alert.message"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "file-reader-unsupported-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("common.modal.file_reader_unsupported.message")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "max-image-limit-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.max_image_limit"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "max-audio-limit-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.max_audio_limit"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "max-video-limit-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.max_video_limit"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "only-audio-or-video-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("page_editor.alerts.only_audio_or_video")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "unsupported-video-service-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("page_editor.alerts.unsupported_video_service")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "video-load-failed-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("page_editor.alerts.video_load_failed"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.reportContentModalIsShown
        ? _c("ReportContentFromPreview", {
            on: {
              ok: function($event) {
                return _vm.onContentReportSent()
              },
              cancel: function($event) {
                _vm.reportContentModalIsShown = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AiScoreGuideModal"),
      _vm._v(" "),
      _vm.contentReportSuccessModalIsShown
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal no-header-modal hide-cancel-btn",
              attrs: {
                id: "content-report-success-modal",
                "hide-header": true,
                "ok-title": _vm.$t("common.confirm")
              },
              on: {
                ok: function($event) {
                  _vm.contentReportSuccessModalIsShown = false
                }
              }
            },
            [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("common.modal.content_report_success.message")
                  )
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.countryCodeSettingModalIsShown
        ? _c(
            "CustomModal",
            {
              staticClass: "basic-modal no-header-modal hide-cancel-btn",
              attrs: {
                id: "is-empty-country-code",
                "hide-header": true,
                "ok-title": _vm.$t("common.confirm")
              },
              on: {
                ok: function($event) {
                  _vm.countryCodeSettingModalIsShown = false
                }
              }
            },
            [
              _c("div", [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("common.empty_country_code.text"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "country-code-setting-link",
                    attrs: { href: _vm.countryCodeSettingLink }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("common.empty_country_code.link")) + " >"
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "basic-error-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("common.modal.basic_error_alert.message")
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer-area" }, [_vm._t("footer")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24df821a", esExports)
  }
}

/***/ }),

/***/ "gp/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClassItem__ = __webpack_require__("vbPQ");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'classes',

  components: {
    ClassItem: __WEBPACK_IMPORTED_MODULE_2__components_ClassItem__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['managingClassList']))
});

/***/ }),

/***/ "hFJB":
/***/ (function(module, exports) {

module.exports = {"Play":"Spel","Pause":"Pause","Current Time":"Aktuell tid","Duration Time":"Varigheit","Remaining Time":"Tid attende","Stream Type":"Type straum","LIVE":"DIREKTE","Loaded":"Lasta inn","Progress":"Status","Fullscreen":"Fullskjerm","Non-Fullscreen":"Stenga fullskjerm","Mute":"Ljod av","Unmute":"Ljod på","Playback Rate":"Avspelingsrate","Subtitles":"Teksting på","subtitles off":"Teksting av","Captions":"Teksting for høyrselshemma på","captions off":"Teksting for høyrselshemma av","Chapters":"Kapitel","You aborted the media playback":"Du avbraut avspelinga.","A network error caused the media download to fail part-way.":"Ein nettverksfeil avbraut nedlasting av videoen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videoen kunne ikkje lastas ned, på grunn av ein nettverksfeil eller serverfeil, eller av di formatet ikkje er stoda.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videoavspelinga blei broten på grunn av øydelagde data eller av di videoen ville gjera noe som nettlesaren din ikkje stodar.","No compatible source was found for this media.":"Fant ikke en kompatibel kilde for dette mediainnholdet."}

/***/ }),

/***/ "hOXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-add-block',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['checkedTutorials']), {
    showTooltip: function showTooltip() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.checkedTutorials) && !this.checkedTutorials.tryAddNewPages) {
        return true;
      }

      return false;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setTutorialAsChecked']), {
    onTooltipClosed: function onTooltipClosed() {
      this.setTutorialAsChecked('tryAddNewPages');
    },
    openPageLibraryModal: function openPageLibraryModal() {
      var _this = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.checkedTutorials) && !this.checkedTutorials.tryAddNewPages) {
        return this.setTutorialAsChecked('tryAddNewPages').then(function () {
          _this.$root.$emit('show::modal', 'page-library-modal');
        });
      }

      return this.$root.$emit('show::modal', 'page-library-modal');
    }
  })
});

/***/ }),

/***/ "hV5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchMyVideoLectureList"] = fetchMyVideoLectureList;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoLecture"] = fetchVideoLecture;
/* harmony export (immutable) */ __webpack_exports__["createNewVideoLecture"] = createNewVideoLecture;
/* harmony export (immutable) */ __webpack_exports__["updateVideoLecture"] = updateVideoLecture;
/* harmony export (immutable) */ __webpack_exports__["removeVideoLecture"] = removeVideoLecture;
/* harmony export (immutable) */ __webpack_exports__["getVideoLectureUploadUrl"] = getVideoLectureUploadUrl;
/* harmony export (immutable) */ __webpack_exports__["uploadVideoLecture"] = uploadVideoLecture;
/* harmony export (immutable) */ __webpack_exports__["setVideoLecturesInStore"] = setVideoLecturesInStore;
/* harmony export (immutable) */ __webpack_exports__["removeVideoLectureInStore"] = removeVideoLectureInStore;
/* harmony export (immutable) */ __webpack_exports__["setRecentVideoUploadInfoInStore"] = setRecentVideoUploadInfoInStore;
/* harmony export (immutable) */ __webpack_exports__["clearVideoLecturesInStore"] = clearVideoLecturesInStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("3QMj");





function fetchMyVideoLectureList(_ref, params) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/my-video-lectures', { params: params }).then(function (res) {
    return res.data;
  }).then(function (videoLectures) {
    return dispatch('setVideoLecturesInStore', videoLectures);
  }).catch(function (err) {
    console.error('err while fetching video lectures:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchVideoLecture(_ref2, lectureId) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId).then(function (res) {
    return res.data;
  }).then(function (videoLecture) {
    return dispatch('setVideoLecturesInStore', [videoLecture]);
  }).catch(function (err) {
    console.error('err while fetching video lecture by ID:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createNewVideoLecture(_ref3, params) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video-lectures', params).then(function (res) {
    return res.data;
  }).then(function (videoLecture) {
    return dispatch('fetchVideoLecture', videoLecture.id);
  }).catch(function (err) {
    console.error('err while creating a new video lecture:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateVideoLecture(_ref4, params) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video-lectures/' + params.id, params).then(function (res) {
    return res.data;
  }).then(function () {
    return dispatch('fetchVideoLecture', params.id);
  }).catch(function (err) {
    console.error('err while updating a video lecture:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeVideoLecture(_ref5, lectureId) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId).then(function (res) {
    return res.data;
  }).then(function () {
    return dispatch('removeVideoLectureInStore', lectureId);
  }).catch(function (err) {
    console.error('err while removing a video lecture:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function getVideoLectureUploadUrl() {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["l" /* VIDEO_LAMBDA_URL */]).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while getting video lecture upload url:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadVideoLecture(_, _ref6) {
  var uploadLink = _ref6.uploadLink,
      videoFile = _ref6.videoFile;

  var formData = new FormData();
  formData.append('file_data', videoFile);

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(uploadLink, formData, {
    transformRequest: [function (data, headers) {
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];

      return data;
    }]
  }).catch(function (err) {
    console.error('err while uploading video lecture:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setVideoLecturesInStore(_ref7, videoLectures) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_VIDEO_LECTURE, videoLectures);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(videoLectures);
}

function removeVideoLectureInStore(_ref8, lectureId) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REMOVE_VIDEO_LECTURE, lectureId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(lectureId);
}

function setRecentVideoUploadInfoInStore(_ref9, uploadInfo) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_RECENT_UPLOAD_INFO, uploadInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(uploadInfo);
}

function clearVideoLecturesInStore(_ref10) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].CLEAR_VIDEO_LECTURES);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

/***/ }),

/***/ "hY/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* HorizontalBar */],
  mixins: [reactiveProp],
  props: ['totalStudents'],
  data: function data() {
    var _this = this;

    return {
      chartOptions: {
        scales: {
          xAxes: [{
            ticks: {
              maxTicksLimit: 4,
              min: 0,
              max: this.totalStudents
            },
            gridLines: {
              display: true
            }
          }],
          yAxes: [{
            barThickness: 20
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            title: function title(tooltipItem) {
              return '' + tooltipItem[0]['xLabel'] + _this.$t('common.modal.preview.count');
            },
            label: function label() {
              return '';
            }
          },
          displayColors: false,
          backgroundColor: 'rgba(255,255,255,1)',
          borderColor: '#00c896',
          borderWidth: 1,
          titleFontColor: '#000000',
          titleFontStyle: 'normal'
        }
      }
    };
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
});

/***/ }),

/***/ "hcAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyModal_vue__ = __webpack_require__("m8Oq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070b65ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyModal_vue__ = __webpack_require__("0xvn");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070b65ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/PolicyModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-070b65ca", Component.options)
  } else {
    hotAPI.reload("data-v-070b65ca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hg9+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report-content-modal',

  props: {
    card: {
      type: Object,
      default: null
    },
    page: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      reportIssue: 1,
      busy: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUserId', 'currentUser']), {
    reportIssueText: function reportIssueText() {
      if (this.reportIssue === 1) {
        return this.$t('common.modal.report_content.options.has_error');
      }

      return this.$t('common.modal.report_content.options.inappropriate');
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['sendSlackContentReports']), {
    onRadioSelect: function onRadioSelect(value) {
      this.reportIssue = value;
    },
    reportContent: function reportContent() {
      var _this = this;

      if (!this.busy && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.card) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.page)) {
        this.busy = true;

        var params = {
          card_id: this.card.copy_id || this.page.card_id || this.card.card_id || null,
          store_card_id: this.card.store_card_id || null,
          card_title: this.card.title || this.page.card_title,
          page_id: this.page.id,
          page_position: this.page.position,
          card_publisher_name: this.card.publisher_name || this.page.publisher_name || null,
          card_publisher_id: this.card.publisher_id || this.page.publisher_id || null,
          card_author_name: this.card.author_name || this.page.author_name || null,
          card_author_id: this.card.author_id || this.page.author_id || null,
          card_subject_id: this.card.subject_id || null,
          card_grade_id: this.card.grade_id || this.page.grade_id || null,
          user_id: this.currentUserId || null,
          user_name: this.currentUser.name || null,
          user_role: this.currentUser.role || null,
          reason: this.reportIssueText,
          reported_from: this.$route.fullPath,
          reported_at: new Date().toString()
        };

        this.sendSlackContentReports(params).then(function () {
          _this.busy = false;
          _this.$emit('ok');
        });
      }
    }
  })
});

/***/ }),

/***/ "hiGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "my-card",
      on: {
        mouseover: function($event) {
          return _vm.handleCardOver(_vm.card.id)
        },
        mouseleave: _vm.handleCardLeave
      }
    },
    [
      _vm.selectedCardId === _vm.card.id
        ? _c("div", { staticClass: "card-background" }, [
            _c("div", { staticClass: "card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.openCardPreview }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", { attrs: { src: "/static/images/ic-eye.svg" } }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.preview")) +
                        "\n        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.goToMyCardDetails }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-zoom-in.svg" }
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.detail_view")) +
                        "\n        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit(
                        "onShareLevelSetupClick",
                        _vm.card.id,
                        _vm.card.share_level
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-hotspot.svg" }
                    }),
                    _vm._v(" "),
                    _vm.card.share_level === 2
                      ? _c("span", [_vm._v("비공개중")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.share_level === 1
                      ? _c("span", [_vm._v("전체 공개중")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.share_level === 3
                      ? _c("span", [_vm._v("기관 공개중")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.share_level === 99
                      ? _c("span", [_vm._v("숨김처리중")])
                      : _vm._e()
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-cover-img-thumb clickable",
          style: _vm.styleBindings
        },
        [
          false
            ? _c("div", { staticClass: "card-action" }, [
                _c(
                  "div",
                  { staticClass: "card-action-btn" },
                  [
                    _c(
                      "IconDropdown",
                      { attrs: { dropup: false } },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function($event) {
                                return _vm.$emit(
                                  "open-delete-modal",
                                  _vm.card.id
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.card.menu.remove")))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.openCardPreview }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.preview")))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.updateShareLevel }
                          },
                          [
                            _vm.card.share_level === 1
                              ? _c(
                                  "span",
                                  { staticClass: "typography--color-accent" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.card.menu.make_private")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-block clickable" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 card-info-section" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "h4",
                {
                  staticClass: "card-title",
                  class: _vm.card.title.length > 20 && "long-title",
                  attrs: { title: _vm.card.title }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.card.title) + "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-subtitle typography--caption" }, [
                _vm.card.grade_id !== undefined
                  ? _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getGradeLabel(_vm.card)) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.card.subject_id
                  ? _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getSubjectLabel(_vm.card)) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.card.chapter_name
                  ? _c("span", [
                      _vm._v(
                        "\n              / " +
                          _vm._s(_vm.card.chapter_name) +
                          "\n            "
                      )
                    ])
                  : _vm.card.core_concept_id
                  ? _c("span", [
                      _vm._v(
                        "\n              ∙ " +
                          _vm._s(
                            _vm.getCoreConceptLabel(_vm.card.core_concept)
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-bottom-desc" }, [
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _vm.card.page_count - _vm.card.quiz_count > 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.card.non_quiz")) +
                              " " +
                              _vm._s(
                                _vm.$t("common.card.count", {
                                  cnt: _vm.card.page_count - _vm.card.quiz_count
                                })
                              ) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.page_count - _vm.card.quiz_count > 0 &&
                    _vm.card.quiz_count > 0
                      ? _c("span", [_vm._v("∙")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.quiz_count > 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.card.quiz")) +
                              " " +
                              _vm._s(
                                _vm.$t("common.card.count", {
                                  cnt: _vm.card.quiz_count
                                })
                              ) +
                              "\n              "
                          )
                        ])
                      : _c("span", { staticStyle: { color: "transparent" } }, [
                          _vm._v("_")
                        ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.getShareLevelLabel(_vm.card.share_level))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.card.assigned_count
                      ? _c("span", [
                          _vm._v(
                            "∙ " +
                              _vm._s(
                                _vm.$t("common.card.share_count", {
                                  cnt: _vm.card.assigned_count
                                })
                              )
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("common.card.updated_at")) +
                        ": " +
                        _vm._s(_vm._f("datetime")(_vm.card.updated_at)) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d21ef0f", esExports)
  }
}

/***/ }),

/***/ "hwN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i7qK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchPublisherSeries"] = fetchPublisherSeries;
/* harmony export (immutable) */ __webpack_exports__["fetchSeriesById"] = fetchSeriesById;
/* harmony export (immutable) */ __webpack_exports__["createNewSeries"] = createNewSeries;
/* harmony export (immutable) */ __webpack_exports__["updateSeries"] = updateSeries;
/* harmony export (immutable) */ __webpack_exports__["uploadNewSeriesCoverImage"] = uploadNewSeriesCoverImage;
/* harmony export (immutable) */ __webpack_exports__["addCardToSeries"] = addCardToSeries;
/* harmony export (immutable) */ __webpack_exports__["removeSeries"] = removeSeries;
/* harmony export (immutable) */ __webpack_exports__["updateSeriesCard"] = updateSeriesCard;
/* harmony export (immutable) */ __webpack_exports__["removeCardFromSeries"] = removeCardFromSeries;
/* harmony export (immutable) */ __webpack_exports__["removePublisherCard"] = removePublisherCard;
/* harmony export (immutable) */ __webpack_exports__["fetchNonSeriesCards"] = fetchNonSeriesCards;
/* harmony export (immutable) */ __webpack_exports__["fetchSeriesChapters"] = fetchSeriesChapters;
/* harmony export (immutable) */ __webpack_exports__["updateChapter"] = updateChapter;
/* harmony export (immutable) */ __webpack_exports__["fetchChapterCards"] = fetchChapterCards;
/* harmony export (immutable) */ __webpack_exports__["createVideoCourseCards"] = createVideoCourseCards;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoCourseCards"] = fetchVideoCourseCards;
/* harmony export (immutable) */ __webpack_exports__["updateVideoCourseCards"] = updateVideoCourseCards;
/* harmony export (immutable) */ __webpack_exports__["setSeries"] = setSeries;
/* harmony export (immutable) */ __webpack_exports__["removeSeriesInStore"] = removeSeriesInStore;
/* harmony export (immutable) */ __webpack_exports__["setNonSeriesCards"] = setNonSeriesCards;
/* harmony export (immutable) */ __webpack_exports__["removeNonSeriesCardInStore"] = removeNonSeriesCardInStore;
/* harmony export (immutable) */ __webpack_exports__["setChapters"] = setChapters;
/* harmony export (immutable) */ __webpack_exports__["setChapterCards"] = setChapterCards;
/* harmony export (immutable) */ __webpack_exports__["removeChapterCardInStore"] = removeChapterCardInStore;
/* harmony export (immutable) */ __webpack_exports__["requestVideoCourseCard"] = requestVideoCourseCard;
/* harmony export (immutable) */ __webpack_exports__["updateExtraContent"] = updateExtraContent;
/* harmony export (immutable) */ __webpack_exports__["removeExtraContent"] = removeExtraContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("pNG8");





function fetchPublisherSeries(_ref, params) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/publishers/' + params.publisher_id + '/series', { params: params }).then(function (res) {
    return res.data;
  }).then(function (series) {
    return dispatch('setSeries', series);
  }).catch(function (err) {
    console.error('err while fetching publisher series:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchSeriesById(_ref2, seriesId) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + seriesId).then(function (res) {
    return res.data;
  }).then(function (series) {
    return dispatch('setSeries', [series]);
  }).catch(function (err) {
    console.error('err while fetching series by ID:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createNewSeries(_ref3, params) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/publishers/' + params.publisher_id + '/series', params).then(function (res) {
    return res.data;
  }).then(function (series) {
    return dispatch('setSeries', [series]);
  }).catch(function (err) {
    console.error('err while creating a new series:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateSeries(_ref4, params) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + params.id, params).then(function (res) {
    return res.data;
  }).then(function (series) {
    return dispatch('setSeries', [series]);
  }).catch(function (err) {
    console.error('err while updating a series:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadNewSeriesCoverImage(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var seriesId = _ref6.seriesId,
      imageFile = _ref6.imageFile;

  var formData = new FormData();
  formData.append('file', imageFile);

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + seriesId + '/cover_images', formData).then(function (res) {
    return res.data;
  }).then(function (series) {
    return dispatch('setSeries', [series]);
  }).catch(function (err) {
    console.error('err while uploading new series cover image:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function addCardToSeries(_ref7, params) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + params.series_id + '/cards', params).then(function (res) {
    return res.data;
  }).then(function (card) {
    return dispatch('setChapterCards', [card]);
  }).then(function () {
    return dispatch('removeNonSeriesCardInStore', params.card_id);
  }).catch(function (err) {
    console.error('err while adding card to a series:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeSeries(_ref8, seriesId) {
  var dispatch = _ref8.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + seriesId).then(function () {
    return dispatch('removeSeriesInStore', seriesId);
  }).catch(function (err) {
    console.error('err while removing a series:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateSeriesCard(_ref9, params) {
  var dispatch = _ref9.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + params.series_id + '/cards/' + params.card_id, params).then(function (res) {
    return res.data;
  }).then(function (card) {
    return dispatch('setChapterCards', [card]);
  }).catch(function (err) {
    console.error('err while updating a series card:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeCardFromSeries(_ref10, params) {
  var dispatch = _ref10.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + params.series_id + '/cards/' + params.card_id).then(function (res) {
    return res.data;
  }).then(function (card) {
    return dispatch('setNonSeriesCards', [card]);
  }).then(function () {
    return dispatch('removeChapterCardInStore', params.card_id);
  }).catch(function (err) {
    console.error('err while removing a card from series:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removePublisherCard(_ref11, cardId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId).then(function () {
    return dispatch('removeChapterCardInStore', cardId);
  }).then(function () {
    return dispatch('removeNonSeriesCardInStore', cardId);
  }).catch(function (err) {
    console.error('err while removing publisher card:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchNonSeriesCards(_ref12, params) {
  var dispatch = _ref12.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/publishers/' + params.publisher_id + '/non_series_cards', { params: params }).then(function (res) {
    return res.data;
  }).then(function (nonSeriesCards) {
    return dispatch('setNonSeriesCards', nonSeriesCards);
  }).catch(function (err) {
    console.error('err while fetching non series cards:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchSeriesChapters(_ref13, seriesId) {
  var dispatch = _ref13.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/series/' + seriesId + '/chapters').then(function (res) {
    return res.data;
  }).then(function (chapters) {
    return dispatch('setChapters', chapters);
  }).catch(function (err) {
    console.error('err while fetching series chapters:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateChapter(_ref14, params) {
  var dispatch = _ref14.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/chapters/' + params.id, params).then(function (res) {
    return res.data;
  }).then(function (chapter) {
    return dispatch('setChapters', [chapter]);
  }).catch(function (err) {
    console.error('err while updating a chapter:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchChapterCards(_ref15, chapterId) {
  var dispatch = _ref15.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/chapters/' + chapterId + '/cards').then(function (res) {
    return res.data;
  }).then(function (cards) {
    return dispatch('setChapterCards', cards);
  }).catch(function (err) {
    console.error('err while fetching chapter cards:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createVideoCourseCards(_ref16, data) {
  var commit = _ref16.commit;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video_courses_cards', data).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_VIDEO_COURSE_CARD, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchVideoCourseCards(_ref17, params) {
  var commit = _ref17.commit;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video_courses_cards', { params: params }).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].FETCH_VIDEO_COURSE_CARDS, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateVideoCourseCards(_ref18, data) {
  var commit = _ref18.commit;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].put(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/video_courses_cards/' + data.id, data).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].UPDATE_VIDEO_COURSE_CARD, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setSeries(_ref19, series) {
  var commit = _ref19.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_SERIES, series);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(series);
}

function removeSeriesInStore(_ref20, seriesId) {
  var commit = _ref20.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REMOVE_SERIES, seriesId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(seriesId);
}

function setNonSeriesCards(_ref21, nonSeriesCards) {
  var commit = _ref21.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_NON_SERIES_CARDS, nonSeriesCards);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(nonSeriesCards);
}

function removeNonSeriesCardInStore(_ref22, cardId) {
  var commit = _ref22.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REMOVE_NON_SERIES_CARD, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardId);
}

function setChapters(_ref23, chapters) {
  var commit = _ref23.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CHAPTERS, chapters);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(chapters);
}

function setChapterCards(_ref24, cards) {
  var commit = _ref24.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CHAPTER_CARDS, cards);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cards);
}

function removeChapterCardInStore(_ref25, cardId) {
  var commit = _ref25.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REMOVE_CHAPTER_CARD, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardId);
}

function requestVideoCourseCard(_ref26) {
  var commit = _ref26.commit;

  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].REQUEST_VIDEO_COURSE_CARD, true);
}

function updateExtraContent(_ref27, _ref28) {
  var commit = _ref27.commit;
  var pageId = _ref28.pageId,
      params = _ref28.params;

  var formData = new FormData();
  if (params.title) {
    formData.append('title', params.title);
  }
  if (params.imageFile) {
    formData.append('file', params.imageFile);
  }
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId + '/extra_contents', formData);
}

function removeExtraContent(_ref29, extraContentId) {
  var commit = _ref29.commit;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["f" /* MINERVA_API_URL */] + '/extra_contents/' + extraContentId);
}

/***/ }),

/***/ "i9WJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal chapter-edit-modal",
      attrs: {
        id: "chapter-edit-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "chapter-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [_vm._v("\n    " + _vm._s(_vm.modalTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c("div", { staticClass: "chapter-edit-modal__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "chapter-title-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.chapter_edit.name")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.chapterTitle,
                    expression: "chapterTitle"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "chapter-title-input",
                  placeholder: _vm.$t(
                    "publishers.modal.chapter_edit.name_placeholder"
                  )
                },
                domProps: { value: _vm.chapterTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.chapterTitle = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "domain-select" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.chapter_edit.domain")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected.domainId,
                      expression: "selected.domainId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "domain-select",
                    disabled: _vm.filteredDomains.length === 0
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.selected,
                        "domainId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "publishers.modal.chapter_edit.domain_placeholder"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredDomains, function(domain) {
                    return _c(
                      "option",
                      { key: domain.id, domProps: { value: domain.id } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(domain.name) + "\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "core-concept-select" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("publishers.modal.chapter_edit.core_concept")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected.coreConceptId,
                      expression: "selected.coreConceptId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "core-concept-select",
                    disabled: _vm.filteredCoreConepts.length === 0
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.selected,
                        "coreConceptId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "publishers.modal.chapter_edit.core_concept_placeholder"
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredCoreConepts, function(cc) {
                    return _c(
                      "option",
                      { key: cc.id, domProps: { value: cc.id } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(cc.name) +
                            " (" +
                            _vm._s(cc.description) +
                            ")\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3868149e", esExports)
  }
}

/***/ }),

/***/ "iV6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_MyCardDetails__ = __webpack_require__("LDaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_NewMyCard__ = __webpack_require__("dgSd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_MyCards__ = __webpack_require__("cmNB");




var router = [{
  name: 'myCards',
  path: '/my-cards',
  component: __WEBPACK_IMPORTED_MODULE_2__views_MyCards__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'myCardDetails',
  path: '/my-cards/:card_id',
  component: __WEBPACK_IMPORTED_MODULE_0__views_MyCardDetails__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'newMyCard',
  path: '/new-my-card',
  component: __WEBPACK_IMPORTED_MODULE_1__views_NewMyCard__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "iW3f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BarChart__ = __webpack_require__("SH2g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LineChart__ = __webpack_require__("RhCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DoughnutChart__ = __webpack_require__("SCW2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SelectAssignmentModal__ = __webpack_require__("6WOJ");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'class-report',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_6__components_BarChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_7__components_LineChart__["a" /* default */],
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_8__components_DoughnutChart__["a" /* default */],
    SelectAssignmentModal: __WEBPACK_IMPORTED_MODULE_9__components_SelectAssignmentModal__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false,
      cls: null,
      students: null,
      studentToRecommend: {},
      studentList: [],
      selectedSubjectId: 0,
      selectedReport: 1,
      selectedGraph: 1,
      selectedStudentReport: 1,
      managingStudentList: [],
      checkedStudents: [],
      assignments: [],
      selectedAssignmentList: [],
      hasSelectedAllAssignments: true,
      assignmentStats: {},
      allSubmissions: [],
      assignmentsBySubjects: {},
      submissionsBySubjects: {},

      averageScoreBySubjects: {},
      diffScoreBySubjects: {},
      averageDurationBySubjects: {},
      diffDurationBySubjects: {},
      averageSubmitrateBySubjects: {},
      diffSubmitrateBySubjects: {},

      viewMoreLength: 8,
      viewMoreNeedHelp: false,
      viewMoreTotalStudents: false,

      classScores: [],
      currentAvgScore: 0,
      diffAvgScore: 0,
      currentSubmissionRate: 0,
      diffSubmissionRate: 0,
      sortType: 'number',

      selectAssignmentModalIsShown: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['managingClasses', 'getRouteQuery', 'coreConcepts', 'subjectMap', 'units']), {
    subjectIds: function subjectIds() {
      if (this.cls.school_name.includes('중학교')) {
        return [2, 5, 43, 44, 41, 42, 50, 51, 47, 48];
      }

      if (this.cls.grade >= 3 && this.cls.grade <= 6) {
        return [2, 3, 5, 41, 42, 50, 51, 47, 48];
      } else if (this.cls.grade >= 7 && this.cls.grade <= 9) {
        return [2, 5, 43, 44, 41, 42, 50, 51, 47, 48];
      }

      return [41, 42, 50, 51, 47, 48, 49];
    },
    selectedAssignmentsById: function selectedAssignmentsById() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["keyBy"])(this.selectedAssignmentList, 'id');
    },
    sortedStudentList: function sortedStudentList() {
      var _this = this;

      if (this.sortType === 'number') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(this.studentList, function (student) {
          return student.number || 9999;
        }, 'asc');
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(this.studentList, function (student) {
        var studentSubjectScore = _this.getSubmissionSubjectScore(student.submissions, _this.selectedSubjectId);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(studentSubjectScore)) {
          return -1;
        }
        return studentSubjectScore;
      }, 'desc');
    },
    formattedClassName: function formattedClassName() {
      if (this.cls) {
        var year = this.cls.year;
        var schoolName = this.cls.school_name;
        var grade = this.cls.grade;
        var className = this.cls.name;

        return year + ' ' + this.getShortenedString(schoolName, 15) + ' ' + grade + ' - ' + this.getShortenedString(className, 15);
      }

      return '';
    },
    classScoreRanks: function classScoreRanks() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(this.classScores, null, 'desc');
    },
    classSubjectScoreRanks: function classSubjectScoreRanks() {
      var _this2 = this;

      var classSubjectScores = [];
      this.studentList.forEach(function (student) {
        var score = _this2.getSubmissionSubjectScore(student.submissions, _this2.selectedSubjectId);
        if (score !== null) {
          classSubjectScores.push(score);
        }
      });

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(classSubjectScores, null, 'desc');
    },
    needHelpStudentList: function needHelpStudentList() {
      var _this3 = this;

      var studentList = this.studentList.filter(function (student) {
        var averageScore = _this3.getSubmissionSubjectScore(student.submissions, _this3.selectedSubjectId);
        var classRank = _this3.classSubjectScoreRanks.indexOf(averageScore) + 1;

        if (averageScore !== null && (averageScore <= 49 || classRank >= Math.floor(_this3.studentList.length * 2 / 3) && averageScore <= 60)) {
          return true;
        }
        return false;
      });

      if (this.sortType === 'number') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(studentList, function (student) {
          return student.number || 9999;
        }, 'asc');
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(studentList, function (student) {
        return _this3.getSubmissionSubjectScore(student.submissions, _this3.selectedSubjectId);
      }, 'desc');
    },
    achievementDistributionCriteria: function achievementDistributionCriteria() {
      return [100, 89, 79, 69, 59, -1];
    },
    dayDiffForWeek: function dayDiffForWeek() {
      return [6, 0, 1, 2, 3, 4, 5];
    },
    achievementDistributionLabel: function achievementDistributionLabel() {
      var distributionLabel = [];

      for (var i = 0; i < this.achievementDistributionCriteria.length - 1; i += 1) {
        distributionLabel.push(this.achievementDistributionCriteria[i + 1] + 1 + '-' + this.achievementDistributionCriteria[i]);
      }
      return distributionLabel;
    },
    achievementDistribution: function achievementDistribution() {
      var _this4 = this;

      var distributionData = [0, 0, 0, 0, 0, 0];

      this.studentList.forEach(function (student) {
        var score = _this4.getSubmissionSubjectScore(student.submissions, _this4.selectedSubjectId);
        if (score !== null) {
          for (var i = 1; i < _this4.achievementDistributionCriteria.length; i += 1) {
            if (score > _this4.achievementDistributionCriteria[i]) {
              distributionData[i - 1] += 1;
              break;
            }
          }
        }
      });

      return {
        labels: this.achievementDistributionLabel,
        datasets: [{
          data: distributionData,
          backgroundColor: '#00c896'
        }]
      };
    },
    activeStudentData: function activeStudentData() {
      var _this5 = this;

      var activeStudent = [];

      this.studentList.forEach(function (student) {
        var durations = [];
        var selectedSubmissions = (student.submissions || []).filter(function (submission) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(_this5.selectedAssignmentsById[submission.assignment_id]);
        });
        _this5.getSubmissionsThisWeek(selectedSubmissions).forEach(function (submission) {
          if (submission.subject_id === _this5.selectedSubjectId) {
            durations.push(submission.duration);
          }
        });

        if (durations.length > 0) {
          activeStudent.push(student);
        }
      });

      var chartData = [];

      chartData.push(activeStudent.length);
      chartData.push(this.studentList.length - activeStudent.length);

      return {
        datasets: [{
          backgroundColor: ['#89d5ff', '#cccccc'],
          data: chartData
        }]
      };
    },
    trendData: function trendData() {
      var _this6 = this;

      var trendLabel = [];
      var trendDataAchievement = [];
      var trendDataSubmissionRate = [];
      var now = new Date();
      var howManyWeeksToShow = 6;
      var subjectAssignmentList = this.assignmentsBySubjects[this.selectedSubjectId];
      var assignmentList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(subjectAssignmentList, function (assignment) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(_this6.selectedAssignmentsById[assignment.id]);
      });

      try {
        var totalAssignedCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sum"])(assignmentList.map(function (assignment) {
          return assignment.submissions.length;
        }));

        var _loop = function _loop(i) {
          var date = new Date();
          date.setDate(now.getDate() - 7 * i);
          date.setHours(23);
          date.setMinutes(59);
          date.setSeconds(59);
          trendLabel.push('' + (date.getMonth() + 1) + _this6.$t('common.month') + ' ' + date.getDate() + _this6.$t('common.day'));
          var submissions = [];
          assignmentList.forEach(function (assignment) {
            assignment.submissions.filter(function (submission) {
              if (submission.submitted_at) {
                var submittedDate = new Date(submission.submitted_at);
                if (submittedDate.getTime() <= date.getTime()) {
                  submissions.push(submission);
                  return true;
                }
              }
              return false;
            });
          });
          trendDataSubmissionRate.push(submissions.length / totalAssignedCount * 100);
          trendDataAchievement.push(_this6.getAverageScore(submissions));
        };

        for (var i = howManyWeeksToShow; i >= 0; i -= 1) {
          _loop(i);
        }
      } catch (err) {
        for (var i = howManyWeeksToShow; i >= 0; i -= 1) {
          trendDataSubmissionRate.push(0);
          trendDataAchievement.push(0);
          var _date = new Date();
          _date.setDate(now.getDate() - 7 * i);
          _date.setHours(23);
          _date.setMinutes(59);
          _date.setSeconds(59);
          trendLabel.push('' + (_date.getMonth() + 1) + this.$t('common.month') + ' ' + _date.getDate() + this.$t('common.day'));
        }
      }

      this.currentAvgScore = Math.round(trendDataAchievement[howManyWeeksToShow]);
      this.diffAvgScore = Math.round(trendDataAchievement[howManyWeeksToShow] - trendDataAchievement[howManyWeeksToShow - 1]);
      this.currentSubmissionRate = Math.round(trendDataSubmissionRate[howManyWeeksToShow]);
      this.diffSubmissionRate = Math.round(trendDataSubmissionRate[howManyWeeksToShow] - trendDataSubmissionRate[howManyWeeksToShow - 1]);

      return {
        labels: trendLabel,
        datasets: [{
          data: trendDataSubmissionRate,
          lineTension: 0,
          backgroundColor: 'rgba(0, 0, 0, 0)',
          borderColor: '#ffcd78',
          pointRadius: 5,
          pointBackgroundColor: '#ffcd78'
        }, {
          data: trendDataAchievement,
          lineTension: 0,
          backgroundColor: 'rgba(0, 0, 0, 0)',
          borderColor: '#00c896',
          pointRadius: 5,
          pointBackgroundColor: '#00c896'
        }]
      };
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'setIsClassAssignmentPreview', 'fetchTeacherAssignmentStats', 'fetchAssignedCardPages', 'setSelectedPreviewCard', 'fetchClassAssignments', 'manageClassStudents', 'fetchClassStudents', 'syncClassStudents', 'setLibrartFilter', 'fetchUnits']), {
    isNil: function isNil(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(value);
    },
    getNumStrTwoDigit: function getNumStrTwoDigit(number) {
      if (number === null || number === undefined) {
        return '-';
      }

      if (number <= 9) {
        return '0' + number;
      }
      return number;
    },
    formattedTime: function formattedTime(duration) {
      if (!duration) {
        return '00h 00m';
      }
      return this.getNumStrTwoDigit(Math.floor(Math.abs(duration) / 3600)) + 'h ' + this.getNumStrTwoDigit(Math.floor(Math.abs(duration) / 60) % 60) + 'm';
    },
    formattedDiff: function formattedDiff(number) {
      if (number >= 0) {
        return '+ ' + this.getNumStrTwoDigit(number);
      }
      return '- ' + this.getNumStrTwoDigit(-number);
    },
    getLearningElements: function getLearningElements(coreConcept) {
      if (!coreConcept) {
        return null;
      }

      return coreConcept.description;
    },
    selectStudent: function selectStudent(checkedStudents) {
      this.checkedStudents = checkedStudents;
    },
    selectStudentGender: function selectStudentGender(student, gender) {
      student.gender = gender;
    },
    reOrderManagingStudentList: function reOrderManagingStudentList() {
      this.managingStudentList.forEach(function (student, i) {
        student.number = i + 1;
      });
    },
    move: function move(list, from, to) {
      if (to >= list.length || to < 0) {
        return from;
      }

      var item = list.splice(from, 1)[0];
      item.number = to + 1;
      list.splice(to, 0, item);

      return to;
    },
    moveStudentNumber: function moveStudentNumber(direction) {
      var _this7 = this;

      var usedPos = [];

      if (direction === 'up') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(this.checkedStudents, 'number', 'asc').forEach(function (student) {
          var from = student.number - 1;
          var to = student.number - 2;

          if (usedPos.indexOf(to) === -1) {
            var pos = _this7.move(_this7.managingStudentList, from, to);
            usedPos.push(pos);
          } else {
            usedPos.push(from);
          }
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(this.checkedStudents, 'number', 'desc').forEach(function (student) {
          var from = student.number - 1;
          var to = student.number;

          if (usedPos.indexOf(to) === -1) {
            var pos = _this7.move(_this7.managingStudentList, from, to);
            usedPos.push(pos);
          } else {
            usedPos.push(from);
          }
        });
      }

      this.reOrderManagingStudentList();
    },
    openStudentManageModal: function openStudentManageModal() {
      this.managingStudentList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(this.studentList), 'number', 'asc');
      this.reOrderManagingStudentList();
      this.checkedStudents = [];

      this.$root.$emit('show::modal', 'student-manage-modal');
    },
    openRecommendContentModal: function openRecommendContentModal() {
      this.$root.$emit('show::modal', 'recommend-content-modal');
    },
    updateStudents: function updateStudents() {
      var _this8 = this;

      var modifiedStudents = this.managingStudentList.filter(function (student) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(student, _this8.students[student.student_id]);
      }).map(function (student) {
        return {
          student_id: student.student_id,
          class_id: student.class_id,
          number: student.number,
          gender: student.gender
        };
      });

      var updateInfo = {
        students: modifiedStudents,
        classId: this.cls.id
      };

      this.manageClassStudents(updateInfo).then(function () {
        _this8.managingStudentList.forEach(function (student) {
          _this8.students[student.student_id].number = student.number;
          _this8.students[student.student_id].gender = student.gender;
        });
      }).then(function () {
        _this8.$root.$emit('hide::modal', 'student-manage-modal');
      }).catch(function (err) {
        _this8.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    getSubmittedSubmissions: function getSubmittedSubmissions(submissions) {
      if (!submissions) {
        return [];
      }

      return submissions.filter(function (submission) {
        return !!submission.is_submitted;
      });
    },
    getSubmissionSubjectScore: function getSubmissionSubjectScore(submissions, subjectId, subjectIdList) {
      var _this9 = this;

      if (!submissions) {
        return null;
      }

      var filtered = submissions.filter(function (submission) {
        if (subjectId) {
          return submission.subject_id === subjectId && !!submission.is_submitted && _this9.selectedAssignmentsById[submission.assignment_id];
        }

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(subjectIdList)) {
          return subjectIdList.indexOf(submission.subject_id) !== -1 && !!submission.is_submitted;
        }

        return false;
      }).filter(function (submission) {
        return submission.quiz_count > 0;
      });

      if (filtered.length === 0) {
        return null;
      }

      var scores = filtered.map(function (submission) {
        return submission.score / submission.total_score * 100;
      });

      return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["mean"])(scores), 10);
    },
    getAverageScore: function getAverageScore(submissions) {
      if (!submissions) {
        return null;
      }

      var filtered = submissions.filter(function (submission) {
        return submission.quiz_count > 0;
      });

      if (filtered.length === 0) {
        return null;
      }

      var scores = this.getSubmittedSubmissions(filtered).map(function (submission) {
        return submission.score / submission.total_score * 100;
      });

      if (scores.length === 0) {
        return null;
      }

      return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["mean"])(scores), 10);
    },
    getAverageDuration: function getAverageDuration(submissions) {
      var _this10 = this;

      if (!submissions) {
        return null;
      }

      var filtered = this.getSubmittedSubmissions(submissions).filter(function (submission) {
        return submission.duration !== null && _this10.selectedAssignmentsById[submission.assignment_id];
      });

      if (filtered.length === 0) {
        return null;
      }

      var durations = filtered.map(function (submission) {
        return submission.duration;
      });

      return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["mean"])(durations), 10);
    },
    getTotalDuration: function getTotalDuration(submissions) {
      var _this11 = this;

      if (!submissions) {
        return null;
      }

      var filtered = this.getSubmittedSubmissions(submissions).filter(function (submission) {
        return submission.duration !== null && _this11.selectedAssignmentsById[submission.assignment_id];
      });

      if (filtered.length === 0) {
        return 0;
      }

      var durations = filtered.map(function (submission) {
        return submission.duration;
      });

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sum"])(durations);
    },
    getCompleteRate: function getCompleteRate(submissions) {
      if (!submissions || submissions.length === 0) {
        return 0;
      }

      var submittedCount = this.getSubmittedSubmissions(submissions).length;
      var rate = submittedCount / submissions.length * 100;

      return parseInt(rate, 10);
    },
    getCompleteRateSubject: function getCompleteRateSubject(submissions, subjectId, subjectIdList) {
      var _this12 = this;

      if (!submissions || submissions.length === 0) {
        return 0;
      }

      var filtered = submissions.filter(function (submission) {
        if (subjectId) {
          return submission.subject_id === subjectId && _this12.selectedAssignmentsById[submission.assignment_id];
        }

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(subjectIdList)) {
          return subjectIdList.indexOf(submission.subject_id) !== -1;
        }

        return false;
      });

      var submittedCount = this.getSubmittedSubmissions(filtered).length;
      var rate = submittedCount / filtered.length * 100;

      return parseInt(rate, 10);
    },
    getActiveStudents: function getActiveStudents() {
      var _this13 = this;

      var now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);

      var activeStudentList = this.studentList.filter(function (student) {
        if (student.submissions) {
          for (var i = 0; i < student.submissions.length; i += 1) {
            if (student.submissions[i].subject_id === _this13.selectedSubjectId && student.submissions[i].submitted_at) {
              var submittedDate = new Date(student.submissions[i].submitted_at);
              if (submittedDate.getTime() >= now.getTime() - _this13.dayDiffForWeek[now.getDay()] * 24 * 60 * 60 * 1000 && _this13.selectedAssignmentsById[student.submissions[i].assignment_id]) {
                return true;
              }
            }
          }
        }
        return false;
      });

      return activeStudentList.length;
    },
    getSubmissionsUntilLastWeek: function getSubmissionsUntilLastWeek(submissions) {
      var _this14 = this;

      if (submissions) {
        var now = new Date();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        var filtered = submissions.filter(function (submission) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(_this14.selectedAssignmentsById[submission.assignment_id]);
        }).filter(function (submission) {
          var submittedDate = new Date(submission.submitted_at);
          if (submittedDate.getTime() < now.getTime() - _this14.dayDiffForWeek[now.getDay()] * 24 * 60 * 60 * 1000) {
            return true;
          }
          return false;
        });

        return filtered;
      }

      return [];
    },
    getSubmissionsThisWeek: function getSubmissionsThisWeek(submissions) {
      var _this15 = this;

      if (submissions) {
        var now = new Date();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        var filtered = submissions.filter(function (submission) {
          var submittedDate = new Date(submission.submitted_at);
          if (submittedDate.getTime() >= now.getTime() - _this15.dayDiffForWeek[now.getDay()] * 24 * 60 * 60 * 1000) {
            return true;
          }
          return false;
        });

        return filtered;
      }

      return [];
    },
    getSubmissionsOfUnit: function getSubmissionsOfUnit(submissions, unitId) {
      var _this16 = this;

      return submissions.filter(function (submission) {
        return submission.subject_id === _this16.selectedSubjectId && submission.unit_id === unitId;
      });
    },
    openClassAssignmentPreview: function openClassAssignmentPreview(assignment) {
      var _this17 = this;

      var cardClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(assignment.assigned_card);

      cardClone.title += ' (' + this.formattedClassName + ')';

      this.fetchAssignedCardPages(assignment.id).then(function (pages) {
        var quizPages = pages.filter(function (page) {
          return !!page.is_quiz;
        });
        cardClone.pages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(quizPages);
      }).then(function () {
        return _this17.setSelectedPreviewCard(cardClone);
      }).then(function () {
        return _this17.setSelectedPreviewPageIndex(0);
      }).then(function () {
        return _this17.setIsClassAssignmentPreview(true);
      }).then(function () {
        _this17.$root.$emit('show::modal', 'card-preview-modal');
      }).catch(function (err) {
        _this17.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    getRecommendUnits: function getRecommendUnits(student) {
      var _this18 = this;

      if (!student.submissions) {
        return [];
      }

      var unitList = [];

      student.submissions.forEach(function (submission) {
        if (submission.subject_id === _this18.selectedSubjectId && submission.unit_id) {
          if (_this18.getAverageScore([submission]) !== null && _this18.getAverageScore([submission]) <= 50 && unitList.indexOf(submission.unit_id) === -1 && _this18.units[submission.unit_id]) {
            unitList.push(submission.unit_id);
          }
        }
      });

      return unitList;
    },
    goToLibrary: function goToLibrary(selectedSubjectId, cls, unitId) {
      this.$root.$emit('hide::modal', 'recommend-content-modal');

      this.$router.push('/library/store-cards?subject_id=' + selectedSubjectId + '&grade_id=' + cls.grade + '&unit_id=' + unitId);
    },
    getShortenedString: function getShortenedString(string, maxLength) {
      if (string.length <= maxLength) {
        return string;
      }
      return string.substring(0, maxLength) + '...';
    },
    onAssignmentsSelected: function onAssignmentsSelected(_ref) {
      var selectedList = _ref.selectedList,
          isAll = _ref.isAll;

      if (isAll) {
        this.selectedAssignmentList = this.assignmentsBySubjects[this.selectedSubjectId] || [];
        this.hasSelectedAllAssignments = true;
      } else {
        var assignmentsById = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["keyBy"])(this.assignmentsBySubjects[this.selectedSubjectId], 'id');

        this.selectedAssignmentList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(selectedList, function (id) {
          return assignmentsById[id];
        });
        this.hasSelectedAllAssignments = false;
      }

      this.selectAssignmentModalIsShown = false;
    }
  }),

  watch: {
    selectedSubjectId: function selectedSubjectId(subjectId) {
      this.selectedAssignmentList = this.assignmentsBySubjects[subjectId] || [];
      this.hasSelectedAllAssignments = true;
    }
  },

  created: function created() {
    var _this19 = this;

    this.loading = true;
    var classId = this.$route.params.class_id;

    this.cls = this.managingClasses[classId];

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.cls)) {
      this.fetchClassStudents(this.cls.id).then(function (studentList) {
        if (!studentList || studentList.length === 0) {
          return _this19.syncClassStudents(_this19.cls.id);
        }

        return studentList;
      }).then(function (studentList) {
        _this19.studentList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"])(studentList, function (student) {
          return student.number || 9999;
        }, 'asc');
        _this19.students = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["keyBy"])(_this19.studentList, 'student_id');
      }).then(function () {
        _this19.setLibrartFilter({ property: 'grade_id', value: _this19.cls.grade });
      }).then(function () {
        return _this19.fetchTeacherAssignmentStats({ class_id: classId }).then(function (assignmentStats) {
          _this19.assignmentStats = assignmentStats;

          return assignmentStats;
        });
      }).then(function (assignmentStats) {
        return _this19.fetchClassAssignments({ class_id: classId, per_page: assignmentStats.total_count });
      }).then(function (assignments) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["uniq"])(assignments.filter(function (assignment) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(assignment.assigned_card.subject_id) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(assignment.assigned_card.grade_id);
        }).map(function (assignment) {
          return assignment.assigned_card.subject_id + '&' + assignment.assigned_card.grade_id;
        })).map(function (subjectGrade) {
          var _subjectGrade$split = subjectGrade.split('&'),
              _subjectGrade$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_subjectGrade$split, 2),
              subjectId = _subjectGrade$split2[0],
              gradeId = _subjectGrade$split2[1];

          return _this19.fetchUnits({
            subject_id: subjectId,
            grade_id: gradeId
          });
        })).then(function () {
          return assignments;
        });
      }).then(function (assignments) {
        _this19.assignments = assignments;
      }).then(function () {
        _this19.assignments.forEach(function (assignment) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(_this19.assignmentsBySubjects[assignment.assigned_card.subject_id])) {
            _this19.assignmentsBySubjects[assignment.assigned_card.subject_id] = [];
            _this19.submissionsBySubjects[assignment.assigned_card.subject_id] = [];
          }

          _this19.assignmentsBySubjects[assignment.assigned_card.subject_id].push(assignment);

          assignment.submissions.forEach(function (submission) {
            _this19.submissionsBySubjects[assignment.assigned_card.subject_id].push(submission);
            _this19.allSubmissions.push(submission);

            if (_this19.students[submission.student_id]) {
              if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(_this19.students[submission.student_id].submissions)) {
                _this19.students[submission.student_id].submissions = [];
              }

              _this19.students[submission.student_id].submissions.push(submission);
            }
          });
        });

        _this19.subjectIds.forEach(function (subjectId) {
          _this19.averageScoreBySubjects[subjectId] = _this19.getAverageScore(_this19.submissionsBySubjects[subjectId]) || 0;
          _this19.diffScoreBySubjects[subjectId] = _this19.averageScoreBySubjects[subjectId] - _this19.getAverageScore(_this19.getSubmissionsUntilLastWeek(_this19.submissionsBySubjects[subjectId]));

          _this19.averageDurationBySubjects[subjectId] = _this19.getAverageDuration(_this19.submissionsBySubjects[subjectId]);
          _this19.diffDurationBySubjects[subjectId] = _this19.averageDurationBySubjects[subjectId] - _this19.getAverageDuration(_this19.getSubmissionsUntilLastWeek(_this19.submissionsBySubjects[subjectId]));

          _this19.averageSubmitrateBySubjects[subjectId] = _this19.getCompleteRate(_this19.submissionsBySubjects[subjectId]);
          _this19.diffSubmitrateBySubjects[subjectId] = _this19.averageSubmitrateBySubjects[subjectId] - _this19.getCompleteRate(_this19.getSubmissionsUntilLastWeek(_this19.submissionsBySubjects[subjectId]));
        });
      }).then(function () {
        if (_this19.getRouteQuery.subject_id) {
          _this19.selectedSubjectId = Number(_this19.getRouteQuery.subject_id);
        } else {
          _this19.selectedSubjectId = _this19.subjectIds[0];
        }
        _this19.setLibrartFilter({ property: 'subject_id', value: _this19.selectedSubjectId });

        _this19.selectedAssignmentList = _this19.assignmentsBySubjects[_this19.selectedSubjectId];
        _this19.hasSelectedAllAssignments = true;

        _this19.loading = false;
      }).catch(function (err) {
        _this19.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
      });
    } else {
      this.loading = false;
      this.$root.$emit('show::modal', 'basic-error-alert');
    }
  }
});

/***/ }),

/***/ "j1rw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  myQuizzes: [],
  quiz: {}
});

/***/ }),

/***/ "j3Pa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorToolbar_vue__ = __webpack_require__("q7yG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b57aa4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorToolbar_vue__ = __webpack_require__("t1lr");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b57aa4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/EditorToolbar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b57aa4e", Component.options)
  } else {
    hotAPI.reload("data-v-6b57aa4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jCu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function duration(rawDuration) {
  if (!rawDuration) {
    return '-';
  }

  var minutes = parseInt(rawDuration / 60, 10);
  minutes = minutes > 9 ? minutes : '0' + minutes;
  var seconds = rawDuration % 60;
  seconds = seconds > 9 ? seconds : '0' + seconds;

  return minutes + ':' + seconds;
}

/* harmony default export */ __webpack_exports__["a"] = (duration);

/***/ }),

/***/ "jPcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imageList
    ? _c(
        "section",
        { staticClass: "image-carousel" },
        [
          _c(
            "carousel",
            {
              attrs: {
                "per-page": 1,
                "pagination-active-color": "#00c896",
                "pagination-color": "rgba(0, 0, 0, 0.1)",
                "pagination-padding": 6,
                "pagination-size": 10,
                "autoplay-timeout": 3000,
                loop: true,
                "autoplay-hover-pause": true,
                autoplay: true
              }
            },
            _vm._l(_vm.imageList, function(image, index) {
              return _c("slide", { key: index }, [
                _c("img", { staticClass: "img-fluid", attrs: { src: image } })
              ])
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3772825b", esExports)
  }
}

/***/ }),

/***/ "jT7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-content" }, [
    _c("div", { staticClass: "footer-box text-center" }, [
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [_vm._v("\n      " + _vm._s(_vm.$t("footer.brand")) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass:
                "typography--body-3 typography--color-secondary passive-link-btns clickable",
              on: {
                click: function($event) {
                  return _vm.$root.$emit("show::modal", "terms-policy-modal")
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("footer.terms")) + "\n      ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass:
                "typography--body-3 typography--color-secondary passive-link-btns clickable",
              on: {
                click: function($event) {
                  return _vm.$root.$emit("show::modal", "privacy-policy-modal")
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("footer.privacy")) + "\n      "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass:
                "typography--body-3 typography--color-secondary passive-link-btns clickable",
              on: {
                click: function($event) {
                  return _vm.$root.$emit(
                    "show::modal",
                    "operation-policy-modal"
                  )
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("footer.operation")) + "\n      "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass: "typography--body-3 typography--color-secondary",
              attrs: {
                href:
                  "http://support.classting.com/hc/ko/sections/115000081194-%ED%81%B4%EB%9E%98%EC%8A%A4%ED%8C%85-%EB%9F%AC%EB%8B%9D-%EC%82%AC%EC%9A%A9%EB%B2%95",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("footer.support")) + "\n      "
              )
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("PolicyModal", {
          attrs: {
            id: "terms-policy-modal",
            title: _vm.$t("footer.terms"),
            "policy-id": "terms"
          }
        }),
        _vm._v(" "),
        _c("PolicyModal", {
          attrs: {
            id: "privacy-policy-modal",
            title: _vm.$t("footer.privacy"),
            "policy-id": "privacy"
          }
        }),
        _vm._v(" "),
        _c("PolicyModal", {
          attrs: {
            id: "operation-policy-modal",
            title: _vm.$t("footer.operation"),
            "policy-id": "operation"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98417144", esExports)
  }
}

/***/ }),

/***/ "jd7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchVideoCourseList"] = fetchVideoCourseList;
/* harmony export (immutable) */ __webpack_exports__["fetchUnitList"] = fetchUnitList;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoCourse"] = fetchVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["createNewVideoCourse"] = createNewVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["updateVideoCourse"] = updateVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["updateVideoCourseLecturesShareLevel"] = updateVideoCourseLecturesShareLevel;
/* harmony export (immutable) */ __webpack_exports__["removeVideoCourse"] = removeVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["setCoreConceptVideoCoursesInStore"] = setCoreConceptVideoCoursesInStore;
/* harmony export (immutable) */ __webpack_exports__["setUnitsWithCoreConceptsInStore"] = setUnitsWithCoreConceptsInStore;
/* harmony export (immutable) */ __webpack_exports__["setVideoCoursesInStore"] = setVideoCoursesInStore;
/* harmony export (immutable) */ __webpack_exports__["removeVideoCourseInStore"] = removeVideoCourseInStore;
/* harmony export (immutable) */ __webpack_exports__["createCoreConceptVideoCourse"] = createCoreConceptVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["fetchCoreConceptVideoCourses"] = fetchCoreConceptVideoCourses;
/* harmony export (immutable) */ __webpack_exports__["updateCoreConceptVideoCourse"] = updateCoreConceptVideoCourse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("EXL+");






function fetchVideoCourseList(_ref, params) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-courses', { params: params }).then(function (res) {
    return res.data;
  }).then(function (videoCourses) {
    return dispatch('fetchUnitList', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(videoCourses, 'id')).then(function () {
      return videoCourses;
    });
  }).then(function (videoCourses) {
    return dispatch('setVideoCoursesInStore', videoCourses);
  }).catch(function (err) {
    console.error('err while fetching video courses:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchUnitList(_ref2, videoCourseIds) {
  var dispatch = _ref2.dispatch;

  if (videoCourseIds.length === 0) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
  }

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/core_concept_video_courses', { params: { video_course_ids: videoCourseIds } }).then(function (res) {
    return res.data;
  }).then(function (coreConceptVideoCourses) {
    return dispatch('setCoreConceptVideoCoursesInStore', coreConceptVideoCourses);
  }).then(function (coreConceptVideoCourses) {
    var coreConceptIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(coreConceptVideoCourses, 'core_concept_id');
    if (coreConceptIds.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
    }
    return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/units', { params: { core_concept_ids: coreConceptIds } }).then(function (res) {
      return res.data;
    }).then(function (units) {
      return dispatch('setUnitsWithCoreConceptsInStore', units);
    });
  }).catch(function (err) {
    console.error('err while fetching units:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchVideoCourse(_ref3, courseId) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-courses/' + courseId).then(function (res) {
    return res.data;
  }).then(function (videoCourse) {
    return dispatch('setVideoCoursesInStore', [videoCourse]);
  }).catch(function (err) {
    console.error('err while fetching video course by ID:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createNewVideoCourse(_ref4, params) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-courses', params).then(function (res) {
    return res.data;
  }).then(function (videoCourse) {
    return dispatch('fetchVideoCourse', videoCourse.id);
  }).catch(function (err) {
    console.error('err while creating a new video course:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateVideoCourse(_ref5, params) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-courses/' + params.id, params).then(function (res) {
    return res.data;
  }).then(function () {
    return dispatch('fetchVideoCourse', params.id);
  }).catch(function (err) {
    console.error('err while updating a video course:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateVideoCourseLecturesShareLevel(_ref6, params) {
  var dispatch = _ref6.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-courses/' + params.id + '/share-levels', params).then(function () {
    return dispatch('clearVideoLecturesInStore');
  }).catch(function (err) {
    console.error('err while updating video course lectures share level:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeVideoCourse(_ref7, courseId) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-courses/' + courseId).then(function (res) {
    return res.data;
  }).then(function () {
    return dispatch('removeVideoCourseInStore', courseId);
  }).catch(function (err) {
    console.error('err while removing a video course:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setCoreConceptVideoCoursesInStore(_ref8, coreConceptVideoCourses) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CORE_CONCEPT_VIDEO_COURSES, coreConceptVideoCourses);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(coreConceptVideoCourses);
}

function setUnitsWithCoreConceptsInStore(_ref9, units) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_UNITS_WITH_CORE_CONCEPTS, units);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(units);
}

function setVideoCoursesInStore(_ref10, videoCourses) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_VIDEO_COURSES, videoCourses);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(videoCourses);
}

function removeVideoCourseInStore(_ref11, courseId) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_VIDEO_COURSE, courseId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(courseId);
}

function createCoreConceptVideoCourse(_ref12, data) {
  var commit = _ref12.commit;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/core_concept_video_courses', data).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CORE_CONCEPT_VIDEO_COURSE, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchCoreConceptVideoCourses(_ref13, params) {
  var commit = _ref13.commit;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/core_concept_video_courses', { params: params }).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_CORE_CONCEPT_VIDEO_COURSES, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateCoreConceptVideoCourse(_ref14, data) {
  var commit = _ref14.commit;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].put(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/core_concept_video_courses/' + data.id, data).then(function (res) {
    return commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].UPDATE_CORE_CONCEPT_VIDEO_COURSE, res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

/***/ }),

/***/ "jlG8":
/***/ (function(module, exports) {

module.exports = {"Play":"Воспроизвести","Pause":"Приостановить","Current Time":"Текущее время","Duration Time":"Продолжительность","Remaining Time":"Оставшееся время","Stream Type":"Тип потока","LIVE":"ОНЛАЙН","Loaded":"Загрузка","Progress":"Прогресс","Fullscreen":"Полноэкранный режим","Non-Fullscreen":"Неполноэкранный режим","Mute":"Без звука","Unmute":"Со звуком","Playback Rate":"Скорость воспроизведения","Subtitles":"Субтитры","subtitles off":"Субтитры выкл.","Captions":"Подписи","captions off":"Подписи выкл.","Chapters":"Главы","You aborted the media playback":"Вы прервали воспроизведение видео","A network error caused the media download to fail part-way.":"Ошибка сети вызвала сбой во время загрузки видео.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Невозможно загрузить видео из-за сетевого или серверного сбоя либо формат не поддерживается.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Воспроизведение видео было приостановлено из-за повреждения либо в связи с тем, что видео использует функции, неподдерживаемые вашим браузером.","No compatible source was found for this media.":"Совместимые источники для этого видео отсутствуют."}

/***/ }),

/***/ "jt7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'basic-modal',

  props: {
    id: String,
    title: String,
    okTitle: {
      type: String,
      default: null
    },
    closeTitle: {
      type: String,
      default: null
    }
  },

  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "k/oC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_CHECKED_TUTORIALS = 'tutorials/SET_CHECKED_TUTORIALS';
var CHECK_TUTORIAL = 'tutorials/CHECK_TUTORIAL';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CHECKED_TUTORIALS: SET_CHECKED_TUTORIALS,
  CHECK_TUTORIAL: CHECK_TUTORIAL
});

/***/ }),

/***/ "k0lw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_SELECTED_CLASS_EVALUATION_DOMAINS = 'evaluations/SET_SELECTED_CLASS_EVALUATION_DOMAINS';
var SET_CLASS_EVALUATION_DOMAINS = 'evaluations/SET_CLASS_EVALUATION_DOMAINS';
var SET_EVALUATION_ORDER_BY = 'evaluations/SET_EVALUATION_ORDER_BY';
var SET_EVALUATION_CRITERIA = 'evaluations/SET_EVALUATION_CRITERIA';
var SET_EVALUATION_FILTER = 'evaluations/SET_EVALUATION_FILTER';
var SET_EVALUATION_LIST = 'evaluations/SET_EVALUATION_LIST';
var SET_EVALUATION = 'evaluations/SET_EVALUATION';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SELECTED_CLASS_EVALUATION_DOMAINS: SET_SELECTED_CLASS_EVALUATION_DOMAINS,
  SET_CLASS_EVALUATION_DOMAINS: SET_CLASS_EVALUATION_DOMAINS,
  SET_EVALUATION_ORDER_BY: SET_EVALUATION_ORDER_BY,
  SET_EVALUATION_CRITERIA: SET_EVALUATION_CRITERIA,
  SET_EVALUATION_FILTER: SET_EVALUATION_FILTER,
  SET_EVALUATION_LIST: SET_EVALUATION_LIST,
  SET_EVALUATION: SET_EVALUATION
});

/***/ }),

/***/ "k4Nh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k8Lu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kBv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



var needAuth = function needAuth(auth) {
  return auth === true;
};
var needTeacherRole = function needTeacherRole(teacherRole) {
  return teacherRole === true;
};

function beforeEachRoutes(router) {
  router.beforeEach(function (to, from, next) {
    var auth = to.meta.requiresAuth;
    var teacherRole = to.meta.requiresTeacherRole;

    if (from.query.parent_ids) {
      to.query.parent_ids = from.query.parent_ids;
    }

    if (from.query.source) {
      to.query.source = from.query.source;
    }


    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('checkUserToken').then(function () {
      if (needTeacherRole(teacherRole)) {
        var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.currentUser;

        if (user.role === 'teacher') {
          next();
        } else {
          next({
            name: 'errors.forbidden'
          });
        }
      } else {
        next();
      }
    }).catch(function () {
      if (needAuth(auth)) {
        if (to.query && to.query.source === 'classting') {
          next({
            path: '/mobile_callback/classting?continue_url=' + encodeURIComponent(to.fullPath),
            replace: true
          });
        } else {
          sessionStorage.setItem('continue_url', to.fullPath);
          window.location.href = __WEBPACK_IMPORTED_MODULE_0__config__["e" /* CLASSTING_FULL_AUTH_URL */];
        }
      } else {
        next();
      }
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (beforeEachRoutes);

/***/ }),

/***/ "kCuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCourseList_vue__ = __webpack_require__("VJrM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084694d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCourseList_vue__ = __webpack_require__("TX5r");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCourseList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084694d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCourseList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-courses/views/VideoCourseList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-084694d3", Component.options)
  } else {
    hotAPI.reload("data-v-084694d3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kdnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__("kl7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_publisherOnly__ = __webpack_require__("vWCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CoverImageEditModal__ = __webpack_require__("GFai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ChapterEditModal__ = __webpack_require__("+4uU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SeriesEditModal__ = __webpack_require__("LF/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChapterView__ = __webpack_require__("lXSw");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'series-cards',

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_publisherOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */]],

  components: {
    CoverImageEditModal: __WEBPACK_IMPORTED_MODULE_7__components_CoverImageEditModal__["a" /* default */],
    ChapterEditModal: __WEBPACK_IMPORTED_MODULE_8__components_ChapterEditModal__["a" /* default */],
    SeriesEditModal: __WEBPACK_IMPORTED_MODULE_9__components_SeriesEditModal__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    ChapterView: __WEBPACK_IMPORTED_MODULE_10__components_ChapterView__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false,
      seriesItem: null,
      visibleChapterIndex: -1,
      chapterEditModalIsShown: false,
      seriesEditModalIsShown: false,
      coverImageEditModalIsShown: false,
      chapterForEdit: null,
      cardIdForRemoveFromSeries: null,
      cardIdForRemove: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['currentPublisherInfo', 'chaptersBySeriesId', 'cardsByChapterId', 'subjectMap', 'gradeMap', 'series']), {
    publisherId: function publisherId() {
      return this.currentPublisherInfo.id;
    },
    chapters: function chapters() {
      var seriesId = this.$route.params.series_id;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(this.chaptersBySeriesId[seriesId], 'position');
    },
    subjectName: function subjectName() {
      return this.getSubjectLabel(this.seriesItem);
    },
    gradeName: function gradeName() {
      return this.getGradeLabel(this.seriesItem);
    },
    seriesTitle: function seriesTitle() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return '';
      }

      return this.gradeName + ' ' + this.subjectName + ': ' + this.seriesItem.name;
    },
    seriesPrice: function seriesPrice() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return 0;
      }

      return this.seriesItem.price || 0;
    },
    seriesCardPrice: function seriesCardPrice() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return 0;
      }

      return this.seriesItem.card_price || 0;
    },
    seriesShareLevel: function seriesShareLevel() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.seriesItem)) {
        return 0;
      }

      return this.seriesItem.share_level;
    },
    visibleChapters: function visibleChapters() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.chapters)) {
        return [];
      }

      return this.chapters.slice(0, this.visibleChapterIndex + 1);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['removeCardFromSeries', 'removePublisherCard', 'fetchSeriesChapters', 'fetchChapterCards', 'fetchSeriesById', 'removeSeries']), {
    openChapterEditModal: function openChapterEditModal(chapter) {
      this.chapterForEdit = chapter;
      this.chapterEditModalIsShown = true;
    },
    openRemoveFromSeriesModal: function openRemoveFromSeriesModal(cardId) {
      this.cardIdForRemoveFromSeries = cardId;
      this.$root.$emit('show::modal', 'remove-from-series-modal');
    },
    openRemoveCardModal: function openRemoveCardModal(cardId) {
      this.cardIdForRemove = cardId;
      this.$root.$emit('show::modal', 'remove-card-modal');
    },
    resetChapterForEdit: function resetChapterForEdit() {
      this.chapterEditModalIsShown = false;
      this.chapterForEdit = null;
    },
    resetCardIdForRemoveFromSeries: function resetCardIdForRemoveFromSeries() {
      this.cardIdForRemoveFromSeries = null;
    },
    resetCardIdForRemove: function resetCardIdForRemove() {
      this.cardIdForRemove = null;
    },
    updateSeriesItem: function updateSeriesItem() {
      this.seriesEditModalIsShown = false;
      this.coverImageEditModalIsShown = false;
      this.seriesItem = this.series[this.seriesItem.id];
    },
    remove: function remove() {
      var _this = this;

      this.removeSeries(this.seriesItem.id).then(function () {
        return _this.$router.replace('/publishers/series');
      });
    },
    removeFromSeries: function removeFromSeries() {
      if (this.cardIdForRemoveFromSeries) {
        var params = {
          series_id: this.seriesItem.id,
          card_id: this.cardIdForRemoveFromSeries
        };

        this.removeCardFromSeries(params);
      }
    },
    removeCard: function removeCard() {
      if (this.cardIdForRemove) {
        this.removePublisherCard(this.cardIdForRemove);
      }
    },
    onInfinite: function onInfinite() {
      var _this2 = this;

      var nextChapter = this.chapters[this.visibleChapterIndex + 1];

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(nextChapter)) {
        return this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
      }

      return this.fetchChapterCards(nextChapter.id).then(function () {
        _this2.visibleChapterIndex += 1;
        _this2.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this3 = this;

    this.loading = true;

    var seriesId = this.$route.params.series_id;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.series)) {
        return _this3.fetchSeriesById(seriesId);
      }

      return true;
    }).then(function () {
      _this3.seriesItem = _this3.series[seriesId];

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(_this3.seriesItem)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Series not found');
      }

      return true;
    }).then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.chapters)) {
        return _this3.fetchSeriesChapters(seriesId);
      }

      return true;
    }).then(function () {
      return _this3.chapters.forEach(function (chapter, i) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(_this3.cardsByChapterId[chapter.id])) {
          _this3.visibleChapterIndex = i;
        }
      });
    }).then(function () {
      _this3.loading = false;
    });
  }
});

/***/ }),

/***/ "kg9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kl7r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shareLevelKeys: {
        1: 'common.card.share_level.public',
        2: 'common.card.share_level.private'
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['subjectMap', 'gradeMap'])),

  methods: {
    getCoreConceptLabel: function getCoreConceptLabel(coreConcept) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(coreConcept) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(coreConcept)) {
        return null;
      }

      return coreConcept.name;
    },
    getDetailedCoreConceptLabel: function getDetailedCoreConceptLabel(coreConcept) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(coreConcept) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(coreConcept)) {
        return null;
      }

      return coreConcept.name + ' (' + coreConcept.description + ')';
    },
    getSchoolYear: function getSchoolYear(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'school_year', 0);
    },
    getName: function getName(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'name');
    },
    getTranslatedName: function getTranslatedName(item) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["has"])(item, 'id')) {
        return this.getName(item);
      }

      return this.$t(this.getName(item));
    },
    getSubjectLabel: function getSubjectLabel(item) {
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'subject.name');

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(name)) {
        return this.getName(this.subjectMap[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'subject_id')]);
      }

      return name;
    },
    getGradeLabel: function getGradeLabel(item) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(item)) {
        return this.getTranslatedName(this.gradeMap[item]);
      }

      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'grade.name');

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(name)) {
        return this.getTranslatedName(this.gradeMap[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'grade_id')]);
      }

      return name;
    },
    getGradeSchoolYear: function getGradeSchoolYear(item) {
      var grade = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'grade') || this.gradeMap[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(item, 'grade_id')];

      return this.getSchoolYear(grade);
    },
    getUnitLabel: function getUnitLabel(unit) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(unit) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(unit)) {
        return null;
      }

      return unit.name;
    },
    getDomainLabel: function getDomainLabel(domain) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(domain) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(domain)) {
        return null;
      }

      return domain.name;
    },
    getShareLevelLabel: function getShareLevelLabel(shareLevel) {
      if (shareLevel === 1 || shareLevel === 2) {
        return this.$t(this.shareLevelKeys[shareLevel]);
      }

      return '-';
    }
  }
});

/***/ }),

/***/ "klwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__("39Ul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("ZzLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("+TP4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("nk1q");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "ksQV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kwSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_lectures_views_VideoLectureDetails__ = __webpack_require__("OBYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__video_lectures_views_UploadVideoLecture__ = __webpack_require__("/8gj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__video_lectures_views_EditVideoLecture__ = __webpack_require__("nDej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_VideoCourseDetails__ = __webpack_require__("8iHU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_VideoCourseList__ = __webpack_require__("kCuy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_EditVideoCourse__ = __webpack_require__("RKoN");







var router = [{
  name: 'videoCourses.videoCourseList',
  path: '/video-courses',
  component: __WEBPACK_IMPORTED_MODULE_4__views_VideoCourseList__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.newVideoCourse',
  path: '/new-video-course',
  component: __WEBPACK_IMPORTED_MODULE_5__views_EditVideoCourse__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.videoCourseDetails',
  path: '/video-courses/:course_id',
  component: __WEBPACK_IMPORTED_MODULE_3__views_VideoCourseDetails__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.editVideoCourse',
  path: '/video-courses/:course_id/edit',
  component: __WEBPACK_IMPORTED_MODULE_5__views_EditVideoCourse__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.videoLectureDetails',
  path: '/video-courses/:course_id/lectures/:lecture_id',
  component: __WEBPACK_IMPORTED_MODULE_0__video_lectures_views_VideoLectureDetails__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.uploadVideoLecture',
  path: '/video-courses/:course_id/upload-video-lecture',
  component: __WEBPACK_IMPORTED_MODULE_1__video_lectures_views_UploadVideoLecture__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.newVideoLecture',
  path: '/video-courses/:course_id/new-video-lecture',
  component: __WEBPACK_IMPORTED_MODULE_2__video_lectures_views_EditVideoLecture__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}, {
  name: 'videoCourses.editVideoLecture',
  path: '/video-courses/:course_id/lectures/:lecture_id/edit',
  component: __WEBPACK_IMPORTED_MODULE_2__video_lectures_views_EditVideoLecture__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "kx4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_labels__ = __webpack_require__("kl7r");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-item',

  props: ['index', 'page'],

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['selectedPageIds', 'coreConcepts', 'subjectMap', 'gradeMap']), {
    isSelectedPage: function isSelectedPage() {
      return this.selectedPageIds.indexOf(this.page.id) !== -1;
    },
    selectedPageBindings: function selectedPageBindings() {
      return {
        'selected-page': this.isSelectedPage
      };
    },
    pageType: function pageType() {
      if (this.page && this.page.is_quiz) {
        return this.$t('page_editor.question.title');
      }

      return this.$t('page_editor.non_quiz.title');
    },
    hasImage: function hasImage() {
      return this.page.image_count > 0 && this.page.images.length > 0;
    },
    hasAudio: function hasAudio() {
      return this.page.audio_count > 0 && this.page.audios.length > 0;
    },
    hasVideo: function hasVideo() {
      return this.page.video_count > 0 && this.page.videos && this.page.videos.length > 0;
    },
    hasEmbededVideo: function hasEmbededVideo() {
      return this.page.content.match(/<iframe/g) || (this.page.description || '').match(/<iframe/g);
    },
    classBindings: function classBindings() {
      return {
        'has-image': this.hasImage,
        'has-audio': this.hasAudio,
        'has-video': this.hasVideo || this.hasEmbededVideo
      };
    },
    firstImageSrc: function firstImageSrc() {
      if (this.hasImage) {
        var imageUrl = this.page.images[0].image_url || this.page.images[0].small_url || this.page.images[0].medium_url || this.page.images[0].original_url;

        return 'url(\'' + imageUrl + '\')';
      }

      return '';
    },
    firstAudioDuration: function firstAudioDuration() {
      if (this.hasAudio) {
        return this.page.audios[0].duration;
      }

      return 0;
    },
    firstVideoDuration: function firstVideoDuration() {
      if (this.hasVideo) {
        return this.page.videos[0].duration;
      }

      return 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'setSelectedPreviewCard', 'removeSelectedPage', 'setIsPagePreview', 'addSelectedPage']), {
    selectPage: function selectPage() {
      if (this.isSelectedPage) {
        return this.removeSelectedPage(this.page.id);
      }

      return this.addSelectedPage(this.page);
    },
    openCardPreview: function openCardPreview() {
      var _this = this;

      var tempCard = {
        title: this.page.card_title,
        pages: [this.page]
      };

      this.setSelectedPreviewCard(tempCard).then(function () {
        return _this.setSelectedPreviewPageIndex(0);
      }).then(function () {
        return _this.setIsPagePreview(true);
      }).then(function () {
        _this.$root.$emit('show::modal', 'card-preview-modal');
      });
    }
  })
});

/***/ }),

/***/ "l8k1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal new-series-modal",
      attrs: {
        id: "new-series-modal",
        "ok-disabled": _vm.newSeriesDisabled,
        "ok-busy": _vm.busy
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.create()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "new-series-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.new_series.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new-series-modal__form" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "subject-select" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.modal.new_series.subject")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected.subjectId,
                  expression: "selected.subjectId"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "subject-select" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.selected,
                    "subjectId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { disabled: "", value: "" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("publishers.modal.new_series.subject_placeholder")
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.subjectIds.filter(function(id) {
                  return id !== "0" && id !== "9999"
                }),
                function(sjId) {
                  return _c(
                    "option",
                    { key: sjId, domProps: { value: sjId } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getTranslatedName(_vm.subjectMap[sjId])) +
                          "\n        "
                      )
                    ]
                  )
                }
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "grade-select" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.modal.new_series.grade")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected.gradeId,
                  expression: "selected.gradeId"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "grade-select" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.selected,
                    "gradeId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { disabled: "", value: "" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("publishers.modal.new_series.grade_placeholder")
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.gradeIds.filter(function(id) {
                  return id !== "0" && id !== "9999"
                }),
                function(gId) {
                  return _c("option", { key: gId, domProps: { value: gId } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getTranslatedName(_vm.gradeMap[gId])) +
                        "\n        "
                    )
                  ])
                }
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "typography--body-3 typography--color-secondary typography--font-weight-600",
              attrs: { for: "series-title-input" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.seriesTitle,
                expression: "seriesTitle"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "series-title-input",
              placeholder: _vm.$t(
                "publishers.modal.new_series.name_placeholder"
              )
            },
            domProps: { value: _vm.seriesTitle },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.seriesTitle = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showChapterSelect,
                expression: "showChapterSelect"
              }
            ],
            staticClass: "form-group"
          },
          [
            _c(
              "label",
              {
                staticClass:
                  "typography--body-3 typography--color-secondary typography--font-weight-600",
                attrs: { for: "chapter-count-select" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("publishers.modal.new_series.unit")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selected.chapterCount,
                    expression: "selected.chapterCount"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "chapter-count-select" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.selected,
                      "chapterCount",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("publishers.modal.new_series.unit_placeholder")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _vm._l(20, function(n) {
                  return _c("option", { key: n, domProps: { value: n } }, [
                    _vm._v("\n          " + _vm._s(n) + "\n        ")
                  ])
                })
              ],
              2
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a979744", esExports)
  }
}

/***/ }),

/***/ "lBJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("rfSt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("95k5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("jd7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("AgwV");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "lH8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingMainV3_vue__ = __webpack_require__("5QD0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58196e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingMainV3_vue__ = __webpack_require__("Yskx");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("P9CW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingMainV3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58196e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingMainV3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LandingMainV3.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d58196e6", Component.options)
  } else {
    hotAPI.reload("data-v-d58196e6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lLtv":
/***/ (function(module, exports) {

module.exports = {"Play":"Lejátszás","Pause":"Szünet","Current Time":"Aktuális időpont","Duration Time":"Hossz","Remaining Time":"Hátralévő idő","Stream Type":"Adatfolyam típusa","LIVE":"ÉLŐ","Loaded":"Betöltve","Progress":"Állapot","Fullscreen":"Teljes képernyő","Non-Fullscreen":"Normál méret","Mute":"Némítás","Unmute":"Némítás kikapcsolva","Playback Rate":"Lejátszási sebesség","Subtitles":"Feliratok","subtitles off":"Feliratok kikapcsolva","Captions":"Magyarázó szöveg","captions off":"Magyarázó szöveg kikapcsolva","Chapters":"Fejezetek","You aborted the media playback":"Leállította a lejátszást","A network error caused the media download to fail part-way.":"Hálózati hiba miatt a videó részlegesen töltődött le.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"A videó nem tölthető be hálózati vagy kiszolgálói hiba miatt, vagy a formátuma nem támogatott.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"A lejátszás adatsérülés miatt leállt, vagy a videó egyes tulajdonságait a böngészője nem támogatja.","No compatible source was found for this media.":"Nincs kompatibilis forrás ehhez a videóhoz."}

/***/ }),

/***/ "lRsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Kj51");




var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_ADVERTISEMENT, function (state, value) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'advertisement', value);
});

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "lX4D":
/***/ (function(module, exports) {

module.exports = {"brand":{"name":"러닝+"},"header":{"nav_menu":{"reports":"과제 결과","my_cards":"내가 만든 학습 자료","library":"추천 학습 자료실","evaluations":"종합 의견","publishers":"퍼블리셔","video_lectures":"영상강의"}},"common":{"preview":"미리보기","loading":"로딩중","assign":"과제로 내보내기","cancel":"취소","save":"저장","close":"닫기","add":"추가하기","previous":"이전","next":"다음","confirm":"확인","show_description":"해설 보기","browse_filters":{"in_progress":"진행 과제","past_assignments":"완료 과제","search_placeholder":"검색어를 입력하세요","all_subjects":"전체 과목","all_grades":"전체 학년","all_chapters":"전체 단원","media_type":{"all":"전체","image":"이미지","audio":"오디오","video":"동영상"},"order_by":{"popularity":"인기순","title":"제목순","recency":"최신순"},"all_core_concepts":"전체 핵심개념"},"modal":{"remove":{"title":"삭제","message":"정말 삭제하시겠습니까?"},"assign":{"title":"과제로 내보내기","message":"카드를 내보내기 전에 저장해야합니다.<br>현재 내용을 저장하시겠습니까?"},"status":{"title":"과제 상태 보기","assign_more":"추가 할당","assigned_classes":"과제 낸 클래스","assigned_period":"과제 기간","is_active":"할당 중","is_inactive":"종료됨"},"make_public":{"title":"학습 자료실에 공개","message":"학습 자료를 공개하기 전에 저장해야합니다.<br>변경된 내용을 저장하시겠습니까?"},"close_assignment":{"title":"과제 종료","message":"해당 과제의 종료일은 {date} 입니다.<br>선택한 과제를 지금 종료하시겠습니까?"},"file_size_alert":{"message":"이미지 파일 업로드가 실패하였습니다. 이미지 파일은 10MB까지 업로드할 수 있습니다."},"file_type_alert":{"message":"이미지 파일 업로드가 실패하였습니다. 이미지 파일은 JPG, JPEG, PNG 확장자를 가진 파일만 업로드할 수 있습니다."},"preview":{"show_solution":"해설 보기","class_average_score":"반 평균 정답률","count":"명","is_incorrect":"오답입니다.","is_correct":"정답입니다.","no_pages":"표시할 페이지가 없습니다.","correct_answer":"정답","answer_number":"{n}번","chosen_answer":"선택한 답","entered_answer":"입력한 답","score_input":"점수 입력","grading_keywords":"핵심 키워드","no_grading_keywords":"설정된 핵심 키워드가 없습니다.","no_submitted_answer":"제출된 답변이 없습니다.","feedback_input":"해설 입력","feedback_placeholder":"해설을 입력해주세요.","use_default_description":"개별 피드백 입력","submitted_answer":"입력한 답","score":"점수","report_content":"오류 신고","edit_assignment":"과제수정"},"no_class_to_assign_alert":{"message":"관리자로 있는 클래스가 없습니다. 클래스를 개설 후 다시 시도해주세요."},"welcome_msg":{"title":"효과적인 수업 준비와 학습 활동,<br>이제 클래스팅 러닝과 함께 하세요.","body_1":"수업자료를 찾거나 새로 만들 수 있습니다.","body_2":"클래스에 과제로 내고 결과를 취합할 수 있습니다.","body_3":"학생들의 성취도를 비교 분석할 수 있습니다.","start":"시작하기"},"empty_card_info":{"message":"정보를 모두 입력한 후 과제로 낼 수 있습니다."},"assignments_init":{"title":"학습 결과 초기화","desc":"기존 정답률, 학습 시간 등 학습 결과가 초기화됩니다.\n다시 학습하시겠습니까?"},"assignments_end":{"title":"과제 종료","desc":"{date} 과제가 종료되었습니다"},"make_private":{"title":"공개 취소","message":"자료 공개를 취소하시겠습니까?"},"page_leave_alert":{"message":"변경된 내용을 저장하지 않고 페이지를 이동하겠습니까?"},"change_due_date":{"title":"과제일 수정"},"assignments_only_students":{"title":"문제 풀이 안내","desc":"계정이 학생인 경우만 문제풀기가 가능합니다."},"math_editor":{"title":"수식 입력하기","tabs":{"basic":"기본 수식","geometry":"도형 수식","etc":"기타"}},"basic_error_alert":{"message":"알 수 없는 오류로 요청한 작업을 수행하지 못했습니다. 문제가 계속 발생하면 클래스팅 고객센터로 문의주세요."},"card_not_purchased_alert":{"message":"아직 구매하지 않은 카드입니다. 먼저 구매 후 이용해주시기 바랍니다."},"asmt_events":{"title":"러닝과제 만들고 쿠폰받자!<br>이벤트 참여가 완료되었습니다.","message":"이벤트 쿠폰으로 우리반 학생들의 스토어 콘텐츠 학습이 가능합니다.<br>\n쿠폰 나눠주기 페이지로 이동하시겠습니까?","ok_title":"쿠폰 나눠주러 가기"},"ask_skip_landing":{"message":"<strong>클래스팅 러닝</strong>으로 이동합니다.","checkbox_label":"현재 페이지 다시 보지 않기"},"add_video":{"title":"동영상 링크 입력","input_placeholder":"Youtube, Vimeo, 네이버 TV 등 동영상 URL을 입력하세요","message":"저작권을 침해하거나 명예를 훼손하는 동영상은 클래스팅 이용약관 및 관련 법률에 의해 제재를 받으실 수 있습니다."},"confirm_assign":{"message":"교사가 직접 만든 문항은 과제 내보내기 후에도 수정이 가능합니다.<br>과제 내보내기를 진행하시겠습니까?"},"remove_assignment":{"title":"과제 삭제","message":"삭제된 과제는 복구되지 않습니다.<br>해당 과제를 정말 삭제하시겠습니까?"},"content_report_success":{"message":"오류 신고 접수가 완료되었습니다."},"report_content":{"title":"오류 신고","options":{"has_error":"과제 내용에 오류가 있습니다.","inappropriate":"과제 내용 중 부적절한 내용이 있습니다."}},"video_type_alert":{"message":"동영상 파일 업로드가 실패하였습니다. 동영상 파일은 MP4, MOV, WMV, AVI, FLV, WebM 확장자를 가진 파일만 업로드할 수 있습니다."},"docx_type_alert":{"message":"문서 파일 업로드가 실패하였습니다. 문서 파일은 DOCX 확장자를 가진 파일만 업로드할 수 있습니다."},"file_reader_unsupported":{"message":"파일 업로드가 지원되지 않는 환경입니다.<br>다른 웹 브라우저에서 시도해주시기 바랍니다."},"audio_size_alert":{"message":"오디오 파일 업로드가 실패하였습니다. 오디오 파일은 20MB까지 업로드할 수 있습니다."},"audio_type_alert":{"message":"오디오 파일 업로드가 실패하였습니다. 오디오 파일은 MP3, WAV, OGG, FLAC 확장자를 가진 파일만 업로드할 수 있습니다."},"confirm_report_content":{"title":"신고 확인","desc":"신고 즉시 클래스팅에 신고내용이 전달됩니다.\n<br />\n신고하시려는 문항에  오류가 있음이 확실한가요?"}},"card":{"menu":{"duplicate":"사본 만들기","remove":"삭제","status":"과제 상태 보기","make_public":"학습 자료실 공개","make_private":"학습 자료실 공개중"},"page":{"edit":"내용 수정","remove":"삭제","description":"해설"},"non_quiz":"본문","quiz":"문제","count":"{cnt}개","share_count":"공유 {cnt}회","updated_at":"최종 수정일","share_level":{"public":"공개됨","private":"비공개"}},"assignment":{"due_date":{"date":"종료일","time":"종료시간","active":"까지","inactive":"에 종료됨"}},"empty":"없음","in_progress":"진행 중","tooltip":{"try_new_my_card":"새로운 학습자료를<br>만들어 보세요","try_add_new_pages":"원하는 본문/문제를<br>추가해보세요","try_select_and_add_pages":"본문/문제를 선택하고<br>학습자료로 추가하세요","try_assign":"과제로 낼 준비가<br>모두 완료되었습니다","try_set_due_date":"과제 설명을 입력하고<br>종료일을 설정해주세요","try_check_class":"클래스에서 직접<br>확인해보세요","try_custom_card":"선생님들이 직접 만든 자료를<br>이용해보세요."},"change":"변경","complete":"완료","page_types":{"multiple_choice":"객관식 문제","text_entry":"단답형 문제","non_quiz":"본문 내용","essay_type":"서술형 문제"},"learning_elements":"학습요소","numeric_score":"{n}점","optional":"(선택)","complete_grading":"채점 완료","rank":"순위","view_more":"더 보기","view_less":"접기","month":"월","day":"일","time":"시간","wrong_answer":"오답","not_graded":"미채점","minute":"분","numeric_score_suffix":"점","class":"반","student":"학생","count_suffix":"개","edit":"수정","terms":{"like":"빛내기","view_count":"조회수","no_description":"설명 없음","posted_date":"게시일"},"uploading":"업로드 중","video_lectures":{"share_level":{"private":"비공개","public":"전체공개"}},"save_edit":"수정완료","reading_file":"파일 읽는 중","selects":{"all_subjects":"과목 전체","all_grades":"학년 전체","placeholder":"선택","others":"기타"},"empty_country_code":{"text":"클래스팅 웹에서 거주 중인 국가를 설정해주세요.<br />\n새로고침 이후 일부 서비스를 이용할 수 있습니다.","link":"국가 설정하기"},"view_count":"조회수 {view_count}","grade_label":"{grade}학년","detail_view":"상세보기"},"assignments":{"sub_header":{"all_class":"모든 클래스"},"assignment":{"submitted":"제출완료","not_submitted":"미응답","menu":{"edit":"과제 내용 수정","close":"과제 종료","remove":"과제 삭제","preview":"과제 보기"},"completed":"진행 완료"},"no_assignments":"내보낸 과제가 없습니다.<br>과제용 자료를 찾아보거나 직접 만들 수 있습니다."},"new_assignment":{"sub_header":{"title":"클래스에 할당","write":"글쓰기"},"privacy":"공개설정","role":{"teacher":"선생님","student":"학생","parent":"학부모"},"select_topic":"주제 선택","class_picker":"과제를 내보내실 클래스를 선택해주세요.","write":"글쓰기 버튼을 눌러서 클래스에 과제를 올려주세요."},"my_cards":{"sub_header":{"new_my_card":"새 자료 만들기"},"no_cards":"아직 과제가 없습니다.<br>새 자료를 만들고 클래스에 과제로 내보내세요."},"card_details":{"card_meta":{"title_placeholder":"제목을 입력해주세요","subject_placeholder":"과목을 선택해주세요.","grade_placeholder":"학년을 선택해주세요.","chapter_placeholder":"단원을 선택해주세요.","elements_placeholder":"핵심개념을 선택해주세요.","elements_select_placeholder":"준비중입니다.","subject":"과목","grade":"학년","chapter":"단원","elements":"핵심개념","edit":"정보 수정","select":"선택","title":"제목","core_concept":"핵심개념","core_concepts_placeholder":"핵심개념을 선택해주세요.","learning_elements":"학습요소","goal":"학습목표","goal_placeholder":"학습목표를 입력해주세요","video_course":"비디오 코스 아이디"},"import_page":"본문 또는 문제를 추가할 수 있습니다.","create_page":"직접 제작하기","search_page":"학습자료 불러오기","error":{"title_required":"제목을 입력해주세요","title_max_len":"제목은 50자 이상 초과될 수 없습니다"}},"library":{"sub_header":{"store_cards_tab":"출판사","custom_cards_tab":"교사 제작 자료","featured_cards_tab":"칸아카데미","school_cards_tab":"우리학교 교사자료"},"no_cards":"학습 자료가 없습니다.","no_search_cards":"'{keyword}'에 대한 학습 자료가 없습니다"},"page_library":{"selected_count":"{cnt}개 선택됨","no_pages":"과제가 없습니다."},"edit_assignment":{"sub_header":{"title":"과제 내용 수정","update":"완료"}},"reports":{"sub_header":{"assignments_tab":"과제 목록","classes_tab":"클래스 목록","class_ai_reports_tab":"클래스 리포트"},"students_report":"학생별 리포트","assignment_info":"과제 정보","quiz_correct_ratio":"문제별 정답률","learning_result_summary":"과제 결과 요약","learning_result_summary_desc":"반 평균 (전체 평균)","manage_students":"학생 정보 관리","class_name":"클래스","assigner":"게시자","assigned_date":"게시일","go_to_class":"클래스 가기","go_to_card":"수업자료 가기","show_quizzes":"문제 보기","answer_ratio":"정답률","complete_rate":"과제 완료율","average_duration":"평균 학습시간","assignment_result_report":"학습 결과 리포트","go_to_class_report":"클래스 상세 리포트","filters":{"all":"전체","submitted":"제출완료","not_submitted":"미제출"},"student_count":"전체 {cnt}명","table":{"number":"번호","student":"학생","name":"이름","gender":"성별","submitted_date":"제출날짜","correct_count":"정답/문제","score":"성취도","average_score":"평균성취도","average_duration":"평균학습시간","perfect":"(만점:100)","ratio":"백분위","class_over_all":"(반평균/전체)","class_rank":"반 등수","all_rank":"등수/전체(백분위)","duration":"학습시간","complete_rate":"완료율","not_submitted":"제출안함","chapter_name":"단원명","core_concept":"핵심개념","card_name":"과제명","subjects":{"title":"과목","korean":"국어","math":"수학","science":"과학","social":"사회","english":"영어"},"class_avg":"반평균","all_avg":"전체 평균","no_score":"표시할 정보가 없습니다.","learning_elements":"학습요소","need_grading":"채점 필요","thead":{"number":"#","student_id":"아이디","student_name":"이름","is_submitted":"제출","is_graded":"채점","duration":"소요시간","score":"성취도","rank":"순위","non_essay_score":"객관식 점수","essay_score":"서술형 점수","submitted_at":"제출시간","not_submitted":"미제출"}},"gender":{"1":"남","2":"여"},"assignment_count":"총 과제","chapter_results":"단원 진단 결과","key_concept_results":"핵심개념 진단 결과","personal_score":"개인 성취도","avg_class_score":"반 평균 성취도","avg_all_score":"전체 평균 성취도","chapter_count":"총 {cnt}단원","key_concept_count":"총 {cnt}개","all_students":"전체 학생","submission_completed":"제출 완료","not_submitted":"미 제출","class_average":"반 평균","correct_ratio":"과제 정답률","study_time":"과제 학습시간","class_students_report":"클래스 학생 리포트","student_report":"학습 결과 학생 리포트","correct_question":"정답문제","correct_answer":"정답","see_result":"과제 결과 보기","assignment_due_date":"과제 종료일","all_assignments":"모든 과제","assignment_rank":"과제 순위","rank_suffix":"등","manage_class_students":"클래스 학생 관리","subject_study_status":"과목별 학습 현황","all_study_status":"전체 학습 현황","need_help_students":"도움이 필요한 학생","all_students_report":"전체 학생 리포트","go_to_recommend_contents":"추천 학습 자료 보러가기","no_need_help_students":"도움이 필요한 학생이 없습니다.","students_well_following":"학생들이 수업을 잘 따라오고 있어요!","all_students_count":"전체 학생 수","average_score":"평균 점수","submit_assignment":"과제 제출","achievement":"학습 성취도","achievement_trend":"학습 성장률","study_status":"학습활동 현황","last_week_avg_time":"지난 주 평균 학습시간","active_students":"학습활동이 있는 학생","inactive_students":"학습활동이 없는 학생","avg_score":"평균 성취도","no_chapter_name":"단원명 없음","sort_new_assignment":"최근 과제 순","sort_achievement":"성취도 순","assignment_period":"과제기간","assignment_result":"과제 결과","go_to_library":"학습 자료실로 이동하기","no_assignment":"해당 클래스에 과제가 없습니다.","no_assignment_desc":"학습 자료실에서 과제를 만들어 클래스에 배포하세요!","sort_number":"번호 순","sort_rank":"순위 순","assignment_count_cnt":"총 {cnt} 과제","class_report":"클래스 리포트","partial_answer":"부분정답","no_recommend_chapters":"추천 가능한 단원이 없습니다.","question_type":{"multiple_choice":"객관식","essay":"서술형"},"btns":{"ai_report":"<strong>클래스팅 AI</strong> 리포트","export":"내보내기"},"select_assignments":"과제 선택","select_all_assignments":"모든 과제","select_all_assignments_help":"*모든 과제 선택 시 개별 과제 선택이 불가능합니다","sync_students":"학생수 동기화"},"classes":{"no_classes":"관리 중인 클래스가 없습니다.<br>과제를 내보내려면 클래스의 관리자가 되어보세요."},"view":{"not_found":{"title":"페이지를 찾을 수 없습니다","content":"주소가 잘못 입력되었거나 변경되어<br>\n페이지를 찾을 수 없습니다."},"payment_required":{"content":"하루 한 장 무료 학습이 종료되었습니다.<br>\n학습을 계속 하려면 앱 설치 후 구독을 시작하세요.","title":"구독을 시작하세요."},"oauth_callback":{"classting":{"title":"클래스팅으로 로그인","help":"클래스팅 계정으로 로그인 중..."},"naver":{"title":"네이버로 로그인","help":"네이버 계정으로 로그인 중..."},"google":{"title":"구글로 로그인","help":"구글 계정으로 로그인 중..."}},"terms_confirmation":{"title":"약관 동의","help":"아래 내용을 모두 확인하고<br>\n동의하신 후, 러닝카드를 시작해주세요."}},"btn":{"redirect_to_root":"돌아가기","launch_app":"학습 계속하기","sign_in":{"classting":"클래스팅으로 로그인","naver":"네이버로 로그인","google":"구글로 로그인"},"detail":"보기","sign_out":"로그아웃","view_as_app":"앱으로 보기","start_free_learning":"무료 학습 시작하기","study_again":"다시 풀기","study":"학습하기","see_results":"결과 확인","check_quiz_results":"정답 확인하기","back_to_classting":"","more":"더보기"},"form":{"terms_confirmation":{"label":{"all_checked":"모두 확인, 동의합니다.","terms_of_use":"이용약관","privacy_policy":"개인정보취급방침"},"btn":{"submit":"러닝+ 시작하기"}},"label":{"required":"(필수)"}},"footer":{"nav":{"about":"서비스 소개","terms_of_use":"이용약관","privacy_policy":"개인정보취급방침","copyright":"© Classting {year}"},"brand":"ⓒ Classting 2018","terms":"이용약관","privacy":"개인정보취급방침","operation":"운영정책","support":"클래스팅 러닝 이용법"},"comp":{"card":{"goal":{"title":"배울 내용:"},"info":{"summary":"{chapterPosition}. {chapterName} 카드","publisher_name":"{name} 선생님"},"additional_info":{"label":{"quizzes_count":"퀴즈 수","videos_count":"비디오 수","duration":"소요 시간"}},"results":{"title":"학습 완료","label":{"correct_ratio":"정답률","rank_ratio":"상위","duration":"소요 시간","all_rank_ratio":"전체 상위","class_rank_ratio":"학급 상위","not_graded":"미채점 문제"},"quiz_result_chart":"문제 별 정답 현황"},"due_date":"{date}까지","submission_date":"{date}에 제출 완료"},"learningcard_app":{"subtitle":"국내 최고의 문제집, 동영상 강의 600여 개가 한 곳에!","title":"러닝+ 앱에서 더 많은 카드를 만나보세요.","btn":{"launch_app":"앱에서 학습하기"},"description":"학습을 완료했습니다.\n입력한 답은 종료일 전까지 수정할 수 있습니다."},"correct_answers_graph":{"title":"맞춘 문제","label":{"total_quizzes_count":"총 {totalQuizzesCount}문제"}}},"seo":{"global":{"title":"모바일 공부의 시작","title_template":"%s - 클래스팅 러닝+","description":"클래스팅이 만드는 모바일 공부 트렌드","keywords":"모바일 공부, 러닝카드, Learing Card, 클래스팅, Classting, 인공지능, 학습비서, EBS, 디즈니, 대교, 천재교육, 지학사, 교학사, 미래엔, 와이즈캠프, 윤선생, YBM, 비상, MBC, 노리, 푸르넷, 금성출판사, 정철영어, 문정아중국어"}},"viewer":{"modal":{"init":{"title":"학습 결과 초기화","message":"기존 정답, 학습 시간 등 학습 결과가 초기화됩니다.\n다시 학습하시겠습니까?"}},"quiz_item":{"text_entry_control":{"alerts":{"max_length":"30자까지 입력할 수 있습니다."}}},"quiz":{"result":{"score_labels":{"great":"참 잘 썼어요.","good":"더 잘 쓸 수 있어요!","need_effort":"노력이 필요해요. ","not_graded":"아직 채점이 되지 않았어요!"},"submission":{"label":"입력한 답:"}},"header":{"label":"{pageNumber}. 문제"}},"confirm_submit":{"message":"과제를 다 풀었어요!<br>\n과제를 한 번 제출하면 다시 수정할 수 없어요. 과제를 제출하시겠습니까?","submit_btn":"제출하기","review_btn":"수정하기","message_mobile":"과제를 다 풀었어요!<br>\n과제를 한 번 제출하면 다시 수정할 수 없어요.<br>\n과제를 제출하시겠습니까?","title":"과제 풀기 완료"},"card":{"sam":{"explain":"최초 진단 과제는 총 <strong>{quizCount}문항</strong>으로 진행되며,<br>\n이후, 학생의 진단 결과에 따라 <strong>SAM</strong>이 문제 난이도를 조정하여 <strong>10문제</strong>씩 제공합니다.\n","progress":{"label":"진단율"},"domain":{"label":"영역"},"study":{"button":"시작하기"}},"explain":{"growth":"같은 학년 대비, {growthScore}점이 더 높아요!","ungrowth":"같은 학년 대비, {growthScore}점이 더 낮아요!"},"result":{"learning":"과제 제출이 완료되었어요.<br>\nSam의 과제 진단결과를 확인해볼까요?","assignment":"과제 제출이 완료되었어요.<br />내가 제출한 과제 결과를 확인해볼까요?","ai_learning":"완료되었어요.<br />진단결과를 확인해볼까요?"},"my":{"score":"나의 클래스팅 점수"},"score":"{currentScore}점","domain":{"label":"영역"},"chapter":{"label":"단원"},"goal":{"label":"배울내용"},"assignment":{"result":{"label":"과제결과","action":"전체 보기"},"score":{"result":"내점수","rate":"백분율"},"class":{"score":"클래스 평균점수"},"max":{"score":"100점"},"correct":{"answer":"정답"},"essay":{"label":"서술형","description":"선생님 해설보기","score":"점/5점","comment":"선생님 해설","result":"결과보기"},"learning":{"button":"클래스 과제로 이동하기"},"store":{"button":"해당 영역 학습하기"}},"chart":{"label":"오늘 학습한 진단 결과는 다음날 반영됩니다."},"parent":{"child":{"report":"Sam 진단 결과 확인하기","uncompleted":"자녀가 진단 중입니다.<br>진단이 완료되면 결과를 볼 수 있습니다.","unsupport":"<strong>학부모</strong>는 해당 문제풀이가 불가능하며, 내 자녀의 진단결과 확인만 가능합니다."}},"user":{"unsupport":"학생이 아닌 학습자의 풀이는 결과에 반영되지 않습니다."}},"page":{"header":{"label":"문제 {quizCount}"},"quiz":{"result":{"correct":"정답입니다.","wrong":"오답입니다."},"text":{"save":"저장하기"},"desc":{"label":"해설"},"completed":"저장된 학습 내용이 있습니다.\n마지막 문제에 이어서 학습을 진행 합니다.","position":"학습일시 {date}"},"modal":{"quiz":{"text":{"save":"내용이 저장되었습니다."}}},"next":{"button":"다음"},"prev":{"button":"이전"},"completed":{"graded":"채점완료"},"submit":{"button":"진단완료"},"result":{"button":"정답확인"},"submit-assignments":{"button":"과제 완료"},"assignments":{"button":"과제 시작"},"loading":{"text":"문제를 찾는중 ..."}},"learning":"학습하기","result":{"score":"내 점수","answers":{"count":"정답","percent":"정답률"},"wrong":{"answers":{"explain":"오답을 한 번에 확인해볼까요?","action":"오답 모아보기"}},"action":{"learning":"학습요소 더 공부하기"},"growth":{"learning":"Sam 진단 계속하기"},"back":{"learning":"Sam의 과제로 이동하기"},"my":{"score":"내점수"},"learning":"진단 결과","more":{"learning":"부족한 학습요소"},"parent":{"child":{"report":"내 자녀의 Sam 과제 진단 결과 리포트가<br>있습니다. 확인해볼까요?"}},"close":{"learning":"닫기"}},"content":{"header":{"label":"{count}. 본문"}},"sam":{"quiz":{"prev":{"button":"이전문제"},"next":{"button":"다음문제"}}},"cat":{"page":{"error":"퀴즈를 준비중입니다!"}}},"errors":{"not_found_msg":"주소가 잘못 입력되었거나 변경되어<br>페이지를 찾을 수 없습니다.","unauthorized_msg":"클래스팅 러닝은 선생님만 이용할 수 있습니다.<br>학생, 학부모님은 조금만 기다려주세요.","back_to_classting":"클래스팅으로 돌아가기","unassigned_msg":"페이지를 볼 수 없습니다.<br>내 클래스 과제가 맞는지 다시 확인해보세요.","empty_school_info":"우리 학교 학습자료를 확인하시려면 클래스팅에서 학교정보 설정이 필요합니다.\n"},"page_editor":{"question":{"title":"문제","placeholder":"문제를 입력하세요."},"choices":{"title":"보기","hint":"* 보기를 입력하고 정답을 선택해주세요","is_correct":"정답","add_new":{"placeholder":"+ 보기 추가"},"alerts":{"max_length":"500자 이상 입력할 수 없습니다.","view_type_hint":"보기가 30자 이상일 때 '번호 버튼'이 적합합니다."},"view_types":{"title":"보기 선택 방법","text_button_type":"글자 버튼 선택 (짧은보기)","number_button_type":"번호 버튼 선택 (긴글보기)"},"placeholder":"보기를 입력해주세요."},"text_entry":{"title":"정답","hint":"* 중복 정답은 최대 5개까지 입력할 수 있습니다.","placeholder":"정답을 입력해주세요.","add_new":{"placeholder":"+ 중복 정답 추가"}},"description":{"title":"해설","placeholder":"문제 해설을 입력하세요.","essay_type_hint":"* 서술형 해설에는 미디어 첨부, 수식 입력, 폰트 굵기 변경 등이 지원되지 않습니다."},"header":{"multiple_choice":"객관식 문제","text_entry":"단답형 문제","non_quiz":"본문 내용","essay_type":"서술형 문제"},"alerts":{"max_image_limit":"최대 한 장의 이미지까지 첨부할 수 있습니다.","max_video_limit":"동영상은 한 개만 첨부 가능합니다.","unsupported_video_service":"지원하지 않는 동영상 서비스 입니다.","video_load_failed":"동영상을 불러오는데 실패했습니다.","max_audio_limit":"음성 파일은 한 개만 첨부 가능합니다.","only_audio_or_video":"동영상과 음성 파일 중 한 가지만 첨부 가능합니다."},"non_quiz":{"title":"본문","placeholder":"본문 내용을 입력하세요."},"score_allotment":{"title":"문제 배점 설정","hint":"* 최대 10점까지 설정 가능합니다.","disabled_hint":"* 과제 내보내기 후에는 문제 배점 설정을 할 수 없습니다."},"grading_keywords":{"title":"핵심 키워드 입력","hint":"* 핵심 키워드가 학생의 답변에 포함되면 하이라이트됩니다.","long_placeholder":"키워드를 입력하고 Enter를 누르세요","short_placeholder":"키워드 입력"},"essay_type":{"placeholder":"답안을 입력해주세요."}},"editor":{"alerts":{"max_length":"{n}자 이상 입력할 수 없습니다."}},"evaluations":{"table":{"number":"번호","student_name":"이름","comment":"종합 의견","comment_empty":"종합 의견이 없습니다.","comment_not_supported":"해당 학년 혹은 과목은 아직 지원되지 않습니다.","btn":{"copied_to_clipboard":"클립보드로 복사","refresh":"새로고침"}},"filters":{"order_by":{"number":"번호순","name":"이름순"}},"sub_header":{"config_criteria":"점수 설정"},"modal":{"config_criteria":{"title":"점수 설정","body":{"high_score":"에 대한 점수를 <strong>{score}점</strong> 부터 <strong>100점</strong> 이하 까지 적용합니다.","middle_score":"에 대한 점수를 <strong>0점</strong> 부터 <strong>{score}점</strong> 미만 까지 적용합니다.","middle_score_mark":"중","high_score_mark":"상","min_value":"0점","max_value":"100점","control_help":"막대바를 좌우로 움직이며 점수를 설정하세요! "},"ok_title":"적용"}},"snackbar":{"copied_to_clipboard":"클립보드로 복사되었습니다.","dismiss":"숨기기"},"domain_select":{"header":{"title":"영역 선택","description":"* 과제를 배포한 영역만 표시되며, 선택한 영역을 기준으로 종합의견이 자동 작성됩니다."}},"no_classes":"관리 중인 클래스가 없습니다.<br>종합의견을 이용하려면 클래스의 관리자가 되어보세요."},"landing_v2":{"block1":{"title":"함께 성장하는 교육","subtitle":"클래스팅 러닝은 디지털 기술 기반으로<br>선생님, 학생, 학부모 모두 성장할 수 있는 교육 경험을 제공합니다.","start_btn":"<strong>클래스팅 러닝</strong> 시작하기","checkbox_label":"다음 접속시부터 클래스팅 러닝 소개화면 보지 않기","manual_btn":"사용 설명서 다운로드"},"block2":{"title":"을 손쉽게 활용해 보세요.","subtitle":"다면적 분석과 추천 그리고 종합 의견을 제공합니다."},"block3":{"icon_desc_1":"다면적 학습분석과 추천","icon_desc_2":"손쉬운 학습관리 시스템과 종합의견","icon_desc_3":"클래스팅 기반의 공유와 협업"},"block4":{"scenario1":{"title":"선생님은 손쉽게 학습과제를 만들고<br>클래스팅을 통해 학생들에게 과제를 공유합니다.","desc":"다양한 문제들에서 선택할 수도 있고,<br>\n여러가지 자료를 조합하거나 직접 문제를 만들 수도 있으며,<br>\n동료 선생님들과의 협업도 가능합니다.<br>\n<br>\n클래스팅 앱과 학습과제 연동이 가능하며<br>\n나의 클래스에 제작된 학습과제를 손쉽게 배포할 수 있습니다."},"scenario2":{"title":"다각적으로 학습현황을 분석하며<br>\n학습자에 최적화된 콘텐츠를 추천합니다.","desc":"학생은 자신의 강점과 약점을 파악하고<br>\n자신에게 최적화된 콘텐츠를 제공받습니다.<br>\n<br>\n학부모는 자녀의 학습현황을 지속적으로 확인할 수 있습니다. \n"},"scenario3":{"title":"학습자의 다면분석에 기반한 종합의견 서비스를<br>\n활용하며 선생님은 더 나은 교육을 지향합니다.","desc":"선생님은 자신의 클래스 학습현황을 한 눈에 파악할 수 있으며<br>\n도움이 필요한 학생들에게 즉각적인 피드백이 가능합니다.<br>\n<br>\n다각적 학습분석에 기반한 학생 개개인의 종합의견을 제공합니다."}},"block5":{"title":"선생님, 학생, 학부모를 위한 즉각적이고 다각적인 학습현황 분석","subtitle":"간단한 퀴즈에서 서술형 과제까지 클래스팅 러닝은 즉각적이고 다각적인 학습분석을 제공합니다.<br>\n선생님, 학생, 학부모에게 제공되는 분석결과를 비교해보세요."},"block6":{"icon_desc_1":"선생님을 위한 교육시스템","icon_desc_2":"학생을 위한 학습 퍼포먼스","icon_desc_3":"학부모를 위한 자녀리포트"},"block8":{"title":"국내 최고의 학습 콘텐츠 총 집합","subtitle":"EBS, Disney, YBM, 교학사, 대교, 미래엔, 비상, 윤선생, 지학사, 푸르넷, 천재교육 등<br>\n700만원 상당의 20여 교육회사 대표 콘텐츠 탑재"},"block10":{"title":"클래스팅은 더 나은 학교를 꿈꿉니다.","subtitle":"수 많은 학교가 클래스팅을 이용하고 있습니다.<br>\n클래스팅은 최고의 교육을 위한 서비스를 개발하고, 다음 세대를 위해 더 나은 교육환경을 만듭니다."},"block11":{"icon_title_1":"4,000,000+","icon_desc_1":"전체 이용자 수","icon_title_2":"150,000+","icon_desc_2":"이용 교사 수","icon_title_3":"14,500+","icon_desc_3":"이용 학교 수"},"block12":{"title":"클래스팅 러닝을 교육에 활용하고 싶으신가요?","subtitle":"클래스팅 러닝 도입, 활용 등 기타 궁금한 사항은 문의하기 버튼을 눌러주세요.","ask_btn":"<strong>클래스팅 러닝</strong> 문의하기","manual_btn":"클래스팅 러닝 사용 설명서 보기"},"block7":{"teacher":{"slide1":{"title":"우리 반 학생들의 학습현황을 파악할 수 있습니다.","subtitle":"선생님은 클래스팅 러닝을 통해서<br>\n우리 반 학생들의 현재 학습상태를 리포트의 형태로 확인하고<br>\n각 학생에게 맞는 교육방향을 제시할 수 있습니다."},"slide2":{"title":"학생 별 종합의견을 제공합니다.","subtitle":"학생의 학습분석 결과를 토대로<br>\n종합의견을 자동으로 매칭하여 문장을 조합하여 보여줍니다.<br>\n<br>\n점수에 따른 등급 설정이 가능하며,<br>\n등급에 따라 매칭되는 문장 조합이 변화합니다."}},"student":{"slide1":{"title":"나의 학습 능력을 확인할 수 있습니다.","subtitle":"학생은 자신의 학습결과를 클래스팅 러닝을 통해서<br>\n학습리포트의 형태로 한 눈에 확인할 수 있습니다.<br>\n<br>\n학습리포트를 통해 자신의 부족한 학습영역을 확인하고,<br>\n학습시간을 효율적으로 활용할 수 있습니다."},"slide2":{"title":"개인 맞춤형 학습 콘텐츠를 추천합니다.","subtitle":"학생의 학습데이터 결과를 자동으로 분석하고<br>\n분석 결과에 따라 각기 다른 학습 콘텐츠를 추천합니다.<br>\n<br>\n보기 쉽게 정리된 양질의 학습 콘텐츠로<br>\n학생은 자신의 학습능력을 향상시킬 수 있습니다."}},"parent":{"slide1":{"title":"자녀의 학습 상태를 확인할 수 있습니다.","subtitle":"자녀의 학습리포트를 클래스팅 앱을 통해서 쉽게 확인할 수 있습니다.<br>\n<br>\n각 과목별로 성취도, 열정, 이해, 성장으로 세분화된 리포트를 제공하여<br>\n자녀와의 학습 커뮤니케이션이 원활할 수 있도록 도와줍니다."},"slide2":{"title":"자녀의 학습활동을 위한 활동이 가능합니다.","subtitle":"클래스팅 러닝을 통해서 자녀의 학습상태에 알맞는 학습카드를 추천받고<br>\n코인을 사용해 자녀에게 학습카드를 선물할 수 있습니다.<br>\n<br>\n선물한 학습카드를 자녀가 학습한 경우<br>\n학습결과가 자녀 리포트에 반영되어 학습결과 확인이 가능합니다."}}}},"inquiry_form":{"header":{"title":"클래스팅 러닝 문의하기","subtitle":"학교/학원 등 교육활동에 클래스팅 러닝을 도입해 편리한 학급 관리, 다양한 콘텐츠를 경험하세요."},"form":{"school_name":"학교/기관명","school_name_placeholder":"학교/기관명","name":"이름","name_placeholder":"이름","position":"직책","position_placeholder":"직책","email":"이메일 (기관 발급 이메일)","email_placeholder":"abcd@classting.com","mobile":"휴대폰 번호","mobile_placeholder":"010-1234-5678","content":"문의내용","content_placeholder":"문의하실 내용을 입력해주세요.","submit_btn":"문의하기"},"contact":{"title":"바로 전화 상담을 원하시나요?","subtitle":"1544-0570","desc":"평일 오전9시 ~ 오후6시"},"modal":{"inquiry_submitted_alert":"문의가 접수되었습니다."}},"card_results":{"modal":{"card_ratings":{"title":"공부에 도움이 되었나요?<br>직접 푼 과제를 평가해주세요!","rates":{"10":"1점, 글쎄요...","15":"1.5점, 별로...","20":"2점, 이도저도 아니에요","25":"2.5점, 아쉬워요","30":"3점, 보통이에요","35":"3.5점, 그럭저럭 좋았어요","40":"4점, 좋았어요","45":"4.5점, 아주 괜찮아요!","50":"5점, 최고에요!","05":"0.5점, 도움이 안돼요"}}}},"mission":{"mission_complete":"미션 완료!","view_mission_progress":"미션 현황 보기"},"publishers":{"sub_header":{"series":"시리즈","non_series_cards":"기타 카드","new_series":"시리즈 생성"},"no_series":"아직 시리즈가 없습니다.","modal":{"new_series":{"title":"시리즈 생성","subject":"과목","subject_placeholder":"과목을 선택해주세요.","grade":"학년","grade_placeholder":"학년을 선택해주세요.","name":"제목","name_placeholder":"제목을 입력해주세요","unit":"단원","unit_placeholder":"단원 수를 선택해주세요.","description_placeholder":"설명을 입력해주세요","description":"설명","hashtags":"태그"},"chapter_edit":{"name":"제목","name_placeholder":"제목을 입력해주세요","domain":"영역","domain_placeholder":"영역을 선택해주세요","core_concept":"핵심개념","core_concept_placeholder":"핵심개념을 선택해주세요","domain_concept":"핵심개념","domain_concept_placeholder":"핵심개념을 선택해주세요"},"series_edit":{"title":"시리즈 수정","price":"시리즈 가격 (원)","price_placeholder":"시리즈 가격을 입력해주세요","card_price":"카드당 가격 (원)","card_price_placeholder":"카드당 가격을 입력해주세요","share_level":"전체카드 공개설정"},"remove_series":{"title":"시리즈 삭제","message":"시리즈에 포함된 카드는 삭제되지 않습니다.<br>\n정말 삭제하시겠습니까?"},"cover_image_edit":{"message":"저장 후 시리즈의 대표 이미지가 변경되며, 이후 추가하는 카드의 기본 표지 이미지로 사용됩니다.","title":"시리즈 대표이미지 설정"},"add_to_series":{"title":"시리즈에 추가"},"remove_from_series":{"title":"시리즈에서 카드 제거","message":"시리즈에서 카드를 제거하시겠습니까?<br>\n제거된 카드는 기타카드 탭에서 확인할 수 있습니다."},"remove_publisher_card":{"title":"카드 삭제","message":"삭제된 카드는 복구될 수 없습니다.<br>\n정말 삭제하시겠습니까?"},"new_video_course":{"title":"새로운 영상강의 코스 생성"},"edit_video_course":{"title":"영상강의 코스 정보 수정"},"edit_video_lecture":{"title":"영상강의 정보 수정","share_level":"공개설정"},"new_video_lecture":{"title":"새로운 영상강의 생성"}},"series":{"chapter_count":"단원 수 {cnt}개"},"card":{"add_to_series":"시리즈에 추가","remove_from_series":"시리즈에서 제거"},"headers":{"actions":{"upload_cover_image":"대표이미지 설정","remove":"삭제"}},"no_cards":"표시할 카드가 없습니다.","create_docx_quizzes":{"title":"문항 자동 입력하기","upload_text":"업로드할 *.docx 파일을 선택하세요","create":"생성하기","file_info":{"name":"파일: {name}","quiz_count":"총 {count}문제","multiple_choice_count":"객관식 유형 {count}개","text_entry_count":"단답형 유형 {count}개","image_count":"포함된 이미지 {count}개"}}},"series_cards":{"chapters":{"index":"{i} 단원","meta":{"card_count":"카드 {cnt}개","domain":"영역","core_concept":"핵심개념"}},"meta":{"series_price":"시리즈 가격: {price}원","card_price":"카드 가격: {price}원"}},"landing_v3":{"block1":{"title":"함께 성장하는 미래 교육","subtitle":"클래스팅 러닝은 선생님, 학생, 학부모 모두 성장하는 미래 교육의 경험을 제공합니다.","start_btn":"<strong>클래스팅 러닝</strong> 시작하기","go_to_premium":"AI 살펴보기","subtitle_mobile":"클래스팅 러닝은 선생님, 학생, 학부모<br>\n모두 성장하는 미래 교육의 경험을 제공합니다."},"block2":{"title":"<strong>지속적 상호작용</strong>을 통한 개인 별 맞춤 학습"},"block3":{"title":"은 이렇게 합니다.","features":{"01":{"title":"손쉽게 만드는 과제","description":"다양한 문제 제작 에디터를 통해 손쉽게 문제를 만들고,<br>\n무료로 제공되는 20여 개의 출판사 학습 자료를 조합하여<br>\n학생들에게 과제를 공유할 수 있습니다."},"02":{"title":"종합의견과 클래스 리포트","description":"선생님은 학생들의 학습 현황을 리포트로 한 눈에 파악하고<br>\n도움이 필요한 학생들을 확인하여 즉각적인 피드백을 줄 수 있습니다.<br>\n<br>\n종합의견은 지속적으로 학생의 학습결과를 반영하여<br>\n정확하고 신뢰도 높은 종합의견을 제공합니다."},"03":{"title":"지능적 분석에 의한 맞춤 학습","description":"학생은 다각적으로 분석된 학습 결과를 통해서 강점과 약점을 파악하고<br>\n수준에 알맞는 콘텐츠를 추천받습니다.<br>\n<br>\n클래스팅 러닝은 맞춤형 분석으로 혁신적인 학습경험을 제공합니다. \n"}},"go_to_premium":"AI 살펴보기"},"block6":{"title":"클래스팅은 더 나은 학교를 꿈꿉니다.","subtitle":"수많은 학교가 클래스팅을 이용하고 있습니다.<br>\n클래스팅은 최고의 교육을 위한 서비스를 개발하고, 다음 세대를 위해 더 나은 교육 환경을 만듭니다.","stats":{"users":{"count":"6,700,000+","label":"전체 이용자 수"},"teachers":{"count":"300,000+","label":"이용 교사 수"},"schools":{"count":"20,000+","label":"이용 학교 수"}}},"block7":{"title":"클래스팅 러닝을 교육에 활용하고 싶으신가요?","subtitle":"클래스팅 러닝 도입, 활용 등 기타 궁금한 사항은 문의하기 버튼을 클릭해주세요","start_btn":"<strong>클래스팅 러닝</strong> 시작하기","inquiry_btn":"문의하기"},"block8":{"video_title":"<strong class=\"typography--color-accent\">클래스팅 러닝</strong>은<br>\n교육 환경 개선에 열정을 가진<br>\n<strong>전국의 에듀랩 선생님</strong>들과 함께 합니다."}},"video_lectures":{"sub_header":{"video_courses":"영상강의 코스","video_lectures":"개별 영상강의","new_video_course":"코스 생성","new_video_lecture":"영상강의 생성"},"no_course":"아직 영상강의 코스가 없습니다.","video_course":{"lecture_count":"강의 수 {count}개","edit":"코스 정보 수정","create_new_lecture":"영상강의 추가"},"new_video_course":{"create":"생성하기"},"modals":{"remove_course":{"title":"영상강의 코스 삭제","message":"코스에 포함된 영상강의도 모두 삭제됩니다.<br>\n정말 삭제하시겠습니까?"},"remove_lecture":{"title":"영상강의 삭제","message":"정말 삭제하시겠습니까?"},"make_course_lectures_public":{"message":"코스에 포함된 모든 영상강의가 전체공개로 변경됩니다.<br>\n변경하시겠습니까?"},"make_course_lectures_private":{"message":"코스에 포함된 모든 영상강의가 비공개로 변경됩니다.<br>\n변경하시겠습니까?"}},"no_lectures":"아직 영상강의가 없습니다.","upload_video":{"header_title":"새로운 영상강의 업로드","upload_text":"업로드할 파일을 선택"},"video_lecture":{"edit":"강의 정보 수정"}},"hashtag_form":{"hashtag_candidate":{"media_count":"게시물 {count}개"},"hashtag_input":{"placeholder":"태그를 입력해주세요 (최대 30개)"}},"ai_report":{"header":{"title":"클래스 리포트"},"summary":{"title":"클래스팅 점수","me":"나","average":"평균","need_cat":"진단필요"},"proficiency_rank":{"top":"상위","label_suffix":"기준","in_progress":"집계중입니다","grade_rank_label":"전체","updated_at":"<strong>{month}월 {day}일</strong> 업데이트 기준, 같은 학년 대비 백분율(%) 정보입니다."},"proficiency_history":{"title":"{name} 학생의 수준 변화"},"domain_list":{"title":"영역 ({cnt})","score":"점수","rank":"상위"},"score_guide":{"title":"클래스팅 점수란?","description":"학생의 수준에 맞춰 제공되는 문제를 푸는 과정을 통해<br>\n나의 수준을 판단할 수 있게 고안된 평가 체계입니다.<br>\n<br>\n점수를 통해 내가 어떤 학년에서 어느 정도 수준인지 직관적으로 알 수 있습니다.","score_label_1":"초등학교 1학년 수준","score_label_2":"초등학교 2학년 수준","score_label_3":"초등학교 3학년 수준","score_label_4":"초등학교 4학년 수준","score_label_5":"초등학교 5학년 수준","score_label_6":"초등학교 6학년 수준","score_label_7":"중학교 1학년 수준","score_label_8":"중학교 2학년 수준","score_label_9":"중학교 3학년 수준","score_label_10":"고등학교 1학년 수준","score_label_11":"고등학교 2학년 수준","score_label_12":"고등학교 3학년 수준","score_value_1":"100 ~ 199점","score_value_2":"200 ~ 299점","score_value_3":"300 ~ 399점","score_value_4":"400 ~ 499점","score_value_5":"500 ~ 599점","score_value_6":"600 ~ 699점","score_value_7":"700 ~ 799점","score_value_8":"800 ~ 899점","score_value_9":"900 ~ 999점","score_value_10":"1000 ~ 1099점","score_value_11":"1100 ~ 1199점","score_value_12":"1200 ~ 1299점"},"learning_element_list":{"title":"내용 요소"}},"not_support_prime":{"title":"AI 라이센스 회원이 아니신가요?","description":"학교/담당 선생님께 AI 라이센스 문의 또는 등록 후 이용 가능합니다."},"prime":{"first_quiz_complete":"학습 진단 1회 무료제공 완료!<br><strong>프라임 멤버십</strong>으로 더 많은<br>AI 자동분석 학습진단을 경험하세요.","not_support_user":"현재 클래스팅 프라임 회원이 아닙니다. 해당 콘텐츠의 상세보기 페이지로 이동합니다.","benefit":{"title":"맞춤형 학습 리포트를 확인하려면?<br><strong>클래스팅 프라임을 구독해보세요!</strong>","item_1":"AI 첫 진단 과제 무제한","item_2":"AI 추천 참고서 동영상 강의 무제한","item_3":"실시간 학습분석 리포트 제공","item_4":"광고 제거 기능 및 오프라인 혜택","not_support":"일반 회원은 영역별 1회 무료제공 됩니다.","title_2":"AI 선생님 Sam의<br><strong>자동 분석 학습 진단<strong> 서비스를<br>무제한으로 경험해 보세요!"},"notice":{"confirm":"프라임 멤버십 자세히 보기","cancel":"나중에 보기"}},"class_ai_report":{"proficiency_history":{"title":"클래스 전체 수준 변화"},"no_classes":"생성된 클래스가 없습니다.<br>\n클래스팅에서 클래스를 만들고<br>\n학생들을 초대하여 AI 학습 결과를 한 눈에 살펴보세요!","btns":{"go_to_new_class":"새 클래스 만들기","print":"인쇄하기","export":"내보내기","go_to_class_details":"클래스 바로가기"},"table":{"all_subjects":"전체","title":"클래스팅 점수","subtitle":"<strong>{month}월 {day}일</strong> 업데이트 기준, 같은 학교 기준 대비 백분율(%) 정보입니다.","thead":{"number":"#","id":"아이디","name":"이름"}},"no_students":"클래스에 학생이 없습니다.<br>클래스에 학생들을 초대하여 AI 학습 결과를 한 눈에 살펴보세요!"}}

/***/ }),

/***/ "lXSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterView_vue__ = __webpack_require__("cQSt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e2bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterView_vue__ = __webpack_require__("Tarp");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ECU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e2bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/components/ChapterView.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52e2bc1a", Component.options)
  } else {
    hotAPI.reload("data-v-52e2bc1a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lZGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("F7iD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("30WV");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),

/***/ "leln":
/***/ (function(module, exports) {

module.exports = {"Play":"Play","Pause":"Pause","Current Time":"Current Time","Duration Time":"Duration Time","Remaining Time":"Remaining Time","Stream Type":"Stream Type","LIVE":"LIVE","Loaded":"Loaded","Progress":"Progress","Fullscreen":"Fullscreen","Non-Fullscreen":"Non-Fullscreen","Mute":"Mute","Unmute":"Unmute","Playback Rate":"Playback Rate","Subtitles":"Subtitles","subtitles off":"subtitles off","Captions":"Captions","captions off":"captions off","Chapters":"Chapters","Close Modal Dialog":"Close Modal Dialog","Descriptions":"Descriptions","descriptions off":"descriptions off","Audio Track":"Audio Track","You aborted the media playback":"You aborted the media playback","A network error caused the media download to fail part-way.":"A network error caused the media download to fail part-way.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"The media could not be loaded, either because the server or network failed or because the format is not supported.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.","No compatible source was found for this media.":"No compatible source was found for this media.","The media is encrypted and we do not have the keys to decrypt it.":"The media is encrypted and we do not have the keys to decrypt it.","Play Video":"Play Video","Close":"Close","Modal Window":"Modal Window","This is a modal window":"This is a modal window","This modal can be closed by pressing the Escape key or activating the close button.":"This modal can be closed by pressing the Escape key or activating the close button.",", opens captions settings dialog":", opens captions settings dialog",", opens subtitles settings dialog":", opens subtitles settings dialog",", opens descriptions settings dialog":", opens descriptions settings dialog",", selected":", selected"}

/***/ }),

/***/ "lkEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      {
        staticClass: "base-editor",
        class: { "show-placeholder": _vm.showPlaceHolder },
        style: _vm.disabled === true ? "pointer-events: none;" : "",
        attrs: { id: _vm.editorId }
      },
      [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.textLimitExceeded
      ? _c(
          "div",
          {
            staticClass:
              "typography--caption typography--color-alert text-center pt-12"
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("editor.alerts.max_length", { n: _vm.textLimit })
                ) +
                "\n  "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e65e264", esExports)
  }
}

/***/ }),

/***/ "luS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "floating-dropup-box" }, [
    _c(
      "div",
      { staticClass: "dropup floating-dropup", class: { show: _vm.visible } },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary rounded-circle menu-toggle",
            on: { click: _vm.toggleMenu }
          },
          [
            _c(
              "i",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible"
                  }
                ],
                staticClass: "material-icons"
              },
              [_vm._v("close")]
            ),
            _vm._v(" "),
            _c(
              "i",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.visible,
                    expression: "!visible"
                  }
                ],
                staticClass: "material-icons"
              },
              [_vm._v("add")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-menu dropdown-menu-right" },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dde28c0", esExports)
  }
}

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  selectedPreviewCard: null,

  selectedPreviewPageIndex: 0,

  isStudentAssignmentPreview: false,

  isClassAssignmentPreview: false,

  isPagePreview: false,

  busy: false,

  activeEditorId: null,

  activeEditorLocation: null
});

/***/ }),

/***/ "m0Mz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-6 col-lg-6 col-xl-7" },
            [
              _c("CardTitleInput", {
                staticClass: "action-header typography--headline",
                attrs: { "model-value": _vm.card.title },
                on: { input: _vm.applyCardTitle, "has-error": _vm.onHasError }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 col-lg-6 col-xl-5 hidden-sm-down" },
            [
              _c(
                "div",
                { staticClass: "action-btn-row" },
                [
                  _c(
                    "MoreBtnDropdown",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass:
                            "dropdown-item typography--color-secondary",
                          on: {
                            click: function($event) {
                              return _vm.$root.$emit(
                                "show::modal",
                                "delete-my-card-modal"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.card.menu.remove")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right ml-1 mr-1",
                      attrs: { disabled: _vm.saveDisabled },
                      on: {
                        click: function($event) {
                          return _vm.saveMyCard()
                        }
                      }
                    },
                    [
                      !_vm.busy
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("common.save")))])
                        : _c("LoadingBounce")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary float-right mr-1",
                      attrs: { disabled: _vm.saveDisabled },
                      on: { click: _vm.openCardPreview }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.preview")) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-4 pt-1",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              { staticClass: "card-row" },
              [
                _c("Card", { staticClass: "library-detail-card" }, [
                  _c("div", {
                    staticClass: "card-cover-img-thumb",
                    style: _vm.styleBindings
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "card-cover-img-input text-center clickable"
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/ic-camera.svg", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "no-display",
                        attrs: {
                          type: "file",
                          accept: "image/png,image/jpeg,image/jpg"
                        },
                        on: { change: _vm.onCoverImageChange }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-block" }, [
                    _c("div", { staticClass: "card-info-section" }, [
                      !_vm.card.subject_id
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.subject_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getSubjectLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      _vm.card.grade_id === undefined
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.grade_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getGradeLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      !_vm.card.unit_id
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.chapter_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.unit_id
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.card.chapter_name) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.card.core_concept_id === undefined
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 typography--body-3 typography--color-disabled"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.core_concepts_placeholder"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.getCoreConceptLabel(
                                          _vm.coreConcepts[
                                            _vm.card.core_concept_id
                                          ]
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-keywords-section" }, [
                      _vm.card.core_concept_id
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.learning_elements"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.getLearningElements(
                                          _vm.coreConcepts[
                                            _vm.card.core_concept_id
                                          ]
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-action" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary btn-block",
                          on: {
                            click: function($event) {
                              return _vm.$root.$emit(
                                "show::modal",
                                "edit-card-modal"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("card_details.card_meta.edit")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          staticClass: "edit-card-modal",
                          attrs: {
                            id: "edit-card-modal",
                            title: _vm.$t("card_details.card_meta.edit"),
                            "ok-title": _vm.$t("common.save"),
                            "close-title": _vm.$t("common.cancel")
                          },
                          on: {
                            ok: _vm.applySelectedCardInfo,
                            shown: _vm.setupEditCardModal
                          }
                        },
                        [
                          _c("div", { staticClass: "dropdown-group" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-secondary",
                                  attrs: { for: "card-title-input" }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.title")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected.title,
                                    expression: "selected.title"
                                  }
                                ],
                                staticClass: "form-control basic-text-input",
                                attrs: {
                                  type: "text",
                                  id: "card-title-input",
                                  placeholder: _vm.$t(
                                    "card_details.card_meta.title_placeholder"
                                  ),
                                  maxlength: "50"
                                },
                                domProps: { value: _vm.selected.title },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.selected,
                                      "title",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isPublisherUser
                            ? _c("div", { staticClass: "dropdown-group" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "typography--body-3 typography--color-secondary",
                                        attrs: { for: "card-goal-input" }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "card_details.card_meta.goal"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("AutosizeTextarea", {
                                      staticClass:
                                        "form-control basic-text-input",
                                      attrs: {
                                        id: "card-goal-input",
                                        rows: 3,
                                        limit: 5000,
                                        placeholder: _vm.$t(
                                          "card_details.card_meta.goal_placeholder"
                                        )
                                      },
                                      model: {
                                        value: _vm.selected.goal,
                                        callback: function($$v) {
                                          _vm.$set(_vm.selected, "goal", $$v)
                                        },
                                        expression: "selected.goal"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    text: _vm.getTranslatedName(
                                      _vm.gradeMap[_vm.selected.grade_id]
                                    )
                                  }
                                },
                                [
                                  _vm._l(_vm.gradeList, function(value, key) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: key,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGrade(
                                              value.id,
                                              value.school_year
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getTranslatedName(
                                                _vm.gradeMap[value.id]
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectGrade(null, "null")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("common.selects.others")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    id: "subject-dropdown",
                                    text: _vm.getTranslatedName(
                                      _vm.subjectMap[_vm.selected.subject_id]
                                    )
                                  }
                                },
                                _vm._l(_vm.gradeSubjects, function(value, key) {
                                  return _c(
                                    "b-dropdown-item",
                                    {
                                      key: key,
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSubject(value.id)
                                        }
                                      }
                                    },
                                    [
                                      value.id
                                        ? [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.getTranslatedName(
                                                    _vm.subjectMap[value.id]
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    id: "unit-dropdown",
                                    text:
                                      _vm.getUnitLabel(
                                        _vm.units[_vm.selected.unit_id]
                                      ) ||
                                      _vm.$t("card_details.card_meta.select")
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectUnit("9999")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "card_details.card_meta.select"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.currentUnitList, function(unit) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: unit.id,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectUnit(unit.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.getUnitLabel(unit)) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-group" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-label typography--body-3 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "edit-card-dropdown",
                                  attrs: {
                                    id: "core-concept-dropdown",
                                    text:
                                      _vm.getDetailedCoreConceptLabel(
                                        _vm.coreConcepts[
                                          _vm.selected.core_concept_id
                                        ]
                                      ) ||
                                      _vm.$t("card_details.card_meta.select")
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectCoreConcept("9999")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "card_details.card_meta.select"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.currentCoreConceptList, function(
                                    coreConcept
                                  ) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: coreConcept.id,
                                        attrs: {
                                          title:
                                            _vm.$t(
                                              "card_details.card_meta.learning_elements"
                                            ) +
                                            ": " +
                                            coreConcept.description
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectCoreConcept(
                                              coreConcept.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getDetailedCoreConceptLabel(
                                                coreConcept
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "keyword-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "keyword-label typography--body-3 typography--color-secondary"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "card_details.card_meta.learning_elements"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "keyword-container" }, [
                              _vm.coreConcepts[_vm.selected.core_concept_id]
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-secondary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getLearningElements(
                                              _vm.coreConcepts[
                                                _vm.selected.core_concept_id
                                              ]
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-8" },
            [
              _c(
                "draggable",
                {
                  on: {
                    start: function($event) {
                      _vm.drag = true
                    },
                    end: function($event) {
                      _vm.drag = false
                    }
                  },
                  model: {
                    value: _vm.card.pages,
                    callback: function($$v) {
                      _vm.$set(_vm.card, "pages", $$v)
                    },
                    expression: "card.pages"
                  }
                },
                _vm._l(_vm.card.pages, function(page, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "card-row" },
                    [
                      _c("MyPageSummary", {
                        attrs: {
                          page: page,
                          index: index,
                          "card-title": _vm.card.title
                        },
                        on: {
                          "edit-page": _vm.openPageEditorModal,
                          "remove-page": _vm.openRemovePageModal
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-row" }, [_c("PageAddBlock")], 1)
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.deleteCard }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-my-card-page-modal",
              title: _vm.$t("common.modal.remove.title")
            },
            on: { ok: _vm.removePage, cancel: _vm.cancelRemovePage }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.remove.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "make-card-public-modal",
              title: _vm.$t("common.modal.make_public.title")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.modal.make_public.message"))
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal hide-ok-btn square-area-btn-modal",
            attrs: {
              id: "quiz-type-select-modal",
              title: _vm.$t("card_details.create_page"),
              "close-title": _vm.$t("common.close")
            }
          },
          [
            _c("div", { staticClass: "row square-area-btn-row" }, [
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showNonQuizEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-non-quiz"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.non_quiz")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showMultipleChoiceEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-multiple-choice"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.multiple_choice")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showTextEntryEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-text-entry"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.text_entry")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 square-area-btn-col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "square-area-btn text-center typography--body-3 typography--color-secondary clickable",
                    on: {
                      click: function($event) {
                        _vm.showEssayTypeEditorModal = true
                        _vm.$root.$emit("hide::modal", "quiz-type-select-modal")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "square-area-btn-icon square-area-btn-essay-type"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.page_types.essay_type")) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("PageLibraryModal", { on: { "import-pages": _vm.importPages } }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNonQuizEditorModal,
              expression: "showNonQuizEditorModal"
            }
          ],
          attrs: {
            id: "non_quiz-editor-modal",
            "new-page-type": "non_quiz",
            "is-shown": _vm.showNonQuizEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showNonQuizEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMultipleChoiceEditorModal,
              expression: "showMultipleChoiceEditorModal"
            }
          ],
          attrs: {
            id: "multiple_choice-editor-modal",
            "new-page-type": "multiple_choice",
            "is-shown": _vm.showMultipleChoiceEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showMultipleChoiceEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTextEntryEditorModal,
              expression: "showTextEntryEditorModal"
            }
          ],
          attrs: {
            id: "text_entry-editor-modal",
            "new-page-type": "text_entry",
            "is-shown": _vm.showTextEntryEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showTextEntryEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEssayTypeEditorModal,
              expression: "showEssayTypeEditorModal"
            }
          ],
          attrs: {
            id: "essay_type-editor-modal",
            "new-page-type": "essay_type",
            "is-shown": _vm.showEssayTypeEditorModal
          },
          on: {
            "page-added": _vm.onPageAdded,
            cancel: function($event) {
              _vm.showEssayTypeEditorModal = false
            }
          }
        }),
        _vm._v(" "),
        _c("PageEditorModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEditPageModal,
              expression: "showEditPageModal"
            }
          ],
          attrs: {
            id: "edit-page-editor-modal",
            page: _vm.currentEditingPage,
            "is-shown": _vm.showEditPageModal
          },
          on: { "page-added": _vm.onPageAdded, cancel: _vm.cancelPageEdit }
        }),
        _vm._v(" "),
        _c("AddVideoModal", { on: { add: _vm.addVideo } }),
        _vm._v(" "),
        _c("MathEditorModal", {
          attrs: { id: "math-editor-modal" },
          on: { add: _vm.addMath }
        }),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "page-leave-alert",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: { ok: _vm.pageLeaveOk, cancel: _vm.pageLeaveCancel }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.page_leave_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hidden-md-up",
        attrs: { slot: "floating-action-menu" },
        slot: "floating-action-menu"
      },
      [
        _c(
          "FloatingDropup",
          [
            _c("b-dropdown-item", { on: { click: _vm.openCardPreview } }, [
              _vm._v(_vm._s(_vm.$t("common.preview")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                attrs: { disabled: _vm.saveDisabled },
                on: {
                  click: function($event) {
                    return _vm.saveMyCard()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                on: {
                  click: function($event) {
                    return _vm.$root.$emit(
                      "show::modal",
                      "delete-my-card-modal"
                    )
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.card.menu.remove")))]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee0f9ad6", esExports)
  }
}

/***/ }),

/***/ "m0xj":
/***/ (function(module, exports) {

module.exports = {"Play":"Toisto","Pause":"Tauko","Current Time":"Tämänhetkinen aika","Duration Time":"Kokonaisaika","Remaining Time":"Jäljellä oleva aika","Stream Type":"Lähetystyyppi","LIVE":"LIVE","Loaded":"Ladattu","Progress":"Edistyminen","Fullscreen":"Koko näyttö","Non-Fullscreen":"Koko näyttö pois","Mute":"Ääni pois","Unmute":"Ääni päällä","Playback Rate":"Toistonopeus","Subtitles":"Tekstitys","subtitles off":"Tekstitys pois","Captions":"Tekstitys","captions off":"Tekstitys pois","Chapters":"Kappaleet","You aborted the media playback":"Olet keskeyttänyt videotoiston.","A network error caused the media download to fail part-way.":"Verkkovirhe keskeytti videon latauksen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Videon lataus ei onnistunut joko palvelin- tai verkkovirheestä tai väärästä formaatista johtuen.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Videon toisto keskeytyi, koska media on vaurioitunut tai käyttää käyttää toimintoja, joita selaimesi ei tue.","No compatible source was found for this media.":"Tälle videolle ei löytynyt yhteensopivaa lähdettä."}

/***/ }),

/***/ "m3BN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_input_tag__ = __webpack_require__("28+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddAnswerButton__ = __webpack_require__("tnmD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("qI5z");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-editor-modal',

  components: {
    AddAnswerButton: __WEBPACK_IMPORTED_MODULE_5__AddAnswerButton__["a" /* default */],
    InputTag: __WEBPACK_IMPORTED_MODULE_4_vue_input_tag___default.a
  },

  props: {
    id: {
      type: String
    },
    newPageType: {
      type: String,
      default: 'multiple_choice'
    },
    page: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isShown: {
      type: Boolean
    }
  },

  data: function data() {
    return {
      pageType: null,

      chosenAnswer: 0,

      quiz: null,

      answers: [],

      audios: [],

      images: [],

      gradingKeywords: [],

      errors: {
        content: false,
        description: false
      },

      selectedAnswerCriteriaTypes: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['currentPublisherInfo', 'currentUser', 'isPublisherUser']), {
    sourceEditAvaliable: function sourceEditAvaliable() {
      return this.page.source_type !== 'edubank' && this.page.source_type !== 'ebs';
    },
    hasLongAnswerChoices: function hasLongAnswerChoices() {
      return this.answers.filter(function (answer) {
        return answer.content && answer.content.length > 30;
      }).length > 0;
    },
    hasAnswersError: function hasAnswersError() {
      return this.answers.filter(function (answer) {
        return answer.content && answer.content.length > 499;
      }).length > 0;
    },
    hasNoCorrectAnswer: function hasNoCorrectAnswer() {
      if (this.pageType === 'multiple_choice' && !this.chosenAnswer) {
        return true;
      }

      if (this.pageType === 'text_entry' && this.answers.length > 0 && this.answers[0].content && this.answers[0].content.length === 0) {
        return true;
      }

      return false;
    },
    addQuizDisabled: function addQuizDisabled() {
      return this.errors.content || this.errors.description || this.hasAnswersError || this.hasNoCorrectAnswer;
    },
    videoCount: function videoCount() {
      var content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(this.quiz, 'content') || '';
      var description = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(this.quiz, 'description') || '';
      var contentVideoCount = (content.match(/<iframe/g) || []).length;
      var descriptionVideoCount = (description.match(/<iframe/g) || []).length;

      return contentVideoCount + descriptionVideoCount;
    },
    answerCriteriaTypes: function answerCriteriaTypes() {
      return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* answerCriteriaTypes */] || [];
    },
    sumByAnswerCriteria: function sumByAnswerCriteria() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.selectedAnswerCriteriaTypes)) {
        return 0;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sum"])(this.selectedAnswerCriteriaTypes);
    }
  }),

  watch: {
    page: function page() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.page)) {
        this.setEditingPage();
      }
    },
    isShown: function isShown() {
      if (this.isShown) {
        this.setup();
      }
    }
  },

  methods: {
    checkContentError: function checkContentError(hasError) {
      this.errors.content = hasError;
    },
    checkDescriptionError: function checkDescriptionError(hasError) {
      this.errors.description = hasError;
    },
    getAnswerKey: function getAnswerKey(answer) {
      return answer.key || answer.id;
    },
    selectAnswerViewType: function selectAnswerViewType(selectedAnswerViewType) {
      this.quiz.answer_view_type = selectedAnswerViewType;
    },
    addNewAnswer: function addNewAnswer(isCorrect) {
      if (this.answers.length < 5) {
        this.answers.push({
          key: Math.floor(Math.random() * 1000),
          content: '',
          is_correct: isCorrect || false
        });
      }
    },
    removeAnswer: function removeAnswer(index) {
      if (this.pageType === 'multiple_choice' && this.answers.length > 2) {
        this.answers.splice(index, 1);
      }

      if (this.pageType === 'text_entry' && this.answers.length > 1) {
        this.answers.splice(index, 1);
      }
    },
    selectCorrectAnswerChoice: function selectCorrectAnswerChoice(answer) {
      this.chosenAnswer = answer;
    },
    createEmptyQuizPage: function createEmptyQuizPage() {
      switch (this.pageType) {
        case 'multiple_choice':
          return {
            author_id: this.currentUser.id,
            author_name: this.currentUser.name,
            publisher_id: this.currentPublisherInfo.id,
            publisher_name: this.currentPublisherInfo.name,
            is_copied_page: false,
            is_store_page: false,
            is_quiz: true,
            score: 1,
            answer_view_type: 'list',
            page_type_id: 2,
            image_count: 0,
            audio_count: 0,
            video_count: 0,
            content: '',
            description: '',
            share_level: 1,
            is_autograde: true,
            language: 'KR' };
        case 'text_entry':
          return {
            author_id: this.currentUser.id,
            author_name: this.currentUser.name,
            publisher_id: this.currentPublisherInfo.id,
            publisher_name: this.currentPublisherInfo.name,
            is_copied_page: false,
            is_store_page: false,
            is_quiz: true,
            score: 1,
            page_type_id: 3,
            image_count: 0,
            audio_count: 0,
            video_count: 0,
            content: '',
            description: '',
            share_level: 1,
            is_autograde: true,
            language: 'KR',
            answer_criteria: 0
          };
        case 'essay_type':
          return {
            author_id: this.currentUser.id,
            author_name: this.currentUser.name,
            publisher_id: this.currentPublisherInfo.id,
            publisher_name: this.currentPublisherInfo.name,
            is_copied_page: false,
            is_store_page: false,
            is_quiz: true,
            score: 1,
            page_type_id: 4,
            image_count: 0,
            audio_count: 0,
            video_count: 0,
            content: '',
            description: '',
            share_level: 1,
            is_autograde: false,
            language: 'KR' };
        case 'non_quiz':
          return {
            author_id: this.currentUser.id,
            author_name: this.currentUser.name,
            publisher_id: this.currentPublisherInfo.id,
            publisher_name: this.currentPublisherInfo.name,
            is_copied_page: false,
            is_store_page: false,
            is_quiz: false,
            page_type_id: 1,
            image_count: 0,
            audio_count: 0,
            video_count: 0,
            content: '',
            description: '',
            share_level: 1,
            is_autograde: true,
            language: 'KR' };
        default:
          return {
            author_id: this.currentUser.id,
            author_name: this.currentUser.name,
            publisher_id: this.currentPublisherInfo.id,
            publisher_name: this.currentPublisherInfo.name,
            is_copied_page: false,
            is_store_page: false,
            is_quiz: true,
            image_count: 0,
            audio_count: 0,
            video_count: 0,
            content: '',
            description: '',
            share_level: 1,
            is_autograde: true,
            language: 'KR' };
      }
    },
    resetQuizPage: function resetQuizPage() {
      this.quiz = this.createEmptyQuizPage();
      this.gradingKeywords = [];
      this.answers.splice(0);
      this.images = [];
      this.audios = [];
      this.chosenAnswer = 0;
      this.selectedAnswerCriteriaTypes = [];
    },
    setEditingPage: function setEditingPage() {
      var _this = this;

      switch (this.page.page_type_id) {
        case 1:
          this.pageType = 'non_quiz';
          break;
        case 2:
          this.pageType = 'multiple_choice';
          break;
        case 3:
          this.pageType = 'text_entry';
          break;
        case 4:
          this.pageType = 'essay_type';
          break;
        default:
          this.pageType = '';
          break;
      }

      this.quiz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.page);
      this.answers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.page.answers) || [];
      this.images = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.page.images) || [];
      this.audios = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.page.audios) || [];

      delete this.quiz.answers;
      delete this.quiz.images;
      delete this.quiz.audios;

      if (this.pageType === 'multiple_choice') {
        this.answers.forEach(function (answer) {
          if (answer.is_correct) {
            _this.chosenAnswer = answer;
          }
        });
      }

      if (this.pageType === 'text_entry' && this.quiz.answer_criteria !== 0) {
        this.selectedAnswerCriteriaTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* answerCriteriaTypes */], function (answerCriteria) {
          if (answerCriteria.value & _this.quiz.answer_criteria) {
            return answerCriteria.value;
          }

          return false;
        }), 'value');
      }

      if (!this.quiz.description) {
        this.quiz.description = '';
      }

      if (this.pageType === 'essay_type' && this.quiz.grading_keywords) {
        this.gradingKeywords = this.quiz.grading_keywords.split(',');
      }
    },
    onImageAdded: function onImageAdded(image) {
      this.images.push(image);
    },
    onAudioAdded: function onAudioAdded(audio) {
      if (this.audios.length > 0) {
        return this.$root.$emit('show::modal', 'max-audio-limit-alert');
      }

      if (this.videoCount > 0) {
        return this.$root.$emit('show::modal', 'only-audio-or-video-alert');
      }

      return this.audios.push(audio);
    },
    showAddVideoModal: function showAddVideoModal() {
      if (this.audios.length > 0) {
        return this.$root.$emit('show::modal', 'only-audio-or-video-alert');
      }

      return this.$root.$emit('show::modal', 'add-video-modal');
    },
    addNonQuiz: function addNonQuiz() {
      var _this2 = this;

      var images = this.images.filter(function (img) {
        return _this2.quiz.content.indexOf('data-image-id="' + img.id + '"') !== -1 || _this2.quiz.description.indexOf('data-image-id="' + img.id + '"') !== -1 || _this2.quiz.content.indexOf('data-image-id="' + img.key + '"') !== -1 || _this2.quiz.description.indexOf('data-image-id="' + img.key + '"') !== -1;
      });

      var newNonQuizPage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.quiz, {

        images: images,
        audios: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.audios)),
        image_count: images.length,
        audio_count: this.audios.length,
        video_count: this.videoCount
      });

      newNonQuizPage.content = newNonQuizPage.content.replace(/class="mce-preview-object mce-object-iframe"/g, '');
      newNonQuizPage.description = newNonQuizPage.description.replace(/class="mce-preview-object mce-object-iframe"/g, '');

      this.$emit('page-added', newNonQuizPage);
      this.clean();
    },
    addQuiz: function addQuiz() {
      var _this3 = this;

      var images = this.images.filter(function (img) {
        return _this3.quiz.content.indexOf('data-image-id="' + img.id + '"') !== -1 || _this3.quiz.description.indexOf('data-image-id="' + img.id + '"') !== -1 || _this3.quiz.content.indexOf('data-image-id="' + img.key + '"') !== -1 || _this3.quiz.description.indexOf('data-image-id="' + img.key + '"') !== -1;
      });

      var answers = this.answers.map(function (answer) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, answer, {
          is_correct: _this3.pageType === 'text_entry' && answer.is_correct || _this3.getAnswerKey(answer) === _this3.getAnswerKey(_this3.chosenAnswer)
        });
      }).filter(function (answer) {
        if (_this3.pageType === 'multiple_choice') {
          return true;
        }

        if (_this3.pageType === 'text_entry' && answer.content === '') {
          return false;
        }

        return true;
      });

      var newQuizPage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.quiz, {

        answers: answers,
        images: images,
        audios: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.audios)),
        image_count: images.length,
        audio_count: this.audios.length,
        video_count: this.videoCount,
        answer_criteria: this.sumByAnswerCriteria
      });

      newQuizPage.content = newQuizPage.content.replace(/class="mce-preview-object mce-object-iframe"/g, '');
      newQuizPage.description = newQuizPage.description.replace(/class="mce-preview-object mce-object-iframe"/g, '');

      if (this.pageType === 'essay_type') {
        newQuizPage.grading_keywords = this.gradingKeywords.join(',');
      }

      this.$emit('page-added', newQuizPage);
      this.clean();
    },
    setup: function setup() {
      var _this4 = this;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.page)) {
        this.pageType = this.newPageType;

        if (!this.quiz) {
          this.quiz = this.createEmptyQuizPage();
        }

        if (this.answers.length === 0) {
          if (this.pageType === 'multiple_choice') {
            this.addNewAnswer();
            this.addNewAnswer();
            this.selectCorrectAnswerChoice(this.answers[0]);
          } else {
            this.addNewAnswer(true);
          }
        }
      } else {
        this.setEditingPage();
      }

      tinymce.editors.forEach(function (editor) {
        if (editor.id === 'quiz-editor-' + _this4.id) {
          tinymce.setActive(editor);
        }
      });
    },
    close: function close() {
      this.$emit('cancel');
      this.clean();
    },
    clean: function clean() {
      this.resetQuizPage();
    },
    selectAnswerCriteria: function selectAnswerCriteria(value) {
      this.selectedAnswerCriteriaTypes = value;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.clean();
  },
  created: function created() {
    this.setup();
  }
});

/***/ }),

/***/ "m5iD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_snackbar_dist_mdc_snackbar_min__ = __webpack_require__("r6kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_snackbar_dist_mdc_snackbar_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_snackbar_dist_mdc_snackbar_min__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'snackbar',

  mounted: function mounted() {
    var snackbar = new __WEBPACK_IMPORTED_MODULE_0__material_snackbar_dist_mdc_snackbar_min__["MDCSnackbar"](this.$el);

    this.$root.$on('show::snackbar', function (options) {
      snackbar.show(options);
    });
  },
  destroyed: function destroyed() {
    this.$root.$off('show::snackbar');
  }
});

/***/ }),

/***/ "m8Oq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("2uFj");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'policy-modal',

  props: ['id', 'title', 'policyId'],

  components: {
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },

  data: function data() {
    return {
      markdown: null,

      policyVersion: null,

      lang: 'ko'
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchPolicy']), {
    onOpen: function onOpen() {
      var _this = this;

      if (!this.markdown) {
        this.policyVersion = __WEBPACK_IMPORTED_MODULE_4__config__["c" /* POLICY_VERSIONS */][this.policyId][this.lang][0];

        this.fetchPolicy(this.policyVersion.url).then(function (md) {
          _this.markdown = md.replace('/policies/', __WEBPACK_IMPORTED_MODULE_4__config__["b" /* CLASSTING_URL */] + '/policies/');
        }).catch(function (err) {
          _this.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    }
  })
});

/***/ }),

/***/ "mEiJ":
/***/ (function(module, exports) {

module.exports = {"Play":"Phát","Pause":"Tạm dừng","Current Time":"Thời gian hiện tại","Duration Time":"Độ dài","Remaining Time":"Thời gian còn lại","Stream Type":"Kiểu Stream","LIVE":"TRỰC TIẾP","Loaded":"Đã tải","Progress":"Tiến trình","Fullscreen":"Toàn màn hình","Non-Fullscreen":"Thoát toàn màn hình","Mute":"Tắt tiếng","Unmute":"Bật âm thanh","Playback Rate":"Tốc độ phát","Subtitles":"Phụ đề","subtitles off":"Tắt phụ đề","Captions":"Chú thích","captions off":"Tắt chú thích","Chapters":"Chương","You aborted the media playback":"Bạn đã hủy việc phát media.","A network error caused the media download to fail part-way.":"Một lỗi mạng dẫn đến việc tải media bị lỗi.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video không tải được, mạng hay server có lỗi hoặc định dạng không được hỗ trợ.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Phát media đã bị hủy do một sai lỗi hoặc media sử dụng những tính năng trình duyệt không hỗ trợ.","No compatible source was found for this media.":"Không có nguồn tương thích cho media này."}

/***/ }),

/***/ "mUaw":
/***/ (function(module, exports) {

module.exports = {"Play":"Oynat","Pause":"Duraklat","Current Time":"Süre","Duration Time":"Toplam Süre","Remaining Time":"Kalan Süre","Stream Type":"Yayın Tipi","LIVE":"CANLI","Loaded":"Yüklendi","Progress":"Yükleniyor","Fullscreen":"Tam Ekran","Non-Fullscreen":"Küçük Ekran","Mute":"Ses Kapa","Unmute":"Ses Aç","Playback Rate":"Oynatma Hızı","Subtitles":"Altyazı","subtitles off":"Altyazı Kapalı","Captions":"Ek Açıklamalar","captions off":"Ek Açıklamalar Kapalı","Chapters":"Bölümler","You aborted the media playback":"Video oynatmayı iptal ettiniz","A network error caused the media download to fail part-way.":"Video indirilirken bağlantı sorunu oluştu.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video oynatılamadı, ağ ya da sunucu hatası veya belirtilen format desteklenmiyor.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Tarayıcınız desteklemediği için videoda hata oluştu.","No compatible source was found for this media.":"Video için kaynak bulunamadı.","Play Video":"Videoyu Oynat","Close":"Kapat","Modal Window":"Modal Penceresi","This is a modal window":"Bu bir modal penceresidir","This modal can be closed by pressing the Escape key or activating the close button.":"Bu modal ESC tuşuna basarak ya da kapata tıklanarak kapatılabilir.",", opens captions settings dialog":", ek açıklama ayarları menüsünü açar",", opens subtitles settings dialog":", altyazı ayarları menüsünü açar",", selected":", seçildi"}

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setSelectedPreviewCard"] = setSelectedPreviewCard;
/* harmony export (immutable) */ __webpack_exports__["setSelectedPreviewPageIndex"] = setSelectedPreviewPageIndex;
/* harmony export (immutable) */ __webpack_exports__["setIsStudentAssignmentPreview"] = setIsStudentAssignmentPreview;
/* harmony export (immutable) */ __webpack_exports__["setIsClassAssignmentPreview"] = setIsClassAssignmentPreview;
/* harmony export (immutable) */ __webpack_exports__["setIsPagePreview"] = setIsPagePreview;
/* harmony export (immutable) */ __webpack_exports__["setBusy"] = setBusy;
/* harmony export (immutable) */ __webpack_exports__["setActiveEditorLocation"] = setActiveEditorLocation;
/* harmony export (immutable) */ __webpack_exports__["setActiveEditorId"] = setActiveEditorId;
/* harmony export (immutable) */ __webpack_exports__["submitGoogleForms"] = submitGoogleForms;
/* harmony export (immutable) */ __webpack_exports__["sendSlackNotification"] = sendSlackNotification;
/* harmony export (immutable) */ __webpack_exports__["sendSlackContentReports"] = sendSlackContentReports;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("Du/2");






function setSelectedPreviewCard(_ref, card) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED, card);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setSelectedPreviewPageIndex(_ref2, pageIndex) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PAGE_INDEX, pageIndex);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setIsStudentAssignmentPreview(_ref3, isStudentAssignmentPreview) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_IS_STUDENT_PREVIEW, isStudentAssignmentPreview);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setIsClassAssignmentPreview(_ref4, isClassAssignmentPreview) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_IS_CLASS_PREVIEW, isClassAssignmentPreview);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setIsPagePreview(_ref5, isPagePreview) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_IS_PAGE_PREVIEW, isPagePreview);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
}

function setBusy(_ref6, obj) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_BUSY, obj);
}

function setActiveEditorLocation(_ref7, editorLocation) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ACTIVE_EDITOR_LOCATION, editorLocation);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(editorLocation);
}

function setActiveEditorId(_ref8, editorId) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ACTIVE_EDITOR_ID, editorId);

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(editorId);
}

function submitGoogleForms(_, params) {
  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/google-forms', params);
}

function sendSlackNotification(_, params) {
  var body = {
    username: __WEBPACK_IMPORTED_MODULE_2__config__["u" /* SLACK_CONFIG */].username,
    icon_url: __WEBPACK_IMPORTED_MODULE_2__config__["u" /* SLACK_CONFIG */].iconUrl,
    attachments: [{
      color: 'good',
      mrkdwn_in: ['text'],
      text: __WEBPACK_IMPORTED_MODULE_2__config__["u" /* SLACK_CONFIG */].header + '\n\n```' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params, null, '  ') + '```'
    }]
  };

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["u" /* SLACK_CONFIG */].url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body), {
    headers: { 'Content-Type': 'text/plain' },
    transformRequest: [function (data, headers) {
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];
      return data;
    }]
  });
}

function sendSlackContentReports(_, params) {
  var body = {
    username: __WEBPACK_IMPORTED_MODULE_2__config__["v" /* CONTENT_REPORTS_CONFIG */].username,
    attachments: [{
      color: 'warning',
      mrkdwn_in: ['text'],
      text: __WEBPACK_IMPORTED_MODULE_2__config__["v" /* CONTENT_REPORTS_CONFIG */].header + '\n\n```' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params, null, '  ') + '```'
    }]
  };

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["v" /* CONTENT_REPORTS_CONFIG */].url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body), {
    headers: { 'Content-Type': 'text/plain' },
    transformRequest: [function (data, headers) {
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];
      return data;
    }]
  });
}

/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zh_TW_json__ = __webpack_require__("gS7P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zh_TW_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zh_TW_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ko_KR_json__ = __webpack_require__("lX4D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ko_KR_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ko_KR_json__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'ko',
  fallbackLocale: 'ko',
  messages: {
    'zh-TW': __WEBPACK_IMPORTED_MODULE_2__zh_TW_json___default.a,
    ko: __WEBPACK_IMPORTED_MODULE_3__ko_KR_json___default.a
  }
}));

/***/ }),

/***/ "mab8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  selectedStorePageId: '',

  storePageList: []
});

/***/ }),

/***/ "mcwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function numberToPercentage() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.0;

  return parseInt(Math.round(number), 10) + "%";
}

/* harmony default export */ __webpack_exports__["a"] = (numberToPercentage);

/***/ }),

/***/ "mfnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'up-down-arrow',

  props: {
    value: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ''
    }
  },

  computed: {
    arrowSrc: function arrowSrc() {
      if (this.value > 0) {
        return '/static/images/ic-increase-info.svg';
      }

      return '/static/images/ic-decrease-info.svg';
    },
    absValue: function absValue() {
      return Math.abs(this.value);
    },
    upDownClass: function upDownClass() {
      return {
        increased: this.value > 0,
        decreased: this.value < 0
      };
    }
  }
});

/***/ }),

/***/ "mi6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("dpag");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("YQXT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("E42Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("7VK4");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "moW2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n0Sg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageCarousel_vue__ = __webpack_require__("2ZuB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3772825b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageCarousel_vue__ = __webpack_require__("jPcw");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3772825b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ImageCarousel.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3772825b", Component.options)
  } else {
    hotAPI.reload("data-v-3772825b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n4MN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n4lW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContentFromPreview_vue__ = __webpack_require__("6qw9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed1f689_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContentFromPreview_vue__ = __webpack_require__("5HxE");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportContentFromPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed1f689_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportContentFromPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ReportContentFromPreview.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ed1f689", Component.options)
  } else {
    hotAPI.reload("data-v-0ed1f689", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nDej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVideoLecture_vue__ = __webpack_require__("AS8Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd4df9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVideoLecture_vue__ = __webpack_require__("0Eyt");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("EZHp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVideoLecture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd4df9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVideoLecture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-lectures/views/EditVideoLecture.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4fd4df9f", Component.options)
  } else {
    hotAPI.reload("data-v-4fd4df9f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nk1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("C8Zk");




var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].UPDATE_PAGE, function (state, page) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'page', page);
});

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "nsht":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nt+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_SELECTED = 'storePages/SET_SELECTED';
var SET_PAGES = 'storePages/SET_PAGES';
var ADD_PAGES = 'storePages/ADD_PAGES';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SELECTED: SET_SELECTED,
  SET_PAGES: SET_PAGES,
  ADD_PAGES: ADD_PAGES
});

/***/ }),

/***/ "nwTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nztc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TableCard", { staticClass: "evaluation-table" }, [
    _c("thead", { attrs: { slot: "thead" }, slot: "thead" }, [
      _c("tr", [
        _c(
          "th",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("evaluations.table.number")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("evaluations.table.student_name")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("evaluations.table.comment")) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      { attrs: { slot: "tbody" }, slot: "tbody" },
      _vm._l(_vm.evaluationList, function(evaluation) {
        return _c("EvaluationTableRow", {
          key: evaluation.student_id,
          attrs: {
            evaluation: evaluation,
            "selected-domain-ids": _vm.selectedDomainIds
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a005f8", esExports)
  }
}

/***/ }),

/***/ "o3Mh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLayout_vue__ = __webpack_require__("XmDo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24df821a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLayout_vue__ = __webpack_require__("gUDR");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("k4Nh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24df821a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MainLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24df821a", Component.options)
  } else {
    hotAPI.reload("data-v-24df821a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o4Zc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oFyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizPreview_vue__ = __webpack_require__("/UHL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e372280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizPreview_vue__ = __webpack_require__("8coR");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("7Xb3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e372280"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e372280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-quizzes/components/QuizPreview.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e372280", Component.options)
  } else {
    hotAPI.reload("data-v-3e372280", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oIH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "dummy-page-summary" }, [
    _c("div", { staticClass: "card-block" }, [
      _c("div", { staticClass: "page-header-section" }, [
        _c("div", { staticClass: "row" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-content-section" }, [
        _c("div", { staticClass: "row" }),
        _vm._v(" "),
        _c("div", { staticClass: "row" })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a32be02", esExports)
  }
}

/***/ }),

/***/ "okbZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "app-header", attrs: { toggleable: "", variant: "faded" } },
    [
      _c(
        "div",
        { staticClass: "container app-header-container" },
        [
          _c("b-nav-toggle", {
            staticClass: "clickable",
            attrs: { target: "app-header-nav-collapse" }
          }),
          _vm._v(" "),
          _vm.attachHome
            ? _c(
                "b-link",
                {
                  staticClass: "navbar-brand app-brand",
                  attrs: { to: "/intro" }
                },
                [
                  _c("img", {
                    attrs: { src: "/static/images/new-classting-logo.svg" }
                  })
                ]
              )
            : _c(
                "b-link",
                {
                  staticClass: "navbar-brand app-brand",
                  attrs: { to: "/library" }
                },
                [
                  _c("img", {
                    attrs: { src: "/static/images/new-classting-logo.svg" }
                  })
                ]
              ),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { "is-nav": "", id: "app-header-nav-collapse" } },
            [
              _c(
                "b-nav",
                { staticClass: "mx-auto", attrs: { "is-nav-bar": "" } },
                [
                  _c("b-nav-item", { attrs: { to: "/library" } }, [
                    _vm._v(_vm._s(_vm.$t("header.nav_menu.library")))
                  ]),
                  _vm._v(" "),
                  _c("b-nav-item", { attrs: { to: "/my-cards" } }, [
                    _vm._v(_vm._s(_vm.$t("header.nav_menu.my_cards")))
                  ]),
                  _vm._v(" "),
                  _vm.isPublisherUser
                    ? _c("b-nav-item", { attrs: { to: "/publishers" } }, [
                        _vm._v(_vm._s(_vm.$t("header.nav_menu.publishers")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPublisherUser
                    ? _c("b-nav-item", { attrs: { to: "/video-courses" } }, [
                        _vm._v(_vm._s(_vm.$t("header.nav_menu.video_lectures")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-nav",
                { staticClass: "hidden-sm-down", attrs: { "is-nav-bar": "" } },
                [
                  _c("a", {
                    staticClass: "btn rounded-circle profile-btn",
                    style: _vm.styleBindings,
                    attrs: { href: _vm.userProfileUrl, target: "_blank" }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb50a5e4", esExports)
  }
}

/***/ }),

/***/ "olR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "publisher-card-view" }, [
    _c("div", {
      staticClass: "publisher-card-view__cover-img-thumb clickable",
      style: _vm.coverImageStyle,
      on: {
        click: function($event) {
          return _vm.goToMyCardDetails()
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "card-block clickable",
        on: {
          click: function($event) {
            return _vm.goToMyCardDetails()
          }
        }
      },
      [
        _c(
          "h4",
          {
            staticClass: "publisher-card-view__title typography--headline",
            attrs: { title: _vm.card.title }
          },
          [_vm._v("\n      " + _vm._s(_vm.card.title) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "typography--caption" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.getGradeLabel(_vm.card)) +
              " ∙\n      " +
              _vm._s(_vm.getSubjectLabel(_vm.card)) +
              "\n      "
          ),
          _vm.card.chapter_name
            ? _c("span", [
                _vm._v(
                  "\n        ∙ " + _vm._s(_vm.card.chapter_name) + "\n      "
                )
              ])
            : !_vm.isEmpty(_vm.card.core_concept)
            ? _c("span", [
                _vm._v(
                  "\n        ∙ " +
                    _vm._s(_vm.getCoreConceptLabel(_vm.card.core_concept)) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-16" }, [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _vm.card.page_count - _vm.card.quiz_count > 0
                ? _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.card.non_quiz")) +
                        " " +
                        _vm._s(
                          _vm.$t("common.card.count", {
                            cnt: _vm.card.page_count - _vm.card.quiz_count
                          })
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.card.page_count - _vm.card.quiz_count > 0 &&
              _vm.card.quiz_count > 0
                ? _c("span", [_vm._v("∙")])
                : _vm._e(),
              _vm._v(" "),
              _vm.card.quiz_count > 0
                ? _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.card.quiz")) +
                        " " +
                        _vm._s(
                          _vm.$t("common.card.count", {
                            cnt: _vm.card.quiz_count
                          })
                        ) +
                        "\n        "
                    )
                  ])
                : _c("span", { staticStyle: { color: "transparent" } }, [
                    _vm._v("_")
                  ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("series_cards.meta.card_price", {
                      price: _vm.cardPrice
                    })
                  ) +
                  "\n      "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _c("strong", [
                _vm._v(_vm._s(_vm.getShareLevelLabel(_vm.card.share_level)))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "small",
            { staticClass: "typography--caption typography--color-secondary" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("common.card.updated_at")) +
                  ": " +
                  _vm._s(_vm._f("datetime")(_vm.card.updated_at)) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "publisher-card-view__action" }, [
      _vm.isSeriesCard
        ? _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "IconDropdown",
                { attrs: { dropup: true } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.$emit(
                            "open-remove-from-series-modal",
                            _vm.card.id
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("publishers.card.remove_from_series")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isCardAuthor
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.$emit(
                                "open-remove-card-modal",
                                _vm.card.id
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("common.card.menu.remove")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "button",
            {
              staticClass: "btn btn-inverted-primary",
              on: {
                click: function($event) {
                  return _vm.$emit("open-add-to-series-modal", _vm.card.id)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("publishers.card.add_to_series")) +
                  "\n    "
              )
            ]
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4920eff9", esExports)
  }
}

/***/ }),

/***/ "om2z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (typeof document !== 'undefined') {
      document.documentElement.addEventListener('click', this._clickOutListener);
    }
  },
  destroyed: function destroyed() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', this._clickOutListener);
    }
  },


  methods: {
    _clickOutListener: function _clickOutListener(e) {
      if (!this.$el.contains(e.target)) {
        if (this.clickOutListener) {
          this.clickOutListener();
        }
      }
    }
  }
});

/***/ }),

/***/ "otGn":
/***/ (function(module, exports) {

module.exports = {"Play":"Odtwarzaj","Pause":"Pauza","Current Time":"Aktualny czas","Duration Time":"Czas trwania","Remaining Time":"Pozostały czas","Stream Type":"Typ strumienia","LIVE":"NA ŻYWO","Loaded":"Załadowany","Progress":"Status","Fullscreen":"Pełny ekran","Non-Fullscreen":"Pełny ekran niedostępny","Mute":"Wyłącz dźwięk","Unmute":"Włącz dźwięk","Playback Rate":"Szybkość odtwarzania","Subtitles":"Napisy","subtitles off":"Napisy wyłączone","Captions":"Transkrypcja","captions off":"Transkrypcja wyłączona","Chapters":"Rozdziały","You aborted the media playback":"Odtwarzanie zostało przerwane","A network error caused the media download to fail part-way.":"Problemy z siecią spowodowały błąd przy pobieraniu materiału wideo.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Materiał wideo nie może być załadowany, ponieważ wystąpił problem z siecią lub format nie jest obsługiwany","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Odtwarzanie materiału wideo zostało przerwane z powodu uszkodzonego pliku wideo lub z powodu błędu funkcji, które nie są wspierane przez przeglądarkę.","No compatible source was found for this media.":"Dla tego materiału wideo nie znaleziono kompatybilnego źródła.","Play video":"Odtwarzaj wideo","Close":"Zamknij","Modal Window":"Okno Modala","This is a modal window":"To jest okno modala","This modal can be closed by pressing the Escape key or activating the close button.":"Ten modal możesz zamknąć naciskając przycisk Escape albo wybierając przycisk Zamknij.",", opens captions settings dialog":", otwiera okno dialogowe ustawień transkrypcji",", opens subtitles settings dialog":", otwiera okno dialogowe napisów",", selected":", zaznaczone"}

/***/ }),

/***/ "p1XE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudentReport_vue__ = __webpack_require__("+8Ka");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6e2e2a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StudentReport_vue__ = __webpack_require__("N5uh");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("A6/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudentReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6e2e2a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StudentReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/views/StudentReport.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a6e2e2a4", Component.options)
  } else {
    hotAPI.reload("data-v-a6e2e2a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p3dc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p9Zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__("kl7r");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'series-edit-modal',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  props: {
    seriesItem: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      seriesPrice: null,
      seriesCardPrice: null,
      seriesTitle: '',
      seriesShareLevel: 0,
      busy: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['chapterCardList']), {
    saveDisabled: function saveDisabled() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.seriesItem)) {
        return this.seriesPrice === this.seriesItem.price && this.seriesCardPrice === this.seriesItem.card_price && this.seriesShareLevel === this.seriesItem.share_level && this.seriesTitle === this.seriesItem.name;
      }

      return true;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setChapterCards', 'updateSeries']), {
    toggleShareLevel: function toggleShareLevel(value) {
      this.seriesShareLevel = value ? 1 : 2;
    },
    save: function save() {
      var _this = this;

      if (!this.busy) {
        this.busy = true;

        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.seriesItem, {
          name: this.seriesTitle,
          price: this.seriesPrice || null,
          card_price: this.seriesCardPrice || null,
          share_level: this.seriesShareLevel
        });

        this.updateSeries(params).then(function () {
          var updatedSeriesCards = _this.chapterCardList.filter(function (card) {
            return card.series_id === _this.seriesItem.id;
          }).map(function (card) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, card, {
              price: _this.seriesCardPrice || null,
              share_level: _this.seriesShareLevel
            });
          });

          return _this.setChapterCards(updatedSeriesCards);
        }).then(function () {
          return _this.$emit('ok');
        });
      }
    }
  }),

  beforeMount: function beforeMount() {
    this.loading = true;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.seriesItem)) {
      this.seriesPrice = this.seriesItem.price;
      this.seriesCardPrice = this.seriesItem.card_price;
      this.seriesShareLevel = this.seriesItem.share_level;
      this.seriesTitle = this.seriesItem.name;
    }

    this.loading = false;
  }
});

/***/ }),

/***/ "pNG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var REMOVE_NON_SERIES_CARD = 'publishers/REMOVE_NON_SERIES_CARD';
var SET_NON_SERIES_CARDS = 'publishers/SET_NON_SERIES_CARDS';
var REMOVE_CHAPTER_CARD = 'publishers/REMOVE_CHAPTER_CARD';
var SET_CHAPTER_CARDS = 'publishers/SET_CHAPTER_CARDS';
var REMOVE_SERIES = 'publishers/REMOVE_SERIES';
var SET_CHAPTERS = 'publishers/SET_CHAPTERS';
var SET_SERIES = 'publishers/SET_SERIES';
var REQUEST_VIDEO_COURSE_CARD = 'publishers/REQUEST_VIDEO_COURSE_CARD';
var SET_VIDEO_COURSE_CARD = 'publishers/SET_VIDEO_COURSE_CARD';
var FETCH_VIDEO_COURSE_CARDS = 'publishers/SET_VIDEO_COURSE_CARDS';
var UPDATE_VIDEO_COURSE_CARD = 'publishers/UPDATE_VIDEO_COURSE_CARD';

/* harmony default export */ __webpack_exports__["a"] = ({
  REMOVE_NON_SERIES_CARD: REMOVE_NON_SERIES_CARD,
  SET_NON_SERIES_CARDS: SET_NON_SERIES_CARDS,
  REMOVE_CHAPTER_CARD: REMOVE_CHAPTER_CARD,
  SET_CHAPTER_CARDS: SET_CHAPTER_CARDS,
  REMOVE_SERIES: REMOVE_SERIES,
  SET_CHAPTERS: SET_CHAPTERS,
  SET_SERIES: SET_SERIES,
  SET_VIDEO_COURSE_CARD: SET_VIDEO_COURSE_CARD,
  REQUEST_VIDEO_COURSE_CARD: REQUEST_VIDEO_COURSE_CARD,
  FETCH_VIDEO_COURSE_CARDS: FETCH_VIDEO_COURSE_CARDS,
  UPDATE_VIDEO_COURSE_CARD: UPDATE_VIDEO_COURSE_CARD
});

/***/ }),

/***/ "pO6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return true
    ? _c(
        "CustomModal",
        {
          staticClass: "basic-modal my-quiz-modal",
          attrs: { id: "my-quiz-modal", isCustomFooter: true }
        },
        [
          _c(
            "div",
            {
              staticClass: "quiz-title",
              attrs: { slot: "modal-header" },
              slot: "modal-header"
            },
            [
              _vm._v("\n    데일리 퀴즈 상세\n    "),
              _c("div", { staticClass: "quiz-subtitle" }, [
                _vm._v("\n      검토 완료 이후 퀴즈 수정이 불가능합니다.\n    ")
              ])
            ]
          ),
          _vm._v(" "),
          _c("QuizPreview", { attrs: { quiz: _vm.quiz } }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              },
              [_vm._v("\n      취소\n    ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.isActiveQuiz ||
                    _vm.isEndQuiz ||
                    _vm.isReviewCompletedQuiz
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("ok")
                  }
                }
              },
              [_vm._v("\n      수정\n    ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: {
                  type: "button",
                  disabled: _vm.isActiveQuiz || _vm.isReviewCompletedQuiz
                },
                on: { click: _vm.handleDeleteClick }
              },
              [!_vm.isLoading ? [_vm._v("삭제")] : _c("LoadingBounce")],
              2
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456438ce", esExports)
  }
}

/***/ }),

/***/ "pRPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "my-quiz-card",
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.isQuizTags
        ? _c(
            "div",
            { staticClass: "tag-wrapper" },
            _vm._l(_vm.getQuizTags(_vm.quiz), function(value, index) {
              return _c("div", { key: index, staticClass: "tag" }, [
                _vm._v("\n      " + _vm._s(value) + "\n    ")
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.quiz.content || "-"))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "quiz-type" }, [
        _vm._v(_vm._s(_vm.getQuizTypeName))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "date" }, [
        _vm._v("최초 생성일 " + _vm._s(_vm.getQuizCreatedDate))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "row stats-wrapper" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "label" }, [_vm._v("정답수")]),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getToCommas(_vm.getCorrectResultsCount)))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "label" }, [_vm._v("총 문제 푼수")]),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getToCommas(_vm.getTotalResultsCount)))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 quiz-state-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "quiz-state",
              class: _vm.getQuizState(_vm.getQuizSet).value
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getQuizState(_vm.getQuizSet).label) +
                  "\n      "
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc23358", esExports)
  }
}

/***/ }),

/***/ "pTQH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FloatingDropup_vue__ = __webpack_require__("2n7g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dde28c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FloatingDropup_vue__ = __webpack_require__("luS1");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FloatingDropup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dde28c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FloatingDropup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/FloatingDropup.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dde28c0", Component.options)
  } else {
    hotAPI.reload("data-v-2dde28c0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pZbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "page-add-block" },
    [
      _c(
        "Tooltip",
        {
          attrs: { position: "bottom", show: _vm.showTooltip },
          on: { "tooltip-closed": _vm.onTooltipClosed }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$root.$emit(
                        "show::modal",
                        "quiz-type-select-modal"
                      )
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "page-create-icon",
                    attrs: { src: "/static/images/ic-edit.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "typography--body-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("card_details.create_page")) +
                        "\n          "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.openPageLibraryModal }
                },
                [
                  _c("img", {
                    staticClass: "page-search-icon",
                    attrs: { src: "/static/images/ic-import.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "typography--body-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("card_details.search_page")) +
                        "\n          "
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "tooltip-body" }, slot: "tooltip-body" }, [
            _c("div", {
              staticClass: "typography--body-3 typography--color-secondary",
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.tooltip.try_add_new_pages"))
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a24f08e", esExports)
  }
}

/***/ }),

/***/ "pgxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "card-preview-modal",
      attrs: { id: "card-preview-modal" },
      on: { shown: _vm.setup, hidden: _vm.clean }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _c("h5", { staticClass: "modal-title card-preview-modal__title" }, [
            _vm._v(_vm._s(_vm.cardTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "modal-close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$root.$emit("hide::modal", "card-preview-modal")
                }
              }
            },
            [_c("img", { attrs: { src: "/static/images/btn-close.svg" } })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showToggle,
                      expression: "showToggle"
                    }
                  ]
                },
                [
                  _c(
                    "ToggleSwitch",
                    {
                      attrs: {
                        "model-value": _vm.showSolution,
                        "check-value": true,
                        id: "show-solution-switch"
                      },
                      on: { change: _vm.toggleShowSolution }
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("common.modal.preview.show_solution"))
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "divider" }),
              _vm._v(" "),
              _vm.isStorePage
                ? _c(
                    "span",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-500 passive-link-btns clickable",
                      on: {
                        click: function($event) {
                          return _vm.showReportContentModal()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("common.modal.preview.report_content")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.hasAudio(_vm.currentPage)
        ? _c("LcAudio", {
            attrs: { audio: _vm.getFormattedAudio(_vm.currentPage) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNoPages
        ? _c("div", {
            staticClass:
              "typography--body-2 typography--color-disabled text-center mt-5",
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.preview.no_pages"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onShown
        ? _c(
            "div",
            {
              staticClass: "preview-content-container",
              class: { "show-solution": _vm.showSolution }
            },
            [
              _vm.isQuizPage
                ? _c("div", { staticClass: "quiz-badge" }, [
                    _c("span", { staticClass: "badge badge-default" }, [
                      _vm._v(_vm._s(_vm.$t("common.card.quiz")))
                    ]),
                    _vm._v(" "),
                    _vm.isClassAssignmentPreview
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "typography--body-3 typography--color-secondary ml-1"
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t(
                                    "common.modal.preview.class_average_score"
                                  )
                                ) +
                                ": " +
                                _vm._s(
                                  _vm.getAverageQuizScoreRatio(
                                    _vm.currentPage.submitted_answers
                                  )
                                ) +
                                "%\n      "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary float-right"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.numeric_score", {
                              n: _vm.currentPage.score || 1
                            })
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasExtraContent
                ? _c("div", { staticClass: "preview-content" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.currentPage.extra_content.title) +
                        "\n      "
                    ),
                    _c("div", [
                      _c("img", {
                        staticClass: "extra-content-image",
                        attrs: { src: _vm.currentPage.extra_content.image_url }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasVideo(_vm.currentPage)
                ? _c("LcVideo", {
                    attrs: { video: _vm.getFormattedVideo(_vm.currentPage) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentPage
                ? _c("div", {
                    staticClass: "preview-content",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.parseHyperlink(_vm.currentPage.content)
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.getPageType() === "multiple_choice" &&
              _vm.isVisibleQuizOptions()
                ? _c(
                    "div",
                    { staticClass: "quiz-answers" },
                    _vm._l(_vm.quizAnswers, function(answer, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "typography--content-body" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(index + 1) +
                              ". " +
                              _vm._s(_vm.getAnswerContent(answer)) +
                              "\n      "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isQuizPage && _vm.showSolution && !_vm.isEssayType
                ? _c("div", { staticClass: "quiz-answer-result-container" }, [
                    _vm.isStudentAssignmentPreview && _vm.submittedAnswer
                      ? _c(
                          "div",
                          {
                            staticClass: "typography--content-body is-incorrect"
                          },
                          [
                            _vm.submittedAnswer &&
                            _vm.submittedAnswer.is_correct
                              ? _c("strong", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.modal.preview.is_correct"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ])
                              : _c("strong", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.modal.preview.is_incorrect"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "quiz-answer-result" }, [
                      _c("span", { staticClass: "typography--body-1" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("common.modal.preview.correct_answer")
                            ) +
                            ":\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.getPageType() === "multiple_choice"
                        ? _c("span", { staticClass: "typography--body-1" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("common.modal.preview.answer_number", {
                                    n: _vm.correctAnswerIndex
                                  })
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getPageType() === "text_entry"
                        ? _c("span", { staticClass: "typography--body-1" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.correctAnswerContents) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isStudentAssignmentPreview
                        ? _c("span", { staticClass: "incorrect-answer-area" }, [
                            _c(
                              "span",
                              { staticClass: "typography--color-dividers" },
                              [_vm._v("|")]
                            ),
                            _vm._v(" "),
                            _vm.getPageType() === "multiple_choice"
                              ? _c(
                                  "span",
                                  { staticClass: "typography--body-1" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.modal.preview.chosen_answer"
                                          )
                                        ) +
                                        ":\n            "
                                    ),
                                    _vm.submittedAnswer
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.modal.preview.answer_number",
                                                  {
                                                    n: _vm.submittedAnswerIndex
                                                  }
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ])
                                      : _c("span", [_vm._v("-")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getPageType() === "text_entry"
                              ? _c(
                                  "span",
                                  { staticClass: "typography--body-1" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.modal.preview.entered_answer"
                                          )
                                        ) +
                                        ":\n            "
                                    ),
                                    _vm.submittedAnswer
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.submittedAnswerContent
                                              ) +
                                              "\n            "
                                          )
                                        ])
                                      : _c("span", [_vm._v("-")])
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.isStudentAssignmentPreview &&
                    _vm.submittedAnswer &&
                    !_vm.submittedAnswer.is_correct
                      ? _c("div", { staticClass: "incorrect-img" }, [
                          _c("img", {
                            attrs: { src: "/static/images/quiz-wrong-s.svg" }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isStudentAssignmentPreview &&
                    _vm.submittedAnswer &&
                    _vm.submittedAnswer.is_correct
                      ? _c("div", { staticClass: "correct-img" }, [
                          _c("img", {
                            attrs: { src: "/static/images/quiz-correct-s.png" }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isClassAssignmentPreview &&
                    _vm.currentPage.submitted_answers &&
                    _vm.currentPage.submitted_answers.length > 0
                      ? _c(
                          "div",
                          { staticClass: "class-quiz-answer-results" },
                          [
                            _vm.getPageType() === "multiple_choice"
                              ? _c(
                                  "div",
                                  _vm._l(_vm.quizAnswers, function(
                                    answer,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "typography--body-1 typography--color-secondary"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(index + 1) +
                                            ".\n            " +
                                            _vm._s(
                                              _vm.getSumittedAnswerCount(answer)
                                            ) +
                                            _vm._s(
                                              _vm.$t(
                                                "common.modal.preview.count"
                                              )
                                            ) +
                                            "\n            (" +
                                            _vm._s(
                                              _vm.getSumittedAnswerRatio(
                                                _vm.getSumittedAnswerCount(
                                                  answer
                                                )
                                              )
                                            ) +
                                            "%)\n          "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getPageType() === "text_entry"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    _vm.summarizedSubmittedAnswers,
                                    function(value, key) {
                                      return _c(
                                        "div",
                                        {
                                          key: key,
                                          staticClass:
                                            "typography--body-1 typography--color-secondary"
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(key) +
                                              " -\n            " +
                                              _vm._s(value.length) +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.modal.preview.count"
                                                )
                                              ) +
                                              "\n            (" +
                                              _vm._s(
                                                _vm.getSumittedAnswerRatio(
                                                  value.length
                                                )
                                              ) +
                                              "%)\n          "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isQuizPage && _vm.showSolution
                ? _c("div", { staticClass: "quiz-description" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--content-body description-header"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("common.card.page.description")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.currentPage &&
                    !_vm.isEssayType &&
                    _vm.currentPage.description
                      ? _c("div", {
                          staticClass: "preview-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.parseHyperlink(_vm.currentPage.description)
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentPage &&
                    _vm.isEssayType &&
                    _vm.currentPage.description
                      ? _c("div", {
                          staticClass: "preview-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.parseHyperlink(
                                _vm.currentPage.description
                                  .replace(/\n/g, "<br>")
                                  .replace(/\\n/g, "<br>")
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c("div", { staticClass: "col-5 hidden-sm-up" }, [
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary btn-fab btn-mini-fab mr-1",
                    attrs: {
                      type: "button",
                      disabled: _vm.currentPageIndex === 0
                    },
                    on: { click: _vm.prev }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary btn-fab btn-mini-fab",
                    attrs: { type: "button", disabled: _vm.isLastPage },
                    on: { click: _vm.next }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_forward")
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-5 hidden-xs-down" }, [
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary mr-1",
                    attrs: {
                      type: "button",
                      disabled: _vm.currentPageIndex === 0
                    },
                    on: { click: _vm.prev }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("common.previous")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary",
                    attrs: { type: "button", disabled: _vm.isLastPage },
                    on: { click: _vm.next }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("common.next")) + "\n      "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 text-center page-counter" }, [
            !_vm.isPagePreview
              ? _c(
                  "small",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.currentPageIndex + 1) +
                        "/" +
                        _vm._s(_vm.cardPagesLength) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d558bed0", esExports)
  }
}

/***/ }),

/***/ "pjQi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_SELECTED_CARD_FOR_NEW_ASMT = 'assignments/SET_SELECTED_CARD_FOR_NEW_ASMT';
var SET_ASSIGNMENT_STATS = 'assignments/SET_ASSIGNMENT_STATS';
var REMOVE_ASSIGNMENT = 'assignments/REMOVE_ASSIGNMENT';
var UPDATE_ASSIGNMENT = 'assignments/UPDATE_ASSIGNMENT';
var SET_ASSIGNMENTS = 'assignments/SET_ASSIGNMENTS';
var ADD_ASSIGNMENTS = 'assignments/ADD_ASSIGNMENTS';
var ADD_ASSIGNMENT = 'assignments/ADD_ASSIGNMENT';
var SET_CARD_PAGES = 'assignments/SET_CARD_PAGES';
var SET_SELECTED = 'assignments/SET_SELECTED';
var SET_PROPERTY = 'assignments/SET_PROPERTY';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SELECTED_CARD_FOR_NEW_ASMT: SET_SELECTED_CARD_FOR_NEW_ASMT,
  SET_ASSIGNMENT_STATS: SET_ASSIGNMENT_STATS,
  REMOVE_ASSIGNMENT: REMOVE_ASSIGNMENT,
  UPDATE_ASSIGNMENT: UPDATE_ASSIGNMENT,
  SET_ASSIGNMENTS: SET_ASSIGNMENTS,
  ADD_ASSIGNMENTS: ADD_ASSIGNMENTS,
  ADD_ASSIGNMENT: ADD_ASSIGNMENT,
  SET_CARD_PAGES: SET_CARD_PAGES,
  SET_SELECTED: SET_SELECTED,
  SET_PROPERTY: SET_PROPERTY
});

/***/ }),

/***/ "ptPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn mr-10 mt-10",
      class: { "btn-primary": _vm.isSelected, "btn-inactive": !_vm.isSelected },
      attrs: { disabled: _vm.loading },
      on: {
        click: function($event) {
          return _vm.$emit("domain-option-clicked", _vm.domain.id)
        }
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.domain.name) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e54c342", esExports)
  }
}

/***/ }),

/***/ "q7yG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editor-toobar',

  data: function data() {
    return {
      acceptableImageTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      acceptableAudioTypes: ['audio/x-mpeg3', 'audio/x-flac', 'audio/mpeg3', 'audio/x-mp3', 'audio/x-m4a', 'audio/x-ogg', 'audio/x-wav', 'audio/flac', 'audio/mpeg', 'audio/wave', 'audio/m4a', 'audio/mp4', 'audio/mp3', 'audio/wav', 'audio/ogg'],

      imageSizeLimit: 10 * 1024 * 1024,
      audioSizeLimit: 20 * 1024 * 1024
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['activeEditorLocation', 'activeEditorId']), {
    acceptableImageTypeString: function acceptableImageTypeString() {
      return this.acceptableImageTypes.join(',');
    },
    acceptableAudioTypeString: function acceptableAudioTypeString() {
      return this.acceptableAudioTypes.join(',');
    }
  }),

  methods: {
    getDefaultPlaceholders: function getDefaultPlaceholders() {
      return ['<p>' + this.$t('page_editor.non_quiz.placeholder') + '</p>', '<p>' + this.$t('page_editor.question.placeholder') + '</p>', '<p>' + this.$t('page_editor.choices.placeholder') + '</p>', '<p>' + this.$t('page_editor.text_entry.placeholder') + '</p>', '<p>' + this.$t('page_editor.description.placeholder') + '</p>'];
    },
    resetImageInput: function resetImageInput() {
      this.$refs.imageInputRef.value = '';
    },
    onImageChange: function onImageChange(event) {
      var images = event.target.files || event.dataTransfer.files;

      if (!images.length) {
        return null;
      }

      var file = images[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (file.size > this.imageSizeLimit) {
        return this.$root.$emit('show::modal', 'file-size-alert');
      }

      if (this.acceptableImageTypes.indexOf(file.type) === -1) {
        return this.$root.$emit('show::modal', 'file-type-alert');
      }

      return this.createMedia(file, 'image');
    },
    onAudioChange: function onAudioChange(event) {
      var audios = event.target.files || event.dataTransfer.files;

      if (!audios.length) {
        return null;
      }

      var file = audios[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (file.size > this.audioSizeLimit) {
        return this.$root.$emit('show::modal', 'audio-size-alert');
      }

      if (this.acceptableAudioTypes.indexOf(file.type) === -1) {
        return this.$root.$emit('show::modal', 'audio-type-alert');
      }

      return this.createMedia(file, 'audio');
    },
    onImageLoaded: function onImageLoaded(event, file) {
      var dataImgId = Math.floor(Math.random() * 1000);
      var activeEditor = this.activeEditorId ? tinymce.get(this.activeEditorId) : tinymce.activeEditor;
      if (this.activeEditorLocation) {
        activeEditor.selection.setRng(this.activeEditorLocation);
      }

      if (activeEditor && activeEditor.getContent().indexOf('<img') !== -1) {
        return this.$root.$emit('show::modal', 'max-image-limit-alert');
      }

      var imgHtml = '<figure><img data-image-id="' + dataImgId + '" src="' + event.target.result + '"></figure>';

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["includes"])(this.getDefaultPlaceholders(), activeEditor.getContent())) {
        activeEditor.setContent(imgHtml);
      } else {
        activeEditor.insertContent(imgHtml);
      }

      return this.$emit('image-added', {
        in_content: activeEditor.id.indexOf('quiz-editor-') !== -1,
        key: dataImgId,
        image_file: file,
        image_url: event.target.result
      });
    },
    onAudioLoaded: function onAudioLoaded(event, file) {
      return this.$emit('audio-added', {
        audio_file: file,
        audio_url: event.target.result
      });
    },
    createMedia: function createMedia(file, mediaType) {
      var _this = this;

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function (event) {
        switch (mediaType) {
          case 'image':
            return _this.onImageLoaded(event, file);
          case 'audio':
            return _this.onAudioLoaded(event, file);
          default:
            return null;
        }
      };

      return reader.readAsDataURL(file);
    },
    addVideo: function addVideo() {
      var activeEditor = void 0;

      if (this.activeEditorId) {
        activeEditor = tinymce.get(this.activeEditorId);

        if (this.activeEditorLocation) {
          activeEditor.selection.setRng(this.activeEditorLocation);
        }
      } else {
        activeEditor = tinymce.activeEditor;
      }

      if (activeEditor && activeEditor.getContent().indexOf('<iframe') !== -1) {
        return this.$root.$emit('show::modal', 'max-video-limit-alert');
      }

      return this.$emit('show-add-video-modal');
    },
    addMath: function addMath() {
      this.$root.$emit('show::modal', 'math-editor-modal');
    },
    boldText: function boldText() {
      tinymce.EditorManager.execCommand('Bold', true);
    },
    italicText: function italicText() {
      tinymce.EditorManager.execCommand('Italic', true);
    },
    underlineText: function underlineText() {
      tinymce.EditorManager.execCommand('Underline', true);
    },
    addUl: function addUl() {
      tinymce.EditorManager.execCommand('InsertUnorderedList', true);
    },
    addOl: function addOl() {
      tinymce.EditorManager.execCommand('InsertOrderedList', true);
    }
  }
});

/***/ }),

/***/ "qI5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagination__ = __webpack_require__("tHl9");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__answerCriteria__ = __webpack_require__("NkA/");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__answerCriteria__["a"]; });



/***/ }),

/***/ "qJ5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollAppHeader_vue__ = __webpack_require__("SxYe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48717d41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollAppHeader_vue__ = __webpack_require__("BsW3");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("TwK6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollAppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48717d41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollAppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ScrollAppHeader.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48717d41", Component.options)
  } else {
    hotAPI.reload("data-v-48717d41", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qNpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InProgressBadge_vue__ = __webpack_require__("IBWz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3f5dd1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InProgressBadge_vue__ = __webpack_require__("1ekj");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InProgressBadge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3f5dd1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InProgressBadge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/InProgressBadge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b3f5dd1", Component.options)
  } else {
    hotAPI.reload("data-v-1b3f5dd1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qVUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("MRjo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("56Sp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("5+pX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("sAw7");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "qYau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("dmSE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("66Wm");



var module = {
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "qbKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("symk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce5b7f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("JsV8");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce5b7f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/errors/views/NotFound.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ce5b7f86", Component.options)
  } else {
    hotAPI.reload("data-v-ce5b7f86", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qr4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dummy-detail-card'
});

/***/ }),

/***/ "qrX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_QuizPreview__ = __webpack_require__("oFyy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_quiz__ = __webpack_require__("cUxh");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quiz-form-modal',

  props: {
    quiz: {
      type: Object,
      default: {}
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_quiz__["a" /* default */]],

  data: function data() {
    return {
      isPreviewQuiz: false,
      selectedQuizType: 0,
      quizTypes: [{ name: '객관식(4지선다)', options_label: '보기 입력', options_count: 4 }, { name: 'OX퀴즈', options_label: '정답 입력', options_count: 2 }],
      tags: [{ name: '상식', color: '' }, { name: '넌센스', color: '' }, { name: '일상', color: '' }, { name: '명언', color: '' }, { name: '효도', color: '' }, { name: '시사', color: '' }, { name: '경제', color: '' }, { name: '동물', color: '' }, { name: '신체', color: '' }, { name: '맞춤법', color: '' }, { name: '외국어', color: '' }],
      selectedTags: [],
      content: '',
      options: [],
      selectedOption: 0,
      answer: ''
    };
  },


  components: {
    QuizPreview: __WEBPACK_IMPORTED_MODULE_6__components_QuizPreview__["a" /* default */]
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['createQuiz', 'updateQuiz']), {
    handleTagClick: function handleTagClick(value) {
      if (this.isSelectedTag(value)) {
        this.selectedTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(this.selectedTags, function (item) {
          return item.name !== value.name;
        });
        return;
      }

      this.selectedTags.push(value);
    },
    handleNewQuizClick: function handleNewQuizClick() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.isEmptyQuiz) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                data = {
                  content: _this.content,
                  options: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.getQuizOptions(_this.options)),
                  tags: _this.getTags
                };
                _context.next = 5;
                return _this.createQuiz(data);

              case 5:
                _context.next = 7;
                return _this.$emit('cancel');

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleUpdateQuizClick: function handleUpdateQuizClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.quiz.id) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                data = {
                  id: _this2.quiz.id,
                  content: _this2.content,
                  options: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.getQuizOptions(_this2.options)),
                  tags: _this2.getTags
                };
                _context2.next = 5;
                return _this2.updateQuiz(data);

              case 5:
                _context2.next = 7;
                return _this2.$emit('cancel');

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    isSelectedTag: function isSelectedTag(value) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.selectedTags, { name: value.name }));
    },
    isCorrectOption: function isCorrectOption(option) {
      return option.key === this.selectedOption;
    },
    handleQuizTypeChange: function handleQuizTypeChange(value) {
      this.selectedQuizType = value;
      this.options = this.getNewQuizOptions();
    },
    getNewQuizOptions: function getNewQuizOptions() {
      if (this.selectedQuizType === 1) {
        return [{
          value: 'O',
          is_answer: true,
          key: 0
        }, {
          value: 'X',
          is_answer: false,
          key: 1
        }];
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["range"])(this.quizType.options_count), function (item) {
        return {
          value: '',
          is_answer: false,
          key: item
        };
      });
    },
    handleOptionChange: function handleOptionChange(value) {
      this.selectedOption = value;
    },
    handlePreviewQuizClick: function handlePreviewQuizClick() {
      this.isPreviewQuiz = true;
    },
    handlePreviewCloseClick: function handlePreviewCloseClick() {
      this.isPreviewQuiz = false;
    },
    getQuizOptions: function getQuizOptions(options) {
      var _this3 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(options, function (item, index) {
        return {
          key: index,
          value: item.value,
          is_answer: _this3.isCorrectOption(item),
          answer: _this3.answer
        };
      });
    }
  }),

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    isLoading: 'isLoadingQuiz'
  }), {
    quizType: function quizType() {
      return this.quizTypes[this.selectedQuizType];
    },
    isDisabledTags: function isDisabledTags() {
      var LIMIT_TABS = 2;
      return this.selectedTags.length > LIMIT_TABS || this.selectedTags.length === 0;
    },
    isDisabledQuiz: function isDisabledQuiz() {
      return this.content.length === 0 || this.isDisabledTags || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(this.options, function (item) {
        return item.value.length === 0;
      })) || this.answer.length === 0;
    },
    isNewQuiz: function isNewQuiz() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.quiz);
    },
    getTags: function getTags() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(this.selectedTags, 'name').join(',');
    },
    getPreviewQuizData: function getPreviewQuizData() {
      return {
        content: this.content,
        options: this.getQuizOptions(this.options),
        tags: this.getTags
      };
    }
  }),

  beforeMount: function beforeMount() {
    if (!this.isNewQuiz) {
      var option = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["head"])(this.quiz.options);
      var tags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["split"])(this.quiz.tags, ',', this.tags.length), function (item) {
        return { name: item };
      });
      this.content = this.quiz.content;
      this.options = this.getQuizOptions(this.quiz.options);
      this.selectedQuizType = this.isNoOptionsQuiz(this.quiz.options) ? 1 : 0;
      this.selectedTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(this.tags, function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(tags, { name: item.name });
      });
      this.selectedOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(this.quiz.options, { is_answer: true });
      this.answer = option.answer || '';
    }

    if (this.isNewQuiz) {
      this.options = this.getNewQuizOptions();
    }
  }
});

/***/ }),

/***/ "r5lM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome-message-modal',

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setTutorialAsChecked']))
});

/***/ }),

/***/ "rC0b":
/***/ (function(module, exports) {

module.exports = {"Play":"Play","Pause":"Pausa","Current Time":"Orario attuale","Duration Time":"Durata","Remaining Time":"Tempo rimanente","Stream Type":"Tipo del Streaming","LIVE":"LIVE","Loaded":"Caricato","Progress":"Stato","Fullscreen":"Schermo intero","Non-Fullscreen":"Chiudi schermo intero","Mute":"Muto","Unmute":"Audio","Playback Rate":"Tasso di riproduzione","Subtitles":"Sottotitoli","subtitles off":"Senza sottotitoli","Captions":"Sottotitoli non udenti","captions off":"Senza sottotitoli non udenti","Chapters":"Capitolo","You aborted the media playback":"La riproduzione del filmato è stata interrotta.","A network error caused the media download to fail part-way.":"Il download del filmato è stato interrotto a causa di un problema rete.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Il filmato non può essere caricato a causa di un errore nel server o nella rete o perché il formato non viene supportato.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"La riproduzione del filmato è stata interrotta a causa di un file danneggiato o per l’utilizzo di impostazioni non supportate dal browser.","No compatible source was found for this media.":"Non ci sono fonti compatibili per questo filmato."}

/***/ }),

/***/ "rM12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_PUB_CARD_PAGES = 'storeCards/SET_PUB_CARD_PAGES';
var SET_CARD_PAGES = 'storeCards/SET_CARD_PAGES';
var SET_SELECTED = 'storeCards/SET_SELECTED';
var SET_CARDS = 'storeCards/SET_CARDS';
var ADD_CARDS = 'storeCards/ADD_CARDS';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_PUB_CARD_PAGES: SET_PUB_CARD_PAGES,
  SET_CARD_PAGES: SET_CARD_PAGES,
  SET_SELECTED: SET_SELECTED,
  SET_CARDS: SET_CARDS,
  ADD_CARDS: ADD_CARDS
});

/***/ }),

/***/ "rcBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-page-summary',

  props: ['card-title', 'index', 'page', 'card'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentPublisherInfo', 'isPublisherUser', 'currentUser', 'coreConcepts']), {
    isEditablePage: function isEditablePage() {
      return this.page && this.page.author_id === this.currentUser.id && (!this.page.is_copied_page || this.isPublisherUser && this.currentPublisherInfo.user_id === this.page.author_id && this.currentPublisherInfo.id === this.page.publisher_id);
    },
    getCoreConceptDescription: function getCoreConceptDescription() {
      var coreConceptName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.coreConcepts[this.page.core_concept_id], 'name', '');
      return coreConceptName;
    },
    getPageMetadataBackgroundColor: function getPageMetadataBackgroundColor() {
      if (this.card && this.card.core_concept_id !== this.page.core_concept_id) {
        return '#ff0000aa';
      }
      if (this.page.share_level === 1) {
        return '#00ff0060';
      }
      if (this.page.share_level === 99) {
        return '#0000ff60';
      }
      return '#00000015';
    },
    getPageShareLevelDescription: function getPageShareLevelDescription() {
      if (this.page.share_level === 1) {
        return '전체 공개';
      }
      if (this.page.share_level === 2) {
        return '비공개';
      }
      if (this.page.share_level === 3) {
        return '기관 공개';
      }
      if (this.page.share_level === 99) {
        return '숨김';
      }
      return this.page.share_level;
    },
    getKeywords: function getKeywords() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(this.page.page_keywords, 'keyword');
    },
    pageContent: function pageContent() {
      return this.page ? this.page.content : '<p></p>';
    },
    summarizedContent: function summarizedContent() {
      return this.pageContent.replace(/<iframe.*<\/iframe>/g, '');
    },
    contentImages: function contentImages() {
      var _this = this;

      return this.page.images.filter(function (image) {
        return _this.page.content.indexOf('data-image-id="' + _this.getImageId(image) + '"') !== -1;
      });
    },
    hasImage: function hasImage() {
      return this.page.image_count > 0 && this.contentImages.length > 0;
    },
    hasAudio: function hasAudio() {
      return this.page.audio_count > 0 && this.page.audios.length > 0;
    },
    hasVideo: function hasVideo() {
      return this.page.video_count > 0 && this.page.videos && this.page.videos.length > 0;
    },
    hasEmbededVideo: function hasEmbededVideo() {
      return this.page.content.match(/<iframe/g) || (this.page.description || '').match(/<iframe/g);
    },
    classBindings: function classBindings() {
      return {
        'has-image': this.hasImage,
        'has-audio': this.hasAudio,
        'has-video': this.hasVideo || this.hasEmbededVideo
      };
    },
    extraContentImageSrc: function extraContentImageSrc() {
      if (this.page.extra_content.image_url) {
        return 'url(\'' + this.page.extra_content.image_url + '\')';
      }
      return '';
    },
    firstImageSrc: function firstImageSrc() {
      if (this.hasImage) {
        var imageUrl = this.contentImages[0].image_url || this.contentImages[0].small_url || this.contentImages[0].medium_url || this.contentImages[0].original_url;

        return 'url(\'' + imageUrl + '\')';
      }

      return '';
    },
    firstAudioDuration: function firstAudioDuration() {
      if (this.hasAudio) {
        return this.page.audios[0].duration;
      }

      return 0;
    },
    firstVideoDuration: function firstVideoDuration() {
      if (this.hasVideo) {
        return this.page.videos[0].duration;
      }

      return 0;
    },
    hasExtraContent: function hasExtraContent() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.page.extra_content);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'setSelectedPreviewCard', 'setIsPagePreview']), {
    getImageId: function getImageId(image) {
      return image.id || image.key;
    },
    openCardPreview: function openCardPreview() {
      var _this2 = this;

      var tempCard = {
        title: this.cardTitle,
        pages: [this.page]
      };

      this.setSelectedPreviewCard(tempCard).then(function () {
        return _this2.setSelectedPreviewPageIndex(0);
      }).then(function () {
        return _this2.setIsPagePreview(true);
      }).then(function () {
        _this2.$root.$emit('show::modal', 'card-preview-modal');
      });
    }
  })
});

/***/ }),

/***/ "rfSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("EXL+");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CORE_CONCEPT_VIDEO_COURSES, function (state, coreConceptVideoCourses) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'coreConceptVideoCourses', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.coreConceptVideoCourses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["difference"])(coreConceptVideoCourses, state.coreConceptVideoCourses)));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_UNITS_WITH_CORE_CONCEPTS, function (state, units) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'unitsWithCoreConcepts', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.unitsWithCoreConcepts, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["difference"])(units, state.units)));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_VIDEO_COURSES, function (state, courseList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoCourses', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.videoCourses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(courseList, function (course) {
    return course.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_VIDEO_COURSE, function (state, courseId) {
  var filtered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(state.videoCourses, function (course) {
    return course.id !== courseId;
  });

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoCourses', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(filtered, function (course) {
    return course.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CORE_CONCEPT_VIDEO_COURSE, function (state, coreConceptVideoCourse) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'coreConceptVideoCourse', coreConceptVideoCourse);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].FETCH_CORE_CONCEPT_VIDEO_COURSES, function (state, coreConceptVideoCourses) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'coreConceptVideoCourse', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(coreConceptVideoCourses));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].UPDATE_CORE_CONCEPT_VIDEO_COURSE, function (state, coreConceptVideoCourse) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'coreConceptVideoCourse', coreConceptVideoCourse);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "rgzp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video-player" }, [
      _c("video", { staticClass: "video-js vjs-custom-skin" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e6ee47f", esExports)
  }
}

/***/ }),

/***/ "rh7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("evzl");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__app__["b" /* store */].modules));

/***/ }),

/***/ "rhdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("NU23");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54cdc180_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("Iqoe");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54cdc180_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Card.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-54cdc180", Component.options)
  } else {
    hotAPI.reload("data-v-54cdc180", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ro9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toggle-switch',

  props: ['id', 'model-value', 'check-value'],

  data: function data() {
    return {
      isChecked: false
    };
  },


  computed: {
    state: function state() {
      return this.modelValue === this.checkValue;
    }
  },

  methods: {
    check: function check() {
      return this.$emit('change', this.checkValue);
    },
    uncheck: function uncheck() {
      if (this.checkValue === true) {
        return this.$emit('change', false);
      }

      return this.$emit('change', null);
    },
    onChange: function onChange() {
      if (this.state) {
        this.uncheck();
      } else {
        this.check();
      }
    }
  }
});

/***/ }),

/***/ "s3LW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  videoLectures: {},

  recentVideoUploadInfo: null
});

/***/ }),

/***/ "s4iX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_publisherOnly__ = __webpack_require__("vWCn");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upload-video-lecture',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_publisherOnly__["a" /* default */]],

  data: function data() {
    return {
      busy: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setRecentVideoUploadInfoInStore', 'getVideoLectureUploadUrl', 'uploadVideoLecture']), {
    onVideoInputChange: function onVideoInputChange(event) {
      if (this.busy) {
        return null;
      }

      var images = event.target.files || event.dataTransfer.files;

      if (!images.length) {
        return null;
      }

      var file = images[0];

      if (!file || file.size === undefined || file.type === undefined) {
        return null;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["startsWith"])(file.type, 'video/')) {
        return this.$root.$emit('show::modal', 'video-type-alert');
      }

      return this.createMedia(file);
    },
    createMedia: function createMedia(file) {
      var _this = this;

      if (!window.FileReader) {
        return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
      }

      var reader = new window.FileReader();

      reader.onload = function () {
        _this.uploadVideo(file);
      };

      this.busy = true;

      return reader.readAsDataURL(file);
    },
    uploadVideo: function uploadVideo(videoFile) {
      var _this2 = this;

      this.getVideoLectureUploadUrl().then(function (uploadInfo) {
        var _uploadInfo$upload_li = uploadInfo.upload_link.split('?'),
            _uploadInfo$upload_li2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_uploadInfo$upload_li, 2),
            uploadUrl = _uploadInfo$upload_li2[0],
            queryString = _uploadInfo$upload_li2[1];

        var queryParams = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(queryString);
        var uploadLink = uploadUrl + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["omit"])(queryParams, 'redirect_url'));
        var params = {
          uploadLink: uploadLink,
          videoFile: videoFile
        };

        return _this2.uploadVideoLecture(params).then(function () {
          return _this2.setRecentVideoUploadInfoInStore(uploadInfo);
        }).then(function () {
          return _this2.$router.replace('new-video-lecture');
        });
      });
    }
  })
});

/***/ }),

/***/ "sAw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["selectedStoreCardId"] = selectedStoreCardId;
/* harmony export (immutable) */ __webpack_exports__["storeCardList"] = storeCardList;
/* harmony export (immutable) */ __webpack_exports__["storeCards"] = storeCards;
/* harmony export (immutable) */ __webpack_exports__["publisherCards"] = publisherCards;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function selectedStoreCardId(state) {
  return state.selectedStoreCardId;
}

function storeCardList(state) {
  return state.storeCardList;
}

function storeCards(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keyBy"])(state.storeCardList.filter(function (card) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(card.store_card_id);
  }), function (card) {
    return card.id;
  });
}

function publisherCards(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["keyBy"])(state.storeCardList.filter(function (card) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(card.store_card_id);
  }), function (card) {
    return card.id;
  });
}

/***/ }),

/***/ "sOIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["checkUserTutorial"] = checkUserTutorial;
/* harmony export (immutable) */ __webpack_exports__["setCheckedTutorials"] = setCheckedTutorials;
/* harmony export (immutable) */ __webpack_exports__["setTutorialAsChecked"] = setTutorialAsChecked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("k/oC");







function checkUserTutorial(_ref) {
  var dispatch = _ref.dispatch,
      state = _ref.state,
      getters = _ref.getters;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(state.checkedTutorials)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.checkedTutorials);
  }

  var userCheckedTutorialStr = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["p" /* USER_TUTORIAL_KEY */] + '/' + getters.currentUserId);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(userCheckedTutorialStr)) {
    return dispatch('setCheckedTutorials', {
      welcome: false,
      tryNewMyCard: false,
      tryAddNewPages: false,
      trySelectAndAddPages: false,
      tryAssign: false,
      trySetDueDate: false,
      tryCheckClass: false,
      tryCustomCard: false
    });
  }

  return dispatch('setCheckedTutorials', JSON.parse(userCheckedTutorialStr));
}

function setCheckedTutorials(_ref2, checkedTutorials) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CHECKED_TUTORIALS, checkedTutorials);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setTutorialAsChecked(_ref3, tutorial) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].CHECK_TUTORIAL, tutorial);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

/***/ }),

/***/ "sQ9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("aoyf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("/OdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("Eahh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("LWwL");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "shMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-courses" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-courses" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_courses"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-lectures" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_lectures"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-primary new-video-course-btn float-right",
                    attrs: { to: "/upload-video-lecture" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.new_video_lecture")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.lectures.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("video_lectures.no_lectures")
                            )
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.lectures, function(videoLecture) {
                      return _c(
                        "div",
                        {
                          key: videoLecture.id,
                          staticClass: "col-sm-6 col-md-4 col-lg-3"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "card-row",
                              attrs: {
                                to: "/video-lectures/" + videoLecture.id,
                                tag: "div"
                              }
                            },
                            [
                              _c("VideoLectureItem", {
                                attrs: { lecture: videoLecture }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-417e449a", esExports)
  }
}

/***/ }),

/***/ "slOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7 col-xl-8" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile"
              },
              [_vm._v("\n          " + _vm._s(_vm.cardTitle) + "\n        ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 col-lg-5 col-xl-4 hidden-sm-down" },
            [
              _c("div", { staticClass: "action-btn-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right mr-1",
                    on: { click: _vm.openCardPreview }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.preview")))]
                )
              ])
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-4 pt-1",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row" }, [
          !_vm.card
            ? _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "card-row" }, [_c("DummyCard")], 1)
              ])
            : _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [
                    _c("Card", { staticClass: "library-detail-card" }, [
                      _c("div", {
                        staticClass: "card-cover-img-thumb",
                        style: _vm.styleBindings
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-block" }, [
                        _c("div", { staticClass: "card-info-section" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getSubjectLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getGradeLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _vm.card.chapter_name
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.card.chapter_name) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _vm.card.core_concept_id
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getCoreConceptLabel(
                                              _vm.card.core_concept
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-keywords-section" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.learning_elements"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _vm.card.core_concept_id
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getLearningElements(
                                              _vm.card.core_concept
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-bottom-desc" }, [
                        _c(
                          "small",
                          {
                            staticClass:
                              "typography--caption typography--color-secondary"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.card.non_quiz")) +
                                " " +
                                _vm._s(
                                  _vm.$t("common.card.count", {
                                    cnt:
                                      _vm.card.page_count - _vm.card.quiz_count
                                  })
                                ) +
                                " ∙\n                " +
                                _vm._s(_vm.$t("common.card.quiz")) +
                                " " +
                                _vm._s(
                                  _vm.$t("common.card.count", {
                                    cnt: _vm.card.quiz_count
                                  })
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "small",
                          {
                            staticClass:
                              "typography--caption typography--color-secondary"
                          },
                          [
                            _c("strong", [_vm._v(_vm._s(_vm.cardAuthorName))]),
                            _vm._v(" "),
                            _vm.card.assigned_count
                              ? _c("span", [
                                  _vm._v(
                                    "| " +
                                      _vm._s(
                                        _vm.$t("common.card.share_count", {
                                          cnt: _vm.card.assigned_count
                                        })
                                      )
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.card.publisher_id
                          ? _c(
                              "small",
                              {
                                staticClass:
                                  "typography--caption typography--color-secondary"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.card.updated_at")) +
                                    ": " +
                                    _vm._s(
                                      _vm._f("datetime")(_vm.card.updated_at)
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ],
                  1
                )
              ]),
          _vm._v(" "),
          !_vm.pagesReady
            ? _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [_c("DummyPageSummary")],
                  1
                )
              ])
            : _c(
                "div",
                { staticClass: "col-md-8" },
                _vm._l(_vm.card.pages, function(page, index) {
                  return _c(
                    "div",
                    { key: page.id, staticClass: "card-row" },
                    [
                      _c("PageSummary", { attrs: { page: page, index: index } })
                    ],
                    1
                  )
                }),
                0
              )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "no-class-to-assign-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.no_class_to_assign_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hidden-md-up",
        attrs: { slot: "floating-action-menu" },
        slot: "floating-action-menu"
      },
      [
        _c(
          "FloatingDropup",
          [
            _c("b-dropdown-item", { on: { click: _vm.openCardPreview } }, [
              _vm._v(_vm._s(_vm.$t("common.preview")))
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74c30b86", esExports)
  }
}

/***/ }),

/***/ "symk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'not-found'
});

/***/ }),

/***/ "t+79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EvaluationBadge__ = __webpack_require__("6a9H");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-table-row',

  components: {
    EvaluationBadge: __WEBPACK_IMPORTED_MODULE_3__EvaluationBadge__["a" /* default */]
  },

  props: {
    evaluation: {
      type: Object,
      default: null
    },
    selectedDomainIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      loading: false,

      snackbarOptions: {
        message: this.$t('evaluations.snackbar.copied_to_clipboard'),
        actionText: this.$t('evaluations.snackbar.dismiss'),
        actionHandler: function actionHandler() {}
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evaluationFilters']), {
    evaluationComment: function evaluationComment() {
      if (this.evaluation && this.evaluation.evaluation && this.evaluation.evaluation !== '작성 가능한 과제 활동이 없습니다.') {
        return this.evaluation.evaluation;
      }

      return null;
    },
    evaluationNotSupported: function evaluationNotSupported() {
      if (this.evaluation) {
        return this.evaluation.not_supported;
      }

      return false;
    },
    domains: function domains() {
      if (this.evaluation && this.evaluation.domains_id && this.evaluation.domains_name && this.evaluation.domains_grade) {
        var domainIds = this.evaluation.domains_id.split(',');
        var domainNames = this.evaluation.domains_name.split(',');
        var domainGrades = this.evaluation.domains_grade.split(',');

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["zipWith"])(domainIds, domainNames, domainGrades, function (id, name, grade) {
          return {
            id: id,
            name: name,
            grade: grade
          };
        });
      }

      return [];
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchEvaluation']), {
    refreshEvaluation: function refreshEvaluation() {
      var _this = this;

      this.loading = true;

      var params = {
        studentId: this.evaluation.student_id,
        filters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.evaluationFilters, {
          domains: this.selectedDomainIds.join(',')
        }),
        index: this.evaluation.index
      };

      this.fetchEvaluation(params).then(function () {
        _this.loading = false;
      });
    }
  })
});

/***/ }),

/***/ "t/qG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chapter-list-item" }, [
    _c(
      "div",
      {
        staticClass: "chapter-list-item__chapter-info clickable",
        class: { "chapter-list-item__chapter-info--active": _vm.isActive },
        on: {
          click: function($event) {
            return _vm.selectChapter()
          }
        }
      },
      [
        _c("div", { staticClass: "chapter-list-item__chapter-description" }, [
          _c(
            "div",
            {
              staticClass:
                "chapter-list-item__chapter-title typography--caption"
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("series_cards.chapters.index", {
                      i: _vm.chapter.position
                    })
                  ) +
                  ": " +
                  _vm._s(_vm.chapter.name) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f06b5c6", esExports)
  }
}

/***/ }),

/***/ "t/um":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__("8wyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_numbers__ = __webpack_require__("+iR1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_quiz__ = __webpack_require__("cUxh");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-quiz-card',

  props: {
    quiz: {
      type: Object,
      default: {}
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_numbers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_quiz__["a" /* default */]],

  computed: {
    isQuizTags: function isQuizTags() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(this.getQuizTags(this.quiz));
    },
    getQuizTypeName: function getQuizTypeName() {
      if (this.isNoOptionsQuiz(this.quiz.options)) {
        return 'OX퀴즈';
      }

      if (!this.isNoOptionsQuiz(this.quiz.options)) {
        return '객관식(4지선다)';
      }

      return '';
    },
    getQuizSet: function getQuizSet() {
      return this.quiz.quiz_set || {};
    },
    getCorrectResultsCount: function getCorrectResultsCount() {
      return this.quiz.correct_results_count || 0;
    },
    getTotalResultsCount: function getTotalResultsCount() {
      return this.quiz.incorrect_results_count + this.getCorrectResultsCount || 0;
    },
    getQuizCreatedDate: function getQuizCreatedDate() {
      if (!this.getQuizSet.created_at) {
        return '-';
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["a" /* format */])(new Date(this.getQuizSet.created_at), 'yyyy-MM-dd');
    }
  }

});

/***/ }),

/***/ "t1lr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "editor-toolbar" }, [
    _c("div", { staticClass: "toolbar-btn-group" }, [
      _c("label", { staticClass: "toolbar-btn toolbar-add-img clickable" }, [
        _c("input", {
          ref: "imageInputRef",
          staticClass: "no-display",
          attrs: { type: "file", accept: _vm.acceptableImageTypeString },
          on: { click: _vm.resetImageInput, change: _vm.onImageChange }
        })
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-video clickable",
        on: { click: _vm.addVideo }
      }),
      _vm._v(" "),
      _c("label", { staticClass: "toolbar-btn toolbar-add-audio clickable" }, [
        _c("input", {
          staticClass: "no-display",
          attrs: { type: "file", accept: _vm.acceptableAudioTypeString },
          on: { change: _vm.onAudioChange }
        })
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-math clickable",
        on: { click: _vm.addMath }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toolbar-btn-group" }, [
      _c("button", {
        staticClass: "toolbar-btn toolbar-bold-text clickable",
        on: { click: _vm.boldText }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-italic-text clickable",
        on: { click: _vm.italicText }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-underline-text clickable",
        on: { click: _vm.underlineText }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toolbar-btn-group" }, [
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-ul clickable",
        on: { click: _vm.addUl }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "toolbar-btn toolbar-add-ol clickable",
        on: { click: _vm.addOl }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b57aa4e", esExports)
  }
}

/***/ }),

/***/ "t56z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLectureItem_vue__ = __webpack_require__("4xbG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518c2c2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLectureItem_vue__ = __webpack_require__("2IbC");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("6WE2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-518c2c2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoLectureItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518c2c2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoLectureItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/video-lectures/components/VideoLectureItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-518c2c2e", Component.options)
  } else {
    hotAPI.reload("data-v-518c2c2e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t8qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPage_vue__ = __webpack_require__("P6Ue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e37d9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPage_vue__ = __webpack_require__("c6YG");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e37d9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/edit-page/views/EditPage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-50e37d9e", Component.options)
  } else {
    hotAPI.reload("data-v-50e37d9e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tGcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["advertisement"] = advertisement;

function advertisement(state) {
  return state.advertisement || {};
}

/***/ }),

/***/ "tHl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PER_PAGE; });

var PER_PAGE = 40;

/***/ }),

/***/ "tQIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("3QMj");



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_VIDEO_LECTURE, function (state, lectureList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoLectures', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.videoLectures, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(lectureList, function (lecture) {
    return lecture.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_VIDEO_LECTURE, function (state, lectureId) {
  var filtered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["filter"])(state.videoLectures, function (lecture) {
    return lecture.id !== lectureId;
  });

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoLectures', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(filtered, function (lecture) {
    return lecture.id;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].CLEAR_VIDEO_LECTURES, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'videoLectures', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_RECENT_UPLOAD_INFO, function (state, uploadInfo) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'recentVideoUploadInfo', uploadInfo);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "tnmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAnswerButton_vue__ = __webpack_require__("UNMB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8f26a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAnswerButton_vue__ = __webpack_require__("2vgd");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAnswerButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8f26a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAnswerButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/AddAnswerButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b8f26a4", Component.options)
  } else {
    hotAPI.reload("data-v-6b8f26a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "trVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forbidden_vue__ = __webpack_require__("BsrQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3029ac1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forbidden_vue__ = __webpack_require__("Ofg8");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forbidden_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3029ac1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forbidden_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/errors/views/Forbidden.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3029ac1b", Component.options)
  } else {
    hotAPI.reload("data-v-3029ac1b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u+tO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




var MathQuill = __webpack_require__("4o45");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'math-editor-modal',

  props: ['id', 'config'],

  data: function data() {
    return {
      mathField: null,

      currentTab: 'basic'
    };
  },


  methods: {
    writeMathCmd: function writeMathCmd(latex, isCmd) {
      if (this.mathField && isCmd) {
        this.mathField.cmd(latex);
        this.mathField.focus();
      } else if (this.mathField && !isCmd) {
        this.mathField.write(latex);
        this.mathField.focus();
      }
    },
    getLatex: function getLatex() {
      return this.mathField.latex();
    },
    clear: function clear() {
      this.mathField.latex('');
    },
    addMath: function addMath() {
      this.$emit('add', this.getLatex());
      this.clear();
    }
  },

  mounted: function mounted() {
    var MQ = MathQuill.getInterface(2);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(this.$el.getElementsByClassName('mathquill-embedded-latex'), function (el) {
      return MQ.StaticMath(el);
    });

    this.mathField = MQ.MathField(this.$el.getElementsByClassName('math-editor-field')[0]);


    this.mathField.focus();
  }
});

/***/ }),

/***/ "u655":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("RQVd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("mab8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("Y47w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("MjF7");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "uCIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  libraryFilters: {
    subject_id: '0',
    grade_id: '0',
    unit_id: '0',
    chapter_position: '0',
    core_concept_id: '0',
    publisher_id: '0',
    media_type: 'all',
    order_by: 'updated_at',
    search_keywords: '',
    share_level: 1,
    offset: 0,
    school_id: '',
    school_year: '0'
  },

  myCardsFilters: {
    subject_id: '0',
    grade_id: '0',
    unit_id: '0',
    core_concept_id: '0',
    chapter_position: '0',
    media_type: 'all',
    order_by: 'updated_at',
    search_keywords: '',
    offset: 0,
    school_year: '0'
  },

  pageLibraryFilters: {
    subject_id: '0',
    grade_id: '0',
    unit_id: '0',
    core_concept_id: '0',
    chapter_position: '0',
    media_type: 'all',
    order_by: 'updated_at',
    is_quiz: '0',
    search_keywords: '',
    offset: 0,
    school_year: '0'
  },

  assignmentsFilters: {
    status: 'all',
    class_id: 'all',
    per_page: 10,
    page: 1
  },

  subjectMap: {
    0: { name: 'common.selects.all_subjects' },
    9999: { name: 'common.selects.placeholder' }
  },

  gradeMap: {
    0: { name: 'common.selects.all_grades' },
    9999: { name: 'common.selects.placeholder' },
    null: { name: 'common.selects.others' }
  },

  domains: {},

  coreConcepts: {},

  units: {},

  subjectList: [],

  gradeSubjects: []
});

/***/ }),

/***/ "uMsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dummy-page-item'
});

/***/ }),

/***/ "uPNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("uve6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961ceb0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("EY1k");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961ceb0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Radio.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-961ceb0a", Component.options)
  } else {
    hotAPI.reload("data-v-961ceb0a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uS0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-card'
});

/***/ }),

/***/ "uUra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", { attrs: { src: _vm.defaultSrc, srcset: _vm.srcSet } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21d9fe24", esExports)
  }
}

/***/ }),

/***/ "udcR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["libraryFilters"] = libraryFilters;
/* harmony export (immutable) */ __webpack_exports__["trimmedLibraryFilters"] = trimmedLibraryFilters;
/* harmony export (immutable) */ __webpack_exports__["myCardsFilters"] = myCardsFilters;
/* harmony export (immutable) */ __webpack_exports__["trimmedMyCardsFilters"] = trimmedMyCardsFilters;
/* harmony export (immutable) */ __webpack_exports__["pageLibraryFilters"] = pageLibraryFilters;
/* harmony export (immutable) */ __webpack_exports__["trimmedPageLibraryFilters"] = trimmedPageLibraryFilters;
/* harmony export (immutable) */ __webpack_exports__["assignmentsFilters"] = assignmentsFilters;
/* harmony export (immutable) */ __webpack_exports__["trimmedAssignmentsFilters"] = trimmedAssignmentsFilters;
/* harmony export (immutable) */ __webpack_exports__["subjectMap"] = subjectMap;
/* harmony export (immutable) */ __webpack_exports__["subjectIds"] = subjectIds;
/* harmony export (immutable) */ __webpack_exports__["subjectList"] = subjectList;
/* harmony export (immutable) */ __webpack_exports__["gradeMap"] = gradeMap;
/* harmony export (immutable) */ __webpack_exports__["gradeIds"] = gradeIds;
/* harmony export (immutable) */ __webpack_exports__["gradeList"] = gradeList;
/* harmony export (immutable) */ __webpack_exports__["coreConcepts"] = coreConcepts;
/* harmony export (immutable) */ __webpack_exports__["units"] = units;
/* harmony export (immutable) */ __webpack_exports__["coreConceptList"] = coreConceptList;
/* harmony export (immutable) */ __webpack_exports__["domainList"] = domainList;
/* harmony export (immutable) */ __webpack_exports__["unitList"] = unitList;
/* harmony export (immutable) */ __webpack_exports__["gradeSubjects"] = gradeSubjects;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



function libraryFilters(state) {
  return state.libraryFilters;
}

function trimmedLibraryFilters(state, getter) {
  return {
    subject_id: state.libraryFilters.subject_id === '0' ? '' : state.libraryFilters.subject_id,
    grade_id: state.libraryFilters.grade_id === '0' ? '' : state.libraryFilters.grade_id,
    unit_id: state.libraryFilters.unit_id === '0' ? '' : state.libraryFilters.unit_id,
    core_concept_id: state.libraryFilters.core_concept_id === '0' ? '' : state.libraryFilters.core_concept_id,
    publisher_id: state.libraryFilters.publisher_id === '0' ? '' : state.libraryFilters.publisher_id,
    chapter_position: getter.currentLibraryChapterPosition,
    media_type: state.libraryFilters.media_type === 'all' ? '' : state.libraryFilters.media_type,
    share_level: state.libraryFilters.share_level,
    order_by: state.libraryFilters.order_by,
    search_keywords: state.libraryFilters.search_keywords,
    offset: state.libraryFilters.offset,
    school_id: state.libraryFilters.school_id
  };
}

function myCardsFilters(state) {
  return state.myCardsFilters;
}

function trimmedMyCardsFilters(state, getter) {
  return {
    subject_id: state.myCardsFilters.subject_id === '0' ? '' : state.myCardsFilters.subject_id,
    grade_id: state.myCardsFilters.grade_id === '0' ? '' : state.myCardsFilters.grade_id,
    unit_id: state.myCardsFilters.unit_id === '0' ? '' : state.myCardsFilters.unit_id,
    core_concept_id: state.myCardsFilters.core_concept_id === '0' ? '' : state.myCardsFilters.core_concept_id,
    chapter_position: getter.currentMyCardsChapterPosition,
    media_type: state.myCardsFilters.media_type === 'all' ? '' : state.myCardsFilters.media_type,
    order_by: state.myCardsFilters.order_by,
    search_keywords: state.myCardsFilters.search_keywords,
    offset: state.myCardsFilters.offset,
    author_id: getter.currentUser.id
  };
}

function pageLibraryFilters(state) {
  return state.pageLibraryFilters;
}

function trimmedPageLibraryFilters(state, getter) {
  return {
    subject_id: state.pageLibraryFilters.subject_id === '0' ? '' : state.pageLibraryFilters.subject_id,
    grade_id: state.pageLibraryFilters.grade_id === '0' ? '' : state.pageLibraryFilters.grade_id,
    unit_id: state.pageLibraryFilters.unit_id === '0' ? '' : state.pageLibraryFilters.unit_id,
    core_concept_id: state.pageLibraryFilters.core_concept_id === '0' ? '' : state.pageLibraryFilters.core_concept_id,
    chapter_position: getter.currentPageLibraryChapterPosition,
    media_type: state.pageLibraryFilters.media_type === 'all' ? '' : state.pageLibraryFilters.media_type,
    is_quiz: state.pageLibraryFilters.is_quiz,
    order_by: state.pageLibraryFilters.order_by,
    search_keywords: state.pageLibraryFilters.search_keywords,
    offset: state.pageLibraryFilters.offset
  };
}

function assignmentsFilters(state) {
  return state.assignmentsFilters;
}

function trimmedAssignmentsFilters(state) {
  return {
    status: state.assignmentsFilters.status === 'all' ? '' : state.assignmentsFilters.status,
    class_id: state.assignmentsFilters.class_id === 'all' ? '' : state.assignmentsFilters.class_id,
    per_page: state.assignmentsFilters.per_page,
    page: state.assignmentsFilters.page
  };
}

function subjectMap(state) {
  return state.subjectMap;
}

function subjectIds(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"])(state.subjectMap).filter(function (id) {
    return id !== '9999';
  }), parseInt);
}

function subjectList(state) {
  return [{ id: '0', name: 'common.selects.all_subjects' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.subjectList));
}

function gradeMap(state) {
  return state.gradeMap;
}

function gradeIds(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"])(state.gradeMap).filter(function (id) {
    return id !== '9999';
  }), parseInt);
}

function gradeList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["filter"])(state.gradeMap, function (grade) {
    if (grade.id && grade.id !== 0 && grade.id !== 999) {
      return grade;
    }

    return false;
  }));
}

function coreConcepts(state) {
  return state.coreConcepts;
}

function units(state) {
  return state.units;
}

function coreConceptList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["values"])(state.coreConcepts);
}

function domainList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["values"])(state.domains);
}

function unitList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["values"])(state.units);
}

function gradeSubjects(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["orderBy"])(state.gradeSubjects, ['position'], ['asc']) || [];
}

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_ACTIVE_EDITOR_LOCATION, function (state, editorLocation) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'activeEditorLocation', editorLocation);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_ACTIVE_EDITOR_ID, function (state, editorId) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'activeEditorId', editorId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_PAGE_INDEX, function (state, pageIndex) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'selectedPreviewPageIndex', pageIndex);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_IS_STUDENT_PREVIEW, function (state, isStudentAssignmentPreview) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'isStudentAssignmentPreview', isStudentAssignmentPreview);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_IS_CLASS_PREVIEW, function (state, isClassAssignmentPreview) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'isClassAssignmentPreview', isClassAssignmentPreview);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_IS_PAGE_PREVIEW, function (state, isPagePreview) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'isPagePreview', isPagePreview);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_SELECTED, function (state, card) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'selectedPreviewCard', card);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_BUSY, function (state, obj) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'busy', obj.busy);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "uklx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-editor',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    editorId: {
      type: String,
      default: 'base-editor'
    },
    value: {
      type: String,
      default: ''
    },
    textLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: null
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    value: function value() {
      if (this.editor && this.placeholder && this.value !== this.editor.getContent() && this.value === '') {
        this.editor.setContent(this.placeholder);
        this.showPlaceHolder = true;
      } else if (this.editor && this.value !== this.editor.getContent({ format: 'raw' })) {
        this.editor.setContent(this.value, { format: 'raw' });
        this.showPlaceHolder = false;
      } else if (this.editor && this.value && this.value.indexOf('<img') === -1 && this.value.indexOf('<figure') !== -1) {
        this.editor.setContent(this.value.replace(/<figure>/g, '').replace(/<\/figure>/g, ''), { format: 'raw' });
      }
    }
  },

  data: function data() {
    var _this = this;

    return {
      showPlaceHolder: true,

      textLimitExceeded: false,

      editor: null,

      editorConfig: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        menubar: false,
        inline: true,
        theme: 'inlite',
        selection_toolbar: 'h1 blockquote | forecolor backcolor | charmap',
        insert_toolbar: '',
        plugins: ['autoresize lists hr textcolor charmap', 'paste media table contextmenu'],
        paste_as_text: true,

        toolbar: false,
        language_url: '/static/editor-langs/ko_KR.js',

        formats: {
          underline: { inline: 'u', exact: true }
        },

        extended_valid_elements: '*[*]',

        setup: function setup(editor) {
          editor.on('change', function () {
            var html = editor.getContent();
            var rawHtml = editor.getContent({ format: 'raw' });
            _this.checkTextLimit(html);

            if (rawHtml !== _this.value) {
              _this.$emit('input', rawHtml);
            }
          });

          editor.on('NodeChange', function () {
            var html = editor.getContent();
            var rawHtml = editor.getContent({ format: 'raw' });
            _this.checkTextLimit(html);

            if (rawHtml !== _this.value) {
              _this.$emit('input', rawHtml);
            }
          });

          editor.on('keyup', function () {
            var html = editor.getContent();
            var rawHtml = editor.getContent({ format: 'raw' });
            _this.checkTextLimit(html);

            if (rawHtml !== _this.value) {
              _this.$emit('input', rawHtml);
            }
          });

          editor.on('SetContent', function () {
            var html = editor.getContent();
            var rawHtml = editor.getContent({ format: 'raw' });
            _this.checkTextLimit(html);

            if (rawHtml !== _this.value) {
              _this.$emit('input', rawHtml);
            }
          });

          editor.on('MouseLeave', function () {
            _this.setActiveEditorId(editor.id).then(function () {
              return _this.setActiveEditorLocation(editor.selection.getRng());
            });
          });

          editor.on('Remove', function () {
            _this.setActiveEditorId(null).then(function () {
              return _this.setActiveEditorLocation(null);
            });
          });

          if (_this.placeholder) {
            editor.on('focus', function () {
              setTimeout(function () {
                if (editor.getContent() === '<p>' + _this.placeholder + '</p>') {
                  editor.setContent('');
                }

                _this.showPlaceHolder = false;
              }, 0);
            });

            editor.on('blur', function () {
              _this.setActiveEditorId(editor.id).then(function () {
                if (editor.getContent() === '') {
                  editor.setContent(_this.placeholder);
                  _this.showPlaceHolder = true;
                }
              });
            });
          }
        },

        init_instance_callback: function init_instance_callback(editor) {
          if ((_this.value === '' || _this.value === '<p><br data-mce-bogus="1"></p>') && _this.placeholder) {
            _this.showPlaceHolder = true;
            editor.setContent(_this.placeholder);
          } else {
            _this.showPlaceHolder = false;
          }

          _this.editor = editor;
        }

      }, this.config, {

        selector: '#' + this.editorId
      })
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setActiveEditorLocation', 'setActiveEditorId']), {
    remove: function remove() {
      if (this.editor) {
        this.editor.destroy();
      }
    },
    checkTextLimit: function checkTextLimit(html) {
      if (this.textLimit === 0) {
        this.textLimitExceeded = false;
      } else {
        var text = html.replace(/(<([^>]+)>)/ig, '').replace(/&nbsp;/g, ' ').replace(/\u21B5/g, '\n');

        this.textLimitExceeded = text.length > this.textLimit;
        this.$emit('error', this.textLimitExceeded);
      }
    }
  }),

  mounted: function mounted() {
    tinymce.init(this.editorConfig);
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  }
});

/***/ }),

/***/ "umTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mdl-grid mdl-grid--no-spacing line-gauge-container" },
    [
      _c(
        "div",
        { staticClass: "mdl-cell mdl-cell--middle lg-box" },
        [
          _c("LineGauge", {
            attrs: { value: _vm.value, "bg-color": _vm.bgColor }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c55e1cb4", esExports)
  }
}

/***/ }),

/***/ "uosL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppMain")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5055158c", esExports)
  }
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uve6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  props: ['id', 'model-value', 'check-value', 'left-label'],

  data: function data() {
    return {
      isChecked: false
    };
  },


  computed: {
    state: function state() {
      return this.modelValue === this.checkValue;
    }
  },

  methods: {
    check: function check() {
      return this.$emit('change', this.checkValue);
    },
    uncheck: function uncheck() {
      if (this.checkValue === true) {
        return this.$emit('change', false);
      }

      return this.$emit('change', null);
    },
    onChange: function onChange() {
      if (this.state) {
        this.uncheck();
      } else {
        this.check();
      }
    }
  }
});

/***/ }),

/***/ "v8Nw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCard_vue__ = __webpack_require__("f9ux");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d21ef0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCard_vue__ = __webpack_require__("hiGW");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d21ef0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/my-cards/components/MyCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d21ef0f", Component.options)
  } else {
    hotAPI.reload("data-v-7d21ef0f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vC3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageItem_vue__ = __webpack_require__("kx4n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c6a172_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageItem_vue__ = __webpack_require__("42JS");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c6a172_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/PageItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02c6a172", Component.options)
  } else {
    hotAPI.reload("data-v-02c6a172", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vOfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "create-docx-quizzes" }, [
    _c("div", { staticClass: "create-docx-quizzes__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "create-docx-quizzes__header-title typography--color-primary text-center"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("publishers.create_docx_quizzes.title")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "create-docx-quizzes__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "subject-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.subject")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subjectId,
                      expression: "subjectId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "subject-select", disabled: _vm.isSeriesCard },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.subjectId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("card_details.card_meta.subject_placeholder")
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.subjectIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(sjId) {
                      return _c(
                        "option",
                        { key: sjId, domProps: { value: sjId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.getTranslatedName(_vm.subjectMap[sjId])
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "grade-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.grade")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gradeId,
                      expression: "gradeId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "grade-select", disabled: _vm.isSeriesCard },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.gradeId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("card_details.card_meta.grade_placeholder")
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.gradeIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(gId) {
                      return _c(
                        "option",
                        { key: gId, domProps: { value: gId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getTranslatedName(_vm.gradeMap[gId])) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showUnitSelect,
                    expression: "showUnitSelect"
                  }
                ],
                staticClass: "form-group"
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary typography--font-weight-600",
                    attrs: { for: "unit-select" }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("card_details.card_meta.chapter")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.unitId,
                        expression: "unitId"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "unit-select",
                      disabled: _vm.isSeriesCard && _vm.$route.query.unit_id
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.unitId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.onUnitSelect
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("card_details.card_meta.chapter_placeholder")
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.unitList, function(unit) {
                      return _c(
                        "option",
                        { key: unit.id, domProps: { value: unit.id } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(unit.name) +
                              "\n              "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCoreConceptSelect,
                    expression: "showCoreConceptSelect"
                  }
                ],
                staticClass: "form-group"
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary typography--font-weight-600",
                    attrs: { for: "core-concept-select" }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("card_details.card_meta.core_concept")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.coreConceptId,
                        expression: "coreConceptId"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "core-concept-select",
                      disabled:
                        _vm.isSeriesCard && _vm.$route.query.core_concept_id
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.coreConceptId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "card_details.card_meta.core_concepts_placeholder"
                            )
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.coreConceptList, function(coreConcept) {
                      return _c(
                        "option",
                        {
                          key: coreConcept.id,
                          domProps: { value: coreConcept.id }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(coreConcept.name) +
                              "\n              "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "video-course-id" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.video_course")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.videoCourseId,
                    expression: "videoCourseId",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "video-course-id" },
                domProps: { value: _vm.videoCourseId },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.videoCourseId = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "card-title-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.title")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.cardTitle,
                    expression: "cardTitle",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "card-title-input",
                  maxlength: "50",
                  placeholder: _vm.$t(
                    "card_details.card_meta.title_placeholder"
                  )
                },
                domProps: { value: _vm.cardTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cardTitle = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "card-goal-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.goal")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cardGoal,
                    expression: "cardGoal"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: "card-goal-input",
                  rows: "5",
                  maxlength: "5000",
                  placeholder: _vm.$t("card_details.card_meta.goal_placeholder")
                },
                domProps: { value: _vm.cardGoal },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cardGoal = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            !_vm.docxParsingCompleted
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "create-docx-quizzes__upload-area mx-auto text-center"
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "create-docx-quizzes__upload-input text-center clickable w-100"
                        },
                        [
                          _c("input", {
                            ref: "docxFileInput",
                            staticClass: "no-display",
                            attrs: {
                              type: "file",
                              accept: _vm.validFileType,
                              disabled: _vm.loading
                            },
                            on: { change: _vm.onFileInputChange }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "create-docx-quizzes__upload-text typography--headline typography--color-secondary text-center"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("publishers.create_docx_quizzes.upload_text")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "mt-40 text-center" },
                        [
                          _c("LoadingBounce"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "typography--body-2 typography--color-disabled typography--font-weight-bold pb-5"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.reading_file")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _c("div", { staticClass: "text-center mt-40" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--content-body typography--color-primary mb-12"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.name",
                              { name: _vm.docxFileName }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.quiz_count",
                              { count: _vm.fileInfo.quizCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.multiple_choice_count",
                              { count: _vm.fileInfo.multipleChoiceCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.text_entry_count",
                              { count: _vm.fileInfo.textEntryCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.image_count",
                              { count: _vm.fileInfo.imageCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center mt-40" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-full create-docx-quizzes__create-btn",
                  attrs: { disabled: _vm.createDisabled },
                  on: {
                    click: function($event) {
                      return _vm.create()
                    }
                  }
                },
                [
                  !_vm.busy
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("publishers.create_docx_quizzes.create")
                          )
                        )
                      ])
                    : _c("LoadingBounce")
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center mt-2" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-secondary btn-full create-docx-quizzes__cancel-btn typography--color-secondary",
                    attrs: { to: _vm.prevLink }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("btn.redirect_to_root")) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "docx-type-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.docx_type_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "file-reader-unsupported-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.file_reader_unsupported.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "basic-error-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.basic_error_alert.message")
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "break-word-all mt-3" }, [
              _vm._v("\n        " + _vm._s(_vm.errMsg) + "\n      ")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a8b936", esExports)
  }
}

/***/ }),

/***/ "vWCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isPublisherUser'])),

  created: function created() {
    if (!this.isPublisherUser) {
      this.$router.replace('/library');
    }
  }
});

/***/ }),

/***/ "vY3X":
/***/ (function(module, exports) {

module.exports = {"Play":"Přehrát","Pause":"Pauza","Current Time":"Aktuální čas","Duration Time":"Doba trvání","Remaining Time":"Zbývající čas","Stream Type":"Stream Type","LIVE":"ŽIVĚ","Loaded":"Načteno","Progress":"Stav","Fullscreen":"Celá obrazovka","Non-Fullscreen":"Zmenšená obrazovka","Mute":"Ztlumit zvuk","Unmute":"Přehrát zvuk","Playback Rate":"Rychlost přehrávání","Subtitles":"Titulky","subtitles off":"Titulky vypnuty","Captions":"Popisky","captions off":"Popisky vypnuty","Chapters":"Kapitoly","You aborted the media playback":"Přehrávání videa je přerušeno.","A network error caused the media download to fail part-way.":"Video nemohlo být načteno, kvůli chybě v síti.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Video nemohlo být načteno, buď kvůli chybě serveru nebo sítě nebo proto, že daný formát není podporován.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Váš prohlížeč nepodporuje formát videa.","No compatible source was found for this media.":"Špatně zadaný zdroj videa."}

/***/ }),

/***/ "vZwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("LCT6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1e3f0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("9XSs");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1e3f0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/AppMain.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c1e3f0c", Component.options)
  } else {
    hotAPI.reload("data-v-7c1e3f0c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vbPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassItem_vue__ = __webpack_require__("2gnU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d78fcbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassItem_vue__ = __webpack_require__("JX/M");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d78fcbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/classes/components/ClassItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d78fcbc", Component.options)
  } else {
    hotAPI.reload("data-v-3d78fcbc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vbWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oauth-callback" },
    [
      _c("LoadingBounce"),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "basic-error-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("common.modal.basic_error_alert.message")
              )
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0104e8a", esExports)
  }
}

/***/ }),

/***/ "vfyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-gauge-container" }, [
    _c(
      "div",
      {
        staticClass:
          "lg-col lg-label typography--body-3 typography--color-secondary"
      },
      [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "lg-col lg-box" },
      [
        _c("LineGauge", {
          attrs: { value: _vm.ratio, "bg-color": _vm.bgColor }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "lg-col lg-position-num typography--body-3 typography--color-secondary"
      },
      [_vm._v("\n    " + _vm._s(_vm.value || "-") + _vm._s(_vm.unit) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-737ef387", esExports)
  }
}

/***/ }),

/***/ "w/4p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getMyQuizzes"] = getMyQuizzes;
/* harmony export (immutable) */ __webpack_exports__["getQuiz"] = getQuiz;
/* harmony export (immutable) */ __webpack_exports__["isLoadingQuiz"] = isLoadingQuiz;
/* harmony export (immutable) */ __webpack_exports__["isLoadingMyQuizzes"] = isLoadingMyQuizzes;
/* harmony export (immutable) */ __webpack_exports__["getQuizError"] = getQuizError;
/* harmony export (immutable) */ __webpack_exports__["getTotalMyQuizzes"] = getTotalMyQuizzes;
function getMyQuizzes(state) {
  return state.myQuizzes;
}

function getQuiz(state) {
  return state.quiz;
}

function isLoadingQuiz(state) {
  return state.isLoadingQuiz;
}

function isLoadingMyQuizzes(state) {
  return state.isLoadingMyQuizzes;
}

function getQuizError(state) {
  return state.error;
}

function getTotalMyQuizzes(state) {
  return state.total;
}

/***/ }),

/***/ "w1p6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("qVUV");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),

/***/ "w4MO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  series: {},

  nonSeriesCards: {},

  chapters: {},

  chapterCards: {}
});

/***/ }),

/***/ "wBJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-badge',

  props: {
    domain: {
      type: Object,
      default: null
    }
  },

  computed: {
    grade: function grade() {
      if (this.domain.grade === '상') {
        return 'high';
      }

      if (this.domain.grade === '중') {
        return 'middle';
      }

      return 'low';
    },
    classBindings: function classBindings() {
      return {
        'high-grade': this.grade === 'high',
        'middle-grade': this.grade === 'middle',
        'low-grade': this.grade === 'low'
      };
    }
  }
});

/***/ }),

/***/ "wDRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'line-gauge',

  props: {
    value: {
      type: Number,
      default: 50
    },
    bgColor: {
      type: String,
      default: '#00c896'
    }
  },

  computed: {
    styleBindings: function styleBindings() {
      return {
        width: this.value + '%',
        'background-color': this.bgColor,
        'border-color': this.bgColor
      };
    }
  }
});

/***/ }),

/***/ "wJ1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Library_vue__ = __webpack_require__("+IHj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377c84af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Library_vue__ = __webpack_require__("4SVC");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Library_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377c84af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Library_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/library/views/Library.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-377c84af", Component.options)
  } else {
    hotAPI.reload("data-v-377c84af", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wNoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "domain-select" }, [
    _c("div", { staticClass: "domain-select__header" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass:
                "domain-select__header-item typography--body-3 typography--color-secondary typography--font-weight-bold"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("evaluations.domain_select.header.title")) +
                  "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c(
            "div",
            {
              staticClass:
                "domain-select__header-item typography--caption typography--color-secondary text-right"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("evaluations.domain_select.header.description")
                  ) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "domain-select__option-list" },
      _vm._l(_vm.domains, function(domain) {
        return _c("DomainSelectOption", {
          key: domain.id,
          attrs: {
            domain: domain,
            loading: _vm.loading,
            "is-selected": _vm.isSelectedDomain(domain.id)
          },
          on: {
            "domain-option-clicked": function($event) {
              return _vm.$emit("domain-option-clicked", domain.id)
            }
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8febac6c", esExports)
  }
}

/***/ }),

/***/ "waa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ai-score-guide-modal',

  data: function data() {
    return {
      aiGradeCount: 12
    };
  }
});

/***/ }),

/***/ "wbE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sendCardRatingLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");




function getDevice() {
  var userAgent = window.navigator.userAgent;

  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    return 'ios.event';
  }

  if (userAgent.match(/android/i)) {
    return 'android.event';
  }

  return 'web.event';
}

function sendApiLog(res, store) {
  try {
    if (!res || !res.config || !res.config.url || res.config.url.indexOf('wlog') !== -1) {
      return;
    }

    var user = store.getters.currentUser || {};
    var now = new Date();
    var body = {
      method: res.config.method,
      api: res.config.url,
      code: res.status,
      uid: user.id,
      role: user.role,
      grade: user.grade,
      device: getDevice(),
      client_time: now.getTime(),
      origin: '' + window.location.origin + window.location.pathname,
      host: window.location.host,
      msg: (res.data || {}).error_description
    };

    var parentIds = store.getters.getRouteQuery.parent_ids;

    if (parentIds) {
      var parentIdList = parentIds.split(',');

      parentIdList.forEach(function (parentId, i) {
        body['parent_id' + (i + 1)] = parentId;
      });
    }

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* LOG_URL */], body);
  } catch (err) {
    console.error('failed to send log with err:', err);
  }
}

function sendCardRatingLog(ratingInfo, user, isStoreCard) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    var logType = isStoreCard ? 'store_card_rating' : 'card_rating';
    var body = {
      card_id: ratingInfo.card_id,
      uid: ratingInfo.user_id,
      assignment_id: ratingInfo.assignment_id,
      client_time: new Date().getTime(),
      rating: ratingInfo.rating,
      device: getDevice(),
      origin: '' + window.location.origin + window.location.pathname,
      host: window.location.host,
      role: user.role,
      grade: user.grade
    };

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* LOG_BASE_URL */] + '_' + logType, body);
  }).catch(function (err) {
    console.error('failed to send rating log with err:', err);
  });
}

function rfreshAuthorize() {
  sessionStorage.setItem('continue_url', window.location.pathname);
  window.location.href = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* CLASSTING_FULL_AUTH_URL */];
}

/* harmony default export */ __webpack_exports__["a"] = (function (http, store) {
  http.interceptors.response.use(function (response) {
    sendApiLog(response, store);
    return response;
  }, function (error) {
    var response = error.response;


    if (response && response.status === 401) {
      rfreshAuthorize();
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
});

/***/ }),

/***/ "wbe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progress-bar',

  props: {
    value: {
      type: Number,
      default: 50
    },
    bgColor: {
      type: String,
      default: '#00c896'
    }
  }
});

/***/ }),

/***/ "wuUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LcVideo_vue__ = __webpack_require__("x+xF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b64d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LcVideo_vue__ = __webpack_require__("W9X/");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LcVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b64d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LcVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LcVideo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b4b64d78", Component.options)
  } else {
    hotAPI.reload("data-v-b4b64d78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wwUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tooltip_vue__ = __webpack_require__("P4Wo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70596efa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__ = __webpack_require__("G5b0");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70596efa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Tooltip.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70596efa", Component.options)
  } else {
    hotAPI.reload("data-v-70596efa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wwUL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("DIUU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("j1rw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("0fi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("w/4p");






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),

/***/ "x+xF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mobile__ = __webpack_require__("yx9P");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lc-video',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mobile__["a" /* default */]],

  props: ['video'],

  computed: {
    videoOptions: function videoOptions() {
      return {
        sources: [{
          type: 'video/mp4',
          src: this.video.video_url || this.video.url
        }],
        poster: this.video.poster_url
      };
    },
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  },

  created: function created() {
    var _this = this;

    window.pauseMedia = function () {
      if (_this.isOldAndroid) {
        _this.$refs.videofile.pause();
      } else {
        _this.player.pause();
      }
    };
  }
});

/***/ }),

/***/ "x0qI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isSignedIn"] = isSignedIn;
/* harmony export (immutable) */ __webpack_exports__["currentUser"] = currentUser;
/* harmony export (immutable) */ __webpack_exports__["currentUserId"] = currentUserId;
/* harmony export (immutable) */ __webpack_exports__["isPublisherUser"] = isPublisherUser;
/* harmony export (immutable) */ __webpack_exports__["isBusanPublisher"] = isBusanPublisher;
/* harmony export (immutable) */ __webpack_exports__["currentUserContryCode"] = currentUserContryCode;
/* harmony export (immutable) */ __webpack_exports__["isKrUser"] = isKrUser;
/* harmony export (immutable) */ __webpack_exports__["currentPublisherInfo"] = currentPublisherInfo;
/* harmony export (immutable) */ __webpack_exports__["getIsDevice"] = getIsDevice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function isSignedIn(state) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.user);
}

function currentUser(state) {
  return state.user;
}

function currentUserId(state) {
  return state.user.id;
}

function isPublisherUser(state) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.user) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.user.publisher)) {
    return true;
  }

  return false;
}

function isBusanPublisher(state) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.user) && state.user.id === 'busanedu';
}

function currentUserContryCode(state, getters) {
  return getters.currentUser.country_code || 'KR';
}

function isKrUser(state, getters) {
  return getters.currentUserContryCode === 'KR';
}

function currentPublisherInfo(state, getters) {
  if (getters.isPublisherUser) {
    return state.user.publisher;
  }

  return {};
}

function getIsDevice(state) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.device);
}

/***/ }),

/***/ "x2Y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchAssignments"] = fetchAssignments;
/* harmony export (immutable) */ __webpack_exports__["fetchTeacherAssignmentStats"] = fetchTeacherAssignmentStats;
/* harmony export (immutable) */ __webpack_exports__["fetchAssignmentDetails"] = fetchAssignmentDetails;
/* harmony export (immutable) */ __webpack_exports__["createNewAssignment"] = createNewAssignment;
/* harmony export (immutable) */ __webpack_exports__["updateAssignment"] = updateAssignment;
/* harmony export (immutable) */ __webpack_exports__["removeAssignment"] = removeAssignment;
/* harmony export (immutable) */ __webpack_exports__["gradeAssignment"] = gradeAssignment;
/* harmony export (immutable) */ __webpack_exports__["gradeQuizResult"] = gradeQuizResult;
/* harmony export (immutable) */ __webpack_exports__["updateAssignmentResults"] = updateAssignmentResults;
/* harmony export (immutable) */ __webpack_exports__["fetchAssignedCardPages"] = fetchAssignedCardPages;
/* harmony export (immutable) */ __webpack_exports__["setTeacherAssignmentStatsInStore"] = setTeacherAssignmentStatsInStore;
/* harmony export (immutable) */ __webpack_exports__["setAssignmentsInStore"] = setAssignmentsInStore;
/* harmony export (immutable) */ __webpack_exports__["addAssignmentsInStore"] = addAssignmentsInStore;
/* harmony export (immutable) */ __webpack_exports__["addAssignmentInStore"] = addAssignmentInStore;
/* harmony export (immutable) */ __webpack_exports__["updateAssignmentInStore"] = updateAssignmentInStore;
/* harmony export (immutable) */ __webpack_exports__["setAssignmentPropertyInStore"] = setAssignmentPropertyInStore;
/* harmony export (immutable) */ __webpack_exports__["removeAssignmentInStore"] = removeAssignmentInStore;
/* harmony export (immutable) */ __webpack_exports__["setSelectedAssignmentId"] = setSelectedAssignmentId;
/* harmony export (immutable) */ __webpack_exports__["setSelectedCardForNewAssignment"] = setSelectedCardForNewAssignment;
/* harmony export (immutable) */ __webpack_exports__["setAssignedCardPages"] = setAssignedCardPages;
/* harmony export (immutable) */ __webpack_exports__["syncAssignmentSubmissions"] = syncAssignmentSubmissions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("pjQi");






function fetchAssignments(_ref, filters) {
  var dispatch = _ref.dispatch;

  var queryParams = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(filters);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments?' + queryParams).then(function (res) {
    if (filters.page === 1) {
      return dispatch('setAssignmentsInStore', res.data);
    }

    return dispatch('addAssignmentsInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching assignments:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchTeacherAssignmentStats(_ref2, filters) {
  var dispatch = _ref2.dispatch;

  var queryParams = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(filters);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignment-stats?' + queryParams).then(function (res) {
    return dispatch('setTeacherAssignmentStatsInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching assignment stats:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchAssignmentDetails(_ref3, assignmentId) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + assignmentId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching assignment details:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createNewAssignment(_ref4, newAssignment) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments', newAssignment).then(function (res) {
    return dispatch('addAssignmentInStore', res.data);
  }).catch(function (err) {
    console.error('err while creating new assignment:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateAssignment(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var assignmentId = _ref6.assignmentId,
      updateInfo = _ref6.updateInfo;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + assignmentId, updateInfo).then(function () {
    console.info('assignment updated!');
  }).catch(function (err) {
    console.error('err while updating assignment:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeAssignment(_ref7, assignmentId) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + assignmentId).then(function () {
    return dispatch('removeAssignmentInStore', assignmentId);
  }).catch(function (err) {
    console.error('err while deleting assignment:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function gradeAssignment(_ref8, params) {
  var dispatch = _ref8.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + params.assignment_id + '/submissions/grades', params).then(function () {
    console.info('assignment graded!');
  }).catch(function (err) {
    console.error('err while grading assignment submission:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function gradeQuizResult(_ref9, params) {
  var dispatch = _ref9.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + params.assignment_id + '/quiz_results/grades', params).then(function () {
    console.info('quiz graded!');
  }).catch(function (err) {
    console.error('err while grading quiz result:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateAssignmentResults(_ref10, params) {
  var dispatch = _ref10.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + params.assignment_id + '/student-results', params).then(function () {
    console.info('assignment results updated!');
  }).catch(function (err) {
    console.error('err while updating assignment results:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchAssignedCardPages(_ref11, assignmentId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + assignmentId + '/pages').then(function (res) {
    return dispatch('setAssignedCardPages', { assignmentId: assignmentId, pageList: res.data });
  }).catch(function (err) {
    console.error('err while fetching assignment card pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setTeacherAssignmentStatsInStore(_ref12, assignmentStats) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ASSIGNMENT_STATS, assignmentStats);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(assignmentStats);
}

function setAssignmentsInStore(_ref13, assignmentList) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_ASSIGNMENTS, assignmentList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(assignmentList);
}

function addAssignmentsInStore(_ref14, assignmentList) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_ASSIGNMENTS, assignmentList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(assignmentList);
}

function addAssignmentInStore(_ref15, newAssignment) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_ASSIGNMENT, newAssignment);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(newAssignment);
}

function updateAssignmentInStore(_ref16, assignment) {
  var commit = _ref16.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].UPDATE_ASSIGNMENT, assignment);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(assignment);
}

function setAssignmentPropertyInStore(_ref17, setInfo) {
  var commit = _ref17.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PROPERTY, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function removeAssignmentInStore(_ref18, assignmentId) {
  var commit = _ref18.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_ASSIGNMENT, assignmentId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setSelectedAssignmentId(_ref19, assignmentId) {
  var commit = _ref19.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED, assignmentId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setSelectedCardForNewAssignment(_ref20, card) {
  var commit = _ref20.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_SELECTED_CARD_FOR_NEW_ASMT, card);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setAssignedCardPages(_ref21, setInfo) {
  var commit = _ref21.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_PAGES, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setInfo.pageList);
}

function syncAssignmentSubmissions(_ref22, assignmentId) {
  var dispatch = _ref22.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/assignments/' + assignmentId + '/sync_submissions').then(function () {
    console.info('sync assignment submissions!');
  }).catch(function (err) {
    console.error('err while sync assignment submissions:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

/***/ }),

/***/ "x7vy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NonSeriesCards_vue__ = __webpack_require__("E4H8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37da1be1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NonSeriesCards_vue__ = __webpack_require__("y0EJ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NonSeriesCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37da1be1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NonSeriesCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/publishers/views/NonSeriesCards.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37da1be1", Component.options)
  } else {
    hotAPI.reload("data-v-37da1be1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x94F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  selectedAssignmentId: '',

  assignments: {},

  selectedCardForNewAssignment: {},

  teacherAssignmentStats: {
    inactive_count: 0,
    active_count: 0,
    total_count: 0
  }
});

/***/ }),

/***/ "xJdW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "page-summary-card clickable" }, [
    _c(
      "div",
      { staticClass: "card-block", on: { click: _vm.openCardPreview } },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "typography--body-3" }, [
              _c("strong", { staticClass: "typography--color-secondary" }, [
                _vm._v(_vm._s(_vm.index + 1))
              ]),
              _vm._v(" "),
              _vm.page.is_quiz
                ? _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.quiz")))]
                  )
                : _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.non_quiz")))]
                  )
            ]),
            _vm._v(" "),
            this.isPublisherUser
              ? _c(
                  "div",
                  {
                    style: {
                      background: _vm.getPageMetadataBackgroundColor,
                      cursor: "default"
                    }
                  },
                  [
                    _c("div", { staticClass: "ml-1" }, [
                      _vm._v(
                        "[페이지] - " +
                          _vm._s(this.page.id) +
                          " (" +
                          _vm._s(_vm.getPageShareLevelDescription) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.hasExtraContent
                      ? _c("div", { staticClass: "ml-1" }, [
                          _vm._v("* 긴지문 있음 *")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-1" }, [
                      _vm._v(
                        "[핵심개념] - " +
                          _vm._s(this.page.core_concept_id) +
                          " (" +
                          _vm._s(_vm.getCoreConceptDescription) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-1" }, [_vm._v("[키워드]")]),
                    _vm._v(" "),
                    _vm._l(_vm.getKeywords, function(keyword, index) {
                      return _c("div", { key: index }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(keyword.id + ": " + keyword.name) +
                            "\n          "
                        )
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "page-content-container",
                class: _vm.classBindings
              },
              [
                _vm.hasExtraContent
                  ? _c("div", {
                      staticClass: "page-image-summary float-left",
                      style: { "background-image": _vm.extraContentImageSrc }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasImage
                  ? _c("div", {
                      staticClass: "page-image-summary float-left",
                      style: { "background-image": _vm.firstImageSrc }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAudio
                  ? _c("div", { staticClass: "page-audio-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-audio.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstAudioDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasVideo || _vm.hasEmbededVideo
                  ? _c("div", { staticClass: "page-video-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-video.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstVideoDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "typography--body-2 typography--pre-line page-content",
                  domProps: { innerHTML: _vm._s(_vm.summarizedContent) }
                })
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-action" }, [
      _c(
        "div",
        { staticClass: "card-action-btn" },
        [
          _c(
            "IconDropdown",
            [
              _vm.isEditablePage
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.$emit("edit-page", _vm.index)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.card.page.edit")) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function($event) {
                      return _vm.$emit("remove-page", _vm.index)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.card.page.remove")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              this.isPublisherUser
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "dropdown-divider" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-label",
                          style: { "padding-left": "20px" }
                        },
                        [_c("strong", [_vm._v("관리자 메뉴")])]
                      ),
                      _vm._v(" "),
                      this.page.share_level !== 99
                        ? _c(
                            "b-dropdown-item",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  return _vm.$emit("hidden-page", _vm.index)
                                }
                              }
                            },
                            [_vm._v("\n            숨김\n          ")]
                          )
                        : _c(
                            "b-dropdown-item",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "recover-hidden-page",
                                    _vm.index
                                  )
                                }
                              }
                            },
                            [_vm._v("\n            숨김처리 복구\n          ")]
                          ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.$emit("edit-extra-content", _vm.index)
                            }
                          }
                        },
                        [_vm._v("\n            긴지문 설정\n          ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5538a1e8", esExports)
  }
}

/***/ }),

/***/ "xMHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



window.videojs = __webpack_require__("94rq");
__webpack_require__("g3Gj");
var languages = __webpack_require__("ktPO");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },

  methods: {
    initialize: function initialize() {
      var self = this;
      this.player = null;

      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        start: 0,
        playsinline: false,
        customEventName: 'statechanged',

        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5', 'flash'],
        playbackRates: [],
        plugins: {}
      }, this.options);

      var language = videoOptions.language;
      videojs.addLanguage(language, languages[language]);

      var playsinline = videoOptions.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(videoOptions.customEventName, values);
        }
      };

      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }
      this.player = videojs(this.$el.children[0], videoOptions, function () {
        self.$emit('ready', self.player);

        this.on('loadeddata', function () {
          this.muted(videoOptions.muted);
          if (!!videoOptions.start) {
            this.currentTime(videoOptions.start);
          }
          emitPlayerState('loadeddata', true);
        });

        this.on('canplay', function () {
          emitPlayerState('canplay', true);
        });

        this.on('canplaythrough', function () {
          emitPlayerState('canplaythrough', true);
        });

        this.on('play', function () {
          emitPlayerState('play', true);
        });

        this.on('pause', function () {
          emitPlayerState('pause', true);
        });

        this.on('waiting', function () {
          emitPlayerState('waiting', true);
        });

        this.on('playing', function () {
          emitPlayerState('playing', true);
        });

        this.on('ended', function () {
          emitPlayerState('ended', true);
        });

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        this.player.pause && this.player.pause();
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js vjs-custom-skin';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),

/***/ "xQUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_MyQuizzes__ = __webpack_require__("1Lkz");


var router = [{
  name: 'myQuizzes',
  path: '/my-quizzes',
  component: __WEBPACK_IMPORTED_MODULE_0__views_MyQuizzes__["a" /* default */],
  meta: {
    requiresAuth: true,
    requiresTeacherRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "xXit":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("AmN6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_756cbb1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("ISPZ");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("EOeG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_756cbb1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Checkbox.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-756cbb1a", Component.options)
  } else {
    hotAPI.reload("data-v-756cbb1a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xYUW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("k0lw");



var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_SELECTED_CLASS_EVALUATION_DOMAINS, function (state, _ref) {
  var classId = _ref.classId,
      selectedDomainIds = _ref.selectedDomainIds;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.selectedClassEvaluationDomainIds, classId, selectedDomainIds);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CLASS_EVALUATION_DOMAINS, function (state, _ref2) {
  var classId = _ref2.classId,
      domains = _ref2.domains;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.classEvaluationDomains, classId, domains);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_EVALUATION_LIST, function (state, evaluationList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'evaluationList', evaluationList.map(function (evaluation, index) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, evaluation, {
      index: index
    });
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_EVALUATION, function (state, _ref3) {
  var index = _ref3.index,
      evaluation = _ref3.evaluation;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.evaluationList, index, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, evaluation, { index: index }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_EVALUATION_FILTER, function (state, _ref4) {
  var property = _ref4.property,
      value = _ref4.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.evaluationFilters, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_EVALUATION_CRITERIA, function (state, evaluationCriteria) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'evaluationCriteria', evaluationCriteria);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_EVALUATION_ORDER_BY, function (state, evaluationOrderBy) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'evaluationOrderBy', evaluationOrderBy);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "xYl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    { staticClass: "page-editor-modal", attrs: { id: _vm.id } },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _c("div", { staticClass: "row btn-row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "page-editor-header mx-auto" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "action-header typography--headline typography--color-secondary"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("page_editor.header." + _vm.pageType)
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary float-right",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.close()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("common.close")) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.pageType === "non_quiz"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary float-right",
                            attrs: {
                              type: "button",
                              disabled: _vm.addQuizDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.addNonQuiz()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.complete")) +
                                "\n              "
                            )
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-primary float-right",
                            attrs: {
                              type: "button",
                              disabled: _vm.addQuizDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.addQuiz()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.complete")) +
                                "\n              "
                            )
                          ]
                        )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row editor-toolbar-row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "mw-620 mx-auto" },
                [
                  _c("EditorToolbar", {
                    on: {
                      "image-added": _vm.onImageAdded,
                      "audio-added": _vm.onAudioAdded,
                      "show-add-video-modal": _vm.showAddVideoModal
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.audios.length > 0
            ? _c("div", { staticClass: "row editor-audio-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "mw-620 mx-auto relative-position" },
                    [
                      _c("LcAudio", { attrs: { audio: _vm.audios[0] } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "remove-audio-btn" }, [
                        _c("img", {
                          staticClass: "clickable",
                          attrs: {
                            src: "/static/images/score-guide-close.svg",
                            alt: "remove audio"
                          },
                          on: {
                            click: function($event) {
                              return _vm.audios.pop()
                            }
                          }
                        })
                      ])
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container page-editor-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "mw-620 mx-auto" }, [
              _vm.quiz
                ? _c(
                    "div",
                    { staticClass: "quiz-content-container" },
                    [
                      _c(
                        "h6",
                        {
                          staticClass:
                            "typography--body-1 typography--color-secondary"
                        },
                        [
                          _vm.pageType === "non_quiz"
                            ? _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("page_editor.non_quiz.title"))
                                )
                              ])
                            : _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("page_editor.question.title"))
                                )
                              ]),
                          _vm._v(" "),
                          !_vm.sourceEditAvaliable
                            ? _c(
                                "span",
                                { staticClass: "typography--caption" },
                                [_vm._v("(수정 불가)")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("BaseEditor", {
                        staticClass: "quiz-editor",
                        attrs: {
                          "editor-id": "quiz-editor-" + _vm.id,
                          "text-limit": 5000,
                          disabled: !_vm.sourceEditAvaliable,
                          placeholder:
                            _vm.pageType === "non_quiz"
                              ? _vm.$t("page_editor.non_quiz.placeholder")
                              : _vm.$t("page_editor.question.placeholder")
                        },
                        on: { error: _vm.checkContentError },
                        model: {
                          value: _vm.quiz.content,
                          callback: function($$v) {
                            _vm.$set(_vm.quiz, "content", $$v)
                          },
                          expression: "quiz.content"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "multiple_choice"
                ? _c("div", { staticClass: "quiz-answers-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "typography--body-1 typography--color-secondary"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("page_editor.choices.title"))
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.sourceEditAvaliable
                              ? _c(
                                  "span",
                                  { staticClass: "typography--caption" },
                                  [_vm._v("(수정 불가)")]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", { staticClass: "float-right" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "typography--caption typography--color-secondary align-bottom"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("page_editor.choices.hint")) +
                                  "\n                  "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm._l(_vm.answers, function(answer, index) {
                          return _c(
                            "div",
                            {
                              key: _vm.getAnswerKey(answer),
                              style: _vm.sourceEditAvaliable
                                ? ""
                                : "pointer-events: none;"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "quiz-answer-box",
                                  class: {
                                    "has-error":
                                      answer.content &&
                                      answer.content.length > 499
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.answers.length > 2 &&
                                            _vm.getAnswerKey(answer) !==
                                              _vm.getAnswerKey(
                                                _vm.chosenAnswer
                                              ),
                                          expression:
                                            "answers.length > 2 && getAnswerKey(answer) !== getAnswerKey(chosenAnswer)"
                                        }
                                      ],
                                      staticClass:
                                        "delete-quiz-answer-btn clickable",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeAnswer(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/static/images/icon-delete.svg",
                                          alt: "delete quiz answer choice"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "quiz-choice-item-index float-left"
                                    },
                                    [_vm._v(_vm._s(index + 1) + ".")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "quiz-choice-editor" },
                                    [
                                      _c("AutosizeTextarea", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "page_editor.choices.placeholder"
                                          )
                                        },
                                        model: {
                                          value: answer.content,
                                          callback: function($$v) {
                                            _vm.$set(answer, "content", $$v)
                                          },
                                          expression: "answer.content"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "quiz-choice-item-radio-box float-right"
                                    },
                                    [
                                      _c(
                                        "Radio",
                                        {
                                          attrs: {
                                            "model-value": _vm.chosenAnswer,
                                            "check-value": answer,
                                            id:
                                              "quiz-choice-item-radio-" +
                                              _vm.id +
                                              "-" +
                                              index,
                                            "left-label": "true"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.selectCorrectAnswerChoice(
                                                answer
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.getAnswerKey(
                                                      _vm.chosenAnswer
                                                    ) ===
                                                    _vm.getAnswerKey(answer),
                                                  expression:
                                                    "getAnswerKey(chosenAnswer) === getAnswerKey(answer)"
                                                }
                                              ],
                                              staticClass:
                                                "typography--body-3 typography--color-secondary",
                                              attrs: { slot: "left-label" },
                                              slot: "left-label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "page_editor.choices.is_correct"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              answer.content && answer.content.length > 499
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typography--caption typography--color-alert text-center pb-12"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "page_editor.choices.alerts.max_length"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.answers.length < 5,
                                expression: "answers.length < 5"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.addNewAnswer()
                              }
                            }
                          },
                          [
                            _c("AddAnswerButton", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "page_editor.choices.add_new.placeholder"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "multiple_choice"
                ? _c("div", { staticClass: "quiz-view-type-container" }, [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("page_editor.choices.view_types.title")
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c(
                          "div",
                          { staticClass: "quiz-view-type-box" },
                          [
                            _c("div", {
                              staticClass:
                                "quiz-view-type-img text-button-type-img"
                            }),
                            _vm._v(" "),
                            _c(
                              "Radio",
                              {
                                attrs: {
                                  "model-value": _vm.quiz.answer_view_type,
                                  "check-value": "list",
                                  id: "text-button-radio"
                                },
                                on: { change: _vm.selectAnswerViewType }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typography--body-3 typography--color-secondary",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t(
                                            "page_editor.choices.view_types.text_button_type"
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c(
                          "div",
                          { staticClass: "quiz-view-type-box" },
                          [
                            _c("div", {
                              staticClass:
                                "quiz-view-type-img number-button-type-img"
                            }),
                            _vm._v(" "),
                            _c(
                              "Radio",
                              {
                                attrs: {
                                  "model-value": _vm.quiz.answer_view_type,
                                  "check-value": "control",
                                  id: "number-button-radio"
                                },
                                on: { change: _vm.selectAnswerViewType }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typography--body-3 typography--color-secondary",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t(
                                            "page_editor.choices.view_types.number_button_type"
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.hasLongAnswerChoices
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "typography--caption typography--color-alert text-center pt-12"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "page_editor.choices.alerts.view_type_hint"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "text_entry"
                ? _c(
                    "div",
                    { staticClass: "quiz-answers-container" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-3" }, [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "typography--body-1 typography--color-secondary"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("page_editor.text_entry.title"))
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.sourceEditAvaliable
                                ? _c(
                                    "span",
                                    { staticClass: "typography--caption" },
                                    [_vm._v("(수정 불가)")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-9" }, [
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "typography--caption typography--color-secondary align-bottom"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t("page_editor.text_entry.hint")
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: _vm.sourceEditAvaliable
                            ? ""
                            : "pointer-events: none;"
                        },
                        [
                          _vm._l(_vm.answers, function(answer, index) {
                            return _c(
                              "div",
                              { key: _vm.getAnswerKey(answer) },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "quiz-answer-box",
                                    class: {
                                      "has-error":
                                        answer.content &&
                                        answer.content.length > 499
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: index > 0,
                                            expression: "index > 0"
                                          }
                                        ],
                                        staticClass:
                                          "delete-quiz-answer-btn clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeAnswer(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "/static/images/icon-delete.svg",
                                            alt: "delete quiz answer choice"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quiz-text-entry-editor" },
                                      [
                                        _c("AutosizeTextarea", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "page_editor.text_entry.placeholder"
                                            )
                                          },
                                          model: {
                                            value: answer.content,
                                            callback: function($$v) {
                                              _vm.$set(answer, "content", $$v)
                                            },
                                            expression: "answer.content"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isPublisherUser && !answer.is_correct
                                      ? _c("div", [_vm._v("오답")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isPublisherUser && answer.criteria
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              "관리자 설정 (" +
                                                answer.criteria +
                                                ")"
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                answer.content && answer.content.length > 499
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "typography--caption typography--color-alert text-center pb-12"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "page_editor.choices.alerts.max_length"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.answers.length < 5,
                                  expression: "answers.length < 5"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.addNewAnswer(true)
                                }
                              }
                            },
                            [
                              _c("AddAnswerButton", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "page_editor.text_entry.add_new.placeholder"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isPublisherUser
                        ? [
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "h6",
                                    {
                                      staticClass:
                                        "typography--body-1 typography--color-secondary"
                                    },
                                    [_c("strong", [_vm._v("정답기준")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.answerCriteriaTypes, function(
                                  answerCriteria,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "col-12" },
                                    [
                                      _c(
                                        "Checkbox",
                                        {
                                          attrs: {
                                            "model-value":
                                              _vm.selectedAnswerCriteriaTypes,
                                            "check-value": answerCriteria.value
                                          },
                                          on: {
                                            change: _vm.selectAnswerCriteria
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typography--body-3 typography--color-secondary",
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(answerCriteria.label) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "essay_type"
                ? _c("div", { staticClass: "quiz-score-allotment-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "typography--body-1 typography--color-secondary"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("page_editor.score_allotment.title")
                                )
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", { staticClass: "float-right" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "typography--caption typography--color-secondary align-bottom"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("page_editor.score_allotment.hint")
                                  ) +
                                  "\n                  "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "score-select-dropdown",
                            attrs: {
                              text: _vm.$t("common.numeric_score", {
                                n: _vm.quiz.score
                              })
                            }
                          },
                          _vm._l(10, function(n) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: n,
                                on: {
                                  click: function($event) {
                                    _vm.quiz.score = n
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("common.numeric_score", { n: n })
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType === "essay_type"
                ? _c(
                    "div",
                    { staticClass: "quiz-grading-keywords-container" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-3" }, [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "typography--body-1 typography--color-secondary"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("page_editor.grading_keywords.title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "typography--color-disabled" },
                                [_vm._v(_vm._s(_vm.$t("common.optional")))]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-9" }, [
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "typography--caption typography--color-secondary align-bottom"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "page_editor.grading_keywords.hint"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("InputTag", {
                        class: {
                          "no-grading-keyword": _vm.gradingKeywords.length === 0
                        },
                        attrs: {
                          tags: _vm.gradingKeywords,
                          placeholder: _vm.$t(
                            _vm.gradingKeywords.length > 0
                              ? "page_editor.grading_keywords.short_placeholder"
                              : "page_editor.grading_keywords.long_placeholder"
                          )
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageType !== "non_quiz" && _vm.quiz
                ? _c(
                    "div",
                    { staticClass: "quiz-description-container" },
                    [
                      _vm.pageType !== "essay_type"
                        ? _c(
                            "h6",
                            {
                              staticClass:
                                "typography--body-1 typography--color-secondary"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("page_editor.description.title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.sourceEditAvaliable
                                ? _c(
                                    "span",
                                    { staticClass: "typography--caption" },
                                    [_vm._v("(수정 불가)")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "typography--color-disabled" },
                                [_vm._v(_vm._s(_vm.$t("common.optional")))]
                              )
                            ]
                          )
                        : _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "typography--body-1 typography--color-secondary"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("page_editor.description.title")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "typography--color-disabled"
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.optional")))]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c("div", { staticClass: "float-right" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "typography--caption typography--color-secondary align-bottom"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "page_editor.description.essay_type_hint"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.pageType !== "essay_type"
                        ? _c("BaseEditor", {
                            staticClass: "quiz-editor",
                            attrs: {
                              "editor-id": "quiz-desc-editor-" + _vm.id,
                              "text-limit": 5000,
                              disabled: !_vm.sourceEditAvaliable,
                              placeholder: _vm.$t(
                                "page_editor.description.placeholder"
                              )
                            },
                            on: { error: _vm.checkDescriptionError },
                            model: {
                              value: _vm.quiz.description,
                              callback: function($$v) {
                                _vm.$set(_vm.quiz, "description", $$v)
                              },
                              expression: "quiz.description"
                            }
                          })
                        : _c(
                            "div",
                            { staticClass: "essay-type-desc-editor" },
                            [
                              _c("AutosizeTextarea", {
                                attrs: {
                                  limit: 5000,
                                  placeholder: _vm.$t(
                                    "page_editor.description.placeholder"
                                  )
                                },
                                model: {
                                  value: _vm.quiz.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.quiz, "description", $$v)
                                  },
                                  expression: "quiz.description"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72b6f80e", esExports)
  }
}

/***/ }),

/***/ "y00c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "series-cards" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header series-cards__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                attrs: {
                  title:
                    _vm.$t("publishers.sub_header.series") +
                    " > " +
                    _vm.seriesTitle
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("publishers.sub_header.series")) +
                    " > " +
                    _vm._s(_vm.seriesTitle) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "typography--body-2 typography--color-secondary" },
              [
                _c("span", { staticClass: "mr-6" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("series_cards.meta.series_price", {
                          price: _vm.seriesPrice
                        })
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v("\n          |\n          "),
                _c("span", { staticClass: "ml-6 mr-6" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("series_cards.meta.card_price", {
                          price: _vm.seriesCardPrice
                        })
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v("\n          |\n          "),
                _c("span", { staticClass: "ml-6" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getShareLevelLabel(_vm.seriesShareLevel)) +
                      "\n          "
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-5 hidden-sm-down" }, [
            _c("div", { staticClass: "action-btn-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary float-right ml-1 mr-1",
                  on: {
                    click: function($event) {
                      _vm.seriesEditModalIsShown = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("publishers.modal.series_edit.title")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary float-right ml-1 mr-1",
                  on: {
                    click: function($event) {
                      _vm.coverImageEditModalIsShown = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("publishers.headers.actions.upload_cover_image")
                      ) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary float-right mr-1",
                  on: {
                    click: function($event) {
                      return _vm.$root.$emit(
                        "show::modal",
                        "delete-series-modal"
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("publishers.headers.actions.remove")) +
                      "\n          "
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "container mw-960 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-960 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _vm._l(_vm.visibleChapters, function(chapter) {
              return _c("ChapterView", {
                key: chapter.id,
                staticClass: "row",
                attrs: { chapter: chapter, "series-item": _vm.seriesItem },
                on: {
                  "open-chapter-edit-modal": _vm.openChapterEditModal,
                  "open-remove-from-series-modal":
                    _vm.openRemoveFromSeriesModal,
                  "open-remove-card-modal": _vm.openRemoveCardModal
                }
              })
            }),
            _vm._v(" "),
            _c(
              "InfiniteLoading",
              {
                ref: "infiniteLoading",
                staticClass: "w-100",
                attrs: { "on-infinite": _vm.onInfinite }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "spinner" }, slot: "spinner" },
                  [
                    _c("LoadingBounce"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-2 typography--color-disabled pb-5"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.loading")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-12 text-center mb-5 pb-5",
                  attrs: { slot: "no-more" },
                  slot: "no-more"
                })
              ]
            )
          ],
          2
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _vm.chapterEditModalIsShown
          ? _c("ChapterEditModal", {
              attrs: {
                chapter: _vm.chapterForEdit,
                "series-item": _vm.seriesItem
              },
              on: {
                cancel: function($event) {
                  return _vm.resetChapterForEdit()
                },
                ok: function($event) {
                  return _vm.resetChapterForEdit()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.seriesEditModalIsShown
          ? _c("SeriesEditModal", {
              attrs: { "series-item": _vm.seriesItem },
              on: {
                cancel: function($event) {
                  _vm.seriesEditModalIsShown = false
                },
                ok: function($event) {
                  return _vm.updateSeriesItem()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.coverImageEditModalIsShown
          ? _c("CoverImageEditModal", {
              attrs: { "series-item": _vm.seriesItem },
              on: {
                cancel: function($event) {
                  _vm.coverImageEditModalIsShown = false
                },
                ok: function($event) {
                  return _vm.updateSeriesItem()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-series-modal",
              title: _vm.$t("publishers.modal.remove_series.title")
            },
            on: {
              ok: function($event) {
                return _vm.remove()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("publishers.modal.remove_series.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-from-series-modal",
              title: _vm.$t("publishers.modal.remove_from_series.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeFromSeries()
              },
              cancel: function($event) {
                return _vm.resetCardIdForRemoveFromSeries()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("publishers.modal.remove_from_series.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-card-modal",
              title: _vm.$t("publishers.modal.remove_publisher_card.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeCard()
              },
              cancel: function($event) {
                return _vm.resetCardIdForRemove()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("publishers.modal.remove_publisher_card.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-790dbd5a", esExports)
  }
}

/***/ }),

/***/ "y0EJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/publishers/series" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("publishers.sub_header.series")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/publishers/non-series-cards" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("publishers.sub_header.non_series_cards")
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary new-series-btn float-right",
                    attrs: { to: "/publishers/create-docx-quizzes" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("publishers.create_docx_quizzes.title")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.nonSeriesCardList.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("publishers.no_cards"))
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.nonSeriesCardList, function(card) {
                      return _c(
                        "div",
                        {
                          key: card.id,
                          staticClass: "col-sm-6 col-md-4 col-lg-3"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-row" },
                            [
                              _c("PublisherCardView", {
                                attrs: { card: card, "is-series-card": false },
                                on: {
                                  "open-add-to-series-modal":
                                    _vm.openAddToSeriesModal
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _vm.addToSeriesModalIsShown
          ? _c("AddToSeriesModal", {
              attrs: {
                "series-list": _vm.seriesList,
                "publisher-id": _vm.publisherId,
                "card-id-for-add-to-series": _vm.cardIdForAddToSeries
              },
              on: {
                cancel: function($event) {
                  return _vm.closeAddToSeriesModal()
                },
                ok: function($event) {
                  return _vm.closeAddToSeriesModal()
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37da1be1", esExports)
  }
}

/***/ }),

/***/ "y8Tl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchMyCards"] = fetchMyCards;
/* harmony export (immutable) */ __webpack_exports__["fetchMyCardDetails"] = fetchMyCardDetails;
/* harmony export (immutable) */ __webpack_exports__["fetchMyCardPages"] = fetchMyCardPages;
/* harmony export (immutable) */ __webpack_exports__["createNewMyCard"] = createNewMyCard;
/* harmony export (immutable) */ __webpack_exports__["updateMyCard"] = updateMyCard;
/* harmony export (immutable) */ __webpack_exports__["removeMyCard"] = removeMyCard;
/* harmony export (immutable) */ __webpack_exports__["uploadNewCardCoverImage"] = uploadNewCardCoverImage;
/* harmony export (immutable) */ __webpack_exports__["removeMyCardCoverImage"] = removeMyCardCoverImage;
/* harmony export (immutable) */ __webpack_exports__["createNewMyCardPage"] = createNewMyCardPage;
/* harmony export (immutable) */ __webpack_exports__["updateMyCardPages"] = updateMyCardPages;
/* harmony export (immutable) */ __webpack_exports__["updateMyPage"] = updateMyPage;
/* harmony export (immutable) */ __webpack_exports__["uploadNewCardPageImage"] = uploadNewCardPageImage;
/* harmony export (immutable) */ __webpack_exports__["uploadNewCardPageAudio"] = uploadNewCardPageAudio;
/* harmony export (immutable) */ __webpack_exports__["removeMyCardPageImage"] = removeMyCardPageImage;
/* harmony export (immutable) */ __webpack_exports__["removeMyCardPageAudio"] = removeMyCardPageAudio;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoEmbedSrc"] = fetchVideoEmbedSrc;
/* harmony export (immutable) */ __webpack_exports__["exportToBest"] = exportToBest;
/* harmony export (immutable) */ __webpack_exports__["setMyCardsInStore"] = setMyCardsInStore;
/* harmony export (immutable) */ __webpack_exports__["addMyCardsInStore"] = addMyCardsInStore;
/* harmony export (immutable) */ __webpack_exports__["updateMyCardInStore"] = updateMyCardInStore;
/* harmony export (immutable) */ __webpack_exports__["makeMyCardPrivateInStore"] = makeMyCardPrivateInStore;
/* harmony export (immutable) */ __webpack_exports__["makeMyCardPublicInStore"] = makeMyCardPublicInStore;
/* harmony export (immutable) */ __webpack_exports__["setMyCardShareLevel"] = setMyCardShareLevel;
/* harmony export (immutable) */ __webpack_exports__["removeMyCardInStore"] = removeMyCardInStore;
/* harmony export (immutable) */ __webpack_exports__["setMyCardPages"] = setMyCardPages;
/* harmony export (immutable) */ __webpack_exports__["setMyCardCoverImage"] = setMyCardCoverImage;
/* harmony export (immutable) */ __webpack_exports__["addSelectedPage"] = addSelectedPage;
/* harmony export (immutable) */ __webpack_exports__["removeSelectedPage"] = removeSelectedPage;
/* harmony export (immutable) */ __webpack_exports__["resetSelectedPage"] = resetSelectedPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("EP12");






function fetchMyCards(_ref, filters) {
  var dispatch = _ref.dispatch;

  var queryParams = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(filters);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards?' + queryParams).then(function (res) {
    if (filters.offset === 0) {
      return dispatch('setMyCardsInStore', res.data);
    }

    return dispatch('addMyCardsInStore', res.data);
  }).catch(function (err) {
    console.error('err while fetching my cards:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchMyCardDetails(_ref2, cardId) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching my card details:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchMyCardPages(_ref3, _ref4) {
  var dispatch = _ref3.dispatch;
  var cardId = _ref4.cardId,
      _ref4$isPublisherUser = _ref4.isPublisherUser,
      isPublisherUser = _ref4$isPublisherUser === undefined ? false : _ref4$isPublisherUser;

  var params = isPublisherUser ? { is_publisher: true } : {};
  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/pages', { params: params }).then(function (res) {
    return dispatch('setMyCardPages', { cardId: cardId, pageList: res.data });
  }).catch(function (err) {
    console.error('err while fetching my card pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createNewMyCard(_ref5, newCard) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards', newCard).then(function (res) {
    return dispatch('addMyCardsInStore', [res.data]).then(function () {
      return res.data;
    });
  }).catch(function (err) {
    console.error('err while creating new assignment:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateMyCard(_ref6, _ref7) {
  var dispatch = _ref6.dispatch;
  var cardId = _ref7.cardId,
      updateInfo = _ref7.updateInfo;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId, updateInfo).catch(function (err) {
    console.error('err while updating my card:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeMyCard(_ref8, cardId) {
  var dispatch = _ref8.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId).then(function () {
    return dispatch('removeMyCardInStore', cardId);
  }).catch(function (err) {
    console.error('err while removing my card:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadNewCardCoverImage(_ref9, _ref10) {
  var dispatch = _ref9.dispatch;
  var cardId = _ref10.cardId,
      imageFile = _ref10.imageFile;

  var formData = new FormData();
  formData.append('file', imageFile);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/cover_images', formData).then(function (res) {
    return dispatch('setMyCardCoverImage', { cardId: cardId, coverImage: res.data.file_url });
  }).catch(function (err) {
    console.error('err while uploading new cover image:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeMyCardCoverImage(_ref11, cardId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/cover_images').then(function () {
    return dispatch('setMyCardCoverImage', { cardId: cardId, coverImage: '' });
  }).catch(function (err) {
    var res = err.response;

    if (res && res.status === 404) {
      return err;
    }

    console.error('err while removing card cover image:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createNewMyCardPage(_ref12, _ref13) {
  var dispatch = _ref12.dispatch;
  var cardId = _ref13.cardId,
      page = _ref13.page;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/pages', page).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while creating new my card page:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateMyCardPages(_ref14, _ref15) {
  var dispatch = _ref14.dispatch;
  var cardId = _ref15.cardId,
      pageUpdateList = _ref15.pageUpdateList;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/cards/' + cardId + '/pages', pageUpdateList).catch(function (err) {
    console.error('err while updating my card pages:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function updateMyPage(_ref16, _ref17) {
  var dispatch = _ref16.dispatch;
  var pageId = _ref17.pageId,
      updateInfo = _ref17.updateInfo;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].patch(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId, updateInfo).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while updating my page:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadNewCardPageImage(_ref18, _ref19) {
  var dispatch = _ref18.dispatch;
  var pageId = _ref19.pageId,
      imageFile = _ref19.imageFile;

  var formData = new FormData();
  formData.append('file', imageFile);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId + '/images', formData).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while uploading new page image:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function uploadNewCardPageAudio(_, _ref20) {
  var pageId = _ref20.pageId,
      audioFile = _ref20.audioFile;

  var formData = new FormData();
  formData.append('file', audioFile);

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/pages/' + pageId + '/audios', formData).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while uploading new page audio:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeMyCardPageImage(_ref21, imageId) {
  var dispatch = _ref21.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/images/' + imageId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while removing page image:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function removeMyCardPageAudio(_, audioId) {
  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/audios/' + audioId).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while removing page audio:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchVideoEmbedSrc(_, params) {
  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* MINERVA_API_URL */] + '/video-embed-src', { params: params }).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while fetching video embed src:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function exportToBest(_, card) {
  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["j" /* BEST_URL */] + '/sync', card).then(function (res) {
    return res.data;
  }).catch(function (err) {
    console.error('err while sync content:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setMyCardsInStore(_ref22, cardList) {
  var commit = _ref22.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARDS, cardList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardList);
}

function addMyCardsInStore(_ref23, cardList) {
  var commit = _ref23.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_CARDS, cardList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardList);
}

function updateMyCardInStore(_ref24, updatedCard) {
  var commit = _ref24.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].UPDATE_CARD, updatedCard);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function makeMyCardPrivateInStore(_ref25, cardId) {
  var commit = _ref25.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].MAKE_CARD_PRIVATE, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function makeMyCardPublicInStore(_ref26, cardId) {
  var commit = _ref26.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].MAKE_CARD_PUBLIC, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setMyCardShareLevel(_ref27, _ref28) {
  var commit = _ref27.commit;
  var cardId = _ref28.cardId,
      shareLevel = _ref28.shareLevel;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_SHARE_LEVEL, { cardId: cardId, shareLevel: shareLevel });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function removeMyCardInStore(_ref29, cardId) {
  var commit = _ref29.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_CARD, cardId);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setMyCardPages(_ref30, setInfo) {
  var commit = _ref30.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_PAGES, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setInfo.pageList);
}

function setMyCardCoverImage(_ref31, setInfo) {
  var commit = _ref31.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CARD_COVER_IMAGE, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setInfo.coverImage);
}

function addSelectedPage(_ref32, page) {
  var commit = _ref32.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].ADD_SELECTED_PAGE, page);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function removeSelectedPage(_ref33, pageId) {
  var commit = _ref33.commit,
      getters = _ref33.getters;

  var index = getters.selectedPageIds.indexOf(pageId);
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].REMOVE_SELECTED_PAGE, index);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function resetSelectedPage(_ref34) {
  var commit = _ref34.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].RESET_SELECTED_PAGE);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

/***/ }),

/***/ "yAk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-assignment-modal',

  props: {
    assignmentList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preSelectedList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasSelectedAllAssignments: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      isAll: true,
      selectedList: []
    };
  },


  computed: {
    okDisabled: function okDisabled() {
      return !this.isAll && this.selectedList.length === 0;
    }
  },

  methods: {
    applySelectedList: function applySelectedList() {
      this.$emit('assignments-selected', { selectedList: this.selectedList, isAll: this.isAll });
    },
    selectAllAssignments: function selectAllAssignments(isAll) {
      this.selectedList = [];
      this.isAll = isAll;
    },
    selectAssignment: function selectAssignment(checkedList) {
      this.selectedList = checkedList;
    }
  },

  created: function created() {
    this.isAll = this.hasSelectedAllAssignments;

    if (!this.isAll) {
      this.selectedList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(this.preSelectedList, 'id');
    }
  }
});

/***/ }),

/***/ "yE1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_PAGE_LIBRARY_FILTER = 'browseFilters/SET_PAGE_LIBRARY_FILTER';
var SET_ASSIGNMENTS_FILTER = 'browseFilters/SET_ASSIGNMENTS_FILTER';
var SET_MY_CARDS_FILTER = 'browseFilters/SET_MY_CARDS_FILTER';
var SET_LIBRARY_FILTER = 'browseFilters/SET_LIBRARY_FILTER';
var SET_CORE_CONCEPTS = 'browseFilters/SET_CORE_CONCEPTS';
var SET_SUBJECTS = 'browseFilters/SET_SUBJECTS';
var SET_DOMAINS = 'browseFilters/SET_DOMAINS';
var SET_GRADES = 'browseFilters/SET_GRADES';
var SET_UNITS = 'browseFilters/SET_UNITS';
var FETCH_GRADE_SUBJECTS = 'browseFilters/FETCH_GRADE_SUBJECTS';
var RESET_GRADE_SUBJECTS = 'browseFilters/RESET_GRADE_SUBJECTS';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_PAGE_LIBRARY_FILTER: SET_PAGE_LIBRARY_FILTER,
  SET_ASSIGNMENTS_FILTER: SET_ASSIGNMENTS_FILTER,
  SET_MY_CARDS_FILTER: SET_MY_CARDS_FILTER,
  SET_LIBRARY_FILTER: SET_LIBRARY_FILTER,
  SET_CORE_CONCEPTS: SET_CORE_CONCEPTS,
  SET_SUBJECTS: SET_SUBJECTS,
  SET_DOMAINS: SET_DOMAINS,
  SET_GRADES: SET_GRADES,
  SET_UNITS: SET_UNITS,
  FETCH_GRADE_SUBJECTS: FETCH_GRADE_SUBJECTS,
  RESET_GRADE_SUBJECTS: RESET_GRADE_SUBJECTS
});

/***/ }),

/***/ "yFe9":
/***/ (function(module, exports) {

module.exports = {"Play":"Wiedergabe","Pause":"Pause","Current Time":"Aktueller Zeitpunkt","Duration Time":"Dauer","Remaining Time":"Verbleibende Zeit","Stream Type":"Streamtyp","LIVE":"LIVE","Loaded":"Geladen","Progress":"Status","Fullscreen":"Vollbild","Non-Fullscreen":"Kein Vollbild","Mute":"Ton aus","Unmute":"Ton ein","Playback Rate":"Wiedergabegeschwindigkeit","Subtitles":"Untertitel","subtitles off":"Untertitel aus","Captions":"Untertitel","captions off":"Untertitel aus","Chapters":"Kapitel","You aborted the media playback":"Sie haben die Videowiedergabe abgebrochen.","A network error caused the media download to fail part-way.":"Der Videodownload ist aufgrund eines Netzwerkfehlers fehlgeschlagen.","The media could not be loaded, either because the server or network failed or because the format is not supported.":"Das Video konnte nicht geladen werden, da entweder ein Server- oder Netzwerkfehler auftrat oder das Format nicht unterstützt wird.","The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":"Die Videowiedergabe wurde entweder wegen eines Problems mit einem beschädigten Video oder wegen verwendeten Funktionen, die vom Browser nicht unterstützt werden, abgebrochen.","No compatible source was found for this media.":"Für dieses Video wurde keine kompatible Quelle gefunden.","Play Video":"Video abspielen","Close":"Schließen","Modal Window":"Modales Fenster","This is a modal window":"Dies ist ein modales Fenster","This modal can be closed by pressing the Escape key or activating the close button.":"Durch Drücken der Esc-Taste bzw. Betätigung der Schaltfläche \"Schließen\" wird dieses modale Fenster geschlossen.",", opens captions settings dialog":", öffnet Einstellungen für Untertitel",", opens subtitles settings dialog":", öffnet Einstellungen für Untertitel",", selected":", ausgewählt","Close Modal Dialog":"Modales Fenster schließen","Descriptions":"Beschreibungen","descriptions off":"Beschreibungen aus","The media is encrypted and we do not have the keys to decrypt it.":"Die Entschlüsselungsschlüssel für den verschlüsselten Medieninhalt sind nicht verfügbar.",", opens descriptions settings dialog":", öffnet Einstellungen für Beschreibungen","Audio Track":"Tonspur"}

/***/ }),

/***/ "yh45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-service-gone-modal'
});

/***/ }),

/***/ "ylPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  myCardList: [],

  selectedPageList: []
});

/***/ }),

/***/ "yx9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Mobile',

  computed: {
    isMobile: function isMobile() {
      return this.isIOS || this.isAndroid;
    },
    isIOS: function isIOS() {
      var userAgent = window.navigator.userAgent;

      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return true;
      }
      return false;
    },
    isAndroid: function isAndroid() {
      var userAgent = window.navigator.userAgent;

      if (userAgent.match(/android/i)) {
        return true;
      }
      return false;
    },
    getAndroidVersion: function getAndroidVersion() {
      var userAgent = window.navigator.userAgent;
      var regex = /android\s([0-9]*)/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return match[1];
      }

      return 0;
    },
    isOldAndroid: function isOldAndroid() {
      if (this.isAndroid && this.versionCompare(this.getAndroidVersion, '5.0.0') < 0) {
        return true;
      }

      return false;
    },
    isClasstingAndroidVersion: function isClasstingAndroidVersion() {
      var userAgent = window.navigator.userAgent;
      var regex = /classting_android,\s([0-9])*/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    },
    isClasstingIosVersion: function isClasstingIosVersion() {
      var userAgent = window.navigator.userAgent;
      var regex = /classting_iphone/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    }
  },

  methods: {
    call: function call(url) {
      if (this.isIOS) {
        window.location = url;
      } else {
        if (!window.ctandroid) {
          window.prompt(url);
        } else {
          window.ctandroid.submitFromWeb(url);
        }
      }
    },
    versionCompare: function versionCompare(left, right) {
      if (!(typeof left === 'string' && typeof right === 'string')) {
        return false;
      }

      var a = left.split('.');
      var b = right.split('.');
      var len = Math.max(a.length, b.length);

      for (var i = 0; i < len; i += 1) {
        if (a[i] && !b[i] && parseInt(a[i], 10) > 0 || parseInt(a[i], 10) > parseInt(b[i], 10)) {
          return 1;
        } else if (b[i] && !a[i] && parseInt(b[i], 10) > 0 || parseInt(a[i], 10) < parseInt(b[i], 10)) {
          return -1;
        }
      }

      return 0;
    },
    callActionbar: function callActionbar(isVisible) {
      this.call('ctjscall://navigation?source=classting&is_visible=' + isVisible);
    }
  }
});

/***/ }),

/***/ "yxUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationServiceGoneModal_vue__ = __webpack_require__("yh45");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d061eb42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationServiceGoneModal_vue__ = __webpack_require__("+6rK");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("4LOq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationServiceGoneModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d061eb42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationServiceGoneModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app/evaluations/components/EvaluationServiceGoneModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d061eb42", Component.options)
  } else {
    hotAPI.reload("data-v-d061eb42", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yyHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__("kl7r");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'library-card',

  data: function data() {
    return {
      selectedCardId: null
    };
  },


  props: ['card'],

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['customCards', 'subjectMap', 'gradeMap']), {
    isPublisherCard: function isPublisherCard() {
      if (this.card) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.publisher_id) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.author_id) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isNil"])(this.card.store_card_id);
      }

      return false;
    },
    styleBindings: function styleBindings() {
      if (this.card) {
        return {
          'background-image': 'url(\'' + this.card.cover_image + '\')'
        };
      }

      return {};
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setSelectedPreviewPageIndex', 'fetchPublisherCardPages', 'setSelectedPreviewCard', 'fetchCustomCardPages']), {
    goToCardDetails: function goToCardDetails() {
      if (this.isPublisherCard) {
        return this.$router.push('/library/publisher-cards/' + (this.card.id || this.card.copy_id));
      }

      return this.$router.push(this.$route.path + '/' + this.card.id);
    },
    setPreviewCard: function setPreviewCard() {
      var _this = this;

      return this.setSelectedPreviewCard(this.card).then(function () {
        return _this.setSelectedPreviewPageIndex(0);
      }).then(function () {
        _this.$root.$emit('show::modal', 'card-preview-modal');
      });
    },
    openCardPreview: function openCardPreview() {
      var _this2 = this;

      if (this.isPublisherCard) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.card.pages)) {
          return this.setPreviewCard();
        }

        return this.fetchPublisherCardPages(this.card.id).then(function () {
          return _this2.setPreviewCard();
        }).catch(function (err) {
          _this2.$root.$emit('show::modal', 'basic-error-alert');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }

      return this.fetchCustomCardPages(this.card.id).then(function () {
        return _this2.setPreviewCard();
      }).catch(function (err) {
        _this2.$root.$emit('show::modal', 'basic-error-alert');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    handleCardOver: function handleCardOver(cardId) {
      this.selectedCardId = cardId;
    },
    handleCardLeave: function handleCardLeave() {
      this.selectedCardId = null;
    }
  })
});

/***/ }),

/***/ "z+b6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flatpickr__ = __webpack_require__("GxBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'date-time-picker',

  props: {
    pickerId: {
      type: String,
      default: 'date-time-picker'
    },
    value: {
      type: [Date, String],
      default: null
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initialDueDate: {
      type: String,
      default: ''
    }
  },

  methods: {
    showPicker: function showPicker() {
      if (!this.picker.isOpen) {
        this.picker.open();
      }
    }
  },

  data: function data() {
    var _this = this;

    return {
      pickerConfig: {
        defaultDate: this.value || null,
        minDate: 'today',
        enableTime: true,

        onChange: function onChange(selectedDates) {
          _this.$emit('input', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(selectedDates[0]));
        }
      },

      picker: null
    };
  },
  mounted: function mounted() {
    var elem = document.getElementById(this.pickerId);

    this.picker = new __WEBPACK_IMPORTED_MODULE_0_flatpickr___default.a(elem, this.pickerConfig);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.picker) {
      this.picker.destroy();
    }
  }
});

/***/ }),

/***/ "z0Cz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreBtnDropdown_vue__ = __webpack_require__("4vWO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f70df8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreBtnDropdown_vue__ = __webpack_require__("K8Cj");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreBtnDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f70df8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreBtnDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MoreBtnDropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24f70df8", Component.options)
  } else {
    hotAPI.reload("data-v-24f70df8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zFhp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-root'
});

/***/ }),

/***/ "zkyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal add-to-series-modal",
      attrs: {
        id: "add-to-series-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "add-to-series-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.add_to_series.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "add-to-series-modal__series-list scroll-box" },
            [
              _vm._l(_vm.seriesList, function(seriesItem) {
                return _c("SeriesListItem", {
                  key: seriesItem.id,
                  attrs: {
                    "series-item": seriesItem,
                    "is-active": _vm.selectedSeriesId === seriesItem.id,
                    "selected-chapter-id": _vm.selectedChapterId
                  },
                  on: {
                    "select-series": _vm.selectSeries,
                    "select-chapter": _vm.selectChapter
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "InfiniteLoading",
                {
                  ref: "infiniteLoading",
                  staticClass: "w-100",
                  attrs: { "on-infinite": _vm.onInfinite }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "spinner" }, slot: "spinner" },
                    [
                      _c("LoadingBounce"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "typography--body-2 typography--color-disabled pb-5"
                        },
                        [_vm._v(_vm._s(_vm.$t("common.loading")))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-12 text-center mb-5 pb-5",
                    attrs: { slot: "no-more" },
                    slot: "no-more"
                  })
                ]
              )
            ],
            2
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47b65782", esExports)
  }
}

/***/ }),

/***/ "zpPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_locales__ = __webpack_require__("5BI/");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'oauth-callback',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_locales__["a" /* default */]],

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setToken', 'signIn']), {
    getUrlParams: function getUrlParams() {
      var params = {};
      this.$route.hash.slice(1).split('&').forEach(function (query) {
        var _query$split = query.split('='),
            _query$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_query$split, 2),
            key = _query$split2[0],
            value = _query$split2[1];

        params[key] = value;
      });

      return params;
    }
  }),

  created: function created() {
    var _this = this;

    var urlParams = this.getUrlParams();
    var token = urlParams.access_token;
    var continueUrl = urlParams.continue_url || sessionStorage.getItem('continue_url');

    if (!token) {
      console.error('no token found in URL');
      return 'something';
    }

    return this.setToken(token).then(function () {
      return _this.signIn();
    }).then(function (userInfo) {
      _this.$i18n.locale = _this.getLocale(userInfo);
    }).then(function () {
      if (continueUrl) {
        _this.$router.replace(window.decodeURIComponent(continueUrl));
      } else {
        _this.$router.replace('/');
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }).catch(function (err) {
      console.error('err while signing in:', err);
      _this.$root.$emit('show::modal', 'basic-error-alert');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
  }
});

/***/ }),

/***/ "zq8D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineGauge_vue__ = __webpack_require__("wDRK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549d46e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineGauge_vue__ = __webpack_require__("MYZD");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("nsht")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineGauge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549d46e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineGauge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LineGauge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-549d46e5", Component.options)
  } else {
    hotAPI.reload("data-v-549d46e5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e7c2783f6201ff95ec11.js